import axios from "redaxios";
import React, { createContext, useCallback, useContext, useState, useEffect, useRef } from "react";
import { Transaction as Transaction$1 } from "@ethereumjs/tx";
function _mergeNamespaces(u, t) {
  for (var a = 0; a < t.length; a++) {
    const d = t[a];
    if (typeof d != "string" && !Array.isArray(d)) {
      for (const l in d)
        if (l !== "default" && !(l in u)) {
          const h = Object.getOwnPropertyDescriptor(d, l);
          h && Object.defineProperty(u, l, h.get ? h : {
            enumerable: !0,
            get: () => d[l]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(u, Symbol.toStringTag, { value: "Module" }));
}
var TOKEN = /* @__PURE__ */ ((u) => (u.SD = "sd", u.ETHX = "ethx", u.BNBX = "bnbx", u.MATICX = "maticx", u.SFTMX = "sftmx", u.HBARX = "hbarx", u))(TOKEN || {}), TOKENTYPE = /* @__PURE__ */ ((u) => (u.TOKEN = "token", u.TOKENX = "tokenx", u))(TOKENTYPE || {});
const PATH = {
  [TOKEN.SD]: "/sd",
  [TOKEN.ETHX]: "/ethx",
  [TOKEN.BNBX]: "/bnbx",
  [TOKEN.MATICX]: "/maticx",
  [TOKEN.SFTMX]: "/sftmx",
  [TOKEN.HBARX]: "/hbarx"
}, DAPPPATH = {
  [TOKEN.SD]: "/sd",
  [TOKEN.ETHX]: "/eth",
  [TOKEN.BNBX]: "/bnb",
  [TOKEN.MATICX]: "/polygon",
  [TOKEN.SFTMX]: "/fantom",
  [TOKEN.HBARX]: "/hedera"
};
var QUERY = /* @__PURE__ */ ((u) => (u.TVL = "tvl", u.APY = "apy", u.EXCHANGE_RATE = "exchangeRate", u.SAFE_MODE = "safeMode", u.GAS_FEES = "gasFees", u.NODE_OPERATOR_BOND = "nodeOperatorBond", u.NODE_OPERATOR_COUNT = "nodeOperatorsCount", u.RATED_NETWORK_OVERVIEW = "ratedNetworkOverview", u))(QUERY || {}), ENVIRONMENT = /* @__PURE__ */ ((u) => (u.PROD = "production", u.PREPROD = "pre-production", u.STAGE = "stage", u))(ENVIRONMENT || {});
const DEFAULT_YIELD_URL = {
  [ENVIRONMENT.PROD]: "https://yields.staderlabs.com",
  [ENVIRONMENT.PREPROD]: "https://beta-yields.staderlabs.com",
  [ENVIRONMENT.STAGE]: "https://stage-yields.staderlabs.com"
}, DEFAULT_UNIVERSE_URL = {
  [ENVIRONMENT.PROD]: "https://universe.staderlabs.com",
  [ENVIRONMENT.PREPROD]: "https://beta.universe.staderlabs.com",
  [ENVIRONMENT.STAGE]: "https://stage.universe.staderlabs.com"
};
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(u) {
  return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
}
function getAugmentedNamespace(u) {
  var t = u.default;
  if (typeof t == "function") {
    var a = function() {
      return t.apply(this, arguments);
    };
    a.prototype = t.prototype;
  } else
    a = {};
  return Object.defineProperty(a, "__esModule", { value: !0 }), Object.keys(u).forEach(function(d) {
    var l = Object.getOwnPropertyDescriptor(u, d);
    Object.defineProperty(a, d, l.get ? l : {
      enumerable: !0,
      get: function() {
        return u[d];
      }
    });
  }), a;
}
var long = Long, wasm = null;
try {
  wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    13,
    2,
    96,
    0,
    1,
    127,
    96,
    4,
    127,
    127,
    127,
    127,
    1,
    127,
    3,
    7,
    6,
    0,
    1,
    1,
    1,
    1,
    1,
    6,
    6,
    1,
    127,
    1,
    65,
    0,
    11,
    7,
    50,
    6,
    3,
    109,
    117,
    108,
    0,
    1,
    5,
    100,
    105,
    118,
    95,
    115,
    0,
    2,
    5,
    100,
    105,
    118,
    95,
    117,
    0,
    3,
    5,
    114,
    101,
    109,
    95,
    115,
    0,
    4,
    5,
    114,
    101,
    109,
    95,
    117,
    0,
    5,
    8,
    103,
    101,
    116,
    95,
    104,
    105,
    103,
    104,
    0,
    0,
    10,
    191,
    1,
    6,
    4,
    0,
    35,
    0,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    126,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    127,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    128,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    129,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    130,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11
  ])), {}).exports;
} catch {
}
function Long(u, t, a) {
  this.low = u | 0, this.high = t | 0, this.unsigned = !!a;
}
Long.prototype.__isLong__;
Object.defineProperty(Long.prototype, "__isLong__", { value: !0 });
function isLong$1(u) {
  return (u && u.__isLong__) === !0;
}
Long.isLong = isLong$1;
var INT_CACHE = {}, UINT_CACHE = {};
function fromInt(u, t) {
  var a, d, l;
  return t ? (u >>>= 0, (l = 0 <= u && u < 256) && (d = UINT_CACHE[u], d) ? d : (a = fromBits(u, (u | 0) < 0 ? -1 : 0, !0), l && (UINT_CACHE[u] = a), a)) : (u |= 0, (l = -128 <= u && u < 128) && (d = INT_CACHE[u], d) ? d : (a = fromBits(u, u < 0 ? -1 : 0, !1), l && (INT_CACHE[u] = a), a));
}
Long.fromInt = fromInt;
function fromNumber(u, t) {
  if (isNaN(u))
    return t ? UZERO : ZERO;
  if (t) {
    if (u < 0)
      return UZERO;
    if (u >= TWO_PWR_64_DBL)
      return MAX_UNSIGNED_VALUE;
  } else {
    if (u <= -TWO_PWR_63_DBL)
      return MIN_VALUE;
    if (u + 1 >= TWO_PWR_63_DBL)
      return MAX_VALUE;
  }
  return u < 0 ? fromNumber(-u, t).neg() : fromBits(u % TWO_PWR_32_DBL | 0, u / TWO_PWR_32_DBL | 0, t);
}
Long.fromNumber = fromNumber;
function fromBits(u, t, a) {
  return new Long(u, t, a);
}
Long.fromBits = fromBits;
var pow_dbl = Math.pow;
function fromString$1(u, t, a) {
  if (u.length === 0)
    throw Error("empty string");
  if (u === "NaN" || u === "Infinity" || u === "+Infinity" || u === "-Infinity")
    return ZERO;
  if (typeof t == "number" ? (a = t, t = !1) : t = !!t, a = a || 10, a < 2 || 36 < a)
    throw RangeError("radix");
  var d;
  if ((d = u.indexOf("-")) > 0)
    throw Error("interior hyphen");
  if (d === 0)
    return fromString$1(u.substring(1), t, a).neg();
  for (var l = fromNumber(pow_dbl(a, 8)), h = ZERO, g = 0; g < u.length; g += 8) {
    var c = Math.min(8, u.length - g), x = parseInt(u.substring(g, g + c), a);
    if (c < 8) {
      var R = fromNumber(pow_dbl(a, c));
      h = h.mul(R).add(fromNumber(x));
    } else
      h = h.mul(l), h = h.add(fromNumber(x));
  }
  return h.unsigned = t, h;
}
Long.fromString = fromString$1;
function fromValue(u, t) {
  return typeof u == "number" ? fromNumber(u, t) : typeof u == "string" ? fromString$1(u, t) : fromBits(u.low, u.high, typeof t == "boolean" ? t : u.unsigned);
}
Long.fromValue = fromValue;
var TWO_PWR_16_DBL = 1 << 16, TWO_PWR_24_DBL = 1 << 24, TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL, TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL, TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2, TWO_PWR_24 = fromInt(TWO_PWR_24_DBL), ZERO = fromInt(0);
Long.ZERO = ZERO;
var UZERO = fromInt(0, !0);
Long.UZERO = UZERO;
var ONE$1 = fromInt(1);
Long.ONE = ONE$1;
var UONE = fromInt(1, !0);
Long.UONE = UONE;
var NEG_ONE = fromInt(-1);
Long.NEG_ONE = NEG_ONE;
var MAX_VALUE = fromBits(-1, 2147483647, !1);
Long.MAX_VALUE = MAX_VALUE;
var MAX_UNSIGNED_VALUE = fromBits(-1, -1, !0);
Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
var MIN_VALUE = fromBits(0, -2147483648, !1);
Long.MIN_VALUE = MIN_VALUE;
var LongPrototype = Long.prototype;
LongPrototype.toInt = function() {
  return this.unsigned ? this.low >>> 0 : this.low;
};
LongPrototype.toNumber = function() {
  return this.unsigned ? (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0) : this.high * TWO_PWR_32_DBL + (this.low >>> 0);
};
LongPrototype.toString = function(t) {
  if (t = t || 10, t < 2 || 36 < t)
    throw RangeError("radix");
  if (this.isZero())
    return "0";
  if (this.isNegative())
    if (this.eq(MIN_VALUE)) {
      var a = fromNumber(t), d = this.div(a), l = d.mul(a).sub(this);
      return d.toString(t) + l.toInt().toString(t);
    } else
      return "-" + this.neg().toString(t);
  for (var h = fromNumber(pow_dbl(t, 6), this.unsigned), g = this, c = ""; ; ) {
    var x = g.div(h), R = g.sub(x.mul(h)).toInt() >>> 0, B = R.toString(t);
    if (g = x, g.isZero())
      return B + c;
    for (; B.length < 6; )
      B = "0" + B;
    c = "" + B + c;
  }
};
LongPrototype.getHighBits = function() {
  return this.high;
};
LongPrototype.getHighBitsUnsigned = function() {
  return this.high >>> 0;
};
LongPrototype.getLowBits = function() {
  return this.low;
};
LongPrototype.getLowBitsUnsigned = function() {
  return this.low >>> 0;
};
LongPrototype.getNumBitsAbs = function() {
  if (this.isNegative())
    return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
  for (var t = this.high != 0 ? this.high : this.low, a = 31; a > 0 && (t & 1 << a) == 0; a--)
    ;
  return this.high != 0 ? a + 33 : a + 1;
};
LongPrototype.isZero = function() {
  return this.high === 0 && this.low === 0;
};
LongPrototype.eqz = LongPrototype.isZero;
LongPrototype.isNegative = function() {
  return !this.unsigned && this.high < 0;
};
LongPrototype.isPositive = function() {
  return this.unsigned || this.high >= 0;
};
LongPrototype.isOdd = function() {
  return (this.low & 1) === 1;
};
LongPrototype.isEven = function() {
  return (this.low & 1) === 0;
};
LongPrototype.equals = function(t) {
  return isLong$1(t) || (t = fromValue(t)), this.unsigned !== t.unsigned && this.high >>> 31 === 1 && t.high >>> 31 === 1 ? !1 : this.high === t.high && this.low === t.low;
};
LongPrototype.eq = LongPrototype.equals;
LongPrototype.notEquals = function(t) {
  return !this.eq(t);
};
LongPrototype.neq = LongPrototype.notEquals;
LongPrototype.ne = LongPrototype.notEquals;
LongPrototype.lessThan = function(t) {
  return this.comp(t) < 0;
};
LongPrototype.lt = LongPrototype.lessThan;
LongPrototype.lessThanOrEqual = function(t) {
  return this.comp(t) <= 0;
};
LongPrototype.lte = LongPrototype.lessThanOrEqual;
LongPrototype.le = LongPrototype.lessThanOrEqual;
LongPrototype.greaterThan = function(t) {
  return this.comp(t) > 0;
};
LongPrototype.gt = LongPrototype.greaterThan;
LongPrototype.greaterThanOrEqual = function(t) {
  return this.comp(t) >= 0;
};
LongPrototype.gte = LongPrototype.greaterThanOrEqual;
LongPrototype.ge = LongPrototype.greaterThanOrEqual;
LongPrototype.compare = function(t) {
  if (isLong$1(t) || (t = fromValue(t)), this.eq(t))
    return 0;
  var a = this.isNegative(), d = t.isNegative();
  return a && !d ? -1 : !a && d ? 1 : this.unsigned ? t.high >>> 0 > this.high >>> 0 || t.high === this.high && t.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(t).isNegative() ? -1 : 1;
};
LongPrototype.comp = LongPrototype.compare;
LongPrototype.negate = function() {
  return !this.unsigned && this.eq(MIN_VALUE) ? MIN_VALUE : this.not().add(ONE$1);
};
LongPrototype.neg = LongPrototype.negate;
LongPrototype.add = function(t) {
  isLong$1(t) || (t = fromValue(t));
  var a = this.high >>> 16, d = this.high & 65535, l = this.low >>> 16, h = this.low & 65535, g = t.high >>> 16, c = t.high & 65535, x = t.low >>> 16, R = t.low & 65535, B = 0, j = 0, o = 0, e = 0;
  return e += h + R, o += e >>> 16, e &= 65535, o += l + x, j += o >>> 16, o &= 65535, j += d + c, B += j >>> 16, j &= 65535, B += a + g, B &= 65535, fromBits(o << 16 | e, B << 16 | j, this.unsigned);
};
LongPrototype.subtract = function(t) {
  return isLong$1(t) || (t = fromValue(t)), this.add(t.neg());
};
LongPrototype.sub = LongPrototype.subtract;
LongPrototype.multiply = function(t) {
  if (this.isZero())
    return ZERO;
  if (isLong$1(t) || (t = fromValue(t)), wasm) {
    var a = wasm.mul(
      this.low,
      this.high,
      t.low,
      t.high
    );
    return fromBits(a, wasm.get_high(), this.unsigned);
  }
  if (t.isZero())
    return ZERO;
  if (this.eq(MIN_VALUE))
    return t.isOdd() ? MIN_VALUE : ZERO;
  if (t.eq(MIN_VALUE))
    return this.isOdd() ? MIN_VALUE : ZERO;
  if (this.isNegative())
    return t.isNegative() ? this.neg().mul(t.neg()) : this.neg().mul(t).neg();
  if (t.isNegative())
    return this.mul(t.neg()).neg();
  if (this.lt(TWO_PWR_24) && t.lt(TWO_PWR_24))
    return fromNumber(this.toNumber() * t.toNumber(), this.unsigned);
  var d = this.high >>> 16, l = this.high & 65535, h = this.low >>> 16, g = this.low & 65535, c = t.high >>> 16, x = t.high & 65535, R = t.low >>> 16, B = t.low & 65535, j = 0, o = 0, e = 0, n = 0;
  return n += g * B, e += n >>> 16, n &= 65535, e += h * B, o += e >>> 16, e &= 65535, e += g * R, o += e >>> 16, e &= 65535, o += l * B, j += o >>> 16, o &= 65535, o += h * R, j += o >>> 16, o &= 65535, o += g * x, j += o >>> 16, o &= 65535, j += d * B + l * R + h * x + g * c, j &= 65535, fromBits(e << 16 | n, j << 16 | o, this.unsigned);
};
LongPrototype.mul = LongPrototype.multiply;
LongPrototype.divide = function(t) {
  if (isLong$1(t) || (t = fromValue(t)), t.isZero())
    throw Error("division by zero");
  if (wasm) {
    if (!this.unsigned && this.high === -2147483648 && t.low === -1 && t.high === -1)
      return this;
    var a = (this.unsigned ? wasm.div_u : wasm.div_s)(
      this.low,
      this.high,
      t.low,
      t.high
    );
    return fromBits(a, wasm.get_high(), this.unsigned);
  }
  if (this.isZero())
    return this.unsigned ? UZERO : ZERO;
  var d, l, h;
  if (this.unsigned) {
    if (t.unsigned || (t = t.toUnsigned()), t.gt(this))
      return UZERO;
    if (t.gt(this.shru(1)))
      return UONE;
    h = UZERO;
  } else {
    if (this.eq(MIN_VALUE)) {
      if (t.eq(ONE$1) || t.eq(NEG_ONE))
        return MIN_VALUE;
      if (t.eq(MIN_VALUE))
        return ONE$1;
      var g = this.shr(1);
      return d = g.div(t).shl(1), d.eq(ZERO) ? t.isNegative() ? ONE$1 : NEG_ONE : (l = this.sub(t.mul(d)), h = d.add(l.div(t)), h);
    } else if (t.eq(MIN_VALUE))
      return this.unsigned ? UZERO : ZERO;
    if (this.isNegative())
      return t.isNegative() ? this.neg().div(t.neg()) : this.neg().div(t).neg();
    if (t.isNegative())
      return this.div(t.neg()).neg();
    h = ZERO;
  }
  for (l = this; l.gte(t); ) {
    d = Math.max(1, Math.floor(l.toNumber() / t.toNumber()));
    for (var c = Math.ceil(Math.log(d) / Math.LN2), x = c <= 48 ? 1 : pow_dbl(2, c - 48), R = fromNumber(d), B = R.mul(t); B.isNegative() || B.gt(l); )
      d -= x, R = fromNumber(d, this.unsigned), B = R.mul(t);
    R.isZero() && (R = ONE$1), h = h.add(R), l = l.sub(B);
  }
  return h;
};
LongPrototype.div = LongPrototype.divide;
LongPrototype.modulo = function(t) {
  if (isLong$1(t) || (t = fromValue(t)), wasm) {
    var a = (this.unsigned ? wasm.rem_u : wasm.rem_s)(
      this.low,
      this.high,
      t.low,
      t.high
    );
    return fromBits(a, wasm.get_high(), this.unsigned);
  }
  return this.sub(this.div(t).mul(t));
};
LongPrototype.mod = LongPrototype.modulo;
LongPrototype.rem = LongPrototype.modulo;
LongPrototype.not = function() {
  return fromBits(~this.low, ~this.high, this.unsigned);
};
LongPrototype.and = function(t) {
  return isLong$1(t) || (t = fromValue(t)), fromBits(this.low & t.low, this.high & t.high, this.unsigned);
};
LongPrototype.or = function(t) {
  return isLong$1(t) || (t = fromValue(t)), fromBits(this.low | t.low, this.high | t.high, this.unsigned);
};
LongPrototype.xor = function(t) {
  return isLong$1(t) || (t = fromValue(t)), fromBits(this.low ^ t.low, this.high ^ t.high, this.unsigned);
};
LongPrototype.shiftLeft = function(t) {
  return isLong$1(t) && (t = t.toInt()), (t &= 63) === 0 ? this : t < 32 ? fromBits(this.low << t, this.high << t | this.low >>> 32 - t, this.unsigned) : fromBits(0, this.low << t - 32, this.unsigned);
};
LongPrototype.shl = LongPrototype.shiftLeft;
LongPrototype.shiftRight = function(t) {
  return isLong$1(t) && (t = t.toInt()), (t &= 63) === 0 ? this : t < 32 ? fromBits(this.low >>> t | this.high << 32 - t, this.high >> t, this.unsigned) : fromBits(this.high >> t - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
LongPrototype.shr = LongPrototype.shiftRight;
LongPrototype.shiftRightUnsigned = function(t) {
  if (isLong$1(t) && (t = t.toInt()), t &= 63, t === 0)
    return this;
  var a = this.high;
  if (t < 32) {
    var d = this.low;
    return fromBits(d >>> t | a << 32 - t, a >>> t, this.unsigned);
  } else
    return t === 32 ? fromBits(a, 0, this.unsigned) : fromBits(a >>> t - 32, 0, this.unsigned);
};
LongPrototype.shru = LongPrototype.shiftRightUnsigned;
LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
LongPrototype.toSigned = function() {
  return this.unsigned ? fromBits(this.low, this.high, !1) : this;
};
LongPrototype.toUnsigned = function() {
  return this.unsigned ? this : fromBits(this.low, this.high, !0);
};
LongPrototype.toBytes = function(t) {
  return t ? this.toBytesLE() : this.toBytesBE();
};
LongPrototype.toBytesLE = function() {
  var t = this.high, a = this.low;
  return [
    a & 255,
    a >>> 8 & 255,
    a >>> 16 & 255,
    a >>> 24,
    t & 255,
    t >>> 8 & 255,
    t >>> 16 & 255,
    t >>> 24
  ];
};
LongPrototype.toBytesBE = function() {
  var t = this.high, a = this.low;
  return [
    t >>> 24,
    t >>> 16 & 255,
    t >>> 8 & 255,
    t & 255,
    a >>> 24,
    a >>> 16 & 255,
    a >>> 8 & 255,
    a & 255
  ];
};
Long.fromBytes = function(t, a, d) {
  return d ? Long.fromBytesLE(t, a) : Long.fromBytesBE(t, a);
};
Long.fromBytesLE = function(t, a) {
  return new Long(
    t[0] | t[1] << 8 | t[2] << 16 | t[3] << 24,
    t[4] | t[5] << 8 | t[6] << 16 | t[7] << 24,
    a
  );
};
Long.fromBytesBE = function(t, a) {
  return new Long(
    t[4] << 24 | t[5] << 16 | t[6] << 8 | t[7],
    t[0] << 24 | t[1] << 16 | t[2] << 8 | t[3],
    a
  );
};
const byteToHex$1 = [];
for (let u = 0; u <= 255; u += 1)
  byteToHex$1.push(u.toString(16).padStart(2, "0"));
function encode$4(u) {
  let t = "";
  for (const a of u)
    t += byteToHex$1[a];
  return t;
}
function decode$6(u) {
  const a = (u.startsWith("0x") ? u.substring(2) : u).match(/.{1,2}/gu);
  return new Uint8Array(
    (a == null ? [] : a).map((d) => parseInt(d, 16))
  );
}
class BadEntityIdError extends Error {
  constructor(t, a, d, l, h) {
    super(
      `Entity ID ${t.toString()}.${a.toString()}.${d.toString()}-${l} was incorrect.`
    ), this.name = "BadEntityIdException", this.shard = t, this.realm = a, this.num = d, this.presentChecksum = l, this.expectedChecksum = h;
  }
}
var isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER$1 = 9007199254740991, POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], SQRT_BASE = 1e7, MAX = 1e9;
function clone(u) {
  var t, a, d, l = U.prototype = { constructor: U, toString: null, valueOf: null }, h = new U(1), g = 20, c = 4, x = -7, R = 21, B = -1e7, j = 1e7, o = !1, e = 1, n = 0, i = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: "\xA0",
    suffix: ""
  }, y = "0123456789abcdefghijklmnopqrstuvwxyz", m = !0;
  function U(G, z) {
    var W, F, k, T, p, b, _, v, S = this;
    if (!(S instanceof U))
      return new U(G, z);
    if (z == null) {
      if (G && G._isBigNumber === !0) {
        S.s = G.s, !G.c || G.e > j ? S.c = S.e = null : G.e < B ? S.c = [S.e = 0] : (S.e = G.e, S.c = G.c.slice());
        return;
      }
      if ((b = typeof G == "number") && G * 0 == 0) {
        if (S.s = 1 / G < 0 ? (G = -G, -1) : 1, G === ~~G) {
          for (T = 0, p = G; p >= 10; p /= 10, T++)
            ;
          T > j ? S.c = S.e = null : (S.e = T, S.c = [G]);
          return;
        }
        v = String(G);
      } else {
        if (!isNumeric.test(v = String(G)))
          return d(S, v, b);
        S.s = v.charCodeAt(0) == 45 ? (v = v.slice(1), -1) : 1;
      }
      (T = v.indexOf(".")) > -1 && (v = v.replace(".", "")), (p = v.search(/e/i)) > 0 ? (T < 0 && (T = p), T += +v.slice(p + 1), v = v.substring(0, p)) : T < 0 && (T = v.length);
    } else {
      if (intCheck(z, 2, y.length, "Base"), z == 10 && m)
        return S = new U(G), Pe(S, g + S.e + 1, c);
      if (v = String(G), b = typeof G == "number") {
        if (G * 0 != 0)
          return d(S, v, b, z);
        if (S.s = 1 / G < 0 ? (v = v.slice(1), -1) : 1, U.DEBUG && v.replace(/^0\.0*|\./, "").length > 15)
          throw Error(tooManyDigits + G);
      } else
        S.s = v.charCodeAt(0) === 45 ? (v = v.slice(1), -1) : 1;
      for (W = y.slice(0, z), T = p = 0, _ = v.length; p < _; p++)
        if (W.indexOf(F = v.charAt(p)) < 0) {
          if (F == ".") {
            if (p > T) {
              T = _;
              continue;
            }
          } else if (!k && (v == v.toUpperCase() && (v = v.toLowerCase()) || v == v.toLowerCase() && (v = v.toUpperCase()))) {
            k = !0, p = -1, T = 0;
            continue;
          }
          return d(S, String(G), b, z);
        }
      b = !1, v = a(v, z, 10, S.s), (T = v.indexOf(".")) > -1 ? v = v.replace(".", "") : T = v.length;
    }
    for (p = 0; v.charCodeAt(p) === 48; p++)
      ;
    for (_ = v.length; v.charCodeAt(--_) === 48; )
      ;
    if (v = v.slice(p, ++_)) {
      if (_ -= p, b && U.DEBUG && _ > 15 && (G > MAX_SAFE_INTEGER$1 || G !== mathfloor(G)))
        throw Error(tooManyDigits + S.s * G);
      if ((T = T - p - 1) > j)
        S.c = S.e = null;
      else if (T < B)
        S.c = [S.e = 0];
      else {
        if (S.e = T, S.c = [], p = (T + 1) % LOG_BASE, T < 0 && (p += LOG_BASE), p < _) {
          for (p && S.c.push(+v.slice(0, p)), _ -= LOG_BASE; p < _; )
            S.c.push(+v.slice(p, p += LOG_BASE));
          p = LOG_BASE - (v = v.slice(p)).length;
        } else
          p -= _;
        for (; p--; v += "0")
          ;
        S.c.push(+v);
      }
    } else
      S.c = [S.e = 0];
  }
  U.clone = clone, U.ROUND_UP = 0, U.ROUND_DOWN = 1, U.ROUND_CEIL = 2, U.ROUND_FLOOR = 3, U.ROUND_HALF_UP = 4, U.ROUND_HALF_DOWN = 5, U.ROUND_HALF_EVEN = 6, U.ROUND_HALF_CEIL = 7, U.ROUND_HALF_FLOOR = 8, U.EUCLID = 9, U.config = U.set = function(G) {
    var z, W;
    if (G != null)
      if (typeof G == "object") {
        if (G.hasOwnProperty(z = "DECIMAL_PLACES") && (W = G[z], intCheck(W, 0, MAX, z), g = W), G.hasOwnProperty(z = "ROUNDING_MODE") && (W = G[z], intCheck(W, 0, 8, z), c = W), G.hasOwnProperty(z = "EXPONENTIAL_AT") && (W = G[z], W && W.pop ? (intCheck(W[0], -MAX, 0, z), intCheck(W[1], 0, MAX, z), x = W[0], R = W[1]) : (intCheck(W, -MAX, MAX, z), x = -(R = W < 0 ? -W : W))), G.hasOwnProperty(z = "RANGE"))
          if (W = G[z], W && W.pop)
            intCheck(W[0], -MAX, -1, z), intCheck(W[1], 1, MAX, z), B = W[0], j = W[1];
          else if (intCheck(W, -MAX, MAX, z), W)
            B = -(j = W < 0 ? -W : W);
          else
            throw Error(bignumberError + z + " cannot be zero: " + W);
        if (G.hasOwnProperty(z = "CRYPTO"))
          if (W = G[z], W === !!W)
            if (W)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                o = W;
              else
                throw o = !W, Error(bignumberError + "crypto unavailable");
            else
              o = W;
          else
            throw Error(bignumberError + z + " not true or false: " + W);
        if (G.hasOwnProperty(z = "MODULO_MODE") && (W = G[z], intCheck(W, 0, 9, z), e = W), G.hasOwnProperty(z = "POW_PRECISION") && (W = G[z], intCheck(W, 0, MAX, z), n = W), G.hasOwnProperty(z = "FORMAT"))
          if (W = G[z], typeof W == "object")
            i = W;
          else
            throw Error(bignumberError + z + " not an object: " + W);
        if (G.hasOwnProperty(z = "ALPHABET"))
          if (W = G[z], typeof W == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(W))
            m = W.slice(0, 10) == "0123456789", y = W;
          else
            throw Error(bignumberError + z + " invalid: " + W);
      } else
        throw Error(bignumberError + "Object expected: " + G);
    return {
      DECIMAL_PLACES: g,
      ROUNDING_MODE: c,
      EXPONENTIAL_AT: [x, R],
      RANGE: [B, j],
      CRYPTO: o,
      MODULO_MODE: e,
      POW_PRECISION: n,
      FORMAT: i,
      ALPHABET: y
    };
  }, U.isBigNumber = function(G) {
    if (!G || G._isBigNumber !== !0)
      return !1;
    if (!U.DEBUG)
      return !0;
    var z, W, F = G.c, k = G.e, T = G.s;
    e:
      if ({}.toString.call(F) == "[object Array]") {
        if ((T === 1 || T === -1) && k >= -MAX && k <= MAX && k === mathfloor(k)) {
          if (F[0] === 0) {
            if (k === 0 && F.length === 1)
              return !0;
            break e;
          }
          if (z = (k + 1) % LOG_BASE, z < 1 && (z += LOG_BASE), String(F[0]).length == z) {
            for (z = 0; z < F.length; z++)
              if (W = F[z], W < 0 || W >= BASE || W !== mathfloor(W))
                break e;
            if (W !== 0)
              return !0;
          }
        }
      } else if (F === null && k === null && (T === null || T === 1 || T === -1))
        return !0;
    throw Error(bignumberError + "Invalid BigNumber: " + G);
  }, U.maximum = U.max = function() {
    return Ke(arguments, l.lt);
  }, U.minimum = U.min = function() {
    return Ke(arguments, l.gt);
  }, U.random = function() {
    var G = 9007199254740992, z = Math.random() * G & 2097151 ? function() {
      return mathfloor(Math.random() * G);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(W) {
      var F, k, T, p, b, _ = 0, v = [], S = new U(h);
      if (W == null ? W = g : intCheck(W, 0, MAX), p = mathceil(W / LOG_BASE), o)
        if (crypto.getRandomValues) {
          for (F = crypto.getRandomValues(new Uint32Array(p *= 2)); _ < p; )
            b = F[_] * 131072 + (F[_ + 1] >>> 11), b >= 9e15 ? (k = crypto.getRandomValues(new Uint32Array(2)), F[_] = k[0], F[_ + 1] = k[1]) : (v.push(b % 1e14), _ += 2);
          _ = p / 2;
        } else if (crypto.randomBytes) {
          for (F = crypto.randomBytes(p *= 7); _ < p; )
            b = (F[_] & 31) * 281474976710656 + F[_ + 1] * 1099511627776 + F[_ + 2] * 4294967296 + F[_ + 3] * 16777216 + (F[_ + 4] << 16) + (F[_ + 5] << 8) + F[_ + 6], b >= 9e15 ? crypto.randomBytes(7).copy(F, _) : (v.push(b % 1e14), _ += 7);
          _ = p / 7;
        } else
          throw o = !1, Error(bignumberError + "crypto unavailable");
      if (!o)
        for (; _ < p; )
          b = z(), b < 9e15 && (v[_++] = b % 1e14);
      for (p = v[--_], W %= LOG_BASE, p && W && (b = POWS_TEN[LOG_BASE - W], v[_] = mathfloor(p / b) * b); v[_] === 0; v.pop(), _--)
        ;
      if (_ < 0)
        v = [T = 0];
      else {
        for (T = -1; v[0] === 0; v.splice(0, 1), T -= LOG_BASE)
          ;
        for (_ = 1, b = v[0]; b >= 10; b /= 10, _++)
          ;
        _ < LOG_BASE && (T -= LOG_BASE - _);
      }
      return S.e = T, S.c = v, S;
    };
  }(), U.sum = function() {
    for (var G = 1, z = arguments, W = new U(z[0]); G < z.length; )
      W = W.plus(z[G++]);
    return W;
  }, a = function() {
    var G = "0123456789";
    function z(W, F, k, T) {
      for (var p, b = [0], _, v = 0, S = W.length; v < S; ) {
        for (_ = b.length; _--; b[_] *= F)
          ;
        for (b[0] += T.indexOf(W.charAt(v++)), p = 0; p < b.length; p++)
          b[p] > k - 1 && (b[p + 1] == null && (b[p + 1] = 0), b[p + 1] += b[p] / k | 0, b[p] %= k);
      }
      return b.reverse();
    }
    return function(W, F, k, T, p) {
      var b, _, v, S, E, w, A, I, C = W.indexOf("."), X = g, D = c;
      for (C >= 0 && (S = n, n = 0, W = W.replace(".", ""), I = new U(F), w = I.pow(W.length - C), n = S, I.c = z(
        toFixedPoint(coeffToString(w.c), w.e, "0"),
        10,
        k,
        G
      ), I.e = I.c.length), A = z(W, F, k, p ? (b = y, G) : (b = G, y)), v = S = A.length; A[--S] == 0; A.pop())
        ;
      if (!A[0])
        return b.charAt(0);
      if (C < 0 ? --v : (w.c = A, w.e = v, w.s = T, w = t(w, I, X, D, k), A = w.c, E = w.r, v = w.e), _ = v + X + 1, C = A[_], S = k / 2, E = E || _ < 0 || A[_ + 1] != null, E = D < 4 ? (C != null || E) && (D == 0 || D == (w.s < 0 ? 3 : 2)) : C > S || C == S && (D == 4 || E || D == 6 && A[_ - 1] & 1 || D == (w.s < 0 ? 8 : 7)), _ < 1 || !A[0])
        W = E ? toFixedPoint(b.charAt(1), -X, b.charAt(0)) : b.charAt(0);
      else {
        if (A.length = _, E)
          for (--k; ++A[--_] > k; )
            A[_] = 0, _ || (++v, A = [1].concat(A));
        for (S = A.length; !A[--S]; )
          ;
        for (C = 0, W = ""; C <= S; W += b.charAt(A[C++]))
          ;
        W = toFixedPoint(W, v, b.charAt(0));
      }
      return W;
    };
  }(), t = function() {
    function G(F, k, T) {
      var p, b, _, v, S = 0, E = F.length, w = k % SQRT_BASE, A = k / SQRT_BASE | 0;
      for (F = F.slice(); E--; )
        _ = F[E] % SQRT_BASE, v = F[E] / SQRT_BASE | 0, p = A * _ + v * w, b = w * _ + p % SQRT_BASE * SQRT_BASE + S, S = (b / T | 0) + (p / SQRT_BASE | 0) + A * v, F[E] = b % T;
      return S && (F = [S].concat(F)), F;
    }
    function z(F, k, T, p) {
      var b, _;
      if (T != p)
        _ = T > p ? 1 : -1;
      else
        for (b = _ = 0; b < T; b++)
          if (F[b] != k[b]) {
            _ = F[b] > k[b] ? 1 : -1;
            break;
          }
      return _;
    }
    function W(F, k, T, p) {
      for (var b = 0; T--; )
        F[T] -= b, b = F[T] < k[T] ? 1 : 0, F[T] = b * p + F[T] - k[T];
      for (; !F[0] && F.length > 1; F.splice(0, 1))
        ;
    }
    return function(F, k, T, p, b) {
      var _, v, S, E, w, A, I, C, X, D, V, Z, J, ee, he, le, ie, Ne = F.s == k.s ? 1 : -1, ue = F.c, se = k.c;
      if (!ue || !ue[0] || !se || !se[0])
        return new U(
          !F.s || !k.s || (ue ? se && ue[0] == se[0] : !se) ? NaN : ue && ue[0] == 0 || !se ? Ne * 0 : Ne / 0
        );
      for (C = new U(Ne), X = C.c = [], v = F.e - k.e, Ne = T + v + 1, b || (b = BASE, v = bitFloor(F.e / LOG_BASE) - bitFloor(k.e / LOG_BASE), Ne = Ne / LOG_BASE | 0), S = 0; se[S] == (ue[S] || 0); S++)
        ;
      if (se[S] > (ue[S] || 0) && v--, Ne < 0)
        X.push(1), E = !0;
      else {
        for (ee = ue.length, le = se.length, S = 0, Ne += 2, w = mathfloor(b / (se[0] + 1)), w > 1 && (se = G(se, w, b), ue = G(ue, w, b), le = se.length, ee = ue.length), J = le, D = ue.slice(0, le), V = D.length; V < le; D[V++] = 0)
          ;
        ie = se.slice(), ie = [0].concat(ie), he = se[0], se[1] >= b / 2 && he++;
        do {
          if (w = 0, _ = z(se, D, le, V), _ < 0) {
            if (Z = D[0], le != V && (Z = Z * b + (D[1] || 0)), w = mathfloor(Z / he), w > 1)
              for (w >= b && (w = b - 1), A = G(se, w, b), I = A.length, V = D.length; z(A, D, I, V) == 1; )
                w--, W(A, le < I ? ie : se, I, b), I = A.length, _ = 1;
            else
              w == 0 && (_ = w = 1), A = se.slice(), I = A.length;
            if (I < V && (A = [0].concat(A)), W(D, A, V, b), V = D.length, _ == -1)
              for (; z(se, D, le, V) < 1; )
                w++, W(D, le < V ? ie : se, V, b), V = D.length;
          } else
            _ === 0 && (w++, D = [0]);
          X[S++] = w, D[0] ? D[V++] = ue[J] || 0 : (D = [ue[J]], V = 1);
        } while ((J++ < ee || D[0] != null) && Ne--);
        E = D[0] != null, X[0] || X.splice(0, 1);
      }
      if (b == BASE) {
        for (S = 1, Ne = X[0]; Ne >= 10; Ne /= 10, S++)
          ;
        Pe(C, T + (C.e = S + v * LOG_BASE - 1) + 1, p, E);
      } else
        C.e = v, C.r = +E;
      return C;
    };
  }();
  function be(G, z, W, F) {
    var k, T, p, b, _;
    if (W == null ? W = c : intCheck(W, 0, 8), !G.c)
      return G.toString();
    if (k = G.c[0], p = G.e, z == null)
      _ = coeffToString(G.c), _ = F == 1 || F == 2 && (p <= x || p >= R) ? toExponential(_, p) : toFixedPoint(_, p, "0");
    else if (G = Pe(new U(G), z, W), T = G.e, _ = coeffToString(G.c), b = _.length, F == 1 || F == 2 && (z <= T || T <= x)) {
      for (; b < z; _ += "0", b++)
        ;
      _ = toExponential(_, T);
    } else if (z -= p, _ = toFixedPoint(_, T, "0"), T + 1 > b) {
      if (--z > 0)
        for (_ += "."; z--; _ += "0")
          ;
    } else if (z += T - b, z > 0)
      for (T + 1 == b && (_ += "."); z--; _ += "0")
        ;
    return G.s < 0 && k ? "-" + _ : _;
  }
  function Ke(G, z) {
    for (var W, F = 1, k = new U(G[0]); F < G.length; F++)
      if (W = new U(G[F]), W.s)
        z.call(k, W) && (k = W);
      else {
        k = W;
        break;
      }
    return k;
  }
  function ze(G, z, W) {
    for (var F = 1, k = z.length; !z[--k]; z.pop())
      ;
    for (k = z[0]; k >= 10; k /= 10, F++)
      ;
    return (W = F + W * LOG_BASE - 1) > j ? G.c = G.e = null : W < B ? G.c = [G.e = 0] : (G.e = W, G.c = z), G;
  }
  d = function() {
    var G = /^(-?)0([xbo])(?=\w[\w.]*$)/i, z = /^([^.]+)\.$/, W = /^\.([^.]+)$/, F = /^-?(Infinity|NaN)$/, k = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(T, p, b, _) {
      var v, S = b ? p : p.replace(k, "");
      if (F.test(S))
        T.s = isNaN(S) ? null : S < 0 ? -1 : 1;
      else {
        if (!b && (S = S.replace(G, function(E, w, A) {
          return v = (A = A.toLowerCase()) == "x" ? 16 : A == "b" ? 2 : 8, !_ || _ == v ? w : E;
        }), _ && (v = _, S = S.replace(z, "$1").replace(W, "0.$1")), p != S))
          return new U(S, v);
        if (U.DEBUG)
          throw Error(bignumberError + "Not a" + (_ ? " base " + _ : "") + " number: " + p);
        T.s = null;
      }
      T.c = T.e = null;
    };
  }();
  function Pe(G, z, W, F) {
    var k, T, p, b, _, v, S, E = G.c, w = POWS_TEN;
    if (E) {
      e: {
        for (k = 1, b = E[0]; b >= 10; b /= 10, k++)
          ;
        if (T = z - k, T < 0)
          T += LOG_BASE, p = z, _ = E[v = 0], S = _ / w[k - p - 1] % 10 | 0;
        else if (v = mathceil((T + 1) / LOG_BASE), v >= E.length)
          if (F) {
            for (; E.length <= v; E.push(0))
              ;
            _ = S = 0, k = 1, T %= LOG_BASE, p = T - LOG_BASE + 1;
          } else
            break e;
        else {
          for (_ = b = E[v], k = 1; b >= 10; b /= 10, k++)
            ;
          T %= LOG_BASE, p = T - LOG_BASE + k, S = p < 0 ? 0 : _ / w[k - p - 1] % 10 | 0;
        }
        if (F = F || z < 0 || E[v + 1] != null || (p < 0 ? _ : _ % w[k - p - 1]), F = W < 4 ? (S || F) && (W == 0 || W == (G.s < 0 ? 3 : 2)) : S > 5 || S == 5 && (W == 4 || F || W == 6 && (T > 0 ? p > 0 ? _ / w[k - p] : 0 : E[v - 1]) % 10 & 1 || W == (G.s < 0 ? 8 : 7)), z < 1 || !E[0])
          return E.length = 0, F ? (z -= G.e + 1, E[0] = w[(LOG_BASE - z % LOG_BASE) % LOG_BASE], G.e = -z || 0) : E[0] = G.e = 0, G;
        if (T == 0 ? (E.length = v, b = 1, v--) : (E.length = v + 1, b = w[LOG_BASE - T], E[v] = p > 0 ? mathfloor(_ / w[k - p] % w[p]) * b : 0), F)
          for (; ; )
            if (v == 0) {
              for (T = 1, p = E[0]; p >= 10; p /= 10, T++)
                ;
              for (p = E[0] += b, b = 1; p >= 10; p /= 10, b++)
                ;
              T != b && (G.e++, E[0] == BASE && (E[0] = 1));
              break;
            } else {
              if (E[v] += b, E[v] != BASE)
                break;
              E[v--] = 0, b = 1;
            }
        for (T = E.length; E[--T] === 0; E.pop())
          ;
      }
      G.e > j ? G.c = G.e = null : G.e < B && (G.c = [G.e = 0]);
    }
    return G;
  }
  function st(G) {
    var z, W = G.e;
    return W === null ? G.toString() : (z = coeffToString(G.c), z = W <= x || W >= R ? toExponential(z, W) : toFixedPoint(z, W, "0"), G.s < 0 ? "-" + z : z);
  }
  return l.absoluteValue = l.abs = function() {
    var G = new U(this);
    return G.s < 0 && (G.s = 1), G;
  }, l.comparedTo = function(G, z) {
    return compare$2(this, new U(G, z));
  }, l.decimalPlaces = l.dp = function(G, z) {
    var W, F, k, T = this;
    if (G != null)
      return intCheck(G, 0, MAX), z == null ? z = c : intCheck(z, 0, 8), Pe(new U(T), G + T.e + 1, z);
    if (!(W = T.c))
      return null;
    if (F = ((k = W.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE, k = W[k])
      for (; k % 10 == 0; k /= 10, F--)
        ;
    return F < 0 && (F = 0), F;
  }, l.dividedBy = l.div = function(G, z) {
    return t(this, new U(G, z), g, c);
  }, l.dividedToIntegerBy = l.idiv = function(G, z) {
    return t(this, new U(G, z), 0, 1);
  }, l.exponentiatedBy = l.pow = function(G, z) {
    var W, F, k, T, p, b, _, v, S, E = this;
    if (G = new U(G), G.c && !G.isInteger())
      throw Error(bignumberError + "Exponent not an integer: " + st(G));
    if (z != null && (z = new U(z)), b = G.e > 14, !E.c || !E.c[0] || E.c[0] == 1 && !E.e && E.c.length == 1 || !G.c || !G.c[0])
      return S = new U(Math.pow(+st(E), b ? G.s * (2 - isOdd(G)) : +st(G))), z ? S.mod(z) : S;
    if (_ = G.s < 0, z) {
      if (z.c ? !z.c[0] : !z.s)
        return new U(NaN);
      F = !_ && E.isInteger() && z.isInteger(), F && (E = E.mod(z));
    } else {
      if (G.e > 9 && (E.e > 0 || E.e < -1 || (E.e == 0 ? E.c[0] > 1 || b && E.c[1] >= 24e7 : E.c[0] < 8e13 || b && E.c[0] <= 9999975e7)))
        return T = E.s < 0 && isOdd(G) ? -0 : 0, E.e > -1 && (T = 1 / T), new U(_ ? 1 / T : T);
      n && (T = mathceil(n / LOG_BASE + 2));
    }
    for (b ? (W = new U(0.5), _ && (G.s = 1), v = isOdd(G)) : (k = Math.abs(+st(G)), v = k % 2), S = new U(h); ; ) {
      if (v) {
        if (S = S.times(E), !S.c)
          break;
        T ? S.c.length > T && (S.c.length = T) : F && (S = S.mod(z));
      }
      if (k) {
        if (k = mathfloor(k / 2), k === 0)
          break;
        v = k % 2;
      } else if (G = G.times(W), Pe(G, G.e + 1, 1), G.e > 14)
        v = isOdd(G);
      else {
        if (k = +st(G), k === 0)
          break;
        v = k % 2;
      }
      E = E.times(E), T ? E.c && E.c.length > T && (E.c.length = T) : F && (E = E.mod(z));
    }
    return F ? S : (_ && (S = h.div(S)), z ? S.mod(z) : T ? Pe(S, n, c, p) : S);
  }, l.integerValue = function(G) {
    var z = new U(this);
    return G == null ? G = c : intCheck(G, 0, 8), Pe(z, z.e + 1, G);
  }, l.isEqualTo = l.eq = function(G, z) {
    return compare$2(this, new U(G, z)) === 0;
  }, l.isFinite = function() {
    return !!this.c;
  }, l.isGreaterThan = l.gt = function(G, z) {
    return compare$2(this, new U(G, z)) > 0;
  }, l.isGreaterThanOrEqualTo = l.gte = function(G, z) {
    return (z = compare$2(this, new U(G, z))) === 1 || z === 0;
  }, l.isInteger = function() {
    return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
  }, l.isLessThan = l.lt = function(G, z) {
    return compare$2(this, new U(G, z)) < 0;
  }, l.isLessThanOrEqualTo = l.lte = function(G, z) {
    return (z = compare$2(this, new U(G, z))) === -1 || z === 0;
  }, l.isNaN = function() {
    return !this.s;
  }, l.isNegative = function() {
    return this.s < 0;
  }, l.isPositive = function() {
    return this.s > 0;
  }, l.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, l.minus = function(G, z) {
    var W, F, k, T, p = this, b = p.s;
    if (G = new U(G, z), z = G.s, !b || !z)
      return new U(NaN);
    if (b != z)
      return G.s = -z, p.plus(G);
    var _ = p.e / LOG_BASE, v = G.e / LOG_BASE, S = p.c, E = G.c;
    if (!_ || !v) {
      if (!S || !E)
        return S ? (G.s = -z, G) : new U(E ? p : NaN);
      if (!S[0] || !E[0])
        return E[0] ? (G.s = -z, G) : new U(S[0] ? p : c == 3 ? -0 : 0);
    }
    if (_ = bitFloor(_), v = bitFloor(v), S = S.slice(), b = _ - v) {
      for ((T = b < 0) ? (b = -b, k = S) : (v = _, k = E), k.reverse(), z = b; z--; k.push(0))
        ;
      k.reverse();
    } else
      for (F = (T = (b = S.length) < (z = E.length)) ? b : z, b = z = 0; z < F; z++)
        if (S[z] != E[z]) {
          T = S[z] < E[z];
          break;
        }
    if (T && (k = S, S = E, E = k, G.s = -G.s), z = (F = E.length) - (W = S.length), z > 0)
      for (; z--; S[W++] = 0)
        ;
    for (z = BASE - 1; F > b; ) {
      if (S[--F] < E[F]) {
        for (W = F; W && !S[--W]; S[W] = z)
          ;
        --S[W], S[F] += BASE;
      }
      S[F] -= E[F];
    }
    for (; S[0] == 0; S.splice(0, 1), --v)
      ;
    return S[0] ? ze(G, S, v) : (G.s = c == 3 ? -1 : 1, G.c = [G.e = 0], G);
  }, l.modulo = l.mod = function(G, z) {
    var W, F, k = this;
    return G = new U(G, z), !k.c || !G.s || G.c && !G.c[0] ? new U(NaN) : !G.c || k.c && !k.c[0] ? new U(k) : (e == 9 ? (F = G.s, G.s = 1, W = t(k, G, 0, 3), G.s = F, W.s *= F) : W = t(k, G, 0, e), G = k.minus(W.times(G)), !G.c[0] && e == 1 && (G.s = k.s), G);
  }, l.multipliedBy = l.times = function(G, z) {
    var W, F, k, T, p, b, _, v, S, E, w, A, I, C, X, D = this, V = D.c, Z = (G = new U(G, z)).c;
    if (!V || !Z || !V[0] || !Z[0])
      return !D.s || !G.s || V && !V[0] && !Z || Z && !Z[0] && !V ? G.c = G.e = G.s = null : (G.s *= D.s, !V || !Z ? G.c = G.e = null : (G.c = [0], G.e = 0)), G;
    for (F = bitFloor(D.e / LOG_BASE) + bitFloor(G.e / LOG_BASE), G.s *= D.s, _ = V.length, E = Z.length, _ < E && (I = V, V = Z, Z = I, k = _, _ = E, E = k), k = _ + E, I = []; k--; I.push(0))
      ;
    for (C = BASE, X = SQRT_BASE, k = E; --k >= 0; ) {
      for (W = 0, w = Z[k] % X, A = Z[k] / X | 0, p = _, T = k + p; T > k; )
        v = V[--p] % X, S = V[p] / X | 0, b = A * v + S * w, v = w * v + b % X * X + I[T] + W, W = (v / C | 0) + (b / X | 0) + A * S, I[T--] = v % C;
      I[T] = W;
    }
    return W ? ++F : I.splice(0, 1), ze(G, I, F);
  }, l.negated = function() {
    var G = new U(this);
    return G.s = -G.s || null, G;
  }, l.plus = function(G, z) {
    var W, F = this, k = F.s;
    if (G = new U(G, z), z = G.s, !k || !z)
      return new U(NaN);
    if (k != z)
      return G.s = -z, F.minus(G);
    var T = F.e / LOG_BASE, p = G.e / LOG_BASE, b = F.c, _ = G.c;
    if (!T || !p) {
      if (!b || !_)
        return new U(k / 0);
      if (!b[0] || !_[0])
        return _[0] ? G : new U(b[0] ? F : k * 0);
    }
    if (T = bitFloor(T), p = bitFloor(p), b = b.slice(), k = T - p) {
      for (k > 0 ? (p = T, W = _) : (k = -k, W = b), W.reverse(); k--; W.push(0))
        ;
      W.reverse();
    }
    for (k = b.length, z = _.length, k - z < 0 && (W = _, _ = b, b = W, z = k), k = 0; z; )
      k = (b[--z] = b[z] + _[z] + k) / BASE | 0, b[z] = BASE === b[z] ? 0 : b[z] % BASE;
    return k && (b = [k].concat(b), ++p), ze(G, b, p);
  }, l.precision = l.sd = function(G, z) {
    var W, F, k, T = this;
    if (G != null && G !== !!G)
      return intCheck(G, 1, MAX), z == null ? z = c : intCheck(z, 0, 8), Pe(new U(T), G, z);
    if (!(W = T.c))
      return null;
    if (k = W.length - 1, F = k * LOG_BASE + 1, k = W[k]) {
      for (; k % 10 == 0; k /= 10, F--)
        ;
      for (k = W[0]; k >= 10; k /= 10, F++)
        ;
    }
    return G && T.e + 1 > F && (F = T.e + 1), F;
  }, l.shiftedBy = function(G) {
    return intCheck(G, -MAX_SAFE_INTEGER$1, MAX_SAFE_INTEGER$1), this.times("1e" + G);
  }, l.squareRoot = l.sqrt = function() {
    var G, z, W, F, k, T = this, p = T.c, b = T.s, _ = T.e, v = g + 4, S = new U("0.5");
    if (b !== 1 || !p || !p[0])
      return new U(!b || b < 0 && (!p || p[0]) ? NaN : p ? T : 1 / 0);
    if (b = Math.sqrt(+st(T)), b == 0 || b == 1 / 0 ? (z = coeffToString(p), (z.length + _) % 2 == 0 && (z += "0"), b = Math.sqrt(+z), _ = bitFloor((_ + 1) / 2) - (_ < 0 || _ % 2), b == 1 / 0 ? z = "5e" + _ : (z = b.toExponential(), z = z.slice(0, z.indexOf("e") + 1) + _), W = new U(z)) : W = new U(b + ""), W.c[0]) {
      for (_ = W.e, b = _ + v, b < 3 && (b = 0); ; )
        if (k = W, W = S.times(k.plus(t(T, k, v, 1))), coeffToString(k.c).slice(0, b) === (z = coeffToString(W.c)).slice(0, b))
          if (W.e < _ && --b, z = z.slice(b - 3, b + 1), z == "9999" || !F && z == "4999") {
            if (!F && (Pe(k, k.e + g + 2, 0), k.times(k).eq(T))) {
              W = k;
              break;
            }
            v += 4, b += 4, F = 1;
          } else {
            (!+z || !+z.slice(1) && z.charAt(0) == "5") && (Pe(W, W.e + g + 2, 1), G = !W.times(W).eq(T));
            break;
          }
    }
    return Pe(W, W.e + g + 1, c, G);
  }, l.toExponential = function(G, z) {
    return G != null && (intCheck(G, 0, MAX), G++), be(this, G, z, 1);
  }, l.toFixed = function(G, z) {
    return G != null && (intCheck(G, 0, MAX), G = G + this.e + 1), be(this, G, z);
  }, l.toFormat = function(G, z, W) {
    var F, k = this;
    if (W == null)
      G != null && z && typeof z == "object" ? (W = z, z = null) : G && typeof G == "object" ? (W = G, G = z = null) : W = i;
    else if (typeof W != "object")
      throw Error(bignumberError + "Argument not an object: " + W);
    if (F = k.toFixed(G, z), k.c) {
      var T, p = F.split("."), b = +W.groupSize, _ = +W.secondaryGroupSize, v = W.groupSeparator || "", S = p[0], E = p[1], w = k.s < 0, A = w ? S.slice(1) : S, I = A.length;
      if (_ && (T = b, b = _, _ = T, I -= T), b > 0 && I > 0) {
        for (T = I % b || b, S = A.substr(0, T); T < I; T += b)
          S += v + A.substr(T, b);
        _ > 0 && (S += v + A.slice(T)), w && (S = "-" + S);
      }
      F = E ? S + (W.decimalSeparator || "") + ((_ = +W.fractionGroupSize) ? E.replace(
        new RegExp("\\d{" + _ + "}\\B", "g"),
        "$&" + (W.fractionGroupSeparator || "")
      ) : E) : S;
    }
    return (W.prefix || "") + F + (W.suffix || "");
  }, l.toFraction = function(G) {
    var z, W, F, k, T, p, b, _, v, S, E, w, A = this, I = A.c;
    if (G != null && (b = new U(G), !b.isInteger() && (b.c || b.s !== 1) || b.lt(h)))
      throw Error(bignumberError + "Argument " + (b.isInteger() ? "out of range: " : "not an integer: ") + st(b));
    if (!I)
      return new U(A);
    for (z = new U(h), v = W = new U(h), F = _ = new U(h), w = coeffToString(I), T = z.e = w.length - A.e - 1, z.c[0] = POWS_TEN[(p = T % LOG_BASE) < 0 ? LOG_BASE + p : p], G = !G || b.comparedTo(z) > 0 ? T > 0 ? z : v : b, p = j, j = 1 / 0, b = new U(w), _.c[0] = 0; S = t(b, z, 0, 1), k = W.plus(S.times(F)), k.comparedTo(G) != 1; )
      W = F, F = k, v = _.plus(S.times(k = v)), _ = k, z = b.minus(S.times(k = z)), b = k;
    return k = t(G.minus(W), F, 0, 1), _ = _.plus(k.times(v)), W = W.plus(k.times(F)), _.s = v.s = A.s, T = T * 2, E = t(v, F, T, c).minus(A).abs().comparedTo(
      t(_, W, T, c).minus(A).abs()
    ) < 1 ? [v, F] : [_, W], j = p, E;
  }, l.toNumber = function() {
    return +st(this);
  }, l.toPrecision = function(G, z) {
    return G != null && intCheck(G, 1, MAX), be(this, G, z, 2);
  }, l.toString = function(G) {
    var z, W = this, F = W.s, k = W.e;
    return k === null ? F ? (z = "Infinity", F < 0 && (z = "-" + z)) : z = "NaN" : (G == null ? z = k <= x || k >= R ? toExponential(coeffToString(W.c), k) : toFixedPoint(coeffToString(W.c), k, "0") : G === 10 && m ? (W = Pe(new U(W), g + k + 1, c), z = toFixedPoint(coeffToString(W.c), W.e, "0")) : (intCheck(G, 2, y.length, "Base"), z = a(toFixedPoint(coeffToString(W.c), k, "0"), 10, G, F, !0)), F < 0 && W.c[0] && (z = "-" + z)), z;
  }, l.valueOf = l.toJSON = function() {
    return st(this);
  }, l._isBigNumber = !0, l[Symbol.toStringTag] = "BigNumber", l[Symbol.for("nodejs.util.inspect.custom")] = l.valueOf, u != null && U.set(u), U;
}
function bitFloor(u) {
  var t = u | 0;
  return u > 0 || u === t ? t : t - 1;
}
function coeffToString(u) {
  for (var t, a, d = 1, l = u.length, h = u[0] + ""; d < l; ) {
    for (t = u[d++] + "", a = LOG_BASE - t.length; a--; t = "0" + t)
      ;
    h += t;
  }
  for (l = h.length; h.charCodeAt(--l) === 48; )
    ;
  return h.slice(0, l + 1 || 1);
}
function compare$2(u, t) {
  var a, d, l = u.c, h = t.c, g = u.s, c = t.s, x = u.e, R = t.e;
  if (!g || !c)
    return null;
  if (a = l && !l[0], d = h && !h[0], a || d)
    return a ? d ? 0 : -c : g;
  if (g != c)
    return g;
  if (a = g < 0, d = x == R, !l || !h)
    return d ? 0 : !l ^ a ? 1 : -1;
  if (!d)
    return x > R ^ a ? 1 : -1;
  for (c = (x = l.length) < (R = h.length) ? x : R, g = 0; g < c; g++)
    if (l[g] != h[g])
      return l[g] > h[g] ^ a ? 1 : -1;
  return x == R ? 0 : x > R ^ a ? 1 : -1;
}
function intCheck(u, t, a, d) {
  if (u < t || u > a || u !== mathfloor(u))
    throw Error(bignumberError + (d || "Argument") + (typeof u == "number" ? u < t || u > a ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(u));
}
function isOdd(u) {
  var t = u.c.length - 1;
  return bitFloor(u.e / LOG_BASE) == t && u.c[t] % 2 != 0;
}
function toExponential(u, t) {
  return (u.length > 1 ? u.charAt(0) + "." + u.slice(1) : u) + (t < 0 ? "e" : "e+") + t;
}
function toFixedPoint(u, t, a) {
  var d, l;
  if (t < 0) {
    for (l = a + "."; ++t; l += a)
      ;
    u = l + u;
  } else if (d = u.length, ++t > d) {
    for (l = a, t -= d; --t; l += a)
      ;
    u += l;
  } else
    t < d && (u = u.slice(0, t) + "." + u.slice(t));
  return u;
}
var BigNumber$1 = clone();
const REQUIRE_NON_NULL_ERROR = "This value cannot be null | undefined.", REQUIRE_STRING_OR_UINT8ARRAY_ERROR = "This value must be a string or Uint8Array.", REQUIRE_ARRAY_ERROR = "The provided variable must be an Array.", FUNCTION_CONVERT_TO_BIGNUMBER_ERROR = "This value must be a String, Number, or BigNumber to be converted.", FUNCTION_CONVERT_TO_NUMBER_ERROR = "This value must be a String, Number, or BigNumber to be converted.", FUNCTION_CONVERT_TO_NUMBER_PARSE_ERROR = "Unable to parse given variable. Returns NaN.";
function isNonNull(u) {
  return u != null;
}
function isUint8Array(u) {
  return isNonNull(u) && u instanceof Uint8Array;
}
function isNumber(u) {
  return isNonNull(u) && (typeof u == "number" || u instanceof Number);
}
function isBigNumber(u) {
  return isNonNull(u) && u instanceof BigNumber$1;
}
function isLong(u) {
  return isNonNull(u) && u instanceof long;
}
function isString(u) {
  return isNonNull(u) && typeof u == "string";
}
function isStringOrUint8Array(u) {
  return isNonNull(u) && (isString(u) || isUint8Array(u));
}
function requireNonNull(u) {
  if (isNonNull(u))
    return u;
  throw new Error(REQUIRE_NON_NULL_ERROR);
}
function requireStringOrUint8Array(u) {
  if (isStringOrUint8Array(requireNonNull(u)))
    return u;
  throw new Error(REQUIRE_STRING_OR_UINT8ARRAY_ERROR);
}
function convertToBigNumber(u) {
  if (requireNonNull(u), isBigNumber(u) || isString(u) || isNumber(u) || isLong(u))
    return new BigNumber$1(u);
  throw new Error(FUNCTION_CONVERT_TO_BIGNUMBER_ERROR);
}
function convertToBigNumberArray(u) {
  if (u instanceof Array)
    return u.map(convertToBigNumber);
  throw new Error(REQUIRE_ARRAY_ERROR);
}
function convertToNumber(u) {
  if (requireNonNull(u), isBigNumber(u) || isString(u) || isNumber(u) || isLong(u)) {
    const t = parseInt(u);
    if (isNaN(t))
      throw new Error(FUNCTION_CONVERT_TO_NUMBER_PARSE_ERROR);
    return t;
  } else
    throw new Error(FUNCTION_CONVERT_TO_NUMBER_ERROR);
}
function safeView(u, t = 0, a = u.byteLength) {
  if (!(Number.isInteger(t) && t >= 0))
    throw new Error("Invalid offset!");
  if (!(Number.isInteger(a) && a >= 0))
    throw new Error("Invalid length!");
  return new DataView(
    u.buffer,
    u.byteOffset + t,
    Math.min(a, u.byteLength - t)
  );
}
function compare$1(u, t, a = /* @__PURE__ */ new Set()) {
  if (typeof u == "object" && typeof t == "object") {
    const d = Object.keys(u), l = Object.keys(t);
    if (d.length !== l.length)
      return !1;
    for (let h = 0; h < d.length; h++) {
      if (d[h] !== l[h])
        return !1;
      if (!a.has(d[h]) && !compare$1(u[d[h]], t[l[h]], a))
        return !1;
    }
    return !0;
  } else
    return typeof u == "number" && typeof t == "number" || typeof u == "string" && typeof t == "string" || typeof u == "boolean" && typeof t == "boolean" ? u === t : !1;
}
function arrayEqual$2(u, t) {
  if (u === t)
    return !0;
  if (u.byteLength !== t.byteLength)
    return !1;
  const a = new DataView(
    u.buffer,
    u.byteOffset,
    u.byteLength
  ), d = new DataView(
    t.buffer,
    t.byteOffset,
    t.byteLength
  );
  let l = u.byteLength;
  for (; l--; )
    if (a.getUint8(l) !== d.getUint8(l))
      return !1;
  return !0;
}
const ENTITY_ID_REGEX = /^(\d+)(?:\.(\d+)\.([a-fA-F0-9]+))?(?:-([a-z]{5}))?$/;
function constructor(u, t, a) {
  if (t == null && a != null || t != null && a == null)
    throw new Error("invalid entity ID");
  const [d, l, h] = typeof u == "number" || long.isLong(u) ? [
    a != null ? long.fromValue(u) : long.ZERO,
    t != null ? long.fromValue(t) : long.ZERO,
    a != null ? long.fromValue(a) : long.fromValue(u)
  ] : [
    u.shard != null ? long.fromValue(u.shard) : long.ZERO,
    u.realm != null ? long.fromValue(u.realm) : long.ZERO,
    long.fromValue(u.num)
  ];
  if (d.isNegative() || l.isNegative() || h.isNegative())
    throw new Error("negative numbers are not allowed in IDs");
  return {
    shard: d,
    realm: l,
    num: h
  };
}
function compare(u, t) {
  let a = u[0].compare(t[0]);
  return a != 0 || (a = u[1].compare(t[1]), a != 0) ? a : u[2].compare(t[2]);
}
function fromStringSplitter(u) {
  const t = ENTITY_ID_REGEX.exec(u);
  if (t == null)
    throw new Error(`failed to parse entity id: ${u}`);
  return t[2] == null && t[3] == null ? {
    shard: "0",
    realm: "0",
    numOrHex: t[1],
    checksum: t[4]
  } : {
    shard: t[1],
    realm: t[2],
    numOrHex: t[3],
    checksum: t[4]
  };
}
function fromString(u) {
  const t = fromStringSplitter(u);
  if (Number.isNaN(t.shard) || Number.isNaN(t.realm) || Number.isNaN(t.numOrHex))
    throw new Error("invalid format for entity ID");
  return {
    shard: t.shard != null ? long.fromString(t.shard) : long.ZERO,
    realm: t.realm != null ? long.fromString(t.realm) : long.ZERO,
    num: long.fromString(t.numOrHex),
    checksum: t.checksum
  };
}
function fromSolidityAddress(u) {
  const t = u.startsWith("0x") ? decode$6(u.slice(2)) : decode$6(u);
  if (t.length !== 20)
    throw new Error(`Invalid hex encoded solidity address length:
                expected length 40, got length ${u.length}`);
  const a = long.fromBytesBE([0, 0, 0, 0, ...t.slice(0, 4)]), d = long.fromBytesBE(Array.from(t.slice(4, 12))), l = long.fromBytesBE(Array.from(t.slice(12, 20)));
  return [a, d, l];
}
function toSolidityAddress(u) {
  const t = new Uint8Array(20), a = safeView(t), [d, l, h] = u;
  return a.setUint32(0, convertToNumber(d)), a.setUint32(8, convertToNumber(l)), a.setUint32(16, convertToNumber(h)), encode$4(t);
}
function _checksum(u, t) {
  let a = "", d = [], l = 0, h = 0, g = 0, c = 0, x = 0;
  const R = 26 * 26 * 26, B = 26 * 26 * 26 * 26 * 26, j = "a".charCodeAt(0), o = 1000003, e = 31;
  let n = new Uint8Array(u.length + 6);
  n.set(u, 0), n.set([0, 0, 0, 0, 0, 0], u.length);
  for (let i = 0; i < t.length; i++)
    d.push(t[i] === "." ? 10 : parseInt(t[i], 10));
  for (let i = 0; i < d.length; i++)
    g = (e * g + d[i]) % R, i % 2 === 0 ? l = (l + d[i]) % 11 : h = (h + d[i]) % 11;
  for (let i = 0; i < n.length; i++)
    c = (e * c + n[i]) % B;
  x = (((t.length % 5 * 11 + l) * 11 + h) * R + g + c) % B, x = x * o % B;
  for (let i = 0; i < 5; i++)
    a = String.fromCharCode(j + x % 26) + a, x /= 26;
  return a;
}
function validateChecksum(u, t, a, d, l) {
  if (l._network._ledgerId == null || d == null)
    return;
  const h = _checksum(
    l._network._ledgerId._ledgerId,
    `${u.toString()}.${t.toString()}.${a.toString()}`
  );
  if (d != h)
    throw new BadEntityIdError(
      u,
      t,
      a,
      d,
      h
    );
}
function toStringWithChecksum(u, t) {
  if (t._network._ledgerId == null)
    throw new Error(
      "cannot calculate checksum with a client that does not contain a recognzied ledger ID"
    );
  const a = _checksum(t._network._ledgerId._ledgerId, u);
  return `${u}-${a}`;
}
class Cache {
  constructor() {
    this._timeDrift = 0, this._contractId = null, this._keyList = null, this._thresholdKey = null, this._publicKeyED25519 = null, this._publicKeyECDSA = null, this._privateKeyConstructor = null, this._mnemonicFromString = null, this._accountIdConstructor = null, this._delegateContractId = null, this._evmAddress = null, this._ethereumTransactionDataLegacyFromBytes = null, this._ethereumTransactionDataEip1559FromBytes = null, this._transactionReceiptQueryConstructor = null, this._transactionRecordQueryConstructor = null;
  }
  setTimeDrift(t) {
    this._timeDrift = t;
  }
  get timeDrift() {
    if (this._timeDrift == null)
      throw new Error("Cache.timeDrift was used before it was set");
    return this._timeDrift;
  }
  setContractId(t) {
    this._contractId = t;
  }
  get contractId() {
    if (this._contractId == null)
      throw new Error("Cache.contractId was used before it was set");
    return this._contractId;
  }
  setKeyList(t) {
    this._keyList = t;
  }
  get keyList() {
    if (this._keyList == null)
      throw new Error("Cache.keyList was used before it was set");
    return this._keyList;
  }
  setThresholdKey(t) {
    this._thresholdKey = t;
  }
  get thresholdKey() {
    if (this._thresholdKey == null)
      throw new Error("Cache.thresholdKey was used before it was set");
    return this._thresholdKey;
  }
  setPublicKeyED25519(t) {
    this._publicKeyED25519 = t;
  }
  get publicKeyED25519() {
    if (this._publicKeyED25519 == null)
      throw new Error(
        "Cache.publicKeyED25519 was used before it was set"
      );
    return this._publicKeyED25519;
  }
  setPublicKeyECDSA(t) {
    this._publicKeyECDSA = t;
  }
  get publicKeyECDSA() {
    if (this._publicKeyECDSA == null)
      throw new Error("Cache.publicKeyECDSA was used before it was set");
    return this._publicKeyECDSA;
  }
  setPrivateKeyConstructor(t) {
    this._privateKeyConstructor = t;
  }
  get privateKeyConstructor() {
    if (this._privateKeyConstructor == null)
      throw new Error(
        "Cache.privateKeyConstructor was used before it was set"
      );
    return this._privateKeyConstructor;
  }
  setMnemonicFromString(t) {
    this._mnemonicFromString = t;
  }
  get mnemonicFromString() {
    if (this._mnemonicFromString == null)
      throw new Error(
        "Cache.mnemonicFromString was used before it was set"
      );
    return this.mnemonicFromString;
  }
  setAccountIdConstructor(t) {
    this._accountIdConstructor = t;
  }
  get accountIdConstructor() {
    if (this._accountIdConstructor == null)
      throw new Error(
        "Cache.accountIdConstructor was used before it was set"
      );
    return this._accountIdConstructor;
  }
  setDelegateContractId(t) {
    this._delegateContractId = t;
  }
  get delegateContractId() {
    if (this._delegateContractId == null)
      throw new Error(
        "Cache.delegateContractId was used before it was set"
      );
    return this._delegateContractId;
  }
  setEvmAddress(t) {
    this._evmAddress = t;
  }
  get evmAddress() {
    if (this._evmAddress == null)
      throw new Error("Cache.evmAddress was used before it was set");
    return this._evmAddress;
  }
  setEthereumTransactionDataLegacyFromBytes(t) {
    this._ethereumTransactionDataLegacyFromBytes = t;
  }
  get ethereumTransactionDataLegacyFromBytes() {
    if (this._ethereumTransactionDataLegacyFromBytes == null)
      throw new Error(
        "Cache.ethereumTransactionDataLegacyFromBytes was used before it was set"
      );
    return this._ethereumTransactionDataLegacyFromBytes;
  }
  setEthereumTransactionDataEip1559FromBytes(t) {
    this._ethereumTransactionDataEip1559FromBytes = t;
  }
  get ethereumTransactionDataEip1559FromBytes() {
    if (this._ethereumTransactionDataEip1559FromBytes == null)
      throw new Error(
        "Cache.ethereumTransactionDataEip1559FromBytes was used before it was set"
      );
    return this._ethereumTransactionDataEip1559FromBytes;
  }
  setTransactionReceiptQueryConstructor(t) {
    this._transactionReceiptQueryConstructor = t;
  }
  get transactionReceiptQueryConstructor() {
    if (this._transactionReceiptQueryConstructor == null)
      throw new Error(
        "Cache.transactionReceiptQueryConstructor was used before it was set"
      );
    return this._transactionReceiptQueryConstructor;
  }
  setTransactionRecordQueryConstructor(t) {
    this._transactionRecordQueryConstructor = t;
  }
  get transactionRecordQueryConstructor() {
    if (this._transactionRecordQueryConstructor == null)
      throw new Error(
        "Cache.transactionRecordQueryConstructor was used before it was set"
      );
    return this._transactionRecordQueryConstructor;
  }
  setAddressBookQueryConstructor(t) {
    this._addressBookQueryConstructor = t;
  }
  get addressBookQueryConstructor() {
    if (this._addressBookQueryConstructor == null)
      throw new Error(
        "Cache.addressBookQueryConstructor was used before it was set"
      );
    return this._addressBookQueryConstructor;
  }
}
const CACHE$1 = new Cache();
class Key$1 {
}
class BadKeyError extends Error {
  constructor(t) {
    super(
      t instanceof Error ? t.message : t
    ), this.name = "BadKeyError", t instanceof Error && (this.cause = t, this.stack = t.stack);
  }
}
function commonjsRequire(u) {
  throw new Error('Could not dynamically require "' + u + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var naclFast = { exports: {} };
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
(function(u) {
  (function(t) {
    var a = function(M) {
      var L, $ = new Float64Array(16);
      if (M)
        for (L = 0; L < M.length; L++)
          $[L] = M[L];
      return $;
    }, d = function() {
      throw new Error("no PRNG");
    }, l = new Uint8Array(16), h = new Uint8Array(32);
    h[0] = 9;
    var g = a(), c = a([1]), x = a([56129, 1]), R = a([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), B = a([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), j = a([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), o = a([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), e = a([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function n(M, L, $, O) {
      M[L] = $ >> 24 & 255, M[L + 1] = $ >> 16 & 255, M[L + 2] = $ >> 8 & 255, M[L + 3] = $ & 255, M[L + 4] = O >> 24 & 255, M[L + 5] = O >> 16 & 255, M[L + 6] = O >> 8 & 255, M[L + 7] = O & 255;
    }
    function i(M, L, $, O, P) {
      var H, q = 0;
      for (H = 0; H < P; H++)
        q |= M[L + H] ^ $[O + H];
      return (1 & q - 1 >>> 8) - 1;
    }
    function y(M, L, $, O) {
      return i(M, L, $, O, 16);
    }
    function m(M, L, $, O) {
      return i(M, L, $, O, 32);
    }
    function U(M, L, $, O) {
      for (var P = O[0] & 255 | (O[1] & 255) << 8 | (O[2] & 255) << 16 | (O[3] & 255) << 24, H = $[0] & 255 | ($[1] & 255) << 8 | ($[2] & 255) << 16 | ($[3] & 255) << 24, q = $[4] & 255 | ($[5] & 255) << 8 | ($[6] & 255) << 16 | ($[7] & 255) << 24, Q = $[8] & 255 | ($[9] & 255) << 8 | ($[10] & 255) << 16 | ($[11] & 255) << 24, re = $[12] & 255 | ($[13] & 255) << 8 | ($[14] & 255) << 16 | ($[15] & 255) << 24, ae = O[4] & 255 | (O[5] & 255) << 8 | (O[6] & 255) << 16 | (O[7] & 255) << 24, te = L[0] & 255 | (L[1] & 255) << 8 | (L[2] & 255) << 16 | (L[3] & 255) << 24, ge = L[4] & 255 | (L[5] & 255) << 8 | (L[6] & 255) << 16 | (L[7] & 255) << 24, pe = L[8] & 255 | (L[9] & 255) << 8 | (L[10] & 255) << 16 | (L[11] & 255) << 24, Ie = L[12] & 255 | (L[13] & 255) << 8 | (L[14] & 255) << 16 | (L[15] & 255) << 24, we = O[8] & 255 | (O[9] & 255) << 8 | (O[10] & 255) << 16 | (O[11] & 255) << 24, Ue = $[16] & 255 | ($[17] & 255) << 8 | ($[18] & 255) << 16 | ($[19] & 255) << 24, Ye = $[20] & 255 | ($[21] & 255) << 8 | ($[22] & 255) << 16 | ($[23] & 255) << 24, Qe = $[24] & 255 | ($[25] & 255) << 8 | ($[26] & 255) << 16 | ($[27] & 255) << 24, Ge = $[28] & 255 | ($[29] & 255) << 8 | ($[30] & 255) << 16 | ($[31] & 255) << 24, Je = O[12] & 255 | (O[13] & 255) << 8 | (O[14] & 255) << 16 | (O[15] & 255) << 24, Re = P, $e = H, Se = q, xe = Q, Be = re, Te = ae, ne = te, oe = ge, fe = pe, ce = Ie, de = we, ye = Ue, it = Ye, dt = Qe, pt = Ge, ft = Je, Y, bt = 0; bt < 20; bt += 2)
        Y = Re + it | 0, Be ^= Y << 7 | Y >>> 32 - 7, Y = Be + Re | 0, fe ^= Y << 9 | Y >>> 32 - 9, Y = fe + Be | 0, it ^= Y << 13 | Y >>> 32 - 13, Y = it + fe | 0, Re ^= Y << 18 | Y >>> 32 - 18, Y = Te + $e | 0, ce ^= Y << 7 | Y >>> 32 - 7, Y = ce + Te | 0, dt ^= Y << 9 | Y >>> 32 - 9, Y = dt + ce | 0, $e ^= Y << 13 | Y >>> 32 - 13, Y = $e + dt | 0, Te ^= Y << 18 | Y >>> 32 - 18, Y = de + ne | 0, pt ^= Y << 7 | Y >>> 32 - 7, Y = pt + de | 0, Se ^= Y << 9 | Y >>> 32 - 9, Y = Se + pt | 0, ne ^= Y << 13 | Y >>> 32 - 13, Y = ne + Se | 0, de ^= Y << 18 | Y >>> 32 - 18, Y = ft + ye | 0, xe ^= Y << 7 | Y >>> 32 - 7, Y = xe + ft | 0, oe ^= Y << 9 | Y >>> 32 - 9, Y = oe + xe | 0, ye ^= Y << 13 | Y >>> 32 - 13, Y = ye + oe | 0, ft ^= Y << 18 | Y >>> 32 - 18, Y = Re + xe | 0, $e ^= Y << 7 | Y >>> 32 - 7, Y = $e + Re | 0, Se ^= Y << 9 | Y >>> 32 - 9, Y = Se + $e | 0, xe ^= Y << 13 | Y >>> 32 - 13, Y = xe + Se | 0, Re ^= Y << 18 | Y >>> 32 - 18, Y = Te + Be | 0, ne ^= Y << 7 | Y >>> 32 - 7, Y = ne + Te | 0, oe ^= Y << 9 | Y >>> 32 - 9, Y = oe + ne | 0, Be ^= Y << 13 | Y >>> 32 - 13, Y = Be + oe | 0, Te ^= Y << 18 | Y >>> 32 - 18, Y = de + ce | 0, ye ^= Y << 7 | Y >>> 32 - 7, Y = ye + de | 0, fe ^= Y << 9 | Y >>> 32 - 9, Y = fe + ye | 0, ce ^= Y << 13 | Y >>> 32 - 13, Y = ce + fe | 0, de ^= Y << 18 | Y >>> 32 - 18, Y = ft + pt | 0, it ^= Y << 7 | Y >>> 32 - 7, Y = it + ft | 0, dt ^= Y << 9 | Y >>> 32 - 9, Y = dt + it | 0, pt ^= Y << 13 | Y >>> 32 - 13, Y = pt + dt | 0, ft ^= Y << 18 | Y >>> 32 - 18;
      Re = Re + P | 0, $e = $e + H | 0, Se = Se + q | 0, xe = xe + Q | 0, Be = Be + re | 0, Te = Te + ae | 0, ne = ne + te | 0, oe = oe + ge | 0, fe = fe + pe | 0, ce = ce + Ie | 0, de = de + we | 0, ye = ye + Ue | 0, it = it + Ye | 0, dt = dt + Qe | 0, pt = pt + Ge | 0, ft = ft + Je | 0, M[0] = Re >>> 0 & 255, M[1] = Re >>> 8 & 255, M[2] = Re >>> 16 & 255, M[3] = Re >>> 24 & 255, M[4] = $e >>> 0 & 255, M[5] = $e >>> 8 & 255, M[6] = $e >>> 16 & 255, M[7] = $e >>> 24 & 255, M[8] = Se >>> 0 & 255, M[9] = Se >>> 8 & 255, M[10] = Se >>> 16 & 255, M[11] = Se >>> 24 & 255, M[12] = xe >>> 0 & 255, M[13] = xe >>> 8 & 255, M[14] = xe >>> 16 & 255, M[15] = xe >>> 24 & 255, M[16] = Be >>> 0 & 255, M[17] = Be >>> 8 & 255, M[18] = Be >>> 16 & 255, M[19] = Be >>> 24 & 255, M[20] = Te >>> 0 & 255, M[21] = Te >>> 8 & 255, M[22] = Te >>> 16 & 255, M[23] = Te >>> 24 & 255, M[24] = ne >>> 0 & 255, M[25] = ne >>> 8 & 255, M[26] = ne >>> 16 & 255, M[27] = ne >>> 24 & 255, M[28] = oe >>> 0 & 255, M[29] = oe >>> 8 & 255, M[30] = oe >>> 16 & 255, M[31] = oe >>> 24 & 255, M[32] = fe >>> 0 & 255, M[33] = fe >>> 8 & 255, M[34] = fe >>> 16 & 255, M[35] = fe >>> 24 & 255, M[36] = ce >>> 0 & 255, M[37] = ce >>> 8 & 255, M[38] = ce >>> 16 & 255, M[39] = ce >>> 24 & 255, M[40] = de >>> 0 & 255, M[41] = de >>> 8 & 255, M[42] = de >>> 16 & 255, M[43] = de >>> 24 & 255, M[44] = ye >>> 0 & 255, M[45] = ye >>> 8 & 255, M[46] = ye >>> 16 & 255, M[47] = ye >>> 24 & 255, M[48] = it >>> 0 & 255, M[49] = it >>> 8 & 255, M[50] = it >>> 16 & 255, M[51] = it >>> 24 & 255, M[52] = dt >>> 0 & 255, M[53] = dt >>> 8 & 255, M[54] = dt >>> 16 & 255, M[55] = dt >>> 24 & 255, M[56] = pt >>> 0 & 255, M[57] = pt >>> 8 & 255, M[58] = pt >>> 16 & 255, M[59] = pt >>> 24 & 255, M[60] = ft >>> 0 & 255, M[61] = ft >>> 8 & 255, M[62] = ft >>> 16 & 255, M[63] = ft >>> 24 & 255;
    }
    function be(M, L, $, O) {
      for (var P = O[0] & 255 | (O[1] & 255) << 8 | (O[2] & 255) << 16 | (O[3] & 255) << 24, H = $[0] & 255 | ($[1] & 255) << 8 | ($[2] & 255) << 16 | ($[3] & 255) << 24, q = $[4] & 255 | ($[5] & 255) << 8 | ($[6] & 255) << 16 | ($[7] & 255) << 24, Q = $[8] & 255 | ($[9] & 255) << 8 | ($[10] & 255) << 16 | ($[11] & 255) << 24, re = $[12] & 255 | ($[13] & 255) << 8 | ($[14] & 255) << 16 | ($[15] & 255) << 24, ae = O[4] & 255 | (O[5] & 255) << 8 | (O[6] & 255) << 16 | (O[7] & 255) << 24, te = L[0] & 255 | (L[1] & 255) << 8 | (L[2] & 255) << 16 | (L[3] & 255) << 24, ge = L[4] & 255 | (L[5] & 255) << 8 | (L[6] & 255) << 16 | (L[7] & 255) << 24, pe = L[8] & 255 | (L[9] & 255) << 8 | (L[10] & 255) << 16 | (L[11] & 255) << 24, Ie = L[12] & 255 | (L[13] & 255) << 8 | (L[14] & 255) << 16 | (L[15] & 255) << 24, we = O[8] & 255 | (O[9] & 255) << 8 | (O[10] & 255) << 16 | (O[11] & 255) << 24, Ue = $[16] & 255 | ($[17] & 255) << 8 | ($[18] & 255) << 16 | ($[19] & 255) << 24, Ye = $[20] & 255 | ($[21] & 255) << 8 | ($[22] & 255) << 16 | ($[23] & 255) << 24, Qe = $[24] & 255 | ($[25] & 255) << 8 | ($[26] & 255) << 16 | ($[27] & 255) << 24, Ge = $[28] & 255 | ($[29] & 255) << 8 | ($[30] & 255) << 16 | ($[31] & 255) << 24, Je = O[12] & 255 | (O[13] & 255) << 8 | (O[14] & 255) << 16 | (O[15] & 255) << 24, Re = P, $e = H, Se = q, xe = Q, Be = re, Te = ae, ne = te, oe = ge, fe = pe, ce = Ie, de = we, ye = Ue, it = Ye, dt = Qe, pt = Ge, ft = Je, Y, bt = 0; bt < 20; bt += 2)
        Y = Re + it | 0, Be ^= Y << 7 | Y >>> 32 - 7, Y = Be + Re | 0, fe ^= Y << 9 | Y >>> 32 - 9, Y = fe + Be | 0, it ^= Y << 13 | Y >>> 32 - 13, Y = it + fe | 0, Re ^= Y << 18 | Y >>> 32 - 18, Y = Te + $e | 0, ce ^= Y << 7 | Y >>> 32 - 7, Y = ce + Te | 0, dt ^= Y << 9 | Y >>> 32 - 9, Y = dt + ce | 0, $e ^= Y << 13 | Y >>> 32 - 13, Y = $e + dt | 0, Te ^= Y << 18 | Y >>> 32 - 18, Y = de + ne | 0, pt ^= Y << 7 | Y >>> 32 - 7, Y = pt + de | 0, Se ^= Y << 9 | Y >>> 32 - 9, Y = Se + pt | 0, ne ^= Y << 13 | Y >>> 32 - 13, Y = ne + Se | 0, de ^= Y << 18 | Y >>> 32 - 18, Y = ft + ye | 0, xe ^= Y << 7 | Y >>> 32 - 7, Y = xe + ft | 0, oe ^= Y << 9 | Y >>> 32 - 9, Y = oe + xe | 0, ye ^= Y << 13 | Y >>> 32 - 13, Y = ye + oe | 0, ft ^= Y << 18 | Y >>> 32 - 18, Y = Re + xe | 0, $e ^= Y << 7 | Y >>> 32 - 7, Y = $e + Re | 0, Se ^= Y << 9 | Y >>> 32 - 9, Y = Se + $e | 0, xe ^= Y << 13 | Y >>> 32 - 13, Y = xe + Se | 0, Re ^= Y << 18 | Y >>> 32 - 18, Y = Te + Be | 0, ne ^= Y << 7 | Y >>> 32 - 7, Y = ne + Te | 0, oe ^= Y << 9 | Y >>> 32 - 9, Y = oe + ne | 0, Be ^= Y << 13 | Y >>> 32 - 13, Y = Be + oe | 0, Te ^= Y << 18 | Y >>> 32 - 18, Y = de + ce | 0, ye ^= Y << 7 | Y >>> 32 - 7, Y = ye + de | 0, fe ^= Y << 9 | Y >>> 32 - 9, Y = fe + ye | 0, ce ^= Y << 13 | Y >>> 32 - 13, Y = ce + fe | 0, de ^= Y << 18 | Y >>> 32 - 18, Y = ft + pt | 0, it ^= Y << 7 | Y >>> 32 - 7, Y = it + ft | 0, dt ^= Y << 9 | Y >>> 32 - 9, Y = dt + it | 0, pt ^= Y << 13 | Y >>> 32 - 13, Y = pt + dt | 0, ft ^= Y << 18 | Y >>> 32 - 18;
      M[0] = Re >>> 0 & 255, M[1] = Re >>> 8 & 255, M[2] = Re >>> 16 & 255, M[3] = Re >>> 24 & 255, M[4] = Te >>> 0 & 255, M[5] = Te >>> 8 & 255, M[6] = Te >>> 16 & 255, M[7] = Te >>> 24 & 255, M[8] = de >>> 0 & 255, M[9] = de >>> 8 & 255, M[10] = de >>> 16 & 255, M[11] = de >>> 24 & 255, M[12] = ft >>> 0 & 255, M[13] = ft >>> 8 & 255, M[14] = ft >>> 16 & 255, M[15] = ft >>> 24 & 255, M[16] = ne >>> 0 & 255, M[17] = ne >>> 8 & 255, M[18] = ne >>> 16 & 255, M[19] = ne >>> 24 & 255, M[20] = oe >>> 0 & 255, M[21] = oe >>> 8 & 255, M[22] = oe >>> 16 & 255, M[23] = oe >>> 24 & 255, M[24] = fe >>> 0 & 255, M[25] = fe >>> 8 & 255, M[26] = fe >>> 16 & 255, M[27] = fe >>> 24 & 255, M[28] = ce >>> 0 & 255, M[29] = ce >>> 8 & 255, M[30] = ce >>> 16 & 255, M[31] = ce >>> 24 & 255;
    }
    function Ke(M, L, $, O) {
      U(M, L, $, O);
    }
    function ze(M, L, $, O) {
      be(M, L, $, O);
    }
    var Pe = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function st(M, L, $, O, P, H, q) {
      var Q = new Uint8Array(16), re = new Uint8Array(64), ae, te;
      for (te = 0; te < 16; te++)
        Q[te] = 0;
      for (te = 0; te < 8; te++)
        Q[te] = H[te];
      for (; P >= 64; ) {
        for (Ke(re, Q, q, Pe), te = 0; te < 64; te++)
          M[L + te] = $[O + te] ^ re[te];
        for (ae = 1, te = 8; te < 16; te++)
          ae = ae + (Q[te] & 255) | 0, Q[te] = ae & 255, ae >>>= 8;
        P -= 64, L += 64, O += 64;
      }
      if (P > 0)
        for (Ke(re, Q, q, Pe), te = 0; te < P; te++)
          M[L + te] = $[O + te] ^ re[te];
      return 0;
    }
    function G(M, L, $, O, P) {
      var H = new Uint8Array(16), q = new Uint8Array(64), Q, re;
      for (re = 0; re < 16; re++)
        H[re] = 0;
      for (re = 0; re < 8; re++)
        H[re] = O[re];
      for (; $ >= 64; ) {
        for (Ke(q, H, P, Pe), re = 0; re < 64; re++)
          M[L + re] = q[re];
        for (Q = 1, re = 8; re < 16; re++)
          Q = Q + (H[re] & 255) | 0, H[re] = Q & 255, Q >>>= 8;
        $ -= 64, L += 64;
      }
      if ($ > 0)
        for (Ke(q, H, P, Pe), re = 0; re < $; re++)
          M[L + re] = q[re];
      return 0;
    }
    function z(M, L, $, O, P) {
      var H = new Uint8Array(32);
      ze(H, O, P, Pe);
      for (var q = new Uint8Array(8), Q = 0; Q < 8; Q++)
        q[Q] = O[Q + 16];
      return G(M, L, $, q, H);
    }
    function W(M, L, $, O, P, H, q) {
      var Q = new Uint8Array(32);
      ze(Q, H, q, Pe);
      for (var re = new Uint8Array(8), ae = 0; ae < 8; ae++)
        re[ae] = H[ae + 16];
      return st(M, L, $, O, P, re, Q);
    }
    var F = function(M) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var L, $, O, P, H, q, Q, re;
      L = M[0] & 255 | (M[1] & 255) << 8, this.r[0] = L & 8191, $ = M[2] & 255 | (M[3] & 255) << 8, this.r[1] = (L >>> 13 | $ << 3) & 8191, O = M[4] & 255 | (M[5] & 255) << 8, this.r[2] = ($ >>> 10 | O << 6) & 7939, P = M[6] & 255 | (M[7] & 255) << 8, this.r[3] = (O >>> 7 | P << 9) & 8191, H = M[8] & 255 | (M[9] & 255) << 8, this.r[4] = (P >>> 4 | H << 12) & 255, this.r[5] = H >>> 1 & 8190, q = M[10] & 255 | (M[11] & 255) << 8, this.r[6] = (H >>> 14 | q << 2) & 8191, Q = M[12] & 255 | (M[13] & 255) << 8, this.r[7] = (q >>> 11 | Q << 5) & 8065, re = M[14] & 255 | (M[15] & 255) << 8, this.r[8] = (Q >>> 8 | re << 8) & 8191, this.r[9] = re >>> 5 & 127, this.pad[0] = M[16] & 255 | (M[17] & 255) << 8, this.pad[1] = M[18] & 255 | (M[19] & 255) << 8, this.pad[2] = M[20] & 255 | (M[21] & 255) << 8, this.pad[3] = M[22] & 255 | (M[23] & 255) << 8, this.pad[4] = M[24] & 255 | (M[25] & 255) << 8, this.pad[5] = M[26] & 255 | (M[27] & 255) << 8, this.pad[6] = M[28] & 255 | (M[29] & 255) << 8, this.pad[7] = M[30] & 255 | (M[31] & 255) << 8;
    };
    F.prototype.blocks = function(M, L, $) {
      for (var O = this.fin ? 0 : 2048, P, H, q, Q, re, ae, te, ge, pe, Ie, we, Ue, Ye, Qe, Ge, Je, Re, $e, Se, xe = this.h[0], Be = this.h[1], Te = this.h[2], ne = this.h[3], oe = this.h[4], fe = this.h[5], ce = this.h[6], de = this.h[7], ye = this.h[8], it = this.h[9], dt = this.r[0], pt = this.r[1], ft = this.r[2], Y = this.r[3], bt = this.r[4], Et = this.r[5], Ot = this.r[6], yt = this.r[7], At = this.r[8], St = this.r[9]; $ >= 16; )
        P = M[L + 0] & 255 | (M[L + 1] & 255) << 8, xe += P & 8191, H = M[L + 2] & 255 | (M[L + 3] & 255) << 8, Be += (P >>> 13 | H << 3) & 8191, q = M[L + 4] & 255 | (M[L + 5] & 255) << 8, Te += (H >>> 10 | q << 6) & 8191, Q = M[L + 6] & 255 | (M[L + 7] & 255) << 8, ne += (q >>> 7 | Q << 9) & 8191, re = M[L + 8] & 255 | (M[L + 9] & 255) << 8, oe += (Q >>> 4 | re << 12) & 8191, fe += re >>> 1 & 8191, ae = M[L + 10] & 255 | (M[L + 11] & 255) << 8, ce += (re >>> 14 | ae << 2) & 8191, te = M[L + 12] & 255 | (M[L + 13] & 255) << 8, de += (ae >>> 11 | te << 5) & 8191, ge = M[L + 14] & 255 | (M[L + 15] & 255) << 8, ye += (te >>> 8 | ge << 8) & 8191, it += ge >>> 5 | O, pe = 0, Ie = pe, Ie += xe * dt, Ie += Be * (5 * St), Ie += Te * (5 * At), Ie += ne * (5 * yt), Ie += oe * (5 * Ot), pe = Ie >>> 13, Ie &= 8191, Ie += fe * (5 * Et), Ie += ce * (5 * bt), Ie += de * (5 * Y), Ie += ye * (5 * ft), Ie += it * (5 * pt), pe += Ie >>> 13, Ie &= 8191, we = pe, we += xe * pt, we += Be * dt, we += Te * (5 * St), we += ne * (5 * At), we += oe * (5 * yt), pe = we >>> 13, we &= 8191, we += fe * (5 * Ot), we += ce * (5 * Et), we += de * (5 * bt), we += ye * (5 * Y), we += it * (5 * ft), pe += we >>> 13, we &= 8191, Ue = pe, Ue += xe * ft, Ue += Be * pt, Ue += Te * dt, Ue += ne * (5 * St), Ue += oe * (5 * At), pe = Ue >>> 13, Ue &= 8191, Ue += fe * (5 * yt), Ue += ce * (5 * Ot), Ue += de * (5 * Et), Ue += ye * (5 * bt), Ue += it * (5 * Y), pe += Ue >>> 13, Ue &= 8191, Ye = pe, Ye += xe * Y, Ye += Be * ft, Ye += Te * pt, Ye += ne * dt, Ye += oe * (5 * St), pe = Ye >>> 13, Ye &= 8191, Ye += fe * (5 * At), Ye += ce * (5 * yt), Ye += de * (5 * Ot), Ye += ye * (5 * Et), Ye += it * (5 * bt), pe += Ye >>> 13, Ye &= 8191, Qe = pe, Qe += xe * bt, Qe += Be * Y, Qe += Te * ft, Qe += ne * pt, Qe += oe * dt, pe = Qe >>> 13, Qe &= 8191, Qe += fe * (5 * St), Qe += ce * (5 * At), Qe += de * (5 * yt), Qe += ye * (5 * Ot), Qe += it * (5 * Et), pe += Qe >>> 13, Qe &= 8191, Ge = pe, Ge += xe * Et, Ge += Be * bt, Ge += Te * Y, Ge += ne * ft, Ge += oe * pt, pe = Ge >>> 13, Ge &= 8191, Ge += fe * dt, Ge += ce * (5 * St), Ge += de * (5 * At), Ge += ye * (5 * yt), Ge += it * (5 * Ot), pe += Ge >>> 13, Ge &= 8191, Je = pe, Je += xe * Ot, Je += Be * Et, Je += Te * bt, Je += ne * Y, Je += oe * ft, pe = Je >>> 13, Je &= 8191, Je += fe * pt, Je += ce * dt, Je += de * (5 * St), Je += ye * (5 * At), Je += it * (5 * yt), pe += Je >>> 13, Je &= 8191, Re = pe, Re += xe * yt, Re += Be * Ot, Re += Te * Et, Re += ne * bt, Re += oe * Y, pe = Re >>> 13, Re &= 8191, Re += fe * ft, Re += ce * pt, Re += de * dt, Re += ye * (5 * St), Re += it * (5 * At), pe += Re >>> 13, Re &= 8191, $e = pe, $e += xe * At, $e += Be * yt, $e += Te * Ot, $e += ne * Et, $e += oe * bt, pe = $e >>> 13, $e &= 8191, $e += fe * Y, $e += ce * ft, $e += de * pt, $e += ye * dt, $e += it * (5 * St), pe += $e >>> 13, $e &= 8191, Se = pe, Se += xe * St, Se += Be * At, Se += Te * yt, Se += ne * Ot, Se += oe * Et, pe = Se >>> 13, Se &= 8191, Se += fe * bt, Se += ce * Y, Se += de * ft, Se += ye * pt, Se += it * dt, pe += Se >>> 13, Se &= 8191, pe = (pe << 2) + pe | 0, pe = pe + Ie | 0, Ie = pe & 8191, pe = pe >>> 13, we += pe, xe = Ie, Be = we, Te = Ue, ne = Ye, oe = Qe, fe = Ge, ce = Je, de = Re, ye = $e, it = Se, L += 16, $ -= 16;
      this.h[0] = xe, this.h[1] = Be, this.h[2] = Te, this.h[3] = ne, this.h[4] = oe, this.h[5] = fe, this.h[6] = ce, this.h[7] = de, this.h[8] = ye, this.h[9] = it;
    }, F.prototype.finish = function(M, L) {
      var $ = new Uint16Array(10), O, P, H, q;
      if (this.leftover) {
        for (q = this.leftover, this.buffer[q++] = 1; q < 16; q++)
          this.buffer[q] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (O = this.h[1] >>> 13, this.h[1] &= 8191, q = 2; q < 10; q++)
        this.h[q] += O, O = this.h[q] >>> 13, this.h[q] &= 8191;
      for (this.h[0] += O * 5, O = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += O, O = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += O, $[0] = this.h[0] + 5, O = $[0] >>> 13, $[0] &= 8191, q = 1; q < 10; q++)
        $[q] = this.h[q] + O, O = $[q] >>> 13, $[q] &= 8191;
      for ($[9] -= 1 << 13, P = (O ^ 1) - 1, q = 0; q < 10; q++)
        $[q] &= P;
      for (P = ~P, q = 0; q < 10; q++)
        this.h[q] = this.h[q] & P | $[q];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, H = this.h[0] + this.pad[0], this.h[0] = H & 65535, q = 1; q < 8; q++)
        H = (this.h[q] + this.pad[q] | 0) + (H >>> 16) | 0, this.h[q] = H & 65535;
      M[L + 0] = this.h[0] >>> 0 & 255, M[L + 1] = this.h[0] >>> 8 & 255, M[L + 2] = this.h[1] >>> 0 & 255, M[L + 3] = this.h[1] >>> 8 & 255, M[L + 4] = this.h[2] >>> 0 & 255, M[L + 5] = this.h[2] >>> 8 & 255, M[L + 6] = this.h[3] >>> 0 & 255, M[L + 7] = this.h[3] >>> 8 & 255, M[L + 8] = this.h[4] >>> 0 & 255, M[L + 9] = this.h[4] >>> 8 & 255, M[L + 10] = this.h[5] >>> 0 & 255, M[L + 11] = this.h[5] >>> 8 & 255, M[L + 12] = this.h[6] >>> 0 & 255, M[L + 13] = this.h[6] >>> 8 & 255, M[L + 14] = this.h[7] >>> 0 & 255, M[L + 15] = this.h[7] >>> 8 & 255;
    }, F.prototype.update = function(M, L, $) {
      var O, P;
      if (this.leftover) {
        for (P = 16 - this.leftover, P > $ && (P = $), O = 0; O < P; O++)
          this.buffer[this.leftover + O] = M[L + O];
        if ($ -= P, L += P, this.leftover += P, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if ($ >= 16 && (P = $ - $ % 16, this.blocks(M, L, P), L += P, $ -= P), $) {
        for (O = 0; O < $; O++)
          this.buffer[this.leftover + O] = M[L + O];
        this.leftover += $;
      }
    };
    function k(M, L, $, O, P, H) {
      var q = new F(H);
      return q.update($, O, P), q.finish(M, L), 0;
    }
    function T(M, L, $, O, P, H) {
      var q = new Uint8Array(16);
      return k(q, 0, $, O, P, H), y(M, L, q, 0);
    }
    function p(M, L, $, O, P) {
      var H;
      if ($ < 32)
        return -1;
      for (W(M, 0, L, 0, $, O, P), k(M, 16, M, 32, $ - 32, M), H = 0; H < 16; H++)
        M[H] = 0;
      return 0;
    }
    function b(M, L, $, O, P) {
      var H, q = new Uint8Array(32);
      if ($ < 32 || (z(q, 0, 32, O, P), T(L, 16, L, 32, $ - 32, q) !== 0))
        return -1;
      for (W(M, 0, L, 0, $, O, P), H = 0; H < 32; H++)
        M[H] = 0;
      return 0;
    }
    function _(M, L) {
      var $;
      for ($ = 0; $ < 16; $++)
        M[$] = L[$] | 0;
    }
    function v(M) {
      var L, $, O = 1;
      for (L = 0; L < 16; L++)
        $ = M[L] + O + 65535, O = Math.floor($ / 65536), M[L] = $ - O * 65536;
      M[0] += O - 1 + 37 * (O - 1);
    }
    function S(M, L, $) {
      for (var O, P = ~($ - 1), H = 0; H < 16; H++)
        O = P & (M[H] ^ L[H]), M[H] ^= O, L[H] ^= O;
    }
    function E(M, L) {
      var $, O, P, H = a(), q = a();
      for ($ = 0; $ < 16; $++)
        q[$] = L[$];
      for (v(q), v(q), v(q), O = 0; O < 2; O++) {
        for (H[0] = q[0] - 65517, $ = 1; $ < 15; $++)
          H[$] = q[$] - 65535 - (H[$ - 1] >> 16 & 1), H[$ - 1] &= 65535;
        H[15] = q[15] - 32767 - (H[14] >> 16 & 1), P = H[15] >> 16 & 1, H[14] &= 65535, S(q, H, 1 - P);
      }
      for ($ = 0; $ < 16; $++)
        M[2 * $] = q[$] & 255, M[2 * $ + 1] = q[$] >> 8;
    }
    function w(M, L) {
      var $ = new Uint8Array(32), O = new Uint8Array(32);
      return E($, M), E(O, L), m($, 0, O, 0);
    }
    function A(M) {
      var L = new Uint8Array(32);
      return E(L, M), L[0] & 1;
    }
    function I(M, L) {
      var $;
      for ($ = 0; $ < 16; $++)
        M[$] = L[2 * $] + (L[2 * $ + 1] << 8);
      M[15] &= 32767;
    }
    function C(M, L, $) {
      for (var O = 0; O < 16; O++)
        M[O] = L[O] + $[O];
    }
    function X(M, L, $) {
      for (var O = 0; O < 16; O++)
        M[O] = L[O] - $[O];
    }
    function D(M, L, $) {
      var O, P, H = 0, q = 0, Q = 0, re = 0, ae = 0, te = 0, ge = 0, pe = 0, Ie = 0, we = 0, Ue = 0, Ye = 0, Qe = 0, Ge = 0, Je = 0, Re = 0, $e = 0, Se = 0, xe = 0, Be = 0, Te = 0, ne = 0, oe = 0, fe = 0, ce = 0, de = 0, ye = 0, it = 0, dt = 0, pt = 0, ft = 0, Y = $[0], bt = $[1], Et = $[2], Ot = $[3], yt = $[4], At = $[5], St = $[6], Ct = $[7], Rt = $[8], Pt = $[9], xt = $[10], Nt = $[11], Dt = $[12], Mt = $[13], Bt = $[14], Ft = $[15];
      O = L[0], H += O * Y, q += O * bt, Q += O * Et, re += O * Ot, ae += O * yt, te += O * At, ge += O * St, pe += O * Ct, Ie += O * Rt, we += O * Pt, Ue += O * xt, Ye += O * Nt, Qe += O * Dt, Ge += O * Mt, Je += O * Bt, Re += O * Ft, O = L[1], q += O * Y, Q += O * bt, re += O * Et, ae += O * Ot, te += O * yt, ge += O * At, pe += O * St, Ie += O * Ct, we += O * Rt, Ue += O * Pt, Ye += O * xt, Qe += O * Nt, Ge += O * Dt, Je += O * Mt, Re += O * Bt, $e += O * Ft, O = L[2], Q += O * Y, re += O * bt, ae += O * Et, te += O * Ot, ge += O * yt, pe += O * At, Ie += O * St, we += O * Ct, Ue += O * Rt, Ye += O * Pt, Qe += O * xt, Ge += O * Nt, Je += O * Dt, Re += O * Mt, $e += O * Bt, Se += O * Ft, O = L[3], re += O * Y, ae += O * bt, te += O * Et, ge += O * Ot, pe += O * yt, Ie += O * At, we += O * St, Ue += O * Ct, Ye += O * Rt, Qe += O * Pt, Ge += O * xt, Je += O * Nt, Re += O * Dt, $e += O * Mt, Se += O * Bt, xe += O * Ft, O = L[4], ae += O * Y, te += O * bt, ge += O * Et, pe += O * Ot, Ie += O * yt, we += O * At, Ue += O * St, Ye += O * Ct, Qe += O * Rt, Ge += O * Pt, Je += O * xt, Re += O * Nt, $e += O * Dt, Se += O * Mt, xe += O * Bt, Be += O * Ft, O = L[5], te += O * Y, ge += O * bt, pe += O * Et, Ie += O * Ot, we += O * yt, Ue += O * At, Ye += O * St, Qe += O * Ct, Ge += O * Rt, Je += O * Pt, Re += O * xt, $e += O * Nt, Se += O * Dt, xe += O * Mt, Be += O * Bt, Te += O * Ft, O = L[6], ge += O * Y, pe += O * bt, Ie += O * Et, we += O * Ot, Ue += O * yt, Ye += O * At, Qe += O * St, Ge += O * Ct, Je += O * Rt, Re += O * Pt, $e += O * xt, Se += O * Nt, xe += O * Dt, Be += O * Mt, Te += O * Bt, ne += O * Ft, O = L[7], pe += O * Y, Ie += O * bt, we += O * Et, Ue += O * Ot, Ye += O * yt, Qe += O * At, Ge += O * St, Je += O * Ct, Re += O * Rt, $e += O * Pt, Se += O * xt, xe += O * Nt, Be += O * Dt, Te += O * Mt, ne += O * Bt, oe += O * Ft, O = L[8], Ie += O * Y, we += O * bt, Ue += O * Et, Ye += O * Ot, Qe += O * yt, Ge += O * At, Je += O * St, Re += O * Ct, $e += O * Rt, Se += O * Pt, xe += O * xt, Be += O * Nt, Te += O * Dt, ne += O * Mt, oe += O * Bt, fe += O * Ft, O = L[9], we += O * Y, Ue += O * bt, Ye += O * Et, Qe += O * Ot, Ge += O * yt, Je += O * At, Re += O * St, $e += O * Ct, Se += O * Rt, xe += O * Pt, Be += O * xt, Te += O * Nt, ne += O * Dt, oe += O * Mt, fe += O * Bt, ce += O * Ft, O = L[10], Ue += O * Y, Ye += O * bt, Qe += O * Et, Ge += O * Ot, Je += O * yt, Re += O * At, $e += O * St, Se += O * Ct, xe += O * Rt, Be += O * Pt, Te += O * xt, ne += O * Nt, oe += O * Dt, fe += O * Mt, ce += O * Bt, de += O * Ft, O = L[11], Ye += O * Y, Qe += O * bt, Ge += O * Et, Je += O * Ot, Re += O * yt, $e += O * At, Se += O * St, xe += O * Ct, Be += O * Rt, Te += O * Pt, ne += O * xt, oe += O * Nt, fe += O * Dt, ce += O * Mt, de += O * Bt, ye += O * Ft, O = L[12], Qe += O * Y, Ge += O * bt, Je += O * Et, Re += O * Ot, $e += O * yt, Se += O * At, xe += O * St, Be += O * Ct, Te += O * Rt, ne += O * Pt, oe += O * xt, fe += O * Nt, ce += O * Dt, de += O * Mt, ye += O * Bt, it += O * Ft, O = L[13], Ge += O * Y, Je += O * bt, Re += O * Et, $e += O * Ot, Se += O * yt, xe += O * At, Be += O * St, Te += O * Ct, ne += O * Rt, oe += O * Pt, fe += O * xt, ce += O * Nt, de += O * Dt, ye += O * Mt, it += O * Bt, dt += O * Ft, O = L[14], Je += O * Y, Re += O * bt, $e += O * Et, Se += O * Ot, xe += O * yt, Be += O * At, Te += O * St, ne += O * Ct, oe += O * Rt, fe += O * Pt, ce += O * xt, de += O * Nt, ye += O * Dt, it += O * Mt, dt += O * Bt, pt += O * Ft, O = L[15], Re += O * Y, $e += O * bt, Se += O * Et, xe += O * Ot, Be += O * yt, Te += O * At, ne += O * St, oe += O * Ct, fe += O * Rt, ce += O * Pt, de += O * xt, ye += O * Nt, it += O * Dt, dt += O * Mt, pt += O * Bt, ft += O * Ft, H += 38 * $e, q += 38 * Se, Q += 38 * xe, re += 38 * Be, ae += 38 * Te, te += 38 * ne, ge += 38 * oe, pe += 38 * fe, Ie += 38 * ce, we += 38 * de, Ue += 38 * ye, Ye += 38 * it, Qe += 38 * dt, Ge += 38 * pt, Je += 38 * ft, P = 1, O = H + P + 65535, P = Math.floor(O / 65536), H = O - P * 65536, O = q + P + 65535, P = Math.floor(O / 65536), q = O - P * 65536, O = Q + P + 65535, P = Math.floor(O / 65536), Q = O - P * 65536, O = re + P + 65535, P = Math.floor(O / 65536), re = O - P * 65536, O = ae + P + 65535, P = Math.floor(O / 65536), ae = O - P * 65536, O = te + P + 65535, P = Math.floor(O / 65536), te = O - P * 65536, O = ge + P + 65535, P = Math.floor(O / 65536), ge = O - P * 65536, O = pe + P + 65535, P = Math.floor(O / 65536), pe = O - P * 65536, O = Ie + P + 65535, P = Math.floor(O / 65536), Ie = O - P * 65536, O = we + P + 65535, P = Math.floor(O / 65536), we = O - P * 65536, O = Ue + P + 65535, P = Math.floor(O / 65536), Ue = O - P * 65536, O = Ye + P + 65535, P = Math.floor(O / 65536), Ye = O - P * 65536, O = Qe + P + 65535, P = Math.floor(O / 65536), Qe = O - P * 65536, O = Ge + P + 65535, P = Math.floor(O / 65536), Ge = O - P * 65536, O = Je + P + 65535, P = Math.floor(O / 65536), Je = O - P * 65536, O = Re + P + 65535, P = Math.floor(O / 65536), Re = O - P * 65536, H += P - 1 + 37 * (P - 1), P = 1, O = H + P + 65535, P = Math.floor(O / 65536), H = O - P * 65536, O = q + P + 65535, P = Math.floor(O / 65536), q = O - P * 65536, O = Q + P + 65535, P = Math.floor(O / 65536), Q = O - P * 65536, O = re + P + 65535, P = Math.floor(O / 65536), re = O - P * 65536, O = ae + P + 65535, P = Math.floor(O / 65536), ae = O - P * 65536, O = te + P + 65535, P = Math.floor(O / 65536), te = O - P * 65536, O = ge + P + 65535, P = Math.floor(O / 65536), ge = O - P * 65536, O = pe + P + 65535, P = Math.floor(O / 65536), pe = O - P * 65536, O = Ie + P + 65535, P = Math.floor(O / 65536), Ie = O - P * 65536, O = we + P + 65535, P = Math.floor(O / 65536), we = O - P * 65536, O = Ue + P + 65535, P = Math.floor(O / 65536), Ue = O - P * 65536, O = Ye + P + 65535, P = Math.floor(O / 65536), Ye = O - P * 65536, O = Qe + P + 65535, P = Math.floor(O / 65536), Qe = O - P * 65536, O = Ge + P + 65535, P = Math.floor(O / 65536), Ge = O - P * 65536, O = Je + P + 65535, P = Math.floor(O / 65536), Je = O - P * 65536, O = Re + P + 65535, P = Math.floor(O / 65536), Re = O - P * 65536, H += P - 1 + 37 * (P - 1), M[0] = H, M[1] = q, M[2] = Q, M[3] = re, M[4] = ae, M[5] = te, M[6] = ge, M[7] = pe, M[8] = Ie, M[9] = we, M[10] = Ue, M[11] = Ye, M[12] = Qe, M[13] = Ge, M[14] = Je, M[15] = Re;
    }
    function V(M, L) {
      D(M, L, L);
    }
    function Z(M, L) {
      var $ = a(), O;
      for (O = 0; O < 16; O++)
        $[O] = L[O];
      for (O = 253; O >= 0; O--)
        V($, $), O !== 2 && O !== 4 && D($, $, L);
      for (O = 0; O < 16; O++)
        M[O] = $[O];
    }
    function J(M, L) {
      var $ = a(), O;
      for (O = 0; O < 16; O++)
        $[O] = L[O];
      for (O = 250; O >= 0; O--)
        V($, $), O !== 1 && D($, $, L);
      for (O = 0; O < 16; O++)
        M[O] = $[O];
    }
    function ee(M, L, $) {
      var O = new Uint8Array(32), P = new Float64Array(80), H, q, Q = a(), re = a(), ae = a(), te = a(), ge = a(), pe = a();
      for (q = 0; q < 31; q++)
        O[q] = L[q];
      for (O[31] = L[31] & 127 | 64, O[0] &= 248, I(P, $), q = 0; q < 16; q++)
        re[q] = P[q], te[q] = Q[q] = ae[q] = 0;
      for (Q[0] = te[0] = 1, q = 254; q >= 0; --q)
        H = O[q >>> 3] >>> (q & 7) & 1, S(Q, re, H), S(ae, te, H), C(ge, Q, ae), X(Q, Q, ae), C(ae, re, te), X(re, re, te), V(te, ge), V(pe, Q), D(Q, ae, Q), D(ae, re, ge), C(ge, Q, ae), X(Q, Q, ae), V(re, Q), X(ae, te, pe), D(Q, ae, x), C(Q, Q, te), D(ae, ae, Q), D(Q, te, pe), D(te, re, P), V(re, ge), S(Q, re, H), S(ae, te, H);
      for (q = 0; q < 16; q++)
        P[q + 16] = Q[q], P[q + 32] = ae[q], P[q + 48] = re[q], P[q + 64] = te[q];
      var Ie = P.subarray(32), we = P.subarray(16);
      return Z(Ie, Ie), D(we, we, Ie), E(M, we), 0;
    }
    function he(M, L) {
      return ee(M, L, h);
    }
    function le(M, L) {
      return d(L, 32), he(M, L);
    }
    function ie(M, L, $) {
      var O = new Uint8Array(32);
      return ee(O, $, L), ze(M, l, O, Pe);
    }
    var Ne = p, ue = b;
    function se(M, L, $, O, P, H) {
      var q = new Uint8Array(32);
      return ie(q, P, H), Ne(M, L, $, O, q);
    }
    function ut(M, L, $, O, P, H) {
      var q = new Uint8Array(32);
      return ie(q, P, H), ue(M, L, $, O, q);
    }
    var qe = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function ve(M, L, $, O) {
      for (var P = new Int32Array(16), H = new Int32Array(16), q, Q, re, ae, te, ge, pe, Ie, we, Ue, Ye, Qe, Ge, Je, Re, $e, Se, xe, Be, Te, ne, oe, fe, ce, de, ye, it = M[0], dt = M[1], pt = M[2], ft = M[3], Y = M[4], bt = M[5], Et = M[6], Ot = M[7], yt = L[0], At = L[1], St = L[2], Ct = L[3], Rt = L[4], Pt = L[5], xt = L[6], Nt = L[7], Dt = 0; O >= 128; ) {
        for (Be = 0; Be < 16; Be++)
          Te = 8 * Be + Dt, P[Be] = $[Te + 0] << 24 | $[Te + 1] << 16 | $[Te + 2] << 8 | $[Te + 3], H[Be] = $[Te + 4] << 24 | $[Te + 5] << 16 | $[Te + 6] << 8 | $[Te + 7];
        for (Be = 0; Be < 80; Be++)
          if (q = it, Q = dt, re = pt, ae = ft, te = Y, ge = bt, pe = Et, Ie = Ot, we = yt, Ue = At, Ye = St, Qe = Ct, Ge = Rt, Je = Pt, Re = xt, $e = Nt, ne = Ot, oe = Nt, fe = oe & 65535, ce = oe >>> 16, de = ne & 65535, ye = ne >>> 16, ne = (Y >>> 14 | Rt << 32 - 14) ^ (Y >>> 18 | Rt << 32 - 18) ^ (Rt >>> 41 - 32 | Y << 32 - (41 - 32)), oe = (Rt >>> 14 | Y << 32 - 14) ^ (Rt >>> 18 | Y << 32 - 18) ^ (Y >>> 41 - 32 | Rt << 32 - (41 - 32)), fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ne = Y & bt ^ ~Y & Et, oe = Rt & Pt ^ ~Rt & xt, fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ne = qe[Be * 2], oe = qe[Be * 2 + 1], fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ne = P[Be % 16], oe = H[Be % 16], fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ce += fe >>> 16, de += ce >>> 16, ye += de >>> 16, Se = de & 65535 | ye << 16, xe = fe & 65535 | ce << 16, ne = Se, oe = xe, fe = oe & 65535, ce = oe >>> 16, de = ne & 65535, ye = ne >>> 16, ne = (it >>> 28 | yt << 32 - 28) ^ (yt >>> 34 - 32 | it << 32 - (34 - 32)) ^ (yt >>> 39 - 32 | it << 32 - (39 - 32)), oe = (yt >>> 28 | it << 32 - 28) ^ (it >>> 34 - 32 | yt << 32 - (34 - 32)) ^ (it >>> 39 - 32 | yt << 32 - (39 - 32)), fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ne = it & dt ^ it & pt ^ dt & pt, oe = yt & At ^ yt & St ^ At & St, fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ce += fe >>> 16, de += ce >>> 16, ye += de >>> 16, Ie = de & 65535 | ye << 16, $e = fe & 65535 | ce << 16, ne = ae, oe = Qe, fe = oe & 65535, ce = oe >>> 16, de = ne & 65535, ye = ne >>> 16, ne = Se, oe = xe, fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ce += fe >>> 16, de += ce >>> 16, ye += de >>> 16, ae = de & 65535 | ye << 16, Qe = fe & 65535 | ce << 16, dt = q, pt = Q, ft = re, Y = ae, bt = te, Et = ge, Ot = pe, it = Ie, At = we, St = Ue, Ct = Ye, Rt = Qe, Pt = Ge, xt = Je, Nt = Re, yt = $e, Be % 16 === 15)
            for (Te = 0; Te < 16; Te++)
              ne = P[Te], oe = H[Te], fe = oe & 65535, ce = oe >>> 16, de = ne & 65535, ye = ne >>> 16, ne = P[(Te + 9) % 16], oe = H[(Te + 9) % 16], fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, Se = P[(Te + 1) % 16], xe = H[(Te + 1) % 16], ne = (Se >>> 1 | xe << 32 - 1) ^ (Se >>> 8 | xe << 32 - 8) ^ Se >>> 7, oe = (xe >>> 1 | Se << 32 - 1) ^ (xe >>> 8 | Se << 32 - 8) ^ (xe >>> 7 | Se << 32 - 7), fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, Se = P[(Te + 14) % 16], xe = H[(Te + 14) % 16], ne = (Se >>> 19 | xe << 32 - 19) ^ (xe >>> 61 - 32 | Se << 32 - (61 - 32)) ^ Se >>> 6, oe = (xe >>> 19 | Se << 32 - 19) ^ (Se >>> 61 - 32 | xe << 32 - (61 - 32)) ^ (xe >>> 6 | Se << 32 - 6), fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ce += fe >>> 16, de += ce >>> 16, ye += de >>> 16, P[Te] = de & 65535 | ye << 16, H[Te] = fe & 65535 | ce << 16;
        ne = it, oe = yt, fe = oe & 65535, ce = oe >>> 16, de = ne & 65535, ye = ne >>> 16, ne = M[0], oe = L[0], fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ce += fe >>> 16, de += ce >>> 16, ye += de >>> 16, M[0] = it = de & 65535 | ye << 16, L[0] = yt = fe & 65535 | ce << 16, ne = dt, oe = At, fe = oe & 65535, ce = oe >>> 16, de = ne & 65535, ye = ne >>> 16, ne = M[1], oe = L[1], fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ce += fe >>> 16, de += ce >>> 16, ye += de >>> 16, M[1] = dt = de & 65535 | ye << 16, L[1] = At = fe & 65535 | ce << 16, ne = pt, oe = St, fe = oe & 65535, ce = oe >>> 16, de = ne & 65535, ye = ne >>> 16, ne = M[2], oe = L[2], fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ce += fe >>> 16, de += ce >>> 16, ye += de >>> 16, M[2] = pt = de & 65535 | ye << 16, L[2] = St = fe & 65535 | ce << 16, ne = ft, oe = Ct, fe = oe & 65535, ce = oe >>> 16, de = ne & 65535, ye = ne >>> 16, ne = M[3], oe = L[3], fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ce += fe >>> 16, de += ce >>> 16, ye += de >>> 16, M[3] = ft = de & 65535 | ye << 16, L[3] = Ct = fe & 65535 | ce << 16, ne = Y, oe = Rt, fe = oe & 65535, ce = oe >>> 16, de = ne & 65535, ye = ne >>> 16, ne = M[4], oe = L[4], fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ce += fe >>> 16, de += ce >>> 16, ye += de >>> 16, M[4] = Y = de & 65535 | ye << 16, L[4] = Rt = fe & 65535 | ce << 16, ne = bt, oe = Pt, fe = oe & 65535, ce = oe >>> 16, de = ne & 65535, ye = ne >>> 16, ne = M[5], oe = L[5], fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ce += fe >>> 16, de += ce >>> 16, ye += de >>> 16, M[5] = bt = de & 65535 | ye << 16, L[5] = Pt = fe & 65535 | ce << 16, ne = Et, oe = xt, fe = oe & 65535, ce = oe >>> 16, de = ne & 65535, ye = ne >>> 16, ne = M[6], oe = L[6], fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ce += fe >>> 16, de += ce >>> 16, ye += de >>> 16, M[6] = Et = de & 65535 | ye << 16, L[6] = xt = fe & 65535 | ce << 16, ne = Ot, oe = Nt, fe = oe & 65535, ce = oe >>> 16, de = ne & 65535, ye = ne >>> 16, ne = M[7], oe = L[7], fe += oe & 65535, ce += oe >>> 16, de += ne & 65535, ye += ne >>> 16, ce += fe >>> 16, de += ce >>> 16, ye += de >>> 16, M[7] = Ot = de & 65535 | ye << 16, L[7] = Nt = fe & 65535 | ce << 16, Dt += 128, O -= 128;
      }
      return O;
    }
    function ot(M, L, $) {
      var O = new Int32Array(8), P = new Int32Array(8), H = new Uint8Array(256), q, Q = $;
      for (O[0] = 1779033703, O[1] = 3144134277, O[2] = 1013904242, O[3] = 2773480762, O[4] = 1359893119, O[5] = 2600822924, O[6] = 528734635, O[7] = 1541459225, P[0] = 4089235720, P[1] = 2227873595, P[2] = 4271175723, P[3] = 1595750129, P[4] = 2917565137, P[5] = 725511199, P[6] = 4215389547, P[7] = 327033209, ve(O, P, L, $), $ %= 128, q = 0; q < $; q++)
        H[q] = L[Q - $ + q];
      for (H[$] = 128, $ = 256 - 128 * ($ < 112 ? 1 : 0), H[$ - 9] = 0, n(H, $ - 8, Q / 536870912 | 0, Q << 3), ve(O, P, H, $), q = 0; q < 8; q++)
        n(M, 8 * q, O[q], P[q]);
      return 0;
    }
    function He(M, L) {
      var $ = a(), O = a(), P = a(), H = a(), q = a(), Q = a(), re = a(), ae = a(), te = a();
      X($, M[1], M[0]), X(te, L[1], L[0]), D($, $, te), C(O, M[0], M[1]), C(te, L[0], L[1]), D(O, O, te), D(P, M[3], L[3]), D(P, P, B), D(H, M[2], L[2]), C(H, H, H), X(q, O, $), X(Q, H, P), C(re, H, P), C(ae, O, $), D(M[0], q, Q), D(M[1], ae, re), D(M[2], re, Q), D(M[3], q, ae);
    }
    function Ae(M, L, $) {
      var O;
      for (O = 0; O < 4; O++)
        S(M[O], L[O], $);
    }
    function ct(M, L) {
      var $ = a(), O = a(), P = a();
      Z(P, L[2]), D($, L[0], P), D(O, L[1], P), E(M, O), M[31] ^= A($) << 7;
    }
    function Ve(M, L, $) {
      var O, P;
      for (_(M[0], g), _(M[1], c), _(M[2], c), _(M[3], g), P = 255; P >= 0; --P)
        O = $[P / 8 | 0] >> (P & 7) & 1, Ae(M, L, O), He(L, M), He(M, M), Ae(M, L, O);
    }
    function _e(M, L) {
      var $ = [a(), a(), a(), a()];
      _($[0], j), _($[1], o), _($[2], c), D($[3], j, o), Ve(M, $, L);
    }
    function lt(M, L, $) {
      var O = new Uint8Array(64), P = [a(), a(), a(), a()], H;
      for ($ || d(L, 32), ot(O, L, 32), O[0] &= 248, O[31] &= 127, O[31] |= 64, _e(P, O), ct(M, P), H = 0; H < 32; H++)
        L[H + 32] = M[H];
      return 0;
    }
    var je = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function me(M, L) {
      var $, O, P, H;
      for (O = 63; O >= 32; --O) {
        for ($ = 0, P = O - 32, H = O - 12; P < H; ++P)
          L[P] += $ - 16 * L[O] * je[P - (O - 32)], $ = Math.floor((L[P] + 128) / 256), L[P] -= $ * 256;
        L[P] += $, L[O] = 0;
      }
      for ($ = 0, P = 0; P < 32; P++)
        L[P] += $ - (L[31] >> 4) * je[P], $ = L[P] >> 8, L[P] &= 255;
      for (P = 0; P < 32; P++)
        L[P] -= $ * je[P];
      for (O = 0; O < 32; O++)
        L[O + 1] += L[O] >> 8, M[O] = L[O] & 255;
    }
    function _t(M) {
      var L = new Float64Array(64), $;
      for ($ = 0; $ < 64; $++)
        L[$] = M[$];
      for ($ = 0; $ < 64; $++)
        M[$] = 0;
      me(M, L);
    }
    function tt(M, L, $, O) {
      var P = new Uint8Array(64), H = new Uint8Array(64), q = new Uint8Array(64), Q, re, ae = new Float64Array(64), te = [a(), a(), a(), a()];
      ot(P, O, 32), P[0] &= 248, P[31] &= 127, P[31] |= 64;
      var ge = $ + 64;
      for (Q = 0; Q < $; Q++)
        M[64 + Q] = L[Q];
      for (Q = 0; Q < 32; Q++)
        M[32 + Q] = P[32 + Q];
      for (ot(q, M.subarray(32), $ + 32), _t(q), _e(te, q), ct(M, te), Q = 32; Q < 64; Q++)
        M[Q] = O[Q];
      for (ot(H, M, $ + 64), _t(H), Q = 0; Q < 64; Q++)
        ae[Q] = 0;
      for (Q = 0; Q < 32; Q++)
        ae[Q] = q[Q];
      for (Q = 0; Q < 32; Q++)
        for (re = 0; re < 32; re++)
          ae[Q + re] += H[Q] * P[re];
      return me(M.subarray(32), ae), ge;
    }
    function Le(M, L) {
      var $ = a(), O = a(), P = a(), H = a(), q = a(), Q = a(), re = a();
      return _(M[2], c), I(M[1], L), V(P, M[1]), D(H, P, R), X(P, P, M[2]), C(H, M[2], H), V(q, H), V(Q, q), D(re, Q, q), D($, re, P), D($, $, H), J($, $), D($, $, P), D($, $, H), D($, $, H), D(M[0], $, H), V(O, M[0]), D(O, O, H), w(O, P) && D(M[0], M[0], e), V(O, M[0]), D(O, O, H), w(O, P) ? -1 : (A(M[0]) === L[31] >> 7 && X(M[0], g, M[0]), D(M[3], M[0], M[1]), 0);
    }
    function mt(M, L, $, O) {
      var P, H = new Uint8Array(32), q = new Uint8Array(64), Q = [a(), a(), a(), a()], re = [a(), a(), a(), a()];
      if ($ < 64 || Le(re, O))
        return -1;
      for (P = 0; P < $; P++)
        M[P] = L[P];
      for (P = 0; P < 32; P++)
        M[P + 32] = O[P];
      if (ot(q, M, $), _t(q), Ve(Q, re, q), _e(re, L.subarray(32)), He(Q, re), ct(H, Q), $ -= 64, m(L, 0, H, 0)) {
        for (P = 0; P < $; P++)
          M[P] = 0;
        return -1;
      }
      for (P = 0; P < $; P++)
        M[P] = L[P + 64];
      return $;
    }
    var rt = 32, De = 24, gt = 32, Ze = 16, Ce = 32, It = 32, et = 32, Ee = 32, Tt = 32, Xe = De, Fe = gt, wt = Ze, We = 64, Oe = 32, ht = 64, nt = 32, Me = 64;
    t.lowlevel = {
      crypto_core_hsalsa20: ze,
      crypto_stream_xor: W,
      crypto_stream: z,
      crypto_stream_salsa20_xor: st,
      crypto_stream_salsa20: G,
      crypto_onetimeauth: k,
      crypto_onetimeauth_verify: T,
      crypto_verify_16: y,
      crypto_verify_32: m,
      crypto_secretbox: p,
      crypto_secretbox_open: b,
      crypto_scalarmult: ee,
      crypto_scalarmult_base: he,
      crypto_box_beforenm: ie,
      crypto_box_afternm: Ne,
      crypto_box: se,
      crypto_box_open: ut,
      crypto_box_keypair: le,
      crypto_hash: ot,
      crypto_sign: tt,
      crypto_sign_keypair: lt,
      crypto_sign_open: mt,
      crypto_secretbox_KEYBYTES: rt,
      crypto_secretbox_NONCEBYTES: De,
      crypto_secretbox_ZEROBYTES: gt,
      crypto_secretbox_BOXZEROBYTES: Ze,
      crypto_scalarmult_BYTES: Ce,
      crypto_scalarmult_SCALARBYTES: It,
      crypto_box_PUBLICKEYBYTES: et,
      crypto_box_SECRETKEYBYTES: Ee,
      crypto_box_BEFORENMBYTES: Tt,
      crypto_box_NONCEBYTES: Xe,
      crypto_box_ZEROBYTES: Fe,
      crypto_box_BOXZEROBYTES: wt,
      crypto_sign_BYTES: We,
      crypto_sign_PUBLICKEYBYTES: Oe,
      crypto_sign_SECRETKEYBYTES: ht,
      crypto_sign_SEEDBYTES: nt,
      crypto_hash_BYTES: Me,
      gf: a,
      D: R,
      L: je,
      pack25519: E,
      unpack25519: I,
      M: D,
      A: C,
      S: V,
      Z: X,
      pow2523: J,
      add: He,
      set25519: _,
      modL: me,
      scalarmult: Ve,
      scalarbase: _e
    };
    function vt(M, L) {
      if (M.length !== rt)
        throw new Error("bad key size");
      if (L.length !== De)
        throw new Error("bad nonce size");
    }
    function at(M, L) {
      if (M.length !== et)
        throw new Error("bad public key size");
      if (L.length !== Ee)
        throw new Error("bad secret key size");
    }
    function ke() {
      for (var M = 0; M < arguments.length; M++)
        if (!(arguments[M] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function kt(M) {
      for (var L = 0; L < M.length; L++)
        M[L] = 0;
    }
    t.randomBytes = function(M) {
      var L = new Uint8Array(M);
      return d(L, M), L;
    }, t.secretbox = function(M, L, $) {
      ke(M, L, $), vt($, L);
      for (var O = new Uint8Array(gt + M.length), P = new Uint8Array(O.length), H = 0; H < M.length; H++)
        O[H + gt] = M[H];
      return p(P, O, O.length, L, $), P.subarray(Ze);
    }, t.secretbox.open = function(M, L, $) {
      ke(M, L, $), vt($, L);
      for (var O = new Uint8Array(Ze + M.length), P = new Uint8Array(O.length), H = 0; H < M.length; H++)
        O[H + Ze] = M[H];
      return O.length < 32 || b(P, O, O.length, L, $) !== 0 ? null : P.subarray(gt);
    }, t.secretbox.keyLength = rt, t.secretbox.nonceLength = De, t.secretbox.overheadLength = Ze, t.scalarMult = function(M, L) {
      if (ke(M, L), M.length !== It)
        throw new Error("bad n size");
      if (L.length !== Ce)
        throw new Error("bad p size");
      var $ = new Uint8Array(Ce);
      return ee($, M, L), $;
    }, t.scalarMult.base = function(M) {
      if (ke(M), M.length !== It)
        throw new Error("bad n size");
      var L = new Uint8Array(Ce);
      return he(L, M), L;
    }, t.scalarMult.scalarLength = It, t.scalarMult.groupElementLength = Ce, t.box = function(M, L, $, O) {
      var P = t.box.before($, O);
      return t.secretbox(M, L, P);
    }, t.box.before = function(M, L) {
      ke(M, L), at(M, L);
      var $ = new Uint8Array(Tt);
      return ie($, M, L), $;
    }, t.box.after = t.secretbox, t.box.open = function(M, L, $, O) {
      var P = t.box.before($, O);
      return t.secretbox.open(M, L, P);
    }, t.box.open.after = t.secretbox.open, t.box.keyPair = function() {
      var M = new Uint8Array(et), L = new Uint8Array(Ee);
      return le(M, L), { publicKey: M, secretKey: L };
    }, t.box.keyPair.fromSecretKey = function(M) {
      if (ke(M), M.length !== Ee)
        throw new Error("bad secret key size");
      var L = new Uint8Array(et);
      return he(L, M), { publicKey: L, secretKey: new Uint8Array(M) };
    }, t.box.publicKeyLength = et, t.box.secretKeyLength = Ee, t.box.sharedKeyLength = Tt, t.box.nonceLength = Xe, t.box.overheadLength = t.secretbox.overheadLength, t.sign = function(M, L) {
      if (ke(M, L), L.length !== ht)
        throw new Error("bad secret key size");
      var $ = new Uint8Array(We + M.length);
      return tt($, M, M.length, L), $;
    }, t.sign.open = function(M, L) {
      if (ke(M, L), L.length !== Oe)
        throw new Error("bad public key size");
      var $ = new Uint8Array(M.length), O = mt($, M, M.length, L);
      if (O < 0)
        return null;
      for (var P = new Uint8Array(O), H = 0; H < P.length; H++)
        P[H] = $[H];
      return P;
    }, t.sign.detached = function(M, L) {
      for (var $ = t.sign(M, L), O = new Uint8Array(We), P = 0; P < O.length; P++)
        O[P] = $[P];
      return O;
    }, t.sign.detached.verify = function(M, L, $) {
      if (ke(M, L, $), L.length !== We)
        throw new Error("bad signature size");
      if ($.length !== Oe)
        throw new Error("bad public key size");
      var O = new Uint8Array(We + M.length), P = new Uint8Array(We + M.length), H;
      for (H = 0; H < We; H++)
        O[H] = L[H];
      for (H = 0; H < M.length; H++)
        O[H + We] = M[H];
      return mt(P, O, O.length, $) >= 0;
    }, t.sign.keyPair = function() {
      var M = new Uint8Array(Oe), L = new Uint8Array(ht);
      return lt(M, L), { publicKey: M, secretKey: L };
    }, t.sign.keyPair.fromSecretKey = function(M) {
      if (ke(M), M.length !== ht)
        throw new Error("bad secret key size");
      for (var L = new Uint8Array(Oe), $ = 0; $ < L.length; $++)
        L[$] = M[32 + $];
      return { publicKey: L, secretKey: new Uint8Array(M) };
    }, t.sign.keyPair.fromSeed = function(M) {
      if (ke(M), M.length !== nt)
        throw new Error("bad seed size");
      for (var L = new Uint8Array(Oe), $ = new Uint8Array(ht), O = 0; O < 32; O++)
        $[O] = M[O];
      return lt(L, $, !0), { publicKey: L, secretKey: $ };
    }, t.sign.publicKeyLength = Oe, t.sign.secretKeyLength = ht, t.sign.seedLength = nt, t.sign.signatureLength = We, t.hash = function(M) {
      ke(M);
      var L = new Uint8Array(Me);
      return ot(L, M, M.length), L;
    }, t.hash.hashLength = Me, t.verify = function(M, L) {
      return ke(M, L), M.length === 0 || L.length === 0 || M.length !== L.length ? !1 : i(M, 0, L, 0, M.length) === 0;
    }, t.setPRNG = function(M) {
      d = M;
    }, function() {
      var M = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if (M && M.getRandomValues) {
        var L = 65536;
        t.setPRNG(function($, O) {
          var P, H = new Uint8Array(O);
          for (P = 0; P < O; P += L)
            M.getRandomValues(H.subarray(P, P + Math.min(O - P, L)));
          for (P = 0; P < O; P++)
            $[P] = H[P];
          kt(H);
        });
      } else
        typeof commonjsRequire < "u" && (M = require$$0$1, M && M.randomBytes && t.setPRNG(function($, O) {
          var P, H = M.randomBytes(O);
          for (P = 0; P < O; P++)
            $[P] = H[P];
          kt(H);
        }));
    }();
  })(u.exports ? u.exports : self.nacl = self.nacl || {});
})(naclFast);
const nacl = naclFast.exports;
function arrayEqual$1(u, t) {
  if (u === t)
    return !0;
  if (u.byteLength !== t.byteLength)
    return !1;
  const a = new DataView(
    u.buffer,
    u.byteOffset,
    u.byteLength
  ), d = new DataView(
    t.buffer,
    t.byteOffset,
    t.byteLength
  );
  let l = u.byteLength;
  for (; l--; )
    if (a.getUint8(l) !== d.getUint8(l))
      return !1;
  return !0;
}
function arrayStartsWith(u, t) {
  if (u.byteLength < t.byteLength)
    return !1;
  let a = t.byteLength;
  for (; a--; )
    if (u[a] !== t[a])
      return !1;
  return !0;
}
const byteToHex = [];
for (let u = 0; u <= 255; u += 1)
  byteToHex.push(u.toString(16).padStart(2, "0"));
function encode$3(u) {
  let t = "";
  for (const a of u)
    t += byteToHex[a];
  return t;
}
function decode$5(u) {
  const a = (u.startsWith("0x") ? u.substring(2) : u).match(/.{1,2}/gu);
  return new Uint8Array(
    (a == null ? [] : a).map((d) => parseInt(d, 16))
  );
}
function hexZeroPadded(u, t) {
  const a = "0123456789abcdef";
  let d = "0x";
  for (let l = 0; l < u.length; l++) {
    let h = u[l];
    d += a[(h & 240) >> 4] + a[h & 15];
  }
  for (d.length > 2 * t + 2 && console.log("result out of range", "result"); d.length < 2 * t + 2; )
    d = "0x0" + d.substring(2);
  return d.substring(2);
}
const derPrefix$3 = "302a300506032b6570032100", derPrefixBytes$3 = decode$5(derPrefix$3);
class Ed25519PublicKey extends Key$1 {
  constructor(t) {
    super(), this._keyData = t;
  }
  get _type() {
    return "ED25519";
  }
  static fromBytes(t) {
    switch (t.length) {
      case 32:
        return Ed25519PublicKey.fromBytesRaw(t);
      case 44:
        return Ed25519PublicKey.fromBytesDer(t);
      default:
        throw new BadKeyError(
          `invalid public key length: ${t.length} bytes`
        );
    }
  }
  static fromBytesDer(t) {
    if (t.length != 44 || !arrayStartsWith(t, derPrefixBytes$3))
      throw new BadKeyError(
        `invalid public key length: ${t.length} bytes`
      );
    return new Ed25519PublicKey(t.subarray(12));
  }
  static fromBytesRaw(t) {
    if (t.length != 32)
      throw new BadKeyError(
        `invalid public key length: ${t.length} bytes`
      );
    return new Ed25519PublicKey(t);
  }
  static fromString(t) {
    return Ed25519PublicKey.fromBytes(decode$5(t));
  }
  verify(t, a) {
    return nacl.sign.detached.verify(t, a, this._keyData);
  }
  toBytesDer() {
    const t = new Uint8Array(derPrefixBytes$3.length + 32);
    return t.set(derPrefixBytes$3, 0), t.set(this._keyData.subarray(0, 32), derPrefixBytes$3.length), t;
  }
  toBytesRaw() {
    return this._keyData.slice();
  }
  equals(t) {
    return arrayEqual$1(this._keyData, t._keyData);
  }
}
function bytes(u) {
  return nacl.randomBytes(u);
}
function bytesAsync(u) {
  return Promise.resolve(nacl.randomBytes(u));
}
function decode$4(u) {
  return new TextDecoder().decode(u);
}
function encode$2(u) {
  return new TextEncoder().encode(u);
}
const HashAlgorithm = {
  Sha256: "SHA-256",
  Sha384: "SHA-384",
  Sha512: "SHA-512"
};
async function hash$3(u, t, a) {
  const d = typeof t == "string" ? encode$2(t) : t, l = typeof a == "string" ? encode$2(a) : a;
  try {
    const h = await window.crypto.subtle.importKey(
      "raw",
      d,
      {
        name: "HMAC",
        hash: u
      },
      !1,
      ["sign"]
    );
    return new Uint8Array(
      await window.crypto.subtle.sign("HMAC", h, l)
    );
  } catch {
    throw new Error("Fallback if SubtleCrypto fails is not implemented");
  }
}
var elliptic = {};
const name = "elliptic", version$9 = "6.5.4", description = "EC cryptography", main = "lib/elliptic.js", files = [
  "lib"
], scripts = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, repository = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, keywords = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], author = "Fedor Indutny <fedor@indutny.com>", license = "MIT", bugs = {
  url: "https://github.com/indutny/elliptic/issues"
}, homepage = "https://github.com/indutny/elliptic", devDependencies = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, dependencies = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, require$$0 = {
  name,
  version: version$9,
  description,
  main,
  files,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  dependencies
};
var utils$m = {}, bn$2 = { exports: {} };
(function(u) {
  (function(t, a) {
    function d(F, k) {
      if (!F)
        throw new Error(k || "Assertion failed");
    }
    function l(F, k) {
      F.super_ = k;
      var T = function() {
      };
      T.prototype = k.prototype, F.prototype = new T(), F.prototype.constructor = F;
    }
    function h(F, k, T) {
      if (h.isBN(F))
        return F;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, F !== null && ((k === "le" || k === "be") && (T = k, k = 10), this._init(F || 0, k || 10, T || "be"));
    }
    typeof t == "object" ? t.exports = h : a.BN = h, h.BN = h, h.wordSize = 26;
    var g;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? g = window.Buffer : g = require$$0$1.Buffer;
    } catch {
    }
    h.isBN = function(k) {
      return k instanceof h ? !0 : k !== null && typeof k == "object" && k.constructor.wordSize === h.wordSize && Array.isArray(k.words);
    }, h.max = function(k, T) {
      return k.cmp(T) > 0 ? k : T;
    }, h.min = function(k, T) {
      return k.cmp(T) < 0 ? k : T;
    }, h.prototype._init = function(k, T, p) {
      if (typeof k == "number")
        return this._initNumber(k, T, p);
      if (typeof k == "object")
        return this._initArray(k, T, p);
      T === "hex" && (T = 16), d(T === (T | 0) && T >= 2 && T <= 36), k = k.toString().replace(/\s+/g, "");
      var b = 0;
      k[0] === "-" && (b++, this.negative = 1), b < k.length && (T === 16 ? this._parseHex(k, b, p) : (this._parseBase(k, T, b), p === "le" && this._initArray(this.toArray(), T, p)));
    }, h.prototype._initNumber = function(k, T, p) {
      k < 0 && (this.negative = 1, k = -k), k < 67108864 ? (this.words = [k & 67108863], this.length = 1) : k < 4503599627370496 ? (this.words = [
        k & 67108863,
        k / 67108864 & 67108863
      ], this.length = 2) : (d(k < 9007199254740992), this.words = [
        k & 67108863,
        k / 67108864 & 67108863,
        1
      ], this.length = 3), p === "le" && this._initArray(this.toArray(), T, p);
    }, h.prototype._initArray = function(k, T, p) {
      if (d(typeof k.length == "number"), k.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(k.length / 3), this.words = new Array(this.length);
      for (var b = 0; b < this.length; b++)
        this.words[b] = 0;
      var _, v, S = 0;
      if (p === "be")
        for (b = k.length - 1, _ = 0; b >= 0; b -= 3)
          v = k[b] | k[b - 1] << 8 | k[b - 2] << 16, this.words[_] |= v << S & 67108863, this.words[_ + 1] = v >>> 26 - S & 67108863, S += 24, S >= 26 && (S -= 26, _++);
      else if (p === "le")
        for (b = 0, _ = 0; b < k.length; b += 3)
          v = k[b] | k[b + 1] << 8 | k[b + 2] << 16, this.words[_] |= v << S & 67108863, this.words[_ + 1] = v >>> 26 - S & 67108863, S += 24, S >= 26 && (S -= 26, _++);
      return this.strip();
    };
    function c(F, k) {
      var T = F.charCodeAt(k);
      return T >= 65 && T <= 70 ? T - 55 : T >= 97 && T <= 102 ? T - 87 : T - 48 & 15;
    }
    function x(F, k, T) {
      var p = c(F, T);
      return T - 1 >= k && (p |= c(F, T - 1) << 4), p;
    }
    h.prototype._parseHex = function(k, T, p) {
      this.length = Math.ceil((k.length - T) / 6), this.words = new Array(this.length);
      for (var b = 0; b < this.length; b++)
        this.words[b] = 0;
      var _ = 0, v = 0, S;
      if (p === "be")
        for (b = k.length - 1; b >= T; b -= 2)
          S = x(k, T, b) << _, this.words[v] |= S & 67108863, _ >= 18 ? (_ -= 18, v += 1, this.words[v] |= S >>> 26) : _ += 8;
      else {
        var E = k.length - T;
        for (b = E % 2 === 0 ? T + 1 : T; b < k.length; b += 2)
          S = x(k, T, b) << _, this.words[v] |= S & 67108863, _ >= 18 ? (_ -= 18, v += 1, this.words[v] |= S >>> 26) : _ += 8;
      }
      this.strip();
    };
    function R(F, k, T, p) {
      for (var b = 0, _ = Math.min(F.length, T), v = k; v < _; v++) {
        var S = F.charCodeAt(v) - 48;
        b *= p, S >= 49 ? b += S - 49 + 10 : S >= 17 ? b += S - 17 + 10 : b += S;
      }
      return b;
    }
    h.prototype._parseBase = function(k, T, p) {
      this.words = [0], this.length = 1;
      for (var b = 0, _ = 1; _ <= 67108863; _ *= T)
        b++;
      b--, _ = _ / T | 0;
      for (var v = k.length - p, S = v % b, E = Math.min(v, v - S) + p, w = 0, A = p; A < E; A += b)
        w = R(k, A, A + b, T), this.imuln(_), this.words[0] + w < 67108864 ? this.words[0] += w : this._iaddn(w);
      if (S !== 0) {
        var I = 1;
        for (w = R(k, A, k.length, T), A = 0; A < S; A++)
          I *= T;
        this.imuln(I), this.words[0] + w < 67108864 ? this.words[0] += w : this._iaddn(w);
      }
      this.strip();
    }, h.prototype.copy = function(k) {
      k.words = new Array(this.length);
      for (var T = 0; T < this.length; T++)
        k.words[T] = this.words[T];
      k.length = this.length, k.negative = this.negative, k.red = this.red;
    }, h.prototype.clone = function() {
      var k = new h(null);
      return this.copy(k), k;
    }, h.prototype._expand = function(k) {
      for (; this.length < k; )
        this.words[this.length++] = 0;
      return this;
    }, h.prototype.strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, h.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, h.prototype.inspect = function() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    var B = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], j = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], o = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    h.prototype.toString = function(k, T) {
      k = k || 10, T = T | 0 || 1;
      var p;
      if (k === 16 || k === "hex") {
        p = "";
        for (var b = 0, _ = 0, v = 0; v < this.length; v++) {
          var S = this.words[v], E = ((S << b | _) & 16777215).toString(16);
          _ = S >>> 24 - b & 16777215, _ !== 0 || v !== this.length - 1 ? p = B[6 - E.length] + E + p : p = E + p, b += 2, b >= 26 && (b -= 26, v--);
        }
        for (_ !== 0 && (p = _.toString(16) + p); p.length % T !== 0; )
          p = "0" + p;
        return this.negative !== 0 && (p = "-" + p), p;
      }
      if (k === (k | 0) && k >= 2 && k <= 36) {
        var w = j[k], A = o[k];
        p = "";
        var I = this.clone();
        for (I.negative = 0; !I.isZero(); ) {
          var C = I.modn(A).toString(k);
          I = I.idivn(A), I.isZero() ? p = C + p : p = B[w - C.length] + C + p;
        }
        for (this.isZero() && (p = "0" + p); p.length % T !== 0; )
          p = "0" + p;
        return this.negative !== 0 && (p = "-" + p), p;
      }
      d(!1, "Base should be between 2 and 36");
    }, h.prototype.toNumber = function() {
      var k = this.words[0];
      return this.length === 2 ? k += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? k += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && d(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -k : k;
    }, h.prototype.toJSON = function() {
      return this.toString(16);
    }, h.prototype.toBuffer = function(k, T) {
      return d(typeof g < "u"), this.toArrayLike(g, k, T);
    }, h.prototype.toArray = function(k, T) {
      return this.toArrayLike(Array, k, T);
    }, h.prototype.toArrayLike = function(k, T, p) {
      var b = this.byteLength(), _ = p || Math.max(1, b);
      d(b <= _, "byte array longer than desired length"), d(_ > 0, "Requested array length <= 0"), this.strip();
      var v = T === "le", S = new k(_), E, w, A = this.clone();
      if (v) {
        for (w = 0; !A.isZero(); w++)
          E = A.andln(255), A.iushrn(8), S[w] = E;
        for (; w < _; w++)
          S[w] = 0;
      } else {
        for (w = 0; w < _ - b; w++)
          S[w] = 0;
        for (w = 0; !A.isZero(); w++)
          E = A.andln(255), A.iushrn(8), S[_ - w - 1] = E;
      }
      return S;
    }, Math.clz32 ? h.prototype._countBits = function(k) {
      return 32 - Math.clz32(k);
    } : h.prototype._countBits = function(k) {
      var T = k, p = 0;
      return T >= 4096 && (p += 13, T >>>= 13), T >= 64 && (p += 7, T >>>= 7), T >= 8 && (p += 4, T >>>= 4), T >= 2 && (p += 2, T >>>= 2), p + T;
    }, h.prototype._zeroBits = function(k) {
      if (k === 0)
        return 26;
      var T = k, p = 0;
      return (T & 8191) === 0 && (p += 13, T >>>= 13), (T & 127) === 0 && (p += 7, T >>>= 7), (T & 15) === 0 && (p += 4, T >>>= 4), (T & 3) === 0 && (p += 2, T >>>= 2), (T & 1) === 0 && p++, p;
    }, h.prototype.bitLength = function() {
      var k = this.words[this.length - 1], T = this._countBits(k);
      return (this.length - 1) * 26 + T;
    };
    function e(F) {
      for (var k = new Array(F.bitLength()), T = 0; T < k.length; T++) {
        var p = T / 26 | 0, b = T % 26;
        k[T] = (F.words[p] & 1 << b) >>> b;
      }
      return k;
    }
    h.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var k = 0, T = 0; T < this.length; T++) {
        var p = this._zeroBits(this.words[T]);
        if (k += p, p !== 26)
          break;
      }
      return k;
    }, h.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, h.prototype.toTwos = function(k) {
      return this.negative !== 0 ? this.abs().inotn(k).iaddn(1) : this.clone();
    }, h.prototype.fromTwos = function(k) {
      return this.testn(k - 1) ? this.notn(k).iaddn(1).ineg() : this.clone();
    }, h.prototype.isNeg = function() {
      return this.negative !== 0;
    }, h.prototype.neg = function() {
      return this.clone().ineg();
    }, h.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, h.prototype.iuor = function(k) {
      for (; this.length < k.length; )
        this.words[this.length++] = 0;
      for (var T = 0; T < k.length; T++)
        this.words[T] = this.words[T] | k.words[T];
      return this.strip();
    }, h.prototype.ior = function(k) {
      return d((this.negative | k.negative) === 0), this.iuor(k);
    }, h.prototype.or = function(k) {
      return this.length > k.length ? this.clone().ior(k) : k.clone().ior(this);
    }, h.prototype.uor = function(k) {
      return this.length > k.length ? this.clone().iuor(k) : k.clone().iuor(this);
    }, h.prototype.iuand = function(k) {
      var T;
      this.length > k.length ? T = k : T = this;
      for (var p = 0; p < T.length; p++)
        this.words[p] = this.words[p] & k.words[p];
      return this.length = T.length, this.strip();
    }, h.prototype.iand = function(k) {
      return d((this.negative | k.negative) === 0), this.iuand(k);
    }, h.prototype.and = function(k) {
      return this.length > k.length ? this.clone().iand(k) : k.clone().iand(this);
    }, h.prototype.uand = function(k) {
      return this.length > k.length ? this.clone().iuand(k) : k.clone().iuand(this);
    }, h.prototype.iuxor = function(k) {
      var T, p;
      this.length > k.length ? (T = this, p = k) : (T = k, p = this);
      for (var b = 0; b < p.length; b++)
        this.words[b] = T.words[b] ^ p.words[b];
      if (this !== T)
        for (; b < T.length; b++)
          this.words[b] = T.words[b];
      return this.length = T.length, this.strip();
    }, h.prototype.ixor = function(k) {
      return d((this.negative | k.negative) === 0), this.iuxor(k);
    }, h.prototype.xor = function(k) {
      return this.length > k.length ? this.clone().ixor(k) : k.clone().ixor(this);
    }, h.prototype.uxor = function(k) {
      return this.length > k.length ? this.clone().iuxor(k) : k.clone().iuxor(this);
    }, h.prototype.inotn = function(k) {
      d(typeof k == "number" && k >= 0);
      var T = Math.ceil(k / 26) | 0, p = k % 26;
      this._expand(T), p > 0 && T--;
      for (var b = 0; b < T; b++)
        this.words[b] = ~this.words[b] & 67108863;
      return p > 0 && (this.words[b] = ~this.words[b] & 67108863 >> 26 - p), this.strip();
    }, h.prototype.notn = function(k) {
      return this.clone().inotn(k);
    }, h.prototype.setn = function(k, T) {
      d(typeof k == "number" && k >= 0);
      var p = k / 26 | 0, b = k % 26;
      return this._expand(p + 1), T ? this.words[p] = this.words[p] | 1 << b : this.words[p] = this.words[p] & ~(1 << b), this.strip();
    }, h.prototype.iadd = function(k) {
      var T;
      if (this.negative !== 0 && k.negative === 0)
        return this.negative = 0, T = this.isub(k), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && k.negative !== 0)
        return k.negative = 0, T = this.isub(k), k.negative = 1, T._normSign();
      var p, b;
      this.length > k.length ? (p = this, b = k) : (p = k, b = this);
      for (var _ = 0, v = 0; v < b.length; v++)
        T = (p.words[v] | 0) + (b.words[v] | 0) + _, this.words[v] = T & 67108863, _ = T >>> 26;
      for (; _ !== 0 && v < p.length; v++)
        T = (p.words[v] | 0) + _, this.words[v] = T & 67108863, _ = T >>> 26;
      if (this.length = p.length, _ !== 0)
        this.words[this.length] = _, this.length++;
      else if (p !== this)
        for (; v < p.length; v++)
          this.words[v] = p.words[v];
      return this;
    }, h.prototype.add = function(k) {
      var T;
      return k.negative !== 0 && this.negative === 0 ? (k.negative = 0, T = this.sub(k), k.negative ^= 1, T) : k.negative === 0 && this.negative !== 0 ? (this.negative = 0, T = k.sub(this), this.negative = 1, T) : this.length > k.length ? this.clone().iadd(k) : k.clone().iadd(this);
    }, h.prototype.isub = function(k) {
      if (k.negative !== 0) {
        k.negative = 0;
        var T = this.iadd(k);
        return k.negative = 1, T._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(k), this.negative = 1, this._normSign();
      var p = this.cmp(k);
      if (p === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var b, _;
      p > 0 ? (b = this, _ = k) : (b = k, _ = this);
      for (var v = 0, S = 0; S < _.length; S++)
        T = (b.words[S] | 0) - (_.words[S] | 0) + v, v = T >> 26, this.words[S] = T & 67108863;
      for (; v !== 0 && S < b.length; S++)
        T = (b.words[S] | 0) + v, v = T >> 26, this.words[S] = T & 67108863;
      if (v === 0 && S < b.length && b !== this)
        for (; S < b.length; S++)
          this.words[S] = b.words[S];
      return this.length = Math.max(this.length, S), b !== this && (this.negative = 1), this.strip();
    }, h.prototype.sub = function(k) {
      return this.clone().isub(k);
    };
    function n(F, k, T) {
      T.negative = k.negative ^ F.negative;
      var p = F.length + k.length | 0;
      T.length = p, p = p - 1 | 0;
      var b = F.words[0] | 0, _ = k.words[0] | 0, v = b * _, S = v & 67108863, E = v / 67108864 | 0;
      T.words[0] = S;
      for (var w = 1; w < p; w++) {
        for (var A = E >>> 26, I = E & 67108863, C = Math.min(w, k.length - 1), X = Math.max(0, w - F.length + 1); X <= C; X++) {
          var D = w - X | 0;
          b = F.words[D] | 0, _ = k.words[X] | 0, v = b * _ + I, A += v / 67108864 | 0, I = v & 67108863;
        }
        T.words[w] = I | 0, E = A | 0;
      }
      return E !== 0 ? T.words[w] = E | 0 : T.length--, T.strip();
    }
    var i = function(k, T, p) {
      var b = k.words, _ = T.words, v = p.words, S = 0, E, w, A, I = b[0] | 0, C = I & 8191, X = I >>> 13, D = b[1] | 0, V = D & 8191, Z = D >>> 13, J = b[2] | 0, ee = J & 8191, he = J >>> 13, le = b[3] | 0, ie = le & 8191, Ne = le >>> 13, ue = b[4] | 0, se = ue & 8191, ut = ue >>> 13, qe = b[5] | 0, ve = qe & 8191, ot = qe >>> 13, He = b[6] | 0, Ae = He & 8191, ct = He >>> 13, Ve = b[7] | 0, _e = Ve & 8191, lt = Ve >>> 13, je = b[8] | 0, me = je & 8191, _t = je >>> 13, tt = b[9] | 0, Le = tt & 8191, mt = tt >>> 13, rt = _[0] | 0, De = rt & 8191, gt = rt >>> 13, Ze = _[1] | 0, Ce = Ze & 8191, It = Ze >>> 13, et = _[2] | 0, Ee = et & 8191, Tt = et >>> 13, Xe = _[3] | 0, Fe = Xe & 8191, wt = Xe >>> 13, We = _[4] | 0, Oe = We & 8191, ht = We >>> 13, nt = _[5] | 0, Me = nt & 8191, vt = nt >>> 13, at = _[6] | 0, ke = at & 8191, kt = at >>> 13, M = _[7] | 0, L = M & 8191, $ = M >>> 13, O = _[8] | 0, P = O & 8191, H = O >>> 13, q = _[9] | 0, Q = q & 8191, re = q >>> 13;
      p.negative = k.negative ^ T.negative, p.length = 19, E = Math.imul(C, De), w = Math.imul(C, gt), w = w + Math.imul(X, De) | 0, A = Math.imul(X, gt);
      var ae = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (ae >>> 26) | 0, ae &= 67108863, E = Math.imul(V, De), w = Math.imul(V, gt), w = w + Math.imul(Z, De) | 0, A = Math.imul(Z, gt), E = E + Math.imul(C, Ce) | 0, w = w + Math.imul(C, It) | 0, w = w + Math.imul(X, Ce) | 0, A = A + Math.imul(X, It) | 0;
      var te = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (te >>> 26) | 0, te &= 67108863, E = Math.imul(ee, De), w = Math.imul(ee, gt), w = w + Math.imul(he, De) | 0, A = Math.imul(he, gt), E = E + Math.imul(V, Ce) | 0, w = w + Math.imul(V, It) | 0, w = w + Math.imul(Z, Ce) | 0, A = A + Math.imul(Z, It) | 0, E = E + Math.imul(C, Ee) | 0, w = w + Math.imul(C, Tt) | 0, w = w + Math.imul(X, Ee) | 0, A = A + Math.imul(X, Tt) | 0;
      var ge = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, E = Math.imul(ie, De), w = Math.imul(ie, gt), w = w + Math.imul(Ne, De) | 0, A = Math.imul(Ne, gt), E = E + Math.imul(ee, Ce) | 0, w = w + Math.imul(ee, It) | 0, w = w + Math.imul(he, Ce) | 0, A = A + Math.imul(he, It) | 0, E = E + Math.imul(V, Ee) | 0, w = w + Math.imul(V, Tt) | 0, w = w + Math.imul(Z, Ee) | 0, A = A + Math.imul(Z, Tt) | 0, E = E + Math.imul(C, Fe) | 0, w = w + Math.imul(C, wt) | 0, w = w + Math.imul(X, Fe) | 0, A = A + Math.imul(X, wt) | 0;
      var pe = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (pe >>> 26) | 0, pe &= 67108863, E = Math.imul(se, De), w = Math.imul(se, gt), w = w + Math.imul(ut, De) | 0, A = Math.imul(ut, gt), E = E + Math.imul(ie, Ce) | 0, w = w + Math.imul(ie, It) | 0, w = w + Math.imul(Ne, Ce) | 0, A = A + Math.imul(Ne, It) | 0, E = E + Math.imul(ee, Ee) | 0, w = w + Math.imul(ee, Tt) | 0, w = w + Math.imul(he, Ee) | 0, A = A + Math.imul(he, Tt) | 0, E = E + Math.imul(V, Fe) | 0, w = w + Math.imul(V, wt) | 0, w = w + Math.imul(Z, Fe) | 0, A = A + Math.imul(Z, wt) | 0, E = E + Math.imul(C, Oe) | 0, w = w + Math.imul(C, ht) | 0, w = w + Math.imul(X, Oe) | 0, A = A + Math.imul(X, ht) | 0;
      var Ie = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, E = Math.imul(ve, De), w = Math.imul(ve, gt), w = w + Math.imul(ot, De) | 0, A = Math.imul(ot, gt), E = E + Math.imul(se, Ce) | 0, w = w + Math.imul(se, It) | 0, w = w + Math.imul(ut, Ce) | 0, A = A + Math.imul(ut, It) | 0, E = E + Math.imul(ie, Ee) | 0, w = w + Math.imul(ie, Tt) | 0, w = w + Math.imul(Ne, Ee) | 0, A = A + Math.imul(Ne, Tt) | 0, E = E + Math.imul(ee, Fe) | 0, w = w + Math.imul(ee, wt) | 0, w = w + Math.imul(he, Fe) | 0, A = A + Math.imul(he, wt) | 0, E = E + Math.imul(V, Oe) | 0, w = w + Math.imul(V, ht) | 0, w = w + Math.imul(Z, Oe) | 0, A = A + Math.imul(Z, ht) | 0, E = E + Math.imul(C, Me) | 0, w = w + Math.imul(C, vt) | 0, w = w + Math.imul(X, Me) | 0, A = A + Math.imul(X, vt) | 0;
      var we = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, E = Math.imul(Ae, De), w = Math.imul(Ae, gt), w = w + Math.imul(ct, De) | 0, A = Math.imul(ct, gt), E = E + Math.imul(ve, Ce) | 0, w = w + Math.imul(ve, It) | 0, w = w + Math.imul(ot, Ce) | 0, A = A + Math.imul(ot, It) | 0, E = E + Math.imul(se, Ee) | 0, w = w + Math.imul(se, Tt) | 0, w = w + Math.imul(ut, Ee) | 0, A = A + Math.imul(ut, Tt) | 0, E = E + Math.imul(ie, Fe) | 0, w = w + Math.imul(ie, wt) | 0, w = w + Math.imul(Ne, Fe) | 0, A = A + Math.imul(Ne, wt) | 0, E = E + Math.imul(ee, Oe) | 0, w = w + Math.imul(ee, ht) | 0, w = w + Math.imul(he, Oe) | 0, A = A + Math.imul(he, ht) | 0, E = E + Math.imul(V, Me) | 0, w = w + Math.imul(V, vt) | 0, w = w + Math.imul(Z, Me) | 0, A = A + Math.imul(Z, vt) | 0, E = E + Math.imul(C, ke) | 0, w = w + Math.imul(C, kt) | 0, w = w + Math.imul(X, ke) | 0, A = A + Math.imul(X, kt) | 0;
      var Ue = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (Ue >>> 26) | 0, Ue &= 67108863, E = Math.imul(_e, De), w = Math.imul(_e, gt), w = w + Math.imul(lt, De) | 0, A = Math.imul(lt, gt), E = E + Math.imul(Ae, Ce) | 0, w = w + Math.imul(Ae, It) | 0, w = w + Math.imul(ct, Ce) | 0, A = A + Math.imul(ct, It) | 0, E = E + Math.imul(ve, Ee) | 0, w = w + Math.imul(ve, Tt) | 0, w = w + Math.imul(ot, Ee) | 0, A = A + Math.imul(ot, Tt) | 0, E = E + Math.imul(se, Fe) | 0, w = w + Math.imul(se, wt) | 0, w = w + Math.imul(ut, Fe) | 0, A = A + Math.imul(ut, wt) | 0, E = E + Math.imul(ie, Oe) | 0, w = w + Math.imul(ie, ht) | 0, w = w + Math.imul(Ne, Oe) | 0, A = A + Math.imul(Ne, ht) | 0, E = E + Math.imul(ee, Me) | 0, w = w + Math.imul(ee, vt) | 0, w = w + Math.imul(he, Me) | 0, A = A + Math.imul(he, vt) | 0, E = E + Math.imul(V, ke) | 0, w = w + Math.imul(V, kt) | 0, w = w + Math.imul(Z, ke) | 0, A = A + Math.imul(Z, kt) | 0, E = E + Math.imul(C, L) | 0, w = w + Math.imul(C, $) | 0, w = w + Math.imul(X, L) | 0, A = A + Math.imul(X, $) | 0;
      var Ye = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (Ye >>> 26) | 0, Ye &= 67108863, E = Math.imul(me, De), w = Math.imul(me, gt), w = w + Math.imul(_t, De) | 0, A = Math.imul(_t, gt), E = E + Math.imul(_e, Ce) | 0, w = w + Math.imul(_e, It) | 0, w = w + Math.imul(lt, Ce) | 0, A = A + Math.imul(lt, It) | 0, E = E + Math.imul(Ae, Ee) | 0, w = w + Math.imul(Ae, Tt) | 0, w = w + Math.imul(ct, Ee) | 0, A = A + Math.imul(ct, Tt) | 0, E = E + Math.imul(ve, Fe) | 0, w = w + Math.imul(ve, wt) | 0, w = w + Math.imul(ot, Fe) | 0, A = A + Math.imul(ot, wt) | 0, E = E + Math.imul(se, Oe) | 0, w = w + Math.imul(se, ht) | 0, w = w + Math.imul(ut, Oe) | 0, A = A + Math.imul(ut, ht) | 0, E = E + Math.imul(ie, Me) | 0, w = w + Math.imul(ie, vt) | 0, w = w + Math.imul(Ne, Me) | 0, A = A + Math.imul(Ne, vt) | 0, E = E + Math.imul(ee, ke) | 0, w = w + Math.imul(ee, kt) | 0, w = w + Math.imul(he, ke) | 0, A = A + Math.imul(he, kt) | 0, E = E + Math.imul(V, L) | 0, w = w + Math.imul(V, $) | 0, w = w + Math.imul(Z, L) | 0, A = A + Math.imul(Z, $) | 0, E = E + Math.imul(C, P) | 0, w = w + Math.imul(C, H) | 0, w = w + Math.imul(X, P) | 0, A = A + Math.imul(X, H) | 0;
      var Qe = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (Qe >>> 26) | 0, Qe &= 67108863, E = Math.imul(Le, De), w = Math.imul(Le, gt), w = w + Math.imul(mt, De) | 0, A = Math.imul(mt, gt), E = E + Math.imul(me, Ce) | 0, w = w + Math.imul(me, It) | 0, w = w + Math.imul(_t, Ce) | 0, A = A + Math.imul(_t, It) | 0, E = E + Math.imul(_e, Ee) | 0, w = w + Math.imul(_e, Tt) | 0, w = w + Math.imul(lt, Ee) | 0, A = A + Math.imul(lt, Tt) | 0, E = E + Math.imul(Ae, Fe) | 0, w = w + Math.imul(Ae, wt) | 0, w = w + Math.imul(ct, Fe) | 0, A = A + Math.imul(ct, wt) | 0, E = E + Math.imul(ve, Oe) | 0, w = w + Math.imul(ve, ht) | 0, w = w + Math.imul(ot, Oe) | 0, A = A + Math.imul(ot, ht) | 0, E = E + Math.imul(se, Me) | 0, w = w + Math.imul(se, vt) | 0, w = w + Math.imul(ut, Me) | 0, A = A + Math.imul(ut, vt) | 0, E = E + Math.imul(ie, ke) | 0, w = w + Math.imul(ie, kt) | 0, w = w + Math.imul(Ne, ke) | 0, A = A + Math.imul(Ne, kt) | 0, E = E + Math.imul(ee, L) | 0, w = w + Math.imul(ee, $) | 0, w = w + Math.imul(he, L) | 0, A = A + Math.imul(he, $) | 0, E = E + Math.imul(V, P) | 0, w = w + Math.imul(V, H) | 0, w = w + Math.imul(Z, P) | 0, A = A + Math.imul(Z, H) | 0, E = E + Math.imul(C, Q) | 0, w = w + Math.imul(C, re) | 0, w = w + Math.imul(X, Q) | 0, A = A + Math.imul(X, re) | 0;
      var Ge = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (Ge >>> 26) | 0, Ge &= 67108863, E = Math.imul(Le, Ce), w = Math.imul(Le, It), w = w + Math.imul(mt, Ce) | 0, A = Math.imul(mt, It), E = E + Math.imul(me, Ee) | 0, w = w + Math.imul(me, Tt) | 0, w = w + Math.imul(_t, Ee) | 0, A = A + Math.imul(_t, Tt) | 0, E = E + Math.imul(_e, Fe) | 0, w = w + Math.imul(_e, wt) | 0, w = w + Math.imul(lt, Fe) | 0, A = A + Math.imul(lt, wt) | 0, E = E + Math.imul(Ae, Oe) | 0, w = w + Math.imul(Ae, ht) | 0, w = w + Math.imul(ct, Oe) | 0, A = A + Math.imul(ct, ht) | 0, E = E + Math.imul(ve, Me) | 0, w = w + Math.imul(ve, vt) | 0, w = w + Math.imul(ot, Me) | 0, A = A + Math.imul(ot, vt) | 0, E = E + Math.imul(se, ke) | 0, w = w + Math.imul(se, kt) | 0, w = w + Math.imul(ut, ke) | 0, A = A + Math.imul(ut, kt) | 0, E = E + Math.imul(ie, L) | 0, w = w + Math.imul(ie, $) | 0, w = w + Math.imul(Ne, L) | 0, A = A + Math.imul(Ne, $) | 0, E = E + Math.imul(ee, P) | 0, w = w + Math.imul(ee, H) | 0, w = w + Math.imul(he, P) | 0, A = A + Math.imul(he, H) | 0, E = E + Math.imul(V, Q) | 0, w = w + Math.imul(V, re) | 0, w = w + Math.imul(Z, Q) | 0, A = A + Math.imul(Z, re) | 0;
      var Je = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (Je >>> 26) | 0, Je &= 67108863, E = Math.imul(Le, Ee), w = Math.imul(Le, Tt), w = w + Math.imul(mt, Ee) | 0, A = Math.imul(mt, Tt), E = E + Math.imul(me, Fe) | 0, w = w + Math.imul(me, wt) | 0, w = w + Math.imul(_t, Fe) | 0, A = A + Math.imul(_t, wt) | 0, E = E + Math.imul(_e, Oe) | 0, w = w + Math.imul(_e, ht) | 0, w = w + Math.imul(lt, Oe) | 0, A = A + Math.imul(lt, ht) | 0, E = E + Math.imul(Ae, Me) | 0, w = w + Math.imul(Ae, vt) | 0, w = w + Math.imul(ct, Me) | 0, A = A + Math.imul(ct, vt) | 0, E = E + Math.imul(ve, ke) | 0, w = w + Math.imul(ve, kt) | 0, w = w + Math.imul(ot, ke) | 0, A = A + Math.imul(ot, kt) | 0, E = E + Math.imul(se, L) | 0, w = w + Math.imul(se, $) | 0, w = w + Math.imul(ut, L) | 0, A = A + Math.imul(ut, $) | 0, E = E + Math.imul(ie, P) | 0, w = w + Math.imul(ie, H) | 0, w = w + Math.imul(Ne, P) | 0, A = A + Math.imul(Ne, H) | 0, E = E + Math.imul(ee, Q) | 0, w = w + Math.imul(ee, re) | 0, w = w + Math.imul(he, Q) | 0, A = A + Math.imul(he, re) | 0;
      var Re = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, E = Math.imul(Le, Fe), w = Math.imul(Le, wt), w = w + Math.imul(mt, Fe) | 0, A = Math.imul(mt, wt), E = E + Math.imul(me, Oe) | 0, w = w + Math.imul(me, ht) | 0, w = w + Math.imul(_t, Oe) | 0, A = A + Math.imul(_t, ht) | 0, E = E + Math.imul(_e, Me) | 0, w = w + Math.imul(_e, vt) | 0, w = w + Math.imul(lt, Me) | 0, A = A + Math.imul(lt, vt) | 0, E = E + Math.imul(Ae, ke) | 0, w = w + Math.imul(Ae, kt) | 0, w = w + Math.imul(ct, ke) | 0, A = A + Math.imul(ct, kt) | 0, E = E + Math.imul(ve, L) | 0, w = w + Math.imul(ve, $) | 0, w = w + Math.imul(ot, L) | 0, A = A + Math.imul(ot, $) | 0, E = E + Math.imul(se, P) | 0, w = w + Math.imul(se, H) | 0, w = w + Math.imul(ut, P) | 0, A = A + Math.imul(ut, H) | 0, E = E + Math.imul(ie, Q) | 0, w = w + Math.imul(ie, re) | 0, w = w + Math.imul(Ne, Q) | 0, A = A + Math.imul(Ne, re) | 0;
      var $e = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + ($e >>> 26) | 0, $e &= 67108863, E = Math.imul(Le, Oe), w = Math.imul(Le, ht), w = w + Math.imul(mt, Oe) | 0, A = Math.imul(mt, ht), E = E + Math.imul(me, Me) | 0, w = w + Math.imul(me, vt) | 0, w = w + Math.imul(_t, Me) | 0, A = A + Math.imul(_t, vt) | 0, E = E + Math.imul(_e, ke) | 0, w = w + Math.imul(_e, kt) | 0, w = w + Math.imul(lt, ke) | 0, A = A + Math.imul(lt, kt) | 0, E = E + Math.imul(Ae, L) | 0, w = w + Math.imul(Ae, $) | 0, w = w + Math.imul(ct, L) | 0, A = A + Math.imul(ct, $) | 0, E = E + Math.imul(ve, P) | 0, w = w + Math.imul(ve, H) | 0, w = w + Math.imul(ot, P) | 0, A = A + Math.imul(ot, H) | 0, E = E + Math.imul(se, Q) | 0, w = w + Math.imul(se, re) | 0, w = w + Math.imul(ut, Q) | 0, A = A + Math.imul(ut, re) | 0;
      var Se = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, E = Math.imul(Le, Me), w = Math.imul(Le, vt), w = w + Math.imul(mt, Me) | 0, A = Math.imul(mt, vt), E = E + Math.imul(me, ke) | 0, w = w + Math.imul(me, kt) | 0, w = w + Math.imul(_t, ke) | 0, A = A + Math.imul(_t, kt) | 0, E = E + Math.imul(_e, L) | 0, w = w + Math.imul(_e, $) | 0, w = w + Math.imul(lt, L) | 0, A = A + Math.imul(lt, $) | 0, E = E + Math.imul(Ae, P) | 0, w = w + Math.imul(Ae, H) | 0, w = w + Math.imul(ct, P) | 0, A = A + Math.imul(ct, H) | 0, E = E + Math.imul(ve, Q) | 0, w = w + Math.imul(ve, re) | 0, w = w + Math.imul(ot, Q) | 0, A = A + Math.imul(ot, re) | 0;
      var xe = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, E = Math.imul(Le, ke), w = Math.imul(Le, kt), w = w + Math.imul(mt, ke) | 0, A = Math.imul(mt, kt), E = E + Math.imul(me, L) | 0, w = w + Math.imul(me, $) | 0, w = w + Math.imul(_t, L) | 0, A = A + Math.imul(_t, $) | 0, E = E + Math.imul(_e, P) | 0, w = w + Math.imul(_e, H) | 0, w = w + Math.imul(lt, P) | 0, A = A + Math.imul(lt, H) | 0, E = E + Math.imul(Ae, Q) | 0, w = w + Math.imul(Ae, re) | 0, w = w + Math.imul(ct, Q) | 0, A = A + Math.imul(ct, re) | 0;
      var Be = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, E = Math.imul(Le, L), w = Math.imul(Le, $), w = w + Math.imul(mt, L) | 0, A = Math.imul(mt, $), E = E + Math.imul(me, P) | 0, w = w + Math.imul(me, H) | 0, w = w + Math.imul(_t, P) | 0, A = A + Math.imul(_t, H) | 0, E = E + Math.imul(_e, Q) | 0, w = w + Math.imul(_e, re) | 0, w = w + Math.imul(lt, Q) | 0, A = A + Math.imul(lt, re) | 0;
      var Te = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, E = Math.imul(Le, P), w = Math.imul(Le, H), w = w + Math.imul(mt, P) | 0, A = Math.imul(mt, H), E = E + Math.imul(me, Q) | 0, w = w + Math.imul(me, re) | 0, w = w + Math.imul(_t, Q) | 0, A = A + Math.imul(_t, re) | 0;
      var ne = (S + E | 0) + ((w & 8191) << 13) | 0;
      S = (A + (w >>> 13) | 0) + (ne >>> 26) | 0, ne &= 67108863, E = Math.imul(Le, Q), w = Math.imul(Le, re), w = w + Math.imul(mt, Q) | 0, A = Math.imul(mt, re);
      var oe = (S + E | 0) + ((w & 8191) << 13) | 0;
      return S = (A + (w >>> 13) | 0) + (oe >>> 26) | 0, oe &= 67108863, v[0] = ae, v[1] = te, v[2] = ge, v[3] = pe, v[4] = Ie, v[5] = we, v[6] = Ue, v[7] = Ye, v[8] = Qe, v[9] = Ge, v[10] = Je, v[11] = Re, v[12] = $e, v[13] = Se, v[14] = xe, v[15] = Be, v[16] = Te, v[17] = ne, v[18] = oe, S !== 0 && (v[19] = S, p.length++), p;
    };
    Math.imul || (i = n);
    function y(F, k, T) {
      T.negative = k.negative ^ F.negative, T.length = F.length + k.length;
      for (var p = 0, b = 0, _ = 0; _ < T.length - 1; _++) {
        var v = b;
        b = 0;
        for (var S = p & 67108863, E = Math.min(_, k.length - 1), w = Math.max(0, _ - F.length + 1); w <= E; w++) {
          var A = _ - w, I = F.words[A] | 0, C = k.words[w] | 0, X = I * C, D = X & 67108863;
          v = v + (X / 67108864 | 0) | 0, D = D + S | 0, S = D & 67108863, v = v + (D >>> 26) | 0, b += v >>> 26, v &= 67108863;
        }
        T.words[_] = S, p = v, v = b;
      }
      return p !== 0 ? T.words[_] = p : T.length--, T.strip();
    }
    function m(F, k, T) {
      var p = new U();
      return p.mulp(F, k, T);
    }
    h.prototype.mulTo = function(k, T) {
      var p, b = this.length + k.length;
      return this.length === 10 && k.length === 10 ? p = i(this, k, T) : b < 63 ? p = n(this, k, T) : b < 1024 ? p = y(this, k, T) : p = m(this, k, T), p;
    };
    function U(F, k) {
      this.x = F, this.y = k;
    }
    U.prototype.makeRBT = function(k) {
      for (var T = new Array(k), p = h.prototype._countBits(k) - 1, b = 0; b < k; b++)
        T[b] = this.revBin(b, p, k);
      return T;
    }, U.prototype.revBin = function(k, T, p) {
      if (k === 0 || k === p - 1)
        return k;
      for (var b = 0, _ = 0; _ < T; _++)
        b |= (k & 1) << T - _ - 1, k >>= 1;
      return b;
    }, U.prototype.permute = function(k, T, p, b, _, v) {
      for (var S = 0; S < v; S++)
        b[S] = T[k[S]], _[S] = p[k[S]];
    }, U.prototype.transform = function(k, T, p, b, _, v) {
      this.permute(v, k, T, p, b, _);
      for (var S = 1; S < _; S <<= 1)
        for (var E = S << 1, w = Math.cos(2 * Math.PI / E), A = Math.sin(2 * Math.PI / E), I = 0; I < _; I += E)
          for (var C = w, X = A, D = 0; D < S; D++) {
            var V = p[I + D], Z = b[I + D], J = p[I + D + S], ee = b[I + D + S], he = C * J - X * ee;
            ee = C * ee + X * J, J = he, p[I + D] = V + J, b[I + D] = Z + ee, p[I + D + S] = V - J, b[I + D + S] = Z - ee, D !== E && (he = w * C - A * X, X = w * X + A * C, C = he);
          }
    }, U.prototype.guessLen13b = function(k, T) {
      var p = Math.max(T, k) | 1, b = p & 1, _ = 0;
      for (p = p / 2 | 0; p; p = p >>> 1)
        _++;
      return 1 << _ + 1 + b;
    }, U.prototype.conjugate = function(k, T, p) {
      if (!(p <= 1))
        for (var b = 0; b < p / 2; b++) {
          var _ = k[b];
          k[b] = k[p - b - 1], k[p - b - 1] = _, _ = T[b], T[b] = -T[p - b - 1], T[p - b - 1] = -_;
        }
    }, U.prototype.normalize13b = function(k, T) {
      for (var p = 0, b = 0; b < T / 2; b++) {
        var _ = Math.round(k[2 * b + 1] / T) * 8192 + Math.round(k[2 * b] / T) + p;
        k[b] = _ & 67108863, _ < 67108864 ? p = 0 : p = _ / 67108864 | 0;
      }
      return k;
    }, U.prototype.convert13b = function(k, T, p, b) {
      for (var _ = 0, v = 0; v < T; v++)
        _ = _ + (k[v] | 0), p[2 * v] = _ & 8191, _ = _ >>> 13, p[2 * v + 1] = _ & 8191, _ = _ >>> 13;
      for (v = 2 * T; v < b; ++v)
        p[v] = 0;
      d(_ === 0), d((_ & -8192) === 0);
    }, U.prototype.stub = function(k) {
      for (var T = new Array(k), p = 0; p < k; p++)
        T[p] = 0;
      return T;
    }, U.prototype.mulp = function(k, T, p) {
      var b = 2 * this.guessLen13b(k.length, T.length), _ = this.makeRBT(b), v = this.stub(b), S = new Array(b), E = new Array(b), w = new Array(b), A = new Array(b), I = new Array(b), C = new Array(b), X = p.words;
      X.length = b, this.convert13b(k.words, k.length, S, b), this.convert13b(T.words, T.length, A, b), this.transform(S, v, E, w, b, _), this.transform(A, v, I, C, b, _);
      for (var D = 0; D < b; D++) {
        var V = E[D] * I[D] - w[D] * C[D];
        w[D] = E[D] * C[D] + w[D] * I[D], E[D] = V;
      }
      return this.conjugate(E, w, b), this.transform(E, w, X, v, b, _), this.conjugate(X, v, b), this.normalize13b(X, b), p.negative = k.negative ^ T.negative, p.length = k.length + T.length, p.strip();
    }, h.prototype.mul = function(k) {
      var T = new h(null);
      return T.words = new Array(this.length + k.length), this.mulTo(k, T);
    }, h.prototype.mulf = function(k) {
      var T = new h(null);
      return T.words = new Array(this.length + k.length), m(this, k, T);
    }, h.prototype.imul = function(k) {
      return this.clone().mulTo(k, this);
    }, h.prototype.imuln = function(k) {
      d(typeof k == "number"), d(k < 67108864);
      for (var T = 0, p = 0; p < this.length; p++) {
        var b = (this.words[p] | 0) * k, _ = (b & 67108863) + (T & 67108863);
        T >>= 26, T += b / 67108864 | 0, T += _ >>> 26, this.words[p] = _ & 67108863;
      }
      return T !== 0 && (this.words[p] = T, this.length++), this;
    }, h.prototype.muln = function(k) {
      return this.clone().imuln(k);
    }, h.prototype.sqr = function() {
      return this.mul(this);
    }, h.prototype.isqr = function() {
      return this.imul(this.clone());
    }, h.prototype.pow = function(k) {
      var T = e(k);
      if (T.length === 0)
        return new h(1);
      for (var p = this, b = 0; b < T.length && T[b] === 0; b++, p = p.sqr())
        ;
      if (++b < T.length)
        for (var _ = p.sqr(); b < T.length; b++, _ = _.sqr())
          T[b] !== 0 && (p = p.mul(_));
      return p;
    }, h.prototype.iushln = function(k) {
      d(typeof k == "number" && k >= 0);
      var T = k % 26, p = (k - T) / 26, b = 67108863 >>> 26 - T << 26 - T, _;
      if (T !== 0) {
        var v = 0;
        for (_ = 0; _ < this.length; _++) {
          var S = this.words[_] & b, E = (this.words[_] | 0) - S << T;
          this.words[_] = E | v, v = S >>> 26 - T;
        }
        v && (this.words[_] = v, this.length++);
      }
      if (p !== 0) {
        for (_ = this.length - 1; _ >= 0; _--)
          this.words[_ + p] = this.words[_];
        for (_ = 0; _ < p; _++)
          this.words[_] = 0;
        this.length += p;
      }
      return this.strip();
    }, h.prototype.ishln = function(k) {
      return d(this.negative === 0), this.iushln(k);
    }, h.prototype.iushrn = function(k, T, p) {
      d(typeof k == "number" && k >= 0);
      var b;
      T ? b = (T - T % 26) / 26 : b = 0;
      var _ = k % 26, v = Math.min((k - _) / 26, this.length), S = 67108863 ^ 67108863 >>> _ << _, E = p;
      if (b -= v, b = Math.max(0, b), E) {
        for (var w = 0; w < v; w++)
          E.words[w] = this.words[w];
        E.length = v;
      }
      if (v !== 0)
        if (this.length > v)
          for (this.length -= v, w = 0; w < this.length; w++)
            this.words[w] = this.words[w + v];
        else
          this.words[0] = 0, this.length = 1;
      var A = 0;
      for (w = this.length - 1; w >= 0 && (A !== 0 || w >= b); w--) {
        var I = this.words[w] | 0;
        this.words[w] = A << 26 - _ | I >>> _, A = I & S;
      }
      return E && A !== 0 && (E.words[E.length++] = A), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
    }, h.prototype.ishrn = function(k, T, p) {
      return d(this.negative === 0), this.iushrn(k, T, p);
    }, h.prototype.shln = function(k) {
      return this.clone().ishln(k);
    }, h.prototype.ushln = function(k) {
      return this.clone().iushln(k);
    }, h.prototype.shrn = function(k) {
      return this.clone().ishrn(k);
    }, h.prototype.ushrn = function(k) {
      return this.clone().iushrn(k);
    }, h.prototype.testn = function(k) {
      d(typeof k == "number" && k >= 0);
      var T = k % 26, p = (k - T) / 26, b = 1 << T;
      if (this.length <= p)
        return !1;
      var _ = this.words[p];
      return !!(_ & b);
    }, h.prototype.imaskn = function(k) {
      d(typeof k == "number" && k >= 0);
      var T = k % 26, p = (k - T) / 26;
      if (d(this.negative === 0, "imaskn works only with positive numbers"), this.length <= p)
        return this;
      if (T !== 0 && p++, this.length = Math.min(p, this.length), T !== 0) {
        var b = 67108863 ^ 67108863 >>> T << T;
        this.words[this.length - 1] &= b;
      }
      return this.strip();
    }, h.prototype.maskn = function(k) {
      return this.clone().imaskn(k);
    }, h.prototype.iaddn = function(k) {
      return d(typeof k == "number"), d(k < 67108864), k < 0 ? this.isubn(-k) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < k ? (this.words[0] = k - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(k), this.negative = 1, this) : this._iaddn(k);
    }, h.prototype._iaddn = function(k) {
      this.words[0] += k;
      for (var T = 0; T < this.length && this.words[T] >= 67108864; T++)
        this.words[T] -= 67108864, T === this.length - 1 ? this.words[T + 1] = 1 : this.words[T + 1]++;
      return this.length = Math.max(this.length, T + 1), this;
    }, h.prototype.isubn = function(k) {
      if (d(typeof k == "number"), d(k < 67108864), k < 0)
        return this.iaddn(-k);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(k), this.negative = 1, this;
      if (this.words[0] -= k, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var T = 0; T < this.length && this.words[T] < 0; T++)
          this.words[T] += 67108864, this.words[T + 1] -= 1;
      return this.strip();
    }, h.prototype.addn = function(k) {
      return this.clone().iaddn(k);
    }, h.prototype.subn = function(k) {
      return this.clone().isubn(k);
    }, h.prototype.iabs = function() {
      return this.negative = 0, this;
    }, h.prototype.abs = function() {
      return this.clone().iabs();
    }, h.prototype._ishlnsubmul = function(k, T, p) {
      var b = k.length + p, _;
      this._expand(b);
      var v, S = 0;
      for (_ = 0; _ < k.length; _++) {
        v = (this.words[_ + p] | 0) + S;
        var E = (k.words[_] | 0) * T;
        v -= E & 67108863, S = (v >> 26) - (E / 67108864 | 0), this.words[_ + p] = v & 67108863;
      }
      for (; _ < this.length - p; _++)
        v = (this.words[_ + p] | 0) + S, S = v >> 26, this.words[_ + p] = v & 67108863;
      if (S === 0)
        return this.strip();
      for (d(S === -1), S = 0, _ = 0; _ < this.length; _++)
        v = -(this.words[_] | 0) + S, S = v >> 26, this.words[_] = v & 67108863;
      return this.negative = 1, this.strip();
    }, h.prototype._wordDiv = function(k, T) {
      var p = this.length - k.length, b = this.clone(), _ = k, v = _.words[_.length - 1] | 0, S = this._countBits(v);
      p = 26 - S, p !== 0 && (_ = _.ushln(p), b.iushln(p), v = _.words[_.length - 1] | 0);
      var E = b.length - _.length, w;
      if (T !== "mod") {
        w = new h(null), w.length = E + 1, w.words = new Array(w.length);
        for (var A = 0; A < w.length; A++)
          w.words[A] = 0;
      }
      var I = b.clone()._ishlnsubmul(_, 1, E);
      I.negative === 0 && (b = I, w && (w.words[E] = 1));
      for (var C = E - 1; C >= 0; C--) {
        var X = (b.words[_.length + C] | 0) * 67108864 + (b.words[_.length + C - 1] | 0);
        for (X = Math.min(X / v | 0, 67108863), b._ishlnsubmul(_, X, C); b.negative !== 0; )
          X--, b.negative = 0, b._ishlnsubmul(_, 1, C), b.isZero() || (b.negative ^= 1);
        w && (w.words[C] = X);
      }
      return w && w.strip(), b.strip(), T !== "div" && p !== 0 && b.iushrn(p), {
        div: w || null,
        mod: b
      };
    }, h.prototype.divmod = function(k, T, p) {
      if (d(!k.isZero()), this.isZero())
        return {
          div: new h(0),
          mod: new h(0)
        };
      var b, _, v;
      return this.negative !== 0 && k.negative === 0 ? (v = this.neg().divmod(k, T), T !== "mod" && (b = v.div.neg()), T !== "div" && (_ = v.mod.neg(), p && _.negative !== 0 && _.iadd(k)), {
        div: b,
        mod: _
      }) : this.negative === 0 && k.negative !== 0 ? (v = this.divmod(k.neg(), T), T !== "mod" && (b = v.div.neg()), {
        div: b,
        mod: v.mod
      }) : (this.negative & k.negative) !== 0 ? (v = this.neg().divmod(k.neg(), T), T !== "div" && (_ = v.mod.neg(), p && _.negative !== 0 && _.isub(k)), {
        div: v.div,
        mod: _
      }) : k.length > this.length || this.cmp(k) < 0 ? {
        div: new h(0),
        mod: this
      } : k.length === 1 ? T === "div" ? {
        div: this.divn(k.words[0]),
        mod: null
      } : T === "mod" ? {
        div: null,
        mod: new h(this.modn(k.words[0]))
      } : {
        div: this.divn(k.words[0]),
        mod: new h(this.modn(k.words[0]))
      } : this._wordDiv(k, T);
    }, h.prototype.div = function(k) {
      return this.divmod(k, "div", !1).div;
    }, h.prototype.mod = function(k) {
      return this.divmod(k, "mod", !1).mod;
    }, h.prototype.umod = function(k) {
      return this.divmod(k, "mod", !0).mod;
    }, h.prototype.divRound = function(k) {
      var T = this.divmod(k);
      if (T.mod.isZero())
        return T.div;
      var p = T.div.negative !== 0 ? T.mod.isub(k) : T.mod, b = k.ushrn(1), _ = k.andln(1), v = p.cmp(b);
      return v < 0 || _ === 1 && v === 0 ? T.div : T.div.negative !== 0 ? T.div.isubn(1) : T.div.iaddn(1);
    }, h.prototype.modn = function(k) {
      d(k <= 67108863);
      for (var T = (1 << 26) % k, p = 0, b = this.length - 1; b >= 0; b--)
        p = (T * p + (this.words[b] | 0)) % k;
      return p;
    }, h.prototype.idivn = function(k) {
      d(k <= 67108863);
      for (var T = 0, p = this.length - 1; p >= 0; p--) {
        var b = (this.words[p] | 0) + T * 67108864;
        this.words[p] = b / k | 0, T = b % k;
      }
      return this.strip();
    }, h.prototype.divn = function(k) {
      return this.clone().idivn(k);
    }, h.prototype.egcd = function(k) {
      d(k.negative === 0), d(!k.isZero());
      var T = this, p = k.clone();
      T.negative !== 0 ? T = T.umod(k) : T = T.clone();
      for (var b = new h(1), _ = new h(0), v = new h(0), S = new h(1), E = 0; T.isEven() && p.isEven(); )
        T.iushrn(1), p.iushrn(1), ++E;
      for (var w = p.clone(), A = T.clone(); !T.isZero(); ) {
        for (var I = 0, C = 1; (T.words[0] & C) === 0 && I < 26; ++I, C <<= 1)
          ;
        if (I > 0)
          for (T.iushrn(I); I-- > 0; )
            (b.isOdd() || _.isOdd()) && (b.iadd(w), _.isub(A)), b.iushrn(1), _.iushrn(1);
        for (var X = 0, D = 1; (p.words[0] & D) === 0 && X < 26; ++X, D <<= 1)
          ;
        if (X > 0)
          for (p.iushrn(X); X-- > 0; )
            (v.isOdd() || S.isOdd()) && (v.iadd(w), S.isub(A)), v.iushrn(1), S.iushrn(1);
        T.cmp(p) >= 0 ? (T.isub(p), b.isub(v), _.isub(S)) : (p.isub(T), v.isub(b), S.isub(_));
      }
      return {
        a: v,
        b: S,
        gcd: p.iushln(E)
      };
    }, h.prototype._invmp = function(k) {
      d(k.negative === 0), d(!k.isZero());
      var T = this, p = k.clone();
      T.negative !== 0 ? T = T.umod(k) : T = T.clone();
      for (var b = new h(1), _ = new h(0), v = p.clone(); T.cmpn(1) > 0 && p.cmpn(1) > 0; ) {
        for (var S = 0, E = 1; (T.words[0] & E) === 0 && S < 26; ++S, E <<= 1)
          ;
        if (S > 0)
          for (T.iushrn(S); S-- > 0; )
            b.isOdd() && b.iadd(v), b.iushrn(1);
        for (var w = 0, A = 1; (p.words[0] & A) === 0 && w < 26; ++w, A <<= 1)
          ;
        if (w > 0)
          for (p.iushrn(w); w-- > 0; )
            _.isOdd() && _.iadd(v), _.iushrn(1);
        T.cmp(p) >= 0 ? (T.isub(p), b.isub(_)) : (p.isub(T), _.isub(b));
      }
      var I;
      return T.cmpn(1) === 0 ? I = b : I = _, I.cmpn(0) < 0 && I.iadd(k), I;
    }, h.prototype.gcd = function(k) {
      if (this.isZero())
        return k.abs();
      if (k.isZero())
        return this.abs();
      var T = this.clone(), p = k.clone();
      T.negative = 0, p.negative = 0;
      for (var b = 0; T.isEven() && p.isEven(); b++)
        T.iushrn(1), p.iushrn(1);
      do {
        for (; T.isEven(); )
          T.iushrn(1);
        for (; p.isEven(); )
          p.iushrn(1);
        var _ = T.cmp(p);
        if (_ < 0) {
          var v = T;
          T = p, p = v;
        } else if (_ === 0 || p.cmpn(1) === 0)
          break;
        T.isub(p);
      } while (!0);
      return p.iushln(b);
    }, h.prototype.invm = function(k) {
      return this.egcd(k).a.umod(k);
    }, h.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, h.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, h.prototype.andln = function(k) {
      return this.words[0] & k;
    }, h.prototype.bincn = function(k) {
      d(typeof k == "number");
      var T = k % 26, p = (k - T) / 26, b = 1 << T;
      if (this.length <= p)
        return this._expand(p + 1), this.words[p] |= b, this;
      for (var _ = b, v = p; _ !== 0 && v < this.length; v++) {
        var S = this.words[v] | 0;
        S += _, _ = S >>> 26, S &= 67108863, this.words[v] = S;
      }
      return _ !== 0 && (this.words[v] = _, this.length++), this;
    }, h.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, h.prototype.cmpn = function(k) {
      var T = k < 0;
      if (this.negative !== 0 && !T)
        return -1;
      if (this.negative === 0 && T)
        return 1;
      this.strip();
      var p;
      if (this.length > 1)
        p = 1;
      else {
        T && (k = -k), d(k <= 67108863, "Number is too big");
        var b = this.words[0] | 0;
        p = b === k ? 0 : b < k ? -1 : 1;
      }
      return this.negative !== 0 ? -p | 0 : p;
    }, h.prototype.cmp = function(k) {
      if (this.negative !== 0 && k.negative === 0)
        return -1;
      if (this.negative === 0 && k.negative !== 0)
        return 1;
      var T = this.ucmp(k);
      return this.negative !== 0 ? -T | 0 : T;
    }, h.prototype.ucmp = function(k) {
      if (this.length > k.length)
        return 1;
      if (this.length < k.length)
        return -1;
      for (var T = 0, p = this.length - 1; p >= 0; p--) {
        var b = this.words[p] | 0, _ = k.words[p] | 0;
        if (b !== _) {
          b < _ ? T = -1 : b > _ && (T = 1);
          break;
        }
      }
      return T;
    }, h.prototype.gtn = function(k) {
      return this.cmpn(k) === 1;
    }, h.prototype.gt = function(k) {
      return this.cmp(k) === 1;
    }, h.prototype.gten = function(k) {
      return this.cmpn(k) >= 0;
    }, h.prototype.gte = function(k) {
      return this.cmp(k) >= 0;
    }, h.prototype.ltn = function(k) {
      return this.cmpn(k) === -1;
    }, h.prototype.lt = function(k) {
      return this.cmp(k) === -1;
    }, h.prototype.lten = function(k) {
      return this.cmpn(k) <= 0;
    }, h.prototype.lte = function(k) {
      return this.cmp(k) <= 0;
    }, h.prototype.eqn = function(k) {
      return this.cmpn(k) === 0;
    }, h.prototype.eq = function(k) {
      return this.cmp(k) === 0;
    }, h.red = function(k) {
      return new z(k);
    }, h.prototype.toRed = function(k) {
      return d(!this.red, "Already a number in reduction context"), d(this.negative === 0, "red works only with positives"), k.convertTo(this)._forceRed(k);
    }, h.prototype.fromRed = function() {
      return d(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, h.prototype._forceRed = function(k) {
      return this.red = k, this;
    }, h.prototype.forceRed = function(k) {
      return d(!this.red, "Already a number in reduction context"), this._forceRed(k);
    }, h.prototype.redAdd = function(k) {
      return d(this.red, "redAdd works only with red numbers"), this.red.add(this, k);
    }, h.prototype.redIAdd = function(k) {
      return d(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, k);
    }, h.prototype.redSub = function(k) {
      return d(this.red, "redSub works only with red numbers"), this.red.sub(this, k);
    }, h.prototype.redISub = function(k) {
      return d(this.red, "redISub works only with red numbers"), this.red.isub(this, k);
    }, h.prototype.redShl = function(k) {
      return d(this.red, "redShl works only with red numbers"), this.red.shl(this, k);
    }, h.prototype.redMul = function(k) {
      return d(this.red, "redMul works only with red numbers"), this.red._verify2(this, k), this.red.mul(this, k);
    }, h.prototype.redIMul = function(k) {
      return d(this.red, "redMul works only with red numbers"), this.red._verify2(this, k), this.red.imul(this, k);
    }, h.prototype.redSqr = function() {
      return d(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, h.prototype.redISqr = function() {
      return d(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, h.prototype.redSqrt = function() {
      return d(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, h.prototype.redInvm = function() {
      return d(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, h.prototype.redNeg = function() {
      return d(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, h.prototype.redPow = function(k) {
      return d(this.red && !k.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, k);
    };
    var be = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Ke(F, k) {
      this.name = F, this.p = new h(k, 16), this.n = this.p.bitLength(), this.k = new h(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Ke.prototype._tmp = function() {
      var k = new h(null);
      return k.words = new Array(Math.ceil(this.n / 13)), k;
    }, Ke.prototype.ireduce = function(k) {
      var T = k, p;
      do
        this.split(T, this.tmp), T = this.imulK(T), T = T.iadd(this.tmp), p = T.bitLength();
      while (p > this.n);
      var b = p < this.n ? -1 : T.ucmp(this.p);
      return b === 0 ? (T.words[0] = 0, T.length = 1) : b > 0 ? T.isub(this.p) : T.strip !== void 0 ? T.strip() : T._strip(), T;
    }, Ke.prototype.split = function(k, T) {
      k.iushrn(this.n, 0, T);
    }, Ke.prototype.imulK = function(k) {
      return k.imul(this.k);
    };
    function ze() {
      Ke.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    l(ze, Ke), ze.prototype.split = function(k, T) {
      for (var p = 4194303, b = Math.min(k.length, 9), _ = 0; _ < b; _++)
        T.words[_] = k.words[_];
      if (T.length = b, k.length <= 9) {
        k.words[0] = 0, k.length = 1;
        return;
      }
      var v = k.words[9];
      for (T.words[T.length++] = v & p, _ = 10; _ < k.length; _++) {
        var S = k.words[_] | 0;
        k.words[_ - 10] = (S & p) << 4 | v >>> 22, v = S;
      }
      v >>>= 22, k.words[_ - 10] = v, v === 0 && k.length > 10 ? k.length -= 10 : k.length -= 9;
    }, ze.prototype.imulK = function(k) {
      k.words[k.length] = 0, k.words[k.length + 1] = 0, k.length += 2;
      for (var T = 0, p = 0; p < k.length; p++) {
        var b = k.words[p] | 0;
        T += b * 977, k.words[p] = T & 67108863, T = b * 64 + (T / 67108864 | 0);
      }
      return k.words[k.length - 1] === 0 && (k.length--, k.words[k.length - 1] === 0 && k.length--), k;
    };
    function Pe() {
      Ke.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    l(Pe, Ke);
    function st() {
      Ke.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    l(st, Ke);
    function G() {
      Ke.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    l(G, Ke), G.prototype.imulK = function(k) {
      for (var T = 0, p = 0; p < k.length; p++) {
        var b = (k.words[p] | 0) * 19 + T, _ = b & 67108863;
        b >>>= 26, k.words[p] = _, T = b;
      }
      return T !== 0 && (k.words[k.length++] = T), k;
    }, h._prime = function(k) {
      if (be[k])
        return be[k];
      var T;
      if (k === "k256")
        T = new ze();
      else if (k === "p224")
        T = new Pe();
      else if (k === "p192")
        T = new st();
      else if (k === "p25519")
        T = new G();
      else
        throw new Error("Unknown prime " + k);
      return be[k] = T, T;
    };
    function z(F) {
      if (typeof F == "string") {
        var k = h._prime(F);
        this.m = k.p, this.prime = k;
      } else
        d(F.gtn(1), "modulus must be greater than 1"), this.m = F, this.prime = null;
    }
    z.prototype._verify1 = function(k) {
      d(k.negative === 0, "red works only with positives"), d(k.red, "red works only with red numbers");
    }, z.prototype._verify2 = function(k, T) {
      d((k.negative | T.negative) === 0, "red works only with positives"), d(
        k.red && k.red === T.red,
        "red works only with red numbers"
      );
    }, z.prototype.imod = function(k) {
      return this.prime ? this.prime.ireduce(k)._forceRed(this) : k.umod(this.m)._forceRed(this);
    }, z.prototype.neg = function(k) {
      return k.isZero() ? k.clone() : this.m.sub(k)._forceRed(this);
    }, z.prototype.add = function(k, T) {
      this._verify2(k, T);
      var p = k.add(T);
      return p.cmp(this.m) >= 0 && p.isub(this.m), p._forceRed(this);
    }, z.prototype.iadd = function(k, T) {
      this._verify2(k, T);
      var p = k.iadd(T);
      return p.cmp(this.m) >= 0 && p.isub(this.m), p;
    }, z.prototype.sub = function(k, T) {
      this._verify2(k, T);
      var p = k.sub(T);
      return p.cmpn(0) < 0 && p.iadd(this.m), p._forceRed(this);
    }, z.prototype.isub = function(k, T) {
      this._verify2(k, T);
      var p = k.isub(T);
      return p.cmpn(0) < 0 && p.iadd(this.m), p;
    }, z.prototype.shl = function(k, T) {
      return this._verify1(k), this.imod(k.ushln(T));
    }, z.prototype.imul = function(k, T) {
      return this._verify2(k, T), this.imod(k.imul(T));
    }, z.prototype.mul = function(k, T) {
      return this._verify2(k, T), this.imod(k.mul(T));
    }, z.prototype.isqr = function(k) {
      return this.imul(k, k.clone());
    }, z.prototype.sqr = function(k) {
      return this.mul(k, k);
    }, z.prototype.sqrt = function(k) {
      if (k.isZero())
        return k.clone();
      var T = this.m.andln(3);
      if (d(T % 2 === 1), T === 3) {
        var p = this.m.add(new h(1)).iushrn(2);
        return this.pow(k, p);
      }
      for (var b = this.m.subn(1), _ = 0; !b.isZero() && b.andln(1) === 0; )
        _++, b.iushrn(1);
      d(!b.isZero());
      var v = new h(1).toRed(this), S = v.redNeg(), E = this.m.subn(1).iushrn(1), w = this.m.bitLength();
      for (w = new h(2 * w * w).toRed(this); this.pow(w, E).cmp(S) !== 0; )
        w.redIAdd(S);
      for (var A = this.pow(w, b), I = this.pow(k, b.addn(1).iushrn(1)), C = this.pow(k, b), X = _; C.cmp(v) !== 0; ) {
        for (var D = C, V = 0; D.cmp(v) !== 0; V++)
          D = D.redSqr();
        d(V < X);
        var Z = this.pow(A, new h(1).iushln(X - V - 1));
        I = I.redMul(Z), A = Z.redSqr(), C = C.redMul(A), X = V;
      }
      return I;
    }, z.prototype.invm = function(k) {
      var T = k._invmp(this.m);
      return T.negative !== 0 ? (T.negative = 0, this.imod(T).redNeg()) : this.imod(T);
    }, z.prototype.pow = function(k, T) {
      if (T.isZero())
        return new h(1).toRed(this);
      if (T.cmpn(1) === 0)
        return k.clone();
      var p = 4, b = new Array(1 << p);
      b[0] = new h(1).toRed(this), b[1] = k;
      for (var _ = 2; _ < b.length; _++)
        b[_] = this.mul(b[_ - 1], k);
      var v = b[0], S = 0, E = 0, w = T.bitLength() % 26;
      for (w === 0 && (w = 26), _ = T.length - 1; _ >= 0; _--) {
        for (var A = T.words[_], I = w - 1; I >= 0; I--) {
          var C = A >> I & 1;
          if (v !== b[0] && (v = this.sqr(v)), C === 0 && S === 0) {
            E = 0;
            continue;
          }
          S <<= 1, S |= C, E++, !(E !== p && (_ !== 0 || I !== 0)) && (v = this.mul(v, b[S]), E = 0, S = 0);
        }
        w = 26;
      }
      return v;
    }, z.prototype.convertTo = function(k) {
      var T = k.umod(this.m);
      return T === k ? T.clone() : T;
    }, z.prototype.convertFrom = function(k) {
      var T = k.clone();
      return T.red = null, T;
    }, h.mont = function(k) {
      return new W(k);
    };
    function W(F) {
      z.call(this, F), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new h(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    l(W, z), W.prototype.convertTo = function(k) {
      return this.imod(k.ushln(this.shift));
    }, W.prototype.convertFrom = function(k) {
      var T = this.imod(k.mul(this.rinv));
      return T.red = null, T;
    }, W.prototype.imul = function(k, T) {
      if (k.isZero() || T.isZero())
        return k.words[0] = 0, k.length = 1, k;
      var p = k.imul(T), b = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = p.isub(b).iushrn(this.shift), v = _;
      return _.cmp(this.m) >= 0 ? v = _.isub(this.m) : _.cmpn(0) < 0 && (v = _.iadd(this.m)), v._forceRed(this);
    }, W.prototype.mul = function(k, T) {
      if (k.isZero() || T.isZero())
        return new h(0)._forceRed(this);
      var p = k.mul(T), b = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = p.isub(b).iushrn(this.shift), v = _;
      return _.cmp(this.m) >= 0 ? v = _.isub(this.m) : _.cmpn(0) < 0 && (v = _.iadd(this.m)), v._forceRed(this);
    }, W.prototype.invm = function(k) {
      var T = this.imod(k._invmp(this.m).mul(this.r2));
      return T._forceRed(this);
    };
  })(u, commonjsGlobal);
})(bn$2);
var minimalisticAssert = assert$f;
function assert$f(u, t) {
  if (!u)
    throw new Error(t || "Assertion failed");
}
assert$f.equal = function(t, a, d) {
  if (t != a)
    throw new Error(d || "Assertion failed: " + t + " != " + a);
};
var utils$l = {};
(function(u) {
  var t = u;
  function a(h, g) {
    if (Array.isArray(h))
      return h.slice();
    if (!h)
      return [];
    var c = [];
    if (typeof h != "string") {
      for (var x = 0; x < h.length; x++)
        c[x] = h[x] | 0;
      return c;
    }
    if (g === "hex") {
      h = h.replace(/[^a-z0-9]+/ig, ""), h.length % 2 !== 0 && (h = "0" + h);
      for (var x = 0; x < h.length; x += 2)
        c.push(parseInt(h[x] + h[x + 1], 16));
    } else
      for (var x = 0; x < h.length; x++) {
        var R = h.charCodeAt(x), B = R >> 8, j = R & 255;
        B ? c.push(B, j) : c.push(j);
      }
    return c;
  }
  t.toArray = a;
  function d(h) {
    return h.length === 1 ? "0" + h : h;
  }
  t.zero2 = d;
  function l(h) {
    for (var g = "", c = 0; c < h.length; c++)
      g += d(h[c].toString(16));
    return g;
  }
  t.toHex = l, t.encode = function(g, c) {
    return c === "hex" ? l(g) : g;
  };
})(utils$l);
(function(u) {
  var t = u, a = bn$2.exports, d = minimalisticAssert, l = utils$l;
  t.assert = d, t.toArray = l.toArray, t.zero2 = l.zero2, t.toHex = l.toHex, t.encode = l.encode;
  function h(B, j, o) {
    var e = new Array(Math.max(B.bitLength(), o) + 1);
    e.fill(0);
    for (var n = 1 << j + 1, i = B.clone(), y = 0; y < e.length; y++) {
      var m, U = i.andln(n - 1);
      i.isOdd() ? (U > (n >> 1) - 1 ? m = (n >> 1) - U : m = U, i.isubn(m)) : m = 0, e[y] = m, i.iushrn(1);
    }
    return e;
  }
  t.getNAF = h;
  function g(B, j) {
    var o = [
      [],
      []
    ];
    B = B.clone(), j = j.clone();
    for (var e = 0, n = 0, i; B.cmpn(-e) > 0 || j.cmpn(-n) > 0; ) {
      var y = B.andln(3) + e & 3, m = j.andln(3) + n & 3;
      y === 3 && (y = -1), m === 3 && (m = -1);
      var U;
      (y & 1) === 0 ? U = 0 : (i = B.andln(7) + e & 7, (i === 3 || i === 5) && m === 2 ? U = -y : U = y), o[0].push(U);
      var be;
      (m & 1) === 0 ? be = 0 : (i = j.andln(7) + n & 7, (i === 3 || i === 5) && y === 2 ? be = -m : be = m), o[1].push(be), 2 * e === U + 1 && (e = 1 - e), 2 * n === be + 1 && (n = 1 - n), B.iushrn(1), j.iushrn(1);
    }
    return o;
  }
  t.getJSF = g;
  function c(B, j, o) {
    var e = "_" + j;
    B.prototype[j] = function() {
      return this[e] !== void 0 ? this[e] : this[e] = o.call(this);
    };
  }
  t.cachedProperty = c;
  function x(B) {
    return typeof B == "string" ? t.toArray(B, "hex") : B;
  }
  t.parseBytes = x;
  function R(B) {
    return new a(B, "hex", "le");
  }
  t.intFromLE = R;
})(utils$m);
var brorand = { exports: {} }, r$1;
brorand.exports = function(t) {
  return r$1 || (r$1 = new Rand(null)), r$1.generate(t);
};
function Rand(u) {
  this.rand = u;
}
brorand.exports.Rand = Rand;
Rand.prototype.generate = function(t) {
  return this._rand(t);
};
Rand.prototype._rand = function(t) {
  if (this.rand.getBytes)
    return this.rand.getBytes(t);
  for (var a = new Uint8Array(t), d = 0; d < a.length; d++)
    a[d] = this.rand.getByte();
  return a;
};
if (typeof self == "object")
  self.crypto && self.crypto.getRandomValues ? Rand.prototype._rand = function(t) {
    var a = new Uint8Array(t);
    return self.crypto.getRandomValues(a), a;
  } : self.msCrypto && self.msCrypto.getRandomValues ? Rand.prototype._rand = function(t) {
    var a = new Uint8Array(t);
    return self.msCrypto.getRandomValues(a), a;
  } : typeof window == "object" && (Rand.prototype._rand = function() {
    throw new Error("Not implemented yet");
  });
else
  try {
    var crypto$1 = require$$0$1;
    if (typeof crypto$1.randomBytes != "function")
      throw new Error("Not supported");
    Rand.prototype._rand = function(t) {
      return crypto$1.randomBytes(t);
    };
  } catch {
  }
var curve = {}, BN$9 = bn$2.exports, utils$k = utils$m, getNAF = utils$k.getNAF, getJSF = utils$k.getJSF, assert$e = utils$k.assert;
function BaseCurve(u, t) {
  this.type = u, this.p = new BN$9(t.p, 16), this.red = t.prime ? BN$9.red(t.prime) : BN$9.mont(this.p), this.zero = new BN$9(0).toRed(this.red), this.one = new BN$9(1).toRed(this.red), this.two = new BN$9(2).toRed(this.red), this.n = t.n && new BN$9(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
  var a = this.n && this.p.div(this.n);
  !a || a.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
}
var base = BaseCurve;
BaseCurve.prototype.point = function() {
  throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function() {
  throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function(t, a) {
  assert$e(t.precomputed);
  var d = t._getDoubles(), l = getNAF(a, 1, this._bitLength), h = (1 << d.step + 1) - (d.step % 2 === 0 ? 2 : 1);
  h /= 3;
  var g = [], c, x;
  for (c = 0; c < l.length; c += d.step) {
    x = 0;
    for (var R = c + d.step - 1; R >= c; R--)
      x = (x << 1) + l[R];
    g.push(x);
  }
  for (var B = this.jpoint(null, null, null), j = this.jpoint(null, null, null), o = h; o > 0; o--) {
    for (c = 0; c < g.length; c++)
      x = g[c], x === o ? j = j.mixedAdd(d.points[c]) : x === -o && (j = j.mixedAdd(d.points[c].neg()));
    B = B.add(j);
  }
  return B.toP();
};
BaseCurve.prototype._wnafMul = function(t, a) {
  var d = 4, l = t._getNAFPoints(d);
  d = l.wnd;
  for (var h = l.points, g = getNAF(a, d, this._bitLength), c = this.jpoint(null, null, null), x = g.length - 1; x >= 0; x--) {
    for (var R = 0; x >= 0 && g[x] === 0; x--)
      R++;
    if (x >= 0 && R++, c = c.dblp(R), x < 0)
      break;
    var B = g[x];
    assert$e(B !== 0), t.type === "affine" ? B > 0 ? c = c.mixedAdd(h[B - 1 >> 1]) : c = c.mixedAdd(h[-B - 1 >> 1].neg()) : B > 0 ? c = c.add(h[B - 1 >> 1]) : c = c.add(h[-B - 1 >> 1].neg());
  }
  return t.type === "affine" ? c.toP() : c;
};
BaseCurve.prototype._wnafMulAdd = function(t, a, d, l, h) {
  var g = this._wnafT1, c = this._wnafT2, x = this._wnafT3, R = 0, B, j, o;
  for (B = 0; B < l; B++) {
    o = a[B];
    var e = o._getNAFPoints(t);
    g[B] = e.wnd, c[B] = e.points;
  }
  for (B = l - 1; B >= 1; B -= 2) {
    var n = B - 1, i = B;
    if (g[n] !== 1 || g[i] !== 1) {
      x[n] = getNAF(d[n], g[n], this._bitLength), x[i] = getNAF(d[i], g[i], this._bitLength), R = Math.max(x[n].length, R), R = Math.max(x[i].length, R);
      continue;
    }
    var y = [
      a[n],
      null,
      null,
      a[i]
    ];
    a[n].y.cmp(a[i].y) === 0 ? (y[1] = a[n].add(a[i]), y[2] = a[n].toJ().mixedAdd(a[i].neg())) : a[n].y.cmp(a[i].y.redNeg()) === 0 ? (y[1] = a[n].toJ().mixedAdd(a[i]), y[2] = a[n].add(a[i].neg())) : (y[1] = a[n].toJ().mixedAdd(a[i]), y[2] = a[n].toJ().mixedAdd(a[i].neg()));
    var m = [
      -3,
      -1,
      -5,
      -7,
      0,
      7,
      5,
      1,
      3
    ], U = getJSF(d[n], d[i]);
    for (R = Math.max(U[0].length, R), x[n] = new Array(R), x[i] = new Array(R), j = 0; j < R; j++) {
      var be = U[0][j] | 0, Ke = U[1][j] | 0;
      x[n][j] = m[(be + 1) * 3 + (Ke + 1)], x[i][j] = 0, c[n] = y;
    }
  }
  var ze = this.jpoint(null, null, null), Pe = this._wnafT4;
  for (B = R; B >= 0; B--) {
    for (var st = 0; B >= 0; ) {
      var G = !0;
      for (j = 0; j < l; j++)
        Pe[j] = x[j][B] | 0, Pe[j] !== 0 && (G = !1);
      if (!G)
        break;
      st++, B--;
    }
    if (B >= 0 && st++, ze = ze.dblp(st), B < 0)
      break;
    for (j = 0; j < l; j++) {
      var z = Pe[j];
      z !== 0 && (z > 0 ? o = c[j][z - 1 >> 1] : z < 0 && (o = c[j][-z - 1 >> 1].neg()), o.type === "affine" ? ze = ze.mixedAdd(o) : ze = ze.add(o));
    }
  }
  for (B = 0; B < l; B++)
    c[B] = null;
  return h ? ze : ze.toP();
};
function BasePoint(u, t) {
  this.curve = u, this.type = t, this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function() {
  throw new Error("Not implemented");
};
BasePoint.prototype.validate = function() {
  return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function(t, a) {
  t = utils$k.toArray(t, a);
  var d = this.p.byteLength();
  if ((t[0] === 4 || t[0] === 6 || t[0] === 7) && t.length - 1 === 2 * d) {
    t[0] === 6 ? assert$e(t[t.length - 1] % 2 === 0) : t[0] === 7 && assert$e(t[t.length - 1] % 2 === 1);
    var l = this.point(
      t.slice(1, 1 + d),
      t.slice(1 + d, 1 + 2 * d)
    );
    return l;
  } else if ((t[0] === 2 || t[0] === 3) && t.length - 1 === d)
    return this.pointFromX(t.slice(1, 1 + d), t[0] === 3);
  throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function(t) {
  return this.encode(t, !0);
};
BasePoint.prototype._encode = function(t) {
  var a = this.curve.p.byteLength(), d = this.getX().toArray("be", a);
  return t ? [this.getY().isEven() ? 2 : 3].concat(d) : [4].concat(d, this.getY().toArray("be", a));
};
BasePoint.prototype.encode = function(t, a) {
  return utils$k.encode(this._encode(a), t);
};
BasePoint.prototype.precompute = function(t) {
  if (this.precomputed)
    return this;
  var a = {
    doubles: null,
    naf: null,
    beta: null
  };
  return a.naf = this._getNAFPoints(8), a.doubles = this._getDoubles(4, t), a.beta = this._getBeta(), this.precomputed = a, this;
};
BasePoint.prototype._hasDoubles = function(t) {
  if (!this.precomputed)
    return !1;
  var a = this.precomputed.doubles;
  return a ? a.points.length >= Math.ceil((t.bitLength() + 1) / a.step) : !1;
};
BasePoint.prototype._getDoubles = function(t, a) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;
  for (var d = [this], l = this, h = 0; h < a; h += t) {
    for (var g = 0; g < t; g++)
      l = l.dbl();
    d.push(l);
  }
  return {
    step: t,
    points: d
  };
};
BasePoint.prototype._getNAFPoints = function(t) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;
  for (var a = [this], d = (1 << t) - 1, l = d === 1 ? null : this.dbl(), h = 1; h < d; h++)
    a[h] = a[h - 1].add(l);
  return {
    wnd: t,
    points: a
  };
};
BasePoint.prototype._getBeta = function() {
  return null;
};
BasePoint.prototype.dblp = function(t) {
  for (var a = this, d = 0; d < t; d++)
    a = a.dbl();
  return a;
};
var inherits_browser = { exports: {} };
typeof Object.create == "function" ? inherits_browser.exports = function(t, a) {
  a && (t.super_ = a, t.prototype = Object.create(a.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : inherits_browser.exports = function(t, a) {
  if (a) {
    t.super_ = a;
    var d = function() {
    };
    d.prototype = a.prototype, t.prototype = new d(), t.prototype.constructor = t;
  }
};
var utils$j = utils$m, BN$8 = bn$2.exports, inherits$3 = inherits_browser.exports, Base$2 = base, assert$d = utils$j.assert;
function ShortCurve(u) {
  Base$2.call(this, "short", u), this.a = new BN$8(u.a, 16).toRed(this.red), this.b = new BN$8(u.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(u), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
}
inherits$3(ShortCurve, Base$2);
var short = ShortCurve;
ShortCurve.prototype._getEndomorphism = function(t) {
  if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
    var a, d;
    if (t.beta)
      a = new BN$8(t.beta, 16).toRed(this.red);
    else {
      var l = this._getEndoRoots(this.p);
      a = l[0].cmp(l[1]) < 0 ? l[0] : l[1], a = a.toRed(this.red);
    }
    if (t.lambda)
      d = new BN$8(t.lambda, 16);
    else {
      var h = this._getEndoRoots(this.n);
      this.g.mul(h[0]).x.cmp(this.g.x.redMul(a)) === 0 ? d = h[0] : (d = h[1], assert$d(this.g.mul(d).x.cmp(this.g.x.redMul(a)) === 0));
    }
    var g;
    return t.basis ? g = t.basis.map(function(c) {
      return {
        a: new BN$8(c.a, 16),
        b: new BN$8(c.b, 16)
      };
    }) : g = this._getEndoBasis(d), {
      beta: a,
      lambda: d,
      basis: g
    };
  }
};
ShortCurve.prototype._getEndoRoots = function(t) {
  var a = t === this.p ? this.red : BN$8.mont(t), d = new BN$8(2).toRed(a).redInvm(), l = d.redNeg(), h = new BN$8(3).toRed(a).redNeg().redSqrt().redMul(d), g = l.redAdd(h).fromRed(), c = l.redSub(h).fromRed();
  return [g, c];
};
ShortCurve.prototype._getEndoBasis = function(t) {
  for (var a = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), d = t, l = this.n.clone(), h = new BN$8(1), g = new BN$8(0), c = new BN$8(0), x = new BN$8(1), R, B, j, o, e, n, i, y = 0, m, U; d.cmpn(0) !== 0; ) {
    var be = l.div(d);
    m = l.sub(be.mul(d)), U = c.sub(be.mul(h));
    var Ke = x.sub(be.mul(g));
    if (!j && m.cmp(a) < 0)
      R = i.neg(), B = h, j = m.neg(), o = U;
    else if (j && ++y === 2)
      break;
    i = m, l = d, d = m, c = h, h = U, x = g, g = Ke;
  }
  e = m.neg(), n = U;
  var ze = j.sqr().add(o.sqr()), Pe = e.sqr().add(n.sqr());
  return Pe.cmp(ze) >= 0 && (e = R, n = B), j.negative && (j = j.neg(), o = o.neg()), e.negative && (e = e.neg(), n = n.neg()), [
    { a: j, b: o },
    { a: e, b: n }
  ];
};
ShortCurve.prototype._endoSplit = function(t) {
  var a = this.endo.basis, d = a[0], l = a[1], h = l.b.mul(t).divRound(this.n), g = d.b.neg().mul(t).divRound(this.n), c = h.mul(d.a), x = g.mul(l.a), R = h.mul(d.b), B = g.mul(l.b), j = t.sub(c).sub(x), o = R.add(B).neg();
  return { k1: j, k2: o };
};
ShortCurve.prototype.pointFromX = function(t, a) {
  t = new BN$8(t, 16), t.red || (t = t.toRed(this.red));
  var d = t.redSqr().redMul(t).redIAdd(t.redMul(this.a)).redIAdd(this.b), l = d.redSqrt();
  if (l.redSqr().redSub(d).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var h = l.fromRed().isOdd();
  return (a && !h || !a && h) && (l = l.redNeg()), this.point(t, l);
};
ShortCurve.prototype.validate = function(t) {
  if (t.inf)
    return !0;
  var a = t.x, d = t.y, l = this.a.redMul(a), h = a.redSqr().redMul(a).redIAdd(l).redIAdd(this.b);
  return d.redSqr().redISub(h).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function(t, a, d) {
  for (var l = this._endoWnafT1, h = this._endoWnafT2, g = 0; g < t.length; g++) {
    var c = this._endoSplit(a[g]), x = t[g], R = x._getBeta();
    c.k1.negative && (c.k1.ineg(), x = x.neg(!0)), c.k2.negative && (c.k2.ineg(), R = R.neg(!0)), l[g * 2] = x, l[g * 2 + 1] = R, h[g * 2] = c.k1, h[g * 2 + 1] = c.k2;
  }
  for (var B = this._wnafMulAdd(1, l, h, g * 2, d), j = 0; j < g * 2; j++)
    l[j] = null, h[j] = null;
  return B;
};
function Point$2(u, t, a, d) {
  Base$2.BasePoint.call(this, u, "affine"), t === null && a === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new BN$8(t, 16), this.y = new BN$8(a, 16), d && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
}
inherits$3(Point$2, Base$2.BasePoint);
ShortCurve.prototype.point = function(t, a, d) {
  return new Point$2(this, t, a, d);
};
ShortCurve.prototype.pointFromJSON = function(t, a) {
  return Point$2.fromJSON(this, t, a);
};
Point$2.prototype._getBeta = function() {
  if (!!this.curve.endo) {
    var t = this.precomputed;
    if (t && t.beta)
      return t.beta;
    var a = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (t) {
      var d = this.curve, l = function(h) {
        return d.point(h.x.redMul(d.endo.beta), h.y);
      };
      t.beta = a, a.precomputed = {
        beta: null,
        naf: t.naf && {
          wnd: t.naf.wnd,
          points: t.naf.points.map(l)
        },
        doubles: t.doubles && {
          step: t.doubles.step,
          points: t.doubles.points.map(l)
        }
      };
    }
    return a;
  }
};
Point$2.prototype.toJSON = function() {
  return this.precomputed ? [this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  }] : [this.x, this.y];
};
Point$2.fromJSON = function(t, a, d) {
  typeof a == "string" && (a = JSON.parse(a));
  var l = t.point(a[0], a[1], d);
  if (!a[2])
    return l;
  function h(c) {
    return t.point(c[0], c[1], d);
  }
  var g = a[2];
  return l.precomputed = {
    beta: null,
    doubles: g.doubles && {
      step: g.doubles.step,
      points: [l].concat(g.doubles.points.map(h))
    },
    naf: g.naf && {
      wnd: g.naf.wnd,
      points: [l].concat(g.naf.points.map(h))
    }
  }, l;
};
Point$2.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point$2.prototype.isInfinity = function() {
  return this.inf;
};
Point$2.prototype.add = function(t) {
  if (this.inf)
    return t;
  if (t.inf)
    return this;
  if (this.eq(t))
    return this.dbl();
  if (this.neg().eq(t))
    return this.curve.point(null, null);
  if (this.x.cmp(t.x) === 0)
    return this.curve.point(null, null);
  var a = this.y.redSub(t.y);
  a.cmpn(0) !== 0 && (a = a.redMul(this.x.redSub(t.x).redInvm()));
  var d = a.redSqr().redISub(this.x).redISub(t.x), l = a.redMul(this.x.redSub(d)).redISub(this.y);
  return this.curve.point(d, l);
};
Point$2.prototype.dbl = function() {
  if (this.inf)
    return this;
  var t = this.y.redAdd(this.y);
  if (t.cmpn(0) === 0)
    return this.curve.point(null, null);
  var a = this.curve.a, d = this.x.redSqr(), l = t.redInvm(), h = d.redAdd(d).redIAdd(d).redIAdd(a).redMul(l), g = h.redSqr().redISub(this.x.redAdd(this.x)), c = h.redMul(this.x.redSub(g)).redISub(this.y);
  return this.curve.point(g, c);
};
Point$2.prototype.getX = function() {
  return this.x.fromRed();
};
Point$2.prototype.getY = function() {
  return this.y.fromRed();
};
Point$2.prototype.mul = function(t) {
  return t = new BN$8(t, 16), this.isInfinity() ? this : this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [t]) : this.curve._wnafMul(this, t);
};
Point$2.prototype.mulAdd = function(t, a, d) {
  var l = [this, a], h = [t, d];
  return this.curve.endo ? this.curve._endoWnafMulAdd(l, h) : this.curve._wnafMulAdd(1, l, h, 2);
};
Point$2.prototype.jmulAdd = function(t, a, d) {
  var l = [this, a], h = [t, d];
  return this.curve.endo ? this.curve._endoWnafMulAdd(l, h, !0) : this.curve._wnafMulAdd(1, l, h, 2, !0);
};
Point$2.prototype.eq = function(t) {
  return this === t || this.inf === t.inf && (this.inf || this.x.cmp(t.x) === 0 && this.y.cmp(t.y) === 0);
};
Point$2.prototype.neg = function(t) {
  if (this.inf)
    return this;
  var a = this.curve.point(this.x, this.y.redNeg());
  if (t && this.precomputed) {
    var d = this.precomputed, l = function(h) {
      return h.neg();
    };
    a.precomputed = {
      naf: d.naf && {
        wnd: d.naf.wnd,
        points: d.naf.points.map(l)
      },
      doubles: d.doubles && {
        step: d.doubles.step,
        points: d.doubles.points.map(l)
      }
    };
  }
  return a;
};
Point$2.prototype.toJ = function() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);
  var t = this.curve.jpoint(this.x, this.y, this.curve.one);
  return t;
};
function JPoint(u, t, a, d) {
  Base$2.BasePoint.call(this, u, "jacobian"), t === null && a === null && d === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new BN$8(0)) : (this.x = new BN$8(t, 16), this.y = new BN$8(a, 16), this.z = new BN$8(d, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
}
inherits$3(JPoint, Base$2.BasePoint);
ShortCurve.prototype.jpoint = function(t, a, d) {
  return new JPoint(this, t, a, d);
};
JPoint.prototype.toP = function() {
  if (this.isInfinity())
    return this.curve.point(null, null);
  var t = this.z.redInvm(), a = t.redSqr(), d = this.x.redMul(a), l = this.y.redMul(a).redMul(t);
  return this.curve.point(d, l);
};
JPoint.prototype.neg = function() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function(t) {
  if (this.isInfinity())
    return t;
  if (t.isInfinity())
    return this;
  var a = t.z.redSqr(), d = this.z.redSqr(), l = this.x.redMul(a), h = t.x.redMul(d), g = this.y.redMul(a.redMul(t.z)), c = t.y.redMul(d.redMul(this.z)), x = l.redSub(h), R = g.redSub(c);
  if (x.cmpn(0) === 0)
    return R.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var B = x.redSqr(), j = B.redMul(x), o = l.redMul(B), e = R.redSqr().redIAdd(j).redISub(o).redISub(o), n = R.redMul(o.redISub(e)).redISub(g.redMul(j)), i = this.z.redMul(t.z).redMul(x);
  return this.curve.jpoint(e, n, i);
};
JPoint.prototype.mixedAdd = function(t) {
  if (this.isInfinity())
    return t.toJ();
  if (t.isInfinity())
    return this;
  var a = this.z.redSqr(), d = this.x, l = t.x.redMul(a), h = this.y, g = t.y.redMul(a).redMul(this.z), c = d.redSub(l), x = h.redSub(g);
  if (c.cmpn(0) === 0)
    return x.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
  var R = c.redSqr(), B = R.redMul(c), j = d.redMul(R), o = x.redSqr().redIAdd(B).redISub(j).redISub(j), e = x.redMul(j.redISub(o)).redISub(h.redMul(B)), n = this.z.redMul(c);
  return this.curve.jpoint(o, e, n);
};
JPoint.prototype.dblp = function(t) {
  if (t === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!t)
    return this.dbl();
  var a;
  if (this.curve.zeroA || this.curve.threeA) {
    var d = this;
    for (a = 0; a < t; a++)
      d = d.dbl();
    return d;
  }
  var l = this.curve.a, h = this.curve.tinv, g = this.x, c = this.y, x = this.z, R = x.redSqr().redSqr(), B = c.redAdd(c);
  for (a = 0; a < t; a++) {
    var j = g.redSqr(), o = B.redSqr(), e = o.redSqr(), n = j.redAdd(j).redIAdd(j).redIAdd(l.redMul(R)), i = g.redMul(o), y = n.redSqr().redISub(i.redAdd(i)), m = i.redISub(y), U = n.redMul(m);
    U = U.redIAdd(U).redISub(e);
    var be = B.redMul(x);
    a + 1 < t && (R = R.redMul(e)), g = y, x = be, B = U;
  }
  return this.curve.jpoint(g, B.redMul(h), x);
};
JPoint.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
};
JPoint.prototype._zeroDbl = function() {
  var t, a, d;
  if (this.zOne) {
    var l = this.x.redSqr(), h = this.y.redSqr(), g = h.redSqr(), c = this.x.redAdd(h).redSqr().redISub(l).redISub(g);
    c = c.redIAdd(c);
    var x = l.redAdd(l).redIAdd(l), R = x.redSqr().redISub(c).redISub(c), B = g.redIAdd(g);
    B = B.redIAdd(B), B = B.redIAdd(B), t = R, a = x.redMul(c.redISub(R)).redISub(B), d = this.y.redAdd(this.y);
  } else {
    var j = this.x.redSqr(), o = this.y.redSqr(), e = o.redSqr(), n = this.x.redAdd(o).redSqr().redISub(j).redISub(e);
    n = n.redIAdd(n);
    var i = j.redAdd(j).redIAdd(j), y = i.redSqr(), m = e.redIAdd(e);
    m = m.redIAdd(m), m = m.redIAdd(m), t = y.redISub(n).redISub(n), a = i.redMul(n.redISub(t)).redISub(m), d = this.y.redMul(this.z), d = d.redIAdd(d);
  }
  return this.curve.jpoint(t, a, d);
};
JPoint.prototype._threeDbl = function() {
  var t, a, d;
  if (this.zOne) {
    var l = this.x.redSqr(), h = this.y.redSqr(), g = h.redSqr(), c = this.x.redAdd(h).redSqr().redISub(l).redISub(g);
    c = c.redIAdd(c);
    var x = l.redAdd(l).redIAdd(l).redIAdd(this.curve.a), R = x.redSqr().redISub(c).redISub(c);
    t = R;
    var B = g.redIAdd(g);
    B = B.redIAdd(B), B = B.redIAdd(B), a = x.redMul(c.redISub(R)).redISub(B), d = this.y.redAdd(this.y);
  } else {
    var j = this.z.redSqr(), o = this.y.redSqr(), e = this.x.redMul(o), n = this.x.redSub(j).redMul(this.x.redAdd(j));
    n = n.redAdd(n).redIAdd(n);
    var i = e.redIAdd(e);
    i = i.redIAdd(i);
    var y = i.redAdd(i);
    t = n.redSqr().redISub(y), d = this.y.redAdd(this.z).redSqr().redISub(o).redISub(j);
    var m = o.redSqr();
    m = m.redIAdd(m), m = m.redIAdd(m), m = m.redIAdd(m), a = n.redMul(i.redISub(t)).redISub(m);
  }
  return this.curve.jpoint(t, a, d);
};
JPoint.prototype._dbl = function() {
  var t = this.curve.a, a = this.x, d = this.y, l = this.z, h = l.redSqr().redSqr(), g = a.redSqr(), c = d.redSqr(), x = g.redAdd(g).redIAdd(g).redIAdd(t.redMul(h)), R = a.redAdd(a);
  R = R.redIAdd(R);
  var B = R.redMul(c), j = x.redSqr().redISub(B.redAdd(B)), o = B.redISub(j), e = c.redSqr();
  e = e.redIAdd(e), e = e.redIAdd(e), e = e.redIAdd(e);
  var n = x.redMul(o).redISub(e), i = d.redAdd(d).redMul(l);
  return this.curve.jpoint(j, n, i);
};
JPoint.prototype.trpl = function() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);
  var t = this.x.redSqr(), a = this.y.redSqr(), d = this.z.redSqr(), l = a.redSqr(), h = t.redAdd(t).redIAdd(t), g = h.redSqr(), c = this.x.redAdd(a).redSqr().redISub(t).redISub(l);
  c = c.redIAdd(c), c = c.redAdd(c).redIAdd(c), c = c.redISub(g);
  var x = c.redSqr(), R = l.redIAdd(l);
  R = R.redIAdd(R), R = R.redIAdd(R), R = R.redIAdd(R);
  var B = h.redIAdd(c).redSqr().redISub(g).redISub(x).redISub(R), j = a.redMul(B);
  j = j.redIAdd(j), j = j.redIAdd(j);
  var o = this.x.redMul(x).redISub(j);
  o = o.redIAdd(o), o = o.redIAdd(o);
  var e = this.y.redMul(B.redMul(R.redISub(B)).redISub(c.redMul(x)));
  e = e.redIAdd(e), e = e.redIAdd(e), e = e.redIAdd(e);
  var n = this.z.redAdd(c).redSqr().redISub(d).redISub(x);
  return this.curve.jpoint(o, e, n);
};
JPoint.prototype.mul = function(t, a) {
  return t = new BN$8(t, a), this.curve._wnafMul(this, t);
};
JPoint.prototype.eq = function(t) {
  if (t.type === "affine")
    return this.eq(t.toJ());
  if (this === t)
    return !0;
  var a = this.z.redSqr(), d = t.z.redSqr();
  if (this.x.redMul(d).redISub(t.x.redMul(a)).cmpn(0) !== 0)
    return !1;
  var l = a.redMul(this.z), h = d.redMul(t.z);
  return this.y.redMul(h).redISub(t.y.redMul(l)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function(t) {
  var a = this.z.redSqr(), d = t.toRed(this.curve.red).redMul(a);
  if (this.x.cmp(d) === 0)
    return !0;
  for (var l = t.clone(), h = this.curve.redN.redMul(a); ; ) {
    if (l.iadd(this.curve.n), l.cmp(this.curve.p) >= 0)
      return !1;
    if (d.redIAdd(h), this.x.cmp(d) === 0)
      return !0;
  }
};
JPoint.prototype.inspect = function() {
  return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
var BN$7 = bn$2.exports, inherits$2 = inherits_browser.exports, Base$1 = base, utils$i = utils$m;
function MontCurve(u) {
  Base$1.call(this, "mont", u), this.a = new BN$7(u.a, 16).toRed(this.red), this.b = new BN$7(u.b, 16).toRed(this.red), this.i4 = new BN$7(4).toRed(this.red).redInvm(), this.two = new BN$7(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits$2(MontCurve, Base$1);
var mont = MontCurve;
MontCurve.prototype.validate = function(t) {
  var a = t.normalize().x, d = a.redSqr(), l = d.redMul(a).redAdd(d.redMul(this.a)).redAdd(a), h = l.redSqrt();
  return h.redSqr().cmp(l) === 0;
};
function Point$1(u, t, a) {
  Base$1.BasePoint.call(this, u, "projective"), t === null && a === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new BN$7(t, 16), this.z = new BN$7(a, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
}
inherits$2(Point$1, Base$1.BasePoint);
MontCurve.prototype.decodePoint = function(t, a) {
  return this.point(utils$i.toArray(t, a), 1);
};
MontCurve.prototype.point = function(t, a) {
  return new Point$1(this, t, a);
};
MontCurve.prototype.pointFromJSON = function(t) {
  return Point$1.fromJSON(this, t);
};
Point$1.prototype.precompute = function() {
};
Point$1.prototype._encode = function() {
  return this.getX().toArray("be", this.curve.p.byteLength());
};
Point$1.fromJSON = function(t, a) {
  return new Point$1(t, a[0], a[1] || t.one);
};
Point$1.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point$1.prototype.isInfinity = function() {
  return this.z.cmpn(0) === 0;
};
Point$1.prototype.dbl = function() {
  var t = this.x.redAdd(this.z), a = t.redSqr(), d = this.x.redSub(this.z), l = d.redSqr(), h = a.redSub(l), g = a.redMul(l), c = h.redMul(l.redAdd(this.curve.a24.redMul(h)));
  return this.curve.point(g, c);
};
Point$1.prototype.add = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.diffAdd = function(t, a) {
  var d = this.x.redAdd(this.z), l = this.x.redSub(this.z), h = t.x.redAdd(t.z), g = t.x.redSub(t.z), c = g.redMul(d), x = h.redMul(l), R = a.z.redMul(c.redAdd(x).redSqr()), B = a.x.redMul(c.redISub(x).redSqr());
  return this.curve.point(R, B);
};
Point$1.prototype.mul = function(t) {
  for (var a = t.clone(), d = this, l = this.curve.point(null, null), h = this, g = []; a.cmpn(0) !== 0; a.iushrn(1))
    g.push(a.andln(1));
  for (var c = g.length - 1; c >= 0; c--)
    g[c] === 0 ? (d = d.diffAdd(l, h), l = l.dbl()) : (l = d.diffAdd(l, h), d = d.dbl());
  return l;
};
Point$1.prototype.mulAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.jumlAdd = function() {
  throw new Error("Not supported on Montgomery curve");
};
Point$1.prototype.eq = function(t) {
  return this.getX().cmp(t.getX()) === 0;
};
Point$1.prototype.normalize = function() {
  return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
};
Point$1.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
var utils$h = utils$m, BN$6 = bn$2.exports, inherits$1 = inherits_browser.exports, Base = base, assert$c = utils$h.assert;
function EdwardsCurve(u) {
  this.twisted = (u.a | 0) !== 1, this.mOneA = this.twisted && (u.a | 0) === -1, this.extended = this.mOneA, Base.call(this, "edwards", u), this.a = new BN$6(u.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new BN$6(u.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new BN$6(u.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), assert$c(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (u.c | 0) === 1;
}
inherits$1(EdwardsCurve, Base);
var edwards = EdwardsCurve;
EdwardsCurve.prototype._mulA = function(t) {
  return this.mOneA ? t.redNeg() : this.a.redMul(t);
};
EdwardsCurve.prototype._mulC = function(t) {
  return this.oneC ? t : this.c.redMul(t);
};
EdwardsCurve.prototype.jpoint = function(t, a, d, l) {
  return this.point(t, a, d, l);
};
EdwardsCurve.prototype.pointFromX = function(t, a) {
  t = new BN$6(t, 16), t.red || (t = t.toRed(this.red));
  var d = t.redSqr(), l = this.c2.redSub(this.a.redMul(d)), h = this.one.redSub(this.c2.redMul(this.d).redMul(d)), g = l.redMul(h.redInvm()), c = g.redSqrt();
  if (c.redSqr().redSub(g).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  var x = c.fromRed().isOdd();
  return (a && !x || !a && x) && (c = c.redNeg()), this.point(t, c);
};
EdwardsCurve.prototype.pointFromY = function(t, a) {
  t = new BN$6(t, 16), t.red || (t = t.toRed(this.red));
  var d = t.redSqr(), l = d.redSub(this.c2), h = d.redMul(this.d).redMul(this.c2).redSub(this.a), g = l.redMul(h.redInvm());
  if (g.cmp(this.zero) === 0) {
    if (a)
      throw new Error("invalid point");
    return this.point(this.zero, t);
  }
  var c = g.redSqrt();
  if (c.redSqr().redSub(g).cmp(this.zero) !== 0)
    throw new Error("invalid point");
  return c.fromRed().isOdd() !== a && (c = c.redNeg()), this.point(c, t);
};
EdwardsCurve.prototype.validate = function(t) {
  if (t.isInfinity())
    return !0;
  t.normalize();
  var a = t.x.redSqr(), d = t.y.redSqr(), l = a.redMul(this.a).redAdd(d), h = this.c2.redMul(this.one.redAdd(this.d.redMul(a).redMul(d)));
  return l.cmp(h) === 0;
};
function Point(u, t, a, d, l) {
  Base.BasePoint.call(this, u, "projective"), t === null && a === null && d === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new BN$6(t, 16), this.y = new BN$6(a, 16), this.z = d ? new BN$6(d, 16) : this.curve.one, this.t = l && new BN$6(l, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
}
inherits$1(Point, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function(t) {
  return Point.fromJSON(this, t);
};
EdwardsCurve.prototype.point = function(t, a, d, l) {
  return new Point(this, t, a, d, l);
};
Point.fromJSON = function(t, a) {
  return new Point(t, a[0], a[1], a[2]);
};
Point.prototype.inspect = function() {
  return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function() {
  return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function() {
  var t = this.x.redSqr(), a = this.y.redSqr(), d = this.z.redSqr();
  d = d.redIAdd(d);
  var l = this.curve._mulA(t), h = this.x.redAdd(this.y).redSqr().redISub(t).redISub(a), g = l.redAdd(a), c = g.redSub(d), x = l.redSub(a), R = h.redMul(c), B = g.redMul(x), j = h.redMul(x), o = c.redMul(g);
  return this.curve.point(R, B, o, j);
};
Point.prototype._projDbl = function() {
  var t = this.x.redAdd(this.y).redSqr(), a = this.x.redSqr(), d = this.y.redSqr(), l, h, g, c, x, R;
  if (this.curve.twisted) {
    c = this.curve._mulA(a);
    var B = c.redAdd(d);
    this.zOne ? (l = t.redSub(a).redSub(d).redMul(B.redSub(this.curve.two)), h = B.redMul(c.redSub(d)), g = B.redSqr().redSub(B).redSub(B)) : (x = this.z.redSqr(), R = B.redSub(x).redISub(x), l = t.redSub(a).redISub(d).redMul(R), h = B.redMul(c.redSub(d)), g = B.redMul(R));
  } else
    c = a.redAdd(d), x = this.curve._mulC(this.z).redSqr(), R = c.redSub(x).redSub(x), l = this.curve._mulC(t.redISub(c)).redMul(R), h = this.curve._mulC(c).redMul(a.redISub(d)), g = c.redMul(R);
  return this.curve.point(l, h, g);
};
Point.prototype.dbl = function() {
  return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
};
Point.prototype._extAdd = function(t) {
  var a = this.y.redSub(this.x).redMul(t.y.redSub(t.x)), d = this.y.redAdd(this.x).redMul(t.y.redAdd(t.x)), l = this.t.redMul(this.curve.dd).redMul(t.t), h = this.z.redMul(t.z.redAdd(t.z)), g = d.redSub(a), c = h.redSub(l), x = h.redAdd(l), R = d.redAdd(a), B = g.redMul(c), j = x.redMul(R), o = g.redMul(R), e = c.redMul(x);
  return this.curve.point(B, j, e, o);
};
Point.prototype._projAdd = function(t) {
  var a = this.z.redMul(t.z), d = a.redSqr(), l = this.x.redMul(t.x), h = this.y.redMul(t.y), g = this.curve.d.redMul(l).redMul(h), c = d.redSub(g), x = d.redAdd(g), R = this.x.redAdd(this.y).redMul(t.x.redAdd(t.y)).redISub(l).redISub(h), B = a.redMul(c).redMul(R), j, o;
  return this.curve.twisted ? (j = a.redMul(x).redMul(h.redSub(this.curve._mulA(l))), o = c.redMul(x)) : (j = a.redMul(x).redMul(h.redSub(l)), o = this.curve._mulC(c).redMul(x)), this.curve.point(B, j, o);
};
Point.prototype.add = function(t) {
  return this.isInfinity() ? t : t.isInfinity() ? this : this.curve.extended ? this._extAdd(t) : this._projAdd(t);
};
Point.prototype.mul = function(t) {
  return this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve._wnafMul(this, t);
};
Point.prototype.mulAdd = function(t, a, d) {
  return this.curve._wnafMulAdd(1, [this, a], [t, d], 2, !1);
};
Point.prototype.jmulAdd = function(t, a, d) {
  return this.curve._wnafMulAdd(1, [this, a], [t, d], 2, !0);
};
Point.prototype.normalize = function() {
  if (this.zOne)
    return this;
  var t = this.z.redInvm();
  return this.x = this.x.redMul(t), this.y = this.y.redMul(t), this.t && (this.t = this.t.redMul(t)), this.z = this.curve.one, this.zOne = !0, this;
};
Point.prototype.neg = function() {
  return this.curve.point(
    this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg()
  );
};
Point.prototype.getX = function() {
  return this.normalize(), this.x.fromRed();
};
Point.prototype.getY = function() {
  return this.normalize(), this.y.fromRed();
};
Point.prototype.eq = function(t) {
  return this === t || this.getX().cmp(t.getX()) === 0 && this.getY().cmp(t.getY()) === 0;
};
Point.prototype.eqXToP = function(t) {
  var a = t.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(a) === 0)
    return !0;
  for (var d = t.clone(), l = this.curve.redN.redMul(this.z); ; ) {
    if (d.iadd(this.curve.n), d.cmp(this.curve.p) >= 0)
      return !1;
    if (a.redIAdd(l), this.x.cmp(a) === 0)
      return !0;
  }
};
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;
(function(u) {
  var t = u;
  t.base = base, t.short = short, t.mont = mont, t.edwards = edwards;
})(curve);
var curves$2 = {}, hash$2 = {}, utils$g = {}, assert$b = minimalisticAssert, inherits = inherits_browser.exports;
utils$g.inherits = inherits;
function isSurrogatePair(u, t) {
  return (u.charCodeAt(t) & 64512) !== 55296 || t < 0 || t + 1 >= u.length ? !1 : (u.charCodeAt(t + 1) & 64512) === 56320;
}
function toArray(u, t) {
  if (Array.isArray(u))
    return u.slice();
  if (!u)
    return [];
  var a = [];
  if (typeof u == "string")
    if (t) {
      if (t === "hex")
        for (u = u.replace(/[^a-z0-9]+/ig, ""), u.length % 2 !== 0 && (u = "0" + u), l = 0; l < u.length; l += 2)
          a.push(parseInt(u[l] + u[l + 1], 16));
    } else
      for (var d = 0, l = 0; l < u.length; l++) {
        var h = u.charCodeAt(l);
        h < 128 ? a[d++] = h : h < 2048 ? (a[d++] = h >> 6 | 192, a[d++] = h & 63 | 128) : isSurrogatePair(u, l) ? (h = 65536 + ((h & 1023) << 10) + (u.charCodeAt(++l) & 1023), a[d++] = h >> 18 | 240, a[d++] = h >> 12 & 63 | 128, a[d++] = h >> 6 & 63 | 128, a[d++] = h & 63 | 128) : (a[d++] = h >> 12 | 224, a[d++] = h >> 6 & 63 | 128, a[d++] = h & 63 | 128);
      }
  else
    for (l = 0; l < u.length; l++)
      a[l] = u[l] | 0;
  return a;
}
utils$g.toArray = toArray;
function toHex$1(u) {
  for (var t = "", a = 0; a < u.length; a++)
    t += zero2(u[a].toString(16));
  return t;
}
utils$g.toHex = toHex$1;
function htonl(u) {
  var t = u >>> 24 | u >>> 8 & 65280 | u << 8 & 16711680 | (u & 255) << 24;
  return t >>> 0;
}
utils$g.htonl = htonl;
function toHex32(u, t) {
  for (var a = "", d = 0; d < u.length; d++) {
    var l = u[d];
    t === "little" && (l = htonl(l)), a += zero8(l.toString(16));
  }
  return a;
}
utils$g.toHex32 = toHex32;
function zero2(u) {
  return u.length === 1 ? "0" + u : u;
}
utils$g.zero2 = zero2;
function zero8(u) {
  return u.length === 7 ? "0" + u : u.length === 6 ? "00" + u : u.length === 5 ? "000" + u : u.length === 4 ? "0000" + u : u.length === 3 ? "00000" + u : u.length === 2 ? "000000" + u : u.length === 1 ? "0000000" + u : u;
}
utils$g.zero8 = zero8;
function join32(u, t, a, d) {
  var l = a - t;
  assert$b(l % 4 === 0);
  for (var h = new Array(l / 4), g = 0, c = t; g < h.length; g++, c += 4) {
    var x;
    d === "big" ? x = u[c] << 24 | u[c + 1] << 16 | u[c + 2] << 8 | u[c + 3] : x = u[c + 3] << 24 | u[c + 2] << 16 | u[c + 1] << 8 | u[c], h[g] = x >>> 0;
  }
  return h;
}
utils$g.join32 = join32;
function split32(u, t) {
  for (var a = new Array(u.length * 4), d = 0, l = 0; d < u.length; d++, l += 4) {
    var h = u[d];
    t === "big" ? (a[l] = h >>> 24, a[l + 1] = h >>> 16 & 255, a[l + 2] = h >>> 8 & 255, a[l + 3] = h & 255) : (a[l + 3] = h >>> 24, a[l + 2] = h >>> 16 & 255, a[l + 1] = h >>> 8 & 255, a[l] = h & 255);
  }
  return a;
}
utils$g.split32 = split32;
function rotr32$1(u, t) {
  return u >>> t | u << 32 - t;
}
utils$g.rotr32 = rotr32$1;
function rotl32$2(u, t) {
  return u << t | u >>> 32 - t;
}
utils$g.rotl32 = rotl32$2;
function sum32$3(u, t) {
  return u + t >>> 0;
}
utils$g.sum32 = sum32$3;
function sum32_3$1(u, t, a) {
  return u + t + a >>> 0;
}
utils$g.sum32_3 = sum32_3$1;
function sum32_4$2(u, t, a, d) {
  return u + t + a + d >>> 0;
}
utils$g.sum32_4 = sum32_4$2;
function sum32_5$2(u, t, a, d, l) {
  return u + t + a + d + l >>> 0;
}
utils$g.sum32_5 = sum32_5$2;
function sum64$1(u, t, a, d) {
  var l = u[t], h = u[t + 1], g = d + h >>> 0, c = (g < d ? 1 : 0) + a + l;
  u[t] = c >>> 0, u[t + 1] = g;
}
utils$g.sum64 = sum64$1;
function sum64_hi$1(u, t, a, d) {
  var l = t + d >>> 0, h = (l < t ? 1 : 0) + u + a;
  return h >>> 0;
}
utils$g.sum64_hi = sum64_hi$1;
function sum64_lo$1(u, t, a, d) {
  var l = t + d;
  return l >>> 0;
}
utils$g.sum64_lo = sum64_lo$1;
function sum64_4_hi$1(u, t, a, d, l, h, g, c) {
  var x = 0, R = t;
  R = R + d >>> 0, x += R < t ? 1 : 0, R = R + h >>> 0, x += R < h ? 1 : 0, R = R + c >>> 0, x += R < c ? 1 : 0;
  var B = u + a + l + g + x;
  return B >>> 0;
}
utils$g.sum64_4_hi = sum64_4_hi$1;
function sum64_4_lo$1(u, t, a, d, l, h, g, c) {
  var x = t + d + h + c;
  return x >>> 0;
}
utils$g.sum64_4_lo = sum64_4_lo$1;
function sum64_5_hi$1(u, t, a, d, l, h, g, c, x, R) {
  var B = 0, j = t;
  j = j + d >>> 0, B += j < t ? 1 : 0, j = j + h >>> 0, B += j < h ? 1 : 0, j = j + c >>> 0, B += j < c ? 1 : 0, j = j + R >>> 0, B += j < R ? 1 : 0;
  var o = u + a + l + g + x + B;
  return o >>> 0;
}
utils$g.sum64_5_hi = sum64_5_hi$1;
function sum64_5_lo$1(u, t, a, d, l, h, g, c, x, R) {
  var B = t + d + h + c + R;
  return B >>> 0;
}
utils$g.sum64_5_lo = sum64_5_lo$1;
function rotr64_hi$1(u, t, a) {
  var d = t << 32 - a | u >>> a;
  return d >>> 0;
}
utils$g.rotr64_hi = rotr64_hi$1;
function rotr64_lo$1(u, t, a) {
  var d = u << 32 - a | t >>> a;
  return d >>> 0;
}
utils$g.rotr64_lo = rotr64_lo$1;
function shr64_hi$1(u, t, a) {
  return u >>> a;
}
utils$g.shr64_hi = shr64_hi$1;
function shr64_lo$1(u, t, a) {
  var d = u << 32 - a | t >>> a;
  return d >>> 0;
}
utils$g.shr64_lo = shr64_lo$1;
var common$5 = {}, utils$f = utils$g, assert$a = minimalisticAssert;
function BlockHash$4() {
  this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
}
common$5.BlockHash = BlockHash$4;
BlockHash$4.prototype.update = function(t, a) {
  if (t = utils$f.toArray(t, a), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
    t = this.pending;
    var d = t.length % this._delta8;
    this.pending = t.slice(t.length - d, t.length), this.pending.length === 0 && (this.pending = null), t = utils$f.join32(t, 0, t.length - d, this.endian);
    for (var l = 0; l < t.length; l += this._delta32)
      this._update(t, l, l + this._delta32);
  }
  return this;
};
BlockHash$4.prototype.digest = function(t) {
  return this.update(this._pad()), assert$a(this.pending === null), this._digest(t);
};
BlockHash$4.prototype._pad = function() {
  var t = this.pendingTotal, a = this._delta8, d = a - (t + this.padLength) % a, l = new Array(d + this.padLength);
  l[0] = 128;
  for (var h = 1; h < d; h++)
    l[h] = 0;
  if (t <<= 3, this.endian === "big") {
    for (var g = 8; g < this.padLength; g++)
      l[h++] = 0;
    l[h++] = 0, l[h++] = 0, l[h++] = 0, l[h++] = 0, l[h++] = t >>> 24 & 255, l[h++] = t >>> 16 & 255, l[h++] = t >>> 8 & 255, l[h++] = t & 255;
  } else
    for (l[h++] = t & 255, l[h++] = t >>> 8 & 255, l[h++] = t >>> 16 & 255, l[h++] = t >>> 24 & 255, l[h++] = 0, l[h++] = 0, l[h++] = 0, l[h++] = 0, g = 8; g < this.padLength; g++)
      l[h++] = 0;
  return l;
};
var sha = {}, common$4 = {}, utils$e = utils$g, rotr32 = utils$e.rotr32;
function ft_1$1(u, t, a, d) {
  if (u === 0)
    return ch32$1(t, a, d);
  if (u === 1 || u === 3)
    return p32(t, a, d);
  if (u === 2)
    return maj32$1(t, a, d);
}
common$4.ft_1 = ft_1$1;
function ch32$1(u, t, a) {
  return u & t ^ ~u & a;
}
common$4.ch32 = ch32$1;
function maj32$1(u, t, a) {
  return u & t ^ u & a ^ t & a;
}
common$4.maj32 = maj32$1;
function p32(u, t, a) {
  return u ^ t ^ a;
}
common$4.p32 = p32;
function s0_256$1(u) {
  return rotr32(u, 2) ^ rotr32(u, 13) ^ rotr32(u, 22);
}
common$4.s0_256 = s0_256$1;
function s1_256$1(u) {
  return rotr32(u, 6) ^ rotr32(u, 11) ^ rotr32(u, 25);
}
common$4.s1_256 = s1_256$1;
function g0_256$1(u) {
  return rotr32(u, 7) ^ rotr32(u, 18) ^ u >>> 3;
}
common$4.g0_256 = g0_256$1;
function g1_256$1(u) {
  return rotr32(u, 17) ^ rotr32(u, 19) ^ u >>> 10;
}
common$4.g1_256 = g1_256$1;
var utils$d = utils$g, common$3 = common$5, shaCommon$1 = common$4, rotl32$1 = utils$d.rotl32, sum32$2 = utils$d.sum32, sum32_5$1 = utils$d.sum32_5, ft_1 = shaCommon$1.ft_1, BlockHash$3 = common$3.BlockHash, sha1_K = [
  1518500249,
  1859775393,
  2400959708,
  3395469782
];
function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();
  BlockHash$3.call(this), this.h = [
    1732584193,
    4023233417,
    2562383102,
    271733878,
    3285377520
  ], this.W = new Array(80);
}
utils$d.inherits(SHA1, BlockHash$3);
var _1 = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function(t, a) {
  for (var d = this.W, l = 0; l < 16; l++)
    d[l] = t[a + l];
  for (; l < d.length; l++)
    d[l] = rotl32$1(d[l - 3] ^ d[l - 8] ^ d[l - 14] ^ d[l - 16], 1);
  var h = this.h[0], g = this.h[1], c = this.h[2], x = this.h[3], R = this.h[4];
  for (l = 0; l < d.length; l++) {
    var B = ~~(l / 20), j = sum32_5$1(rotl32$1(h, 5), ft_1(B, g, c, x), R, d[l], sha1_K[B]);
    R = x, x = c, c = rotl32$1(g, 30), g = h, h = j;
  }
  this.h[0] = sum32$2(this.h[0], h), this.h[1] = sum32$2(this.h[1], g), this.h[2] = sum32$2(this.h[2], c), this.h[3] = sum32$2(this.h[3], x), this.h[4] = sum32$2(this.h[4], R);
};
SHA1.prototype._digest = function(t) {
  return t === "hex" ? utils$d.toHex32(this.h, "big") : utils$d.split32(this.h, "big");
};
var utils$c = utils$g, common$2 = common$5, shaCommon = common$4, assert$9 = minimalisticAssert, sum32$1 = utils$c.sum32, sum32_4$1 = utils$c.sum32_4, sum32_5 = utils$c.sum32_5, ch32 = shaCommon.ch32, maj32 = shaCommon.maj32, s0_256 = shaCommon.s0_256, s1_256 = shaCommon.s1_256, g0_256 = shaCommon.g0_256, g1_256 = shaCommon.g1_256, BlockHash$2 = common$2.BlockHash, sha256_K = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
];
function SHA256$1() {
  if (!(this instanceof SHA256$1))
    return new SHA256$1();
  BlockHash$2.call(this), this.h = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ], this.k = sha256_K, this.W = new Array(64);
}
utils$c.inherits(SHA256$1, BlockHash$2);
var _256 = SHA256$1;
SHA256$1.blockSize = 512;
SHA256$1.outSize = 256;
SHA256$1.hmacStrength = 192;
SHA256$1.padLength = 64;
SHA256$1.prototype._update = function(t, a) {
  for (var d = this.W, l = 0; l < 16; l++)
    d[l] = t[a + l];
  for (; l < d.length; l++)
    d[l] = sum32_4$1(g1_256(d[l - 2]), d[l - 7], g0_256(d[l - 15]), d[l - 16]);
  var h = this.h[0], g = this.h[1], c = this.h[2], x = this.h[3], R = this.h[4], B = this.h[5], j = this.h[6], o = this.h[7];
  for (assert$9(this.k.length === d.length), l = 0; l < d.length; l++) {
    var e = sum32_5(o, s1_256(R), ch32(R, B, j), this.k[l], d[l]), n = sum32$1(s0_256(h), maj32(h, g, c));
    o = j, j = B, B = R, R = sum32$1(x, e), x = c, c = g, g = h, h = sum32$1(e, n);
  }
  this.h[0] = sum32$1(this.h[0], h), this.h[1] = sum32$1(this.h[1], g), this.h[2] = sum32$1(this.h[2], c), this.h[3] = sum32$1(this.h[3], x), this.h[4] = sum32$1(this.h[4], R), this.h[5] = sum32$1(this.h[5], B), this.h[6] = sum32$1(this.h[6], j), this.h[7] = sum32$1(this.h[7], o);
};
SHA256$1.prototype._digest = function(t) {
  return t === "hex" ? utils$c.toHex32(this.h, "big") : utils$c.split32(this.h, "big");
};
var utils$b = utils$g, SHA256 = _256;
function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();
  SHA256.call(this), this.h = [
    3238371032,
    914150663,
    812702999,
    4144912697,
    4290775857,
    1750603025,
    1694076839,
    3204075428
  ];
}
utils$b.inherits(SHA224, SHA256);
var _224 = SHA224;
SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;
SHA224.prototype._digest = function(t) {
  return t === "hex" ? utils$b.toHex32(this.h.slice(0, 7), "big") : utils$b.split32(this.h.slice(0, 7), "big");
};
var utils$a = utils$g, common$1 = common$5, assert$8 = minimalisticAssert, rotr64_hi = utils$a.rotr64_hi, rotr64_lo = utils$a.rotr64_lo, shr64_hi = utils$a.shr64_hi, shr64_lo = utils$a.shr64_lo, sum64 = utils$a.sum64, sum64_hi = utils$a.sum64_hi, sum64_lo = utils$a.sum64_lo, sum64_4_hi = utils$a.sum64_4_hi, sum64_4_lo = utils$a.sum64_4_lo, sum64_5_hi = utils$a.sum64_5_hi, sum64_5_lo = utils$a.sum64_5_lo, BlockHash$1 = common$1.BlockHash, sha512_K = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
];
function SHA512$1() {
  if (!(this instanceof SHA512$1))
    return new SHA512$1();
  BlockHash$1.call(this), this.h = [
    1779033703,
    4089235720,
    3144134277,
    2227873595,
    1013904242,
    4271175723,
    2773480762,
    1595750129,
    1359893119,
    2917565137,
    2600822924,
    725511199,
    528734635,
    4215389547,
    1541459225,
    327033209
  ], this.k = sha512_K, this.W = new Array(160);
}
utils$a.inherits(SHA512$1, BlockHash$1);
var _512 = SHA512$1;
SHA512$1.blockSize = 1024;
SHA512$1.outSize = 512;
SHA512$1.hmacStrength = 192;
SHA512$1.padLength = 128;
SHA512$1.prototype._prepareBlock = function(t, a) {
  for (var d = this.W, l = 0; l < 32; l++)
    d[l] = t[a + l];
  for (; l < d.length; l += 2) {
    var h = g1_512_hi(d[l - 4], d[l - 3]), g = g1_512_lo(d[l - 4], d[l - 3]), c = d[l - 14], x = d[l - 13], R = g0_512_hi(d[l - 30], d[l - 29]), B = g0_512_lo(d[l - 30], d[l - 29]), j = d[l - 32], o = d[l - 31];
    d[l] = sum64_4_hi(
      h,
      g,
      c,
      x,
      R,
      B,
      j,
      o
    ), d[l + 1] = sum64_4_lo(
      h,
      g,
      c,
      x,
      R,
      B,
      j,
      o
    );
  }
};
SHA512$1.prototype._update = function(t, a) {
  this._prepareBlock(t, a);
  var d = this.W, l = this.h[0], h = this.h[1], g = this.h[2], c = this.h[3], x = this.h[4], R = this.h[5], B = this.h[6], j = this.h[7], o = this.h[8], e = this.h[9], n = this.h[10], i = this.h[11], y = this.h[12], m = this.h[13], U = this.h[14], be = this.h[15];
  assert$8(this.k.length === d.length);
  for (var Ke = 0; Ke < d.length; Ke += 2) {
    var ze = U, Pe = be, st = s1_512_hi(o, e), G = s1_512_lo(o, e), z = ch64_hi(o, e, n, i, y), W = ch64_lo(o, e, n, i, y, m), F = this.k[Ke], k = this.k[Ke + 1], T = d[Ke], p = d[Ke + 1], b = sum64_5_hi(
      ze,
      Pe,
      st,
      G,
      z,
      W,
      F,
      k,
      T,
      p
    ), _ = sum64_5_lo(
      ze,
      Pe,
      st,
      G,
      z,
      W,
      F,
      k,
      T,
      p
    );
    ze = s0_512_hi(l, h), Pe = s0_512_lo(l, h), st = maj64_hi(l, h, g, c, x), G = maj64_lo(l, h, g, c, x, R);
    var v = sum64_hi(ze, Pe, st, G), S = sum64_lo(ze, Pe, st, G);
    U = y, be = m, y = n, m = i, n = o, i = e, o = sum64_hi(B, j, b, _), e = sum64_lo(j, j, b, _), B = x, j = R, x = g, R = c, g = l, c = h, l = sum64_hi(b, _, v, S), h = sum64_lo(b, _, v, S);
  }
  sum64(this.h, 0, l, h), sum64(this.h, 2, g, c), sum64(this.h, 4, x, R), sum64(this.h, 6, B, j), sum64(this.h, 8, o, e), sum64(this.h, 10, n, i), sum64(this.h, 12, y, m), sum64(this.h, 14, U, be);
};
SHA512$1.prototype._digest = function(t) {
  return t === "hex" ? utils$a.toHex32(this.h, "big") : utils$a.split32(this.h, "big");
};
function ch64_hi(u, t, a, d, l) {
  var h = u & a ^ ~u & l;
  return h < 0 && (h += 4294967296), h;
}
function ch64_lo(u, t, a, d, l, h) {
  var g = t & d ^ ~t & h;
  return g < 0 && (g += 4294967296), g;
}
function maj64_hi(u, t, a, d, l) {
  var h = u & a ^ u & l ^ a & l;
  return h < 0 && (h += 4294967296), h;
}
function maj64_lo(u, t, a, d, l, h) {
  var g = t & d ^ t & h ^ d & h;
  return g < 0 && (g += 4294967296), g;
}
function s0_512_hi(u, t) {
  var a = rotr64_hi(u, t, 28), d = rotr64_hi(t, u, 2), l = rotr64_hi(t, u, 7), h = a ^ d ^ l;
  return h < 0 && (h += 4294967296), h;
}
function s0_512_lo(u, t) {
  var a = rotr64_lo(u, t, 28), d = rotr64_lo(t, u, 2), l = rotr64_lo(t, u, 7), h = a ^ d ^ l;
  return h < 0 && (h += 4294967296), h;
}
function s1_512_hi(u, t) {
  var a = rotr64_hi(u, t, 14), d = rotr64_hi(u, t, 18), l = rotr64_hi(t, u, 9), h = a ^ d ^ l;
  return h < 0 && (h += 4294967296), h;
}
function s1_512_lo(u, t) {
  var a = rotr64_lo(u, t, 14), d = rotr64_lo(u, t, 18), l = rotr64_lo(t, u, 9), h = a ^ d ^ l;
  return h < 0 && (h += 4294967296), h;
}
function g0_512_hi(u, t) {
  var a = rotr64_hi(u, t, 1), d = rotr64_hi(u, t, 8), l = shr64_hi(u, t, 7), h = a ^ d ^ l;
  return h < 0 && (h += 4294967296), h;
}
function g0_512_lo(u, t) {
  var a = rotr64_lo(u, t, 1), d = rotr64_lo(u, t, 8), l = shr64_lo(u, t, 7), h = a ^ d ^ l;
  return h < 0 && (h += 4294967296), h;
}
function g1_512_hi(u, t) {
  var a = rotr64_hi(u, t, 19), d = rotr64_hi(t, u, 29), l = shr64_hi(u, t, 6), h = a ^ d ^ l;
  return h < 0 && (h += 4294967296), h;
}
function g1_512_lo(u, t) {
  var a = rotr64_lo(u, t, 19), d = rotr64_lo(t, u, 29), l = shr64_lo(u, t, 6), h = a ^ d ^ l;
  return h < 0 && (h += 4294967296), h;
}
var utils$9 = utils$g, SHA512 = _512;
function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();
  SHA512.call(this), this.h = [
    3418070365,
    3238371032,
    1654270250,
    914150663,
    2438529370,
    812702999,
    355462360,
    4144912697,
    1731405415,
    4290775857,
    2394180231,
    1750603025,
    3675008525,
    1694076839,
    1203062813,
    3204075428
  ];
}
utils$9.inherits(SHA384, SHA512);
var _384 = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function(t) {
  return t === "hex" ? utils$9.toHex32(this.h.slice(0, 12), "big") : utils$9.split32(this.h.slice(0, 12), "big");
};
sha.sha1 = _1;
sha.sha224 = _224;
sha.sha256 = _256;
sha.sha384 = _384;
sha.sha512 = _512;
var ripemd = {}, utils$8 = utils$g, common = common$5, rotl32 = utils$8.rotl32, sum32 = utils$8.sum32, sum32_3 = utils$8.sum32_3, sum32_4 = utils$8.sum32_4, BlockHash = common.BlockHash;
function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();
  BlockHash.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
}
utils$8.inherits(RIPEMD160, BlockHash);
ripemd.ripemd160 = RIPEMD160;
RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;
RIPEMD160.prototype._update = function(t, a) {
  for (var d = this.h[0], l = this.h[1], h = this.h[2], g = this.h[3], c = this.h[4], x = d, R = l, B = h, j = g, o = c, e = 0; e < 80; e++) {
    var n = sum32(
      rotl32(
        sum32_4(d, f$2(e, l, h, g), t[r[e] + a], K(e)),
        s[e]
      ),
      c
    );
    d = c, c = g, g = rotl32(h, 10), h = l, l = n, n = sum32(
      rotl32(
        sum32_4(x, f$2(79 - e, R, B, j), t[rh[e] + a], Kh(e)),
        sh[e]
      ),
      o
    ), x = o, o = j, j = rotl32(B, 10), B = R, R = n;
  }
  n = sum32_3(this.h[1], h, j), this.h[1] = sum32_3(this.h[2], g, o), this.h[2] = sum32_3(this.h[3], c, x), this.h[3] = sum32_3(this.h[4], d, R), this.h[4] = sum32_3(this.h[0], l, B), this.h[0] = n;
};
RIPEMD160.prototype._digest = function(t) {
  return t === "hex" ? utils$8.toHex32(this.h, "little") : utils$8.split32(this.h, "little");
};
function f$2(u, t, a, d) {
  return u <= 15 ? t ^ a ^ d : u <= 31 ? t & a | ~t & d : u <= 47 ? (t | ~a) ^ d : u <= 63 ? t & d | a & ~d : t ^ (a | ~d);
}
function K(u) {
  return u <= 15 ? 0 : u <= 31 ? 1518500249 : u <= 47 ? 1859775393 : u <= 63 ? 2400959708 : 2840853838;
}
function Kh(u) {
  return u <= 15 ? 1352829926 : u <= 31 ? 1548603684 : u <= 47 ? 1836072691 : u <= 63 ? 2053994217 : 0;
}
var r = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], rh = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], s = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], sh = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], utils$7 = utils$g, assert$7 = minimalisticAssert;
function Hmac(u, t, a) {
  if (!(this instanceof Hmac))
    return new Hmac(u, t, a);
  this.Hash = u, this.blockSize = u.blockSize / 8, this.outSize = u.outSize / 8, this.inner = null, this.outer = null, this._init(utils$7.toArray(t, a));
}
var hmac = Hmac;
Hmac.prototype._init = function(t) {
  t.length > this.blockSize && (t = new this.Hash().update(t).digest()), assert$7(t.length <= this.blockSize);
  for (var a = t.length; a < this.blockSize; a++)
    t.push(0);
  for (a = 0; a < t.length; a++)
    t[a] ^= 54;
  for (this.inner = new this.Hash().update(t), a = 0; a < t.length; a++)
    t[a] ^= 106;
  this.outer = new this.Hash().update(t);
};
Hmac.prototype.update = function(t, a) {
  return this.inner.update(t, a), this;
};
Hmac.prototype.digest = function(t) {
  return this.outer.update(this.inner.digest()), this.outer.digest(t);
};
(function(u) {
  var t = u;
  t.utils = utils$g, t.common = common$5, t.sha = sha, t.ripemd = ripemd, t.hmac = hmac, t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
})(hash$2);
var secp256k1$2, hasRequiredSecp256k1;
function requireSecp256k1() {
  return hasRequiredSecp256k1 || (hasRequiredSecp256k1 = 1, secp256k1$2 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), secp256k1$2;
}
(function(u) {
  var t = u, a = hash$2, d = curve, l = utils$m, h = l.assert;
  function g(R) {
    R.type === "short" ? this.curve = new d.short(R) : R.type === "edwards" ? this.curve = new d.edwards(R) : this.curve = new d.mont(R), this.g = this.curve.g, this.n = this.curve.n, this.hash = R.hash, h(this.g.validate(), "Invalid curve"), h(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }
  t.PresetCurve = g;
  function c(R, B) {
    Object.defineProperty(t, R, {
      configurable: !0,
      enumerable: !0,
      get: function() {
        var j = new g(B);
        return Object.defineProperty(t, R, {
          configurable: !0,
          enumerable: !0,
          value: j
        }), j;
      }
    });
  }
  c("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: a.sha256,
    gRed: !1,
    g: [
      "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
      "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
  }), c("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: a.sha256,
    gRed: !1,
    g: [
      "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
      "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
  }), c("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: a.sha256,
    gRed: !1,
    g: [
      "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
      "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
  }), c("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: a.sha384,
    gRed: !1,
    g: [
      "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
      "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
  }), c("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: a.sha512,
    gRed: !1,
    g: [
      "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
      "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
  }), c("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: a.sha256,
    gRed: !1,
    g: [
      "9"
    ]
  }), c("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: a.sha256,
    gRed: !1,
    g: [
      "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
      "6666666666666666666666666666666666666666666666666666666666666658"
    ]
  });
  var x;
  try {
    x = requireSecp256k1();
  } catch {
    x = void 0;
  }
  c("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: a.sha256,
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
      {
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      },
      {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }
    ],
    gRed: !1,
    g: [
      "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
      "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
      x
    ]
  });
})(curves$2);
var hash$1 = hash$2, utils$6 = utils$l, assert$6 = minimalisticAssert;
function HmacDRBG$1(u) {
  if (!(this instanceof HmacDRBG$1))
    return new HmacDRBG$1(u);
  this.hash = u.hash, this.predResist = !!u.predResist, this.outLen = this.hash.outSize, this.minEntropy = u.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
  var t = utils$6.toArray(u.entropy, u.entropyEnc || "hex"), a = utils$6.toArray(u.nonce, u.nonceEnc || "hex"), d = utils$6.toArray(u.pers, u.persEnc || "hex");
  assert$6(
    t.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._init(t, a, d);
}
var hmacDrbg = HmacDRBG$1;
HmacDRBG$1.prototype._init = function(t, a, d) {
  var l = t.concat(a).concat(d);
  this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
  for (var h = 0; h < this.V.length; h++)
    this.K[h] = 0, this.V[h] = 1;
  this._update(l), this._reseed = 1, this.reseedInterval = 281474976710656;
};
HmacDRBG$1.prototype._hmac = function() {
  return new hash$1.hmac(this.hash, this.K);
};
HmacDRBG$1.prototype._update = function(t) {
  var a = this._hmac().update(this.V).update([0]);
  t && (a = a.update(t)), this.K = a.digest(), this.V = this._hmac().update(this.V).digest(), t && (this.K = this._hmac().update(this.V).update([1]).update(t).digest(), this.V = this._hmac().update(this.V).digest());
};
HmacDRBG$1.prototype.reseed = function(t, a, d, l) {
  typeof a != "string" && (l = d, d = a, a = null), t = utils$6.toArray(t, a), d = utils$6.toArray(d, l), assert$6(
    t.length >= this.minEntropy / 8,
    "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
  ), this._update(t.concat(d || [])), this._reseed = 1;
};
HmacDRBG$1.prototype.generate = function(t, a, d, l) {
  if (this._reseed > this.reseedInterval)
    throw new Error("Reseed is required");
  typeof a != "string" && (l = d, d = a, a = null), d && (d = utils$6.toArray(d, l || "hex"), this._update(d));
  for (var h = []; h.length < t; )
    this.V = this._hmac().update(this.V).digest(), h = h.concat(this.V);
  var g = h.slice(0, t);
  return this._update(d), this._reseed++, utils$6.encode(g, a);
};
var BN$5 = bn$2.exports, utils$5 = utils$m, assert$5 = utils$5.assert;
function KeyPair$3(u, t) {
  this.ec = u, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
}
var key$1 = KeyPair$3;
KeyPair$3.fromPublic = function(t, a, d) {
  return a instanceof KeyPair$3 ? a : new KeyPair$3(t, {
    pub: a,
    pubEnc: d
  });
};
KeyPair$3.fromPrivate = function(t, a, d) {
  return a instanceof KeyPair$3 ? a : new KeyPair$3(t, {
    priv: a,
    privEnc: d
  });
};
KeyPair$3.prototype.validate = function() {
  var t = this.getPublic();
  return t.isInfinity() ? { result: !1, reason: "Invalid public key" } : t.validate() ? t.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
};
KeyPair$3.prototype.getPublic = function(t, a) {
  return typeof t == "string" && (a = t, t = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), a ? this.pub.encode(a, t) : this.pub;
};
KeyPair$3.prototype.getPrivate = function(t) {
  return t === "hex" ? this.priv.toString(16, 2) : this.priv;
};
KeyPair$3.prototype._importPrivate = function(t, a) {
  this.priv = new BN$5(t, a || 16), this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair$3.prototype._importPublic = function(t, a) {
  if (t.x || t.y) {
    this.ec.curve.type === "mont" ? assert$5(t.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && assert$5(t.x && t.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(t.x, t.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(t, a);
};
KeyPair$3.prototype.derive = function(t) {
  return t.validate() || assert$5(t.validate(), "public point not validated"), t.mul(this.priv).getX();
};
KeyPair$3.prototype.sign = function(t, a, d) {
  return this.ec.sign(t, this, a, d);
};
KeyPair$3.prototype.verify = function(t, a) {
  return this.ec.verify(t, a, this);
};
KeyPair$3.prototype.inspect = function() {
  return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
var BN$4 = bn$2.exports, utils$4 = utils$m, assert$4 = utils$4.assert;
function Signature$3(u, t) {
  if (u instanceof Signature$3)
    return u;
  this._importDER(u, t) || (assert$4(u.r && u.s, "Signature without r or s"), this.r = new BN$4(u.r, 16), this.s = new BN$4(u.s, 16), u.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = u.recoveryParam);
}
var signature$1 = Signature$3;
function Position() {
  this.place = 0;
}
function getLength(u, t) {
  var a = u[t.place++];
  if (!(a & 128))
    return a;
  var d = a & 15;
  if (d === 0 || d > 4)
    return !1;
  for (var l = 0, h = 0, g = t.place; h < d; h++, g++)
    l <<= 8, l |= u[g], l >>>= 0;
  return l <= 127 ? !1 : (t.place = g, l);
}
function rmPadding(u) {
  for (var t = 0, a = u.length - 1; !u[t] && !(u[t + 1] & 128) && t < a; )
    t++;
  return t === 0 ? u : u.slice(t);
}
Signature$3.prototype._importDER = function(t, a) {
  t = utils$4.toArray(t, a);
  var d = new Position();
  if (t[d.place++] !== 48)
    return !1;
  var l = getLength(t, d);
  if (l === !1 || l + d.place !== t.length || t[d.place++] !== 2)
    return !1;
  var h = getLength(t, d);
  if (h === !1)
    return !1;
  var g = t.slice(d.place, h + d.place);
  if (d.place += h, t[d.place++] !== 2)
    return !1;
  var c = getLength(t, d);
  if (c === !1 || t.length !== c + d.place)
    return !1;
  var x = t.slice(d.place, c + d.place);
  if (g[0] === 0)
    if (g[1] & 128)
      g = g.slice(1);
    else
      return !1;
  if (x[0] === 0)
    if (x[1] & 128)
      x = x.slice(1);
    else
      return !1;
  return this.r = new BN$4(g), this.s = new BN$4(x), this.recoveryParam = null, !0;
};
function constructLength(u, t) {
  if (t < 128) {
    u.push(t);
    return;
  }
  var a = 1 + (Math.log(t) / Math.LN2 >>> 3);
  for (u.push(a | 128); --a; )
    u.push(t >>> (a << 3) & 255);
  u.push(t);
}
Signature$3.prototype.toDER = function(t) {
  var a = this.r.toArray(), d = this.s.toArray();
  for (a[0] & 128 && (a = [0].concat(a)), d[0] & 128 && (d = [0].concat(d)), a = rmPadding(a), d = rmPadding(d); !d[0] && !(d[1] & 128); )
    d = d.slice(1);
  var l = [2];
  constructLength(l, a.length), l = l.concat(a), l.push(2), constructLength(l, d.length);
  var h = l.concat(d), g = [48];
  return constructLength(g, h.length), g = g.concat(h), utils$4.encode(g, t);
};
var BN$3 = bn$2.exports, HmacDRBG = hmacDrbg, utils$3 = utils$m, curves$1 = curves$2, rand = brorand.exports, assert$3 = utils$3.assert, KeyPair$2 = key$1, Signature$2 = signature$1;
function EC(u) {
  if (!(this instanceof EC))
    return new EC(u);
  typeof u == "string" && (assert$3(
    Object.prototype.hasOwnProperty.call(curves$1, u),
    "Unknown curve " + u
  ), u = curves$1[u]), u instanceof curves$1.PresetCurve && (u = { curve: u }), this.curve = u.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = u.curve.g, this.g.precompute(u.curve.n.bitLength() + 1), this.hash = u.hash || u.curve.hash;
}
var ec = EC;
EC.prototype.keyPair = function(t) {
  return new KeyPair$2(this, t);
};
EC.prototype.keyFromPrivate = function(t, a) {
  return KeyPair$2.fromPrivate(this, t, a);
};
EC.prototype.keyFromPublic = function(t, a) {
  return KeyPair$2.fromPublic(this, t, a);
};
EC.prototype.genKeyPair = function(t) {
  t || (t = {});
  for (var a = new HmacDRBG({
    hash: this.hash,
    pers: t.pers,
    persEnc: t.persEnc || "utf8",
    entropy: t.entropy || rand(this.hash.hmacStrength),
    entropyEnc: t.entropy && t.entropyEnc || "utf8",
    nonce: this.n.toArray()
  }), d = this.n.byteLength(), l = this.n.sub(new BN$3(2)); ; ) {
    var h = new BN$3(a.generate(d));
    if (!(h.cmp(l) > 0))
      return h.iaddn(1), this.keyFromPrivate(h);
  }
};
EC.prototype._truncateToN = function(t, a) {
  var d = t.byteLength() * 8 - this.n.bitLength();
  return d > 0 && (t = t.ushrn(d)), !a && t.cmp(this.n) >= 0 ? t.sub(this.n) : t;
};
EC.prototype.sign = function(t, a, d, l) {
  typeof d == "object" && (l = d, d = null), l || (l = {}), a = this.keyFromPrivate(a, d), t = this._truncateToN(new BN$3(t, 16));
  for (var h = this.n.byteLength(), g = a.getPrivate().toArray("be", h), c = t.toArray("be", h), x = new HmacDRBG({
    hash: this.hash,
    entropy: g,
    nonce: c,
    pers: l.pers,
    persEnc: l.persEnc || "utf8"
  }), R = this.n.sub(new BN$3(1)), B = 0; ; B++) {
    var j = l.k ? l.k(B) : new BN$3(x.generate(this.n.byteLength()));
    if (j = this._truncateToN(j, !0), !(j.cmpn(1) <= 0 || j.cmp(R) >= 0)) {
      var o = this.g.mul(j);
      if (!o.isInfinity()) {
        var e = o.getX(), n = e.umod(this.n);
        if (n.cmpn(0) !== 0) {
          var i = j.invm(this.n).mul(n.mul(a.getPrivate()).iadd(t));
          if (i = i.umod(this.n), i.cmpn(0) !== 0) {
            var y = (o.getY().isOdd() ? 1 : 0) | (e.cmp(n) !== 0 ? 2 : 0);
            return l.canonical && i.cmp(this.nh) > 0 && (i = this.n.sub(i), y ^= 1), new Signature$2({ r: n, s: i, recoveryParam: y });
          }
        }
      }
    }
  }
};
EC.prototype.verify = function(t, a, d, l) {
  t = this._truncateToN(new BN$3(t, 16)), d = this.keyFromPublic(d, l), a = new Signature$2(a, "hex");
  var h = a.r, g = a.s;
  if (h.cmpn(1) < 0 || h.cmp(this.n) >= 0 || g.cmpn(1) < 0 || g.cmp(this.n) >= 0)
    return !1;
  var c = g.invm(this.n), x = c.mul(t).umod(this.n), R = c.mul(h).umod(this.n), B;
  return this.curve._maxwellTrick ? (B = this.g.jmulAdd(x, d.getPublic(), R), B.isInfinity() ? !1 : B.eqXToP(h)) : (B = this.g.mulAdd(x, d.getPublic(), R), B.isInfinity() ? !1 : B.getX().umod(this.n).cmp(h) === 0);
};
EC.prototype.recoverPubKey = function(u, t, a, d) {
  assert$3((3 & a) === a, "The recovery param is more than two bits"), t = new Signature$2(t, d);
  var l = this.n, h = new BN$3(u), g = t.r, c = t.s, x = a & 1, R = a >> 1;
  if (g.cmp(this.curve.p.umod(this.curve.n)) >= 0 && R)
    throw new Error("Unable to find sencond key candinate");
  R ? g = this.curve.pointFromX(g.add(this.curve.n), x) : g = this.curve.pointFromX(g, x);
  var B = t.r.invm(l), j = l.sub(h).mul(B).umod(l), o = c.mul(B).umod(l);
  return this.g.mulAdd(j, g, o);
};
EC.prototype.getKeyRecoveryParam = function(u, t, a, d) {
  if (t = new Signature$2(t, d), t.recoveryParam !== null)
    return t.recoveryParam;
  for (var l = 0; l < 4; l++) {
    var h;
    try {
      h = this.recoverPubKey(u, t, l);
    } catch {
      continue;
    }
    if (h.eq(a))
      return l;
  }
  throw new Error("Unable to find valid recovery factor");
};
var utils$2 = utils$m, assert$2 = utils$2.assert, parseBytes$2 = utils$2.parseBytes, cachedProperty$1 = utils$2.cachedProperty;
function KeyPair$1(u, t) {
  this.eddsa = u, this._secret = parseBytes$2(t.secret), u.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = parseBytes$2(t.pub);
}
KeyPair$1.fromPublic = function(t, a) {
  return a instanceof KeyPair$1 ? a : new KeyPair$1(t, { pub: a });
};
KeyPair$1.fromSecret = function(t, a) {
  return a instanceof KeyPair$1 ? a : new KeyPair$1(t, { secret: a });
};
KeyPair$1.prototype.secret = function() {
  return this._secret;
};
cachedProperty$1(KeyPair$1, "pubBytes", function() {
  return this.eddsa.encodePoint(this.pub());
});
cachedProperty$1(KeyPair$1, "pub", function() {
  return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
});
cachedProperty$1(KeyPair$1, "privBytes", function() {
  var t = this.eddsa, a = this.hash(), d = t.encodingLength - 1, l = a.slice(0, t.encodingLength);
  return l[0] &= 248, l[d] &= 127, l[d] |= 64, l;
});
cachedProperty$1(KeyPair$1, "priv", function() {
  return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty$1(KeyPair$1, "hash", function() {
  return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty$1(KeyPair$1, "messagePrefix", function() {
  return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair$1.prototype.sign = function(t) {
  return assert$2(this._secret, "KeyPair can only verify"), this.eddsa.sign(t, this);
};
KeyPair$1.prototype.verify = function(t, a) {
  return this.eddsa.verify(t, a, this);
};
KeyPair$1.prototype.getSecret = function(t) {
  return assert$2(this._secret, "KeyPair is public only"), utils$2.encode(this.secret(), t);
};
KeyPair$1.prototype.getPublic = function(t) {
  return utils$2.encode(this.pubBytes(), t);
};
var key = KeyPair$1, BN$2 = bn$2.exports, utils$1 = utils$m, assert$1 = utils$1.assert, cachedProperty = utils$1.cachedProperty, parseBytes$1 = utils$1.parseBytes;
function Signature$1(u, t) {
  this.eddsa = u, typeof t != "object" && (t = parseBytes$1(t)), Array.isArray(t) && (t = {
    R: t.slice(0, u.encodingLength),
    S: t.slice(u.encodingLength)
  }), assert$1(t.R && t.S, "Signature without R or S"), u.isPoint(t.R) && (this._R = t.R), t.S instanceof BN$2 && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
}
cachedProperty(Signature$1, "S", function() {
  return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature$1, "R", function() {
  return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature$1, "Rencoded", function() {
  return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature$1, "Sencoded", function() {
  return this.eddsa.encodeInt(this.S());
});
Signature$1.prototype.toBytes = function() {
  return this.Rencoded().concat(this.Sencoded());
};
Signature$1.prototype.toHex = function() {
  return utils$1.encode(this.toBytes(), "hex").toUpperCase();
};
var signature = Signature$1, hash = hash$2, curves = curves$2, utils = utils$m, assert = utils.assert, parseBytes = utils.parseBytes, KeyPair = key, Signature = signature;
function EDDSA(u) {
  if (assert(u === "ed25519", "only tested with ed25519 so far"), !(this instanceof EDDSA))
    return new EDDSA(u);
  u = curves[u].curve, this.curve = u, this.g = u.g, this.g.precompute(u.n.bitLength() + 1), this.pointClass = u.point().constructor, this.encodingLength = Math.ceil(u.n.bitLength() / 8), this.hash = hash.sha512;
}
var eddsa = EDDSA;
EDDSA.prototype.sign = function(t, a) {
  t = parseBytes(t);
  var d = this.keyFromSecret(a), l = this.hashInt(d.messagePrefix(), t), h = this.g.mul(l), g = this.encodePoint(h), c = this.hashInt(g, d.pubBytes(), t).mul(d.priv()), x = l.add(c).umod(this.curve.n);
  return this.makeSignature({ R: h, S: x, Rencoded: g });
};
EDDSA.prototype.verify = function(t, a, d) {
  t = parseBytes(t), a = this.makeSignature(a);
  var l = this.keyFromPublic(d), h = this.hashInt(a.Rencoded(), l.pubBytes(), t), g = this.g.mul(a.S()), c = a.R().add(l.pub().mul(h));
  return c.eq(g);
};
EDDSA.prototype.hashInt = function() {
  for (var t = this.hash(), a = 0; a < arguments.length; a++)
    t.update(arguments[a]);
  return utils.intFromLE(t.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function(t) {
  return KeyPair.fromPublic(this, t);
};
EDDSA.prototype.keyFromSecret = function(t) {
  return KeyPair.fromSecret(this, t);
};
EDDSA.prototype.makeSignature = function(t) {
  return t instanceof Signature ? t : new Signature(this, t);
};
EDDSA.prototype.encodePoint = function(t) {
  var a = t.getY().toArray("le", this.encodingLength);
  return a[this.encodingLength - 1] |= t.getX().isOdd() ? 128 : 0, a;
};
EDDSA.prototype.decodePoint = function(t) {
  t = utils.parseBytes(t);
  var a = t.length - 1, d = t.slice(0, a).concat(t[a] & -129), l = (t[a] & 128) !== 0, h = utils.intFromLE(d);
  return this.curve.pointFromY(h, l);
};
EDDSA.prototype.encodeInt = function(t) {
  return t.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function(t) {
  return utils.intFromLE(t);
};
EDDSA.prototype.isPoint = function(t) {
  return t instanceof this.pointClass;
};
(function(u) {
  var t = u;
  t.version = require$$0.version, t.utils = utils$m, t.rand = brorand.exports, t.curve = curve, t.curves = curves$2, t.ec = ec, t.eddsa = eddsa;
})(elliptic);
var bn$1 = { exports: {} };
(function(u) {
  (function(t, a) {
    function d(T, p) {
      if (!T)
        throw new Error(p || "Assertion failed");
    }
    function l(T, p) {
      T.super_ = p;
      var b = function() {
      };
      b.prototype = p.prototype, T.prototype = new b(), T.prototype.constructor = T;
    }
    function h(T, p, b) {
      if (h.isBN(T))
        return T;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, T !== null && ((p === "le" || p === "be") && (b = p, p = 10), this._init(T || 0, p || 10, b || "be"));
    }
    typeof t == "object" ? t.exports = h : a.BN = h, h.BN = h, h.wordSize = 26;
    var g;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? g = window.Buffer : g = require$$0$1.Buffer;
    } catch {
    }
    h.isBN = function(p) {
      return p instanceof h ? !0 : p !== null && typeof p == "object" && p.constructor.wordSize === h.wordSize && Array.isArray(p.words);
    }, h.max = function(p, b) {
      return p.cmp(b) > 0 ? p : b;
    }, h.min = function(p, b) {
      return p.cmp(b) < 0 ? p : b;
    }, h.prototype._init = function(p, b, _) {
      if (typeof p == "number")
        return this._initNumber(p, b, _);
      if (typeof p == "object")
        return this._initArray(p, b, _);
      b === "hex" && (b = 16), d(b === (b | 0) && b >= 2 && b <= 36), p = p.toString().replace(/\s+/g, "");
      var v = 0;
      p[0] === "-" && (v++, this.negative = 1), v < p.length && (b === 16 ? this._parseHex(p, v, _) : (this._parseBase(p, b, v), _ === "le" && this._initArray(this.toArray(), b, _)));
    }, h.prototype._initNumber = function(p, b, _) {
      p < 0 && (this.negative = 1, p = -p), p < 67108864 ? (this.words = [p & 67108863], this.length = 1) : p < 4503599627370496 ? (this.words = [
        p & 67108863,
        p / 67108864 & 67108863
      ], this.length = 2) : (d(p < 9007199254740992), this.words = [
        p & 67108863,
        p / 67108864 & 67108863,
        1
      ], this.length = 3), _ === "le" && this._initArray(this.toArray(), b, _);
    }, h.prototype._initArray = function(p, b, _) {
      if (d(typeof p.length == "number"), p.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(p.length / 3), this.words = new Array(this.length);
      for (var v = 0; v < this.length; v++)
        this.words[v] = 0;
      var S, E, w = 0;
      if (_ === "be")
        for (v = p.length - 1, S = 0; v >= 0; v -= 3)
          E = p[v] | p[v - 1] << 8 | p[v - 2] << 16, this.words[S] |= E << w & 67108863, this.words[S + 1] = E >>> 26 - w & 67108863, w += 24, w >= 26 && (w -= 26, S++);
      else if (_ === "le")
        for (v = 0, S = 0; v < p.length; v += 3)
          E = p[v] | p[v + 1] << 8 | p[v + 2] << 16, this.words[S] |= E << w & 67108863, this.words[S + 1] = E >>> 26 - w & 67108863, w += 24, w >= 26 && (w -= 26, S++);
      return this._strip();
    };
    function c(T, p) {
      var b = T.charCodeAt(p);
      if (b >= 48 && b <= 57)
        return b - 48;
      if (b >= 65 && b <= 70)
        return b - 55;
      if (b >= 97 && b <= 102)
        return b - 87;
      d(!1, "Invalid character in " + T);
    }
    function x(T, p, b) {
      var _ = c(T, b);
      return b - 1 >= p && (_ |= c(T, b - 1) << 4), _;
    }
    h.prototype._parseHex = function(p, b, _) {
      this.length = Math.ceil((p.length - b) / 6), this.words = new Array(this.length);
      for (var v = 0; v < this.length; v++)
        this.words[v] = 0;
      var S = 0, E = 0, w;
      if (_ === "be")
        for (v = p.length - 1; v >= b; v -= 2)
          w = x(p, b, v) << S, this.words[E] |= w & 67108863, S >= 18 ? (S -= 18, E += 1, this.words[E] |= w >>> 26) : S += 8;
      else {
        var A = p.length - b;
        for (v = A % 2 === 0 ? b + 1 : b; v < p.length; v += 2)
          w = x(p, b, v) << S, this.words[E] |= w & 67108863, S >= 18 ? (S -= 18, E += 1, this.words[E] |= w >>> 26) : S += 8;
      }
      this._strip();
    };
    function R(T, p, b, _) {
      for (var v = 0, S = 0, E = Math.min(T.length, b), w = p; w < E; w++) {
        var A = T.charCodeAt(w) - 48;
        v *= _, A >= 49 ? S = A - 49 + 10 : A >= 17 ? S = A - 17 + 10 : S = A, d(A >= 0 && S < _, "Invalid character"), v += S;
      }
      return v;
    }
    h.prototype._parseBase = function(p, b, _) {
      this.words = [0], this.length = 1;
      for (var v = 0, S = 1; S <= 67108863; S *= b)
        v++;
      v--, S = S / b | 0;
      for (var E = p.length - _, w = E % v, A = Math.min(E, E - w) + _, I = 0, C = _; C < A; C += v)
        I = R(p, C, C + v, b), this.imuln(S), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
      if (w !== 0) {
        var X = 1;
        for (I = R(p, C, p.length, b), C = 0; C < w; C++)
          X *= b;
        this.imuln(X), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
      }
      this._strip();
    }, h.prototype.copy = function(p) {
      p.words = new Array(this.length);
      for (var b = 0; b < this.length; b++)
        p.words[b] = this.words[b];
      p.length = this.length, p.negative = this.negative, p.red = this.red;
    };
    function B(T, p) {
      T.words = p.words, T.length = p.length, T.negative = p.negative, T.red = p.red;
    }
    if (h.prototype._move = function(p) {
      B(p, this);
    }, h.prototype.clone = function() {
      var p = new h(null);
      return this.copy(p), p;
    }, h.prototype._expand = function(p) {
      for (; this.length < p; )
        this.words[this.length++] = 0;
      return this;
    }, h.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, h.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        h.prototype[Symbol.for("nodejs.util.inspect.custom")] = j;
      } catch {
        h.prototype.inspect = j;
      }
    else
      h.prototype.inspect = j;
    function j() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var o = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], e = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], n = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    h.prototype.toString = function(p, b) {
      p = p || 10, b = b | 0 || 1;
      var _;
      if (p === 16 || p === "hex") {
        _ = "";
        for (var v = 0, S = 0, E = 0; E < this.length; E++) {
          var w = this.words[E], A = ((w << v | S) & 16777215).toString(16);
          S = w >>> 24 - v & 16777215, v += 2, v >= 26 && (v -= 26, E--), S !== 0 || E !== this.length - 1 ? _ = o[6 - A.length] + A + _ : _ = A + _;
        }
        for (S !== 0 && (_ = S.toString(16) + _); _.length % b !== 0; )
          _ = "0" + _;
        return this.negative !== 0 && (_ = "-" + _), _;
      }
      if (p === (p | 0) && p >= 2 && p <= 36) {
        var I = e[p], C = n[p];
        _ = "";
        var X = this.clone();
        for (X.negative = 0; !X.isZero(); ) {
          var D = X.modrn(C).toString(p);
          X = X.idivn(C), X.isZero() ? _ = D + _ : _ = o[I - D.length] + D + _;
        }
        for (this.isZero() && (_ = "0" + _); _.length % b !== 0; )
          _ = "0" + _;
        return this.negative !== 0 && (_ = "-" + _), _;
      }
      d(!1, "Base should be between 2 and 36");
    }, h.prototype.toNumber = function() {
      var p = this.words[0];
      return this.length === 2 ? p += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? p += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && d(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -p : p;
    }, h.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, g && (h.prototype.toBuffer = function(p, b) {
      return this.toArrayLike(g, p, b);
    }), h.prototype.toArray = function(p, b) {
      return this.toArrayLike(Array, p, b);
    };
    var i = function(p, b) {
      return p.allocUnsafe ? p.allocUnsafe(b) : new p(b);
    };
    h.prototype.toArrayLike = function(p, b, _) {
      this._strip();
      var v = this.byteLength(), S = _ || Math.max(1, v);
      d(v <= S, "byte array longer than desired length"), d(S > 0, "Requested array length <= 0");
      var E = i(p, S), w = b === "le" ? "LE" : "BE";
      return this["_toArrayLike" + w](E, v), E;
    }, h.prototype._toArrayLikeLE = function(p, b) {
      for (var _ = 0, v = 0, S = 0, E = 0; S < this.length; S++) {
        var w = this.words[S] << E | v;
        p[_++] = w & 255, _ < p.length && (p[_++] = w >> 8 & 255), _ < p.length && (p[_++] = w >> 16 & 255), E === 6 ? (_ < p.length && (p[_++] = w >> 24 & 255), v = 0, E = 0) : (v = w >>> 24, E += 2);
      }
      if (_ < p.length)
        for (p[_++] = v; _ < p.length; )
          p[_++] = 0;
    }, h.prototype._toArrayLikeBE = function(p, b) {
      for (var _ = p.length - 1, v = 0, S = 0, E = 0; S < this.length; S++) {
        var w = this.words[S] << E | v;
        p[_--] = w & 255, _ >= 0 && (p[_--] = w >> 8 & 255), _ >= 0 && (p[_--] = w >> 16 & 255), E === 6 ? (_ >= 0 && (p[_--] = w >> 24 & 255), v = 0, E = 0) : (v = w >>> 24, E += 2);
      }
      if (_ >= 0)
        for (p[_--] = v; _ >= 0; )
          p[_--] = 0;
    }, Math.clz32 ? h.prototype._countBits = function(p) {
      return 32 - Math.clz32(p);
    } : h.prototype._countBits = function(p) {
      var b = p, _ = 0;
      return b >= 4096 && (_ += 13, b >>>= 13), b >= 64 && (_ += 7, b >>>= 7), b >= 8 && (_ += 4, b >>>= 4), b >= 2 && (_ += 2, b >>>= 2), _ + b;
    }, h.prototype._zeroBits = function(p) {
      if (p === 0)
        return 26;
      var b = p, _ = 0;
      return (b & 8191) === 0 && (_ += 13, b >>>= 13), (b & 127) === 0 && (_ += 7, b >>>= 7), (b & 15) === 0 && (_ += 4, b >>>= 4), (b & 3) === 0 && (_ += 2, b >>>= 2), (b & 1) === 0 && _++, _;
    }, h.prototype.bitLength = function() {
      var p = this.words[this.length - 1], b = this._countBits(p);
      return (this.length - 1) * 26 + b;
    };
    function y(T) {
      for (var p = new Array(T.bitLength()), b = 0; b < p.length; b++) {
        var _ = b / 26 | 0, v = b % 26;
        p[b] = T.words[_] >>> v & 1;
      }
      return p;
    }
    h.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var p = 0, b = 0; b < this.length; b++) {
        var _ = this._zeroBits(this.words[b]);
        if (p += _, _ !== 26)
          break;
      }
      return p;
    }, h.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, h.prototype.toTwos = function(p) {
      return this.negative !== 0 ? this.abs().inotn(p).iaddn(1) : this.clone();
    }, h.prototype.fromTwos = function(p) {
      return this.testn(p - 1) ? this.notn(p).iaddn(1).ineg() : this.clone();
    }, h.prototype.isNeg = function() {
      return this.negative !== 0;
    }, h.prototype.neg = function() {
      return this.clone().ineg();
    }, h.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, h.prototype.iuor = function(p) {
      for (; this.length < p.length; )
        this.words[this.length++] = 0;
      for (var b = 0; b < p.length; b++)
        this.words[b] = this.words[b] | p.words[b];
      return this._strip();
    }, h.prototype.ior = function(p) {
      return d((this.negative | p.negative) === 0), this.iuor(p);
    }, h.prototype.or = function(p) {
      return this.length > p.length ? this.clone().ior(p) : p.clone().ior(this);
    }, h.prototype.uor = function(p) {
      return this.length > p.length ? this.clone().iuor(p) : p.clone().iuor(this);
    }, h.prototype.iuand = function(p) {
      var b;
      this.length > p.length ? b = p : b = this;
      for (var _ = 0; _ < b.length; _++)
        this.words[_] = this.words[_] & p.words[_];
      return this.length = b.length, this._strip();
    }, h.prototype.iand = function(p) {
      return d((this.negative | p.negative) === 0), this.iuand(p);
    }, h.prototype.and = function(p) {
      return this.length > p.length ? this.clone().iand(p) : p.clone().iand(this);
    }, h.prototype.uand = function(p) {
      return this.length > p.length ? this.clone().iuand(p) : p.clone().iuand(this);
    }, h.prototype.iuxor = function(p) {
      var b, _;
      this.length > p.length ? (b = this, _ = p) : (b = p, _ = this);
      for (var v = 0; v < _.length; v++)
        this.words[v] = b.words[v] ^ _.words[v];
      if (this !== b)
        for (; v < b.length; v++)
          this.words[v] = b.words[v];
      return this.length = b.length, this._strip();
    }, h.prototype.ixor = function(p) {
      return d((this.negative | p.negative) === 0), this.iuxor(p);
    }, h.prototype.xor = function(p) {
      return this.length > p.length ? this.clone().ixor(p) : p.clone().ixor(this);
    }, h.prototype.uxor = function(p) {
      return this.length > p.length ? this.clone().iuxor(p) : p.clone().iuxor(this);
    }, h.prototype.inotn = function(p) {
      d(typeof p == "number" && p >= 0);
      var b = Math.ceil(p / 26) | 0, _ = p % 26;
      this._expand(b), _ > 0 && b--;
      for (var v = 0; v < b; v++)
        this.words[v] = ~this.words[v] & 67108863;
      return _ > 0 && (this.words[v] = ~this.words[v] & 67108863 >> 26 - _), this._strip();
    }, h.prototype.notn = function(p) {
      return this.clone().inotn(p);
    }, h.prototype.setn = function(p, b) {
      d(typeof p == "number" && p >= 0);
      var _ = p / 26 | 0, v = p % 26;
      return this._expand(_ + 1), b ? this.words[_] = this.words[_] | 1 << v : this.words[_] = this.words[_] & ~(1 << v), this._strip();
    }, h.prototype.iadd = function(p) {
      var b;
      if (this.negative !== 0 && p.negative === 0)
        return this.negative = 0, b = this.isub(p), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && p.negative !== 0)
        return p.negative = 0, b = this.isub(p), p.negative = 1, b._normSign();
      var _, v;
      this.length > p.length ? (_ = this, v = p) : (_ = p, v = this);
      for (var S = 0, E = 0; E < v.length; E++)
        b = (_.words[E] | 0) + (v.words[E] | 0) + S, this.words[E] = b & 67108863, S = b >>> 26;
      for (; S !== 0 && E < _.length; E++)
        b = (_.words[E] | 0) + S, this.words[E] = b & 67108863, S = b >>> 26;
      if (this.length = _.length, S !== 0)
        this.words[this.length] = S, this.length++;
      else if (_ !== this)
        for (; E < _.length; E++)
          this.words[E] = _.words[E];
      return this;
    }, h.prototype.add = function(p) {
      var b;
      return p.negative !== 0 && this.negative === 0 ? (p.negative = 0, b = this.sub(p), p.negative ^= 1, b) : p.negative === 0 && this.negative !== 0 ? (this.negative = 0, b = p.sub(this), this.negative = 1, b) : this.length > p.length ? this.clone().iadd(p) : p.clone().iadd(this);
    }, h.prototype.isub = function(p) {
      if (p.negative !== 0) {
        p.negative = 0;
        var b = this.iadd(p);
        return p.negative = 1, b._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(p), this.negative = 1, this._normSign();
      var _ = this.cmp(p);
      if (_ === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var v, S;
      _ > 0 ? (v = this, S = p) : (v = p, S = this);
      for (var E = 0, w = 0; w < S.length; w++)
        b = (v.words[w] | 0) - (S.words[w] | 0) + E, E = b >> 26, this.words[w] = b & 67108863;
      for (; E !== 0 && w < v.length; w++)
        b = (v.words[w] | 0) + E, E = b >> 26, this.words[w] = b & 67108863;
      if (E === 0 && w < v.length && v !== this)
        for (; w < v.length; w++)
          this.words[w] = v.words[w];
      return this.length = Math.max(this.length, w), v !== this && (this.negative = 1), this._strip();
    }, h.prototype.sub = function(p) {
      return this.clone().isub(p);
    };
    function m(T, p, b) {
      b.negative = p.negative ^ T.negative;
      var _ = T.length + p.length | 0;
      b.length = _, _ = _ - 1 | 0;
      var v = T.words[0] | 0, S = p.words[0] | 0, E = v * S, w = E & 67108863, A = E / 67108864 | 0;
      b.words[0] = w;
      for (var I = 1; I < _; I++) {
        for (var C = A >>> 26, X = A & 67108863, D = Math.min(I, p.length - 1), V = Math.max(0, I - T.length + 1); V <= D; V++) {
          var Z = I - V | 0;
          v = T.words[Z] | 0, S = p.words[V] | 0, E = v * S + X, C += E / 67108864 | 0, X = E & 67108863;
        }
        b.words[I] = X | 0, A = C | 0;
      }
      return A !== 0 ? b.words[I] = A | 0 : b.length--, b._strip();
    }
    var U = function(p, b, _) {
      var v = p.words, S = b.words, E = _.words, w = 0, A, I, C, X = v[0] | 0, D = X & 8191, V = X >>> 13, Z = v[1] | 0, J = Z & 8191, ee = Z >>> 13, he = v[2] | 0, le = he & 8191, ie = he >>> 13, Ne = v[3] | 0, ue = Ne & 8191, se = Ne >>> 13, ut = v[4] | 0, qe = ut & 8191, ve = ut >>> 13, ot = v[5] | 0, He = ot & 8191, Ae = ot >>> 13, ct = v[6] | 0, Ve = ct & 8191, _e = ct >>> 13, lt = v[7] | 0, je = lt & 8191, me = lt >>> 13, _t = v[8] | 0, tt = _t & 8191, Le = _t >>> 13, mt = v[9] | 0, rt = mt & 8191, De = mt >>> 13, gt = S[0] | 0, Ze = gt & 8191, Ce = gt >>> 13, It = S[1] | 0, et = It & 8191, Ee = It >>> 13, Tt = S[2] | 0, Xe = Tt & 8191, Fe = Tt >>> 13, wt = S[3] | 0, We = wt & 8191, Oe = wt >>> 13, ht = S[4] | 0, nt = ht & 8191, Me = ht >>> 13, vt = S[5] | 0, at = vt & 8191, ke = vt >>> 13, kt = S[6] | 0, M = kt & 8191, L = kt >>> 13, $ = S[7] | 0, O = $ & 8191, P = $ >>> 13, H = S[8] | 0, q = H & 8191, Q = H >>> 13, re = S[9] | 0, ae = re & 8191, te = re >>> 13;
      _.negative = p.negative ^ b.negative, _.length = 19, A = Math.imul(D, Ze), I = Math.imul(D, Ce), I = I + Math.imul(V, Ze) | 0, C = Math.imul(V, Ce);
      var ge = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, A = Math.imul(J, Ze), I = Math.imul(J, Ce), I = I + Math.imul(ee, Ze) | 0, C = Math.imul(ee, Ce), A = A + Math.imul(D, et) | 0, I = I + Math.imul(D, Ee) | 0, I = I + Math.imul(V, et) | 0, C = C + Math.imul(V, Ee) | 0;
      var pe = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (pe >>> 26) | 0, pe &= 67108863, A = Math.imul(le, Ze), I = Math.imul(le, Ce), I = I + Math.imul(ie, Ze) | 0, C = Math.imul(ie, Ce), A = A + Math.imul(J, et) | 0, I = I + Math.imul(J, Ee) | 0, I = I + Math.imul(ee, et) | 0, C = C + Math.imul(ee, Ee) | 0, A = A + Math.imul(D, Xe) | 0, I = I + Math.imul(D, Fe) | 0, I = I + Math.imul(V, Xe) | 0, C = C + Math.imul(V, Fe) | 0;
      var Ie = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, A = Math.imul(ue, Ze), I = Math.imul(ue, Ce), I = I + Math.imul(se, Ze) | 0, C = Math.imul(se, Ce), A = A + Math.imul(le, et) | 0, I = I + Math.imul(le, Ee) | 0, I = I + Math.imul(ie, et) | 0, C = C + Math.imul(ie, Ee) | 0, A = A + Math.imul(J, Xe) | 0, I = I + Math.imul(J, Fe) | 0, I = I + Math.imul(ee, Xe) | 0, C = C + Math.imul(ee, Fe) | 0, A = A + Math.imul(D, We) | 0, I = I + Math.imul(D, Oe) | 0, I = I + Math.imul(V, We) | 0, C = C + Math.imul(V, Oe) | 0;
      var we = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, A = Math.imul(qe, Ze), I = Math.imul(qe, Ce), I = I + Math.imul(ve, Ze) | 0, C = Math.imul(ve, Ce), A = A + Math.imul(ue, et) | 0, I = I + Math.imul(ue, Ee) | 0, I = I + Math.imul(se, et) | 0, C = C + Math.imul(se, Ee) | 0, A = A + Math.imul(le, Xe) | 0, I = I + Math.imul(le, Fe) | 0, I = I + Math.imul(ie, Xe) | 0, C = C + Math.imul(ie, Fe) | 0, A = A + Math.imul(J, We) | 0, I = I + Math.imul(J, Oe) | 0, I = I + Math.imul(ee, We) | 0, C = C + Math.imul(ee, Oe) | 0, A = A + Math.imul(D, nt) | 0, I = I + Math.imul(D, Me) | 0, I = I + Math.imul(V, nt) | 0, C = C + Math.imul(V, Me) | 0;
      var Ue = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Ue >>> 26) | 0, Ue &= 67108863, A = Math.imul(He, Ze), I = Math.imul(He, Ce), I = I + Math.imul(Ae, Ze) | 0, C = Math.imul(Ae, Ce), A = A + Math.imul(qe, et) | 0, I = I + Math.imul(qe, Ee) | 0, I = I + Math.imul(ve, et) | 0, C = C + Math.imul(ve, Ee) | 0, A = A + Math.imul(ue, Xe) | 0, I = I + Math.imul(ue, Fe) | 0, I = I + Math.imul(se, Xe) | 0, C = C + Math.imul(se, Fe) | 0, A = A + Math.imul(le, We) | 0, I = I + Math.imul(le, Oe) | 0, I = I + Math.imul(ie, We) | 0, C = C + Math.imul(ie, Oe) | 0, A = A + Math.imul(J, nt) | 0, I = I + Math.imul(J, Me) | 0, I = I + Math.imul(ee, nt) | 0, C = C + Math.imul(ee, Me) | 0, A = A + Math.imul(D, at) | 0, I = I + Math.imul(D, ke) | 0, I = I + Math.imul(V, at) | 0, C = C + Math.imul(V, ke) | 0;
      var Ye = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Ye >>> 26) | 0, Ye &= 67108863, A = Math.imul(Ve, Ze), I = Math.imul(Ve, Ce), I = I + Math.imul(_e, Ze) | 0, C = Math.imul(_e, Ce), A = A + Math.imul(He, et) | 0, I = I + Math.imul(He, Ee) | 0, I = I + Math.imul(Ae, et) | 0, C = C + Math.imul(Ae, Ee) | 0, A = A + Math.imul(qe, Xe) | 0, I = I + Math.imul(qe, Fe) | 0, I = I + Math.imul(ve, Xe) | 0, C = C + Math.imul(ve, Fe) | 0, A = A + Math.imul(ue, We) | 0, I = I + Math.imul(ue, Oe) | 0, I = I + Math.imul(se, We) | 0, C = C + Math.imul(se, Oe) | 0, A = A + Math.imul(le, nt) | 0, I = I + Math.imul(le, Me) | 0, I = I + Math.imul(ie, nt) | 0, C = C + Math.imul(ie, Me) | 0, A = A + Math.imul(J, at) | 0, I = I + Math.imul(J, ke) | 0, I = I + Math.imul(ee, at) | 0, C = C + Math.imul(ee, ke) | 0, A = A + Math.imul(D, M) | 0, I = I + Math.imul(D, L) | 0, I = I + Math.imul(V, M) | 0, C = C + Math.imul(V, L) | 0;
      var Qe = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Qe >>> 26) | 0, Qe &= 67108863, A = Math.imul(je, Ze), I = Math.imul(je, Ce), I = I + Math.imul(me, Ze) | 0, C = Math.imul(me, Ce), A = A + Math.imul(Ve, et) | 0, I = I + Math.imul(Ve, Ee) | 0, I = I + Math.imul(_e, et) | 0, C = C + Math.imul(_e, Ee) | 0, A = A + Math.imul(He, Xe) | 0, I = I + Math.imul(He, Fe) | 0, I = I + Math.imul(Ae, Xe) | 0, C = C + Math.imul(Ae, Fe) | 0, A = A + Math.imul(qe, We) | 0, I = I + Math.imul(qe, Oe) | 0, I = I + Math.imul(ve, We) | 0, C = C + Math.imul(ve, Oe) | 0, A = A + Math.imul(ue, nt) | 0, I = I + Math.imul(ue, Me) | 0, I = I + Math.imul(se, nt) | 0, C = C + Math.imul(se, Me) | 0, A = A + Math.imul(le, at) | 0, I = I + Math.imul(le, ke) | 0, I = I + Math.imul(ie, at) | 0, C = C + Math.imul(ie, ke) | 0, A = A + Math.imul(J, M) | 0, I = I + Math.imul(J, L) | 0, I = I + Math.imul(ee, M) | 0, C = C + Math.imul(ee, L) | 0, A = A + Math.imul(D, O) | 0, I = I + Math.imul(D, P) | 0, I = I + Math.imul(V, O) | 0, C = C + Math.imul(V, P) | 0;
      var Ge = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Ge >>> 26) | 0, Ge &= 67108863, A = Math.imul(tt, Ze), I = Math.imul(tt, Ce), I = I + Math.imul(Le, Ze) | 0, C = Math.imul(Le, Ce), A = A + Math.imul(je, et) | 0, I = I + Math.imul(je, Ee) | 0, I = I + Math.imul(me, et) | 0, C = C + Math.imul(me, Ee) | 0, A = A + Math.imul(Ve, Xe) | 0, I = I + Math.imul(Ve, Fe) | 0, I = I + Math.imul(_e, Xe) | 0, C = C + Math.imul(_e, Fe) | 0, A = A + Math.imul(He, We) | 0, I = I + Math.imul(He, Oe) | 0, I = I + Math.imul(Ae, We) | 0, C = C + Math.imul(Ae, Oe) | 0, A = A + Math.imul(qe, nt) | 0, I = I + Math.imul(qe, Me) | 0, I = I + Math.imul(ve, nt) | 0, C = C + Math.imul(ve, Me) | 0, A = A + Math.imul(ue, at) | 0, I = I + Math.imul(ue, ke) | 0, I = I + Math.imul(se, at) | 0, C = C + Math.imul(se, ke) | 0, A = A + Math.imul(le, M) | 0, I = I + Math.imul(le, L) | 0, I = I + Math.imul(ie, M) | 0, C = C + Math.imul(ie, L) | 0, A = A + Math.imul(J, O) | 0, I = I + Math.imul(J, P) | 0, I = I + Math.imul(ee, O) | 0, C = C + Math.imul(ee, P) | 0, A = A + Math.imul(D, q) | 0, I = I + Math.imul(D, Q) | 0, I = I + Math.imul(V, q) | 0, C = C + Math.imul(V, Q) | 0;
      var Je = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Je >>> 26) | 0, Je &= 67108863, A = Math.imul(rt, Ze), I = Math.imul(rt, Ce), I = I + Math.imul(De, Ze) | 0, C = Math.imul(De, Ce), A = A + Math.imul(tt, et) | 0, I = I + Math.imul(tt, Ee) | 0, I = I + Math.imul(Le, et) | 0, C = C + Math.imul(Le, Ee) | 0, A = A + Math.imul(je, Xe) | 0, I = I + Math.imul(je, Fe) | 0, I = I + Math.imul(me, Xe) | 0, C = C + Math.imul(me, Fe) | 0, A = A + Math.imul(Ve, We) | 0, I = I + Math.imul(Ve, Oe) | 0, I = I + Math.imul(_e, We) | 0, C = C + Math.imul(_e, Oe) | 0, A = A + Math.imul(He, nt) | 0, I = I + Math.imul(He, Me) | 0, I = I + Math.imul(Ae, nt) | 0, C = C + Math.imul(Ae, Me) | 0, A = A + Math.imul(qe, at) | 0, I = I + Math.imul(qe, ke) | 0, I = I + Math.imul(ve, at) | 0, C = C + Math.imul(ve, ke) | 0, A = A + Math.imul(ue, M) | 0, I = I + Math.imul(ue, L) | 0, I = I + Math.imul(se, M) | 0, C = C + Math.imul(se, L) | 0, A = A + Math.imul(le, O) | 0, I = I + Math.imul(le, P) | 0, I = I + Math.imul(ie, O) | 0, C = C + Math.imul(ie, P) | 0, A = A + Math.imul(J, q) | 0, I = I + Math.imul(J, Q) | 0, I = I + Math.imul(ee, q) | 0, C = C + Math.imul(ee, Q) | 0, A = A + Math.imul(D, ae) | 0, I = I + Math.imul(D, te) | 0, I = I + Math.imul(V, ae) | 0, C = C + Math.imul(V, te) | 0;
      var Re = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, A = Math.imul(rt, et), I = Math.imul(rt, Ee), I = I + Math.imul(De, et) | 0, C = Math.imul(De, Ee), A = A + Math.imul(tt, Xe) | 0, I = I + Math.imul(tt, Fe) | 0, I = I + Math.imul(Le, Xe) | 0, C = C + Math.imul(Le, Fe) | 0, A = A + Math.imul(je, We) | 0, I = I + Math.imul(je, Oe) | 0, I = I + Math.imul(me, We) | 0, C = C + Math.imul(me, Oe) | 0, A = A + Math.imul(Ve, nt) | 0, I = I + Math.imul(Ve, Me) | 0, I = I + Math.imul(_e, nt) | 0, C = C + Math.imul(_e, Me) | 0, A = A + Math.imul(He, at) | 0, I = I + Math.imul(He, ke) | 0, I = I + Math.imul(Ae, at) | 0, C = C + Math.imul(Ae, ke) | 0, A = A + Math.imul(qe, M) | 0, I = I + Math.imul(qe, L) | 0, I = I + Math.imul(ve, M) | 0, C = C + Math.imul(ve, L) | 0, A = A + Math.imul(ue, O) | 0, I = I + Math.imul(ue, P) | 0, I = I + Math.imul(se, O) | 0, C = C + Math.imul(se, P) | 0, A = A + Math.imul(le, q) | 0, I = I + Math.imul(le, Q) | 0, I = I + Math.imul(ie, q) | 0, C = C + Math.imul(ie, Q) | 0, A = A + Math.imul(J, ae) | 0, I = I + Math.imul(J, te) | 0, I = I + Math.imul(ee, ae) | 0, C = C + Math.imul(ee, te) | 0;
      var $e = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + ($e >>> 26) | 0, $e &= 67108863, A = Math.imul(rt, Xe), I = Math.imul(rt, Fe), I = I + Math.imul(De, Xe) | 0, C = Math.imul(De, Fe), A = A + Math.imul(tt, We) | 0, I = I + Math.imul(tt, Oe) | 0, I = I + Math.imul(Le, We) | 0, C = C + Math.imul(Le, Oe) | 0, A = A + Math.imul(je, nt) | 0, I = I + Math.imul(je, Me) | 0, I = I + Math.imul(me, nt) | 0, C = C + Math.imul(me, Me) | 0, A = A + Math.imul(Ve, at) | 0, I = I + Math.imul(Ve, ke) | 0, I = I + Math.imul(_e, at) | 0, C = C + Math.imul(_e, ke) | 0, A = A + Math.imul(He, M) | 0, I = I + Math.imul(He, L) | 0, I = I + Math.imul(Ae, M) | 0, C = C + Math.imul(Ae, L) | 0, A = A + Math.imul(qe, O) | 0, I = I + Math.imul(qe, P) | 0, I = I + Math.imul(ve, O) | 0, C = C + Math.imul(ve, P) | 0, A = A + Math.imul(ue, q) | 0, I = I + Math.imul(ue, Q) | 0, I = I + Math.imul(se, q) | 0, C = C + Math.imul(se, Q) | 0, A = A + Math.imul(le, ae) | 0, I = I + Math.imul(le, te) | 0, I = I + Math.imul(ie, ae) | 0, C = C + Math.imul(ie, te) | 0;
      var Se = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, A = Math.imul(rt, We), I = Math.imul(rt, Oe), I = I + Math.imul(De, We) | 0, C = Math.imul(De, Oe), A = A + Math.imul(tt, nt) | 0, I = I + Math.imul(tt, Me) | 0, I = I + Math.imul(Le, nt) | 0, C = C + Math.imul(Le, Me) | 0, A = A + Math.imul(je, at) | 0, I = I + Math.imul(je, ke) | 0, I = I + Math.imul(me, at) | 0, C = C + Math.imul(me, ke) | 0, A = A + Math.imul(Ve, M) | 0, I = I + Math.imul(Ve, L) | 0, I = I + Math.imul(_e, M) | 0, C = C + Math.imul(_e, L) | 0, A = A + Math.imul(He, O) | 0, I = I + Math.imul(He, P) | 0, I = I + Math.imul(Ae, O) | 0, C = C + Math.imul(Ae, P) | 0, A = A + Math.imul(qe, q) | 0, I = I + Math.imul(qe, Q) | 0, I = I + Math.imul(ve, q) | 0, C = C + Math.imul(ve, Q) | 0, A = A + Math.imul(ue, ae) | 0, I = I + Math.imul(ue, te) | 0, I = I + Math.imul(se, ae) | 0, C = C + Math.imul(se, te) | 0;
      var xe = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, A = Math.imul(rt, nt), I = Math.imul(rt, Me), I = I + Math.imul(De, nt) | 0, C = Math.imul(De, Me), A = A + Math.imul(tt, at) | 0, I = I + Math.imul(tt, ke) | 0, I = I + Math.imul(Le, at) | 0, C = C + Math.imul(Le, ke) | 0, A = A + Math.imul(je, M) | 0, I = I + Math.imul(je, L) | 0, I = I + Math.imul(me, M) | 0, C = C + Math.imul(me, L) | 0, A = A + Math.imul(Ve, O) | 0, I = I + Math.imul(Ve, P) | 0, I = I + Math.imul(_e, O) | 0, C = C + Math.imul(_e, P) | 0, A = A + Math.imul(He, q) | 0, I = I + Math.imul(He, Q) | 0, I = I + Math.imul(Ae, q) | 0, C = C + Math.imul(Ae, Q) | 0, A = A + Math.imul(qe, ae) | 0, I = I + Math.imul(qe, te) | 0, I = I + Math.imul(ve, ae) | 0, C = C + Math.imul(ve, te) | 0;
      var Be = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, A = Math.imul(rt, at), I = Math.imul(rt, ke), I = I + Math.imul(De, at) | 0, C = Math.imul(De, ke), A = A + Math.imul(tt, M) | 0, I = I + Math.imul(tt, L) | 0, I = I + Math.imul(Le, M) | 0, C = C + Math.imul(Le, L) | 0, A = A + Math.imul(je, O) | 0, I = I + Math.imul(je, P) | 0, I = I + Math.imul(me, O) | 0, C = C + Math.imul(me, P) | 0, A = A + Math.imul(Ve, q) | 0, I = I + Math.imul(Ve, Q) | 0, I = I + Math.imul(_e, q) | 0, C = C + Math.imul(_e, Q) | 0, A = A + Math.imul(He, ae) | 0, I = I + Math.imul(He, te) | 0, I = I + Math.imul(Ae, ae) | 0, C = C + Math.imul(Ae, te) | 0;
      var Te = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, A = Math.imul(rt, M), I = Math.imul(rt, L), I = I + Math.imul(De, M) | 0, C = Math.imul(De, L), A = A + Math.imul(tt, O) | 0, I = I + Math.imul(tt, P) | 0, I = I + Math.imul(Le, O) | 0, C = C + Math.imul(Le, P) | 0, A = A + Math.imul(je, q) | 0, I = I + Math.imul(je, Q) | 0, I = I + Math.imul(me, q) | 0, C = C + Math.imul(me, Q) | 0, A = A + Math.imul(Ve, ae) | 0, I = I + Math.imul(Ve, te) | 0, I = I + Math.imul(_e, ae) | 0, C = C + Math.imul(_e, te) | 0;
      var ne = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (ne >>> 26) | 0, ne &= 67108863, A = Math.imul(rt, O), I = Math.imul(rt, P), I = I + Math.imul(De, O) | 0, C = Math.imul(De, P), A = A + Math.imul(tt, q) | 0, I = I + Math.imul(tt, Q) | 0, I = I + Math.imul(Le, q) | 0, C = C + Math.imul(Le, Q) | 0, A = A + Math.imul(je, ae) | 0, I = I + Math.imul(je, te) | 0, I = I + Math.imul(me, ae) | 0, C = C + Math.imul(me, te) | 0;
      var oe = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (oe >>> 26) | 0, oe &= 67108863, A = Math.imul(rt, q), I = Math.imul(rt, Q), I = I + Math.imul(De, q) | 0, C = Math.imul(De, Q), A = A + Math.imul(tt, ae) | 0, I = I + Math.imul(tt, te) | 0, I = I + Math.imul(Le, ae) | 0, C = C + Math.imul(Le, te) | 0;
      var fe = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (fe >>> 26) | 0, fe &= 67108863, A = Math.imul(rt, ae), I = Math.imul(rt, te), I = I + Math.imul(De, ae) | 0, C = Math.imul(De, te);
      var ce = (w + A | 0) + ((I & 8191) << 13) | 0;
      return w = (C + (I >>> 13) | 0) + (ce >>> 26) | 0, ce &= 67108863, E[0] = ge, E[1] = pe, E[2] = Ie, E[3] = we, E[4] = Ue, E[5] = Ye, E[6] = Qe, E[7] = Ge, E[8] = Je, E[9] = Re, E[10] = $e, E[11] = Se, E[12] = xe, E[13] = Be, E[14] = Te, E[15] = ne, E[16] = oe, E[17] = fe, E[18] = ce, w !== 0 && (E[19] = w, _.length++), _;
    };
    Math.imul || (U = m);
    function be(T, p, b) {
      b.negative = p.negative ^ T.negative, b.length = T.length + p.length;
      for (var _ = 0, v = 0, S = 0; S < b.length - 1; S++) {
        var E = v;
        v = 0;
        for (var w = _ & 67108863, A = Math.min(S, p.length - 1), I = Math.max(0, S - T.length + 1); I <= A; I++) {
          var C = S - I, X = T.words[C] | 0, D = p.words[I] | 0, V = X * D, Z = V & 67108863;
          E = E + (V / 67108864 | 0) | 0, Z = Z + w | 0, w = Z & 67108863, E = E + (Z >>> 26) | 0, v += E >>> 26, E &= 67108863;
        }
        b.words[S] = w, _ = E, E = v;
      }
      return _ !== 0 ? b.words[S] = _ : b.length--, b._strip();
    }
    function Ke(T, p, b) {
      return be(T, p, b);
    }
    h.prototype.mulTo = function(p, b) {
      var _, v = this.length + p.length;
      return this.length === 10 && p.length === 10 ? _ = U(this, p, b) : v < 63 ? _ = m(this, p, b) : v < 1024 ? _ = be(this, p, b) : _ = Ke(this, p, b), _;
    }, h.prototype.mul = function(p) {
      var b = new h(null);
      return b.words = new Array(this.length + p.length), this.mulTo(p, b);
    }, h.prototype.mulf = function(p) {
      var b = new h(null);
      return b.words = new Array(this.length + p.length), Ke(this, p, b);
    }, h.prototype.imul = function(p) {
      return this.clone().mulTo(p, this);
    }, h.prototype.imuln = function(p) {
      var b = p < 0;
      b && (p = -p), d(typeof p == "number"), d(p < 67108864);
      for (var _ = 0, v = 0; v < this.length; v++) {
        var S = (this.words[v] | 0) * p, E = (S & 67108863) + (_ & 67108863);
        _ >>= 26, _ += S / 67108864 | 0, _ += E >>> 26, this.words[v] = E & 67108863;
      }
      return _ !== 0 && (this.words[v] = _, this.length++), b ? this.ineg() : this;
    }, h.prototype.muln = function(p) {
      return this.clone().imuln(p);
    }, h.prototype.sqr = function() {
      return this.mul(this);
    }, h.prototype.isqr = function() {
      return this.imul(this.clone());
    }, h.prototype.pow = function(p) {
      var b = y(p);
      if (b.length === 0)
        return new h(1);
      for (var _ = this, v = 0; v < b.length && b[v] === 0; v++, _ = _.sqr())
        ;
      if (++v < b.length)
        for (var S = _.sqr(); v < b.length; v++, S = S.sqr())
          b[v] !== 0 && (_ = _.mul(S));
      return _;
    }, h.prototype.iushln = function(p) {
      d(typeof p == "number" && p >= 0);
      var b = p % 26, _ = (p - b) / 26, v = 67108863 >>> 26 - b << 26 - b, S;
      if (b !== 0) {
        var E = 0;
        for (S = 0; S < this.length; S++) {
          var w = this.words[S] & v, A = (this.words[S] | 0) - w << b;
          this.words[S] = A | E, E = w >>> 26 - b;
        }
        E && (this.words[S] = E, this.length++);
      }
      if (_ !== 0) {
        for (S = this.length - 1; S >= 0; S--)
          this.words[S + _] = this.words[S];
        for (S = 0; S < _; S++)
          this.words[S] = 0;
        this.length += _;
      }
      return this._strip();
    }, h.prototype.ishln = function(p) {
      return d(this.negative === 0), this.iushln(p);
    }, h.prototype.iushrn = function(p, b, _) {
      d(typeof p == "number" && p >= 0);
      var v;
      b ? v = (b - b % 26) / 26 : v = 0;
      var S = p % 26, E = Math.min((p - S) / 26, this.length), w = 67108863 ^ 67108863 >>> S << S, A = _;
      if (v -= E, v = Math.max(0, v), A) {
        for (var I = 0; I < E; I++)
          A.words[I] = this.words[I];
        A.length = E;
      }
      if (E !== 0)
        if (this.length > E)
          for (this.length -= E, I = 0; I < this.length; I++)
            this.words[I] = this.words[I + E];
        else
          this.words[0] = 0, this.length = 1;
      var C = 0;
      for (I = this.length - 1; I >= 0 && (C !== 0 || I >= v); I--) {
        var X = this.words[I] | 0;
        this.words[I] = C << 26 - S | X >>> S, C = X & w;
      }
      return A && C !== 0 && (A.words[A.length++] = C), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, h.prototype.ishrn = function(p, b, _) {
      return d(this.negative === 0), this.iushrn(p, b, _);
    }, h.prototype.shln = function(p) {
      return this.clone().ishln(p);
    }, h.prototype.ushln = function(p) {
      return this.clone().iushln(p);
    }, h.prototype.shrn = function(p) {
      return this.clone().ishrn(p);
    }, h.prototype.ushrn = function(p) {
      return this.clone().iushrn(p);
    }, h.prototype.testn = function(p) {
      d(typeof p == "number" && p >= 0);
      var b = p % 26, _ = (p - b) / 26, v = 1 << b;
      if (this.length <= _)
        return !1;
      var S = this.words[_];
      return !!(S & v);
    }, h.prototype.imaskn = function(p) {
      d(typeof p == "number" && p >= 0);
      var b = p % 26, _ = (p - b) / 26;
      if (d(this.negative === 0, "imaskn works only with positive numbers"), this.length <= _)
        return this;
      if (b !== 0 && _++, this.length = Math.min(_, this.length), b !== 0) {
        var v = 67108863 ^ 67108863 >>> b << b;
        this.words[this.length - 1] &= v;
      }
      return this._strip();
    }, h.prototype.maskn = function(p) {
      return this.clone().imaskn(p);
    }, h.prototype.iaddn = function(p) {
      return d(typeof p == "number"), d(p < 67108864), p < 0 ? this.isubn(-p) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= p ? (this.words[0] = p - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(p), this.negative = 1, this) : this._iaddn(p);
    }, h.prototype._iaddn = function(p) {
      this.words[0] += p;
      for (var b = 0; b < this.length && this.words[b] >= 67108864; b++)
        this.words[b] -= 67108864, b === this.length - 1 ? this.words[b + 1] = 1 : this.words[b + 1]++;
      return this.length = Math.max(this.length, b + 1), this;
    }, h.prototype.isubn = function(p) {
      if (d(typeof p == "number"), d(p < 67108864), p < 0)
        return this.iaddn(-p);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(p), this.negative = 1, this;
      if (this.words[0] -= p, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var b = 0; b < this.length && this.words[b] < 0; b++)
          this.words[b] += 67108864, this.words[b + 1] -= 1;
      return this._strip();
    }, h.prototype.addn = function(p) {
      return this.clone().iaddn(p);
    }, h.prototype.subn = function(p) {
      return this.clone().isubn(p);
    }, h.prototype.iabs = function() {
      return this.negative = 0, this;
    }, h.prototype.abs = function() {
      return this.clone().iabs();
    }, h.prototype._ishlnsubmul = function(p, b, _) {
      var v = p.length + _, S;
      this._expand(v);
      var E, w = 0;
      for (S = 0; S < p.length; S++) {
        E = (this.words[S + _] | 0) + w;
        var A = (p.words[S] | 0) * b;
        E -= A & 67108863, w = (E >> 26) - (A / 67108864 | 0), this.words[S + _] = E & 67108863;
      }
      for (; S < this.length - _; S++)
        E = (this.words[S + _] | 0) + w, w = E >> 26, this.words[S + _] = E & 67108863;
      if (w === 0)
        return this._strip();
      for (d(w === -1), w = 0, S = 0; S < this.length; S++)
        E = -(this.words[S] | 0) + w, w = E >> 26, this.words[S] = E & 67108863;
      return this.negative = 1, this._strip();
    }, h.prototype._wordDiv = function(p, b) {
      var _ = this.length - p.length, v = this.clone(), S = p, E = S.words[S.length - 1] | 0, w = this._countBits(E);
      _ = 26 - w, _ !== 0 && (S = S.ushln(_), v.iushln(_), E = S.words[S.length - 1] | 0);
      var A = v.length - S.length, I;
      if (b !== "mod") {
        I = new h(null), I.length = A + 1, I.words = new Array(I.length);
        for (var C = 0; C < I.length; C++)
          I.words[C] = 0;
      }
      var X = v.clone()._ishlnsubmul(S, 1, A);
      X.negative === 0 && (v = X, I && (I.words[A] = 1));
      for (var D = A - 1; D >= 0; D--) {
        var V = (v.words[S.length + D] | 0) * 67108864 + (v.words[S.length + D - 1] | 0);
        for (V = Math.min(V / E | 0, 67108863), v._ishlnsubmul(S, V, D); v.negative !== 0; )
          V--, v.negative = 0, v._ishlnsubmul(S, 1, D), v.isZero() || (v.negative ^= 1);
        I && (I.words[D] = V);
      }
      return I && I._strip(), v._strip(), b !== "div" && _ !== 0 && v.iushrn(_), {
        div: I || null,
        mod: v
      };
    }, h.prototype.divmod = function(p, b, _) {
      if (d(!p.isZero()), this.isZero())
        return {
          div: new h(0),
          mod: new h(0)
        };
      var v, S, E;
      return this.negative !== 0 && p.negative === 0 ? (E = this.neg().divmod(p, b), b !== "mod" && (v = E.div.neg()), b !== "div" && (S = E.mod.neg(), _ && S.negative !== 0 && S.iadd(p)), {
        div: v,
        mod: S
      }) : this.negative === 0 && p.negative !== 0 ? (E = this.divmod(p.neg(), b), b !== "mod" && (v = E.div.neg()), {
        div: v,
        mod: E.mod
      }) : (this.negative & p.negative) !== 0 ? (E = this.neg().divmod(p.neg(), b), b !== "div" && (S = E.mod.neg(), _ && S.negative !== 0 && S.isub(p)), {
        div: E.div,
        mod: S
      }) : p.length > this.length || this.cmp(p) < 0 ? {
        div: new h(0),
        mod: this
      } : p.length === 1 ? b === "div" ? {
        div: this.divn(p.words[0]),
        mod: null
      } : b === "mod" ? {
        div: null,
        mod: new h(this.modrn(p.words[0]))
      } : {
        div: this.divn(p.words[0]),
        mod: new h(this.modrn(p.words[0]))
      } : this._wordDiv(p, b);
    }, h.prototype.div = function(p) {
      return this.divmod(p, "div", !1).div;
    }, h.prototype.mod = function(p) {
      return this.divmod(p, "mod", !1).mod;
    }, h.prototype.umod = function(p) {
      return this.divmod(p, "mod", !0).mod;
    }, h.prototype.divRound = function(p) {
      var b = this.divmod(p);
      if (b.mod.isZero())
        return b.div;
      var _ = b.div.negative !== 0 ? b.mod.isub(p) : b.mod, v = p.ushrn(1), S = p.andln(1), E = _.cmp(v);
      return E < 0 || S === 1 && E === 0 ? b.div : b.div.negative !== 0 ? b.div.isubn(1) : b.div.iaddn(1);
    }, h.prototype.modrn = function(p) {
      var b = p < 0;
      b && (p = -p), d(p <= 67108863);
      for (var _ = (1 << 26) % p, v = 0, S = this.length - 1; S >= 0; S--)
        v = (_ * v + (this.words[S] | 0)) % p;
      return b ? -v : v;
    }, h.prototype.modn = function(p) {
      return this.modrn(p);
    }, h.prototype.idivn = function(p) {
      var b = p < 0;
      b && (p = -p), d(p <= 67108863);
      for (var _ = 0, v = this.length - 1; v >= 0; v--) {
        var S = (this.words[v] | 0) + _ * 67108864;
        this.words[v] = S / p | 0, _ = S % p;
      }
      return this._strip(), b ? this.ineg() : this;
    }, h.prototype.divn = function(p) {
      return this.clone().idivn(p);
    }, h.prototype.egcd = function(p) {
      d(p.negative === 0), d(!p.isZero());
      var b = this, _ = p.clone();
      b.negative !== 0 ? b = b.umod(p) : b = b.clone();
      for (var v = new h(1), S = new h(0), E = new h(0), w = new h(1), A = 0; b.isEven() && _.isEven(); )
        b.iushrn(1), _.iushrn(1), ++A;
      for (var I = _.clone(), C = b.clone(); !b.isZero(); ) {
        for (var X = 0, D = 1; (b.words[0] & D) === 0 && X < 26; ++X, D <<= 1)
          ;
        if (X > 0)
          for (b.iushrn(X); X-- > 0; )
            (v.isOdd() || S.isOdd()) && (v.iadd(I), S.isub(C)), v.iushrn(1), S.iushrn(1);
        for (var V = 0, Z = 1; (_.words[0] & Z) === 0 && V < 26; ++V, Z <<= 1)
          ;
        if (V > 0)
          for (_.iushrn(V); V-- > 0; )
            (E.isOdd() || w.isOdd()) && (E.iadd(I), w.isub(C)), E.iushrn(1), w.iushrn(1);
        b.cmp(_) >= 0 ? (b.isub(_), v.isub(E), S.isub(w)) : (_.isub(b), E.isub(v), w.isub(S));
      }
      return {
        a: E,
        b: w,
        gcd: _.iushln(A)
      };
    }, h.prototype._invmp = function(p) {
      d(p.negative === 0), d(!p.isZero());
      var b = this, _ = p.clone();
      b.negative !== 0 ? b = b.umod(p) : b = b.clone();
      for (var v = new h(1), S = new h(0), E = _.clone(); b.cmpn(1) > 0 && _.cmpn(1) > 0; ) {
        for (var w = 0, A = 1; (b.words[0] & A) === 0 && w < 26; ++w, A <<= 1)
          ;
        if (w > 0)
          for (b.iushrn(w); w-- > 0; )
            v.isOdd() && v.iadd(E), v.iushrn(1);
        for (var I = 0, C = 1; (_.words[0] & C) === 0 && I < 26; ++I, C <<= 1)
          ;
        if (I > 0)
          for (_.iushrn(I); I-- > 0; )
            S.isOdd() && S.iadd(E), S.iushrn(1);
        b.cmp(_) >= 0 ? (b.isub(_), v.isub(S)) : (_.isub(b), S.isub(v));
      }
      var X;
      return b.cmpn(1) === 0 ? X = v : X = S, X.cmpn(0) < 0 && X.iadd(p), X;
    }, h.prototype.gcd = function(p) {
      if (this.isZero())
        return p.abs();
      if (p.isZero())
        return this.abs();
      var b = this.clone(), _ = p.clone();
      b.negative = 0, _.negative = 0;
      for (var v = 0; b.isEven() && _.isEven(); v++)
        b.iushrn(1), _.iushrn(1);
      do {
        for (; b.isEven(); )
          b.iushrn(1);
        for (; _.isEven(); )
          _.iushrn(1);
        var S = b.cmp(_);
        if (S < 0) {
          var E = b;
          b = _, _ = E;
        } else if (S === 0 || _.cmpn(1) === 0)
          break;
        b.isub(_);
      } while (!0);
      return _.iushln(v);
    }, h.prototype.invm = function(p) {
      return this.egcd(p).a.umod(p);
    }, h.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, h.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, h.prototype.andln = function(p) {
      return this.words[0] & p;
    }, h.prototype.bincn = function(p) {
      d(typeof p == "number");
      var b = p % 26, _ = (p - b) / 26, v = 1 << b;
      if (this.length <= _)
        return this._expand(_ + 1), this.words[_] |= v, this;
      for (var S = v, E = _; S !== 0 && E < this.length; E++) {
        var w = this.words[E] | 0;
        w += S, S = w >>> 26, w &= 67108863, this.words[E] = w;
      }
      return S !== 0 && (this.words[E] = S, this.length++), this;
    }, h.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, h.prototype.cmpn = function(p) {
      var b = p < 0;
      if (this.negative !== 0 && !b)
        return -1;
      if (this.negative === 0 && b)
        return 1;
      this._strip();
      var _;
      if (this.length > 1)
        _ = 1;
      else {
        b && (p = -p), d(p <= 67108863, "Number is too big");
        var v = this.words[0] | 0;
        _ = v === p ? 0 : v < p ? -1 : 1;
      }
      return this.negative !== 0 ? -_ | 0 : _;
    }, h.prototype.cmp = function(p) {
      if (this.negative !== 0 && p.negative === 0)
        return -1;
      if (this.negative === 0 && p.negative !== 0)
        return 1;
      var b = this.ucmp(p);
      return this.negative !== 0 ? -b | 0 : b;
    }, h.prototype.ucmp = function(p) {
      if (this.length > p.length)
        return 1;
      if (this.length < p.length)
        return -1;
      for (var b = 0, _ = this.length - 1; _ >= 0; _--) {
        var v = this.words[_] | 0, S = p.words[_] | 0;
        if (v !== S) {
          v < S ? b = -1 : v > S && (b = 1);
          break;
        }
      }
      return b;
    }, h.prototype.gtn = function(p) {
      return this.cmpn(p) === 1;
    }, h.prototype.gt = function(p) {
      return this.cmp(p) === 1;
    }, h.prototype.gten = function(p) {
      return this.cmpn(p) >= 0;
    }, h.prototype.gte = function(p) {
      return this.cmp(p) >= 0;
    }, h.prototype.ltn = function(p) {
      return this.cmpn(p) === -1;
    }, h.prototype.lt = function(p) {
      return this.cmp(p) === -1;
    }, h.prototype.lten = function(p) {
      return this.cmpn(p) <= 0;
    }, h.prototype.lte = function(p) {
      return this.cmp(p) <= 0;
    }, h.prototype.eqn = function(p) {
      return this.cmpn(p) === 0;
    }, h.prototype.eq = function(p) {
      return this.cmp(p) === 0;
    }, h.red = function(p) {
      return new F(p);
    }, h.prototype.toRed = function(p) {
      return d(!this.red, "Already a number in reduction context"), d(this.negative === 0, "red works only with positives"), p.convertTo(this)._forceRed(p);
    }, h.prototype.fromRed = function() {
      return d(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, h.prototype._forceRed = function(p) {
      return this.red = p, this;
    }, h.prototype.forceRed = function(p) {
      return d(!this.red, "Already a number in reduction context"), this._forceRed(p);
    }, h.prototype.redAdd = function(p) {
      return d(this.red, "redAdd works only with red numbers"), this.red.add(this, p);
    }, h.prototype.redIAdd = function(p) {
      return d(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, p);
    }, h.prototype.redSub = function(p) {
      return d(this.red, "redSub works only with red numbers"), this.red.sub(this, p);
    }, h.prototype.redISub = function(p) {
      return d(this.red, "redISub works only with red numbers"), this.red.isub(this, p);
    }, h.prototype.redShl = function(p) {
      return d(this.red, "redShl works only with red numbers"), this.red.shl(this, p);
    }, h.prototype.redMul = function(p) {
      return d(this.red, "redMul works only with red numbers"), this.red._verify2(this, p), this.red.mul(this, p);
    }, h.prototype.redIMul = function(p) {
      return d(this.red, "redMul works only with red numbers"), this.red._verify2(this, p), this.red.imul(this, p);
    }, h.prototype.redSqr = function() {
      return d(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, h.prototype.redISqr = function() {
      return d(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, h.prototype.redSqrt = function() {
      return d(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, h.prototype.redInvm = function() {
      return d(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, h.prototype.redNeg = function() {
      return d(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, h.prototype.redPow = function(p) {
      return d(this.red && !p.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, p);
    };
    var ze = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Pe(T, p) {
      this.name = T, this.p = new h(p, 16), this.n = this.p.bitLength(), this.k = new h(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Pe.prototype._tmp = function() {
      var p = new h(null);
      return p.words = new Array(Math.ceil(this.n / 13)), p;
    }, Pe.prototype.ireduce = function(p) {
      var b = p, _;
      do
        this.split(b, this.tmp), b = this.imulK(b), b = b.iadd(this.tmp), _ = b.bitLength();
      while (_ > this.n);
      var v = _ < this.n ? -1 : b.ucmp(this.p);
      return v === 0 ? (b.words[0] = 0, b.length = 1) : v > 0 ? b.isub(this.p) : b.strip !== void 0 ? b.strip() : b._strip(), b;
    }, Pe.prototype.split = function(p, b) {
      p.iushrn(this.n, 0, b);
    }, Pe.prototype.imulK = function(p) {
      return p.imul(this.k);
    };
    function st() {
      Pe.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    l(st, Pe), st.prototype.split = function(p, b) {
      for (var _ = 4194303, v = Math.min(p.length, 9), S = 0; S < v; S++)
        b.words[S] = p.words[S];
      if (b.length = v, p.length <= 9) {
        p.words[0] = 0, p.length = 1;
        return;
      }
      var E = p.words[9];
      for (b.words[b.length++] = E & _, S = 10; S < p.length; S++) {
        var w = p.words[S] | 0;
        p.words[S - 10] = (w & _) << 4 | E >>> 22, E = w;
      }
      E >>>= 22, p.words[S - 10] = E, E === 0 && p.length > 10 ? p.length -= 10 : p.length -= 9;
    }, st.prototype.imulK = function(p) {
      p.words[p.length] = 0, p.words[p.length + 1] = 0, p.length += 2;
      for (var b = 0, _ = 0; _ < p.length; _++) {
        var v = p.words[_] | 0;
        b += v * 977, p.words[_] = b & 67108863, b = v * 64 + (b / 67108864 | 0);
      }
      return p.words[p.length - 1] === 0 && (p.length--, p.words[p.length - 1] === 0 && p.length--), p;
    };
    function G() {
      Pe.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    l(G, Pe);
    function z() {
      Pe.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    l(z, Pe);
    function W() {
      Pe.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    l(W, Pe), W.prototype.imulK = function(p) {
      for (var b = 0, _ = 0; _ < p.length; _++) {
        var v = (p.words[_] | 0) * 19 + b, S = v & 67108863;
        v >>>= 26, p.words[_] = S, b = v;
      }
      return b !== 0 && (p.words[p.length++] = b), p;
    }, h._prime = function(p) {
      if (ze[p])
        return ze[p];
      var b;
      if (p === "k256")
        b = new st();
      else if (p === "p224")
        b = new G();
      else if (p === "p192")
        b = new z();
      else if (p === "p25519")
        b = new W();
      else
        throw new Error("Unknown prime " + p);
      return ze[p] = b, b;
    };
    function F(T) {
      if (typeof T == "string") {
        var p = h._prime(T);
        this.m = p.p, this.prime = p;
      } else
        d(T.gtn(1), "modulus must be greater than 1"), this.m = T, this.prime = null;
    }
    F.prototype._verify1 = function(p) {
      d(p.negative === 0, "red works only with positives"), d(p.red, "red works only with red numbers");
    }, F.prototype._verify2 = function(p, b) {
      d((p.negative | b.negative) === 0, "red works only with positives"), d(
        p.red && p.red === b.red,
        "red works only with red numbers"
      );
    }, F.prototype.imod = function(p) {
      return this.prime ? this.prime.ireduce(p)._forceRed(this) : (B(p, p.umod(this.m)._forceRed(this)), p);
    }, F.prototype.neg = function(p) {
      return p.isZero() ? p.clone() : this.m.sub(p)._forceRed(this);
    }, F.prototype.add = function(p, b) {
      this._verify2(p, b);
      var _ = p.add(b);
      return _.cmp(this.m) >= 0 && _.isub(this.m), _._forceRed(this);
    }, F.prototype.iadd = function(p, b) {
      this._verify2(p, b);
      var _ = p.iadd(b);
      return _.cmp(this.m) >= 0 && _.isub(this.m), _;
    }, F.prototype.sub = function(p, b) {
      this._verify2(p, b);
      var _ = p.sub(b);
      return _.cmpn(0) < 0 && _.iadd(this.m), _._forceRed(this);
    }, F.prototype.isub = function(p, b) {
      this._verify2(p, b);
      var _ = p.isub(b);
      return _.cmpn(0) < 0 && _.iadd(this.m), _;
    }, F.prototype.shl = function(p, b) {
      return this._verify1(p), this.imod(p.ushln(b));
    }, F.prototype.imul = function(p, b) {
      return this._verify2(p, b), this.imod(p.imul(b));
    }, F.prototype.mul = function(p, b) {
      return this._verify2(p, b), this.imod(p.mul(b));
    }, F.prototype.isqr = function(p) {
      return this.imul(p, p.clone());
    }, F.prototype.sqr = function(p) {
      return this.mul(p, p);
    }, F.prototype.sqrt = function(p) {
      if (p.isZero())
        return p.clone();
      var b = this.m.andln(3);
      if (d(b % 2 === 1), b === 3) {
        var _ = this.m.add(new h(1)).iushrn(2);
        return this.pow(p, _);
      }
      for (var v = this.m.subn(1), S = 0; !v.isZero() && v.andln(1) === 0; )
        S++, v.iushrn(1);
      d(!v.isZero());
      var E = new h(1).toRed(this), w = E.redNeg(), A = this.m.subn(1).iushrn(1), I = this.m.bitLength();
      for (I = new h(2 * I * I).toRed(this); this.pow(I, A).cmp(w) !== 0; )
        I.redIAdd(w);
      for (var C = this.pow(I, v), X = this.pow(p, v.addn(1).iushrn(1)), D = this.pow(p, v), V = S; D.cmp(E) !== 0; ) {
        for (var Z = D, J = 0; Z.cmp(E) !== 0; J++)
          Z = Z.redSqr();
        d(J < V);
        var ee = this.pow(C, new h(1).iushln(V - J - 1));
        X = X.redMul(ee), C = ee.redSqr(), D = D.redMul(C), V = J;
      }
      return X;
    }, F.prototype.invm = function(p) {
      var b = p._invmp(this.m);
      return b.negative !== 0 ? (b.negative = 0, this.imod(b).redNeg()) : this.imod(b);
    }, F.prototype.pow = function(p, b) {
      if (b.isZero())
        return new h(1).toRed(this);
      if (b.cmpn(1) === 0)
        return p.clone();
      var _ = 4, v = new Array(1 << _);
      v[0] = new h(1).toRed(this), v[1] = p;
      for (var S = 2; S < v.length; S++)
        v[S] = this.mul(v[S - 1], p);
      var E = v[0], w = 0, A = 0, I = b.bitLength() % 26;
      for (I === 0 && (I = 26), S = b.length - 1; S >= 0; S--) {
        for (var C = b.words[S], X = I - 1; X >= 0; X--) {
          var D = C >> X & 1;
          if (E !== v[0] && (E = this.sqr(E)), D === 0 && w === 0) {
            A = 0;
            continue;
          }
          w <<= 1, w |= D, A++, !(A !== _ && (S !== 0 || X !== 0)) && (E = this.mul(E, v[w]), A = 0, w = 0);
        }
        I = 26;
      }
      return E;
    }, F.prototype.convertTo = function(p) {
      var b = p.umod(this.m);
      return b === p ? b.clone() : b;
    }, F.prototype.convertFrom = function(p) {
      var b = p.clone();
      return b.red = null, b;
    }, h.mont = function(p) {
      return new k(p);
    };
    function k(T) {
      F.call(this, T), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new h(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    l(k, F), k.prototype.convertTo = function(p) {
      return this.imod(p.ushln(this.shift));
    }, k.prototype.convertFrom = function(p) {
      var b = this.imod(p.mul(this.rinv));
      return b.red = null, b;
    }, k.prototype.imul = function(p, b) {
      if (p.isZero() || b.isZero())
        return p.words[0] = 0, p.length = 1, p;
      var _ = p.imul(b), v = _.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), S = _.isub(v).iushrn(this.shift), E = S;
      return S.cmp(this.m) >= 0 ? E = S.isub(this.m) : S.cmpn(0) < 0 && (E = S.iadd(this.m)), E._forceRed(this);
    }, k.prototype.mul = function(p, b) {
      if (p.isZero() || b.isZero())
        return new h(0)._forceRed(this);
      var _ = p.mul(b), v = _.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), S = _.isub(v).iushrn(this.shift), E = S;
      return S.cmp(this.m) >= 0 ? E = S.isub(this.m) : S.cmpn(0) < 0 && (E = S.iadd(this.m)), E._forceRed(this);
    }, k.prototype.invm = function(p) {
      var b = this.imod(p._invmp(this.m).mul(this.r2));
      return b._forceRed(this);
    };
  })(u, commonjsGlobal);
})(bn$1);
const BN$1 = bn$1.exports, secp256k1$1 = new elliptic.ec("secp256k1"), N = new BN$1(
  "fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141",
  "hex"
), HARDENED_BIT = 2147483648;
async function derive$1(u, t, a) {
  const d = isHardenedIndex(a), l = new Uint8Array(37), h = decode$5(
    secp256k1$1.keyFromPrivate(u).getPublic(!0, "hex")
  );
  d ? (l[0] = 0, l.set(u, 1)) : l.set(h, 0), new DataView(l.buffer, l.byteOffset, l.byteLength).setUint32(
    33,
    a,
    !1
  );
  const g = await hash$3(HashAlgorithm.Sha512, t, l), c = g.subarray(0, 32), x = g.subarray(32);
  try {
    const R = secp256k1$1.keyFromPrivate(u).getPrivate().add(secp256k1$1.keyFromPrivate(c).getPrivate()).mod(N), B = hexZeroPadded(R.toBuffer(), 32);
    return R.eqn(0) ? derive$1(u, t, a + 1) : {
      keyData: decode$5(B),
      chainCode: x
    };
  } catch {
    return derive$1(u, t, a + 1);
  }
}
async function fromSeed$1(u) {
  if (u.length < 16)
    throw new TypeError("Seed should be at least 128 bits");
  if (u.length > 64)
    throw new TypeError("Seed should be at most 512 bits");
  const t = await hash$3(HashAlgorithm.Sha512, "Bitcoin seed", u), a = t.subarray(0, 32), d = t.subarray(32);
  return { keyData: a, chainCode: d };
}
function toHardenedIndex(u) {
  return u | HARDENED_BIT;
}
function isHardenedIndex(u) {
  return (u & HARDENED_BIT) !== 0;
}
async function derive(u, t, a) {
  if (isHardenedIndex(a))
    throw new Error("the index should not be pre-hardened");
  const d = new Uint8Array(37);
  d[0] = 0, d.set(u, 1), new DataView(d.buffer, d.byteOffset, d.byteLength).setUint32(
    33,
    a,
    !1
  ), d[33] |= 128;
  const l = await hash$3(HashAlgorithm.Sha512, t, d);
  return { keyData: l.subarray(0, 32), chainCode: l.subarray(32) };
}
async function fromSeed(u) {
  const t = await hash$3(
    HashAlgorithm.Sha512,
    "ed25519 seed",
    u
  );
  return { keyData: t.subarray(0, 32), chainCode: t.subarray(32) };
}
const derPrefix$2 = "302e020100300506032b657004220420", derPrefixBytes$2 = decode$5(derPrefix$2);
class Ed25519PrivateKey {
  constructor(t, a) {
    this._keyPair = t instanceof Uint8Array ? nacl.sign.keyPair.fromSeed(t) : t, this._chainCode = a != null ? a : null;
  }
  get _type() {
    return "ED25519";
  }
  static generate() {
    const t = bytes(64);
    return new Ed25519PrivateKey(
      nacl.sign.keyPair.fromSeed(t.subarray(0, 32)),
      t.subarray(32)
    );
  }
  static async generateAsync() {
    const t = await bytesAsync(64);
    return new Ed25519PrivateKey(
      nacl.sign.keyPair.fromSeed(t.subarray(0, 32)),
      t.subarray(32)
    );
  }
  static fromBytes(t) {
    switch (t.length) {
      case 48:
        return Ed25519PrivateKey.fromBytesDer(t);
      case 32:
      case 64:
        return Ed25519PrivateKey.fromBytesRaw(t);
      default:
        throw new BadKeyError(
          `invalid private key length: ${t.length} bytes`
        );
    }
  }
  static fromBytesDer(t) {
    if (t.length != 48 || !arrayStartsWith(t, derPrefixBytes$2))
      throw new BadKeyError(
        `invalid private key length: ${t.length} bytes`
      );
    const a = nacl.sign.keyPair.fromSeed(t.subarray(16));
    return new Ed25519PrivateKey(a);
  }
  static fromBytesRaw(t) {
    switch (t.length) {
      case 32:
        return new Ed25519PrivateKey(nacl.sign.keyPair.fromSeed(t));
      case 64:
        return new Ed25519PrivateKey(
          nacl.sign.keyPair.fromSecretKey(t)
        );
    }
    throw new BadKeyError(
      `invalid private key length: ${t.length} bytes`
    );
  }
  static fromString(t) {
    return Ed25519PrivateKey.fromBytes(decode$5(t));
  }
  static fromStringDer(t) {
    return Ed25519PrivateKey.fromBytesDer(decode$5(t));
  }
  static fromStringRaw(t) {
    return Ed25519PrivateKey.fromBytesRaw(decode$5(t));
  }
  static async fromSeed(t) {
    const { keyData: a, chainCode: d } = await fromSeed(t);
    return new Ed25519PrivateKey(a, d);
  }
  get publicKey() {
    return new Ed25519PublicKey(this._keyPair.publicKey);
  }
  sign(t) {
    return nacl.sign.detached(t, this._keyPair.secretKey);
  }
  toBytesDer() {
    const t = new Uint8Array(derPrefixBytes$2.length + 32);
    return t.set(derPrefixBytes$2, 0), t.set(
      this._keyPair.secretKey.subarray(0, 32),
      derPrefixBytes$2.length
    ), t;
  }
  toBytesRaw() {
    return this._keyPair.secretKey.slice(0, 32);
  }
}
const HEX_CHARS$1 = "0123456789abcdef".split(""), KECCAK_PADDING$1 = [1, 256, 65536, 16777216], SHIFT$1 = [0, 8, 16, 24], RC$1 = [
  1,
  0,
  32898,
  0,
  32906,
  2147483648,
  2147516416,
  2147483648,
  32907,
  0,
  2147483649,
  0,
  2147516545,
  2147483648,
  32777,
  2147483648,
  138,
  0,
  136,
  0,
  2147516425,
  0,
  2147483658,
  0,
  2147516555,
  0,
  139,
  2147483648,
  32905,
  2147483648,
  32771,
  2147483648,
  32770,
  2147483648,
  128,
  2147483648,
  32778,
  0,
  2147483658,
  2147483648,
  2147516545,
  2147483648,
  32896,
  2147483648,
  2147483649,
  0,
  2147516424,
  2147483648
], Keccak$1 = (u) => ({
  blocks: [],
  reset: !0,
  block: 0,
  start: 0,
  blockCount: 1600 - (u << 1) >> 5,
  outputBlocks: u >> 5,
  s: ((t) => [].concat(t, t, t, t, t))([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
}), update$1 = (u, t) => {
  for (var a = t.length, d = u.blocks, l = u.blockCount << 2, h = u.blockCount, g = u.outputBlocks, c = u.s, x = 0, R, B; x < a; ) {
    if (u.reset)
      for (u.reset = !1, d[0] = u.block, R = 1; R < h + 1; ++R)
        d[R] = 0;
    if (typeof t != "string")
      for (R = u.start; x < a && R < l; ++x)
        d[R >> 2] |= t[x] << SHIFT$1[R++ & 3];
    else
      for (R = u.start; x < a && R < l; ++x)
        B = t.charCodeAt(x), B < 128 ? d[R >> 2] |= B << SHIFT$1[R++ & 3] : B < 2048 ? (d[R >> 2] |= (192 | B >> 6) << SHIFT$1[R++ & 3], d[R >> 2] |= (128 | B & 63) << SHIFT$1[R++ & 3]) : B < 55296 || B >= 57344 ? (d[R >> 2] |= (224 | B >> 12) << SHIFT$1[R++ & 3], d[R >> 2] |= (128 | B >> 6 & 63) << SHIFT$1[R++ & 3], d[R >> 2] |= (128 | B & 63) << SHIFT$1[R++ & 3]) : (B = 65536 + ((B & 1023) << 10 | t.charCodeAt(++x) & 1023), d[R >> 2] |= (240 | B >> 18) << SHIFT$1[R++ & 3], d[R >> 2] |= (128 | B >> 12 & 63) << SHIFT$1[R++ & 3], d[R >> 2] |= (128 | B >> 6 & 63) << SHIFT$1[R++ & 3], d[R >> 2] |= (128 | B & 63) << SHIFT$1[R++ & 3]);
    if (u.lastByteIndex = R, R >= l) {
      for (u.start = R - l, u.block = d[h], R = 0; R < h; ++R)
        c[R] ^= d[R];
      f$1(c), u.reset = !0;
    } else
      u.start = R;
  }
  if (R = u.lastByteIndex, d[R >> 2] |= KECCAK_PADDING$1[R & 3], u.lastByteIndex === l)
    for (d[0] = d[h], R = 1; R < h + 1; ++R)
      d[R] = 0;
  for (d[h - 1] |= 2147483648, R = 0; R < h; ++R)
    c[R] ^= d[R];
  f$1(c);
  var j = "", o, e = 0;
  for (R = 0; e < g; ) {
    for (R = 0; R < h && e < g; ++R, ++e)
      o = c[R], j += HEX_CHARS$1[o >> 4 & 15] + HEX_CHARS$1[o & 15] + HEX_CHARS$1[o >> 12 & 15] + HEX_CHARS$1[o >> 8 & 15] + HEX_CHARS$1[o >> 20 & 15] + HEX_CHARS$1[o >> 16 & 15] + HEX_CHARS$1[o >> 28 & 15] + HEX_CHARS$1[o >> 24 & 15];
    e % h === 0 && (f$1(c), R = 0);
  }
  return "0x" + j;
}, f$1 = (u) => {
  var t, a, d, l, h, g, c, x, R, B, j, o, e, n, i, y, m, U, be, Ke, ze, Pe, st, G, z, W, F, k, T, p, b, _, v, S, E, w, A, I, C, X, D, V, Z, J, ee, he, le, ie, Ne, ue, se, ut, qe, ve, ot, He, Ae, ct, Ve, _e, lt, je, me;
  for (d = 0; d < 48; d += 2)
    l = u[0] ^ u[10] ^ u[20] ^ u[30] ^ u[40], h = u[1] ^ u[11] ^ u[21] ^ u[31] ^ u[41], g = u[2] ^ u[12] ^ u[22] ^ u[32] ^ u[42], c = u[3] ^ u[13] ^ u[23] ^ u[33] ^ u[43], x = u[4] ^ u[14] ^ u[24] ^ u[34] ^ u[44], R = u[5] ^ u[15] ^ u[25] ^ u[35] ^ u[45], B = u[6] ^ u[16] ^ u[26] ^ u[36] ^ u[46], j = u[7] ^ u[17] ^ u[27] ^ u[37] ^ u[47], o = u[8] ^ u[18] ^ u[28] ^ u[38] ^ u[48], e = u[9] ^ u[19] ^ u[29] ^ u[39] ^ u[49], t = o ^ (g << 1 | c >>> 31), a = e ^ (c << 1 | g >>> 31), u[0] ^= t, u[1] ^= a, u[10] ^= t, u[11] ^= a, u[20] ^= t, u[21] ^= a, u[30] ^= t, u[31] ^= a, u[40] ^= t, u[41] ^= a, t = l ^ (x << 1 | R >>> 31), a = h ^ (R << 1 | x >>> 31), u[2] ^= t, u[3] ^= a, u[12] ^= t, u[13] ^= a, u[22] ^= t, u[23] ^= a, u[32] ^= t, u[33] ^= a, u[42] ^= t, u[43] ^= a, t = g ^ (B << 1 | j >>> 31), a = c ^ (j << 1 | B >>> 31), u[4] ^= t, u[5] ^= a, u[14] ^= t, u[15] ^= a, u[24] ^= t, u[25] ^= a, u[34] ^= t, u[35] ^= a, u[44] ^= t, u[45] ^= a, t = x ^ (o << 1 | e >>> 31), a = R ^ (e << 1 | o >>> 31), u[6] ^= t, u[7] ^= a, u[16] ^= t, u[17] ^= a, u[26] ^= t, u[27] ^= a, u[36] ^= t, u[37] ^= a, u[46] ^= t, u[47] ^= a, t = B ^ (l << 1 | h >>> 31), a = j ^ (h << 1 | l >>> 31), u[8] ^= t, u[9] ^= a, u[18] ^= t, u[19] ^= a, u[28] ^= t, u[29] ^= a, u[38] ^= t, u[39] ^= a, u[48] ^= t, u[49] ^= a, n = u[0], i = u[1], he = u[11] << 4 | u[10] >>> 28, le = u[10] << 4 | u[11] >>> 28, k = u[20] << 3 | u[21] >>> 29, T = u[21] << 3 | u[20] >>> 29, _e = u[31] << 9 | u[30] >>> 23, lt = u[30] << 9 | u[31] >>> 23, V = u[40] << 18 | u[41] >>> 14, Z = u[41] << 18 | u[40] >>> 14, S = u[2] << 1 | u[3] >>> 31, E = u[3] << 1 | u[2] >>> 31, y = u[13] << 12 | u[12] >>> 20, m = u[12] << 12 | u[13] >>> 20, ie = u[22] << 10 | u[23] >>> 22, Ne = u[23] << 10 | u[22] >>> 22, p = u[33] << 13 | u[32] >>> 19, b = u[32] << 13 | u[33] >>> 19, je = u[42] << 2 | u[43] >>> 30, me = u[43] << 2 | u[42] >>> 30, ve = u[5] << 30 | u[4] >>> 2, ot = u[4] << 30 | u[5] >>> 2, w = u[14] << 6 | u[15] >>> 26, A = u[15] << 6 | u[14] >>> 26, U = u[25] << 11 | u[24] >>> 21, be = u[24] << 11 | u[25] >>> 21, ue = u[34] << 15 | u[35] >>> 17, se = u[35] << 15 | u[34] >>> 17, _ = u[45] << 29 | u[44] >>> 3, v = u[44] << 29 | u[45] >>> 3, G = u[6] << 28 | u[7] >>> 4, z = u[7] << 28 | u[6] >>> 4, He = u[17] << 23 | u[16] >>> 9, Ae = u[16] << 23 | u[17] >>> 9, I = u[26] << 25 | u[27] >>> 7, C = u[27] << 25 | u[26] >>> 7, Ke = u[36] << 21 | u[37] >>> 11, ze = u[37] << 21 | u[36] >>> 11, ut = u[47] << 24 | u[46] >>> 8, qe = u[46] << 24 | u[47] >>> 8, J = u[8] << 27 | u[9] >>> 5, ee = u[9] << 27 | u[8] >>> 5, W = u[18] << 20 | u[19] >>> 12, F = u[19] << 20 | u[18] >>> 12, ct = u[29] << 7 | u[28] >>> 25, Ve = u[28] << 7 | u[29] >>> 25, X = u[38] << 8 | u[39] >>> 24, D = u[39] << 8 | u[38] >>> 24, Pe = u[48] << 14 | u[49] >>> 18, st = u[49] << 14 | u[48] >>> 18, u[0] = n ^ ~y & U, u[1] = i ^ ~m & be, u[10] = G ^ ~W & k, u[11] = z ^ ~F & T, u[20] = S ^ ~w & I, u[21] = E ^ ~A & C, u[30] = J ^ ~he & ie, u[31] = ee ^ ~le & Ne, u[40] = ve ^ ~He & ct, u[41] = ot ^ ~Ae & Ve, u[2] = y ^ ~U & Ke, u[3] = m ^ ~be & ze, u[12] = W ^ ~k & p, u[13] = F ^ ~T & b, u[22] = w ^ ~I & X, u[23] = A ^ ~C & D, u[32] = he ^ ~ie & ue, u[33] = le ^ ~Ne & se, u[42] = He ^ ~ct & _e, u[43] = Ae ^ ~Ve & lt, u[4] = U ^ ~Ke & Pe, u[5] = be ^ ~ze & st, u[14] = k ^ ~p & _, u[15] = T ^ ~b & v, u[24] = I ^ ~X & V, u[25] = C ^ ~D & Z, u[34] = ie ^ ~ue & ut, u[35] = Ne ^ ~se & qe, u[44] = ct ^ ~_e & je, u[45] = Ve ^ ~lt & me, u[6] = Ke ^ ~Pe & n, u[7] = ze ^ ~st & i, u[16] = p ^ ~_ & G, u[17] = b ^ ~v & z, u[26] = X ^ ~V & S, u[27] = D ^ ~Z & E, u[36] = ue ^ ~ut & J, u[37] = se ^ ~qe & ee, u[46] = _e ^ ~je & ve, u[47] = lt ^ ~me & ot, u[8] = Pe ^ ~n & y, u[9] = st ^ ~i & m, u[18] = _ ^ ~G & W, u[19] = v ^ ~z & F, u[28] = V ^ ~S & w, u[29] = Z ^ ~E & A, u[38] = ut ^ ~J & he, u[39] = qe ^ ~ee & le, u[48] = je ^ ~ve & He, u[49] = me ^ ~ot & Ae, u[0] ^= RC$1[d], u[1] ^= RC$1[d + 1];
}, keccak$1 = (u) => (t) => {
  var a;
  if (t.slice(0, 2) === "0x") {
    a = [];
    for (var d = 2, l = t.length; d < l; d += 2)
      a.push(parseInt(t.slice(d, d + 2), 16));
  } else
    a = t;
  return update$1(Keccak$1(u), a);
}, keccak256$2 = keccak$1(256), secp256k1 = new elliptic.ec("secp256k1");
function generate() {
  const u = secp256k1.genKeyPair();
  return {
    privateKey: decode$5(u.getPrivate("hex")),
    publicKey: decode$5(u.getPublic(!0, "hex"))
  };
}
async function generateAsync() {
  return Promise.resolve(generate());
}
function fromBytes(u) {
  const t = secp256k1.keyFromPrivate(u);
  return {
    privateKey: decode$5(t.getPrivate("hex")),
    publicKey: decode$5(t.getPublic(!0, "hex"))
  };
}
function getFullPublicKey(u) {
  const t = secp256k1.keyFromPublic(u);
  return decode$5(t.getPublic(!1, "hex"));
}
function sign(u, t) {
  const a = encode$3(t), d = decode$5(keccak256$2(`0x${a}`)), h = secp256k1.keyFromPrivate(u).sign(d), g = h.r.toArray("be", 32), c = h.s.toArray("be", 32), x = new Uint8Array(64);
  return x.set(g, 0), x.set(c, 32), x;
}
function verify(u, t, a) {
  const d = encode$3(t), l = decode$5(keccak256$2(`0x${d}`));
  return secp256k1.keyFromPublic(u).verify(l, {
    r: a.subarray(0, 32),
    s: a.subarray(32, 64)
  });
}
const derPrefix$1 = "302d300706052b8104000a032200", derPrefixBytes$1 = decode$5(derPrefix$1);
class EcdsaPublicKey extends Key$1 {
  constructor(t) {
    super(), this._keyData = t;
  }
  get _type() {
    return "secp256k1";
  }
  static fromBytes(t) {
    switch (t.length) {
      case 33:
        return EcdsaPublicKey.fromBytesRaw(t);
      case 47:
        return EcdsaPublicKey.fromBytesDer(t);
      default:
        throw new BadKeyError(
          `invalid public key length: ${t.length} bytes`
        );
    }
  }
  static fromBytesDer(t) {
    if (t.length != 47 || !arrayStartsWith(t, derPrefixBytes$1))
      throw new BadKeyError(
        `invalid public key length: ${t.length} bytes`
      );
    return new EcdsaPublicKey(t.subarray(derPrefixBytes$1.length));
  }
  static fromBytesRaw(t) {
    if (t.length != 33)
      throw new BadKeyError(
        `invalid public key length: ${t.length} bytes`
      );
    return new EcdsaPublicKey(t);
  }
  static fromString(t) {
    return EcdsaPublicKey.fromBytes(decode$5(t));
  }
  verify(t, a) {
    return verify(this._keyData, t, a);
  }
  toBytesDer() {
    const t = new Uint8Array(
      derPrefixBytes$1.length + this._keyData.length
    );
    return t.set(derPrefixBytes$1, 0), t.set(this._keyData, derPrefixBytes$1.length), t;
  }
  toBytesRaw() {
    return new Uint8Array(this._keyData.subarray());
  }
  toEthereumAddress() {
    const t = decode$5(
      keccak256$2(
        `0x${encode$3(
          getFullPublicKey(this.toBytesRaw()).subarray(1)
        )}`
      )
    );
    return encode$3(t.subarray(12));
  }
  equals(t) {
    return arrayEqual$1(this._keyData, t._keyData);
  }
}
const derPrefix = "3030020100300706052b8104000a04220420", derPrefixBytes = decode$5(derPrefix);
class EcdsaPrivateKey {
  constructor(t, a) {
    this._keyPair = t, this._chainCode = a != null ? a : null;
  }
  get _type() {
    return "secp256k1";
  }
  static generate() {
    return new EcdsaPrivateKey(generate());
  }
  static async generateAsync() {
    return new EcdsaPrivateKey(await generateAsync());
  }
  static fromBytes(t) {
    switch (t.length) {
      case 32:
        return EcdsaPrivateKey.fromBytesRaw(t);
      case 50:
        return EcdsaPrivateKey.fromBytesDer(t);
      default:
        throw new BadKeyError(
          `invalid private key length: ${t.length} bytes`
        );
    }
  }
  static fromBytesDer(t) {
    if (t.length != 32 && !arrayStartsWith(t, derPrefixBytes))
      throw new BadKeyError("invalid der header");
    return new EcdsaPrivateKey(
      fromBytes(t.subarray(derPrefixBytes.length))
    );
  }
  static fromBytesRaw(t) {
    return new EcdsaPrivateKey(fromBytes(t));
  }
  static fromString(t) {
    return EcdsaPrivateKey.fromBytes(decode$5(t));
  }
  static fromStringDer(t) {
    return EcdsaPrivateKey.fromBytesDer(decode$5(t));
  }
  static fromStringRaw(t) {
    return EcdsaPrivateKey.fromBytesRaw(decode$5(t));
  }
  static async fromSeed(t) {
    const { keyData: a, chainCode: d } = await fromSeed$1(t);
    return new EcdsaPrivateKey(fromBytes(a), d);
  }
  get publicKey() {
    return new EcdsaPublicKey(this._keyPair.publicKey);
  }
  sign(t) {
    return sign(this._keyPair.privateKey, t);
  }
  toBytesDer() {
    const t = new Uint8Array(derPrefixBytes.length + 32);
    return t.set(derPrefixBytes, 0), t.set(
      this._keyPair.privateKey.subarray(0, 32),
      derPrefixBytes.length
    ), t;
  }
  toBytesRaw() {
    const t = new Uint8Array(32);
    return t.set(this._keyPair.privateKey.slice(0, 32), 0), t;
  }
}
class PublicKey$1 extends Key$1 {
  constructor(t) {
    super(), this._key = t;
  }
  get _type() {
    return this._key._type;
  }
  static fromBytes(t) {
    try {
      return new PublicKey$1(Ed25519PublicKey.fromBytes(t));
    } catch {
    }
    try {
      return new PublicKey$1(EcdsaPublicKey.fromBytes(t));
    } catch {
    }
    throw new BadKeyError(
      `invalid public key length: ${t.length} bytes`
    );
  }
  static fromBytesED25519(t) {
    return new PublicKey$1(Ed25519PublicKey.fromBytes(t));
  }
  static fromBytesECDSA(t) {
    return new PublicKey$1(EcdsaPublicKey.fromBytes(t));
  }
  static fromString(t) {
    return PublicKey$1.fromBytes(decode$5(t));
  }
  static fromStringED25519(t) {
    return PublicKey$1.fromBytesED25519(decode$5(t));
  }
  static fromStringECDSA(t) {
    return PublicKey$1.fromBytesECDSA(decode$5(t));
  }
  verify(t, a) {
    return this._key.verify(t, a);
  }
  verifyTransaction(t) {
    console.log("Deprecated: use `@hashgraph/sdk`.PublicKey instead"), t._requireFrozen(), t.isFrozen() || t.freeze();
    for (const a of t._signedTransactions)
      if (a.sigMap != null && a.sigMap.sigPair != null) {
        let d = !1;
        for (const l of a.sigMap.sigPair) {
          const h = l.pubKeyPrefix;
          if (arrayEqual$1(h, this.toBytesRaw())) {
            d = !0;
            const g = a.bodyBytes, c = l.ed25519 != null ? l.ed25519 : l.ECDSASecp256k1;
            if (!this.verify(g, c))
              return !1;
          }
        }
        if (!d)
          return !1;
      }
    return !0;
  }
  toBytes() {
    return this._key instanceof Ed25519PublicKey ? this.toBytesRaw() : this.toBytesDer();
  }
  toBytesDer() {
    return this._key.toBytesDer();
  }
  toBytesRaw() {
    return this._key.toBytesRaw();
  }
  toString() {
    return this.toStringDer();
  }
  toStringDer() {
    return encode$3(this.toBytesDer());
  }
  toStringRaw() {
    return encode$3(this.toBytesRaw());
  }
  toEthereumAddress() {
    if (this._key instanceof EcdsaPublicKey)
      return this._key.toEthereumAddress();
    throw new Error("unsupported operation on Ed25519PublicKey");
  }
  equals(t) {
    return this._key instanceof Ed25519PublicKey && t._key instanceof Ed25519PublicKey ? this._key.equals(t._key) : this._key instanceof EcdsaPublicKey && t._key instanceof EcdsaPublicKey ? this._key.equals(t._key) : !1;
  }
}
const CipherAlgorithm = {
  Aes128Ctr: "AES-128-CTR",
  Aes128Cbc: "AES-128-CBC"
};
async function createCipheriv(u, t, a, d) {
  let l;
  switch (u.toUpperCase()) {
    case CipherAlgorithm.Aes128Ctr:
      l = {
        name: "AES-CTR",
        counter: a,
        length: 128
      };
      break;
    case CipherAlgorithm.Aes128Cbc:
      l = {
        name: "AES-CBC",
        iv: a
      };
      break;
    default:
      throw new Error(
        "(BUG) non-exhaustive switch statement for CipherAlgorithm"
      );
  }
  const h = await window.crypto.subtle.importKey(
    "raw",
    t,
    l.name,
    !1,
    ["encrypt"]
  );
  return new Uint8Array(
    await window.crypto.subtle.encrypt(l, h, d)
  );
}
async function createDecipheriv(u, t, a, d) {
  let l;
  switch (u.toUpperCase()) {
    case CipherAlgorithm.Aes128Ctr:
      l = {
        name: "AES-CTR",
        counter: a,
        length: 128
      };
      break;
    case CipherAlgorithm.Aes128Cbc:
      l = {
        name: "AES-CBC",
        iv: a
      };
      break;
    default:
      throw new Error(
        "(BUG) non-exhaustive switch statement for CipherAlgorithm"
      );
  }
  const h = await window.crypto.subtle.importKey(
    "raw",
    t,
    l.name,
    !1,
    ["decrypt"]
  );
  return new Uint8Array(
    await window.crypto.subtle.decrypt(l, h, d)
  );
}
async function deriveKey(u, t, a, d, l) {
  const h = typeof t == "string" ? encode$2(t) : t, g = typeof a == "string" ? encode$2(a) : a;
  try {
    const c = await window.crypto.subtle.importKey(
      "raw",
      h,
      {
        name: "PBKDF2",
        hash: u
      },
      !1,
      ["deriveBits"]
    );
    return new Uint8Array(
      await window.crypto.subtle.deriveBits(
        {
          name: "PBKDF2",
          hash: u,
          salt: g,
          iterations: d
        },
        c,
        l << 3
      )
    );
  } catch {
    throw new Error("(BUG) Non-Exhaustive switch statement for algorithms");
  }
}
const HMAC_SHA256 = "hmac-sha256";
async function createKeystore(u, t) {
  const h = await bytesAsync(32), g = await deriveKey(
    HashAlgorithm.Sha256,
    t,
    h,
    262144,
    32
  ), c = await bytesAsync(16), x = await createCipheriv(
    CipherAlgorithm.Aes128Ctr,
    g.slice(0, 16),
    c,
    u
  ), R = await hash$3(
    HashAlgorithm.Sha384,
    g.slice(16),
    x
  ), B = {
    version: 1,
    crypto: {
      ciphertext: encode$3(x),
      cipherparams: { iv: encode$3(c) },
      cipher: CipherAlgorithm.Aes128Ctr,
      kdf: "pbkdf2",
      kdfparams: {
        dkLen: 32,
        salt: encode$3(h),
        c: 262144,
        prf: HMAC_SHA256
      },
      mac: encode$3(R)
    }
  };
  return encode$2(JSON.stringify(B));
}
async function loadKeystore(u, t) {
  const a = JSON.parse(decode$4(u));
  if (a.version !== 1)
    throw new BadKeyError(
      `unsupported keystore version: ${a.version}`
    );
  const {
    ciphertext: d,
    cipherparams: { iv: l },
    cipher: h,
    kdf: g,
    kdfparams: { dkLen: c, salt: x, c: R, prf: B },
    mac: j
  } = a.crypto;
  if (g !== "pbkdf2")
    throw new BadKeyError(`unsupported key derivation function:" + ${g}`);
  if (B !== HMAC_SHA256)
    throw new BadKeyError(
      `unsupported key derivation hash function: ${B}`
    );
  const o = decode$5(x), e = decode$5(l), n = decode$5(d), i = await deriveKey(
    HashAlgorithm.Sha256,
    t,
    o,
    R,
    c
  ), y = decode$5(j), m = await hash$3(
    HashAlgorithm.Sha384,
    i.slice(16),
    n
  );
  if (!y.every((U, be) => U === m[be]))
    throw new BadKeyError("HMAC mismatch; passphrase is incorrect");
  return createDecipheriv(
    h,
    i.slice(0, 16),
    e,
    n
  );
}
function decode$3(u) {
  return decodeIncremental(u)[0];
}
function decodeIncremental(u) {
  const [t, a] = decodeLength(u.subarray(1)), d = a.subarray(0, t), l = a.subarray(t);
  switch (u[0]) {
    case 2:
      return [{ int: decodeInt(d) }, l];
    case 4:
      return [{ bytes: d }, l];
    case 5:
      return [{}, l];
    case 6:
      return [{ ident: decodeObjectIdent(d) }, l];
    case 48:
      return [{ seq: decodeSeq(d) }, l];
    default:
      throw new Error(`unsupported DER type tag: ${u[0]}`);
  }
}
function decodeSeq(u) {
  let t = u;
  const a = [];
  for (; t.length !== 0; ) {
    const [d, l] = decodeIncremental(t);
    a.push(d), t = l;
  }
  return a;
}
function decodeObjectIdent(u) {
  const t = [
    Math.floor(u[0] / 40),
    u[0] % 40
  ];
  let a = 0;
  for (const d of u.subarray(1))
    a *= 128, d < 128 ? (a += d, t.push(a), a = 0) : a += d & 127;
  return t.join(".");
}
function decodeLength(u) {
  if (u[0] < 128)
    return [u[0], u.subarray(1)];
  const t = u[0] - 128, a = u.subarray(1, t + 1), d = u.subarray(t + 1);
  return [decodeInt(a), d];
}
function decodeInt(u) {
  const t = u.length;
  if (t === 1)
    return u[0];
  let a = new DataView(
    u.buffer,
    u.byteOffset,
    u.byteLength
  );
  if (t === 2)
    return a.getUint16(0, !1);
  if (t === 3) {
    const d = Uint8Array.of(0, ...u);
    a = new DataView(d.buffer, d.byteOffset, d.byteLength);
  }
  if (t > 4)
    throw new Error(`unsupported DER integer length of ${t} bytes`);
  return a.getUint32(0, !1);
}
class AlgorithmIdentifier {
  constructor(t) {
    if ("seq" in t && t.seq.length >= 1 && "ident" in t.seq[0])
      this.algIdent = t.seq[0].ident, this.parameters = t.seq[1];
    else
      throw new Error(
        `error parsing AlgorithmIdentifier from ${JSON.stringify(t)}`
      );
  }
  toString() {
    return JSON.stringify(this);
  }
}
class PBES2Params {
  constructor(t) {
    if ("seq" in t && t.seq.length === 2)
      this.kdf = new AlgorithmIdentifier(t.seq[0]), this.encScheme = new AlgorithmIdentifier(t.seq[1]);
    else
      throw new Error(
        `error parsing PBES2Params from ${JSON.stringify(t)}`
      );
  }
}
class PBKDF2Params {
  constructor(t) {
    if ("seq" in t && t.seq.length >= 2 && "bytes" in t.seq[0] && "int" in t.seq[1] && (this.salt = t.seq[0].bytes, this.iterCount = t.seq[1].int, t.seq.length > 2)) {
      if ("seq" in t.seq[2]) {
        this.prf = new AlgorithmIdentifier(t.seq[2]);
        return;
      } else
        "int" in t.seq[2] && (this.keyLength = t.seq[2].int);
      t.seq.length === 4 && (this.prf = new AlgorithmIdentifier(t.seq[3]));
      return;
    }
    throw new Error(
      `error parsing PBKDF2Params from ${JSON.stringify(t)}`
    );
  }
}
class PrivateKeyInfo {
  constructor(t) {
    if ("seq" in t && t.seq.length === 3) {
      if ("int" in t.seq[0] && t.seq[0].int === 0)
        this.version = 0;
      else
        throw new Error(
          `expected version = 0, got ${JSON.stringify(t.seq[0])}`
        );
      if (this.algId = new AlgorithmIdentifier(t.seq[1]), "bytes" in t.seq[2])
        this.privateKey = t.seq[2].bytes;
      else
        throw new Error(
          `expected octet string as 3rd element, got ${JSON.stringify(
            t.seq[2]
          )}`
        );
      return;
    }
    throw new Error(
      `error parsing PrivateKeyInfo from ${JSON.stringify(t)}`
    );
  }
  static parse(t) {
    return new PrivateKeyInfo(decode$3(t));
  }
}
class EncryptedPrivateKeyInfo {
  constructor(t) {
    if ("seq" in t && t.seq.length === 2 && "bytes" in t.seq[1]) {
      this.algId = new AlgorithmIdentifier(t.seq[0]), this.data = t.seq[1].bytes;
      return;
    }
    throw new Error(
      `error parsing EncryptedPrivateKeyInfo from ${JSON.stringify(t)}`
    );
  }
  static parse(t) {
    return new EncryptedPrivateKeyInfo(decode$3(t));
  }
  async decrypt(t) {
    if (this.algId.algIdent !== "1.2.840.113549.1.5.13" || !this.algId.parameters)
      throw new Error(
        `unsupported key encryption algorithm: ${this.algId.toString()}`
      );
    const a = new PBES2Params(this.algId.parameters);
    if (a.kdf.algIdent !== "1.2.840.113549.1.5.12" || !a.kdf.parameters)
      throw new Error(
        `unsupported key derivation function: ${a.kdf.toString()}`
      );
    const d = new PBKDF2Params(a.kdf.parameters);
    if (d.prf) {
      if (d.prf.algIdent !== "1.2.840.113549.2.9")
        throw new Error(`unsupported PRF ${d.prf.toString()}`);
    } else
      throw new Error("unsupported PRF HMAC-SHA-1");
    if (a.encScheme.algIdent !== "2.16.840.1.101.3.4.1.2")
      throw new Error(
        `unsupported encryption scheme: ${a.encScheme.toString()}`
      );
    if (!a.encScheme.parameters || !("bytes" in a.encScheme.parameters))
      throw new Error(
        `expected IV as bytes for AES-128-CBC, got: ${JSON.stringify(a.encScheme.parameters)}`
      );
    const l = d.keyLength || 16, h = a.encScheme.parameters.bytes, g = await deriveKey(
      HashAlgorithm.Sha256,
      t,
      d.salt,
      d.iterCount,
      l
    ), c = await createDecipheriv(
      CipherAlgorithm.Aes128Cbc,
      g,
      h,
      this.data
    );
    return PrivateKeyInfo.parse(c);
  }
}
function decode$2(u) {
  return Uint8Array.from(atob(u), (t) => t.charCodeAt(0));
}
const BEGIN_PRIVATEKEY = `-----BEGIN PRIVATE KEY-----
`, END_PRIVATEKEY = `-----END PRIVATE KEY-----
`, BEGIN_ENCRYPTED_PRIVATEKEY = `-----BEGIN ENCRYPTED PRIVATE KEY-----
`, END_ENCRYPTED_PRIVATEKEY = `-----END ENCRYPTED PRIVATE KEY-----
`;
async function read(u, t) {
  const a = t ? BEGIN_ENCRYPTED_PRIVATEKEY : BEGIN_PRIVATEKEY, d = t ? END_ENCRYPTED_PRIVATEKEY : END_PRIVATEKEY, l = u.indexOf(a), h = u.indexOf(d);
  if (l === -1 || h === -1)
    throw new BadKeyError("failed to find a private key in the PEM file");
  const g = u.slice(l + a.length, h), c = decode$2(g);
  if (t) {
    let x;
    try {
      x = EncryptedPrivateKeyInfo.parse(c);
    } catch (o) {
      const e = o != null && o.message != null ? o.message : "";
      throw new BadKeyError(
        `failed to parse encrypted private key: ${e}`
      );
    }
    const R = await x.decrypt(t);
    let B = null;
    if (R.algId.algIdent === "1.3.101.112")
      B = Ed25519PrivateKey;
    else if (R.algId.algIdent === "1.3.132.0.10")
      B = EcdsaPrivateKey;
    else
      throw new BadKeyError(
        `unknown private key algorithm ${R.algId.toString()}`
      );
    const j = decode$3(R.privateKey);
    if (!("bytes" in j))
      throw new BadKeyError(
        `expected ASN bytes, got ${JSON.stringify(j)}`
      );
    return B.fromBytes(j.bytes);
  }
  return c.subarray(16);
}
function legacy(u, t) {
  const a = new Uint8Array(u.length + 8);
  a.set(u, 0);
  const d = new DataView(
    a.buffer,
    a.byteOffset,
    a.byteLength
  );
  t === 1099511627775 ? (d.setInt32(u.length + 0, 255), d.setInt32(u.length + 4, -1)) : (d.setInt32(u.length + 0, t < 0 ? -1 : 0), d.setInt32(u.length + 4, t));
  const l = Uint8Array.from([255]);
  return deriveKey(
    HashAlgorithm.Sha512,
    a,
    l,
    2048,
    32
  );
}
const CACHE = {
  privateKeyConstructor: null,
  privateKeyFromBytes: null,
  mnemonicFromString: null
};
class PrivateKey$1 extends Key$1 {
  constructor(t) {
    super(), this._key = t;
  }
  get _type() {
    return this._key._type;
  }
  get _chainCode() {
    return this._key._chainCode;
  }
  static generateED25519() {
    return new PrivateKey$1(Ed25519PrivateKey.generate());
  }
  static generateECDSA() {
    return new PrivateKey$1(EcdsaPrivateKey.generate());
  }
  static generate() {
    return PrivateKey$1.generateED25519();
  }
  static async generateAsync() {
    return PrivateKey$1.generateED25519Async();
  }
  static async generateED25519Async() {
    return new PrivateKey$1(await Ed25519PrivateKey.generateAsync());
  }
  static async generateECDSAAsync() {
    return new PrivateKey$1(await EcdsaPrivateKey.generateAsync());
  }
  static fromBytes(t) {
    try {
      return new PrivateKey$1(Ed25519PrivateKey.fromBytes(t));
    } catch {
    }
    try {
      return new PrivateKey$1(EcdsaPrivateKey.fromBytes(t));
    } catch {
    }
    throw new BadKeyError(
      `invalid private key length: ${t.length} bytes`
    );
  }
  static fromBytesECDSA(t) {
    return new PrivateKey$1(EcdsaPrivateKey.fromBytes(t));
  }
  static fromBytesED25519(t) {
    return new PrivateKey$1(Ed25519PrivateKey.fromBytes(t));
  }
  static fromString(t) {
    return PrivateKey$1.fromBytes(decode$5(t));
  }
  static fromStringECDSA(t) {
    return PrivateKey$1.fromBytesECDSA(decode$5(t));
  }
  static fromStringED25519(t) {
    return PrivateKey$1.fromBytesED25519(decode$5(t));
  }
  static async fromSeedED25519(t) {
    const a = await Ed25519PrivateKey.fromSeed(t);
    return new PrivateKey$1(a);
  }
  static async fromSeedECDSAsecp256k1(t) {
    const a = await EcdsaPrivateKey.fromSeed(t);
    return new PrivateKey$1(a);
  }
  static async fromMnemonic(t, a = "") {
    if (CACHE.mnemonicFromString == null)
      throw new Error("Mnemonic not found in cache");
    return (typeof t == "string" ? CACHE.mnemonicFromString(t) : t).toEd25519PrivateKey(a);
  }
  static async fromKeystore(t, a = "") {
    return PrivateKey$1.fromBytes(await loadKeystore(t, a));
  }
  static async fromPem(t, a = "") {
    const d = await read(t, a);
    return d instanceof Ed25519PrivateKey || d instanceof EcdsaPrivateKey ? new PrivateKey$1(d) : PrivateKey$1.fromBytes(d);
  }
  async derive(t) {
    if (this._key._chainCode == null)
      throw new Error("this private key does not support key derivation");
    if (this._key instanceof Ed25519PrivateKey) {
      const { keyData: a, chainCode: d } = await derive(
        this.toBytesRaw(),
        this._key._chainCode,
        t
      );
      return new PrivateKey$1(new Ed25519PrivateKey(a, d));
    } else {
      const { keyData: a, chainCode: d } = await derive$1(
        this.toBytesRaw(),
        this._key._chainCode,
        t
      );
      return new PrivateKey$1(
        new EcdsaPrivateKey(fromBytes(a), d)
      );
    }
  }
  async legacyDerive(t) {
    const a = await legacy(
      this.toBytesRaw().subarray(0, 32),
      t
    ), d = this._key.constructor;
    return new PrivateKey$1(new d(a));
  }
  get publicKey() {
    return new PublicKey$1(this._key.publicKey);
  }
  sign(t) {
    return this._key.sign(t);
  }
  signTransaction(t) {
    if (t.isFrozen() || t.freeze(), t._signedTransactions.length != 1)
      throw new Error(
        "`PrivateKey.signTransaction()` requires `Transaction` to have a single node `AccountId` set"
      );
    const a = t._signedTransactions[0], d = encode$3(this.publicKey.toBytesRaw());
    a.sigMap == null && (a.sigMap = {}), a.sigMap.sigPair == null && (a.sigMap.sigPair = []);
    for (const g of a.sigMap.sigPair)
      if (g.pubKeyPrefix != null && encode$3(g.pubKeyPrefix) === d)
        switch (this._type) {
          case "ED25519":
            return g.ed25519;
          case "secp256k1":
            return g.ECDSASecp256k1;
        }
    const l = this.sign(
      a.bodyBytes != null ? a.bodyBytes : new Uint8Array()
    ), h = {
      pubKeyPrefix: this.publicKey.toBytesRaw()
    };
    switch (this._type) {
      case "ED25519":
        h.ed25519 = l;
        break;
      case "secp256k1":
        h.ECDSASecp256k1 = l;
        break;
    }
    return a.sigMap.sigPair.push(h), t._signerPublicKeys.add(d), l;
  }
  isDerivable() {
    return this._key._chainCode != null;
  }
  toBytes() {
    return this._key instanceof Ed25519PrivateKey ? this.toBytesRaw() : this.toBytesDer();
  }
  toBytesDer() {
    return this._key.toBytesDer();
  }
  toBytesRaw() {
    return this._key.toBytesRaw();
  }
  toString() {
    return this.toStringDer();
  }
  toStringDer() {
    return encode$3(this.toBytesDer());
  }
  toStringRaw() {
    return encode$3(this.toBytesRaw());
  }
  toKeystore(t = "") {
    return createKeystore(this.toBytesRaw(), t);
  }
}
CACHE.privateKeyConstructor = (u) => new PrivateKey$1(u);
CACHE.privateKeyFromBytes = (u) => PrivateKey$1.fromBytes(u);
const BadMnemonicReason = Object.freeze({
  BadLength: "BadLength",
  UnknownWords: "UnknownWords",
  ChecksumMismatch: "ChecksumMismatch"
});
class BadMnemonicError extends Error {
  constructor(t, a, d) {
    let l;
    switch (a) {
      case BadMnemonicReason.BadLength:
        l = "mnemonic is of an unexpected number of words";
        break;
      case BadMnemonicReason.ChecksumMismatch:
        l = "checksum byte in mnemonic did not match the rest of the mnemonic";
        break;
      case BadMnemonicReason.UnknownWords:
        l = "mnemonic contained words that are not in the standard word list";
        break;
      default:
        throw new Error(
          `unexpected value ${a.toString()} for 'reason'`
        );
    }
    super(`invalid mnemonic: ${l}`), typeof Error.captureStackTrace < "u" && Error.captureStackTrace(this, BadMnemonicError), this.name = "BadMnemonicError", this.reason = a, this.mnemonic = t, this.unknownWordIndices = d;
  }
}
const legacyWords = [
  "aback",
  "abbey",
  "abbot",
  "abide",
  "ablaze",
  "able",
  "aboard",
  "abode",
  "abort",
  "abound",
  "about",
  "above",
  "abroad",
  "abrupt",
  "absent",
  "absorb",
  "absurd",
  "abuse",
  "accent",
  "accept",
  "access",
  "accord",
  "accuse",
  "ace",
  "ache",
  "aching",
  "acid",
  "acidic",
  "acorn",
  "acre",
  "across",
  "act",
  "action",
  "active",
  "actor",
  "actual",
  "acute",
  "adam",
  "adapt",
  "add",
  "added",
  "addict",
  "adept",
  "adhere",
  "adjust",
  "admire",
  "admit",
  "adobe",
  "adopt",
  "adrift",
  "adult",
  "adverb",
  "advice",
  "aerial",
  "afar",
  "affair",
  "affect",
  "afford",
  "afghan",
  "afield",
  "afloat",
  "afraid",
  "afresh",
  "after",
  "again",
  "age",
  "agency",
  "agenda",
  "agent",
  "aghast",
  "agile",
  "ago",
  "agony",
  "agree",
  "agreed",
  "ahead",
  "aid",
  "aide",
  "aim",
  "air",
  "airman",
  "airy",
  "akin",
  "alarm",
  "alaska",
  "albeit",
  "album",
  "ale",
  "alert",
  "alibi",
  "alice",
  "alien",
  "alight",
  "align",
  "alike",
  "alive",
  "alkali",
  "all",
  "alley",
  "allied",
  "allow",
  "alloy",
  "ally",
  "almond",
  "almost",
  "aloft",
  "alone",
  "along",
  "aloof",
  "aloud",
  "alpha",
  "alpine",
  "also",
  "altar",
  "alter",
  "always",
  "amaze",
  "amazon",
  "amber",
  "ambush",
  "amen",
  "amend",
  "amid",
  "amidst",
  "amiss",
  "among",
  "amount",
  "ample",
  "amuse",
  "anchor",
  "and",
  "andrew",
  "anew",
  "angel",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "annoy",
  "annual",
  "answer",
  "anthem",
  "any",
  "anyhow",
  "anyway",
  "apart",
  "apathy",
  "apex",
  "apiece",
  "appeal",
  "appear",
  "apple",
  "apply",
  "april",
  "apron",
  "arab",
  "arcade",
  "arcane",
  "arch",
  "arctic",
  "ardent",
  "are",
  "area",
  "argue",
  "arid",
  "arise",
  "ark",
  "arm",
  "armful",
  "army",
  "aroma",
  "around",
  "arouse",
  "array",
  "arrest",
  "arrive",
  "arrow",
  "arson",
  "art",
  "artery",
  "artful",
  "artist",
  "ascent",
  "ash",
  "ashen",
  "ashore",
  "aside",
  "ask",
  "asleep",
  "aspect",
  "assay",
  "assent",
  "assert",
  "assess",
  "asset",
  "assign",
  "assist",
  "assume",
  "assure",
  "asthma",
  "astute",
  "asylum",
  "ate",
  "athens",
  "atlas",
  "atom",
  "atomic",
  "attach",
  "attack",
  "attain",
  "attend",
  "attic",
  "auburn",
  "audio",
  "audit",
  "august",
  "aunt",
  "auntie",
  "aura",
  "austin",
  "author",
  "auto",
  "autumn",
  "avail",
  "avenge",
  "avenue",
  "avert",
  "avid",
  "avoid",
  "await",
  "awake",
  "awaken",
  "award",
  "aware",
  "awash",
  "away",
  "awful",
  "awhile",
  "axe",
  "axes",
  "axiom",
  "axis",
  "axle",
  "aye",
  "babe",
  "baby",
  "bach",
  "back",
  "backup",
  "bacon",
  "bad",
  "badge",
  "badly",
  "bag",
  "baggy",
  "bail",
  "bait",
  "bake",
  "baker",
  "bakery",
  "bald",
  "ball",
  "ballad",
  "ballet",
  "ballot",
  "baltic",
  "bamboo",
  "ban",
  "banal",
  "banana",
  "band",
  "bang",
  "bank",
  "bar",
  "barber",
  "bare",
  "barely",
  "barge",
  "bark",
  "barley",
  "barn",
  "baron",
  "barrel",
  "barren",
  "basalt",
  "base",
  "basic",
  "basil",
  "basin",
  "basis",
  "basket",
  "bass",
  "bat",
  "batch",
  "bath",
  "baton",
  "battle",
  "bay",
  "beach",
  "beacon",
  "beak",
  "beam",
  "bean",
  "bear",
  "beard",
  "beast",
  "beat",
  "beauty",
  "become",
  "bed",
  "beech",
  "beef",
  "beefy",
  "beep",
  "beer",
  "beet",
  "beetle",
  "before",
  "beg",
  "beggar",
  "begin",
  "behalf",
  "behave",
  "behind",
  "beige",
  "being",
  "belief",
  "bell",
  "belly",
  "belong",
  "below",
  "belt",
  "bench",
  "bend",
  "benign",
  "bent",
  "berlin",
  "berry",
  "berth",
  "beset",
  "beside",
  "best",
  "bestow",
  "bet",
  "beta",
  "betray",
  "better",
  "beware",
  "beyond",
  "bias",
  "biceps",
  "bicker",
  "bid",
  "big",
  "bigger",
  "bike",
  "bile",
  "bill",
  "bin",
  "binary",
  "bind",
  "biopsy",
  "birch",
  "bird",
  "birdie",
  "birth",
  "bishop",
  "bit",
  "bitch",
  "bite",
  "bitter",
  "black",
  "blade",
  "blame",
  "bland",
  "blast",
  "blaze",
  "bleak",
  "blend",
  "bless",
  "blew",
  "blind",
  "blink",
  "blip",
  "bliss",
  "blitz",
  "block",
  "blond",
  "blood",
  "bloody",
  "bloom",
  "blot",
  "blouse",
  "blow",
  "blue",
  "bluff",
  "blunt",
  "blur",
  "blush",
  "boar",
  "board",
  "boast",
  "boat",
  "bob",
  "bodily",
  "body",
  "bogus",
  "boil",
  "bold",
  "bolt",
  "bomb",
  "bombay",
  "bond",
  "bone",
  "bonn",
  "bonnet",
  "bonus",
  "bony",
  "book",
  "boom",
  "boost",
  "boot",
  "booth",
  "booze",
  "border",
  "bore",
  "borrow",
  "bosom",
  "boss",
  "boston",
  "both",
  "bother",
  "bottle",
  "bottom",
  "bought",
  "bounce",
  "bound",
  "bounty",
  "bout",
  "bovine",
  "bow",
  "bowel",
  "bowl",
  "box",
  "boy",
  "boyish",
  "brace",
  "brain",
  "brainy",
  "brake",
  "bran",
  "branch",
  "brand",
  "brandy",
  "brass",
  "brave",
  "bravo",
  "brazil",
  "breach",
  "bread",
  "break",
  "breast",
  "breath",
  "bred",
  "breed",
  "breeze",
  "brew",
  "bribe",
  "brick",
  "bride",
  "bridge",
  "brief",
  "bright",
  "brim",
  "brine",
  "bring",
  "brink",
  "brisk",
  "broad",
  "broke",
  "broken",
  "bronze",
  "brook",
  "broom",
  "brown",
  "bruise",
  "brush",
  "brutal",
  "brute",
  "bubble",
  "buck",
  "bucket",
  "buckle",
  "budget",
  "buffet",
  "buggy",
  "build",
  "bulb",
  "bulge",
  "bulk",
  "bulky",
  "bull",
  "bullet",
  "bully",
  "bump",
  "bumpy",
  "bunch",
  "bundle",
  "bunk",
  "bunny",
  "burden",
  "bureau",
  "burial",
  "buried",
  "burly",
  "burn",
  "burnt",
  "burrow",
  "burst",
  "bury",
  "bus",
  "bush",
  "bust",
  "bustle",
  "busy",
  "but",
  "butler",
  "butt",
  "butter",
  "button",
  "buy",
  "buyer",
  "buzz",
  "bye",
  "byte",
  "cab",
  "cabin",
  "cable",
  "cache",
  "cactus",
  "caesar",
  "cage",
  "cairo",
  "cajun",
  "cajole",
  "cake",
  "calf",
  "call",
  "caller",
  "calm",
  "calmly",
  "came",
  "camel",
  "camera",
  "camp",
  "campus",
  "can",
  "canada",
  "canal",
  "canary",
  "cancel",
  "cancer",
  "candid",
  "candle",
  "candy",
  "cane",
  "canine",
  "canoe",
  "canopy",
  "canvas",
  "canyon",
  "cap",
  "cape",
  "car",
  "carbon",
  "card",
  "care",
  "career",
  "caress",
  "cargo",
  "carl",
  "carnal",
  "carol",
  "carp",
  "carpet",
  "carrot",
  "carry",
  "cart",
  "cartel",
  "case",
  "cash",
  "cask",
  "cast",
  "castle",
  "casual",
  "cat",
  "catch",
  "cater",
  "cattle",
  "caught",
  "causal",
  "cause",
  "cave",
  "cease",
  "celery",
  "cell",
  "cellar",
  "celtic",
  "cement",
  "censor",
  "census",
  "cent",
  "cereal",
  "chain",
  "chair",
  "chalk",
  "chalky",
  "champ",
  "chance",
  "change",
  "chant",
  "chaos",
  "chap",
  "chapel",
  "charge",
  "charm",
  "chart",
  "chase",
  "chat",
  "cheap",
  "cheat",
  "check",
  "cheek",
  "cheeky",
  "cheer",
  "cheery",
  "cheese",
  "chef",
  "cheque",
  "cherry",
  "chess",
  "chest",
  "chew",
  "chic",
  "chick",
  "chief",
  "child",
  "chile",
  "chill",
  "chilly",
  "chin",
  "china",
  "chip",
  "choice",
  "choir",
  "choose",
  "chop",
  "choppy",
  "chord",
  "chorus",
  "chose",
  "chosen",
  "chris",
  "chrome",
  "chunk",
  "chunky",
  "church",
  "cider",
  "cigar",
  "cinema",
  "circa",
  "circle",
  "circus",
  "cite",
  "city",
  "civic",
  "civil",
  "clad",
  "claim",
  "clammy",
  "clan",
  "clap",
  "clash",
  "clasp",
  "class",
  "clause",
  "claw",
  "clay",
  "clean",
  "clear",
  "clergy",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climax",
  "climb",
  "clinch",
  "cling",
  "clinic",
  "clip",
  "cloak",
  "clock",
  "clone",
  "close",
  "closer",
  "closet",
  "cloth",
  "cloud",
  "cloudy",
  "clout",
  "clown",
  "club",
  "clue",
  "clumsy",
  "clung",
  "clutch",
  "coach",
  "coal",
  "coarse",
  "coast",
  "coat",
  "coax",
  "cobalt",
  "cobra",
  "coca",
  "cock",
  "cocoa",
  "code",
  "coffee",
  "coffin",
  "cohort",
  "coil",
  "coin",
  "coke",
  "cold",
  "collar",
  "colon",
  "colony",
  "colt",
  "column",
  "comb",
  "combat",
  "come",
  "comedy",
  "comic",
  "commit",
  "common",
  "compel",
  "comply",
  "concur",
  "cone",
  "confer",
  "congo",
  "consul",
  "convex",
  "convey",
  "convoy",
  "cook",
  "cool",
  "cope",
  "copper",
  "copy",
  "coral",
  "cord",
  "core",
  "cork",
  "corn",
  "corner",
  "corps",
  "corpse",
  "corpus",
  "cortex",
  "cosmic",
  "cosmos",
  "cost",
  "costly",
  "cotton",
  "couch",
  "cough",
  "could",
  "count",
  "county",
  "coup",
  "couple",
  "coupon",
  "course",
  "court",
  "cousin",
  "cove",
  "cover",
  "covert",
  "cow",
  "coward",
  "cowboy",
  "cozy",
  "crab",
  "crack",
  "cradle",
  "craft",
  "crafty",
  "crag",
  "crane",
  "crash",
  "crate",
  "crater",
  "crawl",
  "crazy",
  "creak",
  "cream",
  "creamy",
  "create",
  "credit",
  "creed",
  "creek",
  "creep",
  "creepy",
  "crept",
  "crest",
  "crew",
  "cried",
  "crime",
  "crisis",
  "crisp",
  "critic",
  "crook",
  "crop",
  "cross",
  "crow",
  "crowd",
  "crown",
  "crude",
  "cruel",
  "cruise",
  "crunch",
  "crush",
  "crust",
  "crux",
  "cry",
  "crypt",
  "cuba",
  "cube",
  "cubic",
  "cuckoo",
  "cuff",
  "cult",
  "cup",
  "curb",
  "cure",
  "curfew",
  "curl",
  "curry",
  "curse",
  "cursor",
  "curve",
  "cuss",
  "custom",
  "cut",
  "cute",
  "cycle",
  "cyclic",
  "cynic",
  "czech",
  "dad",
  "daddy",
  "dagger",
  "daily",
  "dairy",
  "daisy",
  "dale",
  "dam",
  "damage",
  "damp",
  "dampen",
  "dance",
  "danger",
  "danish",
  "dare",
  "dark",
  "darken",
  "darn",
  "dart",
  "dash",
  "data",
  "date",
  "david",
  "dawn",
  "day",
  "dead",
  "deadly",
  "deaf",
  "deal",
  "dealer",
  "dean",
  "dear",
  "death",
  "debate",
  "debit",
  "debris",
  "debt",
  "debtor",
  "decade",
  "decay",
  "decent",
  "decide",
  "deck",
  "decor",
  "decree",
  "deduce",
  "deed",
  "deep",
  "deeply",
  "deer",
  "defeat",
  "defect",
  "defend",
  "defer",
  "define",
  "defy",
  "degree",
  "deity",
  "delay",
  "delete",
  "delhi",
  "delta",
  "demand",
  "demise",
  "demo",
  "demure",
  "denial",
  "denote",
  "dense",
  "dental",
  "deny",
  "depart",
  "depend",
  "depict",
  "deploy",
  "depot",
  "depth",
  "deputy",
  "derive",
  "desert",
  "design",
  "desire",
  "desist",
  "desk",
  "detail",
  "detect",
  "deter",
  "detest",
  "detour",
  "device",
  "devise",
  "devoid",
  "devote",
  "devour",
  "dial",
  "diana",
  "diary",
  "dice",
  "dictum",
  "did",
  "die",
  "diesel",
  "diet",
  "differ",
  "dig",
  "digest",
  "digit",
  "dine",
  "dinghy",
  "dinner",
  "diode",
  "dip",
  "dire",
  "direct",
  "dirt",
  "dirty",
  "disc",
  "disco",
  "dish",
  "disk",
  "dismal",
  "dispel",
  "ditch",
  "dive",
  "divert",
  "divide",
  "divine",
  "dizzy",
  "docile",
  "dock",
  "doctor",
  "dog",
  "dogma",
  "dole",
  "doll",
  "dollar",
  "dolly",
  "domain",
  "dome",
  "domino",
  "donate",
  "done",
  "donkey",
  "donor",
  "doom",
  "door",
  "dorsal",
  "dose",
  "dot",
  "double",
  "doubt",
  "dough",
  "dour",
  "dove",
  "down",
  "dozen",
  "draft",
  "drag",
  "dragon",
  "drain",
  "drama",
  "drank",
  "draw",
  "drawer",
  "dread",
  "dream",
  "dreary",
  "dress",
  "drew",
  "dried",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "driver",
  "drop",
  "drove",
  "drown",
  "drug",
  "drum",
  "drunk",
  "dry",
  "dual",
  "duck",
  "duct",
  "due",
  "duel",
  "duet",
  "duke",
  "dull",
  "duly",
  "dumb",
  "dummy",
  "dump",
  "dune",
  "dung",
  "duress",
  "during",
  "dusk",
  "dust",
  "dusty",
  "dutch",
  "duty",
  "dwarf",
  "dwell",
  "dyer",
  "dying",
  "dynamo",
  "each",
  "eager",
  "eagle",
  "ear",
  "earl",
  "early",
  "earn",
  "earth",
  "ease",
  "easel",
  "easily",
  "east",
  "easter",
  "easy",
  "eat",
  "eaten",
  "eater",
  "echo",
  "eddy",
  "eden",
  "edge",
  "edible",
  "edict",
  "edit",
  "editor",
  "eel",
  "eerie",
  "eerily",
  "effect",
  "effort",
  "egg",
  "ego",
  "eight",
  "eighth",
  "eighty",
  "either",
  "elbow",
  "elder",
  "eldest",
  "elect",
  "eleven",
  "elicit",
  "elite",
  "else",
  "elude",
  "elves",
  "embark",
  "emblem",
  "embryo",
  "emerge",
  "emit",
  "empire",
  "employ",
  "empty",
  "enable",
  "enamel",
  "end",
  "endure",
  "enemy",
  "energy",
  "engage",
  "engine",
  "enjoy",
  "enlist",
  "enough",
  "ensure",
  "entail",
  "enter",
  "entire",
  "entry",
  "envoy",
  "envy",
  "enzyme",
  "epic",
  "epoch",
  "equal",
  "equate",
  "equip",
  "equity",
  "era",
  "erect",
  "eric",
  "erode",
  "erotic",
  "errant",
  "error",
  "escape",
  "escort",
  "essay",
  "essex",
  "estate",
  "esteem",
  "ethic",
  "ethnic",
  "europe",
  "evade",
  "eve",
  "even",
  "event",
  "ever",
  "every",
  "evict",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "exam",
  "exceed",
  "excel",
  "except",
  "excess",
  "excise",
  "excite",
  "excuse",
  "exempt",
  "exert",
  "exile",
  "exist",
  "exit",
  "exodus",
  "exotic",
  "expand",
  "expect",
  "expert",
  "expire",
  "export",
  "expose",
  "extend",
  "extra",
  "eye",
  "eyed",
  "fabric",
  "face",
  "facial",
  "fact",
  "factor",
  "fade",
  "fail",
  "faint",
  "fair",
  "fairly",
  "fairy",
  "faith",
  "fake",
  "falcon",
  "fall",
  "false",
  "falter",
  "fame",
  "family",
  "famine",
  "famous",
  "fan",
  "fancy",
  "far",
  "farce",
  "fare",
  "farm",
  "farmer",
  "fast",
  "fasten",
  "faster",
  "fat",
  "fatal",
  "fate",
  "father",
  "fatty",
  "fault",
  "faulty",
  "fauna",
  "fear",
  "feast",
  "feat",
  "fed",
  "fee",
  "feeble",
  "feed",
  "feel",
  "feet",
  "fell",
  "fellow",
  "felt",
  "female",
  "fence",
  "fend",
  "ferry",
  "fetal",
  "fetch",
  "feudal",
  "fever",
  "few",
  "fewer",
  "fiasco",
  "fiddle",
  "field",
  "fiend",
  "fierce",
  "fiery",
  "fifth",
  "fifty",
  "fig",
  "fight",
  "figure",
  "file",
  "fill",
  "filled",
  "filler",
  "film",
  "filter",
  "filth",
  "filthy",
  "final",
  "finale",
  "find",
  "fine",
  "finery",
  "finger",
  "finish",
  "finite",
  "fire",
  "firm",
  "firmly",
  "first",
  "fiscal",
  "fish",
  "fisher",
  "fist",
  "fit",
  "fitful",
  "five",
  "fix",
  "flag",
  "flair",
  "flak",
  "flame",
  "flank",
  "flap",
  "flare",
  "flash",
  "flask",
  "flat",
  "flavor",
  "flaw",
  "fled",
  "flee",
  "fleece",
  "fleet",
  "flesh",
  "fleshy",
  "flew",
  "flick",
  "flight",
  "flimsy",
  "flint",
  "flirt",
  "float",
  "flock",
  "flood",
  "floor",
  "floppy",
  "flora",
  "floral",
  "flour",
  "flow",
  "flower",
  "fluent",
  "fluffy",
  "fluid",
  "flung",
  "flurry",
  "flush",
  "flute",
  "flux",
  "fly",
  "flyer",
  "foal",
  "foam",
  "focal",
  "focus",
  "fog",
  "foil",
  "fold",
  "folk",
  "follow",
  "folly",
  "fond",
  "fondly",
  "font",
  "food",
  "fool",
  "foot",
  "for",
  "forbid",
  "force",
  "ford",
  "forest",
  "forge",
  "forget",
  "fork",
  "form",
  "formal",
  "format",
  "former",
  "fort",
  "forth",
  "forty",
  "forum",
  "fossil",
  "foster",
  "foul",
  "found",
  "four",
  "fourth",
  "fox",
  "foyer",
  "frail",
  "frame",
  "franc",
  "france",
  "frank",
  "fraud",
  "fred",
  "free",
  "freed",
  "freely",
  "freeze",
  "french",
  "frenzy",
  "fresh",
  "friar",
  "friday",
  "fridge",
  "fried",
  "friend",
  "fright",
  "fringe",
  "frock",
  "frog",
  "from",
  "front",
  "frost",
  "frosty",
  "frown",
  "frozen",
  "frugal",
  "fruit",
  "fry",
  "fudge",
  "fuel",
  "full",
  "fully",
  "fumes",
  "fun",
  "fund",
  "funny",
  "fur",
  "furry",
  "fury",
  "fuse",
  "fusion",
  "fuss",
  "fussy",
  "futile",
  "future",
  "fuzzy",
  "gadget",
  "gain",
  "gala",
  "galaxy",
  "gale",
  "gall",
  "galley",
  "gallon",
  "gallop",
  "gamble",
  "game",
  "gamma",
  "gandhi",
  "gang",
  "gap",
  "garage",
  "garden",
  "garlic",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaunt",
  "gave",
  "gaze",
  "gear",
  "geese",
  "gem",
  "gemini",
  "gender",
  "gene",
  "geneva",
  "genial",
  "genius",
  "genre",
  "gentle",
  "gently",
  "gentry",
  "genus",
  "george",
  "germ",
  "get",
  "ghetto",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "gill",
  "gilt",
  "ginger",
  "girl",
  "give",
  "given",
  "glad",
  "glade",
  "glance",
  "gland",
  "glare",
  "glass",
  "glassy",
  "gleam",
  "glee",
  "glide",
  "global",
  "globe",
  "gloom",
  "gloomy",
  "gloria",
  "glory",
  "gloss",
  "glossy",
  "glove",
  "glow",
  "glue",
  "gnat",
  "gnu",
  "goal",
  "goat",
  "gold",
  "golden",
  "golf",
  "gone",
  "gong",
  "goo",
  "good",
  "goose",
  "gore",
  "gorge",
  "gory",
  "gosh",
  "gospel",
  "gossip",
  "got",
  "gothic",
  "govern",
  "gown",
  "grab",
  "grace",
  "grade",
  "grail",
  "grain",
  "grand",
  "grant",
  "grape",
  "graph",
  "grasp",
  "grass",
  "grassy",
  "grate",
  "grave",
  "gravel",
  "gravy",
  "grease",
  "greasy",
  "great",
  "greece",
  "greed",
  "greedy",
  "greek",
  "green",
  "greet",
  "grew",
  "grey",
  "grid",
  "grief",
  "grill",
  "grim",
  "grin",
  "grind",
  "grip",
  "grit",
  "gritty",
  "groan",
  "groin",
  "groom",
  "groove",
  "gross",
  "ground",
  "group",
  "grove",
  "grow",
  "grown",
  "growth",
  "grudge",
  "grunt",
  "guard",
  "guess",
  "guest",
  "guide",
  "guild",
  "guilt",
  "guilty",
  "guise",
  "guitar",
  "gulf",
  "gully",
  "gun",
  "gunman",
  "guru",
  "gut",
  "guy",
  "gypsy",
  "habit",
  "hack",
  "had",
  "hail",
  "hair",
  "hairy",
  "haiti",
  "hale",
  "half",
  "hall",
  "halt",
  "hamlet",
  "hammer",
  "hand",
  "handle",
  "handy",
  "hang",
  "hangar",
  "hanoi",
  "happen",
  "happy",
  "harass",
  "harbor",
  "hard",
  "harder",
  "hardly",
  "hare",
  "harem",
  "harm",
  "harp",
  "harry",
  "harsh",
  "has",
  "hash",
  "hassle",
  "haste",
  "hasten",
  "hasty",
  "hat",
  "hatch",
  "hate",
  "haul",
  "haunt",
  "havana",
  "have",
  "haven",
  "havoc",
  "hawaii",
  "hawk",
  "hay",
  "hazard",
  "haze",
  "hazel",
  "hazy",
  "head",
  "heal",
  "health",
  "heap",
  "hear",
  "heard",
  "heart",
  "hearth",
  "hearty",
  "heat",
  "heater",
  "heaven",
  "heavy",
  "hebrew",
  "heck",
  "hectic",
  "hedge",
  "heel",
  "hefty",
  "height",
  "heir",
  "held",
  "helium",
  "helix",
  "hell",
  "hello",
  "helm",
  "helmet",
  "help",
  "hemp",
  "hence",
  "henry",
  "her",
  "herald",
  "herb",
  "herd",
  "here",
  "hereby",
  "hermes",
  "hernia",
  "hero",
  "heroic",
  "heroin",
  "hey",
  "heyday",
  "hick",
  "hidden",
  "hide",
  "high",
  "higher",
  "highly",
  "hill",
  "him",
  "hind",
  "hinder",
  "hint",
  "hippie",
  "hire",
  "his",
  "hiss",
  "hit",
  "hive",
  "hoard",
  "hoarse",
  "hobby",
  "hockey",
  "hold",
  "holder",
  "hole",
  "hollow",
  "holly",
  "holy",
  "home",
  "honest",
  "honey",
  "hood",
  "hook",
  "hope",
  "horn",
  "horrid",
  "horror",
  "horse",
  "hose",
  "host",
  "hot",
  "hotel",
  "hound",
  "hour",
  "house",
  "hover",
  "how",
  "huge",
  "hull",
  "human",
  "humane",
  "humble",
  "humid",
  "hung",
  "hunger",
  "hungry",
  "hunt",
  "hurdle",
  "hurl",
  "hurry",
  "hurt",
  "hush",
  "hut",
  "hybrid",
  "hymn",
  "hyphen",
  "ice",
  "icing",
  "icon",
  "idaho",
  "idea",
  "ideal",
  "idiom",
  "idiot",
  "idle",
  "idly",
  "idol",
  "ignite",
  "ignore",
  "ill",
  "image",
  "immune",
  "impact",
  "imply",
  "import",
  "impose",
  "inca",
  "incest",
  "inch",
  "income",
  "incur",
  "indeed",
  "index",
  "india",
  "indian",
  "indoor",
  "induce",
  "inept",
  "inert",
  "infant",
  "infect",
  "infer",
  "influx",
  "inform",
  "inject",
  "injure",
  "injury",
  "ink",
  "inlaid",
  "inland",
  "inlet",
  "inmate",
  "inn",
  "innate",
  "inner",
  "input",
  "insane",
  "insect",
  "insert",
  "inset",
  "inside",
  "insist",
  "insult",
  "insure",
  "intact",
  "intake",
  "intend",
  "inter",
  "into",
  "invade",
  "invent",
  "invest",
  "invite",
  "invoke",
  "inward",
  "iowa",
  "iran",
  "iraq",
  "irish",
  "iron",
  "ironic",
  "irony",
  "isaac",
  "isabel",
  "island",
  "isle",
  "israel",
  "issue",
  "italy",
  "itch",
  "item",
  "itself",
  "ivan",
  "ivory",
  "jack",
  "jacket",
  "jacob",
  "jade",
  "jaguar",
  "jail",
  "james",
  "jane",
  "japan",
  "jargon",
  "java",
  "jaw",
  "jazz",
  "jeep",
  "jelly",
  "jerky",
  "jest",
  "jet",
  "jewel",
  "jewish",
  "jim",
  "job",
  "jock",
  "jockey",
  "joe",
  "john",
  "join",
  "joint",
  "joke",
  "jolly",
  "jolt",
  "jordan",
  "joseph",
  "joy",
  "joyful",
  "joyous",
  "judge",
  "judy",
  "juice",
  "juicy",
  "july",
  "jumble",
  "jumbo",
  "jump",
  "june",
  "jungle",
  "junior",
  "junk",
  "junta",
  "jury",
  "just",
  "kansas",
  "karate",
  "karl",
  "keel",
  "keen",
  "keep",
  "keeper",
  "kenya",
  "kept",
  "kernel",
  "kettle",
  "key",
  "khaki",
  "kick",
  "kid",
  "kidnap",
  "kidney",
  "kill",
  "killer",
  "kin",
  "kind",
  "kindly",
  "king",
  "kiss",
  "kite",
  "kitten",
  "knack",
  "knee",
  "kneel",
  "knew",
  "knife",
  "knight",
  "knit",
  "knob",
  "knock",
  "knot",
  "know",
  "known",
  "koran",
  "korea",
  "kuwait",
  "label",
  "lace",
  "lack",
  "lad",
  "ladder",
  "laden",
  "lady",
  "lagoon",
  "laity",
  "lake",
  "lamb",
  "lame",
  "lamp",
  "lance",
  "land",
  "lane",
  "lap",
  "lapse",
  "large",
  "larval",
  "laser",
  "last",
  "latch",
  "late",
  "lately",
  "latent",
  "later",
  "latest",
  "latin",
  "latter",
  "laugh",
  "launch",
  "lava",
  "lavish",
  "law",
  "lawful",
  "lawn",
  "lawyer",
  "lay",
  "layer",
  "layman",
  "lazy",
  "lead",
  "leader",
  "leaf",
  "leafy",
  "league",
  "leak",
  "leaky",
  "lean",
  "leap",
  "learn",
  "lease",
  "leash",
  "least",
  "leave",
  "led",
  "ledge",
  "left",
  "leg",
  "legacy",
  "legal",
  "legend",
  "legion",
  "lemon",
  "lend",
  "length",
  "lens",
  "lent",
  "leo",
  "leper",
  "lesion",
  "less",
  "lessen",
  "lesser",
  "lesson",
  "lest",
  "let",
  "lethal",
  "letter",
  "level",
  "lever",
  "levy",
  "lewis",
  "liable",
  "liar",
  "libel",
  "libya",
  "lice",
  "lick",
  "lid",
  "lie",
  "lied",
  "lier",
  "life",
  "lift",
  "light",
  "like",
  "likely",
  "limb",
  "lime",
  "limit",
  "limp",
  "line",
  "linear",
  "linen",
  "linger",
  "link",
  "lint",
  "lion",
  "lip",
  "liquid",
  "liquor",
  "list",
  "listen",
  "lit",
  "live",
  "lively",
  "liver",
  "liz",
  "lizard",
  "load",
  "loaf",
  "loan",
  "lobby",
  "lobe",
  "local",
  "locate",
  "lock",
  "locus",
  "lodge",
  "loft",
  "lofty",
  "log",
  "logic",
  "logo",
  "london",
  "lone",
  "lonely",
  "long",
  "longer",
  "look",
  "loop",
  "loose",
  "loosen",
  "loot",
  "lord",
  "lorry",
  "lose",
  "loss",
  "lost",
  "lot",
  "lotion",
  "lotus",
  "loud",
  "loudly",
  "lounge",
  "lousy",
  "love",
  "lovely",
  "lover",
  "low",
  "lower",
  "lowest",
  "loyal",
  "lucid",
  "luck",
  "lucky",
  "lucy",
  "lull",
  "lump",
  "lumpy",
  "lunacy",
  "lunar",
  "lunch",
  "lung",
  "lure",
  "lurid",
  "lush",
  "lust",
  "lute",
  "luther",
  "luxury",
  "lying",
  "lymph",
  "lynch",
  "lyric",
  "macho",
  "macro",
  "mad",
  "madam",
  "made",
  "mafia",
  "magic",
  "magma",
  "magnet",
  "magnum",
  "magpie",
  "maid",
  "maiden",
  "mail",
  "main",
  "mainly",
  "major",
  "make",
  "maker",
  "male",
  "malice",
  "mall",
  "malt",
  "mammal",
  "manage",
  "mane",
  "mania",
  "manic",
  "manner",
  "manor",
  "mantle",
  "manual",
  "manure",
  "many",
  "map",
  "maple",
  "marble",
  "march",
  "mare",
  "margin",
  "maria",
  "marina",
  "mark",
  "market",
  "marry",
  "mars",
  "marsh",
  "martin",
  "martyr",
  "mary",
  "mask",
  "mason",
  "mass",
  "mast",
  "master",
  "mat",
  "match",
  "mate",
  "matrix",
  "matter",
  "mature",
  "maxim",
  "may",
  "maybe",
  "mayor",
  "maze",
  "mead",
  "meadow",
  "meal",
  "mean",
  "meant",
  "meat",
  "medal",
  "media",
  "median",
  "medic",
  "medium",
  "meet",
  "mellow",
  "melody",
  "melon",
  "melt",
  "member",
  "memo",
  "memory",
  "menace",
  "mend",
  "mental",
  "mentor",
  "menu",
  "mercy",
  "mere",
  "merely",
  "merge",
  "merger",
  "merit",
  "merry",
  "mesh",
  "mess",
  "messy",
  "met",
  "metal",
  "meter",
  "method",
  "methyl",
  "metric",
  "metro",
  "mexico",
  "miami",
  "mickey",
  "mid",
  "midday",
  "middle",
  "midst",
  "midway",
  "might",
  "mighty",
  "mild",
  "mildew",
  "mile",
  "milk",
  "milky",
  "mill",
  "mimic",
  "mince",
  "mind",
  "mine",
  "mini",
  "mink",
  "minor",
  "mint",
  "minus",
  "minute",
  "mire",
  "mirror",
  "mirth",
  "misery",
  "miss",
  "mist",
  "misty",
  "mite",
  "mix",
  "moan",
  "moat",
  "mob",
  "mobile",
  "mock",
  "mode",
  "model",
  "modem",
  "modern",
  "modest",
  "modify",
  "module",
  "moist",
  "molar",
  "mold",
  "mole",
  "molten",
  "moment",
  "monday",
  "money",
  "monk",
  "monkey",
  "month",
  "mood",
  "moody",
  "moon",
  "moor",
  "moral",
  "morale",
  "morbid",
  "more",
  "morgue",
  "mortal",
  "mortar",
  "mosaic",
  "moscow",
  "moses",
  "mosque",
  "moss",
  "most",
  "mostly",
  "moth",
  "mother",
  "motion",
  "motive",
  "motor",
  "mount",
  "mourn",
  "mouse",
  "mouth",
  "move",
  "movie",
  "mrs",
  "much",
  "muck",
  "mucus",
  "mud",
  "muddle",
  "muddy",
  "mule",
  "mummy",
  "munich",
  "murder",
  "murky",
  "murmur",
  "muscle",
  "museum",
  "music",
  "mussel",
  "must",
  "mutant",
  "mute",
  "mutiny",
  "mutter",
  "mutton",
  "mutual",
  "muzzle",
  "myopic",
  "myriad",
  "myself",
  "mystic",
  "myth",
  "nadir",
  "nail",
  "naked",
  "name",
  "namely",
  "nape",
  "napkin",
  "naples",
  "narrow",
  "nasal",
  "nasty",
  "nathan",
  "nation",
  "native",
  "nature",
  "nausea",
  "naval",
  "nave",
  "navy",
  "near",
  "nearer",
  "nearly",
  "neat",
  "neatly",
  "neck",
  "need",
  "needle",
  "needy",
  "negate",
  "neon",
  "nepal",
  "nephew",
  "nerve",
  "nest",
  "net",
  "neural",
  "never",
  "newly",
  "next",
  "nice",
  "nicely",
  "niche",
  "nickel",
  "niece",
  "night",
  "nile",
  "nimble",
  "nine",
  "ninety",
  "ninth",
  "nobel",
  "noble",
  "nobody",
  "node",
  "noise",
  "noisy",
  "none",
  "noon",
  "nor",
  "norm",
  "normal",
  "north",
  "norway",
  "nose",
  "nosy",
  "not",
  "note",
  "notice",
  "notify",
  "notion",
  "noun",
  "novel",
  "novice",
  "now",
  "nozzle",
  "null",
  "numb",
  "number",
  "nurse",
  "nut",
  "nylon",
  "nymph",
  "oak",
  "oar",
  "oasis",
  "oath",
  "obese",
  "obey",
  "object",
  "oblige",
  "oboe",
  "obtain",
  "obtuse",
  "occult",
  "occupy",
  "occur",
  "ocean",
  "octave",
  "odd",
  "off",
  "offend",
  "offer",
  "office",
  "offset",
  "often",
  "ohio",
  "oil",
  "oily",
  "okay",
  "old",
  "older",
  "oldest",
  "olive",
  "omega",
  "omen",
  "omit",
  "once",
  "one",
  "onion",
  "only",
  "onset",
  "onto",
  "onus",
  "onward",
  "opaque",
  "open",
  "openly",
  "opera",
  "opium",
  "oppose",
  "optic",
  "option",
  "oracle",
  "oral",
  "orange",
  "orbit",
  "orchid",
  "ordeal",
  "order",
  "organ",
  "orgasm",
  "orient",
  "origin",
  "ornate",
  "orphan",
  "oscar",
  "other",
  "otter",
  "ought",
  "ounce",
  "our",
  "out",
  "outer",
  "output",
  "outset",
  "oval",
  "oven",
  "over",
  "overt",
  "owe",
  "owing",
  "owl",
  "own",
  "owner",
  "oxford",
  "oxide",
  "oxygen",
  "oyster",
  "ozone",
  "pace",
  "pack",
  "packet",
  "pact",
  "pad",
  "paddle",
  "paddy",
  "pagan",
  "page",
  "paid",
  "pain",
  "paint",
  "pair",
  "palace",
  "pale",
  "palm",
  "pan",
  "panama",
  "panel",
  "panic",
  "papa",
  "papal",
  "paper",
  "parade",
  "parcel",
  "pardon",
  "parent",
  "paris",
  "parish",
  "park",
  "parody",
  "parrot",
  "part",
  "partly",
  "party",
  "pascal",
  "pass",
  "past",
  "paste",
  "pastel",
  "pastor",
  "pastry",
  "pat",
  "patch",
  "patent",
  "path",
  "patio",
  "patrol",
  "patron",
  "paul",
  "pause",
  "pave",
  "paw",
  "pawn",
  "pay",
  "peace",
  "peach",
  "peak",
  "pear",
  "pearl",
  "pedal",
  "peel",
  "peer",
  "peking",
  "pelvic",
  "pelvis",
  "pen",
  "penal",
  "pence",
  "pencil",
  "penny",
  "people",
  "pepper",
  "per",
  "perch",
  "peril",
  "period",
  "perish",
  "permit",
  "person",
  "peru",
  "pest",
  "pet",
  "peter",
  "petite",
  "petrol",
  "petty",
  "phase",
  "philip",
  "phone",
  "photo",
  "phrase",
  "piano",
  "pick",
  "picket",
  "picnic",
  "pie",
  "piece",
  "pier",
  "pierce",
  "piety",
  "pig",
  "pigeon",
  "piggy",
  "pike",
  "pile",
  "pill",
  "pillar",
  "pillow",
  "pilot",
  "pin",
  "pinch",
  "pine",
  "pink",
  "pint",
  "pious",
  "pipe",
  "pirate",
  "piss",
  "pistol",
  "piston",
  "pit",
  "pitch",
  "pity",
  "pivot",
  "pixel",
  "pizza",
  "place",
  "placid",
  "plague",
  "plain",
  "plan",
  "plane",
  "planet",
  "plank",
  "plant",
  "plasma",
  "plate",
  "play",
  "player",
  "plea",
  "plead",
  "please",
  "pledge",
  "plenty",
  "plight",
  "plot",
  "plough",
  "ploy",
  "plug",
  "plum",
  "plump",
  "plunge",
  "plural",
  "plus",
  "plush",
  "pocket",
  "poem",
  "poet",
  "poetic",
  "poetry",
  "point",
  "poison",
  "poland",
  "polar",
  "pole",
  "police",
  "policy",
  "polish",
  "polite",
  "poll",
  "pollen",
  "polo",
  "pond",
  "ponder",
  "pony",
  "pool",
  "poor",
  "poorly",
  "pop",
  "poppy",
  "pore",
  "pork",
  "port",
  "portal",
  "pose",
  "posh",
  "post",
  "postal",
  "pot",
  "potato",
  "potent",
  "pouch",
  "pound",
  "pour",
  "powder",
  "power",
  "praise",
  "pray",
  "prayer",
  "preach",
  "prefer",
  "prefix",
  "press",
  "pretty",
  "price",
  "pride",
  "priest",
  "primal",
  "prime",
  "prince",
  "print",
  "prior",
  "prism",
  "prison",
  "privy",
  "prize",
  "probe",
  "profit",
  "prompt",
  "prone",
  "proof",
  "propel",
  "proper",
  "prose",
  "proton",
  "proud",
  "prove",
  "proven",
  "proxy",
  "prune",
  "pry",
  "psalm",
  "pseudo",
  "psyche",
  "pub",
  "public",
  "puff",
  "pull",
  "pulp",
  "pulpit",
  "pulsar",
  "pulse",
  "pump",
  "punch",
  "punish",
  "punk",
  "pupil",
  "puppet",
  "puppy",
  "pure",
  "purely",
  "purge",
  "purify",
  "purple",
  "purse",
  "pursue",
  "push",
  "pushy",
  "put",
  "putt",
  "puzzle",
  "quaint",
  "quake",
  "quarry",
  "quart",
  "quartz",
  "quebec",
  "queen",
  "queer",
  "query",
  "quest",
  "queue",
  "quick",
  "quid",
  "quiet",
  "quilt",
  "quirk",
  "quit",
  "quite",
  "quiver",
  "quiz",
  "quota",
  "quote",
  "rabbit",
  "race",
  "racial",
  "racism",
  "rack",
  "racket",
  "radar",
  "radio",
  "radish",
  "radius",
  "raffle",
  "raft",
  "rage",
  "raid",
  "rail",
  "rain",
  "rainy",
  "raise",
  "rake",
  "rally",
  "ramp",
  "random",
  "range",
  "rank",
  "ransom",
  "rape",
  "rapid",
  "rare",
  "rarely",
  "rarity",
  "rash",
  "rat",
  "rate",
  "rather",
  "ratify",
  "ratio",
  "rattle",
  "rave",
  "raven",
  "raw",
  "ray",
  "razor",
  "reach",
  "react",
  "read",
  "reader",
  "ready",
  "real",
  "really",
  "realm",
  "reap",
  "rear",
  "reason",
  "rebel",
  "recall",
  "recent",
  "recess",
  "recipe",
  "reckon",
  "record",
  "recoup",
  "rector",
  "red",
  "redeem",
  "redo",
  "reduce",
  "reed",
  "reef",
  "reek",
  "refer",
  "reform",
  "refuge",
  "refuse",
  "regal",
  "regard",
  "regent",
  "regime",
  "region",
  "regret",
  "reign",
  "reject",
  "relate",
  "relax",
  "relay",
  "relic",
  "relief",
  "relish",
  "rely",
  "remain",
  "remark",
  "remedy",
  "remind",
  "remit",
  "remote",
  "remove",
  "renal",
  "render",
  "rent",
  "rental",
  "repair",
  "repeal",
  "repeat",
  "repent",
  "reply",
  "report",
  "rescue",
  "resent",
  "reside",
  "resign",
  "resin",
  "resist",
  "resort",
  "rest",
  "result",
  "resume",
  "retail",
  "retain",
  "retina",
  "retire",
  "return",
  "reveal",
  "review",
  "revise",
  "revive",
  "revolt",
  "reward",
  "rex",
  "rhine",
  "rhino",
  "rhyme",
  "rhythm",
  "ribbon",
  "rice",
  "rich",
  "rick",
  "rid",
  "ride",
  "rider",
  "ridge",
  "rife",
  "rifle",
  "rift",
  "right",
  "rigid",
  "rile",
  "rim",
  "ring",
  "rinse",
  "riot",
  "ripe",
  "ripen",
  "ripple",
  "rise",
  "risk",
  "risky",
  "rite",
  "ritual",
  "ritz",
  "rival",
  "river",
  "road",
  "roar",
  "roast",
  "rob",
  "robe",
  "robert",
  "robin",
  "robot",
  "robust",
  "rock",
  "rocket",
  "rocky",
  "rod",
  "rode",
  "rodent",
  "rogue",
  "role",
  "roll",
  "roman",
  "rome",
  "roof",
  "room",
  "root",
  "rope",
  "rose",
  "rosy",
  "rot",
  "rotate",
  "rotor",
  "rotten",
  "rouge",
  "rough",
  "round",
  "route",
  "rover",
  "row",
  "royal",
  "rub",
  "rubber",
  "rubble",
  "ruby",
  "rudder",
  "rude",
  "rug",
  "rugby",
  "ruin",
  "rule",
  "ruler",
  "rumble",
  "rump",
  "run",
  "rune",
  "rung",
  "runway",
  "rural",
  "rush",
  "russia",
  "rust",
  "rustic",
  "rusty",
  "sack",
  "sacred",
  "sad",
  "saddle",
  "sadism",
  "sadly",
  "safari",
  "safe",
  "safely",
  "safer",
  "safety",
  "saga",
  "sage",
  "sahara",
  "said",
  "sail",
  "sailor",
  "saint",
  "sake",
  "salad",
  "salary",
  "sale",
  "saline",
  "saliva",
  "salmon",
  "saloon",
  "salt",
  "salty",
  "salute",
  "sam",
  "same",
  "sample",
  "sand",
  "sandy",
  "sane",
  "sash",
  "satin",
  "satire",
  "saturn",
  "sauce",
  "saucer",
  "saudi",
  "sauna",
  "savage",
  "save",
  "saw",
  "say",
  "scale",
  "scalp",
  "scan",
  "scant",
  "scar",
  "scarce",
  "scare",
  "scarf",
  "scary",
  "scene",
  "scenic",
  "scent",
  "school",
  "scold",
  "scope",
  "score",
  "scorn",
  "scotch",
  "scott",
  "scout",
  "scrap",
  "scrape",
  "scream",
  "screen",
  "screw",
  "script",
  "scroll",
  "scrub",
  "scum",
  "sea",
  "seal",
  "seam",
  "seaman",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "sect",
  "sector",
  "secure",
  "see",
  "seed",
  "seeing",
  "seek",
  "seem",
  "seize",
  "seldom",
  "select",
  "self",
  "sell",
  "seller",
  "semi",
  "senate",
  "send",
  "senile",
  "senior",
  "sense",
  "sensor",
  "sent",
  "sentry",
  "seoul",
  "sequel",
  "serene",
  "serial",
  "series",
  "sermon",
  "serum",
  "serve",
  "server",
  "set",
  "settle",
  "seven",
  "severe",
  "sew",
  "sewage",
  "shabby",
  "shade",
  "shadow",
  "shady",
  "shaft",
  "shaggy",
  "shah",
  "shake",
  "shaky",
  "shall",
  "sham",
  "shame",
  "shape",
  "share",
  "shark",
  "sharp",
  "shawl",
  "she",
  "shear",
  "sheen",
  "sheep",
  "sheer",
  "sheet",
  "shelf",
  "shell",
  "sherry",
  "shield",
  "shift",
  "shine",
  "shiny",
  "ship",
  "shire",
  "shirk",
  "shirt",
  "shiver",
  "shock",
  "shoe",
  "shook",
  "shoot",
  "shop",
  "shore",
  "short",
  "shot",
  "should",
  "shout",
  "show",
  "shower",
  "shrank",
  "shrewd",
  "shrill",
  "shrimp",
  "shrine",
  "shrink",
  "shrub",
  "shrug",
  "shut",
  "shy",
  "shyly",
  "sick",
  "side",
  "siege",
  "sigh",
  "sight",
  "sigma",
  "sign",
  "signal",
  "silent",
  "silk",
  "silken",
  "silky",
  "sill",
  "silly",
  "silo",
  "silver",
  "simple",
  "simply",
  "since",
  "sinful",
  "sing",
  "singer",
  "single",
  "sink",
  "sir",
  "sire",
  "siren",
  "sister",
  "sit",
  "site",
  "sitter",
  "six",
  "sixth",
  "sixty",
  "size",
  "sketch",
  "skill",
  "skin",
  "skinny",
  "skip",
  "skirt",
  "skull",
  "sky",
  "slab",
  "slack",
  "slain",
  "slam",
  "slang",
  "slap",
  "slat",
  "slate",
  "slave",
  "sleek",
  "sleep",
  "sleepy",
  "sleeve",
  "slice",
  "slick",
  "slid",
  "slide",
  "slight",
  "slim",
  "slimy",
  "sling",
  "slip",
  "slit",
  "slogan",
  "slope",
  "sloppy",
  "slot",
  "slow",
  "slowly",
  "slug",
  "slum",
  "slump",
  "smack",
  "small",
  "smart",
  "smash",
  "smear",
  "smell",
  "smelly",
  "smelt",
  "smile",
  "smite",
  "smoke",
  "smoky",
  "smooth",
  "smug",
  "snack",
  "snail",
  "snake",
  "snap",
  "snatch",
  "sneak",
  "snow",
  "snowy",
  "snug",
  "soak",
  "soap",
  "sober",
  "soccer",
  "social",
  "sock",
  "socket",
  "socks",
  "soda",
  "sodden",
  "sodium",
  "sofa",
  "soft",
  "soften",
  "softly",
  "soggy",
  "soil",
  "solar",
  "sold",
  "sole",
  "solely",
  "solemn",
  "solid",
  "solo",
  "solve",
  "some",
  "son",
  "sonar",
  "sonata",
  "song",
  "sonic",
  "sony",
  "soon",
  "sooner",
  "soot",
  "soothe",
  "sordid",
  "sore",
  "sorrow",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "sour",
  "source",
  "soviet",
  "sow",
  "space",
  "spade",
  "spain",
  "span",
  "spare",
  "spark",
  "sparse",
  "spasm",
  "spat",
  "spate",
  "speak",
  "spear",
  "speech",
  "speed",
  "speedy",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spicy",
  "spider",
  "spiky",
  "spill",
  "spin",
  "spinal",
  "spine",
  "spiral",
  "spirit",
  "spit",
  "spite",
  "splash",
  "split",
  "spoil",
  "spoke",
  "sponge",
  "spoon",
  "sport",
  "spot",
  "spouse",
  "spray",
  "spread",
  "spree",
  "spring",
  "sprint",
  "spur",
  "squad",
  "square",
  "squash",
  "squat",
  "squid",
  "stab",
  "stable",
  "stack",
  "staff",
  "stage",
  "stain",
  "stair",
  "stairs",
  "stake",
  "stale",
  "stall",
  "stamp",
  "stance",
  "stand",
  "staple",
  "star",
  "starch",
  "stare",
  "stark",
  "start",
  "starve",
  "state",
  "static",
  "statue",
  "status",
  "stay",
  "stead",
  "steady",
  "steak",
  "steal",
  "steam",
  "steel",
  "steep",
  "steer",
  "stem",
  "stench",
  "step",
  "stereo",
  "stern",
  "stew",
  "stick",
  "sticky",
  "stiff",
  "stifle",
  "stigma",
  "still",
  "sting",
  "stint",
  "stir",
  "stitch",
  "stock",
  "stocky",
  "stone",
  "stony",
  "stool",
  "stop",
  "store",
  "storm",
  "stormy",
  "story",
  "stout",
  "stove",
  "stow",
  "strain",
  "strait",
  "strand",
  "strap",
  "strata",
  "straw",
  "stray",
  "streak",
  "stream",
  "street",
  "stress",
  "strict",
  "stride",
  "strife",
  "strike",
  "string",
  "strip",
  "stripe",
  "strive",
  "stroke",
  "stroll",
  "strong",
  "stud",
  "studio",
  "study",
  "stuff",
  "stuffy",
  "stunt",
  "stupid",
  "sturdy",
  "style",
  "submit",
  "subtle",
  "subtly",
  "suburb",
  "such",
  "sudden",
  "sue",
  "suez",
  "suffer",
  "sugar",
  "suit",
  "suite",
  "suitor",
  "sullen",
  "sultan",
  "sum",
  "summer",
  "summit",
  "summon",
  "sun",
  "sunday",
  "sunny",
  "sunset",
  "super",
  "superb",
  "supper",
  "supple",
  "supply",
  "sure",
  "surely",
  "surf",
  "surge",
  "survey",
  "suture",
  "swamp",
  "swan",
  "swap",
  "swarm",
  "sway",
  "swear",
  "sweat",
  "sweaty",
  "sweden",
  "sweep",
  "sweet",
  "swell",
  "swift",
  "swim",
  "swine",
  "swing",
  "swirl",
  "swiss",
  "switch",
  "sword",
  "swore",
  "sydney",
  "symbol",
  "synod",
  "syntax",
  "syria",
  "syrup",
  "system",
  "table",
  "tablet",
  "taboo",
  "tacit",
  "tackle",
  "tact",
  "tactic",
  "tail",
  "tailor",
  "taiwan",
  "take",
  "tale",
  "talent",
  "talk",
  "tall",
  "tally",
  "tame",
  "tampa",
  "tan",
  "tandem",
  "tangle",
  "tank",
  "tap",
  "tape",
  "target",
  "tariff",
  "tarp",
  "tart",
  "tarzan",
  "task",
  "taste",
  "tasty",
  "tattoo",
  "taurus",
  "taut",
  "tavern",
  "tax",
  "taxi",
  "tea",
  "teach",
  "teak",
  "team",
  "tear",
  "tease",
  "tech",
  "teeth",
  "tell",
  "temper",
  "temple",
  "tempo",
  "tempt",
  "ten",
  "tenant",
  "tend",
  "tender",
  "tendon",
  "tennis",
  "tenor",
  "tense",
  "tent",
  "tenth",
  "tenure",
  "teresa",
  "term",
  "terror",
  "terse",
  "test",
  "texas",
  "text",
  "thank",
  "thaw",
  "them",
  "theme",
  "thence",
  "theory",
  "there",
  "these",
  "thesis",
  "they",
  "thick",
  "thief",
  "thigh",
  "thin",
  "thing",
  "think",
  "third",
  "thirst",
  "thirty",
  "this",
  "thomas",
  "thorn",
  "those",
  "though",
  "thread",
  "threat",
  "three",
  "thrill",
  "thrive",
  "throat",
  "throne",
  "throng",
  "throw",
  "thrust",
  "thud",
  "thug",
  "thumb",
  "thus",
  "thyme",
  "tibet",
  "tick",
  "ticket",
  "tidal",
  "tide",
  "tidy",
  "tie",
  "tier",
  "tiger",
  "tight",
  "tile",
  "till",
  "tilt",
  "timber",
  "time",
  "timid",
  "tin",
  "tiny",
  "tip",
  "tire",
  "tissue",
  "title",
  "toad",
  "toast",
  "today",
  "toe",
  "toilet",
  "token",
  "tokyo",
  "told",
  "toll",
  "tom",
  "tomato",
  "tomb",
  "tonal",
  "tone",
  "tongue",
  "tonic",
  "too",
  "took",
  "tool",
  "tooth",
  "top",
  "topaz",
  "topic",
  "torch",
  "torque",
  "torso",
  "tort",
  "toss",
  "total",
  "touch",
  "tough",
  "tour",
  "toward",
  "towel",
  "tower",
  "town",
  "toxic",
  "toxin",
  "toy",
  "trace",
  "track",
  "tract",
  "trade",
  "tragic",
  "trail",
  "train",
  "trait",
  "tram",
  "trance",
  "trap",
  "trauma",
  "travel",
  "tray",
  "tread",
  "treat",
  "treaty",
  "treble",
  "tree",
  "trek",
  "tremor",
  "trench",
  "trend",
  "trendy",
  "trial",
  "tribal",
  "tribe",
  "trick",
  "tricky",
  "tried",
  "trifle",
  "trim",
  "trio",
  "trip",
  "triple",
  "troop",
  "trophy",
  "trot",
  "trough",
  "trout",
  "truce",
  "truck",
  "true",
  "truly",
  "trunk",
  "trust",
  "truth",
  "try",
  "tube",
  "tumble",
  "tuna",
  "tundra",
  "tune",
  "tunic",
  "tunnel",
  "turban",
  "turf",
  "turk",
  "turkey",
  "turn",
  "turtle",
  "tutor",
  "tweed",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "tycoon",
  "tying",
  "type",
  "tyrant",
  "ugly",
  "ulcer",
  "ultra",
  "umpire",
  "unable",
  "uncle",
  "under",
  "uneasy",
  "unfair",
  "unify",
  "union",
  "unique",
  "unit",
  "unite",
  "unity",
  "unlike",
  "unrest",
  "unruly",
  "until",
  "update",
  "upheld",
  "uphill",
  "uphold",
  "upon",
  "upper",
  "uproar",
  "upset",
  "upshot",
  "uptake",
  "upturn",
  "upward",
  "urban",
  "urge",
  "urgent",
  "urging",
  "urine",
  "usable",
  "usage",
  "use",
  "useful",
  "user",
  "usual",
  "utmost",
  "utter",
  "vacant",
  "vacuum",
  "vague",
  "vain",
  "valet",
  "valid",
  "valley",
  "value",
  "valve",
  "van",
  "vanish",
  "vanity",
  "vary",
  "vase",
  "vast",
  "vat",
  "vault",
  "vector",
  "veil",
  "vein",
  "velvet",
  "vendor",
  "veneer",
  "venice",
  "venom",
  "vent",
  "venue",
  "venus",
  "verb",
  "verbal",
  "verge",
  "verify",
  "verity",
  "verse",
  "versus",
  "very",
  "vessel",
  "vest",
  "vet",
  "veto",
  "via",
  "viable",
  "vicar",
  "vice",
  "victim",
  "victor",
  "video",
  "vienna",
  "view",
  "vigil",
  "viking",
  "vile",
  "villa",
  "vine",
  "vinyl",
  "viola",
  "violet",
  "violin",
  "viral",
  "virgo",
  "virtue",
  "virus",
  "visa",
  "vision",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "vodka",
  "vogue",
  "voice",
  "void",
  "volley",
  "volume",
  "vote",
  "vowel",
  "voyage",
  "vulgar",
  "wade",
  "wage",
  "waist",
  "wait",
  "waiter",
  "wake",
  "walk",
  "walker",
  "wall",
  "wallet",
  "walnut",
  "wander",
  "want",
  "war",
  "warden",
  "warm",
  "warmth",
  "warn",
  "warp",
  "warsaw",
  "wary",
  "was",
  "wash",
  "wasp",
  "waste",
  "watch",
  "water",
  "watery",
  "wave",
  "wax",
  "way",
  "weak",
  "weaken",
  "wealth",
  "weapon",
  "wear",
  "weary",
  "weave",
  "wedge",
  "wee",
  "weed",
  "week",
  "weekly",
  "weep",
  "weigh",
  "weight",
  "weird",
  "well",
  "were",
  "west",
  "wet",
  "whale",
  "wharf",
  "what",
  "wheat",
  "wheel",
  "when",
  "whence",
  "where",
  "which",
  "whiff",
  "while",
  "whim",
  "whip",
  "whisky",
  "white",
  "who",
  "whole",
  "wholly",
  "whom",
  "whose",
  "why",
  "wicked",
  "wide",
  "widely",
  "widen",
  "wider",
  "widow",
  "width",
  "wife",
  "wig",
  "wild",
  "wildly",
  "will",
  "willow",
  "wily",
  "win",
  "wind",
  "window",
  "windy",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wipe",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "wit",
  "witch",
  "with",
  "within",
  "witty",
  "wizard",
  "woke",
  "wolf",
  "wolves",
  "woman",
  "womb",
  "won",
  "wonder",
  "wood",
  "wooden",
  "woods",
  "woody",
  "wool",
  "word",
  "work",
  "worker",
  "world",
  "worm",
  "worry",
  "worse",
  "worst",
  "worth",
  "worthy",
  "would",
  "wound",
  "wrap",
  "wrath",
  "wreath",
  "wreck",
  "wring",
  "wrist",
  "writ",
  "write",
  "writer",
  "wrong",
  "xerox",
  "yacht",
  "yale",
  "yard",
  "yarn",
  "yeah",
  "year",
  "yeard",
  "yeast",
  "yellow",
  "yet",
  "yield",
  "yogurt",
  "yolk",
  "you",
  "young",
  "your",
  "youth",
  "zaire",
  "zeal",
  "zebra",
  "zenith",
  "zero",
  "zeus",
  "zigzag",
  "zinc",
  "zombie",
  "zone"
], bip39Words = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
async function digest$1(u) {
  return new Uint8Array(await crypto.subtle.digest("SHA-256", u));
}
async function toSeed(u, t) {
  const a = u.join(" "), d = `mnemonic${t}`.normalize("NFKD");
  return deriveKey(HashAlgorithm.Sha512, a, d, 2048, 64);
}
function legacy1(u, t) {
  const a = u.map((g) => t.indexOf(g.toLowerCase())), d = convertRadix(a, t.length, 256, 33), l = d[d.length - 1], h = new Uint8Array(d.length - 1);
  for (let g = 0; g < d.length - 1; g += 1)
    h[g] = d[g] ^ l;
  return [h, l];
}
async function legacy2(u, t) {
  const a = u.length * 11, d = [];
  d.fill(!1, 0, a);
  for (const [R, B] of u.entries()) {
    const j = t.indexOf(B.toLowerCase());
    if (j < 0)
      throw new Error(`Word not found in wordlist: ${B}`);
    for (let o = 0; o < 11; o += 1)
      d[R * 11 + o] = (j & 1 << 10 - o) !== 0;
  }
  const l = a / 33, h = a - l, g = new Uint8Array(h / 8);
  for (let R = 0; R < g.length; R += 1)
    for (let B = 0; B < 8; B += 1)
      d[R * 8 + B] && (g[R] |= 1 << 7 - B);
  const c = await digest$1(g), x = bytesToBits(c);
  for (let R = 0; R < l; R += 1)
    if (d[h + R] !== x[R])
      throw new Error("Checksum mismatch");
  return g;
}
function crc8(u) {
  let t = 255;
  for (let a = 0; a < u.length - 1; a += 1) {
    t ^= u[a];
    for (let d = 0; d < 8; d += 1)
      t = t >>> 1 ^ ((t & 1) === 0 ? 0 : 178);
  }
  return t ^ 255;
}
function convertRadix(u, t, a, d) {
  let l = new BigNumber$1(0);
  for (const g of u)
    l = l.times(t), l = l.plus(g);
  const h = new Uint8Array(d);
  for (let g = d - 1; g >= 0; g -= 1) {
    const c = l.dividedToIntegerBy(a), x = l.modulo(a);
    l = c, h[g] = x.toNumber();
  }
  return h;
}
function bytesToBits(u) {
  const t = [];
  t.fill(!1, 0, u.length * 8);
  for (let a = 0; a < u.length; a += 1)
    for (let d = 0; d < 8; d += 1)
      t[a * 8 + d] = (u[a] & 1 << 7 - d) !== 0;
  return t;
}
const ED25519_SEED_TEXT = "ed25519 seed", ECDSA_SEED_TEXT = "Bitcoin seed", HEDERA_PATH = [44, 3030, 0, 0];
class Mnemonic$1 {
  constructor({ words: t }) {
    this.words = t;
  }
  static generate() {
    return Mnemonic$1._generate(24);
  }
  static generate12() {
    return Mnemonic$1._generate(12);
  }
  static async _generate(t) {
    let a;
    if (t === 12)
      a = 16;
    else if (t === 24)
      a = 32;
    else
      throw new Error(
        `unsupported phrase length ${t}, only 12 or 24 are supported`
      );
    const d = await bytesAsync(a), l = bytesToBinary(Array.from(d)), h = await deriveChecksumBits(d), c = (l + h).match(/(.{1,11})/g), x = (c != null ? c : []).map(
      (R) => bip39Words[binaryToByte(R)]
    );
    return new Mnemonic$1({ words: x });
  }
  static fromWords(t) {
    return new Mnemonic$1({
      words: t
    })._validate();
  }
  toPrivateKey(t = "") {
    return this.toEd25519PrivateKey(t);
  }
  async toEd25519PrivateKey(t = "", a = HEDERA_PATH) {
    let { keyData: d, chainCode: l } = await this._toKeyData(
      t,
      ED25519_SEED_TEXT
    );
    for (const g of a)
      ({ keyData: d, chainCode: l } = await derive(
        d,
        l,
        g
      ));
    const h = nacl.sign.keyPair.fromSeed(d);
    if (CACHE.privateKeyConstructor == null)
      throw new Error("PrivateKey not found in cache");
    return CACHE.privateKeyConstructor(
      new Ed25519PrivateKey(h, l)
    );
  }
  async toStandardEd25519PrivateKey(t = "", a) {
    const d = await Mnemonic$1.toSeed(this.words, t);
    let l = await PrivateKey$1.fromSeedED25519(d);
    a = a == null ? 0 : a;
    for (const h of [44, 3030, 0, 0, a])
      l = await l.derive(h);
    return l;
  }
  async toEcdsaPrivateKey(t = "", a = HEDERA_PATH) {
    let { keyData: d, chainCode: l } = await this._toKeyData(
      t,
      ECDSA_SEED_TEXT
    );
    for (const h of a)
      ({ keyData: d, chainCode: l } = await derive$1(
        d,
        l,
        h
      ));
    if (CACHE.privateKeyConstructor == null)
      throw new Error("PrivateKey not found in cache");
    return CACHE.privateKeyConstructor(
      new EcdsaPrivateKey(fromBytes(d), l)
    );
  }
  async toStandardECDSAsecp256k1PrivateKey(t = "", a) {
    const d = await Mnemonic$1.toSeed(this.words, t);
    let l = await PrivateKey$1.fromSeedECDSAsecp256k1(d);
    a = a == null ? 0 : a;
    for (const h of [
      toHardenedIndex(44),
      toHardenedIndex(3030),
      toHardenedIndex(0),
      0,
      a
    ])
      l = await l.derive(h);
    return l;
  }
  static async toSeed(t, a) {
    return await toSeed(t, a);
  }
  async _toKeyData(t, a) {
    const d = await toSeed(this.words, t), l = await hash$3(
      HashAlgorithm.Sha512,
      a,
      d
    );
    return {
      keyData: l.subarray(0, 32),
      chainCode: l.subarray(32)
    };
  }
  static async fromString(t) {
    return Mnemonic$1.fromWords(t.split(/\s|,/));
  }
  async _validate() {
    if (this.words.length === 22) {
      const t = this.words.reduce(
        (h, g, c) => legacyWords.includes(g.toLowerCase()) ? h : [...h, c],
        []
      );
      if (t.length > 0)
        throw new BadMnemonicError(
          this,
          BadMnemonicReason.UnknownWords,
          t
        );
      const [a, d] = legacy1(this.words, legacyWords), l = crc8(a);
      if (d !== l)
        throw new BadMnemonicError(
          this,
          BadMnemonicReason.ChecksumMismatch,
          []
        );
    } else {
      if (!(this.words.length === 12 || this.words.length === 24))
        throw new BadMnemonicError(
          this,
          BadMnemonicReason.BadLength,
          []
        );
      const t = this.words.reduce(
        (R, B, j) => bip39Words.includes(B) ? R : [...R, j],
        []
      );
      if (t.length > 0)
        throw new BadMnemonicError(
          this,
          BadMnemonicReason.UnknownWords,
          t
        );
      const a = this.words.map((R) => bip39Words.indexOf(R).toString(2).padStart(11, "0")).join(""), d = Math.floor(a.length / 33) * 32, l = a.slice(0, d), h = a.slice(d), c = l.match(/(.{1,8})/g).map(binaryToByte);
      if (await deriveChecksumBits(
        Uint8Array.from(c)
      ) !== h)
        throw new BadMnemonicError(
          this,
          BadMnemonicReason.ChecksumMismatch,
          []
        );
    }
    return this;
  }
  async toLegacyPrivateKey() {
    let t;
    if (this.words.length === 22 ? [t] = legacy1(this.words, legacyWords) : t = await legacy2(this.words, bip39Words), CACHE.privateKeyFromBytes == null)
      throw new Error("PrivateKey not found in cache");
    return CACHE.privateKeyFromBytes(t);
  }
  toString() {
    return this.words.join(" ");
  }
}
function binaryToByte(u) {
  return parseInt(u, 2);
}
function bytesToBinary(u) {
  return u.map((t) => t.toString(2).padStart(8, "0")).join("");
}
async function deriveChecksumBits(u) {
  const a = u.length * 8 / 32, d = await digest$1(u);
  return bytesToBinary(Array.from(d)).slice(0, a);
}
class Mnemonic {
  constructor(t) {
    this._mnemonic = t;
  }
  static async generate() {
    return new Mnemonic(await Mnemonic$1._generate(24));
  }
  static async generate12() {
    return new Mnemonic(await Mnemonic$1._generate(12));
  }
  static async fromWords(t) {
    return new Mnemonic(await Mnemonic$1.fromWords(t));
  }
  async toPrivateKey(t = "") {
    return CACHE$1.privateKeyConstructor(
      await this._mnemonic.toPrivateKey(t)
    );
  }
  async toEd25519PrivateKey(t = "", a) {
    return CACHE$1.privateKeyConstructor(
      await this._mnemonic.toEd25519PrivateKey(t, a)
    );
  }
  async toStandardEd25519PrivateKey(t = "", a) {
    return CACHE$1.privateKeyConstructor(
      await this._mnemonic.toStandardEd25519PrivateKey(t, a)
    );
  }
  async toEcdsaPrivateKey(t = "", a) {
    return CACHE$1.privateKeyConstructor(
      await this._mnemonic.toEcdsaPrivateKey(t, a)
    );
  }
  async toStandardECDSAsecp256k1PrivateKey(t = "", a) {
    return CACHE$1.privateKeyConstructor(
      await this._mnemonic.toStandardECDSAsecp256k1PrivateKey(
        t,
        a
      )
    );
  }
  static async fromString(t) {
    return new Mnemonic(await Mnemonic$1.fromString(t));
  }
  async toLegacyPrivateKey() {
    return CACHE$1.privateKeyConstructor(
      await this._mnemonic.toLegacyPrivateKey()
    );
  }
  async toSeed(t) {
    return await Mnemonic$1.toSeed(
      this._mnemonic.words,
      t
    );
  }
  toString() {
    return this._mnemonic.toString();
  }
}
function arrayEqual(u, t) {
  if (u === t)
    return !0;
  if (u.byteLength !== t.byteLength)
    return !1;
  const a = new DataView(
    u.buffer,
    u.byteOffset,
    u.byteLength
  ), d = new DataView(
    t.buffer,
    t.byteOffset,
    t.byteLength
  );
  let l = u.byteLength;
  for (; l--; )
    if (a.getUint8(l) !== d.getUint8(l))
      return !1;
  return !0;
}
class Key {
  _toProtobufKey() {
    throw new Error("not implemented");
  }
  static _fromProtobufKey(t) {
    return t.contractID != null ? CACHE$1.contractId(t.contractID) : t.delegatableContractId != null ? CACHE$1.delegateContractId(t.delegatableContractId) : t.ed25519 != null && t.ed25519.byteLength > 0 ? CACHE$1.publicKeyED25519(t.ed25519) : t.ECDSASecp256k1 != null && t.ECDSASecp256k1.byteLength > 0 ? CACHE$1.publicKeyECDSA(t.ECDSASecp256k1) : t.thresholdKey != null && t.thresholdKey.threshold != null ? CACHE$1.thresholdKey(t.thresholdKey) : t.keyList != null ? CACHE$1.keyList(t.keyList) : null;
  }
}
class PublicKey extends Key {
  constructor(t) {
    super(), this._key = t;
  }
  static fromBytes(t) {
    return new PublicKey(PublicKey$1.fromBytes(t));
  }
  static fromBytesED25519(t) {
    return new PublicKey(PublicKey$1.fromBytesED25519(t));
  }
  static fromBytesECDSA(t) {
    return new PublicKey(PublicKey$1.fromBytesECDSA(t));
  }
  static fromString(t) {
    return new PublicKey(PublicKey$1.fromString(t));
  }
  static fromStringECDSA(t) {
    return new PublicKey(PublicKey$1.fromStringECDSA(t));
  }
  static fromStringED25519(t) {
    return new PublicKey(PublicKey$1.fromStringED25519(t));
  }
  verify(t, a) {
    return this._key.verify(t, a);
  }
  verifyTransaction(t) {
    t._requireFrozen(), t.isFrozen() || t.freeze();
    for (const a of t._signedTransactions.list)
      if (a.sigMap != null && a.sigMap.sigPair != null) {
        let d = !1;
        for (const l of a.sigMap.sigPair) {
          const h = l.pubKeyPrefix;
          if (arrayEqual(h, this.toBytesRaw())) {
            d = !0;
            const g = a.bodyBytes;
            let c = null;
            if (l.ed25519 != null ? c = l.ed25519 : l.ECDSASecp256k1 != null && (c = l.ECDSASecp256k1), c == null)
              continue;
            if (!this.verify(g, c))
              return !1;
          }
        }
        if (!d)
          return !1;
      }
    return !0;
  }
  toBytes() {
    return this._key.toBytes();
  }
  toBytesDer() {
    return this._key.toBytesDer();
  }
  toBytesRaw() {
    return this._key.toBytesRaw();
  }
  toEthereumAddress() {
    return this._key.toEthereumAddress();
  }
  toEvmAddress() {
    return this._key.toEthereumAddress();
  }
  toString() {
    return this._key.toString();
  }
  toStringDer() {
    return this._key.toStringDer();
  }
  toStringRaw() {
    return this._key.toStringRaw();
  }
  equals(t) {
    return this._key.equals(t._key);
  }
  _toProtobufKey() {
    switch (this._key._type) {
      case "ED25519":
        return {
          ed25519: this._key.toBytesRaw()
        };
      case "secp256k1":
        return {
          ECDSASecp256k1: this._key.toBytesRaw()
        };
      default:
        throw new Error(`unrecognized key type ${this._key._type}`);
    }
  }
  _toProtobufSignature(t) {
    switch (this._key._type) {
      case "ED25519":
        return {
          pubKeyPrefix: this._key.toBytesRaw(),
          ed25519: t
        };
      case "secp256k1":
        return {
          pubKeyPrefix: this._key.toBytesRaw(),
          ECDSASecp256k1: t
        };
      default:
        throw new Error(`unrecognized key type ${this._key._type}`);
    }
  }
  toAccountId(t, a) {
    return CACHE$1.accountIdConstructor(t, a, this);
  }
}
CACHE$1.setPublicKeyED25519((u) => PublicKey.fromBytesED25519(u));
CACHE$1.setPublicKeyECDSA((u) => PublicKey.fromBytesECDSA(u));
class PrivateKey extends Key {
  constructor(t) {
    super(), this._key = t;
  }
  static generateED25519() {
    return new PrivateKey(PrivateKey$1.generateED25519());
  }
  static generateECDSA() {
    return new PrivateKey(PrivateKey$1.generateECDSA());
  }
  static generate() {
    return PrivateKey.generateED25519();
  }
  static async generateAsync() {
    return new PrivateKey(await PrivateKey$1.generateAsync());
  }
  static async generateED25519Async() {
    return new PrivateKey(
      await PrivateKey$1.generateED25519Async()
    );
  }
  static async generateECDSAAsync() {
    return new PrivateKey(
      await PrivateKey$1.generateECDSAAsync()
    );
  }
  static fromBytes(t) {
    return new PrivateKey(PrivateKey$1.fromBytes(t));
  }
  static fromBytesECDSA(t) {
    return new PrivateKey(PrivateKey$1.fromBytesECDSA(t));
  }
  static fromBytesED25519(t) {
    return new PrivateKey(PrivateKey$1.fromBytesED25519(t));
  }
  static fromString(t) {
    return new PrivateKey(PrivateKey$1.fromString(t));
  }
  static fromStringECDSA(t) {
    return new PrivateKey(PrivateKey$1.fromStringECDSA(t));
  }
  static fromStringED25519(t) {
    return new PrivateKey(PrivateKey$1.fromStringED25519(t));
  }
  static async fromSeedED25519(t) {
    return new PrivateKey(
      await PrivateKey$1.fromSeedED25519(t)
    );
  }
  static async fromSeedECDSAsecp256k1(t) {
    return new PrivateKey(
      await PrivateKey$1.fromSeedECDSAsecp256k1(t)
    );
  }
  static async fromMnemonic(t, a = "") {
    return t instanceof Mnemonic ? new PrivateKey(
      await PrivateKey$1.fromMnemonic(
        t._mnemonic,
        a
      )
    ) : new PrivateKey(
      await PrivateKey$1.fromMnemonic(t, a)
    );
  }
  static async fromKeystore(t, a = "") {
    return new PrivateKey(
      await PrivateKey$1.fromKeystore(t, a)
    );
  }
  static async fromPem(t, a = "") {
    return new PrivateKey(
      await PrivateKey$1.fromPem(t, a)
    );
  }
  async derive(t) {
    return new PrivateKey(await this._key.derive(t));
  }
  async legacyDerive(t) {
    return new PrivateKey(await this._key.legacyDerive(t));
  }
  get publicKey() {
    return new PublicKey(this._key.publicKey);
  }
  get chainCode() {
    return this._key._chainCode;
  }
  sign(t) {
    return this._key.sign(t);
  }
  signTransaction(t) {
    const a = t._signedTransactions.get(0), d = a.bodyBytes != null ? this.sign(a.bodyBytes) : new Uint8Array();
    return t.addSignature(this.publicKey, d), d;
  }
  isDerivable() {
    return this._key.isDerivable();
  }
  toBytes() {
    return this._key.toBytes();
  }
  toBytesDer() {
    return this._key.toBytesDer();
  }
  toBytesRaw() {
    return this._key.toBytesRaw();
  }
  toString() {
    return this._key.toStringDer();
  }
  toStringDer() {
    return this._key.toStringDer();
  }
  toStringRaw() {
    return this._key.toStringRaw();
  }
  toKeystore(t = "") {
    return this._key.toKeystore(t);
  }
  _toProtobufKey() {
    return this.publicKey._toProtobufKey();
  }
  toAccountId(t, a) {
    return this.publicKey.toAccountId(t, a);
  }
}
CACHE$1.setPrivateKeyConstructor((u) => new PrivateKey(u));
class KeyList extends Key {
  constructor(t, a) {
    super(), t == null ? this._keys = [] : t instanceof Key ? this._keys = [t] : this._keys = t, this._threshold = a == null ? null : a;
  }
  static of(...t) {
    return new KeyList(t, null);
  }
  static from(t, a, d) {
    return a == null ? new KeyList(Array.from(t)) : new KeyList(Array.from(t, a, d));
  }
  get threshold() {
    return this._threshold;
  }
  setThreshold(t) {
    return this._threshold = t, this;
  }
  push(...t) {
    return this._keys.push(...t);
  }
  splice(t, a, ...d) {
    return new KeyList(
      this._keys.splice(t, a, ...d),
      this.threshold
    );
  }
  slice(t, a) {
    return new KeyList(this._keys.slice(t, a), this.threshold);
  }
  [Symbol.iterator]() {
    return this._keys[Symbol.iterator]();
  }
  toArray() {
    return this._keys.slice();
  }
  toString() {
    return JSON.stringify({
      threshold: this._threshold,
      keys: this._keys.toString()
    });
  }
  _toProtobufKey() {
    const t = this._keys.map((a) => a._toProtobufKey());
    return this.threshold == null ? { keyList: { keys: t } } : {
      thresholdKey: {
        threshold: this.threshold,
        keys: { keys: t }
      }
    };
  }
  static __fromProtobufKeyList(t) {
    const a = (t.keys != null ? t.keys : []).map(
      (d) => Key._fromProtobufKey(d)
    );
    return new KeyList(a);
  }
  static __fromProtobufThresoldKey(t) {
    const a = KeyList.__fromProtobufKeyList(
      t.keys != null ? t.keys : {}
    );
    return a.setThreshold(t.threshold != null ? t.threshold : 0), a;
  }
}
CACHE$1.setKeyList((u) => KeyList.__fromProtobufKeyList(u));
CACHE$1.setThresholdKey((u) => KeyList.__fromProtobufThresoldKey(u));
function valueToLong(u) {
  return BigNumber$1.isBigNumber(u) ? u : new BigNumber$1(u.toString());
}
class HbarUnit {
  constructor(t, a, d) {
    this._name = t, this._symbol = a, this._tinybar = d, Object.freeze(this);
  }
  static fromString(t) {
    switch (t) {
      case HbarUnit.Hbar._symbol:
        return HbarUnit.Hbar;
      case HbarUnit.Tinybar._symbol:
        return HbarUnit.Tinybar;
      case HbarUnit.Microbar._symbol:
        return HbarUnit.Microbar;
      case HbarUnit.Millibar._symbol:
        return HbarUnit.Millibar;
      case HbarUnit.Kilobar._symbol:
        return HbarUnit.Kilobar;
      case HbarUnit.Megabar._symbol:
        return HbarUnit.Megabar;
      case HbarUnit.Gigabar._symbol:
        return HbarUnit.Gigabar;
      default:
        throw new Error("Unknown unit.");
    }
  }
}
HbarUnit.Tinybar = new HbarUnit("tinybar", "t\u210F", new BigNumber$1(1));
HbarUnit.Microbar = new HbarUnit("microbar", "\u03BC\u210F", new BigNumber$1(100));
HbarUnit.Millibar = new HbarUnit("millibar", "m\u210F", new BigNumber$1(1e5));
HbarUnit.Hbar = new HbarUnit("hbar", "\u210F", new BigNumber$1("100000000"));
HbarUnit.Kilobar = new HbarUnit(
  "kilobar",
  "k\u210F",
  new BigNumber$1(1e3).multipliedBy(new BigNumber$1("100000000"))
);
HbarUnit.Megabar = new HbarUnit(
  "megabar",
  "M\u210F",
  new BigNumber$1(1e6).multipliedBy(new BigNumber$1("100000000"))
);
HbarUnit.Gigabar = new HbarUnit(
  "gigabar",
  "G\u210F",
  new BigNumber$1("1000000000").multipliedBy(new BigNumber$1("100000000"))
);
class Hbar {
  constructor(t, a = HbarUnit.Hbar) {
    if (a === HbarUnit.Tinybar)
      this._valueInTinybar = valueToLong(t);
    else {
      let d;
      long.isLong(t) ? d = new BigNumber$1(t.toString(10)) : BigNumber$1.isBigNumber(t) || typeof t == "string" || typeof t == "number" ? d = new BigNumber$1(t) : d = new BigNumber$1(0), this._valueInTinybar = d.multipliedBy(a._tinybar);
    }
    if (!this._valueInTinybar.isInteger())
      throw new Error("Hbar in tinybars contains decimals");
  }
  static from(t, a) {
    return new Hbar(t, a);
  }
  static fromTinybars(t) {
    return typeof t == "string" ? this.fromString(t, HbarUnit.Tinybar) : new Hbar(t, HbarUnit.Tinybar);
  }
  static fromString(t, a = HbarUnit.Hbar) {
    if (/^((?:\+|-)?\d+(?:\.\d+)?)(?: (tℏ|μℏ|mℏ|ℏ|kℏ|Mℏ|Gℏ))?$/.test(t)) {
      let [l, h] = t.split(" ");
      return h != null && (a = HbarUnit.fromString(h)), new Hbar(new BigNumber$1(l), a);
    } else
      throw new Error("invalid argument provided");
  }
  to(t) {
    return this._valueInTinybar.dividedBy(t._tinybar);
  }
  toBigNumber() {
    return this.to(HbarUnit.Hbar);
  }
  toTinybars() {
    return long.fromValue(this._valueInTinybar.toFixed());
  }
  negated() {
    return Hbar.fromTinybars(this._valueInTinybar.negated());
  }
  isNegative() {
    return this._valueInTinybar.isNegative();
  }
  toString(t) {
    return t != null ? `${this._valueInTinybar.dividedBy(t._tinybar).toString()} ${t._symbol}` : this._valueInTinybar.isLessThan(1e4) && this._valueInTinybar.isGreaterThan(-1e4) ? `${this._valueInTinybar.toFixed()} ${HbarUnit.Tinybar._symbol}` : `${this.to(HbarUnit.Hbar).toString()} ${HbarUnit.Hbar._symbol}`;
  }
}
class StatusError extends Error {
  constructor(t, a) {
    super(a), this.name = "StatusError", this.status = t.status, this.transactionId = t.transactionId, this.message = a, typeof Error.captureStackTrace < "u" && Error.captureStackTrace(this, StatusError);
  }
  toJSON() {
    return {
      name: this.name,
      status: this.status.toString(),
      transactionId: this.transactionId.toString(),
      message: this.message
    };
  }
  toString() {
    return JSON.stringify(this.toJSON());
  }
  valueOf() {
    return this.toJSON();
  }
}
class ReceiptStatusError extends StatusError {
  constructor(t) {
    super(
      t,
      `receipt for transaction ${t.transactionId.toString()} contained error status ${t.status.toString()}`
    ), this.transactionReceipt = t.transactionReceipt;
  }
}
class Status {
  constructor(t) {
    this._code = t, Object.freeze(this);
  }
  toString() {
    switch (this) {
      case Status.Ok:
        return "OK";
      case Status.InvalidTransaction:
        return "INVALID_TRANSACTION";
      case Status.PayerAccountNotFound:
        return "PAYER_ACCOUNT_NOT_FOUND";
      case Status.InvalidNodeAccount:
        return "INVALID_NODE_ACCOUNT";
      case Status.TransactionExpired:
        return "TRANSACTION_EXPIRED";
      case Status.InvalidTransactionStart:
        return "INVALID_TRANSACTION_START";
      case Status.InvalidTransactionDuration:
        return "INVALID_TRANSACTION_DURATION";
      case Status.InvalidSignature:
        return "INVALID_SIGNATURE";
      case Status.MemoTooLong:
        return "MEMO_TOO_LONG";
      case Status.InsufficientTxFee:
        return "INSUFFICIENT_TX_FEE";
      case Status.InsufficientPayerBalance:
        return "INSUFFICIENT_PAYER_BALANCE";
      case Status.DuplicateTransaction:
        return "DUPLICATE_TRANSACTION";
      case Status.Busy:
        return "BUSY";
      case Status.NotSupported:
        return "NOT_SUPPORTED";
      case Status.InvalidFileId:
        return "INVALID_FILE_ID";
      case Status.InvalidAccountId:
        return "INVALID_ACCOUNT_ID";
      case Status.InvalidContractId:
        return "INVALID_CONTRACT_ID";
      case Status.InvalidTransactionId:
        return "INVALID_TRANSACTION_ID";
      case Status.ReceiptNotFound:
        return "RECEIPT_NOT_FOUND";
      case Status.RecordNotFound:
        return "RECORD_NOT_FOUND";
      case Status.InvalidSolidityId:
        return "INVALID_SOLIDITY_ID";
      case Status.Unknown:
        return "UNKNOWN";
      case Status.Success:
        return "SUCCESS";
      case Status.FailInvalid:
        return "FAIL_INVALID";
      case Status.FailFee:
        return "FAIL_FEE";
      case Status.FailBalance:
        return "FAIL_BALANCE";
      case Status.KeyRequired:
        return "KEY_REQUIRED";
      case Status.BadEncoding:
        return "BAD_ENCODING";
      case Status.InsufficientAccountBalance:
        return "INSUFFICIENT_ACCOUNT_BALANCE";
      case Status.InvalidSolidityAddress:
        return "INVALID_SOLIDITY_ADDRESS";
      case Status.InsufficientGas:
        return "INSUFFICIENT_GAS";
      case Status.ContractSizeLimitExceeded:
        return "CONTRACT_SIZE_LIMIT_EXCEEDED";
      case Status.LocalCallModificationException:
        return "LOCAL_CALL_MODIFICATION_EXCEPTION";
      case Status.ContractRevertExecuted:
        return "CONTRACT_REVERT_EXECUTED";
      case Status.ContractExecutionException:
        return "CONTRACT_EXECUTION_EXCEPTION";
      case Status.InvalidReceivingNodeAccount:
        return "INVALID_RECEIVING_NODE_ACCOUNT";
      case Status.MissingQueryHeader:
        return "MISSING_QUERY_HEADER";
      case Status.AccountUpdateFailed:
        return "ACCOUNT_UPDATE_FAILED";
      case Status.InvalidKeyEncoding:
        return "INVALID_KEY_ENCODING";
      case Status.NullSolidityAddress:
        return "NULL_SOLIDITY_ADDRESS";
      case Status.ContractUpdateFailed:
        return "CONTRACT_UPDATE_FAILED";
      case Status.InvalidQueryHeader:
        return "INVALID_QUERY_HEADER";
      case Status.InvalidFeeSubmitted:
        return "INVALID_FEE_SUBMITTED";
      case Status.InvalidPayerSignature:
        return "INVALID_PAYER_SIGNATURE";
      case Status.KeyNotProvided:
        return "KEY_NOT_PROVIDED";
      case Status.InvalidExpirationTime:
        return "INVALID_EXPIRATION_TIME";
      case Status.NoWaclKey:
        return "NO_WACL_KEY";
      case Status.FileContentEmpty:
        return "FILE_CONTENT_EMPTY";
      case Status.InvalidAccountAmounts:
        return "INVALID_ACCOUNT_AMOUNTS";
      case Status.EmptyTransactionBody:
        return "EMPTY_TRANSACTION_BODY";
      case Status.InvalidTransactionBody:
        return "INVALID_TRANSACTION_BODY";
      case Status.InvalidSignatureTypeMismatchingKey:
        return "INVALID_SIGNATURE_TYPE_MISMATCHING_KEY";
      case Status.InvalidSignatureCountMismatchingKey:
        return "INVALID_SIGNATURE_COUNT_MISMATCHING_KEY";
      case Status.EmptyLiveHashBody:
        return "EMPTY_LIVE_HASH_BODY";
      case Status.EmptyLiveHash:
        return "EMPTY_LIVE_HASH";
      case Status.EmptyLiveHashKeys:
        return "EMPTY_LIVE_HASH_KEYS";
      case Status.InvalidLiveHashSize:
        return "INVALID_LIVE_HASH_SIZE";
      case Status.EmptyQueryBody:
        return "EMPTY_QUERY_BODY";
      case Status.EmptyLiveHashQuery:
        return "EMPTY_LIVE_HASH_QUERY";
      case Status.LiveHashNotFound:
        return "LIVE_HASH_NOT_FOUND";
      case Status.AccountIdDoesNotExist:
        return "ACCOUNT_ID_DOES_NOT_EXIST";
      case Status.LiveHashAlreadyExists:
        return "LIVE_HASH_ALREADY_EXISTS";
      case Status.InvalidFileWacl:
        return "INVALID_FILE_WACL";
      case Status.SerializationFailed:
        return "SERIALIZATION_FAILED";
      case Status.TransactionOversize:
        return "TRANSACTION_OVERSIZE";
      case Status.TransactionTooManyLayers:
        return "TRANSACTION_TOO_MANY_LAYERS";
      case Status.ContractDeleted:
        return "CONTRACT_DELETED";
      case Status.PlatformNotActive:
        return "PLATFORM_NOT_ACTIVE";
      case Status.KeyPrefixMismatch:
        return "KEY_PREFIX_MISMATCH";
      case Status.PlatformTransactionNotCreated:
        return "PLATFORM_TRANSACTION_NOT_CREATED";
      case Status.InvalidRenewalPeriod:
        return "INVALID_RENEWAL_PERIOD";
      case Status.InvalidPayerAccountId:
        return "INVALID_PAYER_ACCOUNT_ID";
      case Status.AccountDeleted:
        return "ACCOUNT_DELETED";
      case Status.FileDeleted:
        return "FILE_DELETED";
      case Status.AccountRepeatedInAccountAmounts:
        return "ACCOUNT_REPEATED_IN_ACCOUNT_AMOUNTS";
      case Status.SettingNegativeAccountBalance:
        return "SETTING_NEGATIVE_ACCOUNT_BALANCE";
      case Status.ObtainerRequired:
        return "OBTAINER_REQUIRED";
      case Status.ObtainerSameContractId:
        return "OBTAINER_SAME_CONTRACT_ID";
      case Status.ObtainerDoesNotExist:
        return "OBTAINER_DOES_NOT_EXIST";
      case Status.ModifyingImmutableContract:
        return "MODIFYING_IMMUTABLE_CONTRACT";
      case Status.FileSystemException:
        return "FILE_SYSTEM_EXCEPTION";
      case Status.AutorenewDurationNotInRange:
        return "AUTORENEW_DURATION_NOT_IN_RANGE";
      case Status.ErrorDecodingBytestring:
        return "ERROR_DECODING_BYTESTRING";
      case Status.ContractFileEmpty:
        return "CONTRACT_FILE_EMPTY";
      case Status.ContractBytecodeEmpty:
        return "CONTRACT_BYTECODE_EMPTY";
      case Status.InvalidInitialBalance:
        return "INVALID_INITIAL_BALANCE";
      case Status.InvalidReceiveRecordThreshold:
        return "INVALID_RECEIVE_RECORD_THRESHOLD";
      case Status.InvalidSendRecordThreshold:
        return "INVALID_SEND_RECORD_THRESHOLD";
      case Status.AccountIsNotGenesisAccount:
        return "ACCOUNT_IS_NOT_GENESIS_ACCOUNT";
      case Status.PayerAccountUnauthorized:
        return "PAYER_ACCOUNT_UNAUTHORIZED";
      case Status.InvalidFreezeTransactionBody:
        return "INVALID_FREEZE_TRANSACTION_BODY";
      case Status.FreezeTransactionBodyNotFound:
        return "FREEZE_TRANSACTION_BODY_NOT_FOUND";
      case Status.TransferListSizeLimitExceeded:
        return "TRANSFER_LIST_SIZE_LIMIT_EXCEEDED";
      case Status.ResultSizeLimitExceeded:
        return "RESULT_SIZE_LIMIT_EXCEEDED";
      case Status.NotSpecialAccount:
        return "NOT_SPECIAL_ACCOUNT";
      case Status.ContractNegativeGas:
        return "CONTRACT_NEGATIVE_GAS";
      case Status.ContractNegativeValue:
        return "CONTRACT_NEGATIVE_VALUE";
      case Status.InvalidFeeFile:
        return "INVALID_FEE_FILE";
      case Status.InvalidExchangeRateFile:
        return "INVALID_EXCHANGE_RATE_FILE";
      case Status.InsufficientLocalCallGas:
        return "INSUFFICIENT_LOCAL_CALL_GAS";
      case Status.EntityNotAllowedToDelete:
        return "ENTITY_NOT_ALLOWED_TO_DELETE";
      case Status.AuthorizationFailed:
        return "AUTHORIZATION_FAILED";
      case Status.FileUploadedProtoInvalid:
        return "FILE_UPLOADED_PROTO_INVALID";
      case Status.FileUploadedProtoNotSavedToDisk:
        return "FILE_UPLOADED_PROTO_NOT_SAVED_TO_DISK";
      case Status.FeeScheduleFilePartUploaded:
        return "FEE_SCHEDULE_FILE_PART_UPLOADED";
      case Status.ExchangeRateChangeLimitExceeded:
        return "EXCHANGE_RATE_CHANGE_LIMIT_EXCEEDED";
      case Status.MaxContractStorageExceeded:
        return "MAX_CONTRACT_STORAGE_EXCEEDED";
      case Status.TransferAccountSameAsDeleteAccount:
        return "TRANSFER_ACCOUNT_SAME_AS_DELETE_ACCOUNT";
      case Status.TotalLedgerBalanceInvalid:
        return "TOTAL_LEDGER_BALANCE_INVALID";
      case Status.ExpirationReductionNotAllowed:
        return "EXPIRATION_REDUCTION_NOT_ALLOWED";
      case Status.MaxGasLimitExceeded:
        return "MAX_GAS_LIMIT_EXCEEDED";
      case Status.MaxFileSizeExceeded:
        return "MAX_FILE_SIZE_EXCEEDED";
      case Status.ReceiverSigRequired:
        return "RECEIVER_SIG_REQUIRED";
      case Status.InvalidTopicId:
        return "INVALID_TOPIC_ID";
      case Status.InvalidAdminKey:
        return "INVALID_ADMIN_KEY";
      case Status.InvalidSubmitKey:
        return "INVALID_SUBMIT_KEY";
      case Status.Unauthorized:
        return "UNAUTHORIZED";
      case Status.InvalidTopicMessage:
        return "INVALID_TOPIC_MESSAGE";
      case Status.InvalidAutorenewAccount:
        return "INVALID_AUTORENEW_ACCOUNT";
      case Status.AutorenewAccountNotAllowed:
        return "AUTORENEW_ACCOUNT_NOT_ALLOWED";
      case Status.TopicExpired:
        return "TOPIC_EXPIRED";
      case Status.InvalidChunkNumber:
        return "INVALID_CHUNK_NUMBER";
      case Status.InvalidChunkTransactionId:
        return "INVALID_CHUNK_TRANSACTION_ID";
      case Status.AccountFrozenForToken:
        return "ACCOUNT_FROZEN_FOR_TOKEN";
      case Status.TokensPerAccountLimitExceeded:
        return "TOKENS_PER_ACCOUNT_LIMIT_EXCEEDED";
      case Status.InvalidTokenId:
        return "INVALID_TOKEN_ID";
      case Status.InvalidTokenDecimals:
        return "INVALID_TOKEN_DECIMALS";
      case Status.InvalidTokenInitialSupply:
        return "INVALID_TOKEN_INITIAL_SUPPLY";
      case Status.InvalidTreasuryAccountForToken:
        return "INVALID_TREASURY_ACCOUNT_FOR_TOKEN";
      case Status.InvalidTokenSymbol:
        return "INVALID_TOKEN_SYMBOL";
      case Status.TokenHasNoFreezeKey:
        return "TOKEN_HAS_NO_FREEZE_KEY";
      case Status.TransfersNotZeroSumForToken:
        return "TRANSFERS_NOT_ZERO_SUM_FOR_TOKEN";
      case Status.MissingTokenSymbol:
        return "MISSING_TOKEN_SYMBOL";
      case Status.TokenSymbolTooLong:
        return "TOKEN_SYMBOL_TOO_LONG";
      case Status.AccountKycNotGrantedForToken:
        return "ACCOUNT_KYC_NOT_GRANTED_FOR_TOKEN";
      case Status.TokenHasNoKycKey:
        return "TOKEN_HAS_NO_KYC_KEY";
      case Status.InsufficientTokenBalance:
        return "INSUFFICIENT_TOKEN_BALANCE";
      case Status.TokenWasDeleted:
        return "TOKEN_WAS_DELETED";
      case Status.TokenHasNoSupplyKey:
        return "TOKEN_HAS_NO_SUPPLY_KEY";
      case Status.TokenHasNoWipeKey:
        return "TOKEN_HAS_NO_WIPE_KEY";
      case Status.InvalidTokenMintAmount:
        return "INVALID_TOKEN_MINT_AMOUNT";
      case Status.InvalidTokenBurnAmount:
        return "INVALID_TOKEN_BURN_AMOUNT";
      case Status.TokenNotAssociatedToAccount:
        return "TOKEN_NOT_ASSOCIATED_TO_ACCOUNT";
      case Status.CannotWipeTokenTreasuryAccount:
        return "CANNOT_WIPE_TOKEN_TREASURY_ACCOUNT";
      case Status.InvalidKycKey:
        return "INVALID_KYC_KEY";
      case Status.InvalidWipeKey:
        return "INVALID_WIPE_KEY";
      case Status.InvalidFreezeKey:
        return "INVALID_FREEZE_KEY";
      case Status.InvalidSupplyKey:
        return "INVALID_SUPPLY_KEY";
      case Status.MissingTokenName:
        return "MISSING_TOKEN_NAME";
      case Status.TokenNameTooLong:
        return "TOKEN_NAME_TOO_LONG";
      case Status.InvalidWipingAmount:
        return "INVALID_WIPING_AMOUNT";
      case Status.TokenIsImmutable:
        return "TOKEN_IS_IMMUTABLE";
      case Status.TokenAlreadyAssociatedToAccount:
        return "TOKEN_ALREADY_ASSOCIATED_TO_ACCOUNT";
      case Status.TransactionRequiresZeroTokenBalances:
        return "TRANSACTION_REQUIRES_ZERO_TOKEN_BALANCES";
      case Status.AccountIsTreasury:
        return "ACCOUNT_IS_TREASURY";
      case Status.TokenIdRepeatedInTokenList:
        return "TOKEN_ID_REPEATED_IN_TOKEN_LIST";
      case Status.TokenTransferListSizeLimitExceeded:
        return "TOKEN_TRANSFER_LIST_SIZE_LIMIT_EXCEEDED";
      case Status.EmptyTokenTransferBody:
        return "EMPTY_TOKEN_TRANSFER_BODY";
      case Status.EmptyTokenTransferAccountAmounts:
        return "EMPTY_TOKEN_TRANSFER_ACCOUNT_AMOUNTS";
      case Status.InvalidScheduleId:
        return "INVALID_SCHEDULE_ID";
      case Status.ScheduleIsImmutable:
        return "SCHEDULE_IS_IMMUTABLE";
      case Status.InvalidSchedulePayerId:
        return "INVALID_SCHEDULE_PAYER_ID";
      case Status.InvalidScheduleAccountId:
        return "INVALID_SCHEDULE_ACCOUNT_ID";
      case Status.NoNewValidSignatures:
        return "NO_NEW_VALID_SIGNATURES";
      case Status.UnresolvableRequiredSigners:
        return "UNRESOLVABLE_REQUIRED_SIGNERS";
      case Status.ScheduledTransactionNotInWhitelist:
        return "SCHEDULED_TRANSACTION_NOT_IN_WHITELIST";
      case Status.SomeSignaturesWereInvalid:
        return "SOME_SIGNATURES_WERE_INVALID";
      case Status.TransactionIdFieldNotAllowed:
        return "TRANSACTION_ID_FIELD_NOT_ALLOWED";
      case Status.IdenticalScheduleAlreadyCreated:
        return "IDENTICAL_SCHEDULE_ALREADY_CREATED";
      case Status.InvalidZeroByteInString:
        return "INVALID_ZERO_BYTE_IN_STRING";
      case Status.ScheduleAlreadyDeleted:
        return "SCHEDULE_ALREADY_DELETED";
      case Status.ScheduleAlreadyExecuted:
        return "SCHEDULE_ALREADY_EXECUTED";
      case Status.MessageSizeTooLarge:
        return "MESSAGE_SIZE_TOO_LARGE";
      case Status.OperationRepeatedInBucketGroups:
        return "OPERATION_REPEATED_IN_BUCKET_GROUPS";
      case Status.BucketCapacityOverflow:
        return "BUCKET_CAPACITY_OVERFLOW";
      case Status.NodeCapacityNotSufficientForOperation:
        return "NODE_CAPACITY_NOT_SUFFICIENT_FOR_OPERATION";
      case Status.BucketHasNoThrottleGroups:
        return "BUCKET_HAS_NO_THROTTLE_GROUPS";
      case Status.ThrottleGroupHasZeroOpsPerSec:
        return "THROTTLE_GROUP_HAS_ZERO_OPS_PER_SEC";
      case Status.SuccessButMissingExpectedOperation:
        return "SUCCESS_BUT_MISSING_EXPECTED_OPERATION";
      case Status.UnparseableThrottleDefinitions:
        return "UNPARSEABLE_THROTTLE_DEFINITIONS";
      case Status.InvalidThrottleDefinitions:
        return "INVALID_THROTTLE_DEFINITIONS";
      case Status.AccountExpiredAndPendingRemoval:
        return "ACCOUNT_EXPIRED_AND_PENDING_REMOVAL";
      case Status.InvalidTokenMaxSupply:
        return "INVALID_TOKEN_MAX_SUPPLY";
      case Status.InvalidTokenNftSerialNumber:
        return "INVALID_TOKEN_NFT_SERIAL_NUMBER";
      case Status.InvalidNftId:
        return "INVALID_NFT_ID";
      case Status.MetadataTooLong:
        return "METADATA_TOO_LONG";
      case Status.BatchSizeLimitExceeded:
        return "BATCH_SIZE_LIMIT_EXCEEDED";
      case Status.InvalidQueryRange:
        return "INVALID_QUERY_RANGE";
      case Status.FractionDividesByZero:
        return "FRACTION_DIVIDES_BY_ZERO";
      case Status.InsufficientPayerBalanceForCustomFee:
        return "INSUFFICIENT_PAYER_BALANCE_FOR_CUSTOM_FEE";
      case Status.CustomFeesListTooLong:
        return "CUSTOM_FEES_LIST_TOO_LONG";
      case Status.InvalidCustomFeeCollector:
        return "INVALID_CUSTOM_FEE_COLLECTOR";
      case Status.InvalidTokenIdInCustomFees:
        return "INVALID_TOKEN_ID_IN_CUSTOM_FEES";
      case Status.TokenNotAssociatedToFeeCollector:
        return "TOKEN_NOT_ASSOCIATED_TO_FEE_COLLECTOR";
      case Status.TokenMaxSupplyReached:
        return "TOKEN_MAX_SUPPLY_REACHED";
      case Status.SenderDoesNotOwnNftSerialNo:
        return "SENDER_DOES_NOT_OWN_NFT_SERIAL_NO";
      case Status.CustomFeeNotFullySpecified:
        return "CUSTOM_FEE_NOT_FULLY_SPECIFIED";
      case Status.CustomFeeMustBePositive:
        return "CUSTOM_FEE_MUST_BE_POSITIVE";
      case Status.TokenHasNoFeeScheduleKey:
        return "TOKEN_HAS_NO_FEE_SCHEDULE_KEY";
      case Status.CustomFeeOutsideNumericRange:
        return "CUSTOM_FEE_OUTSIDE_NUMERIC_RANGE";
      case Status.RoyaltyFractionCannotExceedOne:
        return "ROYALTY_FRACTION_CANNOT_EXCEED_ONE";
      case Status.FractionalFeeMaxAmountLessThanMinAmount:
        return "FRACTIONAL_FEE_MAX_AMOUNT_LESS_THAN_MIN_AMOUNT";
      case Status.CustomScheduleAlreadyHasNoFees:
        return "CUSTOM_SCHEDULE_ALREADY_HAS_NO_FEES";
      case Status.CustomFeeDenominationMustBeFungibleCommon:
        return "CUSTOM_FEE_DENOMINATION_MUST_BE_FUNGIBLE_COMMON";
      case Status.CustomFractionalFeeOnlyAllowedForFungibleCommon:
        return "CUSTOM_FRACTIONAL_FEE_ONLY_ALLOWED_FOR_FUNGIBLE_COMMON";
      case Status.InvalidCustomFeeScheduleKey:
        return "INVALID_CUSTOM_FEE_SCHEDULE_KEY";
      case Status.InvalidTokenMintMetadata:
        return "INVALID_TOKEN_MINT_METADATA";
      case Status.InvalidTokenBurnMetadata:
        return "INVALID_TOKEN_BURN_METADATA";
      case Status.CurrentTreasuryStillOwnsNfts:
        return "CURRENT_TREASURY_STILL_OWNS_NFTS";
      case Status.AccountStillOwnsNfts:
        return "ACCOUNT_STILL_OWNS_NFTS";
      case Status.TreasuryMustOwnBurnedNft:
        return "TREASURY_MUST_OWN_BURNED_NFT";
      case Status.AccountDoesNotOwnWipedNft:
        return "ACCOUNT_DOES_NOT_OWN_WIPED_NFT";
      case Status.AccountAmountTransfersOnlyAllowedForFungibleCommon:
        return "ACCOUNT_AMOUNT_TRANSFERS_ONLY_ALLOWED_FOR_FUNGIBLE_COMMON";
      case Status.MaxNftsInPriceRegimeHaveBeenMinted:
        return "MAX_NFTS_IN_PRICE_REGIME_HAVE_BEEN_MINTED";
      case Status.PayerAccountDeleted:
        return "PAYER_ACCOUNT_DELETED";
      case Status.CustomFeeChargingExceededMaxRecursionDepth:
        return "CUSTOM_FEE_CHARGING_EXCEEDED_MAX_RECURSION_DEPTH";
      case Status.CustomFeeChargingExceededMaxAccountAmounts:
        return "CUSTOM_FEE_CHARGING_EXCEEDED_MAX_ACCOUNT_AMOUNTS";
      case Status.InsufficientSenderAccountBalanceForCustomFee:
        return "INSUFFICIENT_SENDER_ACCOUNT_BALANCE_FOR_CUSTOM_FEE";
      case Status.SerialNumberLimitReached:
        return "SERIAL_NUMBER_LIMIT_REACHED";
      case Status.CustomRoyaltyFeeOnlyAllowedForNonFungibleUnique:
        return "CUSTOM_ROYALTY_FEE_ONLY_ALLOWED_FOR_NON_FUNGIBLE_UNIQUE";
      case Status.NoRemainingAutomaticAssociations:
        return "NO_REMAINING_AUTOMATIC_ASSOCIATIONS";
      case Status.ExistingAutomaticAssociationsExceedGivenLimit:
        return "EXISTING_AUTOMATIC_ASSOCIATIONS_EXCEED_GIVEN_LIMIT";
      case Status.RequestedNumAutomaticAssociationsExceedsAssociationLimit:
        return "REQUESTED_NUM_AUTOMATIC_ASSOCIATIONS_EXCEEDS_ASSOCIATION_LIMIT";
      case Status.TokenIsPaused:
        return "TOKEN_IS_PAUSED";
      case Status.TokenHasNoPauseKey:
        return "TOKEN_HAS_NO_PAUSE_KEY";
      case Status.InvalidPauseKey:
        return "INVALID_PAUSE_KEY";
      case Status.FreezeUpdateFileDoesNotExist:
        return "FREEZE_UPDATE_FILE_DOES_NOT_EXIST";
      case Status.FreezeUpdateFileHashDoesNotMatch:
        return "FREEZE_UPDATE_FILE_HASH_DOES_NOT_MATCH";
      case Status.NoUpgradeHasBeenPrepared:
        return "NO_UPGRADE_HAS_BEEN_PREPARED";
      case Status.NoFreezeIsScheduled:
        return "NO_FREEZE_IS_SCHEDULED";
      case Status.UpdateFileHashChangedSincePrepareUpgrade:
        return "UPDATE_FILE_HASH_CHANGED_SINCE_PREPARE_UPGRADE";
      case Status.FreezeStartTimeMustBeFuture:
        return "FREEZE_START_TIME_MUST_BE_FUTURE";
      case Status.PreparedUpdateFileIsImmutable:
        return "PREPARED_UPDATE_FILE_IS_IMMUTABLE";
      case Status.FreezeAlreadyScheduled:
        return "FREEZE_ALREADY_SCHEDULED";
      case Status.FreezeUpgradeInProgress:
        return "FREEZE_UPGRADE_IN_PROGRESS";
      case Status.UpdateFileIdDoesNotMatchPrepared:
        return "UPDATE_FILE_ID_DOES_NOT_MATCH_PREPARED";
      case Status.UpdateFileHashDoesNotMatchPrepared:
        return "UPDATE_FILE_HASH_DOES_NOT_MATCH_PREPARED";
      case Status.ConsensusGasExhausted:
        return "CONSENSUS_GAS_EXHAUSTED";
      case Status.RevertedSuccess:
        return "REVERTED_SUCCESS";
      case Status.MaxStorageInPriceRegimeHasBeenUsed:
        return "MAX_STORAGE_IN_PRICE_REGIME_HAS_BEEN_USED";
      case Status.InvalidAliasKey:
        return "INVALID_ALIAS_KEY";
      case Status.UnexpectedTokenDecimals:
        return "UNEXPECTED_TOKEN_DECIMALS";
      case Status.InvalidProxyAccountId:
        return "INVALID_PROXY_ACCOUNT_ID";
      case Status.InvalidTransferAccountId:
        return "INVALID_TRANSFER_ACCOUNT_ID";
      case Status.InvalidFeeCollectorAccountId:
        return "INVALID_FEE_COLLECTOR_ACCOUNT_ID";
      case Status.AliasIsImmutable:
        return "ALIAS_IS_IMMUTABLE";
      case Status.SpenderAccountSameAsOwner:
        return "SPENDER_ACCOUNT_SAME_AS_OWNER";
      case Status.AmountExceedsTokenMaxSupply:
        return "AMOUNT_EXCEEDS_TOKEN_MAX_SUPPLY";
      case Status.NegativeAllowanceAmount:
        return "NEGATIVE_ALLOWANCE_AMOUNT";
      case Status.CannotApproveForAllFungibleCommon:
        return "CANNOT_APPROVE_FOR_ALL_FUNGIBLE_COMMON";
      case Status.SpenderDoesNotHaveAllowance:
        return "SPENDER_DOES_NOT_HAVE_ALLOWANCE";
      case Status.AmountExceedsAllowance:
        return "AMOUNT_EXCEEDS_ALLOWANCE";
      case Status.MaxAllowancesExceeded:
        return "MAX_ALLOWANCES_EXCEEDED";
      case Status.EmptyAllowances:
        return "EMPTY_ALLOWANCES";
      case Status.SpenderAccountRepeatedInAllowances:
        return "SPENDER_ACCOUNT_REPEATED_IN_ALLOWANCES";
      case Status.RepeatedSerialNumsInNftAllowances:
        return "REPEATED_SERIAL_NUMS_IN_NFT_ALLOWANCES";
      case Status.FungibleTokenInNftAllowances:
        return "FUNGIBLE_TOKEN_IN_NFT_ALLOWANCES";
      case Status.NftInFungibleTokenAllowances:
        return "NFT_IN_FUNGIBLE_TOKEN_ALLOWANCES";
      case Status.InvalidAllowanceOwnerId:
        return "INVALID_ALLOWANCE_OWNER_ID";
      case Status.InvalidAllowanceSpenderId:
        return "INVALID_ALLOWANCE_SPENDER_ID";
      case Status.RepeatedAllowancesToDelete:
        return "REPEATED_ALLOWANCES_TO_DELETE";
      case Status.InvalidDelegatingSpender:
        return "INVALID_DELEGATING_SPENDER";
      case Status.DelegatingSpenderCannotGrantApproveForAll:
        return "DELEGATING_SPENDER_CANNOT_GRANT_APPROVE_FOR_ALL";
      case Status.DelegatingSpenderDoesNotHaveApproveForAll:
        return "DELEGATING_SPENDER_DOES_NOT_HAVE_APPROVE_FOR_ALL";
      case Status.ScheduleExpirationTimeTooFarInFuture:
        return "SCHEDULE_EXPIRATION_TIME_TOO_FAR_IN_FUTURE";
      case Status.ScheduleExpirationTimeMustBeHigherThanConsensusTime:
        return "SCHEDULE_EXPIRATION_TIME_MUST_BE_HIGHER_THAN_CONSENSUS_TIME";
      case Status.ScheduleFutureThrottleExceeded:
        return "SCHEDULE_FUTURE_THROTTLE_EXCEEDED";
      case Status.ScheduleFutureGasLimitExceeded:
        return "SCHEDULE_FUTURE_GAS_LIMIT_EXCEEDED";
      case Status.InvalidEthereumTransaction:
        return "INVALID_ETHEREUM_TRANSACTION";
      case Status.WrongChainId:
        return "WRONG_CHAIN_ID";
      case Status.WrongNonce:
        return "WRONG_NONCE";
      case Status.AccessListUnsupported:
        return "ACCESS_LIST_UNSUPPORTED";
      case Status.SchedulePendingExpiration:
        return "SCHEDULE_PENDING_EXPIRATION";
      case Status.ContractIsTokenTreasury:
        return "CONTRACT_IS_TOKEN_TREASURY";
      case Status.ContractHasNonZeroTokenBalances:
        return "CONTRACT_HAS_NON_ZERO_TOKEN_BALANCES";
      case Status.ContractExpiredAndPendingRemoval:
        return "CONTRACT_EXPIRED_AND_PENDING_REMOVAL";
      case Status.ContractHasNoAutoRenewAccount:
        return "CONTRACT_HAS_NO_AUTO_RENEW_ACCOUNT";
      case Status.PermanentRemovalRequiresSystemInitiation:
        return "PERMANENT_REMOVAL_REQUIRES_SYSTEM_INITIATION";
      case Status.ProxyAccountIdFieldIsDeprecated:
        return "PROXY_ACCOUNT_ID_FIELD_IS_DEPRECATED";
      case Status.SelfStakingIsNotAllowed:
        return "SELF_STAKING_IS_NOT_ALLOWED";
      case Status.InvalidStakingId:
        return "INVALID_STAKING_ID";
      case Status.StakingNotEnabled:
        return "STAKING_NOT_ENABLED";
      case Status.InvalidPrngRange:
        return "INVALID_PRNG_RANGE";
      case Status.MaxEntitiesInPriceRegimeHaveBeenCreated:
        return "MAX_ENTITIES_IN_PRICE_REGIME_HAVE_BEEN_CREATED";
      case Status.InvalidFullPrefixSignatureForPrecompile:
        return "INVALID_FULL_PREFIX_SIGNATURE_FOR_PRECOMPILE";
      case Status.InsufficientBalancesForStorageRent:
        return "INSUFFICIENT_BALANCES_FOR_STORAGE_RENT";
      case Status.MaxChildRecordsExceeded:
        return "MAX_CHILD_RECORDS_EXCEEDED";
      case Status.InsufficientBalancesForRenewalFees:
        return "INSUFFICIENT_BALANCES_FOR_RENEWAL_FEES";
      case Status.TransactionHasUnknownFields:
        return "TRANSACTION_HAS_UNKNOWN_FIELDS";
      case Status.AccountIsImmutable:
        return "ACCOUNT_IS_IMMUTABLE";
      case Status.AliasAlreadyAssigned:
        return "ALIAS_ALREADY_ASSIGNED";
      default:
        return `UNKNOWN (${this._code})`;
    }
  }
  static _fromCode(t) {
    switch (t) {
      case 0:
        return Status.Ok;
      case 1:
        return Status.InvalidTransaction;
      case 2:
        return Status.PayerAccountNotFound;
      case 3:
        return Status.InvalidNodeAccount;
      case 4:
        return Status.TransactionExpired;
      case 5:
        return Status.InvalidTransactionStart;
      case 6:
        return Status.InvalidTransactionDuration;
      case 7:
        return Status.InvalidSignature;
      case 8:
        return Status.MemoTooLong;
      case 9:
        return Status.InsufficientTxFee;
      case 10:
        return Status.InsufficientPayerBalance;
      case 11:
        return Status.DuplicateTransaction;
      case 12:
        return Status.Busy;
      case 13:
        return Status.NotSupported;
      case 14:
        return Status.InvalidFileId;
      case 15:
        return Status.InvalidAccountId;
      case 16:
        return Status.InvalidContractId;
      case 17:
        return Status.InvalidTransactionId;
      case 18:
        return Status.ReceiptNotFound;
      case 19:
        return Status.RecordNotFound;
      case 20:
        return Status.InvalidSolidityId;
      case 21:
        return Status.Unknown;
      case 22:
        return Status.Success;
      case 23:
        return Status.FailInvalid;
      case 24:
        return Status.FailFee;
      case 25:
        return Status.FailBalance;
      case 26:
        return Status.KeyRequired;
      case 27:
        return Status.BadEncoding;
      case 28:
        return Status.InsufficientAccountBalance;
      case 29:
        return Status.InvalidSolidityAddress;
      case 30:
        return Status.InsufficientGas;
      case 31:
        return Status.ContractSizeLimitExceeded;
      case 32:
        return Status.LocalCallModificationException;
      case 33:
        return Status.ContractRevertExecuted;
      case 34:
        return Status.ContractExecutionException;
      case 35:
        return Status.InvalidReceivingNodeAccount;
      case 36:
        return Status.MissingQueryHeader;
      case 37:
        return Status.AccountUpdateFailed;
      case 38:
        return Status.InvalidKeyEncoding;
      case 39:
        return Status.NullSolidityAddress;
      case 40:
        return Status.ContractUpdateFailed;
      case 41:
        return Status.InvalidQueryHeader;
      case 42:
        return Status.InvalidFeeSubmitted;
      case 43:
        return Status.InvalidPayerSignature;
      case 44:
        return Status.KeyNotProvided;
      case 45:
        return Status.InvalidExpirationTime;
      case 46:
        return Status.NoWaclKey;
      case 47:
        return Status.FileContentEmpty;
      case 48:
        return Status.InvalidAccountAmounts;
      case 49:
        return Status.EmptyTransactionBody;
      case 50:
        return Status.InvalidTransactionBody;
      case 51:
        return Status.InvalidSignatureTypeMismatchingKey;
      case 52:
        return Status.InvalidSignatureCountMismatchingKey;
      case 53:
        return Status.EmptyLiveHashBody;
      case 54:
        return Status.EmptyLiveHash;
      case 55:
        return Status.EmptyLiveHashKeys;
      case 56:
        return Status.InvalidLiveHashSize;
      case 57:
        return Status.EmptyQueryBody;
      case 58:
        return Status.EmptyLiveHashQuery;
      case 59:
        return Status.LiveHashNotFound;
      case 60:
        return Status.AccountIdDoesNotExist;
      case 61:
        return Status.LiveHashAlreadyExists;
      case 62:
        return Status.InvalidFileWacl;
      case 63:
        return Status.SerializationFailed;
      case 64:
        return Status.TransactionOversize;
      case 65:
        return Status.TransactionTooManyLayers;
      case 66:
        return Status.ContractDeleted;
      case 67:
        return Status.PlatformNotActive;
      case 68:
        return Status.KeyPrefixMismatch;
      case 69:
        return Status.PlatformTransactionNotCreated;
      case 70:
        return Status.InvalidRenewalPeriod;
      case 71:
        return Status.InvalidPayerAccountId;
      case 72:
        return Status.AccountDeleted;
      case 73:
        return Status.FileDeleted;
      case 74:
        return Status.AccountRepeatedInAccountAmounts;
      case 75:
        return Status.SettingNegativeAccountBalance;
      case 76:
        return Status.ObtainerRequired;
      case 77:
        return Status.ObtainerSameContractId;
      case 78:
        return Status.ObtainerDoesNotExist;
      case 79:
        return Status.ModifyingImmutableContract;
      case 80:
        return Status.FileSystemException;
      case 81:
        return Status.AutorenewDurationNotInRange;
      case 82:
        return Status.ErrorDecodingBytestring;
      case 83:
        return Status.ContractFileEmpty;
      case 84:
        return Status.ContractBytecodeEmpty;
      case 85:
        return Status.InvalidInitialBalance;
      case 86:
        return Status.InvalidReceiveRecordThreshold;
      case 87:
        return Status.InvalidSendRecordThreshold;
      case 88:
        return Status.AccountIsNotGenesisAccount;
      case 89:
        return Status.PayerAccountUnauthorized;
      case 90:
        return Status.InvalidFreezeTransactionBody;
      case 91:
        return Status.FreezeTransactionBodyNotFound;
      case 92:
        return Status.TransferListSizeLimitExceeded;
      case 93:
        return Status.ResultSizeLimitExceeded;
      case 94:
        return Status.NotSpecialAccount;
      case 95:
        return Status.ContractNegativeGas;
      case 96:
        return Status.ContractNegativeValue;
      case 97:
        return Status.InvalidFeeFile;
      case 98:
        return Status.InvalidExchangeRateFile;
      case 99:
        return Status.InsufficientLocalCallGas;
      case 100:
        return Status.EntityNotAllowedToDelete;
      case 101:
        return Status.AuthorizationFailed;
      case 102:
        return Status.FileUploadedProtoInvalid;
      case 103:
        return Status.FileUploadedProtoNotSavedToDisk;
      case 104:
        return Status.FeeScheduleFilePartUploaded;
      case 105:
        return Status.ExchangeRateChangeLimitExceeded;
      case 106:
        return Status.MaxContractStorageExceeded;
      case 107:
        return Status.TransferAccountSameAsDeleteAccount;
      case 108:
        return Status.TotalLedgerBalanceInvalid;
      case 110:
        return Status.ExpirationReductionNotAllowed;
      case 111:
        return Status.MaxGasLimitExceeded;
      case 112:
        return Status.MaxFileSizeExceeded;
      case 113:
        return Status.ReceiverSigRequired;
      case 150:
        return Status.InvalidTopicId;
      case 155:
        return Status.InvalidAdminKey;
      case 156:
        return Status.InvalidSubmitKey;
      case 157:
        return Status.Unauthorized;
      case 158:
        return Status.InvalidTopicMessage;
      case 159:
        return Status.InvalidAutorenewAccount;
      case 160:
        return Status.AutorenewAccountNotAllowed;
      case 162:
        return Status.TopicExpired;
      case 163:
        return Status.InvalidChunkNumber;
      case 164:
        return Status.InvalidChunkTransactionId;
      case 165:
        return Status.AccountFrozenForToken;
      case 166:
        return Status.TokensPerAccountLimitExceeded;
      case 167:
        return Status.InvalidTokenId;
      case 168:
        return Status.InvalidTokenDecimals;
      case 169:
        return Status.InvalidTokenInitialSupply;
      case 170:
        return Status.InvalidTreasuryAccountForToken;
      case 171:
        return Status.InvalidTokenSymbol;
      case 172:
        return Status.TokenHasNoFreezeKey;
      case 173:
        return Status.TransfersNotZeroSumForToken;
      case 174:
        return Status.MissingTokenSymbol;
      case 175:
        return Status.TokenSymbolTooLong;
      case 176:
        return Status.AccountKycNotGrantedForToken;
      case 177:
        return Status.TokenHasNoKycKey;
      case 178:
        return Status.InsufficientTokenBalance;
      case 179:
        return Status.TokenWasDeleted;
      case 180:
        return Status.TokenHasNoSupplyKey;
      case 181:
        return Status.TokenHasNoWipeKey;
      case 182:
        return Status.InvalidTokenMintAmount;
      case 183:
        return Status.InvalidTokenBurnAmount;
      case 184:
        return Status.TokenNotAssociatedToAccount;
      case 185:
        return Status.CannotWipeTokenTreasuryAccount;
      case 186:
        return Status.InvalidKycKey;
      case 187:
        return Status.InvalidWipeKey;
      case 188:
        return Status.InvalidFreezeKey;
      case 189:
        return Status.InvalidSupplyKey;
      case 190:
        return Status.MissingTokenName;
      case 191:
        return Status.TokenNameTooLong;
      case 192:
        return Status.InvalidWipingAmount;
      case 193:
        return Status.TokenIsImmutable;
      case 194:
        return Status.TokenAlreadyAssociatedToAccount;
      case 195:
        return Status.TransactionRequiresZeroTokenBalances;
      case 196:
        return Status.AccountIsTreasury;
      case 197:
        return Status.TokenIdRepeatedInTokenList;
      case 198:
        return Status.TokenTransferListSizeLimitExceeded;
      case 199:
        return Status.EmptyTokenTransferBody;
      case 200:
        return Status.EmptyTokenTransferAccountAmounts;
      case 201:
        return Status.InvalidScheduleId;
      case 202:
        return Status.ScheduleIsImmutable;
      case 203:
        return Status.InvalidSchedulePayerId;
      case 204:
        return Status.InvalidScheduleAccountId;
      case 205:
        return Status.NoNewValidSignatures;
      case 206:
        return Status.UnresolvableRequiredSigners;
      case 207:
        return Status.ScheduledTransactionNotInWhitelist;
      case 208:
        return Status.SomeSignaturesWereInvalid;
      case 209:
        return Status.TransactionIdFieldNotAllowed;
      case 210:
        return Status.IdenticalScheduleAlreadyCreated;
      case 211:
        return Status.InvalidZeroByteInString;
      case 212:
        return Status.ScheduleAlreadyDeleted;
      case 213:
        return Status.ScheduleAlreadyExecuted;
      case 214:
        return Status.MessageSizeTooLarge;
      case 215:
        return Status.OperationRepeatedInBucketGroups;
      case 216:
        return Status.BucketCapacityOverflow;
      case 217:
        return Status.NodeCapacityNotSufficientForOperation;
      case 218:
        return Status.BucketHasNoThrottleGroups;
      case 219:
        return Status.ThrottleGroupHasZeroOpsPerSec;
      case 220:
        return Status.SuccessButMissingExpectedOperation;
      case 221:
        return Status.UnparseableThrottleDefinitions;
      case 222:
        return Status.InvalidThrottleDefinitions;
      case 223:
        return Status.AccountExpiredAndPendingRemoval;
      case 224:
        return Status.InvalidTokenMaxSupply;
      case 225:
        return Status.InvalidTokenNftSerialNumber;
      case 226:
        return Status.InvalidNftId;
      case 227:
        return Status.MetadataTooLong;
      case 228:
        return Status.BatchSizeLimitExceeded;
      case 229:
        return Status.InvalidQueryRange;
      case 230:
        return Status.FractionDividesByZero;
      case 231:
        return Status.InsufficientPayerBalanceForCustomFee;
      case 232:
        return Status.CustomFeesListTooLong;
      case 233:
        return Status.InvalidCustomFeeCollector;
      case 234:
        return Status.InvalidTokenIdInCustomFees;
      case 235:
        return Status.TokenNotAssociatedToFeeCollector;
      case 236:
        return Status.TokenMaxSupplyReached;
      case 237:
        return Status.SenderDoesNotOwnNftSerialNo;
      case 238:
        return Status.CustomFeeNotFullySpecified;
      case 239:
        return Status.CustomFeeMustBePositive;
      case 240:
        return Status.TokenHasNoFeeScheduleKey;
      case 241:
        return Status.CustomFeeOutsideNumericRange;
      case 242:
        return Status.RoyaltyFractionCannotExceedOne;
      case 243:
        return Status.FractionalFeeMaxAmountLessThanMinAmount;
      case 244:
        return Status.CustomScheduleAlreadyHasNoFees;
      case 245:
        return Status.CustomFeeDenominationMustBeFungibleCommon;
      case 246:
        return Status.CustomFractionalFeeOnlyAllowedForFungibleCommon;
      case 247:
        return Status.InvalidCustomFeeScheduleKey;
      case 248:
        return Status.InvalidTokenMintMetadata;
      case 249:
        return Status.InvalidTokenBurnMetadata;
      case 250:
        return Status.CurrentTreasuryStillOwnsNfts;
      case 251:
        return Status.AccountStillOwnsNfts;
      case 252:
        return Status.TreasuryMustOwnBurnedNft;
      case 253:
        return Status.AccountDoesNotOwnWipedNft;
      case 254:
        return Status.AccountAmountTransfersOnlyAllowedForFungibleCommon;
      case 255:
        return Status.MaxNftsInPriceRegimeHaveBeenMinted;
      case 256:
        return Status.PayerAccountDeleted;
      case 257:
        return Status.CustomFeeChargingExceededMaxRecursionDepth;
      case 258:
        return Status.CustomFeeChargingExceededMaxAccountAmounts;
      case 259:
        return Status.InsufficientSenderAccountBalanceForCustomFee;
      case 260:
        return Status.SerialNumberLimitReached;
      case 261:
        return Status.CustomRoyaltyFeeOnlyAllowedForNonFungibleUnique;
      case 262:
        return Status.NoRemainingAutomaticAssociations;
      case 263:
        return Status.ExistingAutomaticAssociationsExceedGivenLimit;
      case 264:
        return Status.RequestedNumAutomaticAssociationsExceedsAssociationLimit;
      case 265:
        return Status.TokenIsPaused;
      case 266:
        return Status.TokenHasNoPauseKey;
      case 267:
        return Status.InvalidPauseKey;
      case 268:
        return Status.FreezeUpdateFileDoesNotExist;
      case 269:
        return Status.FreezeUpdateFileHashDoesNotMatch;
      case 270:
        return Status.NoUpgradeHasBeenPrepared;
      case 271:
        return Status.NoFreezeIsScheduled;
      case 272:
        return Status.UpdateFileHashChangedSincePrepareUpgrade;
      case 273:
        return Status.FreezeStartTimeMustBeFuture;
      case 274:
        return Status.PreparedUpdateFileIsImmutable;
      case 275:
        return Status.FreezeAlreadyScheduled;
      case 276:
        return Status.FreezeUpgradeInProgress;
      case 277:
        return Status.UpdateFileIdDoesNotMatchPrepared;
      case 278:
        return Status.UpdateFileHashDoesNotMatchPrepared;
      case 279:
        return Status.ConsensusGasExhausted;
      case 280:
        return Status.RevertedSuccess;
      case 281:
        return Status.MaxStorageInPriceRegimeHasBeenUsed;
      case 282:
        return Status.InvalidAliasKey;
      case 283:
        return Status.UnexpectedTokenDecimals;
      case 284:
        return Status.InvalidProxyAccountId;
      case 285:
        return Status.InvalidTransferAccountId;
      case 286:
        return Status.InvalidFeeCollectorAccountId;
      case 287:
        return Status.AliasIsImmutable;
      case 288:
        return Status.SpenderAccountSameAsOwner;
      case 289:
        return Status.AmountExceedsTokenMaxSupply;
      case 290:
        return Status.NegativeAllowanceAmount;
      case 291:
        return Status.CannotApproveForAllFungibleCommon;
      case 292:
        return Status.SpenderDoesNotHaveAllowance;
      case 293:
        return Status.AmountExceedsAllowance;
      case 294:
        return Status.MaxAllowancesExceeded;
      case 295:
        return Status.EmptyAllowances;
      case 296:
        return Status.SpenderAccountRepeatedInAllowances;
      case 297:
        return Status.RepeatedSerialNumsInNftAllowances;
      case 298:
        return Status.FungibleTokenInNftAllowances;
      case 299:
        return Status.NftInFungibleTokenAllowances;
      case 300:
        return Status.InvalidAllowanceOwnerId;
      case 301:
        return Status.InvalidAllowanceSpenderId;
      case 302:
        return Status.RepeatedAllowancesToDelete;
      case 303:
        return Status.InvalidDelegatingSpender;
      case 304:
        return Status.DelegatingSpenderCannotGrantApproveForAll;
      case 305:
        return Status.DelegatingSpenderDoesNotHaveApproveForAll;
      case 306:
        return Status.ScheduleExpirationTimeTooFarInFuture;
      case 307:
        return Status.ScheduleExpirationTimeMustBeHigherThanConsensusTime;
      case 308:
        return Status.ScheduleFutureThrottleExceeded;
      case 309:
        return Status.ScheduleFutureGasLimitExceeded;
      case 310:
        return Status.InvalidEthereumTransaction;
      case 311:
        return Status.WrongChainId;
      case 312:
        return Status.WrongNonce;
      case 313:
        return Status.AccessListUnsupported;
      case 314:
        return Status.SchedulePendingExpiration;
      case 315:
        return Status.ContractIsTokenTreasury;
      case 316:
        return Status.ContractHasNonZeroTokenBalances;
      case 317:
        return Status.ContractExpiredAndPendingRemoval;
      case 318:
        return Status.ContractHasNoAutoRenewAccount;
      case 319:
        return Status.PermanentRemovalRequiresSystemInitiation;
      case 320:
        return Status.ProxyAccountIdFieldIsDeprecated;
      case 321:
        return Status.SelfStakingIsNotAllowed;
      case 322:
        return Status.InvalidStakingId;
      case 323:
        return Status.StakingNotEnabled;
      case 324:
        return Status.InvalidPrngRange;
      case 325:
        return Status.MaxEntitiesInPriceRegimeHaveBeenCreated;
      case 326:
        return Status.InvalidFullPrefixSignatureForPrecompile;
      case 327:
        return Status.InsufficientBalancesForStorageRent;
      case 328:
        return Status.MaxChildRecordsExceeded;
      case 329:
        return Status.InsufficientBalancesForRenewalFees;
      case 330:
        return Status.TransactionHasUnknownFields;
      case 331:
        return Status.AccountIsImmutable;
      case 332:
        return Status.AliasAlreadyAssigned;
      default:
        throw new Error(
          `(BUG) Status.fromCode() does not handle code: ${t}`
        );
    }
  }
  valueOf() {
    return this._code;
  }
}
Status.Ok = new Status(0);
Status.InvalidTransaction = new Status(1);
Status.PayerAccountNotFound = new Status(2);
Status.InvalidNodeAccount = new Status(3);
Status.TransactionExpired = new Status(4);
Status.InvalidTransactionStart = new Status(5);
Status.InvalidTransactionDuration = new Status(6);
Status.InvalidSignature = new Status(7);
Status.MemoTooLong = new Status(8);
Status.InsufficientTxFee = new Status(9);
Status.InsufficientPayerBalance = new Status(10);
Status.DuplicateTransaction = new Status(11);
Status.Busy = new Status(12);
Status.NotSupported = new Status(13);
Status.InvalidFileId = new Status(14);
Status.InvalidAccountId = new Status(15);
Status.InvalidContractId = new Status(16);
Status.InvalidTransactionId = new Status(17);
Status.ReceiptNotFound = new Status(18);
Status.RecordNotFound = new Status(19);
Status.InvalidSolidityId = new Status(20);
Status.Unknown = new Status(21);
Status.Success = new Status(22);
Status.FailInvalid = new Status(23);
Status.FailFee = new Status(24);
Status.FailBalance = new Status(25);
Status.KeyRequired = new Status(26);
Status.BadEncoding = new Status(27);
Status.InsufficientAccountBalance = new Status(28);
Status.InvalidSolidityAddress = new Status(29);
Status.InsufficientGas = new Status(30);
Status.ContractSizeLimitExceeded = new Status(31);
Status.LocalCallModificationException = new Status(32);
Status.ContractRevertExecuted = new Status(33);
Status.ContractExecutionException = new Status(34);
Status.InvalidReceivingNodeAccount = new Status(35);
Status.MissingQueryHeader = new Status(36);
Status.AccountUpdateFailed = new Status(37);
Status.InvalidKeyEncoding = new Status(38);
Status.NullSolidityAddress = new Status(39);
Status.ContractUpdateFailed = new Status(40);
Status.InvalidQueryHeader = new Status(41);
Status.InvalidFeeSubmitted = new Status(42);
Status.InvalidPayerSignature = new Status(43);
Status.KeyNotProvided = new Status(44);
Status.InvalidExpirationTime = new Status(45);
Status.NoWaclKey = new Status(46);
Status.FileContentEmpty = new Status(47);
Status.InvalidAccountAmounts = new Status(48);
Status.EmptyTransactionBody = new Status(49);
Status.InvalidTransactionBody = new Status(50);
Status.InvalidSignatureTypeMismatchingKey = new Status(51);
Status.InvalidSignatureCountMismatchingKey = new Status(52);
Status.EmptyLiveHashBody = new Status(53);
Status.EmptyLiveHash = new Status(54);
Status.EmptyLiveHashKeys = new Status(55);
Status.InvalidLiveHashSize = new Status(56);
Status.EmptyQueryBody = new Status(57);
Status.EmptyLiveHashQuery = new Status(58);
Status.LiveHashNotFound = new Status(59);
Status.AccountIdDoesNotExist = new Status(60);
Status.LiveHashAlreadyExists = new Status(61);
Status.InvalidFileWacl = new Status(62);
Status.SerializationFailed = new Status(63);
Status.TransactionOversize = new Status(64);
Status.TransactionTooManyLayers = new Status(65);
Status.ContractDeleted = new Status(66);
Status.PlatformNotActive = new Status(67);
Status.KeyPrefixMismatch = new Status(68);
Status.PlatformTransactionNotCreated = new Status(69);
Status.InvalidRenewalPeriod = new Status(70);
Status.InvalidPayerAccountId = new Status(71);
Status.AccountDeleted = new Status(72);
Status.FileDeleted = new Status(73);
Status.AccountRepeatedInAccountAmounts = new Status(74);
Status.SettingNegativeAccountBalance = new Status(75);
Status.ObtainerRequired = new Status(76);
Status.ObtainerSameContractId = new Status(77);
Status.ObtainerDoesNotExist = new Status(78);
Status.ModifyingImmutableContract = new Status(79);
Status.FileSystemException = new Status(80);
Status.AutorenewDurationNotInRange = new Status(81);
Status.ErrorDecodingBytestring = new Status(82);
Status.ContractFileEmpty = new Status(83);
Status.ContractBytecodeEmpty = new Status(84);
Status.InvalidInitialBalance = new Status(85);
Status.InvalidReceiveRecordThreshold = new Status(86);
Status.InvalidSendRecordThreshold = new Status(87);
Status.AccountIsNotGenesisAccount = new Status(88);
Status.PayerAccountUnauthorized = new Status(89);
Status.InvalidFreezeTransactionBody = new Status(90);
Status.FreezeTransactionBodyNotFound = new Status(91);
Status.TransferListSizeLimitExceeded = new Status(92);
Status.ResultSizeLimitExceeded = new Status(93);
Status.NotSpecialAccount = new Status(94);
Status.ContractNegativeGas = new Status(95);
Status.ContractNegativeValue = new Status(96);
Status.InvalidFeeFile = new Status(97);
Status.InvalidExchangeRateFile = new Status(98);
Status.InsufficientLocalCallGas = new Status(99);
Status.EntityNotAllowedToDelete = new Status(100);
Status.AuthorizationFailed = new Status(101);
Status.FileUploadedProtoInvalid = new Status(102);
Status.FileUploadedProtoNotSavedToDisk = new Status(103);
Status.FeeScheduleFilePartUploaded = new Status(104);
Status.ExchangeRateChangeLimitExceeded = new Status(105);
Status.MaxContractStorageExceeded = new Status(106);
Status.TransferAccountSameAsDeleteAccount = new Status(107);
Status.TotalLedgerBalanceInvalid = new Status(108);
Status.ExpirationReductionNotAllowed = new Status(110);
Status.MaxGasLimitExceeded = new Status(111);
Status.MaxFileSizeExceeded = new Status(112);
Status.ReceiverSigRequired = new Status(113);
Status.InvalidTopicId = new Status(150);
Status.InvalidAdminKey = new Status(155);
Status.InvalidSubmitKey = new Status(156);
Status.Unauthorized = new Status(157);
Status.InvalidTopicMessage = new Status(158);
Status.InvalidAutorenewAccount = new Status(159);
Status.AutorenewAccountNotAllowed = new Status(160);
Status.TopicExpired = new Status(162);
Status.InvalidChunkNumber = new Status(163);
Status.InvalidChunkTransactionId = new Status(164);
Status.AccountFrozenForToken = new Status(165);
Status.TokensPerAccountLimitExceeded = new Status(166);
Status.InvalidTokenId = new Status(167);
Status.InvalidTokenDecimals = new Status(168);
Status.InvalidTokenInitialSupply = new Status(169);
Status.InvalidTreasuryAccountForToken = new Status(170);
Status.InvalidTokenSymbol = new Status(171);
Status.TokenHasNoFreezeKey = new Status(172);
Status.TransfersNotZeroSumForToken = new Status(173);
Status.MissingTokenSymbol = new Status(174);
Status.TokenSymbolTooLong = new Status(175);
Status.AccountKycNotGrantedForToken = new Status(176);
Status.TokenHasNoKycKey = new Status(177);
Status.InsufficientTokenBalance = new Status(178);
Status.TokenWasDeleted = new Status(179);
Status.TokenHasNoSupplyKey = new Status(180);
Status.TokenHasNoWipeKey = new Status(181);
Status.InvalidTokenMintAmount = new Status(182);
Status.InvalidTokenBurnAmount = new Status(183);
Status.TokenNotAssociatedToAccount = new Status(184);
Status.CannotWipeTokenTreasuryAccount = new Status(185);
Status.InvalidKycKey = new Status(186);
Status.InvalidWipeKey = new Status(187);
Status.InvalidFreezeKey = new Status(188);
Status.InvalidSupplyKey = new Status(189);
Status.MissingTokenName = new Status(190);
Status.TokenNameTooLong = new Status(191);
Status.InvalidWipingAmount = new Status(192);
Status.TokenIsImmutable = new Status(193);
Status.TokenAlreadyAssociatedToAccount = new Status(194);
Status.TransactionRequiresZeroTokenBalances = new Status(195);
Status.AccountIsTreasury = new Status(196);
Status.TokenIdRepeatedInTokenList = new Status(197);
Status.TokenTransferListSizeLimitExceeded = new Status(198);
Status.EmptyTokenTransferBody = new Status(199);
Status.EmptyTokenTransferAccountAmounts = new Status(200);
Status.InvalidScheduleId = new Status(201);
Status.ScheduleIsImmutable = new Status(202);
Status.InvalidSchedulePayerId = new Status(203);
Status.InvalidScheduleAccountId = new Status(204);
Status.NoNewValidSignatures = new Status(205);
Status.UnresolvableRequiredSigners = new Status(206);
Status.ScheduledTransactionNotInWhitelist = new Status(207);
Status.SomeSignaturesWereInvalid = new Status(208);
Status.TransactionIdFieldNotAllowed = new Status(209);
Status.IdenticalScheduleAlreadyCreated = new Status(210);
Status.InvalidZeroByteInString = new Status(211);
Status.ScheduleAlreadyDeleted = new Status(212);
Status.ScheduleAlreadyExecuted = new Status(213);
Status.MessageSizeTooLarge = new Status(214);
Status.OperationRepeatedInBucketGroups = new Status(215);
Status.BucketCapacityOverflow = new Status(216);
Status.NodeCapacityNotSufficientForOperation = new Status(217);
Status.BucketHasNoThrottleGroups = new Status(218);
Status.ThrottleGroupHasZeroOpsPerSec = new Status(219);
Status.SuccessButMissingExpectedOperation = new Status(220);
Status.UnparseableThrottleDefinitions = new Status(221);
Status.InvalidThrottleDefinitions = new Status(222);
Status.AccountExpiredAndPendingRemoval = new Status(223);
Status.InvalidTokenMaxSupply = new Status(224);
Status.InvalidTokenNftSerialNumber = new Status(225);
Status.InvalidNftId = new Status(226);
Status.MetadataTooLong = new Status(227);
Status.BatchSizeLimitExceeded = new Status(228);
Status.InvalidQueryRange = new Status(229);
Status.FractionDividesByZero = new Status(230);
Status.InsufficientPayerBalanceForCustomFee = new Status(231);
Status.CustomFeesListTooLong = new Status(232);
Status.InvalidCustomFeeCollector = new Status(233);
Status.InvalidTokenIdInCustomFees = new Status(234);
Status.TokenNotAssociatedToFeeCollector = new Status(235);
Status.TokenMaxSupplyReached = new Status(236);
Status.SenderDoesNotOwnNftSerialNo = new Status(237);
Status.CustomFeeNotFullySpecified = new Status(238);
Status.CustomFeeMustBePositive = new Status(239);
Status.TokenHasNoFeeScheduleKey = new Status(240);
Status.CustomFeeOutsideNumericRange = new Status(241);
Status.RoyaltyFractionCannotExceedOne = new Status(242);
Status.FractionalFeeMaxAmountLessThanMinAmount = new Status(243);
Status.CustomScheduleAlreadyHasNoFees = new Status(244);
Status.CustomFeeDenominationMustBeFungibleCommon = new Status(245);
Status.CustomFractionalFeeOnlyAllowedForFungibleCommon = new Status(246);
Status.InvalidCustomFeeScheduleKey = new Status(247);
Status.InvalidTokenMintMetadata = new Status(248);
Status.InvalidTokenBurnMetadata = new Status(249);
Status.CurrentTreasuryStillOwnsNfts = new Status(250);
Status.AccountStillOwnsNfts = new Status(251);
Status.TreasuryMustOwnBurnedNft = new Status(252);
Status.AccountDoesNotOwnWipedNft = new Status(253);
Status.AccountAmountTransfersOnlyAllowedForFungibleCommon = new Status(254);
Status.MaxNftsInPriceRegimeHaveBeenMinted = new Status(255);
Status.PayerAccountDeleted = new Status(256);
Status.CustomFeeChargingExceededMaxRecursionDepth = new Status(257);
Status.CustomFeeChargingExceededMaxAccountAmounts = new Status(258);
Status.InsufficientSenderAccountBalanceForCustomFee = new Status(259);
Status.SerialNumberLimitReached = new Status(260);
Status.CustomRoyaltyFeeOnlyAllowedForNonFungibleUnique = new Status(261);
Status.NoRemainingAutomaticAssociations = new Status(262);
Status.ExistingAutomaticAssociationsExceedGivenLimit = new Status(263);
Status.RequestedNumAutomaticAssociationsExceedsAssociationLimit = new Status(
  264
);
Status.TokenIsPaused = new Status(265);
Status.TokenHasNoPauseKey = new Status(266);
Status.InvalidPauseKey = new Status(267);
Status.FreezeUpdateFileDoesNotExist = new Status(268);
Status.FreezeUpdateFileHashDoesNotMatch = new Status(269);
Status.NoUpgradeHasBeenPrepared = new Status(270);
Status.NoFreezeIsScheduled = new Status(271);
Status.UpdateFileHashChangedSincePrepareUpgrade = new Status(272);
Status.FreezeStartTimeMustBeFuture = new Status(273);
Status.PreparedUpdateFileIsImmutable = new Status(274);
Status.FreezeAlreadyScheduled = new Status(275);
Status.FreezeUpgradeInProgress = new Status(276);
Status.UpdateFileIdDoesNotMatchPrepared = new Status(277);
Status.UpdateFileHashDoesNotMatchPrepared = new Status(278);
Status.ConsensusGasExhausted = new Status(279);
Status.RevertedSuccess = new Status(280);
Status.MaxStorageInPriceRegimeHasBeenUsed = new Status(281);
Status.InvalidAliasKey = new Status(282);
Status.UnexpectedTokenDecimals = new Status(283);
Status.InvalidProxyAccountId = new Status(284);
Status.InvalidTransferAccountId = new Status(285);
Status.InvalidFeeCollectorAccountId = new Status(286);
Status.AliasIsImmutable = new Status(287);
Status.SpenderAccountSameAsOwner = new Status(288);
Status.AmountExceedsTokenMaxSupply = new Status(289);
Status.NegativeAllowanceAmount = new Status(290);
Status.CannotApproveForAllFungibleCommon = new Status(291);
Status.SpenderDoesNotHaveAllowance = new Status(292);
Status.AmountExceedsAllowance = new Status(293);
Status.MaxAllowancesExceeded = new Status(294);
Status.EmptyAllowances = new Status(295);
Status.SpenderAccountRepeatedInAllowances = new Status(296);
Status.RepeatedSerialNumsInNftAllowances = new Status(297);
Status.FungibleTokenInNftAllowances = new Status(298);
Status.NftInFungibleTokenAllowances = new Status(299);
Status.InvalidAllowanceOwnerId = new Status(300);
Status.InvalidAllowanceSpenderId = new Status(301);
Status.RepeatedAllowancesToDelete = new Status(302);
Status.InvalidDelegatingSpender = new Status(303);
Status.DelegatingSpenderCannotGrantApproveForAll = new Status(304);
Status.DelegatingSpenderDoesNotHaveApproveForAll = new Status(305);
Status.ScheduleExpirationTimeTooFarInFuture = new Status(306);
Status.ScheduleExpirationTimeMustBeHigherThanConsensusTime = new Status(307);
Status.ScheduleFutureThrottleExceeded = new Status(308);
Status.ScheduleFutureGasLimitExceeded = new Status(309);
Status.InvalidEthereumTransaction = new Status(310);
Status.WrongChainId = new Status(311);
Status.WrongNonce = new Status(312);
Status.AccessListUnsupported = new Status(313);
Status.SchedulePendingExpiration = new Status(314);
Status.ContractIsTokenTreasury = new Status(315);
Status.ContractHasNonZeroTokenBalances = new Status(316);
Status.ContractExpiredAndPendingRemoval = new Status(317);
Status.ContractHasNoAutoRenewAccount = new Status(318);
Status.PermanentRemovalRequiresSystemInitiation = new Status(319);
Status.ProxyAccountIdFieldIsDeprecated = new Status(320);
Status.SelfStakingIsNotAllowed = new Status(321);
Status.InvalidStakingId = new Status(322);
Status.StakingNotEnabled = new Status(323);
Status.InvalidPrngRange = new Status(324);
Status.MaxEntitiesInPriceRegimeHaveBeenCreated = new Status(325);
Status.InvalidFullPrefixSignatureForPrecompile = new Status(326);
Status.InsufficientBalancesForStorageRent = new Status(327);
Status.MaxChildRecordsExceeded = new Status(328);
Status.InsufficientBalancesForRenewalFees = new Status(329);
Status.TransactionHasUnknownFields = new Status(330);
Status.AccountIsImmutable = new Status(331);
Status.AliasAlreadyAssigned = new Status(332);
var lib = {}, minimal$1 = { exports: {} }, indexMinimal = {}, minimal = {}, aspromise = asPromise;
function asPromise(u, t) {
  for (var a = new Array(arguments.length - 1), d = 0, l = 2, h = !0; l < arguments.length; )
    a[d++] = arguments[l++];
  return new Promise(function(c, x) {
    a[d] = function(B) {
      if (h)
        if (h = !1, B)
          x(B);
        else {
          for (var j = new Array(arguments.length - 1), o = 0; o < j.length; )
            j[o++] = arguments[o];
          c.apply(null, j);
        }
    };
    try {
      u.apply(t || null, a);
    } catch (R) {
      h && (h = !1, x(R));
    }
  });
}
var base64$1 = {};
(function(u) {
  var t = u;
  t.length = function(c) {
    var x = c.length;
    if (!x)
      return 0;
    for (var R = 0; --x % 4 > 1 && c.charAt(x) === "="; )
      ++R;
    return Math.ceil(c.length * 3) / 4 - R;
  };
  for (var a = new Array(64), d = new Array(123), l = 0; l < 64; )
    d[a[l] = l < 26 ? l + 65 : l < 52 ? l + 71 : l < 62 ? l - 4 : l - 59 | 43] = l++;
  t.encode = function(c, x, R) {
    for (var B = null, j = [], o = 0, e = 0, n; x < R; ) {
      var i = c[x++];
      switch (e) {
        case 0:
          j[o++] = a[i >> 2], n = (i & 3) << 4, e = 1;
          break;
        case 1:
          j[o++] = a[n | i >> 4], n = (i & 15) << 2, e = 2;
          break;
        case 2:
          j[o++] = a[n | i >> 6], j[o++] = a[i & 63], e = 0;
          break;
      }
      o > 8191 && ((B || (B = [])).push(String.fromCharCode.apply(String, j)), o = 0);
    }
    return e && (j[o++] = a[n], j[o++] = 61, e === 1 && (j[o++] = 61)), B ? (o && B.push(String.fromCharCode.apply(String, j.slice(0, o))), B.join("")) : String.fromCharCode.apply(String, j.slice(0, o));
  };
  var h = "invalid encoding";
  t.decode = function(c, x, R) {
    for (var B = R, j = 0, o, e = 0; e < c.length; ) {
      var n = c.charCodeAt(e++);
      if (n === 61 && j > 1)
        break;
      if ((n = d[n]) === void 0)
        throw Error(h);
      switch (j) {
        case 0:
          o = n, j = 1;
          break;
        case 1:
          x[R++] = o << 2 | (n & 48) >> 4, o = n, j = 2;
          break;
        case 2:
          x[R++] = (o & 15) << 4 | (n & 60) >> 2, o = n, j = 3;
          break;
        case 3:
          x[R++] = (o & 3) << 6 | n, j = 0;
          break;
      }
    }
    if (j === 1)
      throw Error(h);
    return R - B;
  }, t.test = function(c) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(c);
  };
})(base64$1);
var eventemitter = EventEmitter;
function EventEmitter() {
  this._listeners = {};
}
EventEmitter.prototype.on = function(t, a, d) {
  return (this._listeners[t] || (this._listeners[t] = [])).push({
    fn: a,
    ctx: d || this
  }), this;
};
EventEmitter.prototype.off = function(t, a) {
  if (t === void 0)
    this._listeners = {};
  else if (a === void 0)
    this._listeners[t] = [];
  else
    for (var d = this._listeners[t], l = 0; l < d.length; )
      d[l].fn === a ? d.splice(l, 1) : ++l;
  return this;
};
EventEmitter.prototype.emit = function(t) {
  var a = this._listeners[t];
  if (a) {
    for (var d = [], l = 1; l < arguments.length; )
      d.push(arguments[l++]);
    for (l = 0; l < a.length; )
      a[l].fn.apply(a[l++].ctx, d);
  }
  return this;
};
var float = factory(factory);
function factory(u) {
  return typeof Float32Array < "u" ? function() {
    var t = new Float32Array([-0]), a = new Uint8Array(t.buffer), d = a[3] === 128;
    function l(x, R, B) {
      t[0] = x, R[B] = a[0], R[B + 1] = a[1], R[B + 2] = a[2], R[B + 3] = a[3];
    }
    function h(x, R, B) {
      t[0] = x, R[B] = a[3], R[B + 1] = a[2], R[B + 2] = a[1], R[B + 3] = a[0];
    }
    u.writeFloatLE = d ? l : h, u.writeFloatBE = d ? h : l;
    function g(x, R) {
      return a[0] = x[R], a[1] = x[R + 1], a[2] = x[R + 2], a[3] = x[R + 3], t[0];
    }
    function c(x, R) {
      return a[3] = x[R], a[2] = x[R + 1], a[1] = x[R + 2], a[0] = x[R + 3], t[0];
    }
    u.readFloatLE = d ? g : c, u.readFloatBE = d ? c : g;
  }() : function() {
    function t(d, l, h, g) {
      var c = l < 0 ? 1 : 0;
      if (c && (l = -l), l === 0)
        d(1 / l > 0 ? 0 : 2147483648, h, g);
      else if (isNaN(l))
        d(2143289344, h, g);
      else if (l > 34028234663852886e22)
        d((c << 31 | 2139095040) >>> 0, h, g);
      else if (l < 11754943508222875e-54)
        d((c << 31 | Math.round(l / 1401298464324817e-60)) >>> 0, h, g);
      else {
        var x = Math.floor(Math.log(l) / Math.LN2), R = Math.round(l * Math.pow(2, -x) * 8388608) & 8388607;
        d((c << 31 | x + 127 << 23 | R) >>> 0, h, g);
      }
    }
    u.writeFloatLE = t.bind(null, writeUintLE), u.writeFloatBE = t.bind(null, writeUintBE);
    function a(d, l, h) {
      var g = d(l, h), c = (g >> 31) * 2 + 1, x = g >>> 23 & 255, R = g & 8388607;
      return x === 255 ? R ? NaN : c * (1 / 0) : x === 0 ? c * 1401298464324817e-60 * R : c * Math.pow(2, x - 150) * (R + 8388608);
    }
    u.readFloatLE = a.bind(null, readUintLE), u.readFloatBE = a.bind(null, readUintBE);
  }(), typeof Float64Array < "u" ? function() {
    var t = new Float64Array([-0]), a = new Uint8Array(t.buffer), d = a[7] === 128;
    function l(x, R, B) {
      t[0] = x, R[B] = a[0], R[B + 1] = a[1], R[B + 2] = a[2], R[B + 3] = a[3], R[B + 4] = a[4], R[B + 5] = a[5], R[B + 6] = a[6], R[B + 7] = a[7];
    }
    function h(x, R, B) {
      t[0] = x, R[B] = a[7], R[B + 1] = a[6], R[B + 2] = a[5], R[B + 3] = a[4], R[B + 4] = a[3], R[B + 5] = a[2], R[B + 6] = a[1], R[B + 7] = a[0];
    }
    u.writeDoubleLE = d ? l : h, u.writeDoubleBE = d ? h : l;
    function g(x, R) {
      return a[0] = x[R], a[1] = x[R + 1], a[2] = x[R + 2], a[3] = x[R + 3], a[4] = x[R + 4], a[5] = x[R + 5], a[6] = x[R + 6], a[7] = x[R + 7], t[0];
    }
    function c(x, R) {
      return a[7] = x[R], a[6] = x[R + 1], a[5] = x[R + 2], a[4] = x[R + 3], a[3] = x[R + 4], a[2] = x[R + 5], a[1] = x[R + 6], a[0] = x[R + 7], t[0];
    }
    u.readDoubleLE = d ? g : c, u.readDoubleBE = d ? c : g;
  }() : function() {
    function t(d, l, h, g, c, x) {
      var R = g < 0 ? 1 : 0;
      if (R && (g = -g), g === 0)
        d(0, c, x + l), d(1 / g > 0 ? 0 : 2147483648, c, x + h);
      else if (isNaN(g))
        d(0, c, x + l), d(2146959360, c, x + h);
      else if (g > 17976931348623157e292)
        d(0, c, x + l), d((R << 31 | 2146435072) >>> 0, c, x + h);
      else {
        var B;
        if (g < 22250738585072014e-324)
          B = g / 5e-324, d(B >>> 0, c, x + l), d((R << 31 | B / 4294967296) >>> 0, c, x + h);
        else {
          var j = Math.floor(Math.log(g) / Math.LN2);
          j === 1024 && (j = 1023), B = g * Math.pow(2, -j), d(B * 4503599627370496 >>> 0, c, x + l), d((R << 31 | j + 1023 << 20 | B * 1048576 & 1048575) >>> 0, c, x + h);
        }
      }
    }
    u.writeDoubleLE = t.bind(null, writeUintLE, 0, 4), u.writeDoubleBE = t.bind(null, writeUintBE, 4, 0);
    function a(d, l, h, g, c) {
      var x = d(g, c + l), R = d(g, c + h), B = (R >> 31) * 2 + 1, j = R >>> 20 & 2047, o = 4294967296 * (R & 1048575) + x;
      return j === 2047 ? o ? NaN : B * (1 / 0) : j === 0 ? B * 5e-324 * o : B * Math.pow(2, j - 1075) * (o + 4503599627370496);
    }
    u.readDoubleLE = a.bind(null, readUintLE, 0, 4), u.readDoubleBE = a.bind(null, readUintBE, 4, 0);
  }(), u;
}
function writeUintLE(u, t, a) {
  t[a] = u & 255, t[a + 1] = u >>> 8 & 255, t[a + 2] = u >>> 16 & 255, t[a + 3] = u >>> 24;
}
function writeUintBE(u, t, a) {
  t[a] = u >>> 24, t[a + 1] = u >>> 16 & 255, t[a + 2] = u >>> 8 & 255, t[a + 3] = u & 255;
}
function readUintLE(u, t) {
  return (u[t] | u[t + 1] << 8 | u[t + 2] << 16 | u[t + 3] << 24) >>> 0;
}
function readUintBE(u, t) {
  return (u[t] << 24 | u[t + 1] << 16 | u[t + 2] << 8 | u[t + 3]) >>> 0;
}
var inquire_1 = inquire;
function inquire(moduleName) {
  try {
    var mod = eval("quire".replace(/^/, "re"))(moduleName);
    if (mod && (mod.length || Object.keys(mod).length))
      return mod;
  } catch (u) {
  }
  return null;
}
var utf8$2 = {};
(function(u) {
  var t = u;
  t.length = function(d) {
    for (var l = 0, h = 0, g = 0; g < d.length; ++g)
      h = d.charCodeAt(g), h < 128 ? l += 1 : h < 2048 ? l += 2 : (h & 64512) === 55296 && (d.charCodeAt(g + 1) & 64512) === 56320 ? (++g, l += 4) : l += 3;
    return l;
  }, t.read = function(d, l, h) {
    var g = h - l;
    if (g < 1)
      return "";
    for (var c = null, x = [], R = 0, B; l < h; )
      B = d[l++], B < 128 ? x[R++] = B : B > 191 && B < 224 ? x[R++] = (B & 31) << 6 | d[l++] & 63 : B > 239 && B < 365 ? (B = ((B & 7) << 18 | (d[l++] & 63) << 12 | (d[l++] & 63) << 6 | d[l++] & 63) - 65536, x[R++] = 55296 + (B >> 10), x[R++] = 56320 + (B & 1023)) : x[R++] = (B & 15) << 12 | (d[l++] & 63) << 6 | d[l++] & 63, R > 8191 && ((c || (c = [])).push(String.fromCharCode.apply(String, x)), R = 0);
    return c ? (R && c.push(String.fromCharCode.apply(String, x.slice(0, R))), c.join("")) : String.fromCharCode.apply(String, x.slice(0, R));
  }, t.write = function(d, l, h) {
    for (var g = h, c, x, R = 0; R < d.length; ++R)
      c = d.charCodeAt(R), c < 128 ? l[h++] = c : c < 2048 ? (l[h++] = c >> 6 | 192, l[h++] = c & 63 | 128) : (c & 64512) === 55296 && ((x = d.charCodeAt(R + 1)) & 64512) === 56320 ? (c = 65536 + ((c & 1023) << 10) + (x & 1023), ++R, l[h++] = c >> 18 | 240, l[h++] = c >> 12 & 63 | 128, l[h++] = c >> 6 & 63 | 128, l[h++] = c & 63 | 128) : (l[h++] = c >> 12 | 224, l[h++] = c >> 6 & 63 | 128, l[h++] = c & 63 | 128);
    return h - g;
  };
})(utf8$2);
var pool_1 = pool;
function pool(u, t, a) {
  var d = a || 8192, l = d >>> 1, h = null, g = d;
  return function(x) {
    if (x < 1 || x > l)
      return u(x);
    g + x > d && (h = u(d), g = 0);
    var R = t.call(h, g, g += x);
    return g & 7 && (g = (g | 7) + 1), R;
  };
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits)
    return longbits;
  hasRequiredLongbits = 1, longbits = t;
  var u = requireMinimal();
  function t(h, g) {
    this.lo = h >>> 0, this.hi = g >>> 0;
  }
  var a = t.zero = new t(0, 0);
  a.toNumber = function() {
    return 0;
  }, a.zzEncode = a.zzDecode = function() {
    return this;
  }, a.length = function() {
    return 1;
  };
  var d = t.zeroHash = "\0\0\0\0\0\0\0\0";
  t.fromNumber = function(g) {
    if (g === 0)
      return a;
    var c = g < 0;
    c && (g = -g);
    var x = g >>> 0, R = (g - x) / 4294967296 >>> 0;
    return c && (R = ~R >>> 0, x = ~x >>> 0, ++x > 4294967295 && (x = 0, ++R > 4294967295 && (R = 0))), new t(x, R);
  }, t.from = function(g) {
    if (typeof g == "number")
      return t.fromNumber(g);
    if (u.isString(g))
      if (u.Long)
        g = u.Long.fromString(g);
      else
        return t.fromNumber(parseInt(g, 10));
    return g.low || g.high ? new t(g.low >>> 0, g.high >>> 0) : a;
  }, t.prototype.toNumber = function(g) {
    if (!g && this.hi >>> 31) {
      var c = ~this.lo + 1 >>> 0, x = ~this.hi >>> 0;
      return c || (x = x + 1 >>> 0), -(c + x * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, t.prototype.toLong = function(g) {
    return u.Long ? new u.Long(this.lo | 0, this.hi | 0, Boolean(g)) : { low: this.lo | 0, high: this.hi | 0, unsigned: Boolean(g) };
  };
  var l = String.prototype.charCodeAt;
  return t.fromHash = function(g) {
    return g === d ? a : new t(
      (l.call(g, 0) | l.call(g, 1) << 8 | l.call(g, 2) << 16 | l.call(g, 3) << 24) >>> 0,
      (l.call(g, 4) | l.call(g, 5) << 8 | l.call(g, 6) << 16 | l.call(g, 7) << 24) >>> 0
    );
  }, t.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, t.prototype.zzEncode = function() {
    var g = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ g) >>> 0, this.lo = (this.lo << 1 ^ g) >>> 0, this;
  }, t.prototype.zzDecode = function() {
    var g = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ g) >>> 0, this.hi = (this.hi >>> 1 ^ g) >>> 0, this;
  }, t.prototype.length = function() {
    var g = this.lo, c = (this.lo >>> 28 | this.hi << 4) >>> 0, x = this.hi >>> 24;
    return x === 0 ? c === 0 ? g < 16384 ? g < 128 ? 1 : 2 : g < 2097152 ? 3 : 4 : c < 16384 ? c < 128 ? 5 : 6 : c < 2097152 ? 7 : 8 : x < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, function(u) {
    var t = u;
    t.asPromise = aspromise, t.base64 = base64$1, t.EventEmitter = eventemitter, t.float = float, t.inquire = inquire_1, t.utf8 = utf8$2, t.pool = pool_1, t.LongBits = requireLongbits(), t.isNode = Boolean(typeof commonjsGlobal < "u" && commonjsGlobal && commonjsGlobal.process && commonjsGlobal.process.versions && commonjsGlobal.process.versions.node), t.global = t.isNode && commonjsGlobal || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal, t.emptyArray = Object.freeze ? Object.freeze([]) : [], t.emptyObject = Object.freeze ? Object.freeze({}) : {}, t.isInteger = Number.isInteger || function(h) {
      return typeof h == "number" && isFinite(h) && Math.floor(h) === h;
    }, t.isString = function(h) {
      return typeof h == "string" || h instanceof String;
    }, t.isObject = function(h) {
      return h && typeof h == "object";
    }, t.isset = t.isSet = function(h, g) {
      var c = h[g];
      return c != null && h.hasOwnProperty(g) ? typeof c != "object" || (Array.isArray(c) ? c.length : Object.keys(c).length) > 0 : !1;
    }, t.Buffer = function() {
      try {
        var l = t.inquire("buffer").Buffer;
        return l.prototype.utf8Write ? l : null;
      } catch {
        return null;
      }
    }(), t._Buffer_from = null, t._Buffer_allocUnsafe = null, t.newBuffer = function(h) {
      return typeof h == "number" ? t.Buffer ? t._Buffer_allocUnsafe(h) : new t.Array(h) : t.Buffer ? t._Buffer_from(h) : typeof Uint8Array > "u" ? h : new Uint8Array(h);
    }, t.Array = typeof Uint8Array < "u" ? Uint8Array : Array, t.Long = t.global.dcodeIO && t.global.dcodeIO.Long || t.global.Long || t.inquire("long"), t.key2Re = /^true|false|0|1$/, t.key32Re = /^-?(?:0|[1-9][0-9]*)$/, t.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, t.longToHash = function(h) {
      return h ? t.LongBits.from(h).toHash() : t.LongBits.zeroHash;
    }, t.longFromHash = function(h, g) {
      var c = t.LongBits.fromHash(h);
      return t.Long ? t.Long.fromBits(c.lo, c.hi, g) : c.toNumber(Boolean(g));
    };
    function a(l, h, g) {
      for (var c = Object.keys(h), x = 0; x < c.length; ++x)
        (l[c[x]] === void 0 || !g) && (l[c[x]] = h[c[x]]);
      return l;
    }
    t.merge = a, t.lcFirst = function(h) {
      return h.charAt(0).toLowerCase() + h.substring(1);
    };
    function d(l) {
      function h(g, c) {
        if (!(this instanceof h))
          return new h(g, c);
        Object.defineProperty(this, "message", { get: function() {
          return g;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, h) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), c && a(this, c);
      }
      return h.prototype = Object.create(Error.prototype, {
        constructor: {
          value: h,
          writable: !0,
          enumerable: !1,
          configurable: !0
        },
        name: {
          get: function() {
            return l;
          },
          set: void 0,
          enumerable: !1,
          configurable: !0
        },
        toString: {
          value: function() {
            return this.name + ": " + this.message;
          },
          writable: !0,
          enumerable: !1,
          configurable: !0
        }
      }), h;
    }
    t.newError = d, t.ProtocolError = d("ProtocolError"), t.oneOfGetter = function(h) {
      for (var g = {}, c = 0; c < h.length; ++c)
        g[h[c]] = 1;
      return function() {
        for (var x = Object.keys(this), R = x.length - 1; R > -1; --R)
          if (g[x[R]] === 1 && this[x[R]] !== void 0 && this[x[R]] !== null)
            return x[R];
      };
    }, t.oneOfSetter = function(h) {
      return function(g) {
        for (var c = 0; c < h.length; ++c)
          h[c] !== g && delete this[h[c]];
      };
    }, t.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, t._configure = function() {
      var l = t.Buffer;
      if (!l) {
        t._Buffer_from = t._Buffer_allocUnsafe = null;
        return;
      }
      t._Buffer_from = l.from !== Uint8Array.from && l.from || function(g, c) {
        return new l(g, c);
      }, t._Buffer_allocUnsafe = l.allocUnsafe || function(g) {
        return new l(g);
      };
    };
  }(minimal)), minimal;
}
var writer = Writer$2, util$4 = requireMinimal(), BufferWriter$1, LongBits$1 = util$4.LongBits, base64 = util$4.base64, utf8$1 = util$4.utf8;
function Op(u, t, a) {
  this.fn = u, this.len = t, this.next = void 0, this.val = a;
}
function noop() {
}
function State(u) {
  this.head = u.head, this.tail = u.tail, this.len = u.len, this.next = u.states;
}
function Writer$2() {
  this.len = 0, this.head = new Op(noop, 0, 0), this.tail = this.head, this.states = null;
}
var create$1 = function u() {
  return util$4.Buffer ? function() {
    return (Writer$2.create = function() {
      return new BufferWriter$1();
    })();
  } : function() {
    return new Writer$2();
  };
};
Writer$2.create = create$1();
Writer$2.alloc = function u(t) {
  return new util$4.Array(t);
};
util$4.Array !== Array && (Writer$2.alloc = util$4.pool(Writer$2.alloc, util$4.Array.prototype.subarray));
Writer$2.prototype._push = function u(t, a, d) {
  return this.tail = this.tail.next = new Op(t, a, d), this.len += a, this;
};
function writeByte(u, t, a) {
  t[a] = u & 255;
}
function writeVarint32(u, t, a) {
  for (; u > 127; )
    t[a++] = u & 127 | 128, u >>>= 7;
  t[a] = u;
}
function VarintOp(u, t) {
  this.len = u, this.next = void 0, this.val = t;
}
VarintOp.prototype = Object.create(Op.prototype);
VarintOp.prototype.fn = writeVarint32;
Writer$2.prototype.uint32 = function u(t) {
  return this.len += (this.tail = this.tail.next = new VarintOp(
    (t = t >>> 0) < 128 ? 1 : t < 16384 ? 2 : t < 2097152 ? 3 : t < 268435456 ? 4 : 5,
    t
  )).len, this;
};
Writer$2.prototype.int32 = function u(t) {
  return t < 0 ? this._push(writeVarint64, 10, LongBits$1.fromNumber(t)) : this.uint32(t);
};
Writer$2.prototype.sint32 = function u(t) {
  return this.uint32((t << 1 ^ t >> 31) >>> 0);
};
function writeVarint64(u, t, a) {
  for (; u.hi; )
    t[a++] = u.lo & 127 | 128, u.lo = (u.lo >>> 7 | u.hi << 25) >>> 0, u.hi >>>= 7;
  for (; u.lo > 127; )
    t[a++] = u.lo & 127 | 128, u.lo = u.lo >>> 7;
  t[a++] = u.lo;
}
Writer$2.prototype.uint64 = function u(t) {
  var a = LongBits$1.from(t);
  return this._push(writeVarint64, a.length(), a);
};
Writer$2.prototype.int64 = Writer$2.prototype.uint64;
Writer$2.prototype.sint64 = function u(t) {
  var a = LongBits$1.from(t).zzEncode();
  return this._push(writeVarint64, a.length(), a);
};
Writer$2.prototype.bool = function u(t) {
  return this._push(writeByte, 1, t ? 1 : 0);
};
function writeFixed32(u, t, a) {
  t[a] = u & 255, t[a + 1] = u >>> 8 & 255, t[a + 2] = u >>> 16 & 255, t[a + 3] = u >>> 24;
}
Writer$2.prototype.fixed32 = function u(t) {
  return this._push(writeFixed32, 4, t >>> 0);
};
Writer$2.prototype.sfixed32 = Writer$2.prototype.fixed32;
Writer$2.prototype.fixed64 = function u(t) {
  var a = LongBits$1.from(t);
  return this._push(writeFixed32, 4, a.lo)._push(writeFixed32, 4, a.hi);
};
Writer$2.prototype.sfixed64 = Writer$2.prototype.fixed64;
Writer$2.prototype.float = function u(t) {
  return this._push(util$4.float.writeFloatLE, 4, t);
};
Writer$2.prototype.double = function u(t) {
  return this._push(util$4.float.writeDoubleLE, 8, t);
};
var writeBytes = util$4.Array.prototype.set ? function u(t, a, d) {
  a.set(t, d);
} : function u(t, a, d) {
  for (var l = 0; l < t.length; ++l)
    a[d + l] = t[l];
};
Writer$2.prototype.bytes = function u(t) {
  var a = t.length >>> 0;
  if (!a)
    return this._push(writeByte, 1, 0);
  if (util$4.isString(t)) {
    var d = Writer$2.alloc(a = base64.length(t));
    base64.decode(t, d, 0), t = d;
  }
  return this.uint32(a)._push(writeBytes, a, t);
};
Writer$2.prototype.string = function u(t) {
  var a = utf8$1.length(t);
  return a ? this.uint32(a)._push(utf8$1.write, a, t) : this._push(writeByte, 1, 0);
};
Writer$2.prototype.fork = function u() {
  return this.states = new State(this), this.head = this.tail = new Op(noop, 0, 0), this.len = 0, this;
};
Writer$2.prototype.reset = function u() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op(noop, 0, 0), this.len = 0), this;
};
Writer$2.prototype.ldelim = function u() {
  var t = this.head, a = this.tail, d = this.len;
  return this.reset().uint32(d), d && (this.tail.next = t.next, this.tail = a, this.len += d), this;
};
Writer$2.prototype.finish = function u() {
  for (var t = this.head.next, a = this.constructor.alloc(this.len), d = 0; t; )
    t.fn(t.val, a, d), d += t.len, t = t.next;
  return a;
};
Writer$2._configure = function(u) {
  BufferWriter$1 = u, Writer$2.create = create$1(), BufferWriter$1._configure();
};
var writer_buffer = BufferWriter, Writer$1 = writer;
(BufferWriter.prototype = Object.create(Writer$1.prototype)).constructor = BufferWriter;
var util$3 = requireMinimal();
function BufferWriter() {
  Writer$1.call(this);
}
BufferWriter._configure = function() {
  BufferWriter.alloc = util$3._Buffer_allocUnsafe, BufferWriter.writeBytesBuffer = util$3.Buffer && util$3.Buffer.prototype instanceof Uint8Array && util$3.Buffer.prototype.set.name === "set" ? function(t, a, d) {
    a.set(t, d);
  } : function(t, a, d) {
    if (t.copy)
      t.copy(a, d, 0, t.length);
    else
      for (var l = 0; l < t.length; )
        a[d++] = t[l++];
  };
};
BufferWriter.prototype.bytes = function u(t) {
  util$3.isString(t) && (t = util$3._Buffer_from(t, "base64"));
  var a = t.length >>> 0;
  return this.uint32(a), a && this._push(BufferWriter.writeBytesBuffer, a, t), this;
};
function writeStringBuffer(u, t, a) {
  u.length < 40 ? util$3.utf8.write(u, t, a) : t.utf8Write ? t.utf8Write(u, a) : t.write(u, a);
}
BufferWriter.prototype.string = function u(t) {
  var a = util$3.Buffer.byteLength(t);
  return this.uint32(a), a && this._push(writeStringBuffer, a, t), this;
};
BufferWriter._configure();
var reader = Reader$2, util$2 = requireMinimal(), BufferReader$1, LongBits = util$2.LongBits, utf8 = util$2.utf8;
function indexOutOfRange(u, t) {
  return RangeError("index out of range: " + u.pos + " + " + (t || 1) + " > " + u.len);
}
function Reader$2(u) {
  this.buf = u, this.pos = 0, this.len = u.length;
}
var create_array = typeof Uint8Array < "u" ? function u(t) {
  if (t instanceof Uint8Array || Array.isArray(t))
    return new Reader$2(t);
  throw Error("illegal buffer");
} : function u(t) {
  if (Array.isArray(t))
    return new Reader$2(t);
  throw Error("illegal buffer");
}, create = function u() {
  return util$2.Buffer ? function(a) {
    return (Reader$2.create = function(l) {
      return util$2.Buffer.isBuffer(l) ? new BufferReader$1(l) : create_array(l);
    })(a);
  } : create_array;
};
Reader$2.create = create();
Reader$2.prototype._slice = util$2.Array.prototype.subarray || util$2.Array.prototype.slice;
Reader$2.prototype.uint32 = function u() {
  var t = 4294967295;
  return function() {
    if (t = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (t = (t | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (t = (t | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (t = (t | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (t = (t | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
      return t;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange(this, 10);
    return t;
  };
}();
Reader$2.prototype.int32 = function u() {
  return this.uint32() | 0;
};
Reader$2.prototype.sint32 = function u() {
  var t = this.uint32();
  return t >>> 1 ^ -(t & 1) | 0;
};
function readLongVarint() {
  var u = new LongBits(0, 0), t = 0;
  if (this.len - this.pos > 4) {
    for (; t < 4; ++t)
      if (u.lo = (u.lo | (this.buf[this.pos] & 127) << t * 7) >>> 0, this.buf[this.pos++] < 128)
        return u;
    if (u.lo = (u.lo | (this.buf[this.pos] & 127) << 28) >>> 0, u.hi = (u.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return u;
    t = 0;
  } else {
    for (; t < 3; ++t) {
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
      if (u.lo = (u.lo | (this.buf[this.pos] & 127) << t * 7) >>> 0, this.buf[this.pos++] < 128)
        return u;
    }
    return u.lo = (u.lo | (this.buf[this.pos++] & 127) << t * 7) >>> 0, u;
  }
  if (this.len - this.pos > 4) {
    for (; t < 5; ++t)
      if (u.hi = (u.hi | (this.buf[this.pos] & 127) << t * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return u;
  } else
    for (; t < 5; ++t) {
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
      if (u.hi = (u.hi | (this.buf[this.pos] & 127) << t * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return u;
    }
  throw Error("invalid varint encoding");
}
Reader$2.prototype.bool = function u() {
  return this.uint32() !== 0;
};
function readFixed32_end(u, t) {
  return (u[t - 4] | u[t - 3] << 8 | u[t - 2] << 16 | u[t - 1] << 24) >>> 0;
}
Reader$2.prototype.fixed32 = function u() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  return readFixed32_end(this.buf, this.pos += 4);
};
Reader$2.prototype.sfixed32 = function u() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  return readFixed32_end(this.buf, this.pos += 4) | 0;
};
function readFixed64() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange(this, 8);
  return new LongBits(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
}
Reader$2.prototype.float = function u() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  var t = util$2.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, t;
};
Reader$2.prototype.double = function u() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange(this, 4);
  var t = util$2.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, t;
};
Reader$2.prototype.bytes = function u() {
  var t = this.uint32(), a = this.pos, d = this.pos + t;
  if (d > this.len)
    throw indexOutOfRange(this, t);
  return this.pos += t, Array.isArray(this.buf) ? this.buf.slice(a, d) : a === d ? new this.buf.constructor(0) : this._slice.call(this.buf, a, d);
};
Reader$2.prototype.string = function u() {
  var t = this.bytes();
  return utf8.read(t, 0, t.length);
};
Reader$2.prototype.skip = function u(t) {
  if (typeof t == "number") {
    if (this.pos + t > this.len)
      throw indexOutOfRange(this, t);
    this.pos += t;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$2.prototype.skipType = function(u) {
  switch (u) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (u = this.uint32() & 7) !== 4; )
        this.skipType(u);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + u + " at offset " + this.pos);
  }
  return this;
};
Reader$2._configure = function(u) {
  BufferReader$1 = u, Reader$2.create = create(), BufferReader$1._configure();
  var t = util$2.Long ? "toLong" : "toNumber";
  util$2.merge(Reader$2.prototype, {
    int64: function() {
      return readLongVarint.call(this)[t](!1);
    },
    uint64: function() {
      return readLongVarint.call(this)[t](!0);
    },
    sint64: function() {
      return readLongVarint.call(this).zzDecode()[t](!1);
    },
    fixed64: function() {
      return readFixed64.call(this)[t](!0);
    },
    sfixed64: function() {
      return readFixed64.call(this)[t](!1);
    }
  });
};
var reader_buffer = BufferReader, Reader$1 = reader;
(BufferReader.prototype = Object.create(Reader$1.prototype)).constructor = BufferReader;
var util$1 = requireMinimal();
function BufferReader(u) {
  Reader$1.call(this, u);
}
BufferReader._configure = function() {
  util$1.Buffer && (BufferReader.prototype._slice = util$1.Buffer.prototype.slice);
};
BufferReader.prototype.string = function u() {
  var t = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + t, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + t, this.len));
};
BufferReader._configure();
var rpc = {}, service = Service, util = requireMinimal();
(Service.prototype = Object.create(util.EventEmitter.prototype)).constructor = Service;
function Service(u, t, a) {
  if (typeof u != "function")
    throw TypeError("rpcImpl must be a function");
  util.EventEmitter.call(this), this.rpcImpl = u, this.requestDelimited = Boolean(t), this.responseDelimited = Boolean(a);
}
Service.prototype.rpcCall = function u(t, a, d, l, h) {
  if (!l)
    throw TypeError("request must be specified");
  var g = this;
  if (!h)
    return util.asPromise(u, g, t, a, d, l);
  if (!g.rpcImpl) {
    setTimeout(function() {
      h(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return g.rpcImpl(
      t,
      a[g.requestDelimited ? "encodeDelimited" : "encode"](l).finish(),
      function(x, R) {
        if (x)
          return g.emit("error", x, t), h(x);
        if (R === null) {
          g.end(!0);
          return;
        }
        if (!(R instanceof d))
          try {
            R = d[g.responseDelimited ? "decodeDelimited" : "decode"](R);
          } catch (B) {
            return g.emit("error", B, t), h(B);
          }
        return g.emit("data", R, t), h(null, R);
      }
    );
  } catch (c) {
    g.emit("error", c, t), setTimeout(function() {
      h(c);
    }, 0);
    return;
  }
};
Service.prototype.end = function u(t) {
  return this.rpcImpl && (t || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(u) {
  var t = u;
  t.Service = service;
})(rpc);
var roots = {};
(function(u) {
  var t = u;
  t.build = "minimal", t.Writer = writer, t.BufferWriter = writer_buffer, t.Reader = reader, t.BufferReader = reader_buffer, t.util = requireMinimal(), t.rpc = rpc, t.roots = roots, t.configure = a;
  function a() {
    t.util._configure(), t.Writer._configure(t.BufferWriter), t.Reader._configure(t.BufferReader);
  }
  a();
})(indexMinimal);
(function(u) {
  u.exports = indexMinimal;
})(minimal$1);
var proto$5 = {};
(function(u) {
  var t = d(minimal$1.exports);
  Object.defineProperty(u, "__esModule", { value: !0 }), u.proto = u.google = u.default = u.com = void 0;
  function a(j) {
    if (typeof WeakMap != "function")
      return null;
    var o = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap();
    return (a = function(n) {
      return n ? e : o;
    })(j);
  }
  function d(j, o) {
    if (!o && j && j.__esModule)
      return j;
    if (j === null || typeof j != "object" && typeof j != "function")
      return { default: j };
    var e = a(o);
    if (e && e.has(j))
      return e.get(j);
    var n = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var y in j)
      if (y != "default" && Object.prototype.hasOwnProperty.call(j, y)) {
        var m = i ? Object.getOwnPropertyDescriptor(j, y) : null;
        m && (m.get || m.set) ? Object.defineProperty(n, y, m) : n[y] = j[y];
      }
    return n.default = j, e && e.set(j, n), n;
  }
  const l = t.Reader, h = t.Writer, g = t.util, c = t.roots.hashgraph || (t.roots.hashgraph = {});
  u.default = c;
  const x = c.com = (() => ({ hedera: function() {
    return { mirror: function() {
      return { api: function() {
        return { proto: function() {
          return { ConsensusTopicQuery: function() {
            function y(m) {
              if (m)
                for (var U = Object.keys(m), be = 0; be < U.length; ++be)
                  m[U[be]] != null && (this[U[be]] = m[U[be]]);
            }
            return y.prototype.topicID = null, y.prototype.consensusStartTime = null, y.prototype.consensusEndTime = null, y.prototype.limit = g.Long ? g.Long.fromBits(0, 0, !0) : 0, y.create = function(m) {
              return new y(m);
            }, y.encode = function(m, U) {
              return U || (U = h.create()), m.topicID != null && Object.hasOwnProperty.call(m, "topicID") && c.proto.TopicID.encode(m.topicID, U.uint32(10).fork()).ldelim(), m.consensusStartTime != null && Object.hasOwnProperty.call(m, "consensusStartTime") && c.proto.Timestamp.encode(m.consensusStartTime, U.uint32(18).fork()).ldelim(), m.consensusEndTime != null && Object.hasOwnProperty.call(m, "consensusEndTime") && c.proto.Timestamp.encode(m.consensusEndTime, U.uint32(26).fork()).ldelim(), m.limit != null && Object.hasOwnProperty.call(m, "limit") && U.uint32(32).uint64(m.limit), U;
            }, y.decode = function(m, U) {
              m instanceof l || (m = l.create(m));
              for (var be = U === void 0 ? m.len : m.pos + U, Ke = new c.com.hedera.mirror.api.proto.ConsensusTopicQuery(), ze; m.pos < be; )
                switch (ze = m.uint32(), ze >>> 3) {
                  case 1: {
                    Ke.topicID = c.proto.TopicID.decode(m, m.uint32());
                    break;
                  }
                  case 2: {
                    Ke.consensusStartTime = c.proto.Timestamp.decode(m, m.uint32());
                    break;
                  }
                  case 3: {
                    Ke.consensusEndTime = c.proto.Timestamp.decode(m, m.uint32());
                    break;
                  }
                  case 4: {
                    Ke.limit = m.uint64();
                    break;
                  }
                  default:
                    m.skipType(7 & ze);
                }
              return Ke;
            }, y.getTypeUrl = function(m) {
              return m === void 0 && (m = "type.googleapis.com"), m + "/com.hedera.mirror.api.proto.ConsensusTopicQuery";
            }, y;
          }(), ConsensusTopicResponse: function() {
            function y(m) {
              if (m)
                for (var U = Object.keys(m), be = 0; be < U.length; ++be)
                  m[U[be]] != null && (this[U[be]] = m[U[be]]);
            }
            return y.prototype.consensusTimestamp = null, y.prototype.message = g.newBuffer([]), y.prototype.runningHash = g.newBuffer([]), y.prototype.sequenceNumber = g.Long ? g.Long.fromBits(0, 0, !0) : 0, y.prototype.runningHashVersion = g.Long ? g.Long.fromBits(0, 0, !0) : 0, y.prototype.chunkInfo = null, y.create = function(m) {
              return new y(m);
            }, y.encode = function(m, U) {
              return U || (U = h.create()), m.consensusTimestamp != null && Object.hasOwnProperty.call(m, "consensusTimestamp") && c.proto.Timestamp.encode(m.consensusTimestamp, U.uint32(10).fork()).ldelim(), m.message != null && Object.hasOwnProperty.call(m, "message") && U.uint32(18).bytes(m.message), m.runningHash != null && Object.hasOwnProperty.call(m, "runningHash") && U.uint32(26).bytes(m.runningHash), m.sequenceNumber != null && Object.hasOwnProperty.call(m, "sequenceNumber") && U.uint32(32).uint64(m.sequenceNumber), m.runningHashVersion != null && Object.hasOwnProperty.call(m, "runningHashVersion") && U.uint32(40).uint64(m.runningHashVersion), m.chunkInfo != null && Object.hasOwnProperty.call(m, "chunkInfo") && c.proto.ConsensusMessageChunkInfo.encode(m.chunkInfo, U.uint32(50).fork()).ldelim(), U;
            }, y.decode = function(m, U) {
              m instanceof l || (m = l.create(m));
              for (var be = U === void 0 ? m.len : m.pos + U, Ke = new c.com.hedera.mirror.api.proto.ConsensusTopicResponse(), ze; m.pos < be; )
                switch (ze = m.uint32(), ze >>> 3) {
                  case 1: {
                    Ke.consensusTimestamp = c.proto.Timestamp.decode(m, m.uint32());
                    break;
                  }
                  case 2: {
                    Ke.message = m.bytes();
                    break;
                  }
                  case 3: {
                    Ke.runningHash = m.bytes();
                    break;
                  }
                  case 4: {
                    Ke.sequenceNumber = m.uint64();
                    break;
                  }
                  case 5: {
                    Ke.runningHashVersion = m.uint64();
                    break;
                  }
                  case 6: {
                    Ke.chunkInfo = c.proto.ConsensusMessageChunkInfo.decode(m, m.uint32());
                    break;
                  }
                  default:
                    m.skipType(7 & ze);
                }
              return Ke;
            }, y.getTypeUrl = function(m) {
              return m === void 0 && (m = "type.googleapis.com"), m + "/com.hedera.mirror.api.proto.ConsensusTopicResponse";
            }, y;
          }(), ConsensusService: function() {
            function y(m, U, be) {
              t.rpc.Service.call(this, m, U, be);
            }
            return (y.prototype = Object.create(t.rpc.Service.prototype)).constructor = y, y.create = function(m, U, be) {
              return new this(m, U, be);
            }, Object.defineProperty(y.prototype.subscribeTopic = function m(U, be) {
              return this.rpcCall(m, c.com.hedera.mirror.api.proto.ConsensusTopicQuery, c.com.hedera.mirror.api.proto.ConsensusTopicResponse, U, be);
            }, "name", { value: "subscribeTopic" }), y;
          }(), AddressBookQuery: function() {
            function y(m) {
              if (m)
                for (var U = Object.keys(m), be = 0; be < U.length; ++be)
                  m[U[be]] != null && (this[U[be]] = m[U[be]]);
            }
            return y.prototype.fileId = null, y.prototype.limit = 0, y.create = function(m) {
              return new y(m);
            }, y.encode = function(m, U) {
              return U || (U = h.create()), m.fileId != null && Object.hasOwnProperty.call(m, "fileId") && c.proto.FileID.encode(m.fileId, U.uint32(10).fork()).ldelim(), m.limit != null && Object.hasOwnProperty.call(m, "limit") && U.uint32(16).int32(m.limit), U;
            }, y.decode = function(m, U) {
              m instanceof l || (m = l.create(m));
              for (var be = U === void 0 ? m.len : m.pos + U, Ke = new c.com.hedera.mirror.api.proto.AddressBookQuery(), ze; m.pos < be; )
                switch (ze = m.uint32(), ze >>> 3) {
                  case 1: {
                    Ke.fileId = c.proto.FileID.decode(m, m.uint32());
                    break;
                  }
                  case 2: {
                    Ke.limit = m.int32();
                    break;
                  }
                  default:
                    m.skipType(7 & ze);
                }
              return Ke;
            }, y.getTypeUrl = function(m) {
              return m === void 0 && (m = "type.googleapis.com"), m + "/com.hedera.mirror.api.proto.AddressBookQuery";
            }, y;
          }(), NetworkService: function() {
            function y(m, U, be) {
              t.rpc.Service.call(this, m, U, be);
            }
            return (y.prototype = Object.create(t.rpc.Service.prototype)).constructor = y, y.create = function(m, U, be) {
              return new this(m, U, be);
            }, Object.defineProperty(y.prototype.getNodes = function m(U, be) {
              return this.rpcCall(m, c.com.hedera.mirror.api.proto.AddressBookQuery, c.proto.NodeAddress, U, be);
            }, "name", { value: "getNodes" }), y;
          }() };
        }() };
      }() };
    }() };
  }() }))();
  u.com = x;
  const R = c.proto = (() => ({ TransactionList: function() {
    function o(e) {
      if (this.transactionList = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.transactionList = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.transactionList != null && e.transactionList.length)
        for (var i = 0; i < e.transactionList.length; ++i)
          c.proto.Transaction.encode(e.transactionList[i], n.uint32(10).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TransactionList(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.transactionList && y.transactionList.length || (y.transactionList = []), y.transactionList.push(c.proto.Transaction.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TransactionList";
    }, o;
  }(), ShardID: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.shardNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.shardNum != null && Object.hasOwnProperty.call(e, "shardNum") && n.uint32(8).int64(e.shardNum), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ShardID(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.shardNum = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ShardID";
    }, o;
  }(), RealmID: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.shardNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.realmNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.shardNum != null && Object.hasOwnProperty.call(e, "shardNum") && n.uint32(8).int64(e.shardNum), e.realmNum != null && Object.hasOwnProperty.call(e, "realmNum") && n.uint32(16).int64(e.realmNum), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.RealmID(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.shardNum = e.int64();
            break;
          }
          case 2: {
            y.realmNum = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.RealmID";
    }, o;
  }(), AccountID: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.shardNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.realmNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.accountNum = null, o.prototype.alias = null;
    let e;
    return Object.defineProperty(o.prototype, "account", { get: g.oneOfGetter(e = ["accountNum", "alias"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.shardNum != null && Object.hasOwnProperty.call(n, "shardNum") && i.uint32(8).int64(n.shardNum), n.realmNum != null && Object.hasOwnProperty.call(n, "realmNum") && i.uint32(16).int64(n.realmNum), n.accountNum != null && Object.hasOwnProperty.call(n, "accountNum") && i.uint32(24).int64(n.accountNum), n.alias != null && Object.hasOwnProperty.call(n, "alias") && i.uint32(34).bytes(n.alias), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.AccountID(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.shardNum = n.int64();
            break;
          }
          case 2: {
            m.realmNum = n.int64();
            break;
          }
          case 3: {
            m.accountNum = n.int64();
            break;
          }
          case 4: {
            m.alias = n.bytes();
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.AccountID";
    }, o;
  }(), FileID: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.shardNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.realmNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.fileNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.shardNum != null && Object.hasOwnProperty.call(e, "shardNum") && n.uint32(8).int64(e.shardNum), e.realmNum != null && Object.hasOwnProperty.call(e, "realmNum") && n.uint32(16).int64(e.realmNum), e.fileNum != null && Object.hasOwnProperty.call(e, "fileNum") && n.uint32(24).int64(e.fileNum), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FileID(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.shardNum = e.int64();
            break;
          }
          case 2: {
            y.realmNum = e.int64();
            break;
          }
          case 3: {
            y.fileNum = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FileID";
    }, o;
  }(), ContractID: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.shardNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.realmNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.contractNum = null, o.prototype.evmAddress = null;
    let e;
    return Object.defineProperty(o.prototype, "contract", { get: g.oneOfGetter(e = ["contractNum", "evmAddress"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.shardNum != null && Object.hasOwnProperty.call(n, "shardNum") && i.uint32(8).int64(n.shardNum), n.realmNum != null && Object.hasOwnProperty.call(n, "realmNum") && i.uint32(16).int64(n.realmNum), n.contractNum != null && Object.hasOwnProperty.call(n, "contractNum") && i.uint32(24).int64(n.contractNum), n.evmAddress != null && Object.hasOwnProperty.call(n, "evmAddress") && i.uint32(34).bytes(n.evmAddress), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.ContractID(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.shardNum = n.int64();
            break;
          }
          case 2: {
            m.realmNum = n.int64();
            break;
          }
          case 3: {
            m.contractNum = n.int64();
            break;
          }
          case 4: {
            m.evmAddress = n.bytes();
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.ContractID";
    }, o;
  }(), TransactionID: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.transactionValidStart = null, o.prototype.accountID = null, o.prototype.scheduled = !1, o.prototype.nonce = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.transactionValidStart != null && Object.hasOwnProperty.call(e, "transactionValidStart") && c.proto.Timestamp.encode(e.transactionValidStart, n.uint32(10).fork()).ldelim(), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(18).fork()).ldelim(), e.scheduled != null && Object.hasOwnProperty.call(e, "scheduled") && n.uint32(24).bool(e.scheduled), e.nonce != null && Object.hasOwnProperty.call(e, "nonce") && n.uint32(32).int32(e.nonce), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TransactionID(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.transactionValidStart = c.proto.Timestamp.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.scheduled = e.bool();
            break;
          }
          case 4: {
            y.nonce = e.int32();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TransactionID";
    }, o;
  }(), AccountAmount: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.accountID = null, o.prototype.amount = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.isApproval = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(10).fork()).ldelim(), e.amount != null && Object.hasOwnProperty.call(e, "amount") && n.uint32(16).sint64(e.amount), e.isApproval != null && Object.hasOwnProperty.call(e, "isApproval") && n.uint32(24).bool(e.isApproval), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.AccountAmount(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.amount = e.sint64();
            break;
          }
          case 3: {
            y.isApproval = e.bool();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.AccountAmount";
    }, o;
  }(), TransferList: function() {
    function o(e) {
      if (this.accountAmounts = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.accountAmounts = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.accountAmounts != null && e.accountAmounts.length)
        for (var i = 0; i < e.accountAmounts.length; ++i)
          c.proto.AccountAmount.encode(e.accountAmounts[i], n.uint32(10).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TransferList(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.accountAmounts && y.accountAmounts.length || (y.accountAmounts = []), y.accountAmounts.push(c.proto.AccountAmount.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TransferList";
    }, o;
  }(), NftTransfer: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.senderAccountID = null, o.prototype.receiverAccountID = null, o.prototype.serialNumber = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.isApproval = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.senderAccountID != null && Object.hasOwnProperty.call(e, "senderAccountID") && c.proto.AccountID.encode(e.senderAccountID, n.uint32(10).fork()).ldelim(), e.receiverAccountID != null && Object.hasOwnProperty.call(e, "receiverAccountID") && c.proto.AccountID.encode(e.receiverAccountID, n.uint32(18).fork()).ldelim(), e.serialNumber != null && Object.hasOwnProperty.call(e, "serialNumber") && n.uint32(24).int64(e.serialNumber), e.isApproval != null && Object.hasOwnProperty.call(e, "isApproval") && n.uint32(32).bool(e.isApproval), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.NftTransfer(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.senderAccountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.receiverAccountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.serialNumber = e.int64();
            break;
          }
          case 4: {
            y.isApproval = e.bool();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.NftTransfer";
    }, o;
  }(), TokenTransferList: function() {
    function o(e) {
      if (this.transfers = [], this.nftTransfers = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.token = null, o.prototype.transfers = g.emptyArray, o.prototype.nftTransfers = g.emptyArray, o.prototype.expectedDecimals = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && c.proto.TokenID.encode(e.token, n.uint32(10).fork()).ldelim(), e.transfers != null && e.transfers.length)
        for (var i = 0; i < e.transfers.length; ++i)
          c.proto.AccountAmount.encode(e.transfers[i], n.uint32(18).fork()).ldelim();
      if (e.nftTransfers != null && e.nftTransfers.length)
        for (var i = 0; i < e.nftTransfers.length; ++i)
          c.proto.NftTransfer.encode(e.nftTransfers[i], n.uint32(26).fork()).ldelim();
      return e.expectedDecimals != null && Object.hasOwnProperty.call(e, "expectedDecimals") && c.google.protobuf.UInt32Value.encode(e.expectedDecimals, n.uint32(34).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenTransferList(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.token = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.transfers && y.transfers.length || (y.transfers = []), y.transfers.push(c.proto.AccountAmount.decode(e, e.uint32()));
            break;
          }
          case 3: {
            y.nftTransfers && y.nftTransfers.length || (y.nftTransfers = []), y.nftTransfers.push(c.proto.NftTransfer.decode(e, e.uint32()));
            break;
          }
          case 4: {
            y.expectedDecimals = c.google.protobuf.UInt32Value.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenTransferList";
    }, o;
  }(), Fraction: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.numerator = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.denominator = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.numerator != null && Object.hasOwnProperty.call(e, "numerator") && n.uint32(8).int64(e.numerator), e.denominator != null && Object.hasOwnProperty.call(e, "denominator") && n.uint32(16).int64(e.denominator), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.Fraction(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.numerator = e.int64();
            break;
          }
          case 2: {
            y.denominator = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.Fraction";
    }, o;
  }(), TopicID: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.shardNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.realmNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.topicNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.shardNum != null && Object.hasOwnProperty.call(e, "shardNum") && n.uint32(8).int64(e.shardNum), e.realmNum != null && Object.hasOwnProperty.call(e, "realmNum") && n.uint32(16).int64(e.realmNum), e.topicNum != null && Object.hasOwnProperty.call(e, "topicNum") && n.uint32(24).int64(e.topicNum), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TopicID(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.shardNum = e.int64();
            break;
          }
          case 2: {
            y.realmNum = e.int64();
            break;
          }
          case 3: {
            y.topicNum = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TopicID";
    }, o;
  }(), TokenID: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.shardNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.realmNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.tokenNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.shardNum != null && Object.hasOwnProperty.call(e, "shardNum") && n.uint32(8).int64(e.shardNum), e.realmNum != null && Object.hasOwnProperty.call(e, "realmNum") && n.uint32(16).int64(e.realmNum), e.tokenNum != null && Object.hasOwnProperty.call(e, "tokenNum") && n.uint32(24).int64(e.tokenNum), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenID(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.shardNum = e.int64();
            break;
          }
          case 2: {
            y.realmNum = e.int64();
            break;
          }
          case 3: {
            y.tokenNum = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenID";
    }, o;
  }(), ScheduleID: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.shardNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.realmNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.scheduleNum = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.shardNum != null && Object.hasOwnProperty.call(e, "shardNum") && n.uint32(8).int64(e.shardNum), e.realmNum != null && Object.hasOwnProperty.call(e, "realmNum") && n.uint32(16).int64(e.realmNum), e.scheduleNum != null && Object.hasOwnProperty.call(e, "scheduleNum") && n.uint32(24).int64(e.scheduleNum), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ScheduleID(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.shardNum = e.int64();
            break;
          }
          case 2: {
            y.realmNum = e.int64();
            break;
          }
          case 3: {
            y.scheduleNum = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ScheduleID";
    }, o;
  }(), TokenType: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "FUNGIBLE_COMMON"] = 0, e[o[1] = "NON_FUNGIBLE_UNIQUE"] = 1, e;
  }(), SubType: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "DEFAULT"] = 0, e[o[1] = "TOKEN_FUNGIBLE_COMMON"] = 1, e[o[2] = "TOKEN_NON_FUNGIBLE_UNIQUE"] = 2, e[o[3] = "TOKEN_FUNGIBLE_COMMON_WITH_CUSTOM_FEES"] = 3, e[o[4] = "TOKEN_NON_FUNGIBLE_UNIQUE_WITH_CUSTOM_FEES"] = 4, e[o[5] = "SCHEDULE_CREATE_CONTRACT_CALL"] = 5, e;
  }(), TokenSupplyType: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "INFINITE"] = 0, e[o[1] = "FINITE"] = 1, e;
  }(), TokenFreezeStatus: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "FreezeNotApplicable"] = 0, e[o[1] = "Frozen"] = 1, e[o[2] = "Unfrozen"] = 2, e;
  }(), TokenKycStatus: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "KycNotApplicable"] = 0, e[o[1] = "Granted"] = 1, e[o[2] = "Revoked"] = 2, e;
  }(), TokenPauseStatus: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "PauseNotApplicable"] = 0, e[o[1] = "Paused"] = 1, e[o[2] = "Unpaused"] = 2, e;
  }(), Key: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.contractID = null, o.prototype.ed25519 = null, o.prototype.RSA_3072 = null, o.prototype.ECDSA_384 = null, o.prototype.thresholdKey = null, o.prototype.keyList = null, o.prototype.ECDSASecp256k1 = null, o.prototype.delegatableContractId = null;
    let e;
    return Object.defineProperty(o.prototype, "key", { get: g.oneOfGetter(e = ["contractID", "ed25519", "RSA_3072", "ECDSA_384", "thresholdKey", "keyList", "ECDSASecp256k1", "delegatableContractId"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.contractID != null && Object.hasOwnProperty.call(n, "contractID") && c.proto.ContractID.encode(n.contractID, i.uint32(10).fork()).ldelim(), n.ed25519 != null && Object.hasOwnProperty.call(n, "ed25519") && i.uint32(18).bytes(n.ed25519), n.RSA_3072 != null && Object.hasOwnProperty.call(n, "RSA_3072") && i.uint32(26).bytes(n.RSA_3072), n.ECDSA_384 != null && Object.hasOwnProperty.call(n, "ECDSA_384") && i.uint32(34).bytes(n.ECDSA_384), n.thresholdKey != null && Object.hasOwnProperty.call(n, "thresholdKey") && c.proto.ThresholdKey.encode(n.thresholdKey, i.uint32(42).fork()).ldelim(), n.keyList != null && Object.hasOwnProperty.call(n, "keyList") && c.proto.KeyList.encode(n.keyList, i.uint32(50).fork()).ldelim(), n.ECDSASecp256k1 != null && Object.hasOwnProperty.call(n, "ECDSASecp256k1") && i.uint32(58).bytes(n.ECDSASecp256k1), n.delegatableContractId != null && Object.hasOwnProperty.call(n, "delegatableContractId") && c.proto.ContractID.encode(n.delegatableContractId, i.uint32(66).fork()).ldelim(), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.Key(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.contractID = c.proto.ContractID.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.ed25519 = n.bytes();
            break;
          }
          case 3: {
            m.RSA_3072 = n.bytes();
            break;
          }
          case 4: {
            m.ECDSA_384 = n.bytes();
            break;
          }
          case 5: {
            m.thresholdKey = c.proto.ThresholdKey.decode(n, n.uint32());
            break;
          }
          case 6: {
            m.keyList = c.proto.KeyList.decode(n, n.uint32());
            break;
          }
          case 7: {
            m.ECDSASecp256k1 = n.bytes();
            break;
          }
          case 8: {
            m.delegatableContractId = c.proto.ContractID.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.Key";
    }, o;
  }(), ThresholdKey: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.threshold = 0, o.prototype.keys = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.threshold != null && Object.hasOwnProperty.call(e, "threshold") && n.uint32(8).uint32(e.threshold), e.keys != null && Object.hasOwnProperty.call(e, "keys") && c.proto.KeyList.encode(e.keys, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ThresholdKey(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.threshold = e.uint32();
            break;
          }
          case 2: {
            y.keys = c.proto.KeyList.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ThresholdKey";
    }, o;
  }(), KeyList: function() {
    function o(e) {
      if (this.keys = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.keys = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.keys != null && e.keys.length)
        for (var i = 0; i < e.keys.length; ++i)
          c.proto.Key.encode(e.keys[i], n.uint32(10).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.KeyList(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.keys && y.keys.length || (y.keys = []), y.keys.push(c.proto.Key.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.KeyList";
    }, o;
  }(), Signature: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.contract = null, o.prototype.ed25519 = null, o.prototype.RSA_3072 = null, o.prototype.ECDSA_384 = null, o.prototype.thresholdSignature = null, o.prototype.signatureList = null;
    let e;
    return Object.defineProperty(o.prototype, "signature", { get: g.oneOfGetter(e = ["contract", "ed25519", "RSA_3072", "ECDSA_384", "thresholdSignature", "signatureList"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.contract != null && Object.hasOwnProperty.call(n, "contract") && i.uint32(10).bytes(n.contract), n.ed25519 != null && Object.hasOwnProperty.call(n, "ed25519") && i.uint32(18).bytes(n.ed25519), n.RSA_3072 != null && Object.hasOwnProperty.call(n, "RSA_3072") && i.uint32(26).bytes(n.RSA_3072), n.ECDSA_384 != null && Object.hasOwnProperty.call(n, "ECDSA_384") && i.uint32(34).bytes(n.ECDSA_384), n.thresholdSignature != null && Object.hasOwnProperty.call(n, "thresholdSignature") && c.proto.ThresholdSignature.encode(n.thresholdSignature, i.uint32(42).fork()).ldelim(), n.signatureList != null && Object.hasOwnProperty.call(n, "signatureList") && c.proto.SignatureList.encode(n.signatureList, i.uint32(50).fork()).ldelim(), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.Signature(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.contract = n.bytes();
            break;
          }
          case 2: {
            m.ed25519 = n.bytes();
            break;
          }
          case 3: {
            m.RSA_3072 = n.bytes();
            break;
          }
          case 4: {
            m.ECDSA_384 = n.bytes();
            break;
          }
          case 5: {
            m.thresholdSignature = c.proto.ThresholdSignature.decode(n, n.uint32());
            break;
          }
          case 6: {
            m.signatureList = c.proto.SignatureList.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.Signature";
    }, o;
  }(), ThresholdSignature: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.sigs = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.sigs != null && Object.hasOwnProperty.call(e, "sigs") && c.proto.SignatureList.encode(e.sigs, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ThresholdSignature(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 2: {
            y.sigs = c.proto.SignatureList.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ThresholdSignature";
    }, o;
  }(), SignatureList: function() {
    function o(e) {
      if (this.sigs = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.sigs = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.sigs != null && e.sigs.length)
        for (var i = 0; i < e.sigs.length; ++i)
          c.proto.Signature.encode(e.sigs[i], n.uint32(18).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.SignatureList(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 2: {
            y.sigs && y.sigs.length || (y.sigs = []), y.sigs.push(c.proto.Signature.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.SignatureList";
    }, o;
  }(), SignaturePair: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.pubKeyPrefix = g.newBuffer([]), o.prototype.contract = null, o.prototype.ed25519 = null, o.prototype.RSA_3072 = null, o.prototype.ECDSA_384 = null, o.prototype.ECDSASecp256k1 = null;
    let e;
    return Object.defineProperty(o.prototype, "signature", { get: g.oneOfGetter(e = ["contract", "ed25519", "RSA_3072", "ECDSA_384", "ECDSASecp256k1"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.pubKeyPrefix != null && Object.hasOwnProperty.call(n, "pubKeyPrefix") && i.uint32(10).bytes(n.pubKeyPrefix), n.contract != null && Object.hasOwnProperty.call(n, "contract") && i.uint32(18).bytes(n.contract), n.ed25519 != null && Object.hasOwnProperty.call(n, "ed25519") && i.uint32(26).bytes(n.ed25519), n.RSA_3072 != null && Object.hasOwnProperty.call(n, "RSA_3072") && i.uint32(34).bytes(n.RSA_3072), n.ECDSA_384 != null && Object.hasOwnProperty.call(n, "ECDSA_384") && i.uint32(42).bytes(n.ECDSA_384), n.ECDSASecp256k1 != null && Object.hasOwnProperty.call(n, "ECDSASecp256k1") && i.uint32(50).bytes(n.ECDSASecp256k1), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.SignaturePair(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.pubKeyPrefix = n.bytes();
            break;
          }
          case 2: {
            m.contract = n.bytes();
            break;
          }
          case 3: {
            m.ed25519 = n.bytes();
            break;
          }
          case 4: {
            m.RSA_3072 = n.bytes();
            break;
          }
          case 5: {
            m.ECDSA_384 = n.bytes();
            break;
          }
          case 6: {
            m.ECDSASecp256k1 = n.bytes();
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.SignaturePair";
    }, o;
  }(), SignatureMap: function() {
    function o(e) {
      if (this.sigPair = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.sigPair = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.sigPair != null && e.sigPair.length)
        for (var i = 0; i < e.sigPair.length; ++i)
          c.proto.SignaturePair.encode(e.sigPair[i], n.uint32(10).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.SignatureMap(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.sigPair && y.sigPair.length || (y.sigPair = []), y.sigPair.push(c.proto.SignaturePair.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.SignatureMap";
    }, o;
  }(), HederaFunctionality: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "NONE"] = 0, e[o[1] = "CryptoTransfer"] = 1, e[o[2] = "CryptoUpdate"] = 2, e[o[3] = "CryptoDelete"] = 3, e[o[4] = "CryptoAddLiveHash"] = 4, e[o[5] = "CryptoDeleteLiveHash"] = 5, e[o[6] = "ContractCall"] = 6, e[o[7] = "ContractCreate"] = 7, e[o[8] = "ContractUpdate"] = 8, e[o[9] = "FileCreate"] = 9, e[o[10] = "FileAppend"] = 10, e[o[11] = "FileUpdate"] = 11, e[o[12] = "FileDelete"] = 12, e[o[13] = "CryptoGetAccountBalance"] = 13, e[o[14] = "CryptoGetAccountRecords"] = 14, e[o[15] = "CryptoGetInfo"] = 15, e[o[16] = "ContractCallLocal"] = 16, e[o[17] = "ContractGetInfo"] = 17, e[o[18] = "ContractGetBytecode"] = 18, e[o[19] = "GetBySolidityID"] = 19, e[o[20] = "GetByKey"] = 20, e[o[21] = "CryptoGetLiveHash"] = 21, e[o[22] = "CryptoGetStakers"] = 22, e[o[23] = "FileGetContents"] = 23, e[o[24] = "FileGetInfo"] = 24, e[o[25] = "TransactionGetRecord"] = 25, e[o[26] = "ContractGetRecords"] = 26, e[o[27] = "CryptoCreate"] = 27, e[o[28] = "SystemDelete"] = 28, e[o[29] = "SystemUndelete"] = 29, e[o[30] = "ContractDelete"] = 30, e[o[31] = "Freeze"] = 31, e[o[32] = "CreateTransactionRecord"] = 32, e[o[33] = "CryptoAccountAutoRenew"] = 33, e[o[34] = "ContractAutoRenew"] = 34, e[o[35] = "GetVersionInfo"] = 35, e[o[36] = "TransactionGetReceipt"] = 36, e[o[50] = "ConsensusCreateTopic"] = 50, e[o[51] = "ConsensusUpdateTopic"] = 51, e[o[52] = "ConsensusDeleteTopic"] = 52, e[o[53] = "ConsensusGetTopicInfo"] = 53, e[o[54] = "ConsensusSubmitMessage"] = 54, e[o[55] = "UncheckedSubmit"] = 55, e[o[56] = "TokenCreate"] = 56, e[o[58] = "TokenGetInfo"] = 58, e[o[59] = "TokenFreezeAccount"] = 59, e[o[60] = "TokenUnfreezeAccount"] = 60, e[o[61] = "TokenGrantKycToAccount"] = 61, e[o[62] = "TokenRevokeKycFromAccount"] = 62, e[o[63] = "TokenDelete"] = 63, e[o[64] = "TokenUpdate"] = 64, e[o[65] = "TokenMint"] = 65, e[o[66] = "TokenBurn"] = 66, e[o[67] = "TokenAccountWipe"] = 67, e[o[68] = "TokenAssociateToAccount"] = 68, e[o[69] = "TokenDissociateFromAccount"] = 69, e[o[70] = "ScheduleCreate"] = 70, e[o[71] = "ScheduleDelete"] = 71, e[o[72] = "ScheduleSign"] = 72, e[o[73] = "ScheduleGetInfo"] = 73, e[o[74] = "TokenGetAccountNftInfos"] = 74, e[o[75] = "TokenGetNftInfo"] = 75, e[o[76] = "TokenGetNftInfos"] = 76, e[o[77] = "TokenFeeScheduleUpdate"] = 77, e[o[78] = "NetworkGetExecutionTime"] = 78, e[o[79] = "TokenPause"] = 79, e[o[80] = "TokenUnpause"] = 80, e[o[81] = "CryptoApproveAllowance"] = 81, e[o[82] = "CryptoDeleteAllowance"] = 82, e[o[83] = "GetAccountDetails"] = 83, e[o[84] = "EthereumTransaction"] = 84, e[o[85] = "NodeStakeUpdate"] = 85, e[o[86] = "UtilPrng"] = 86, e;
  }(), FeeComponents: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.min = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.max = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.constant = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.bpt = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.vpt = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.rbh = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.sbh = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.gas = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.tv = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.bpr = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.sbpr = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.min != null && Object.hasOwnProperty.call(e, "min") && n.uint32(8).int64(e.min), e.max != null && Object.hasOwnProperty.call(e, "max") && n.uint32(16).int64(e.max), e.constant != null && Object.hasOwnProperty.call(e, "constant") && n.uint32(24).int64(e.constant), e.bpt != null && Object.hasOwnProperty.call(e, "bpt") && n.uint32(32).int64(e.bpt), e.vpt != null && Object.hasOwnProperty.call(e, "vpt") && n.uint32(40).int64(e.vpt), e.rbh != null && Object.hasOwnProperty.call(e, "rbh") && n.uint32(48).int64(e.rbh), e.sbh != null && Object.hasOwnProperty.call(e, "sbh") && n.uint32(56).int64(e.sbh), e.gas != null && Object.hasOwnProperty.call(e, "gas") && n.uint32(64).int64(e.gas), e.tv != null && Object.hasOwnProperty.call(e, "tv") && n.uint32(72).int64(e.tv), e.bpr != null && Object.hasOwnProperty.call(e, "bpr") && n.uint32(80).int64(e.bpr), e.sbpr != null && Object.hasOwnProperty.call(e, "sbpr") && n.uint32(88).int64(e.sbpr), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FeeComponents(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.min = e.int64();
            break;
          }
          case 2: {
            y.max = e.int64();
            break;
          }
          case 3: {
            y.constant = e.int64();
            break;
          }
          case 4: {
            y.bpt = e.int64();
            break;
          }
          case 5: {
            y.vpt = e.int64();
            break;
          }
          case 6: {
            y.rbh = e.int64();
            break;
          }
          case 7: {
            y.sbh = e.int64();
            break;
          }
          case 8: {
            y.gas = e.int64();
            break;
          }
          case 9: {
            y.tv = e.int64();
            break;
          }
          case 10: {
            y.bpr = e.int64();
            break;
          }
          case 11: {
            y.sbpr = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FeeComponents";
    }, o;
  }(), TransactionFeeSchedule: function() {
    function o(e) {
      if (this.fees = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.hederaFunctionality = 0, o.prototype.feeData = null, o.prototype.fees = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.hederaFunctionality != null && Object.hasOwnProperty.call(e, "hederaFunctionality") && n.uint32(8).int32(e.hederaFunctionality), e.feeData != null && Object.hasOwnProperty.call(e, "feeData") && c.proto.FeeData.encode(e.feeData, n.uint32(18).fork()).ldelim(), e.fees != null && e.fees.length)
        for (var i = 0; i < e.fees.length; ++i)
          c.proto.FeeData.encode(e.fees[i], n.uint32(26).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TransactionFeeSchedule(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.hederaFunctionality = e.int32();
            break;
          }
          case 2: {
            y.feeData = c.proto.FeeData.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.fees && y.fees.length || (y.fees = []), y.fees.push(c.proto.FeeData.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TransactionFeeSchedule";
    }, o;
  }(), FeeData: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.nodedata = null, o.prototype.networkdata = null, o.prototype.servicedata = null, o.prototype.subType = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.nodedata != null && Object.hasOwnProperty.call(e, "nodedata") && c.proto.FeeComponents.encode(e.nodedata, n.uint32(10).fork()).ldelim(), e.networkdata != null && Object.hasOwnProperty.call(e, "networkdata") && c.proto.FeeComponents.encode(e.networkdata, n.uint32(18).fork()).ldelim(), e.servicedata != null && Object.hasOwnProperty.call(e, "servicedata") && c.proto.FeeComponents.encode(e.servicedata, n.uint32(26).fork()).ldelim(), e.subType != null && Object.hasOwnProperty.call(e, "subType") && n.uint32(32).int32(e.subType), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FeeData(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.nodedata = c.proto.FeeComponents.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.networkdata = c.proto.FeeComponents.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.servicedata = c.proto.FeeComponents.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.subType = e.int32();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FeeData";
    }, o;
  }(), FeeSchedule: function() {
    function o(e) {
      if (this.transactionFeeSchedule = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.transactionFeeSchedule = g.emptyArray, o.prototype.expiryTime = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.transactionFeeSchedule != null && e.transactionFeeSchedule.length)
        for (var i = 0; i < e.transactionFeeSchedule.length; ++i)
          c.proto.TransactionFeeSchedule.encode(e.transactionFeeSchedule[i], n.uint32(10).fork()).ldelim();
      return e.expiryTime != null && Object.hasOwnProperty.call(e, "expiryTime") && c.proto.TimestampSeconds.encode(e.expiryTime, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FeeSchedule(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.transactionFeeSchedule && y.transactionFeeSchedule.length || (y.transactionFeeSchedule = []), y.transactionFeeSchedule.push(c.proto.TransactionFeeSchedule.decode(e, e.uint32()));
            break;
          }
          case 2: {
            y.expiryTime = c.proto.TimestampSeconds.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FeeSchedule";
    }, o;
  }(), CurrentAndNextFeeSchedule: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.currentFeeSchedule = null, o.prototype.nextFeeSchedule = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.currentFeeSchedule != null && Object.hasOwnProperty.call(e, "currentFeeSchedule") && c.proto.FeeSchedule.encode(e.currentFeeSchedule, n.uint32(10).fork()).ldelim(), e.nextFeeSchedule != null && Object.hasOwnProperty.call(e, "nextFeeSchedule") && c.proto.FeeSchedule.encode(e.nextFeeSchedule, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CurrentAndNextFeeSchedule(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.currentFeeSchedule = c.proto.FeeSchedule.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.nextFeeSchedule = c.proto.FeeSchedule.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CurrentAndNextFeeSchedule";
    }, o;
  }(), ServiceEndpoint: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.ipAddressV4 = g.newBuffer([]), o.prototype.port = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.ipAddressV4 != null && Object.hasOwnProperty.call(e, "ipAddressV4") && n.uint32(10).bytes(e.ipAddressV4), e.port != null && Object.hasOwnProperty.call(e, "port") && n.uint32(16).int32(e.port), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ServiceEndpoint(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.ipAddressV4 = e.bytes();
            break;
          }
          case 2: {
            y.port = e.int32();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ServiceEndpoint";
    }, o;
  }(), NodeAddress: function() {
    function o(e) {
      if (this.serviceEndpoint = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.ipAddress = g.newBuffer([]), o.prototype.portno = 0, o.prototype.memo = g.newBuffer([]), o.prototype.RSA_PubKey = "", o.prototype.nodeId = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.nodeAccountId = null, o.prototype.nodeCertHash = g.newBuffer([]), o.prototype.serviceEndpoint = g.emptyArray, o.prototype.description = "", o.prototype.stake = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.ipAddress != null && Object.hasOwnProperty.call(e, "ipAddress") && n.uint32(10).bytes(e.ipAddress), e.portno != null && Object.hasOwnProperty.call(e, "portno") && n.uint32(16).int32(e.portno), e.memo != null && Object.hasOwnProperty.call(e, "memo") && n.uint32(26).bytes(e.memo), e.RSA_PubKey != null && Object.hasOwnProperty.call(e, "RSA_PubKey") && n.uint32(34).string(e.RSA_PubKey), e.nodeId != null && Object.hasOwnProperty.call(e, "nodeId") && n.uint32(40).int64(e.nodeId), e.nodeAccountId != null && Object.hasOwnProperty.call(e, "nodeAccountId") && c.proto.AccountID.encode(e.nodeAccountId, n.uint32(50).fork()).ldelim(), e.nodeCertHash != null && Object.hasOwnProperty.call(e, "nodeCertHash") && n.uint32(58).bytes(e.nodeCertHash), e.serviceEndpoint != null && e.serviceEndpoint.length)
        for (var i = 0; i < e.serviceEndpoint.length; ++i)
          c.proto.ServiceEndpoint.encode(e.serviceEndpoint[i], n.uint32(66).fork()).ldelim();
      return e.description != null && Object.hasOwnProperty.call(e, "description") && n.uint32(74).string(e.description), e.stake != null && Object.hasOwnProperty.call(e, "stake") && n.uint32(80).int64(e.stake), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.NodeAddress(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.ipAddress = e.bytes();
            break;
          }
          case 2: {
            y.portno = e.int32();
            break;
          }
          case 3: {
            y.memo = e.bytes();
            break;
          }
          case 4: {
            y.RSA_PubKey = e.string();
            break;
          }
          case 5: {
            y.nodeId = e.int64();
            break;
          }
          case 6: {
            y.nodeAccountId = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 7: {
            y.nodeCertHash = e.bytes();
            break;
          }
          case 8: {
            y.serviceEndpoint && y.serviceEndpoint.length || (y.serviceEndpoint = []), y.serviceEndpoint.push(c.proto.ServiceEndpoint.decode(e, e.uint32()));
            break;
          }
          case 9: {
            y.description = e.string();
            break;
          }
          case 10: {
            y.stake = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.NodeAddress";
    }, o;
  }(), NodeAddressBook: function() {
    function o(e) {
      if (this.nodeAddress = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.nodeAddress = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.nodeAddress != null && e.nodeAddress.length)
        for (var i = 0; i < e.nodeAddress.length; ++i)
          c.proto.NodeAddress.encode(e.nodeAddress[i], n.uint32(10).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.NodeAddressBook(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.nodeAddress && y.nodeAddress.length || (y.nodeAddress = []), y.nodeAddress.push(c.proto.NodeAddress.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.NodeAddressBook";
    }, o;
  }(), SemanticVersion: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.major = 0, o.prototype.minor = 0, o.prototype.patch = 0, o.prototype.pre = "", o.prototype.build = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.major != null && Object.hasOwnProperty.call(e, "major") && n.uint32(8).int32(e.major), e.minor != null && Object.hasOwnProperty.call(e, "minor") && n.uint32(16).int32(e.minor), e.patch != null && Object.hasOwnProperty.call(e, "patch") && n.uint32(24).int32(e.patch), e.pre != null && Object.hasOwnProperty.call(e, "pre") && n.uint32(34).string(e.pre), e.build != null && Object.hasOwnProperty.call(e, "build") && n.uint32(42).string(e.build), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.SemanticVersion(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.major = e.int32();
            break;
          }
          case 2: {
            y.minor = e.int32();
            break;
          }
          case 3: {
            y.patch = e.int32();
            break;
          }
          case 4: {
            y.pre = e.string();
            break;
          }
          case 5: {
            y.build = e.string();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.SemanticVersion";
    }, o;
  }(), Setting: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.name = "", o.prototype.value = "", o.prototype.data = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(10).string(e.name), e.value != null && Object.hasOwnProperty.call(e, "value") && n.uint32(18).string(e.value), e.data != null && Object.hasOwnProperty.call(e, "data") && n.uint32(26).bytes(e.data), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.Setting(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.name = e.string();
            break;
          }
          case 2: {
            y.value = e.string();
            break;
          }
          case 3: {
            y.data = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.Setting";
    }, o;
  }(), ServicesConfigurationList: function() {
    function o(e) {
      if (this.nameValue = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.nameValue = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.nameValue != null && e.nameValue.length)
        for (var i = 0; i < e.nameValue.length; ++i)
          c.proto.Setting.encode(e.nameValue[i], n.uint32(10).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ServicesConfigurationList(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.nameValue && y.nameValue.length || (y.nameValue = []), y.nameValue.push(c.proto.Setting.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ServicesConfigurationList";
    }, o;
  }(), TokenRelationship: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.tokenId = null, o.prototype.symbol = "", o.prototype.balance = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.kycStatus = 0, o.prototype.freezeStatus = 0, o.prototype.decimals = 0, o.prototype.automaticAssociation = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.tokenId != null && Object.hasOwnProperty.call(e, "tokenId") && c.proto.TokenID.encode(e.tokenId, n.uint32(10).fork()).ldelim(), e.symbol != null && Object.hasOwnProperty.call(e, "symbol") && n.uint32(18).string(e.symbol), e.balance != null && Object.hasOwnProperty.call(e, "balance") && n.uint32(24).uint64(e.balance), e.kycStatus != null && Object.hasOwnProperty.call(e, "kycStatus") && n.uint32(32).int32(e.kycStatus), e.freezeStatus != null && Object.hasOwnProperty.call(e, "freezeStatus") && n.uint32(40).int32(e.freezeStatus), e.decimals != null && Object.hasOwnProperty.call(e, "decimals") && n.uint32(48).uint32(e.decimals), e.automaticAssociation != null && Object.hasOwnProperty.call(e, "automaticAssociation") && n.uint32(56).bool(e.automaticAssociation), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenRelationship(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.tokenId = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.symbol = e.string();
            break;
          }
          case 3: {
            y.balance = e.uint64();
            break;
          }
          case 4: {
            y.kycStatus = e.int32();
            break;
          }
          case 5: {
            y.freezeStatus = e.int32();
            break;
          }
          case 6: {
            y.decimals = e.uint32();
            break;
          }
          case 7: {
            y.automaticAssociation = e.bool();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenRelationship";
    }, o;
  }(), TokenBalance: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.tokenId = null, o.prototype.balance = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.decimals = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.tokenId != null && Object.hasOwnProperty.call(e, "tokenId") && c.proto.TokenID.encode(e.tokenId, n.uint32(10).fork()).ldelim(), e.balance != null && Object.hasOwnProperty.call(e, "balance") && n.uint32(16).uint64(e.balance), e.decimals != null && Object.hasOwnProperty.call(e, "decimals") && n.uint32(24).uint32(e.decimals), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenBalance(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.tokenId = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.balance = e.uint64();
            break;
          }
          case 3: {
            y.decimals = e.uint32();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenBalance";
    }, o;
  }(), TokenBalances: function() {
    function o(e) {
      if (this.tokenBalances = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.tokenBalances = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.tokenBalances != null && e.tokenBalances.length)
        for (var i = 0; i < e.tokenBalances.length; ++i)
          c.proto.TokenBalance.encode(e.tokenBalances[i], n.uint32(10).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenBalances(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.tokenBalances && y.tokenBalances.length || (y.tokenBalances = []), y.tokenBalances.push(c.proto.TokenBalance.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenBalances";
    }, o;
  }(), TokenAssociation: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.tokenId = null, o.prototype.accountId = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.tokenId != null && Object.hasOwnProperty.call(e, "tokenId") && c.proto.TokenID.encode(e.tokenId, n.uint32(10).fork()).ldelim(), e.accountId != null && Object.hasOwnProperty.call(e, "accountId") && c.proto.AccountID.encode(e.accountId, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenAssociation(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.tokenId = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountId = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenAssociation";
    }, o;
  }(), StakingInfo: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.declineReward = !1, o.prototype.stakePeriodStart = null, o.prototype.pendingReward = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.stakedToMe = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.stakedAccountId = null, o.prototype.stakedNodeId = null;
    let e;
    return Object.defineProperty(o.prototype, "stakedId", { get: g.oneOfGetter(e = ["stakedAccountId", "stakedNodeId"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.declineReward != null && Object.hasOwnProperty.call(n, "declineReward") && i.uint32(8).bool(n.declineReward), n.stakePeriodStart != null && Object.hasOwnProperty.call(n, "stakePeriodStart") && c.proto.Timestamp.encode(n.stakePeriodStart, i.uint32(18).fork()).ldelim(), n.pendingReward != null && Object.hasOwnProperty.call(n, "pendingReward") && i.uint32(24).int64(n.pendingReward), n.stakedToMe != null && Object.hasOwnProperty.call(n, "stakedToMe") && i.uint32(32).int64(n.stakedToMe), n.stakedAccountId != null && Object.hasOwnProperty.call(n, "stakedAccountId") && c.proto.AccountID.encode(n.stakedAccountId, i.uint32(42).fork()).ldelim(), n.stakedNodeId != null && Object.hasOwnProperty.call(n, "stakedNodeId") && i.uint32(48).int64(n.stakedNodeId), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.StakingInfo(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.declineReward = n.bool();
            break;
          }
          case 2: {
            m.stakePeriodStart = c.proto.Timestamp.decode(n, n.uint32());
            break;
          }
          case 3: {
            m.pendingReward = n.int64();
            break;
          }
          case 4: {
            m.stakedToMe = n.int64();
            break;
          }
          case 5: {
            m.stakedAccountId = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 6: {
            m.stakedNodeId = n.int64();
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.StakingInfo";
    }, o;
  }(), Timestamp: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.seconds = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.nanos = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.seconds != null && Object.hasOwnProperty.call(e, "seconds") && n.uint32(8).int64(e.seconds), e.nanos != null && Object.hasOwnProperty.call(e, "nanos") && n.uint32(16).int32(e.nanos), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.Timestamp(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.seconds = e.int64();
            break;
          }
          case 2: {
            y.nanos = e.int32();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.Timestamp";
    }, o;
  }(), TimestampSeconds: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.seconds = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.seconds != null && Object.hasOwnProperty.call(e, "seconds") && n.uint32(8).int64(e.seconds), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TimestampSeconds(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.seconds = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TimestampSeconds";
    }, o;
  }(), ConsensusCreateTopicTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.memo = "", o.prototype.adminKey = null, o.prototype.submitKey = null, o.prototype.autoRenewPeriod = null, o.prototype.autoRenewAccount = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.memo != null && Object.hasOwnProperty.call(e, "memo") && n.uint32(10).string(e.memo), e.adminKey != null && Object.hasOwnProperty.call(e, "adminKey") && c.proto.Key.encode(e.adminKey, n.uint32(18).fork()).ldelim(), e.submitKey != null && Object.hasOwnProperty.call(e, "submitKey") && c.proto.Key.encode(e.submitKey, n.uint32(26).fork()).ldelim(), e.autoRenewPeriod != null && Object.hasOwnProperty.call(e, "autoRenewPeriod") && c.proto.Duration.encode(e.autoRenewPeriod, n.uint32(50).fork()).ldelim(), e.autoRenewAccount != null && Object.hasOwnProperty.call(e, "autoRenewAccount") && c.proto.AccountID.encode(e.autoRenewAccount, n.uint32(58).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ConsensusCreateTopicTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.memo = e.string();
            break;
          }
          case 2: {
            y.adminKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.submitKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 6: {
            y.autoRenewPeriod = c.proto.Duration.decode(e, e.uint32());
            break;
          }
          case 7: {
            y.autoRenewAccount = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ConsensusCreateTopicTransactionBody";
    }, o;
  }(), Duration: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.seconds = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.seconds != null && Object.hasOwnProperty.call(e, "seconds") && n.uint32(8).int64(e.seconds), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.Duration(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.seconds = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.Duration";
    }, o;
  }(), ConsensusDeleteTopicTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.topicID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.topicID != null && Object.hasOwnProperty.call(e, "topicID") && c.proto.TopicID.encode(e.topicID, n.uint32(10).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ConsensusDeleteTopicTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.topicID = c.proto.TopicID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ConsensusDeleteTopicTransactionBody";
    }, o;
  }(), ConsensusGetTopicInfoQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.topicID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.topicID != null && Object.hasOwnProperty.call(e, "topicID") && c.proto.TopicID.encode(e.topicID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ConsensusGetTopicInfoQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.topicID = c.proto.TopicID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ConsensusGetTopicInfoQuery";
    }, o;
  }(), ConsensusGetTopicInfoResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.topicID = null, o.prototype.topicInfo = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.topicID != null && Object.hasOwnProperty.call(e, "topicID") && c.proto.TopicID.encode(e.topicID, n.uint32(18).fork()).ldelim(), e.topicInfo != null && Object.hasOwnProperty.call(e, "topicInfo") && c.proto.ConsensusTopicInfo.encode(e.topicInfo, n.uint32(42).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ConsensusGetTopicInfoResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.topicID = c.proto.TopicID.decode(e, e.uint32());
            break;
          }
          case 5: {
            y.topicInfo = c.proto.ConsensusTopicInfo.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ConsensusGetTopicInfoResponse";
    }, o;
  }(), ResponseType: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "ANSWER_ONLY"] = 0, e[o[1] = "ANSWER_STATE_PROOF"] = 1, e[o[2] = "COST_ANSWER"] = 2, e[o[3] = "COST_ANSWER_STATE_PROOF"] = 3, e;
  }(), QueryHeader: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.payment = null, o.prototype.responseType = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.payment != null && Object.hasOwnProperty.call(e, "payment") && c.proto.Transaction.encode(e.payment, n.uint32(10).fork()).ldelim(), e.responseType != null && Object.hasOwnProperty.call(e, "responseType") && n.uint32(16).int32(e.responseType), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.QueryHeader(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.payment = c.proto.Transaction.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.responseType = e.int32();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.QueryHeader";
    }, o;
  }(), Transaction: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.body = null, o.prototype.sigs = null, o.prototype.sigMap = null, o.prototype.bodyBytes = g.newBuffer([]), o.prototype.signedTransactionBytes = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.body != null && Object.hasOwnProperty.call(e, "body") && c.proto.TransactionBody.encode(e.body, n.uint32(10).fork()).ldelim(), e.sigs != null && Object.hasOwnProperty.call(e, "sigs") && c.proto.SignatureList.encode(e.sigs, n.uint32(18).fork()).ldelim(), e.sigMap != null && Object.hasOwnProperty.call(e, "sigMap") && c.proto.SignatureMap.encode(e.sigMap, n.uint32(26).fork()).ldelim(), e.bodyBytes != null && Object.hasOwnProperty.call(e, "bodyBytes") && n.uint32(34).bytes(e.bodyBytes), e.signedTransactionBytes != null && Object.hasOwnProperty.call(e, "signedTransactionBytes") && n.uint32(42).bytes(e.signedTransactionBytes), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.Transaction(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.body = c.proto.TransactionBody.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.sigs = c.proto.SignatureList.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.sigMap = c.proto.SignatureMap.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.bodyBytes = e.bytes();
            break;
          }
          case 5: {
            y.signedTransactionBytes = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.Transaction";
    }, o;
  }(), TransactionBody: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.transactionID = null, o.prototype.nodeAccountID = null, o.prototype.transactionFee = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.transactionValidDuration = null, o.prototype.generateRecord = !1, o.prototype.memo = "", o.prototype.contractCall = null, o.prototype.contractCreateInstance = null, o.prototype.contractUpdateInstance = null, o.prototype.contractDeleteInstance = null, o.prototype.ethereumTransaction = null, o.prototype.cryptoAddLiveHash = null, o.prototype.cryptoApproveAllowance = null, o.prototype.cryptoDeleteAllowance = null, o.prototype.cryptoCreateAccount = null, o.prototype.cryptoDelete = null, o.prototype.cryptoDeleteLiveHash = null, o.prototype.cryptoTransfer = null, o.prototype.cryptoUpdateAccount = null, o.prototype.fileAppend = null, o.prototype.fileCreate = null, o.prototype.fileDelete = null, o.prototype.fileUpdate = null, o.prototype.systemDelete = null, o.prototype.systemUndelete = null, o.prototype.freeze = null, o.prototype.consensusCreateTopic = null, o.prototype.consensusUpdateTopic = null, o.prototype.consensusDeleteTopic = null, o.prototype.consensusSubmitMessage = null, o.prototype.uncheckedSubmit = null, o.prototype.tokenCreation = null, o.prototype.tokenFreeze = null, o.prototype.tokenUnfreeze = null, o.prototype.tokenGrantKyc = null, o.prototype.tokenRevokeKyc = null, o.prototype.tokenDeletion = null, o.prototype.tokenUpdate = null, o.prototype.tokenMint = null, o.prototype.tokenBurn = null, o.prototype.tokenWipe = null, o.prototype.tokenAssociate = null, o.prototype.tokenDissociate = null, o.prototype.tokenFeeScheduleUpdate = null, o.prototype.tokenPause = null, o.prototype.tokenUnpause = null, o.prototype.scheduleCreate = null, o.prototype.scheduleDelete = null, o.prototype.scheduleSign = null, o.prototype.nodeStakeUpdate = null, o.prototype.utilPrng = null;
    let e;
    return Object.defineProperty(o.prototype, "data", { get: g.oneOfGetter(e = ["contractCall", "contractCreateInstance", "contractUpdateInstance", "contractDeleteInstance", "ethereumTransaction", "cryptoAddLiveHash", "cryptoApproveAllowance", "cryptoDeleteAllowance", "cryptoCreateAccount", "cryptoDelete", "cryptoDeleteLiveHash", "cryptoTransfer", "cryptoUpdateAccount", "fileAppend", "fileCreate", "fileDelete", "fileUpdate", "systemDelete", "systemUndelete", "freeze", "consensusCreateTopic", "consensusUpdateTopic", "consensusDeleteTopic", "consensusSubmitMessage", "uncheckedSubmit", "tokenCreation", "tokenFreeze", "tokenUnfreeze", "tokenGrantKyc", "tokenRevokeKyc", "tokenDeletion", "tokenUpdate", "tokenMint", "tokenBurn", "tokenWipe", "tokenAssociate", "tokenDissociate", "tokenFeeScheduleUpdate", "tokenPause", "tokenUnpause", "scheduleCreate", "scheduleDelete", "scheduleSign", "nodeStakeUpdate", "utilPrng"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.transactionID != null && Object.hasOwnProperty.call(n, "transactionID") && c.proto.TransactionID.encode(n.transactionID, i.uint32(10).fork()).ldelim(), n.nodeAccountID != null && Object.hasOwnProperty.call(n, "nodeAccountID") && c.proto.AccountID.encode(n.nodeAccountID, i.uint32(18).fork()).ldelim(), n.transactionFee != null && Object.hasOwnProperty.call(n, "transactionFee") && i.uint32(24).uint64(n.transactionFee), n.transactionValidDuration != null && Object.hasOwnProperty.call(n, "transactionValidDuration") && c.proto.Duration.encode(n.transactionValidDuration, i.uint32(34).fork()).ldelim(), n.generateRecord != null && Object.hasOwnProperty.call(n, "generateRecord") && i.uint32(40).bool(n.generateRecord), n.memo != null && Object.hasOwnProperty.call(n, "memo") && i.uint32(50).string(n.memo), n.contractCall != null && Object.hasOwnProperty.call(n, "contractCall") && c.proto.ContractCallTransactionBody.encode(n.contractCall, i.uint32(58).fork()).ldelim(), n.contractCreateInstance != null && Object.hasOwnProperty.call(n, "contractCreateInstance") && c.proto.ContractCreateTransactionBody.encode(n.contractCreateInstance, i.uint32(66).fork()).ldelim(), n.contractUpdateInstance != null && Object.hasOwnProperty.call(n, "contractUpdateInstance") && c.proto.ContractUpdateTransactionBody.encode(n.contractUpdateInstance, i.uint32(74).fork()).ldelim(), n.cryptoAddLiveHash != null && Object.hasOwnProperty.call(n, "cryptoAddLiveHash") && c.proto.CryptoAddLiveHashTransactionBody.encode(n.cryptoAddLiveHash, i.uint32(82).fork()).ldelim(), n.cryptoCreateAccount != null && Object.hasOwnProperty.call(n, "cryptoCreateAccount") && c.proto.CryptoCreateTransactionBody.encode(n.cryptoCreateAccount, i.uint32(90).fork()).ldelim(), n.cryptoDelete != null && Object.hasOwnProperty.call(n, "cryptoDelete") && c.proto.CryptoDeleteTransactionBody.encode(n.cryptoDelete, i.uint32(98).fork()).ldelim(), n.cryptoDeleteLiveHash != null && Object.hasOwnProperty.call(n, "cryptoDeleteLiveHash") && c.proto.CryptoDeleteLiveHashTransactionBody.encode(n.cryptoDeleteLiveHash, i.uint32(106).fork()).ldelim(), n.cryptoTransfer != null && Object.hasOwnProperty.call(n, "cryptoTransfer") && c.proto.CryptoTransferTransactionBody.encode(n.cryptoTransfer, i.uint32(114).fork()).ldelim(), n.cryptoUpdateAccount != null && Object.hasOwnProperty.call(n, "cryptoUpdateAccount") && c.proto.CryptoUpdateTransactionBody.encode(n.cryptoUpdateAccount, i.uint32(122).fork()).ldelim(), n.fileAppend != null && Object.hasOwnProperty.call(n, "fileAppend") && c.proto.FileAppendTransactionBody.encode(n.fileAppend, i.uint32(130).fork()).ldelim(), n.fileCreate != null && Object.hasOwnProperty.call(n, "fileCreate") && c.proto.FileCreateTransactionBody.encode(n.fileCreate, i.uint32(138).fork()).ldelim(), n.fileDelete != null && Object.hasOwnProperty.call(n, "fileDelete") && c.proto.FileDeleteTransactionBody.encode(n.fileDelete, i.uint32(146).fork()).ldelim(), n.fileUpdate != null && Object.hasOwnProperty.call(n, "fileUpdate") && c.proto.FileUpdateTransactionBody.encode(n.fileUpdate, i.uint32(154).fork()).ldelim(), n.systemDelete != null && Object.hasOwnProperty.call(n, "systemDelete") && c.proto.SystemDeleteTransactionBody.encode(n.systemDelete, i.uint32(162).fork()).ldelim(), n.systemUndelete != null && Object.hasOwnProperty.call(n, "systemUndelete") && c.proto.SystemUndeleteTransactionBody.encode(n.systemUndelete, i.uint32(170).fork()).ldelim(), n.contractDeleteInstance != null && Object.hasOwnProperty.call(n, "contractDeleteInstance") && c.proto.ContractDeleteTransactionBody.encode(n.contractDeleteInstance, i.uint32(178).fork()).ldelim(), n.freeze != null && Object.hasOwnProperty.call(n, "freeze") && c.proto.FreezeTransactionBody.encode(n.freeze, i.uint32(186).fork()).ldelim(), n.consensusCreateTopic != null && Object.hasOwnProperty.call(n, "consensusCreateTopic") && c.proto.ConsensusCreateTopicTransactionBody.encode(n.consensusCreateTopic, i.uint32(194).fork()).ldelim(), n.consensusUpdateTopic != null && Object.hasOwnProperty.call(n, "consensusUpdateTopic") && c.proto.ConsensusUpdateTopicTransactionBody.encode(n.consensusUpdateTopic, i.uint32(202).fork()).ldelim(), n.consensusDeleteTopic != null && Object.hasOwnProperty.call(n, "consensusDeleteTopic") && c.proto.ConsensusDeleteTopicTransactionBody.encode(n.consensusDeleteTopic, i.uint32(210).fork()).ldelim(), n.consensusSubmitMessage != null && Object.hasOwnProperty.call(n, "consensusSubmitMessage") && c.proto.ConsensusSubmitMessageTransactionBody.encode(n.consensusSubmitMessage, i.uint32(218).fork()).ldelim(), n.uncheckedSubmit != null && Object.hasOwnProperty.call(n, "uncheckedSubmit") && c.proto.UncheckedSubmitBody.encode(n.uncheckedSubmit, i.uint32(226).fork()).ldelim(), n.tokenCreation != null && Object.hasOwnProperty.call(n, "tokenCreation") && c.proto.TokenCreateTransactionBody.encode(n.tokenCreation, i.uint32(234).fork()).ldelim(), n.tokenFreeze != null && Object.hasOwnProperty.call(n, "tokenFreeze") && c.proto.TokenFreezeAccountTransactionBody.encode(n.tokenFreeze, i.uint32(250).fork()).ldelim(), n.tokenUnfreeze != null && Object.hasOwnProperty.call(n, "tokenUnfreeze") && c.proto.TokenUnfreezeAccountTransactionBody.encode(n.tokenUnfreeze, i.uint32(258).fork()).ldelim(), n.tokenGrantKyc != null && Object.hasOwnProperty.call(n, "tokenGrantKyc") && c.proto.TokenGrantKycTransactionBody.encode(n.tokenGrantKyc, i.uint32(266).fork()).ldelim(), n.tokenRevokeKyc != null && Object.hasOwnProperty.call(n, "tokenRevokeKyc") && c.proto.TokenRevokeKycTransactionBody.encode(n.tokenRevokeKyc, i.uint32(274).fork()).ldelim(), n.tokenDeletion != null && Object.hasOwnProperty.call(n, "tokenDeletion") && c.proto.TokenDeleteTransactionBody.encode(n.tokenDeletion, i.uint32(282).fork()).ldelim(), n.tokenUpdate != null && Object.hasOwnProperty.call(n, "tokenUpdate") && c.proto.TokenUpdateTransactionBody.encode(n.tokenUpdate, i.uint32(290).fork()).ldelim(), n.tokenMint != null && Object.hasOwnProperty.call(n, "tokenMint") && c.proto.TokenMintTransactionBody.encode(n.tokenMint, i.uint32(298).fork()).ldelim(), n.tokenBurn != null && Object.hasOwnProperty.call(n, "tokenBurn") && c.proto.TokenBurnTransactionBody.encode(n.tokenBurn, i.uint32(306).fork()).ldelim(), n.tokenWipe != null && Object.hasOwnProperty.call(n, "tokenWipe") && c.proto.TokenWipeAccountTransactionBody.encode(n.tokenWipe, i.uint32(314).fork()).ldelim(), n.tokenAssociate != null && Object.hasOwnProperty.call(n, "tokenAssociate") && c.proto.TokenAssociateTransactionBody.encode(n.tokenAssociate, i.uint32(322).fork()).ldelim(), n.tokenDissociate != null && Object.hasOwnProperty.call(n, "tokenDissociate") && c.proto.TokenDissociateTransactionBody.encode(n.tokenDissociate, i.uint32(330).fork()).ldelim(), n.scheduleCreate != null && Object.hasOwnProperty.call(n, "scheduleCreate") && c.proto.ScheduleCreateTransactionBody.encode(n.scheduleCreate, i.uint32(338).fork()).ldelim(), n.scheduleDelete != null && Object.hasOwnProperty.call(n, "scheduleDelete") && c.proto.ScheduleDeleteTransactionBody.encode(n.scheduleDelete, i.uint32(346).fork()).ldelim(), n.scheduleSign != null && Object.hasOwnProperty.call(n, "scheduleSign") && c.proto.ScheduleSignTransactionBody.encode(n.scheduleSign, i.uint32(354).fork()).ldelim(), n.tokenFeeScheduleUpdate != null && Object.hasOwnProperty.call(n, "tokenFeeScheduleUpdate") && c.proto.TokenFeeScheduleUpdateTransactionBody.encode(n.tokenFeeScheduleUpdate, i.uint32(362).fork()).ldelim(), n.tokenPause != null && Object.hasOwnProperty.call(n, "tokenPause") && c.proto.TokenPauseTransactionBody.encode(n.tokenPause, i.uint32(370).fork()).ldelim(), n.tokenUnpause != null && Object.hasOwnProperty.call(n, "tokenUnpause") && c.proto.TokenUnpauseTransactionBody.encode(n.tokenUnpause, i.uint32(378).fork()).ldelim(), n.cryptoApproveAllowance != null && Object.hasOwnProperty.call(n, "cryptoApproveAllowance") && c.proto.CryptoApproveAllowanceTransactionBody.encode(n.cryptoApproveAllowance, i.uint32(386).fork()).ldelim(), n.cryptoDeleteAllowance != null && Object.hasOwnProperty.call(n, "cryptoDeleteAllowance") && c.proto.CryptoDeleteAllowanceTransactionBody.encode(n.cryptoDeleteAllowance, i.uint32(394).fork()).ldelim(), n.ethereumTransaction != null && Object.hasOwnProperty.call(n, "ethereumTransaction") && c.proto.EthereumTransactionBody.encode(n.ethereumTransaction, i.uint32(402).fork()).ldelim(), n.nodeStakeUpdate != null && Object.hasOwnProperty.call(n, "nodeStakeUpdate") && c.proto.NodeStakeUpdateTransactionBody.encode(n.nodeStakeUpdate, i.uint32(410).fork()).ldelim(), n.utilPrng != null && Object.hasOwnProperty.call(n, "utilPrng") && c.proto.UtilPrngTransactionBody.encode(n.utilPrng, i.uint32(418).fork()).ldelim(), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.TransactionBody(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.transactionID = c.proto.TransactionID.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.nodeAccountID = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 3: {
            m.transactionFee = n.uint64();
            break;
          }
          case 4: {
            m.transactionValidDuration = c.proto.Duration.decode(n, n.uint32());
            break;
          }
          case 5: {
            m.generateRecord = n.bool();
            break;
          }
          case 6: {
            m.memo = n.string();
            break;
          }
          case 7: {
            m.contractCall = c.proto.ContractCallTransactionBody.decode(n, n.uint32());
            break;
          }
          case 8: {
            m.contractCreateInstance = c.proto.ContractCreateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 9: {
            m.contractUpdateInstance = c.proto.ContractUpdateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 22: {
            m.contractDeleteInstance = c.proto.ContractDeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 50: {
            m.ethereumTransaction = c.proto.EthereumTransactionBody.decode(n, n.uint32());
            break;
          }
          case 10: {
            m.cryptoAddLiveHash = c.proto.CryptoAddLiveHashTransactionBody.decode(n, n.uint32());
            break;
          }
          case 48: {
            m.cryptoApproveAllowance = c.proto.CryptoApproveAllowanceTransactionBody.decode(n, n.uint32());
            break;
          }
          case 49: {
            m.cryptoDeleteAllowance = c.proto.CryptoDeleteAllowanceTransactionBody.decode(n, n.uint32());
            break;
          }
          case 11: {
            m.cryptoCreateAccount = c.proto.CryptoCreateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 12: {
            m.cryptoDelete = c.proto.CryptoDeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 13: {
            m.cryptoDeleteLiveHash = c.proto.CryptoDeleteLiveHashTransactionBody.decode(n, n.uint32());
            break;
          }
          case 14: {
            m.cryptoTransfer = c.proto.CryptoTransferTransactionBody.decode(n, n.uint32());
            break;
          }
          case 15: {
            m.cryptoUpdateAccount = c.proto.CryptoUpdateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 16: {
            m.fileAppend = c.proto.FileAppendTransactionBody.decode(n, n.uint32());
            break;
          }
          case 17: {
            m.fileCreate = c.proto.FileCreateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 18: {
            m.fileDelete = c.proto.FileDeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 19: {
            m.fileUpdate = c.proto.FileUpdateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 20: {
            m.systemDelete = c.proto.SystemDeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 21: {
            m.systemUndelete = c.proto.SystemUndeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 23: {
            m.freeze = c.proto.FreezeTransactionBody.decode(n, n.uint32());
            break;
          }
          case 24: {
            m.consensusCreateTopic = c.proto.ConsensusCreateTopicTransactionBody.decode(n, n.uint32());
            break;
          }
          case 25: {
            m.consensusUpdateTopic = c.proto.ConsensusUpdateTopicTransactionBody.decode(n, n.uint32());
            break;
          }
          case 26: {
            m.consensusDeleteTopic = c.proto.ConsensusDeleteTopicTransactionBody.decode(n, n.uint32());
            break;
          }
          case 27: {
            m.consensusSubmitMessage = c.proto.ConsensusSubmitMessageTransactionBody.decode(n, n.uint32());
            break;
          }
          case 28: {
            m.uncheckedSubmit = c.proto.UncheckedSubmitBody.decode(n, n.uint32());
            break;
          }
          case 29: {
            m.tokenCreation = c.proto.TokenCreateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 31: {
            m.tokenFreeze = c.proto.TokenFreezeAccountTransactionBody.decode(n, n.uint32());
            break;
          }
          case 32: {
            m.tokenUnfreeze = c.proto.TokenUnfreezeAccountTransactionBody.decode(n, n.uint32());
            break;
          }
          case 33: {
            m.tokenGrantKyc = c.proto.TokenGrantKycTransactionBody.decode(n, n.uint32());
            break;
          }
          case 34: {
            m.tokenRevokeKyc = c.proto.TokenRevokeKycTransactionBody.decode(n, n.uint32());
            break;
          }
          case 35: {
            m.tokenDeletion = c.proto.TokenDeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 36: {
            m.tokenUpdate = c.proto.TokenUpdateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 37: {
            m.tokenMint = c.proto.TokenMintTransactionBody.decode(n, n.uint32());
            break;
          }
          case 38: {
            m.tokenBurn = c.proto.TokenBurnTransactionBody.decode(n, n.uint32());
            break;
          }
          case 39: {
            m.tokenWipe = c.proto.TokenWipeAccountTransactionBody.decode(n, n.uint32());
            break;
          }
          case 40: {
            m.tokenAssociate = c.proto.TokenAssociateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 41: {
            m.tokenDissociate = c.proto.TokenDissociateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 45: {
            m.tokenFeeScheduleUpdate = c.proto.TokenFeeScheduleUpdateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 46: {
            m.tokenPause = c.proto.TokenPauseTransactionBody.decode(n, n.uint32());
            break;
          }
          case 47: {
            m.tokenUnpause = c.proto.TokenUnpauseTransactionBody.decode(n, n.uint32());
            break;
          }
          case 42: {
            m.scheduleCreate = c.proto.ScheduleCreateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 43: {
            m.scheduleDelete = c.proto.ScheduleDeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 44: {
            m.scheduleSign = c.proto.ScheduleSignTransactionBody.decode(n, n.uint32());
            break;
          }
          case 51: {
            m.nodeStakeUpdate = c.proto.NodeStakeUpdateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 52: {
            m.utilPrng = c.proto.UtilPrngTransactionBody.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.TransactionBody";
    }, o;
  }(), SystemDeleteTransactionBody: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.fileID = null, o.prototype.contractID = null, o.prototype.expirationTime = null;
    let e;
    return Object.defineProperty(o.prototype, "id", { get: g.oneOfGetter(e = ["fileID", "contractID"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.fileID != null && Object.hasOwnProperty.call(n, "fileID") && c.proto.FileID.encode(n.fileID, i.uint32(10).fork()).ldelim(), n.contractID != null && Object.hasOwnProperty.call(n, "contractID") && c.proto.ContractID.encode(n.contractID, i.uint32(18).fork()).ldelim(), n.expirationTime != null && Object.hasOwnProperty.call(n, "expirationTime") && c.proto.TimestampSeconds.encode(n.expirationTime, i.uint32(26).fork()).ldelim(), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.SystemDeleteTransactionBody(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.fileID = c.proto.FileID.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.contractID = c.proto.ContractID.decode(n, n.uint32());
            break;
          }
          case 3: {
            m.expirationTime = c.proto.TimestampSeconds.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.SystemDeleteTransactionBody";
    }, o;
  }(), SystemUndeleteTransactionBody: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.fileID = null, o.prototype.contractID = null;
    let e;
    return Object.defineProperty(o.prototype, "id", { get: g.oneOfGetter(e = ["fileID", "contractID"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.fileID != null && Object.hasOwnProperty.call(n, "fileID") && c.proto.FileID.encode(n.fileID, i.uint32(10).fork()).ldelim(), n.contractID != null && Object.hasOwnProperty.call(n, "contractID") && c.proto.ContractID.encode(n.contractID, i.uint32(18).fork()).ldelim(), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.SystemUndeleteTransactionBody(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.fileID = c.proto.FileID.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.contractID = c.proto.ContractID.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.SystemUndeleteTransactionBody";
    }, o;
  }(), FreezeTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.startHour = 0, o.prototype.startMin = 0, o.prototype.endHour = 0, o.prototype.endMin = 0, o.prototype.updateFile = null, o.prototype.fileHash = g.newBuffer([]), o.prototype.startTime = null, o.prototype.freezeType = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.startHour != null && Object.hasOwnProperty.call(e, "startHour") && n.uint32(8).int32(e.startHour), e.startMin != null && Object.hasOwnProperty.call(e, "startMin") && n.uint32(16).int32(e.startMin), e.endHour != null && Object.hasOwnProperty.call(e, "endHour") && n.uint32(24).int32(e.endHour), e.endMin != null && Object.hasOwnProperty.call(e, "endMin") && n.uint32(32).int32(e.endMin), e.updateFile != null && Object.hasOwnProperty.call(e, "updateFile") && c.proto.FileID.encode(e.updateFile, n.uint32(42).fork()).ldelim(), e.fileHash != null && Object.hasOwnProperty.call(e, "fileHash") && n.uint32(50).bytes(e.fileHash), e.startTime != null && Object.hasOwnProperty.call(e, "startTime") && c.proto.Timestamp.encode(e.startTime, n.uint32(58).fork()).ldelim(), e.freezeType != null && Object.hasOwnProperty.call(e, "freezeType") && n.uint32(64).int32(e.freezeType), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FreezeTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.startHour = e.int32();
            break;
          }
          case 2: {
            y.startMin = e.int32();
            break;
          }
          case 3: {
            y.endHour = e.int32();
            break;
          }
          case 4: {
            y.endMin = e.int32();
            break;
          }
          case 5: {
            y.updateFile = c.proto.FileID.decode(e, e.uint32());
            break;
          }
          case 6: {
            y.fileHash = e.bytes();
            break;
          }
          case 7: {
            y.startTime = c.proto.Timestamp.decode(e, e.uint32());
            break;
          }
          case 8: {
            y.freezeType = e.int32();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FreezeTransactionBody";
    }, o;
  }(), FreezeType: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "UNKNOWN_FREEZE_TYPE"] = 0, e[o[1] = "FREEZE_ONLY"] = 1, e[o[2] = "PREPARE_UPGRADE"] = 2, e[o[3] = "FREEZE_UPGRADE"] = 3, e[o[4] = "FREEZE_ABORT"] = 4, e[o[5] = "TELEMETRY_UPGRADE"] = 5, e;
  }(), ContractCallTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.contractID = null, o.prototype.gas = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.amount = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.functionParameters = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.contractID != null && Object.hasOwnProperty.call(e, "contractID") && c.proto.ContractID.encode(e.contractID, n.uint32(10).fork()).ldelim(), e.gas != null && Object.hasOwnProperty.call(e, "gas") && n.uint32(16).int64(e.gas), e.amount != null && Object.hasOwnProperty.call(e, "amount") && n.uint32(24).int64(e.amount), e.functionParameters != null && Object.hasOwnProperty.call(e, "functionParameters") && n.uint32(34).bytes(e.functionParameters), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractCallTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.contractID = c.proto.ContractID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.gas = e.int64();
            break;
          }
          case 3: {
            y.amount = e.int64();
            break;
          }
          case 4: {
            y.functionParameters = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractCallTransactionBody";
    }, o;
  }(), ContractCreateTransactionBody: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.fileID = null, o.prototype.initcode = null, o.prototype.adminKey = null, o.prototype.gas = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.initialBalance = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.proxyAccountID = null, o.prototype.autoRenewPeriod = null, o.prototype.constructorParameters = g.newBuffer([]), o.prototype.shardID = null, o.prototype.realmID = null, o.prototype.newRealmAdminKey = null, o.prototype.memo = "", o.prototype.maxAutomaticTokenAssociations = 0, o.prototype.autoRenewAccountId = null, o.prototype.stakedAccountId = null, o.prototype.stakedNodeId = null, o.prototype.declineReward = !1;
    let e;
    return Object.defineProperty(o.prototype, "initcodeSource", { get: g.oneOfGetter(e = ["fileID", "initcode"]), set: g.oneOfSetter(e) }), Object.defineProperty(o.prototype, "stakedId", { get: g.oneOfGetter(e = ["stakedAccountId", "stakedNodeId"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.fileID != null && Object.hasOwnProperty.call(n, "fileID") && c.proto.FileID.encode(n.fileID, i.uint32(10).fork()).ldelim(), n.adminKey != null && Object.hasOwnProperty.call(n, "adminKey") && c.proto.Key.encode(n.adminKey, i.uint32(26).fork()).ldelim(), n.gas != null && Object.hasOwnProperty.call(n, "gas") && i.uint32(32).int64(n.gas), n.initialBalance != null && Object.hasOwnProperty.call(n, "initialBalance") && i.uint32(40).int64(n.initialBalance), n.proxyAccountID != null && Object.hasOwnProperty.call(n, "proxyAccountID") && c.proto.AccountID.encode(n.proxyAccountID, i.uint32(50).fork()).ldelim(), n.autoRenewPeriod != null && Object.hasOwnProperty.call(n, "autoRenewPeriod") && c.proto.Duration.encode(n.autoRenewPeriod, i.uint32(66).fork()).ldelim(), n.constructorParameters != null && Object.hasOwnProperty.call(n, "constructorParameters") && i.uint32(74).bytes(n.constructorParameters), n.shardID != null && Object.hasOwnProperty.call(n, "shardID") && c.proto.ShardID.encode(n.shardID, i.uint32(82).fork()).ldelim(), n.realmID != null && Object.hasOwnProperty.call(n, "realmID") && c.proto.RealmID.encode(n.realmID, i.uint32(90).fork()).ldelim(), n.newRealmAdminKey != null && Object.hasOwnProperty.call(n, "newRealmAdminKey") && c.proto.Key.encode(n.newRealmAdminKey, i.uint32(98).fork()).ldelim(), n.memo != null && Object.hasOwnProperty.call(n, "memo") && i.uint32(106).string(n.memo), n.maxAutomaticTokenAssociations != null && Object.hasOwnProperty.call(n, "maxAutomaticTokenAssociations") && i.uint32(112).int32(n.maxAutomaticTokenAssociations), n.autoRenewAccountId != null && Object.hasOwnProperty.call(n, "autoRenewAccountId") && c.proto.AccountID.encode(n.autoRenewAccountId, i.uint32(122).fork()).ldelim(), n.initcode != null && Object.hasOwnProperty.call(n, "initcode") && i.uint32(130).bytes(n.initcode), n.stakedAccountId != null && Object.hasOwnProperty.call(n, "stakedAccountId") && c.proto.AccountID.encode(n.stakedAccountId, i.uint32(138).fork()).ldelim(), n.stakedNodeId != null && Object.hasOwnProperty.call(n, "stakedNodeId") && i.uint32(144).int64(n.stakedNodeId), n.declineReward != null && Object.hasOwnProperty.call(n, "declineReward") && i.uint32(152).bool(n.declineReward), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.ContractCreateTransactionBody(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.fileID = c.proto.FileID.decode(n, n.uint32());
            break;
          }
          case 16: {
            m.initcode = n.bytes();
            break;
          }
          case 3: {
            m.adminKey = c.proto.Key.decode(n, n.uint32());
            break;
          }
          case 4: {
            m.gas = n.int64();
            break;
          }
          case 5: {
            m.initialBalance = n.int64();
            break;
          }
          case 6: {
            m.proxyAccountID = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 8: {
            m.autoRenewPeriod = c.proto.Duration.decode(n, n.uint32());
            break;
          }
          case 9: {
            m.constructorParameters = n.bytes();
            break;
          }
          case 10: {
            m.shardID = c.proto.ShardID.decode(n, n.uint32());
            break;
          }
          case 11: {
            m.realmID = c.proto.RealmID.decode(n, n.uint32());
            break;
          }
          case 12: {
            m.newRealmAdminKey = c.proto.Key.decode(n, n.uint32());
            break;
          }
          case 13: {
            m.memo = n.string();
            break;
          }
          case 14: {
            m.maxAutomaticTokenAssociations = n.int32();
            break;
          }
          case 15: {
            m.autoRenewAccountId = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 17: {
            m.stakedAccountId = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 18: {
            m.stakedNodeId = n.int64();
            break;
          }
          case 19: {
            m.declineReward = n.bool();
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.ContractCreateTransactionBody";
    }, o;
  }(), ContractUpdateTransactionBody: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.contractID = null, o.prototype.expirationTime = null, o.prototype.adminKey = null, o.prototype.proxyAccountID = null, o.prototype.autoRenewPeriod = null, o.prototype.fileID = null, o.prototype.memo = null, o.prototype.memoWrapper = null, o.prototype.maxAutomaticTokenAssociations = null, o.prototype.autoRenewAccountId = null, o.prototype.stakedAccountId = null, o.prototype.stakedNodeId = null, o.prototype.declineReward = null;
    let e;
    return Object.defineProperty(o.prototype, "memoField", { get: g.oneOfGetter(e = ["memo", "memoWrapper"]), set: g.oneOfSetter(e) }), Object.defineProperty(o.prototype, "stakedId", { get: g.oneOfGetter(e = ["stakedAccountId", "stakedNodeId"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.contractID != null && Object.hasOwnProperty.call(n, "contractID") && c.proto.ContractID.encode(n.contractID, i.uint32(10).fork()).ldelim(), n.expirationTime != null && Object.hasOwnProperty.call(n, "expirationTime") && c.proto.Timestamp.encode(n.expirationTime, i.uint32(18).fork()).ldelim(), n.adminKey != null && Object.hasOwnProperty.call(n, "adminKey") && c.proto.Key.encode(n.adminKey, i.uint32(26).fork()).ldelim(), n.proxyAccountID != null && Object.hasOwnProperty.call(n, "proxyAccountID") && c.proto.AccountID.encode(n.proxyAccountID, i.uint32(50).fork()).ldelim(), n.autoRenewPeriod != null && Object.hasOwnProperty.call(n, "autoRenewPeriod") && c.proto.Duration.encode(n.autoRenewPeriod, i.uint32(58).fork()).ldelim(), n.fileID != null && Object.hasOwnProperty.call(n, "fileID") && c.proto.FileID.encode(n.fileID, i.uint32(66).fork()).ldelim(), n.memo != null && Object.hasOwnProperty.call(n, "memo") && i.uint32(74).string(n.memo), n.memoWrapper != null && Object.hasOwnProperty.call(n, "memoWrapper") && c.google.protobuf.StringValue.encode(n.memoWrapper, i.uint32(82).fork()).ldelim(), n.maxAutomaticTokenAssociations != null && Object.hasOwnProperty.call(n, "maxAutomaticTokenAssociations") && c.google.protobuf.Int32Value.encode(n.maxAutomaticTokenAssociations, i.uint32(90).fork()).ldelim(), n.autoRenewAccountId != null && Object.hasOwnProperty.call(n, "autoRenewAccountId") && c.proto.AccountID.encode(n.autoRenewAccountId, i.uint32(98).fork()).ldelim(), n.stakedAccountId != null && Object.hasOwnProperty.call(n, "stakedAccountId") && c.proto.AccountID.encode(n.stakedAccountId, i.uint32(106).fork()).ldelim(), n.stakedNodeId != null && Object.hasOwnProperty.call(n, "stakedNodeId") && i.uint32(112).int64(n.stakedNodeId), n.declineReward != null && Object.hasOwnProperty.call(n, "declineReward") && c.google.protobuf.BoolValue.encode(n.declineReward, i.uint32(122).fork()).ldelim(), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.ContractUpdateTransactionBody(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.contractID = c.proto.ContractID.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.expirationTime = c.proto.Timestamp.decode(n, n.uint32());
            break;
          }
          case 3: {
            m.adminKey = c.proto.Key.decode(n, n.uint32());
            break;
          }
          case 6: {
            m.proxyAccountID = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 7: {
            m.autoRenewPeriod = c.proto.Duration.decode(n, n.uint32());
            break;
          }
          case 8: {
            m.fileID = c.proto.FileID.decode(n, n.uint32());
            break;
          }
          case 9: {
            m.memo = n.string();
            break;
          }
          case 10: {
            m.memoWrapper = c.google.protobuf.StringValue.decode(n, n.uint32());
            break;
          }
          case 11: {
            m.maxAutomaticTokenAssociations = c.google.protobuf.Int32Value.decode(n, n.uint32());
            break;
          }
          case 12: {
            m.autoRenewAccountId = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 13: {
            m.stakedAccountId = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 14: {
            m.stakedNodeId = n.int64();
            break;
          }
          case 15: {
            m.declineReward = c.google.protobuf.BoolValue.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.ContractUpdateTransactionBody";
    }, o;
  }(), LiveHash: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.accountId = null, o.prototype.hash = g.newBuffer([]), o.prototype.keys = null, o.prototype.duration = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.accountId != null && Object.hasOwnProperty.call(e, "accountId") && c.proto.AccountID.encode(e.accountId, n.uint32(10).fork()).ldelim(), e.hash != null && Object.hasOwnProperty.call(e, "hash") && n.uint32(18).bytes(e.hash), e.keys != null && Object.hasOwnProperty.call(e, "keys") && c.proto.KeyList.encode(e.keys, n.uint32(26).fork()).ldelim(), e.duration != null && Object.hasOwnProperty.call(e, "duration") && c.proto.Duration.encode(e.duration, n.uint32(42).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.LiveHash(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.accountId = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.hash = e.bytes();
            break;
          }
          case 3: {
            y.keys = c.proto.KeyList.decode(e, e.uint32());
            break;
          }
          case 5: {
            y.duration = c.proto.Duration.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.LiveHash";
    }, o;
  }(), CryptoAddLiveHashTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.liveHash = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.liveHash != null && Object.hasOwnProperty.call(e, "liveHash") && c.proto.LiveHash.encode(e.liveHash, n.uint32(26).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoAddLiveHashTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 3: {
            y.liveHash = c.proto.LiveHash.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoAddLiveHashTransactionBody";
    }, o;
  }(), CryptoCreateTransactionBody: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.key = null, o.prototype.initialBalance = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.proxyAccountID = null, o.prototype.sendRecordThreshold = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.receiveRecordThreshold = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.receiverSigRequired = !1, o.prototype.autoRenewPeriod = null, o.prototype.shardID = null, o.prototype.realmID = null, o.prototype.newRealmAdminKey = null, o.prototype.memo = "", o.prototype.maxAutomaticTokenAssociations = 0, o.prototype.stakedAccountId = null, o.prototype.stakedNodeId = null, o.prototype.declineReward = !1, o.prototype.alias = g.newBuffer([]);
    let e;
    return Object.defineProperty(o.prototype, "stakedId", { get: g.oneOfGetter(e = ["stakedAccountId", "stakedNodeId"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.key != null && Object.hasOwnProperty.call(n, "key") && c.proto.Key.encode(n.key, i.uint32(10).fork()).ldelim(), n.initialBalance != null && Object.hasOwnProperty.call(n, "initialBalance") && i.uint32(16).uint64(n.initialBalance), n.proxyAccountID != null && Object.hasOwnProperty.call(n, "proxyAccountID") && c.proto.AccountID.encode(n.proxyAccountID, i.uint32(26).fork()).ldelim(), n.sendRecordThreshold != null && Object.hasOwnProperty.call(n, "sendRecordThreshold") && i.uint32(48).uint64(n.sendRecordThreshold), n.receiveRecordThreshold != null && Object.hasOwnProperty.call(n, "receiveRecordThreshold") && i.uint32(56).uint64(n.receiveRecordThreshold), n.receiverSigRequired != null && Object.hasOwnProperty.call(n, "receiverSigRequired") && i.uint32(64).bool(n.receiverSigRequired), n.autoRenewPeriod != null && Object.hasOwnProperty.call(n, "autoRenewPeriod") && c.proto.Duration.encode(n.autoRenewPeriod, i.uint32(74).fork()).ldelim(), n.shardID != null && Object.hasOwnProperty.call(n, "shardID") && c.proto.ShardID.encode(n.shardID, i.uint32(82).fork()).ldelim(), n.realmID != null && Object.hasOwnProperty.call(n, "realmID") && c.proto.RealmID.encode(n.realmID, i.uint32(90).fork()).ldelim(), n.newRealmAdminKey != null && Object.hasOwnProperty.call(n, "newRealmAdminKey") && c.proto.Key.encode(n.newRealmAdminKey, i.uint32(98).fork()).ldelim(), n.memo != null && Object.hasOwnProperty.call(n, "memo") && i.uint32(106).string(n.memo), n.maxAutomaticTokenAssociations != null && Object.hasOwnProperty.call(n, "maxAutomaticTokenAssociations") && i.uint32(112).int32(n.maxAutomaticTokenAssociations), n.stakedAccountId != null && Object.hasOwnProperty.call(n, "stakedAccountId") && c.proto.AccountID.encode(n.stakedAccountId, i.uint32(122).fork()).ldelim(), n.stakedNodeId != null && Object.hasOwnProperty.call(n, "stakedNodeId") && i.uint32(128).int64(n.stakedNodeId), n.declineReward != null && Object.hasOwnProperty.call(n, "declineReward") && i.uint32(136).bool(n.declineReward), n.alias != null && Object.hasOwnProperty.call(n, "alias") && i.uint32(146).bytes(n.alias), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.CryptoCreateTransactionBody(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.key = c.proto.Key.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.initialBalance = n.uint64();
            break;
          }
          case 3: {
            m.proxyAccountID = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 6: {
            m.sendRecordThreshold = n.uint64();
            break;
          }
          case 7: {
            m.receiveRecordThreshold = n.uint64();
            break;
          }
          case 8: {
            m.receiverSigRequired = n.bool();
            break;
          }
          case 9: {
            m.autoRenewPeriod = c.proto.Duration.decode(n, n.uint32());
            break;
          }
          case 10: {
            m.shardID = c.proto.ShardID.decode(n, n.uint32());
            break;
          }
          case 11: {
            m.realmID = c.proto.RealmID.decode(n, n.uint32());
            break;
          }
          case 12: {
            m.newRealmAdminKey = c.proto.Key.decode(n, n.uint32());
            break;
          }
          case 13: {
            m.memo = n.string();
            break;
          }
          case 14: {
            m.maxAutomaticTokenAssociations = n.int32();
            break;
          }
          case 15: {
            m.stakedAccountId = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 16: {
            m.stakedNodeId = n.int64();
            break;
          }
          case 17: {
            m.declineReward = n.bool();
            break;
          }
          case 18: {
            m.alias = n.bytes();
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.CryptoCreateTransactionBody";
    }, o;
  }(), CryptoDeleteTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.transferAccountID = null, o.prototype.deleteAccountID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.transferAccountID != null && Object.hasOwnProperty.call(e, "transferAccountID") && c.proto.AccountID.encode(e.transferAccountID, n.uint32(10).fork()).ldelim(), e.deleteAccountID != null && Object.hasOwnProperty.call(e, "deleteAccountID") && c.proto.AccountID.encode(e.deleteAccountID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoDeleteTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.transferAccountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.deleteAccountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoDeleteTransactionBody";
    }, o;
  }(), CryptoDeleteLiveHashTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.accountOfLiveHash = null, o.prototype.liveHashToDelete = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.accountOfLiveHash != null && Object.hasOwnProperty.call(e, "accountOfLiveHash") && c.proto.AccountID.encode(e.accountOfLiveHash, n.uint32(10).fork()).ldelim(), e.liveHashToDelete != null && Object.hasOwnProperty.call(e, "liveHashToDelete") && n.uint32(18).bytes(e.liveHashToDelete), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoDeleteLiveHashTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.accountOfLiveHash = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.liveHashToDelete = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoDeleteLiveHashTransactionBody";
    }, o;
  }(), CryptoTransferTransactionBody: function() {
    function o(e) {
      if (this.tokenTransfers = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.transfers = null, o.prototype.tokenTransfers = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.transfers != null && Object.hasOwnProperty.call(e, "transfers") && c.proto.TransferList.encode(e.transfers, n.uint32(10).fork()).ldelim(), e.tokenTransfers != null && e.tokenTransfers.length)
        for (var i = 0; i < e.tokenTransfers.length; ++i)
          c.proto.TokenTransferList.encode(e.tokenTransfers[i], n.uint32(18).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoTransferTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.transfers = c.proto.TransferList.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.tokenTransfers && y.tokenTransfers.length || (y.tokenTransfers = []), y.tokenTransfers.push(c.proto.TokenTransferList.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoTransferTransactionBody";
    }, o;
  }(), CryptoUpdateTransactionBody: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.accountIDToUpdate = null, o.prototype.key = null, o.prototype.proxyAccountID = null, o.prototype.proxyFraction = 0, o.prototype.sendRecordThreshold = null, o.prototype.sendRecordThresholdWrapper = null, o.prototype.receiveRecordThreshold = null, o.prototype.receiveRecordThresholdWrapper = null, o.prototype.autoRenewPeriod = null, o.prototype.expirationTime = null, o.prototype.receiverSigRequired = null, o.prototype.receiverSigRequiredWrapper = null, o.prototype.memo = null, o.prototype.maxAutomaticTokenAssociations = null, o.prototype.stakedAccountId = null, o.prototype.stakedNodeId = null, o.prototype.declineReward = null;
    let e;
    return Object.defineProperty(o.prototype, "sendRecordThresholdField", { get: g.oneOfGetter(e = ["sendRecordThreshold", "sendRecordThresholdWrapper"]), set: g.oneOfSetter(e) }), Object.defineProperty(o.prototype, "receiveRecordThresholdField", { get: g.oneOfGetter(e = ["receiveRecordThreshold", "receiveRecordThresholdWrapper"]), set: g.oneOfSetter(e) }), Object.defineProperty(o.prototype, "receiverSigRequiredField", { get: g.oneOfGetter(e = ["receiverSigRequired", "receiverSigRequiredWrapper"]), set: g.oneOfSetter(e) }), Object.defineProperty(o.prototype, "stakedId", { get: g.oneOfGetter(e = ["stakedAccountId", "stakedNodeId"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.accountIDToUpdate != null && Object.hasOwnProperty.call(n, "accountIDToUpdate") && c.proto.AccountID.encode(n.accountIDToUpdate, i.uint32(18).fork()).ldelim(), n.key != null && Object.hasOwnProperty.call(n, "key") && c.proto.Key.encode(n.key, i.uint32(26).fork()).ldelim(), n.proxyAccountID != null && Object.hasOwnProperty.call(n, "proxyAccountID") && c.proto.AccountID.encode(n.proxyAccountID, i.uint32(34).fork()).ldelim(), n.proxyFraction != null && Object.hasOwnProperty.call(n, "proxyFraction") && i.uint32(40).int32(n.proxyFraction), n.sendRecordThreshold != null && Object.hasOwnProperty.call(n, "sendRecordThreshold") && i.uint32(48).uint64(n.sendRecordThreshold), n.receiveRecordThreshold != null && Object.hasOwnProperty.call(n, "receiveRecordThreshold") && i.uint32(56).uint64(n.receiveRecordThreshold), n.autoRenewPeriod != null && Object.hasOwnProperty.call(n, "autoRenewPeriod") && c.proto.Duration.encode(n.autoRenewPeriod, i.uint32(66).fork()).ldelim(), n.expirationTime != null && Object.hasOwnProperty.call(n, "expirationTime") && c.proto.Timestamp.encode(n.expirationTime, i.uint32(74).fork()).ldelim(), n.receiverSigRequired != null && Object.hasOwnProperty.call(n, "receiverSigRequired") && i.uint32(80).bool(n.receiverSigRequired), n.sendRecordThresholdWrapper != null && Object.hasOwnProperty.call(n, "sendRecordThresholdWrapper") && c.google.protobuf.UInt64Value.encode(n.sendRecordThresholdWrapper, i.uint32(90).fork()).ldelim(), n.receiveRecordThresholdWrapper != null && Object.hasOwnProperty.call(n, "receiveRecordThresholdWrapper") && c.google.protobuf.UInt64Value.encode(n.receiveRecordThresholdWrapper, i.uint32(98).fork()).ldelim(), n.receiverSigRequiredWrapper != null && Object.hasOwnProperty.call(n, "receiverSigRequiredWrapper") && c.google.protobuf.BoolValue.encode(n.receiverSigRequiredWrapper, i.uint32(106).fork()).ldelim(), n.memo != null && Object.hasOwnProperty.call(n, "memo") && c.google.protobuf.StringValue.encode(n.memo, i.uint32(114).fork()).ldelim(), n.maxAutomaticTokenAssociations != null && Object.hasOwnProperty.call(n, "maxAutomaticTokenAssociations") && c.google.protobuf.Int32Value.encode(n.maxAutomaticTokenAssociations, i.uint32(122).fork()).ldelim(), n.stakedAccountId != null && Object.hasOwnProperty.call(n, "stakedAccountId") && c.proto.AccountID.encode(n.stakedAccountId, i.uint32(130).fork()).ldelim(), n.stakedNodeId != null && Object.hasOwnProperty.call(n, "stakedNodeId") && i.uint32(136).int64(n.stakedNodeId), n.declineReward != null && Object.hasOwnProperty.call(n, "declineReward") && c.google.protobuf.BoolValue.encode(n.declineReward, i.uint32(146).fork()).ldelim(), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.CryptoUpdateTransactionBody(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 2: {
            m.accountIDToUpdate = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 3: {
            m.key = c.proto.Key.decode(n, n.uint32());
            break;
          }
          case 4: {
            m.proxyAccountID = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 5: {
            m.proxyFraction = n.int32();
            break;
          }
          case 6: {
            m.sendRecordThreshold = n.uint64();
            break;
          }
          case 11: {
            m.sendRecordThresholdWrapper = c.google.protobuf.UInt64Value.decode(n, n.uint32());
            break;
          }
          case 7: {
            m.receiveRecordThreshold = n.uint64();
            break;
          }
          case 12: {
            m.receiveRecordThresholdWrapper = c.google.protobuf.UInt64Value.decode(n, n.uint32());
            break;
          }
          case 8: {
            m.autoRenewPeriod = c.proto.Duration.decode(n, n.uint32());
            break;
          }
          case 9: {
            m.expirationTime = c.proto.Timestamp.decode(n, n.uint32());
            break;
          }
          case 10: {
            m.receiverSigRequired = n.bool();
            break;
          }
          case 13: {
            m.receiverSigRequiredWrapper = c.google.protobuf.BoolValue.decode(n, n.uint32());
            break;
          }
          case 14: {
            m.memo = c.google.protobuf.StringValue.decode(n, n.uint32());
            break;
          }
          case 15: {
            m.maxAutomaticTokenAssociations = c.google.protobuf.Int32Value.decode(n, n.uint32());
            break;
          }
          case 16: {
            m.stakedAccountId = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 17: {
            m.stakedNodeId = n.int64();
            break;
          }
          case 18: {
            m.declineReward = c.google.protobuf.BoolValue.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.CryptoUpdateTransactionBody";
    }, o;
  }(), CryptoApproveAllowanceTransactionBody: function() {
    function o(e) {
      if (this.cryptoAllowances = [], this.nftAllowances = [], this.tokenAllowances = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.cryptoAllowances = g.emptyArray, o.prototype.nftAllowances = g.emptyArray, o.prototype.tokenAllowances = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.cryptoAllowances != null && e.cryptoAllowances.length)
        for (var i = 0; i < e.cryptoAllowances.length; ++i)
          c.proto.CryptoAllowance.encode(e.cryptoAllowances[i], n.uint32(10).fork()).ldelim();
      if (e.nftAllowances != null && e.nftAllowances.length)
        for (var i = 0; i < e.nftAllowances.length; ++i)
          c.proto.NftAllowance.encode(e.nftAllowances[i], n.uint32(18).fork()).ldelim();
      if (e.tokenAllowances != null && e.tokenAllowances.length)
        for (var i = 0; i < e.tokenAllowances.length; ++i)
          c.proto.TokenAllowance.encode(e.tokenAllowances[i], n.uint32(26).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoApproveAllowanceTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.cryptoAllowances && y.cryptoAllowances.length || (y.cryptoAllowances = []), y.cryptoAllowances.push(c.proto.CryptoAllowance.decode(e, e.uint32()));
            break;
          }
          case 2: {
            y.nftAllowances && y.nftAllowances.length || (y.nftAllowances = []), y.nftAllowances.push(c.proto.NftAllowance.decode(e, e.uint32()));
            break;
          }
          case 3: {
            y.tokenAllowances && y.tokenAllowances.length || (y.tokenAllowances = []), y.tokenAllowances.push(c.proto.TokenAllowance.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoApproveAllowanceTransactionBody";
    }, o;
  }(), CryptoAllowance: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.owner = null, o.prototype.spender = null, o.prototype.amount = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.owner != null && Object.hasOwnProperty.call(e, "owner") && c.proto.AccountID.encode(e.owner, n.uint32(10).fork()).ldelim(), e.spender != null && Object.hasOwnProperty.call(e, "spender") && c.proto.AccountID.encode(e.spender, n.uint32(18).fork()).ldelim(), e.amount != null && Object.hasOwnProperty.call(e, "amount") && n.uint32(24).int64(e.amount), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoAllowance(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.owner = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.spender = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.amount = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoAllowance";
    }, o;
  }(), NftAllowance: function() {
    function o(e) {
      if (this.serialNumbers = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.tokenId = null, o.prototype.owner = null, o.prototype.spender = null, o.prototype.serialNumbers = g.emptyArray, o.prototype.approvedForAll = null, o.prototype.delegatingSpender = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.tokenId != null && Object.hasOwnProperty.call(e, "tokenId") && c.proto.TokenID.encode(e.tokenId, n.uint32(10).fork()).ldelim(), e.owner != null && Object.hasOwnProperty.call(e, "owner") && c.proto.AccountID.encode(e.owner, n.uint32(18).fork()).ldelim(), e.spender != null && Object.hasOwnProperty.call(e, "spender") && c.proto.AccountID.encode(e.spender, n.uint32(26).fork()).ldelim(), e.serialNumbers != null && e.serialNumbers.length) {
        n.uint32(34).fork();
        for (var i = 0; i < e.serialNumbers.length; ++i)
          n.int64(e.serialNumbers[i]);
        n.ldelim();
      }
      return e.approvedForAll != null && Object.hasOwnProperty.call(e, "approvedForAll") && c.google.protobuf.BoolValue.encode(e.approvedForAll, n.uint32(42).fork()).ldelim(), e.delegatingSpender != null && Object.hasOwnProperty.call(e, "delegatingSpender") && c.proto.AccountID.encode(e.delegatingSpender, n.uint32(50).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.NftAllowance(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.tokenId = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.owner = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.spender = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 4: {
            if (y.serialNumbers && y.serialNumbers.length || (y.serialNumbers = []), (7 & m) == 2)
              for (var U = e.uint32() + e.pos; e.pos < U; )
                y.serialNumbers.push(e.int64());
            else
              y.serialNumbers.push(e.int64());
            break;
          }
          case 5: {
            y.approvedForAll = c.google.protobuf.BoolValue.decode(e, e.uint32());
            break;
          }
          case 6: {
            y.delegatingSpender = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.NftAllowance";
    }, o;
  }(), TokenAllowance: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.tokenId = null, o.prototype.owner = null, o.prototype.spender = null, o.prototype.amount = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.tokenId != null && Object.hasOwnProperty.call(e, "tokenId") && c.proto.TokenID.encode(e.tokenId, n.uint32(10).fork()).ldelim(), e.owner != null && Object.hasOwnProperty.call(e, "owner") && c.proto.AccountID.encode(e.owner, n.uint32(18).fork()).ldelim(), e.spender != null && Object.hasOwnProperty.call(e, "spender") && c.proto.AccountID.encode(e.spender, n.uint32(26).fork()).ldelim(), e.amount != null && Object.hasOwnProperty.call(e, "amount") && n.uint32(32).int64(e.amount), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenAllowance(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.tokenId = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.owner = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.spender = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.amount = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenAllowance";
    }, o;
  }(), CryptoDeleteAllowanceTransactionBody: function() {
    function o(e) {
      if (this.nftAllowances = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.nftAllowances = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.nftAllowances != null && e.nftAllowances.length)
        for (var i = 0; i < e.nftAllowances.length; ++i)
          c.proto.NftRemoveAllowance.encode(e.nftAllowances[i], n.uint32(18).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoDeleteAllowanceTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 2: {
            y.nftAllowances && y.nftAllowances.length || (y.nftAllowances = []), y.nftAllowances.push(c.proto.NftRemoveAllowance.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoDeleteAllowanceTransactionBody";
    }, o;
  }(), NftRemoveAllowance: function() {
    function o(e) {
      if (this.serialNumbers = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.tokenId = null, o.prototype.owner = null, o.prototype.serialNumbers = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.tokenId != null && Object.hasOwnProperty.call(e, "tokenId") && c.proto.TokenID.encode(e.tokenId, n.uint32(10).fork()).ldelim(), e.owner != null && Object.hasOwnProperty.call(e, "owner") && c.proto.AccountID.encode(e.owner, n.uint32(18).fork()).ldelim(), e.serialNumbers != null && e.serialNumbers.length) {
        n.uint32(26).fork();
        for (var i = 0; i < e.serialNumbers.length; ++i)
          n.int64(e.serialNumbers[i]);
        n.ldelim();
      }
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.NftRemoveAllowance(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.tokenId = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.owner = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            if (y.serialNumbers && y.serialNumbers.length || (y.serialNumbers = []), (7 & m) == 2)
              for (var U = e.uint32() + e.pos; e.pos < U; )
                y.serialNumbers.push(e.int64());
            else
              y.serialNumbers.push(e.int64());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.NftRemoveAllowance";
    }, o;
  }(), EthereumTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.ethereumData = g.newBuffer([]), o.prototype.callData = null, o.prototype.maxGasAllowance = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.ethereumData != null && Object.hasOwnProperty.call(e, "ethereumData") && n.uint32(10).bytes(e.ethereumData), e.callData != null && Object.hasOwnProperty.call(e, "callData") && c.proto.FileID.encode(e.callData, n.uint32(18).fork()).ldelim(), e.maxGasAllowance != null && Object.hasOwnProperty.call(e, "maxGasAllowance") && n.uint32(24).int64(e.maxGasAllowance), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.EthereumTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.ethereumData = e.bytes();
            break;
          }
          case 2: {
            y.callData = c.proto.FileID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.maxGasAllowance = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.EthereumTransactionBody";
    }, o;
  }(), FileAppendTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.fileID = null, o.prototype.contents = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.fileID != null && Object.hasOwnProperty.call(e, "fileID") && c.proto.FileID.encode(e.fileID, n.uint32(18).fork()).ldelim(), e.contents != null && Object.hasOwnProperty.call(e, "contents") && n.uint32(34).bytes(e.contents), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FileAppendTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 2: {
            y.fileID = c.proto.FileID.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.contents = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FileAppendTransactionBody";
    }, o;
  }(), FileCreateTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.expirationTime = null, o.prototype.keys = null, o.prototype.contents = g.newBuffer([]), o.prototype.shardID = null, o.prototype.realmID = null, o.prototype.newRealmAdminKey = null, o.prototype.memo = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.expirationTime != null && Object.hasOwnProperty.call(e, "expirationTime") && c.proto.Timestamp.encode(e.expirationTime, n.uint32(18).fork()).ldelim(), e.keys != null && Object.hasOwnProperty.call(e, "keys") && c.proto.KeyList.encode(e.keys, n.uint32(26).fork()).ldelim(), e.contents != null && Object.hasOwnProperty.call(e, "contents") && n.uint32(34).bytes(e.contents), e.shardID != null && Object.hasOwnProperty.call(e, "shardID") && c.proto.ShardID.encode(e.shardID, n.uint32(42).fork()).ldelim(), e.realmID != null && Object.hasOwnProperty.call(e, "realmID") && c.proto.RealmID.encode(e.realmID, n.uint32(50).fork()).ldelim(), e.newRealmAdminKey != null && Object.hasOwnProperty.call(e, "newRealmAdminKey") && c.proto.Key.encode(e.newRealmAdminKey, n.uint32(58).fork()).ldelim(), e.memo != null && Object.hasOwnProperty.call(e, "memo") && n.uint32(66).string(e.memo), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FileCreateTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 2: {
            y.expirationTime = c.proto.Timestamp.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.keys = c.proto.KeyList.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.contents = e.bytes();
            break;
          }
          case 5: {
            y.shardID = c.proto.ShardID.decode(e, e.uint32());
            break;
          }
          case 6: {
            y.realmID = c.proto.RealmID.decode(e, e.uint32());
            break;
          }
          case 7: {
            y.newRealmAdminKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 8: {
            y.memo = e.string();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FileCreateTransactionBody";
    }, o;
  }(), FileDeleteTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.fileID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.fileID != null && Object.hasOwnProperty.call(e, "fileID") && c.proto.FileID.encode(e.fileID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FileDeleteTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 2: {
            y.fileID = c.proto.FileID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FileDeleteTransactionBody";
    }, o;
  }(), FileUpdateTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.fileID = null, o.prototype.expirationTime = null, o.prototype.keys = null, o.prototype.contents = g.newBuffer([]), o.prototype.memo = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.fileID != null && Object.hasOwnProperty.call(e, "fileID") && c.proto.FileID.encode(e.fileID, n.uint32(10).fork()).ldelim(), e.expirationTime != null && Object.hasOwnProperty.call(e, "expirationTime") && c.proto.Timestamp.encode(e.expirationTime, n.uint32(18).fork()).ldelim(), e.keys != null && Object.hasOwnProperty.call(e, "keys") && c.proto.KeyList.encode(e.keys, n.uint32(26).fork()).ldelim(), e.contents != null && Object.hasOwnProperty.call(e, "contents") && n.uint32(34).bytes(e.contents), e.memo != null && Object.hasOwnProperty.call(e, "memo") && c.google.protobuf.StringValue.encode(e.memo, n.uint32(42).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FileUpdateTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.fileID = c.proto.FileID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.expirationTime = c.proto.Timestamp.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.keys = c.proto.KeyList.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.contents = e.bytes();
            break;
          }
          case 5: {
            y.memo = c.google.protobuf.StringValue.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FileUpdateTransactionBody";
    }, o;
  }(), ContractDeleteTransactionBody: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.contractID = null, o.prototype.transferAccountID = null, o.prototype.transferContractID = null, o.prototype.permanentRemoval = !1;
    let e;
    return Object.defineProperty(o.prototype, "obtainers", { get: g.oneOfGetter(e = ["transferAccountID", "transferContractID"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.contractID != null && Object.hasOwnProperty.call(n, "contractID") && c.proto.ContractID.encode(n.contractID, i.uint32(10).fork()).ldelim(), n.transferAccountID != null && Object.hasOwnProperty.call(n, "transferAccountID") && c.proto.AccountID.encode(n.transferAccountID, i.uint32(18).fork()).ldelim(), n.transferContractID != null && Object.hasOwnProperty.call(n, "transferContractID") && c.proto.ContractID.encode(n.transferContractID, i.uint32(26).fork()).ldelim(), n.permanentRemoval != null && Object.hasOwnProperty.call(n, "permanentRemoval") && i.uint32(32).bool(n.permanentRemoval), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.ContractDeleteTransactionBody(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.contractID = c.proto.ContractID.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.transferAccountID = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 3: {
            m.transferContractID = c.proto.ContractID.decode(n, n.uint32());
            break;
          }
          case 4: {
            m.permanentRemoval = n.bool();
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.ContractDeleteTransactionBody";
    }, o;
  }(), ConsensusUpdateTopicTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.topicID = null, o.prototype.memo = null, o.prototype.expirationTime = null, o.prototype.adminKey = null, o.prototype.submitKey = null, o.prototype.autoRenewPeriod = null, o.prototype.autoRenewAccount = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.topicID != null && Object.hasOwnProperty.call(e, "topicID") && c.proto.TopicID.encode(e.topicID, n.uint32(10).fork()).ldelim(), e.memo != null && Object.hasOwnProperty.call(e, "memo") && c.google.protobuf.StringValue.encode(e.memo, n.uint32(18).fork()).ldelim(), e.expirationTime != null && Object.hasOwnProperty.call(e, "expirationTime") && c.proto.Timestamp.encode(e.expirationTime, n.uint32(34).fork()).ldelim(), e.adminKey != null && Object.hasOwnProperty.call(e, "adminKey") && c.proto.Key.encode(e.adminKey, n.uint32(50).fork()).ldelim(), e.submitKey != null && Object.hasOwnProperty.call(e, "submitKey") && c.proto.Key.encode(e.submitKey, n.uint32(58).fork()).ldelim(), e.autoRenewPeriod != null && Object.hasOwnProperty.call(e, "autoRenewPeriod") && c.proto.Duration.encode(e.autoRenewPeriod, n.uint32(66).fork()).ldelim(), e.autoRenewAccount != null && Object.hasOwnProperty.call(e, "autoRenewAccount") && c.proto.AccountID.encode(e.autoRenewAccount, n.uint32(74).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ConsensusUpdateTopicTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.topicID = c.proto.TopicID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.memo = c.google.protobuf.StringValue.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.expirationTime = c.proto.Timestamp.decode(e, e.uint32());
            break;
          }
          case 6: {
            y.adminKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 7: {
            y.submitKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 8: {
            y.autoRenewPeriod = c.proto.Duration.decode(e, e.uint32());
            break;
          }
          case 9: {
            y.autoRenewAccount = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ConsensusUpdateTopicTransactionBody";
    }, o;
  }(), ConsensusMessageChunkInfo: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.initialTransactionID = null, o.prototype.total = 0, o.prototype.number = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.initialTransactionID != null && Object.hasOwnProperty.call(e, "initialTransactionID") && c.proto.TransactionID.encode(e.initialTransactionID, n.uint32(10).fork()).ldelim(), e.total != null && Object.hasOwnProperty.call(e, "total") && n.uint32(16).int32(e.total), e.number != null && Object.hasOwnProperty.call(e, "number") && n.uint32(24).int32(e.number), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ConsensusMessageChunkInfo(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.initialTransactionID = c.proto.TransactionID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.total = e.int32();
            break;
          }
          case 3: {
            y.number = e.int32();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ConsensusMessageChunkInfo";
    }, o;
  }(), ConsensusSubmitMessageTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.topicID = null, o.prototype.message = g.newBuffer([]), o.prototype.chunkInfo = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.topicID != null && Object.hasOwnProperty.call(e, "topicID") && c.proto.TopicID.encode(e.topicID, n.uint32(10).fork()).ldelim(), e.message != null && Object.hasOwnProperty.call(e, "message") && n.uint32(18).bytes(e.message), e.chunkInfo != null && Object.hasOwnProperty.call(e, "chunkInfo") && c.proto.ConsensusMessageChunkInfo.encode(e.chunkInfo, n.uint32(26).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ConsensusSubmitMessageTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.topicID = c.proto.TopicID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.message = e.bytes();
            break;
          }
          case 3: {
            y.chunkInfo = c.proto.ConsensusMessageChunkInfo.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ConsensusSubmitMessageTransactionBody";
    }, o;
  }(), UncheckedSubmitBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.transactionBytes = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.transactionBytes != null && Object.hasOwnProperty.call(e, "transactionBytes") && n.uint32(10).bytes(e.transactionBytes), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.UncheckedSubmitBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.transactionBytes = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.UncheckedSubmitBody";
    }, o;
  }(), TokenCreateTransactionBody: function() {
    function o(e) {
      if (this.customFees = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.name = "", o.prototype.symbol = "", o.prototype.decimals = 0, o.prototype.initialSupply = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.treasury = null, o.prototype.adminKey = null, o.prototype.kycKey = null, o.prototype.freezeKey = null, o.prototype.wipeKey = null, o.prototype.supplyKey = null, o.prototype.freezeDefault = !1, o.prototype.expiry = null, o.prototype.autoRenewAccount = null, o.prototype.autoRenewPeriod = null, o.prototype.memo = "", o.prototype.tokenType = 0, o.prototype.supplyType = 0, o.prototype.maxSupply = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.feeScheduleKey = null, o.prototype.customFees = g.emptyArray, o.prototype.pauseKey = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(10).string(e.name), e.symbol != null && Object.hasOwnProperty.call(e, "symbol") && n.uint32(18).string(e.symbol), e.decimals != null && Object.hasOwnProperty.call(e, "decimals") && n.uint32(24).uint32(e.decimals), e.initialSupply != null && Object.hasOwnProperty.call(e, "initialSupply") && n.uint32(32).uint64(e.initialSupply), e.treasury != null && Object.hasOwnProperty.call(e, "treasury") && c.proto.AccountID.encode(e.treasury, n.uint32(42).fork()).ldelim(), e.adminKey != null && Object.hasOwnProperty.call(e, "adminKey") && c.proto.Key.encode(e.adminKey, n.uint32(50).fork()).ldelim(), e.kycKey != null && Object.hasOwnProperty.call(e, "kycKey") && c.proto.Key.encode(e.kycKey, n.uint32(58).fork()).ldelim(), e.freezeKey != null && Object.hasOwnProperty.call(e, "freezeKey") && c.proto.Key.encode(e.freezeKey, n.uint32(66).fork()).ldelim(), e.wipeKey != null && Object.hasOwnProperty.call(e, "wipeKey") && c.proto.Key.encode(e.wipeKey, n.uint32(74).fork()).ldelim(), e.supplyKey != null && Object.hasOwnProperty.call(e, "supplyKey") && c.proto.Key.encode(e.supplyKey, n.uint32(82).fork()).ldelim(), e.freezeDefault != null && Object.hasOwnProperty.call(e, "freezeDefault") && n.uint32(88).bool(e.freezeDefault), e.expiry != null && Object.hasOwnProperty.call(e, "expiry") && c.proto.Timestamp.encode(e.expiry, n.uint32(106).fork()).ldelim(), e.autoRenewAccount != null && Object.hasOwnProperty.call(e, "autoRenewAccount") && c.proto.AccountID.encode(e.autoRenewAccount, n.uint32(114).fork()).ldelim(), e.autoRenewPeriod != null && Object.hasOwnProperty.call(e, "autoRenewPeriod") && c.proto.Duration.encode(e.autoRenewPeriod, n.uint32(122).fork()).ldelim(), e.memo != null && Object.hasOwnProperty.call(e, "memo") && n.uint32(130).string(e.memo), e.tokenType != null && Object.hasOwnProperty.call(e, "tokenType") && n.uint32(136).int32(e.tokenType), e.supplyType != null && Object.hasOwnProperty.call(e, "supplyType") && n.uint32(144).int32(e.supplyType), e.maxSupply != null && Object.hasOwnProperty.call(e, "maxSupply") && n.uint32(152).int64(e.maxSupply), e.feeScheduleKey != null && Object.hasOwnProperty.call(e, "feeScheduleKey") && c.proto.Key.encode(e.feeScheduleKey, n.uint32(162).fork()).ldelim(), e.customFees != null && e.customFees.length)
        for (var i = 0; i < e.customFees.length; ++i)
          c.proto.CustomFee.encode(e.customFees[i], n.uint32(170).fork()).ldelim();
      return e.pauseKey != null && Object.hasOwnProperty.call(e, "pauseKey") && c.proto.Key.encode(e.pauseKey, n.uint32(178).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenCreateTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.name = e.string();
            break;
          }
          case 2: {
            y.symbol = e.string();
            break;
          }
          case 3: {
            y.decimals = e.uint32();
            break;
          }
          case 4: {
            y.initialSupply = e.uint64();
            break;
          }
          case 5: {
            y.treasury = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 6: {
            y.adminKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 7: {
            y.kycKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 8: {
            y.freezeKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 9: {
            y.wipeKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 10: {
            y.supplyKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 11: {
            y.freezeDefault = e.bool();
            break;
          }
          case 13: {
            y.expiry = c.proto.Timestamp.decode(e, e.uint32());
            break;
          }
          case 14: {
            y.autoRenewAccount = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 15: {
            y.autoRenewPeriod = c.proto.Duration.decode(e, e.uint32());
            break;
          }
          case 16: {
            y.memo = e.string();
            break;
          }
          case 17: {
            y.tokenType = e.int32();
            break;
          }
          case 18: {
            y.supplyType = e.int32();
            break;
          }
          case 19: {
            y.maxSupply = e.int64();
            break;
          }
          case 20: {
            y.feeScheduleKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 21: {
            y.customFees && y.customFees.length || (y.customFees = []), y.customFees.push(c.proto.CustomFee.decode(e, e.uint32()));
            break;
          }
          case 22: {
            y.pauseKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenCreateTransactionBody";
    }, o;
  }(), FractionalFee: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.fractionalAmount = null, o.prototype.minimumAmount = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.maximumAmount = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.netOfTransfers = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.fractionalAmount != null && Object.hasOwnProperty.call(e, "fractionalAmount") && c.proto.Fraction.encode(e.fractionalAmount, n.uint32(10).fork()).ldelim(), e.minimumAmount != null && Object.hasOwnProperty.call(e, "minimumAmount") && n.uint32(16).int64(e.minimumAmount), e.maximumAmount != null && Object.hasOwnProperty.call(e, "maximumAmount") && n.uint32(24).int64(e.maximumAmount), e.netOfTransfers != null && Object.hasOwnProperty.call(e, "netOfTransfers") && n.uint32(32).bool(e.netOfTransfers), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FractionalFee(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.fractionalAmount = c.proto.Fraction.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.minimumAmount = e.int64();
            break;
          }
          case 3: {
            y.maximumAmount = e.int64();
            break;
          }
          case 4: {
            y.netOfTransfers = e.bool();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FractionalFee";
    }, o;
  }(), FixedFee: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.amount = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.denominatingTokenId = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.amount != null && Object.hasOwnProperty.call(e, "amount") && n.uint32(8).int64(e.amount), e.denominatingTokenId != null && Object.hasOwnProperty.call(e, "denominatingTokenId") && c.proto.TokenID.encode(e.denominatingTokenId, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FixedFee(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.amount = e.int64();
            break;
          }
          case 2: {
            y.denominatingTokenId = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FixedFee";
    }, o;
  }(), RoyaltyFee: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.exchangeValueFraction = null, o.prototype.fallbackFee = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.exchangeValueFraction != null && Object.hasOwnProperty.call(e, "exchangeValueFraction") && c.proto.Fraction.encode(e.exchangeValueFraction, n.uint32(10).fork()).ldelim(), e.fallbackFee != null && Object.hasOwnProperty.call(e, "fallbackFee") && c.proto.FixedFee.encode(e.fallbackFee, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.RoyaltyFee(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.exchangeValueFraction = c.proto.Fraction.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.fallbackFee = c.proto.FixedFee.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.RoyaltyFee";
    }, o;
  }(), CustomFee: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.fixedFee = null, o.prototype.fractionalFee = null, o.prototype.royaltyFee = null, o.prototype.feeCollectorAccountId = null, o.prototype.allCollectorsAreExempt = !1;
    let e;
    return Object.defineProperty(o.prototype, "fee", { get: g.oneOfGetter(e = ["fixedFee", "fractionalFee", "royaltyFee"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.fixedFee != null && Object.hasOwnProperty.call(n, "fixedFee") && c.proto.FixedFee.encode(n.fixedFee, i.uint32(10).fork()).ldelim(), n.fractionalFee != null && Object.hasOwnProperty.call(n, "fractionalFee") && c.proto.FractionalFee.encode(n.fractionalFee, i.uint32(18).fork()).ldelim(), n.feeCollectorAccountId != null && Object.hasOwnProperty.call(n, "feeCollectorAccountId") && c.proto.AccountID.encode(n.feeCollectorAccountId, i.uint32(26).fork()).ldelim(), n.royaltyFee != null && Object.hasOwnProperty.call(n, "royaltyFee") && c.proto.RoyaltyFee.encode(n.royaltyFee, i.uint32(34).fork()).ldelim(), n.allCollectorsAreExempt != null && Object.hasOwnProperty.call(n, "allCollectorsAreExempt") && i.uint32(40).bool(n.allCollectorsAreExempt), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.CustomFee(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.fixedFee = c.proto.FixedFee.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.fractionalFee = c.proto.FractionalFee.decode(n, n.uint32());
            break;
          }
          case 4: {
            m.royaltyFee = c.proto.RoyaltyFee.decode(n, n.uint32());
            break;
          }
          case 3: {
            m.feeCollectorAccountId = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 5: {
            m.allCollectorsAreExempt = n.bool();
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.CustomFee";
    }, o;
  }(), AssessedCustomFee: function() {
    function o(e) {
      if (this.effectivePayerAccountId = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.amount = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.tokenId = null, o.prototype.feeCollectorAccountId = null, o.prototype.effectivePayerAccountId = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.amount != null && Object.hasOwnProperty.call(e, "amount") && n.uint32(8).int64(e.amount), e.tokenId != null && Object.hasOwnProperty.call(e, "tokenId") && c.proto.TokenID.encode(e.tokenId, n.uint32(18).fork()).ldelim(), e.feeCollectorAccountId != null && Object.hasOwnProperty.call(e, "feeCollectorAccountId") && c.proto.AccountID.encode(e.feeCollectorAccountId, n.uint32(26).fork()).ldelim(), e.effectivePayerAccountId != null && e.effectivePayerAccountId.length)
        for (var i = 0; i < e.effectivePayerAccountId.length; ++i)
          c.proto.AccountID.encode(e.effectivePayerAccountId[i], n.uint32(34).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.AssessedCustomFee(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.amount = e.int64();
            break;
          }
          case 2: {
            y.tokenId = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.feeCollectorAccountId = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.effectivePayerAccountId && y.effectivePayerAccountId.length || (y.effectivePayerAccountId = []), y.effectivePayerAccountId.push(c.proto.AccountID.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.AssessedCustomFee";
    }, o;
  }(), TokenFreezeAccountTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.token = null, o.prototype.account = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && c.proto.TokenID.encode(e.token, n.uint32(10).fork()).ldelim(), e.account != null && Object.hasOwnProperty.call(e, "account") && c.proto.AccountID.encode(e.account, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenFreezeAccountTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.token = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.account = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenFreezeAccountTransactionBody";
    }, o;
  }(), TokenUnfreezeAccountTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.token = null, o.prototype.account = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && c.proto.TokenID.encode(e.token, n.uint32(10).fork()).ldelim(), e.account != null && Object.hasOwnProperty.call(e, "account") && c.proto.AccountID.encode(e.account, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenUnfreezeAccountTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.token = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.account = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenUnfreezeAccountTransactionBody";
    }, o;
  }(), TokenGrantKycTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.token = null, o.prototype.account = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && c.proto.TokenID.encode(e.token, n.uint32(10).fork()).ldelim(), e.account != null && Object.hasOwnProperty.call(e, "account") && c.proto.AccountID.encode(e.account, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenGrantKycTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.token = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.account = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenGrantKycTransactionBody";
    }, o;
  }(), TokenRevokeKycTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.token = null, o.prototype.account = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && c.proto.TokenID.encode(e.token, n.uint32(10).fork()).ldelim(), e.account != null && Object.hasOwnProperty.call(e, "account") && c.proto.AccountID.encode(e.account, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenRevokeKycTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.token = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.account = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenRevokeKycTransactionBody";
    }, o;
  }(), TokenDeleteTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.token = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && c.proto.TokenID.encode(e.token, n.uint32(10).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenDeleteTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.token = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenDeleteTransactionBody";
    }, o;
  }(), TokenUpdateTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.token = null, o.prototype.symbol = "", o.prototype.name = "", o.prototype.treasury = null, o.prototype.adminKey = null, o.prototype.kycKey = null, o.prototype.freezeKey = null, o.prototype.wipeKey = null, o.prototype.supplyKey = null, o.prototype.autoRenewAccount = null, o.prototype.autoRenewPeriod = null, o.prototype.expiry = null, o.prototype.memo = null, o.prototype.feeScheduleKey = null, o.prototype.pauseKey = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && c.proto.TokenID.encode(e.token, n.uint32(10).fork()).ldelim(), e.symbol != null && Object.hasOwnProperty.call(e, "symbol") && n.uint32(18).string(e.symbol), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(26).string(e.name), e.treasury != null && Object.hasOwnProperty.call(e, "treasury") && c.proto.AccountID.encode(e.treasury, n.uint32(34).fork()).ldelim(), e.adminKey != null && Object.hasOwnProperty.call(e, "adminKey") && c.proto.Key.encode(e.adminKey, n.uint32(42).fork()).ldelim(), e.kycKey != null && Object.hasOwnProperty.call(e, "kycKey") && c.proto.Key.encode(e.kycKey, n.uint32(50).fork()).ldelim(), e.freezeKey != null && Object.hasOwnProperty.call(e, "freezeKey") && c.proto.Key.encode(e.freezeKey, n.uint32(58).fork()).ldelim(), e.wipeKey != null && Object.hasOwnProperty.call(e, "wipeKey") && c.proto.Key.encode(e.wipeKey, n.uint32(66).fork()).ldelim(), e.supplyKey != null && Object.hasOwnProperty.call(e, "supplyKey") && c.proto.Key.encode(e.supplyKey, n.uint32(74).fork()).ldelim(), e.autoRenewAccount != null && Object.hasOwnProperty.call(e, "autoRenewAccount") && c.proto.AccountID.encode(e.autoRenewAccount, n.uint32(82).fork()).ldelim(), e.autoRenewPeriod != null && Object.hasOwnProperty.call(e, "autoRenewPeriod") && c.proto.Duration.encode(e.autoRenewPeriod, n.uint32(90).fork()).ldelim(), e.expiry != null && Object.hasOwnProperty.call(e, "expiry") && c.proto.Timestamp.encode(e.expiry, n.uint32(98).fork()).ldelim(), e.memo != null && Object.hasOwnProperty.call(e, "memo") && c.google.protobuf.StringValue.encode(e.memo, n.uint32(106).fork()).ldelim(), e.feeScheduleKey != null && Object.hasOwnProperty.call(e, "feeScheduleKey") && c.proto.Key.encode(e.feeScheduleKey, n.uint32(114).fork()).ldelim(), e.pauseKey != null && Object.hasOwnProperty.call(e, "pauseKey") && c.proto.Key.encode(e.pauseKey, n.uint32(122).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenUpdateTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.token = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.symbol = e.string();
            break;
          }
          case 3: {
            y.name = e.string();
            break;
          }
          case 4: {
            y.treasury = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 5: {
            y.adminKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 6: {
            y.kycKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 7: {
            y.freezeKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 8: {
            y.wipeKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 9: {
            y.supplyKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 10: {
            y.autoRenewAccount = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 11: {
            y.autoRenewPeriod = c.proto.Duration.decode(e, e.uint32());
            break;
          }
          case 12: {
            y.expiry = c.proto.Timestamp.decode(e, e.uint32());
            break;
          }
          case 13: {
            y.memo = c.google.protobuf.StringValue.decode(e, e.uint32());
            break;
          }
          case 14: {
            y.feeScheduleKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 15: {
            y.pauseKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenUpdateTransactionBody";
    }, o;
  }(), TokenMintTransactionBody: function() {
    function o(e) {
      if (this.metadata = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.token = null, o.prototype.amount = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.metadata = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && c.proto.TokenID.encode(e.token, n.uint32(10).fork()).ldelim(), e.amount != null && Object.hasOwnProperty.call(e, "amount") && n.uint32(16).uint64(e.amount), e.metadata != null && e.metadata.length)
        for (var i = 0; i < e.metadata.length; ++i)
          n.uint32(26).bytes(e.metadata[i]);
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenMintTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.token = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.amount = e.uint64();
            break;
          }
          case 3: {
            y.metadata && y.metadata.length || (y.metadata = []), y.metadata.push(e.bytes());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenMintTransactionBody";
    }, o;
  }(), TokenBurnTransactionBody: function() {
    function o(e) {
      if (this.serialNumbers = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.token = null, o.prototype.amount = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.serialNumbers = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && c.proto.TokenID.encode(e.token, n.uint32(10).fork()).ldelim(), e.amount != null && Object.hasOwnProperty.call(e, "amount") && n.uint32(16).uint64(e.amount), e.serialNumbers != null && e.serialNumbers.length) {
        n.uint32(26).fork();
        for (var i = 0; i < e.serialNumbers.length; ++i)
          n.int64(e.serialNumbers[i]);
        n.ldelim();
      }
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenBurnTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.token = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.amount = e.uint64();
            break;
          }
          case 3: {
            if (y.serialNumbers && y.serialNumbers.length || (y.serialNumbers = []), (7 & m) == 2)
              for (var U = e.uint32() + e.pos; e.pos < U; )
                y.serialNumbers.push(e.int64());
            else
              y.serialNumbers.push(e.int64());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenBurnTransactionBody";
    }, o;
  }(), TokenWipeAccountTransactionBody: function() {
    function o(e) {
      if (this.serialNumbers = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.token = null, o.prototype.account = null, o.prototype.amount = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.serialNumbers = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && c.proto.TokenID.encode(e.token, n.uint32(10).fork()).ldelim(), e.account != null && Object.hasOwnProperty.call(e, "account") && c.proto.AccountID.encode(e.account, n.uint32(18).fork()).ldelim(), e.amount != null && Object.hasOwnProperty.call(e, "amount") && n.uint32(24).uint64(e.amount), e.serialNumbers != null && e.serialNumbers.length) {
        n.uint32(34).fork();
        for (var i = 0; i < e.serialNumbers.length; ++i)
          n.int64(e.serialNumbers[i]);
        n.ldelim();
      }
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenWipeAccountTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.token = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.account = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.amount = e.uint64();
            break;
          }
          case 4: {
            if (y.serialNumbers && y.serialNumbers.length || (y.serialNumbers = []), (7 & m) == 2)
              for (var U = e.uint32() + e.pos; e.pos < U; )
                y.serialNumbers.push(e.int64());
            else
              y.serialNumbers.push(e.int64());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenWipeAccountTransactionBody";
    }, o;
  }(), TokenAssociateTransactionBody: function() {
    function o(e) {
      if (this.tokens = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.account = null, o.prototype.tokens = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.account != null && Object.hasOwnProperty.call(e, "account") && c.proto.AccountID.encode(e.account, n.uint32(10).fork()).ldelim(), e.tokens != null && e.tokens.length)
        for (var i = 0; i < e.tokens.length; ++i)
          c.proto.TokenID.encode(e.tokens[i], n.uint32(18).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenAssociateTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.account = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.tokens && y.tokens.length || (y.tokens = []), y.tokens.push(c.proto.TokenID.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenAssociateTransactionBody";
    }, o;
  }(), TokenDissociateTransactionBody: function() {
    function o(e) {
      if (this.tokens = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.account = null, o.prototype.tokens = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.account != null && Object.hasOwnProperty.call(e, "account") && c.proto.AccountID.encode(e.account, n.uint32(10).fork()).ldelim(), e.tokens != null && e.tokens.length)
        for (var i = 0; i < e.tokens.length; ++i)
          c.proto.TokenID.encode(e.tokens[i], n.uint32(18).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenDissociateTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.account = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.tokens && y.tokens.length || (y.tokens = []), y.tokens.push(c.proto.TokenID.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenDissociateTransactionBody";
    }, o;
  }(), TokenFeeScheduleUpdateTransactionBody: function() {
    function o(e) {
      if (this.customFees = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.tokenId = null, o.prototype.customFees = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.tokenId != null && Object.hasOwnProperty.call(e, "tokenId") && c.proto.TokenID.encode(e.tokenId, n.uint32(10).fork()).ldelim(), e.customFees != null && e.customFees.length)
        for (var i = 0; i < e.customFees.length; ++i)
          c.proto.CustomFee.encode(e.customFees[i], n.uint32(18).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenFeeScheduleUpdateTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.tokenId = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.customFees && y.customFees.length || (y.customFees = []), y.customFees.push(c.proto.CustomFee.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenFeeScheduleUpdateTransactionBody";
    }, o;
  }(), TokenPauseTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.token = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && c.proto.TokenID.encode(e.token, n.uint32(10).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenPauseTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.token = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenPauseTransactionBody";
    }, o;
  }(), TokenUnpauseTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.token = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && c.proto.TokenID.encode(e.token, n.uint32(10).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenUnpauseTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.token = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenUnpauseTransactionBody";
    }, o;
  }(), ScheduleCreateTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.scheduledTransactionBody = null, o.prototype.memo = "", o.prototype.adminKey = null, o.prototype.payerAccountID = null, o.prototype.expirationTime = null, o.prototype.waitForExpiry = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.scheduledTransactionBody != null && Object.hasOwnProperty.call(e, "scheduledTransactionBody") && c.proto.SchedulableTransactionBody.encode(e.scheduledTransactionBody, n.uint32(10).fork()).ldelim(), e.memo != null && Object.hasOwnProperty.call(e, "memo") && n.uint32(18).string(e.memo), e.adminKey != null && Object.hasOwnProperty.call(e, "adminKey") && c.proto.Key.encode(e.adminKey, n.uint32(26).fork()).ldelim(), e.payerAccountID != null && Object.hasOwnProperty.call(e, "payerAccountID") && c.proto.AccountID.encode(e.payerAccountID, n.uint32(34).fork()).ldelim(), e.expirationTime != null && Object.hasOwnProperty.call(e, "expirationTime") && c.proto.Timestamp.encode(e.expirationTime, n.uint32(42).fork()).ldelim(), e.waitForExpiry != null && Object.hasOwnProperty.call(e, "waitForExpiry") && n.uint32(104).bool(e.waitForExpiry), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ScheduleCreateTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.scheduledTransactionBody = c.proto.SchedulableTransactionBody.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.memo = e.string();
            break;
          }
          case 3: {
            y.adminKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.payerAccountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 5: {
            y.expirationTime = c.proto.Timestamp.decode(e, e.uint32());
            break;
          }
          case 13: {
            y.waitForExpiry = e.bool();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ScheduleCreateTransactionBody";
    }, o;
  }(), SchedulableTransactionBody: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.transactionFee = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.memo = "", o.prototype.contractCall = null, o.prototype.contractCreateInstance = null, o.prototype.contractUpdateInstance = null, o.prototype.contractDeleteInstance = null, o.prototype.cryptoApproveAllowance = null, o.prototype.cryptoDeleteAllowance = null, o.prototype.cryptoCreateAccount = null, o.prototype.cryptoDelete = null, o.prototype.cryptoTransfer = null, o.prototype.cryptoUpdateAccount = null, o.prototype.fileAppend = null, o.prototype.fileCreate = null, o.prototype.fileDelete = null, o.prototype.fileUpdate = null, o.prototype.systemDelete = null, o.prototype.systemUndelete = null, o.prototype.freeze = null, o.prototype.consensusCreateTopic = null, o.prototype.consensusUpdateTopic = null, o.prototype.consensusDeleteTopic = null, o.prototype.consensusSubmitMessage = null, o.prototype.tokenCreation = null, o.prototype.tokenFreeze = null, o.prototype.tokenUnfreeze = null, o.prototype.tokenGrantKyc = null, o.prototype.tokenRevokeKyc = null, o.prototype.tokenDeletion = null, o.prototype.tokenUpdate = null, o.prototype.tokenMint = null, o.prototype.tokenBurn = null, o.prototype.tokenWipe = null, o.prototype.tokenAssociate = null, o.prototype.tokenDissociate = null, o.prototype.tokenFeeScheduleUpdate = null, o.prototype.tokenPause = null, o.prototype.tokenUnpause = null, o.prototype.scheduleDelete = null, o.prototype.utilPrng = null;
    let e;
    return Object.defineProperty(o.prototype, "data", { get: g.oneOfGetter(e = ["contractCall", "contractCreateInstance", "contractUpdateInstance", "contractDeleteInstance", "cryptoApproveAllowance", "cryptoDeleteAllowance", "cryptoCreateAccount", "cryptoDelete", "cryptoTransfer", "cryptoUpdateAccount", "fileAppend", "fileCreate", "fileDelete", "fileUpdate", "systemDelete", "systemUndelete", "freeze", "consensusCreateTopic", "consensusUpdateTopic", "consensusDeleteTopic", "consensusSubmitMessage", "tokenCreation", "tokenFreeze", "tokenUnfreeze", "tokenGrantKyc", "tokenRevokeKyc", "tokenDeletion", "tokenUpdate", "tokenMint", "tokenBurn", "tokenWipe", "tokenAssociate", "tokenDissociate", "tokenFeeScheduleUpdate", "tokenPause", "tokenUnpause", "scheduleDelete", "utilPrng"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.transactionFee != null && Object.hasOwnProperty.call(n, "transactionFee") && i.uint32(8).uint64(n.transactionFee), n.memo != null && Object.hasOwnProperty.call(n, "memo") && i.uint32(18).string(n.memo), n.contractCall != null && Object.hasOwnProperty.call(n, "contractCall") && c.proto.ContractCallTransactionBody.encode(n.contractCall, i.uint32(26).fork()).ldelim(), n.contractCreateInstance != null && Object.hasOwnProperty.call(n, "contractCreateInstance") && c.proto.ContractCreateTransactionBody.encode(n.contractCreateInstance, i.uint32(34).fork()).ldelim(), n.contractUpdateInstance != null && Object.hasOwnProperty.call(n, "contractUpdateInstance") && c.proto.ContractUpdateTransactionBody.encode(n.contractUpdateInstance, i.uint32(42).fork()).ldelim(), n.contractDeleteInstance != null && Object.hasOwnProperty.call(n, "contractDeleteInstance") && c.proto.ContractDeleteTransactionBody.encode(n.contractDeleteInstance, i.uint32(50).fork()).ldelim(), n.cryptoCreateAccount != null && Object.hasOwnProperty.call(n, "cryptoCreateAccount") && c.proto.CryptoCreateTransactionBody.encode(n.cryptoCreateAccount, i.uint32(58).fork()).ldelim(), n.cryptoDelete != null && Object.hasOwnProperty.call(n, "cryptoDelete") && c.proto.CryptoDeleteTransactionBody.encode(n.cryptoDelete, i.uint32(66).fork()).ldelim(), n.cryptoTransfer != null && Object.hasOwnProperty.call(n, "cryptoTransfer") && c.proto.CryptoTransferTransactionBody.encode(n.cryptoTransfer, i.uint32(74).fork()).ldelim(), n.cryptoUpdateAccount != null && Object.hasOwnProperty.call(n, "cryptoUpdateAccount") && c.proto.CryptoUpdateTransactionBody.encode(n.cryptoUpdateAccount, i.uint32(82).fork()).ldelim(), n.fileAppend != null && Object.hasOwnProperty.call(n, "fileAppend") && c.proto.FileAppendTransactionBody.encode(n.fileAppend, i.uint32(90).fork()).ldelim(), n.fileCreate != null && Object.hasOwnProperty.call(n, "fileCreate") && c.proto.FileCreateTransactionBody.encode(n.fileCreate, i.uint32(98).fork()).ldelim(), n.fileDelete != null && Object.hasOwnProperty.call(n, "fileDelete") && c.proto.FileDeleteTransactionBody.encode(n.fileDelete, i.uint32(106).fork()).ldelim(), n.fileUpdate != null && Object.hasOwnProperty.call(n, "fileUpdate") && c.proto.FileUpdateTransactionBody.encode(n.fileUpdate, i.uint32(114).fork()).ldelim(), n.systemDelete != null && Object.hasOwnProperty.call(n, "systemDelete") && c.proto.SystemDeleteTransactionBody.encode(n.systemDelete, i.uint32(122).fork()).ldelim(), n.systemUndelete != null && Object.hasOwnProperty.call(n, "systemUndelete") && c.proto.SystemUndeleteTransactionBody.encode(n.systemUndelete, i.uint32(130).fork()).ldelim(), n.freeze != null && Object.hasOwnProperty.call(n, "freeze") && c.proto.FreezeTransactionBody.encode(n.freeze, i.uint32(138).fork()).ldelim(), n.consensusCreateTopic != null && Object.hasOwnProperty.call(n, "consensusCreateTopic") && c.proto.ConsensusCreateTopicTransactionBody.encode(n.consensusCreateTopic, i.uint32(146).fork()).ldelim(), n.consensusUpdateTopic != null && Object.hasOwnProperty.call(n, "consensusUpdateTopic") && c.proto.ConsensusUpdateTopicTransactionBody.encode(n.consensusUpdateTopic, i.uint32(154).fork()).ldelim(), n.consensusDeleteTopic != null && Object.hasOwnProperty.call(n, "consensusDeleteTopic") && c.proto.ConsensusDeleteTopicTransactionBody.encode(n.consensusDeleteTopic, i.uint32(162).fork()).ldelim(), n.consensusSubmitMessage != null && Object.hasOwnProperty.call(n, "consensusSubmitMessage") && c.proto.ConsensusSubmitMessageTransactionBody.encode(n.consensusSubmitMessage, i.uint32(170).fork()).ldelim(), n.tokenCreation != null && Object.hasOwnProperty.call(n, "tokenCreation") && c.proto.TokenCreateTransactionBody.encode(n.tokenCreation, i.uint32(178).fork()).ldelim(), n.tokenFreeze != null && Object.hasOwnProperty.call(n, "tokenFreeze") && c.proto.TokenFreezeAccountTransactionBody.encode(n.tokenFreeze, i.uint32(186).fork()).ldelim(), n.tokenUnfreeze != null && Object.hasOwnProperty.call(n, "tokenUnfreeze") && c.proto.TokenUnfreezeAccountTransactionBody.encode(n.tokenUnfreeze, i.uint32(194).fork()).ldelim(), n.tokenGrantKyc != null && Object.hasOwnProperty.call(n, "tokenGrantKyc") && c.proto.TokenGrantKycTransactionBody.encode(n.tokenGrantKyc, i.uint32(202).fork()).ldelim(), n.tokenRevokeKyc != null && Object.hasOwnProperty.call(n, "tokenRevokeKyc") && c.proto.TokenRevokeKycTransactionBody.encode(n.tokenRevokeKyc, i.uint32(210).fork()).ldelim(), n.tokenDeletion != null && Object.hasOwnProperty.call(n, "tokenDeletion") && c.proto.TokenDeleteTransactionBody.encode(n.tokenDeletion, i.uint32(218).fork()).ldelim(), n.tokenUpdate != null && Object.hasOwnProperty.call(n, "tokenUpdate") && c.proto.TokenUpdateTransactionBody.encode(n.tokenUpdate, i.uint32(226).fork()).ldelim(), n.tokenMint != null && Object.hasOwnProperty.call(n, "tokenMint") && c.proto.TokenMintTransactionBody.encode(n.tokenMint, i.uint32(234).fork()).ldelim(), n.tokenBurn != null && Object.hasOwnProperty.call(n, "tokenBurn") && c.proto.TokenBurnTransactionBody.encode(n.tokenBurn, i.uint32(242).fork()).ldelim(), n.tokenWipe != null && Object.hasOwnProperty.call(n, "tokenWipe") && c.proto.TokenWipeAccountTransactionBody.encode(n.tokenWipe, i.uint32(250).fork()).ldelim(), n.tokenAssociate != null && Object.hasOwnProperty.call(n, "tokenAssociate") && c.proto.TokenAssociateTransactionBody.encode(n.tokenAssociate, i.uint32(258).fork()).ldelim(), n.tokenDissociate != null && Object.hasOwnProperty.call(n, "tokenDissociate") && c.proto.TokenDissociateTransactionBody.encode(n.tokenDissociate, i.uint32(266).fork()).ldelim(), n.scheduleDelete != null && Object.hasOwnProperty.call(n, "scheduleDelete") && c.proto.ScheduleDeleteTransactionBody.encode(n.scheduleDelete, i.uint32(274).fork()).ldelim(), n.tokenPause != null && Object.hasOwnProperty.call(n, "tokenPause") && c.proto.TokenPauseTransactionBody.encode(n.tokenPause, i.uint32(282).fork()).ldelim(), n.tokenUnpause != null && Object.hasOwnProperty.call(n, "tokenUnpause") && c.proto.TokenUnpauseTransactionBody.encode(n.tokenUnpause, i.uint32(290).fork()).ldelim(), n.cryptoApproveAllowance != null && Object.hasOwnProperty.call(n, "cryptoApproveAllowance") && c.proto.CryptoApproveAllowanceTransactionBody.encode(n.cryptoApproveAllowance, i.uint32(298).fork()).ldelim(), n.cryptoDeleteAllowance != null && Object.hasOwnProperty.call(n, "cryptoDeleteAllowance") && c.proto.CryptoDeleteAllowanceTransactionBody.encode(n.cryptoDeleteAllowance, i.uint32(306).fork()).ldelim(), n.tokenFeeScheduleUpdate != null && Object.hasOwnProperty.call(n, "tokenFeeScheduleUpdate") && c.proto.TokenFeeScheduleUpdateTransactionBody.encode(n.tokenFeeScheduleUpdate, i.uint32(314).fork()).ldelim(), n.utilPrng != null && Object.hasOwnProperty.call(n, "utilPrng") && c.proto.UtilPrngTransactionBody.encode(n.utilPrng, i.uint32(322).fork()).ldelim(), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.SchedulableTransactionBody(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.transactionFee = n.uint64();
            break;
          }
          case 2: {
            m.memo = n.string();
            break;
          }
          case 3: {
            m.contractCall = c.proto.ContractCallTransactionBody.decode(n, n.uint32());
            break;
          }
          case 4: {
            m.contractCreateInstance = c.proto.ContractCreateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 5: {
            m.contractUpdateInstance = c.proto.ContractUpdateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 6: {
            m.contractDeleteInstance = c.proto.ContractDeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 37: {
            m.cryptoApproveAllowance = c.proto.CryptoApproveAllowanceTransactionBody.decode(n, n.uint32());
            break;
          }
          case 38: {
            m.cryptoDeleteAllowance = c.proto.CryptoDeleteAllowanceTransactionBody.decode(n, n.uint32());
            break;
          }
          case 7: {
            m.cryptoCreateAccount = c.proto.CryptoCreateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 8: {
            m.cryptoDelete = c.proto.CryptoDeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 9: {
            m.cryptoTransfer = c.proto.CryptoTransferTransactionBody.decode(n, n.uint32());
            break;
          }
          case 10: {
            m.cryptoUpdateAccount = c.proto.CryptoUpdateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 11: {
            m.fileAppend = c.proto.FileAppendTransactionBody.decode(n, n.uint32());
            break;
          }
          case 12: {
            m.fileCreate = c.proto.FileCreateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 13: {
            m.fileDelete = c.proto.FileDeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 14: {
            m.fileUpdate = c.proto.FileUpdateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 15: {
            m.systemDelete = c.proto.SystemDeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 16: {
            m.systemUndelete = c.proto.SystemUndeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 17: {
            m.freeze = c.proto.FreezeTransactionBody.decode(n, n.uint32());
            break;
          }
          case 18: {
            m.consensusCreateTopic = c.proto.ConsensusCreateTopicTransactionBody.decode(n, n.uint32());
            break;
          }
          case 19: {
            m.consensusUpdateTopic = c.proto.ConsensusUpdateTopicTransactionBody.decode(n, n.uint32());
            break;
          }
          case 20: {
            m.consensusDeleteTopic = c.proto.ConsensusDeleteTopicTransactionBody.decode(n, n.uint32());
            break;
          }
          case 21: {
            m.consensusSubmitMessage = c.proto.ConsensusSubmitMessageTransactionBody.decode(n, n.uint32());
            break;
          }
          case 22: {
            m.tokenCreation = c.proto.TokenCreateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 23: {
            m.tokenFreeze = c.proto.TokenFreezeAccountTransactionBody.decode(n, n.uint32());
            break;
          }
          case 24: {
            m.tokenUnfreeze = c.proto.TokenUnfreezeAccountTransactionBody.decode(n, n.uint32());
            break;
          }
          case 25: {
            m.tokenGrantKyc = c.proto.TokenGrantKycTransactionBody.decode(n, n.uint32());
            break;
          }
          case 26: {
            m.tokenRevokeKyc = c.proto.TokenRevokeKycTransactionBody.decode(n, n.uint32());
            break;
          }
          case 27: {
            m.tokenDeletion = c.proto.TokenDeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 28: {
            m.tokenUpdate = c.proto.TokenUpdateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 29: {
            m.tokenMint = c.proto.TokenMintTransactionBody.decode(n, n.uint32());
            break;
          }
          case 30: {
            m.tokenBurn = c.proto.TokenBurnTransactionBody.decode(n, n.uint32());
            break;
          }
          case 31: {
            m.tokenWipe = c.proto.TokenWipeAccountTransactionBody.decode(n, n.uint32());
            break;
          }
          case 32: {
            m.tokenAssociate = c.proto.TokenAssociateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 33: {
            m.tokenDissociate = c.proto.TokenDissociateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 39: {
            m.tokenFeeScheduleUpdate = c.proto.TokenFeeScheduleUpdateTransactionBody.decode(n, n.uint32());
            break;
          }
          case 35: {
            m.tokenPause = c.proto.TokenPauseTransactionBody.decode(n, n.uint32());
            break;
          }
          case 36: {
            m.tokenUnpause = c.proto.TokenUnpauseTransactionBody.decode(n, n.uint32());
            break;
          }
          case 34: {
            m.scheduleDelete = c.proto.ScheduleDeleteTransactionBody.decode(n, n.uint32());
            break;
          }
          case 40: {
            m.utilPrng = c.proto.UtilPrngTransactionBody.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.SchedulableTransactionBody";
    }, o;
  }(), ScheduleDeleteTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.scheduleID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.scheduleID != null && Object.hasOwnProperty.call(e, "scheduleID") && c.proto.ScheduleID.encode(e.scheduleID, n.uint32(10).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ScheduleDeleteTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.scheduleID = c.proto.ScheduleID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ScheduleDeleteTransactionBody";
    }, o;
  }(), UtilPrngTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.range = 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.range != null && Object.hasOwnProperty.call(e, "range") && n.uint32(8).int32(e.range), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.UtilPrngTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.range = e.int32();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.UtilPrngTransactionBody";
    }, o;
  }(), ScheduleSignTransactionBody: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.scheduleID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.scheduleID != null && Object.hasOwnProperty.call(e, "scheduleID") && c.proto.ScheduleID.encode(e.scheduleID, n.uint32(10).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ScheduleSignTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.scheduleID = c.proto.ScheduleID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ScheduleSignTransactionBody";
    }, o;
  }(), NodeStakeUpdateTransactionBody: function() {
    function o(e) {
      if (this.nodeStake = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.endOfStakingPeriod = null, o.prototype.nodeStake = g.emptyArray, o.prototype.maxStakingRewardRatePerHbar = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.nodeRewardFeeFraction = null, o.prototype.stakingPeriodsStored = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.stakingPeriod = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.stakingRewardFeeFraction = null, o.prototype.stakingStartThreshold = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.stakingRewardRate = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.endOfStakingPeriod != null && Object.hasOwnProperty.call(e, "endOfStakingPeriod") && c.proto.Timestamp.encode(e.endOfStakingPeriod, n.uint32(10).fork()).ldelim(), e.nodeStake != null && e.nodeStake.length)
        for (var i = 0; i < e.nodeStake.length; ++i)
          c.proto.NodeStake.encode(e.nodeStake[i], n.uint32(18).fork()).ldelim();
      return e.maxStakingRewardRatePerHbar != null && Object.hasOwnProperty.call(e, "maxStakingRewardRatePerHbar") && n.uint32(24).int64(e.maxStakingRewardRatePerHbar), e.nodeRewardFeeFraction != null && Object.hasOwnProperty.call(e, "nodeRewardFeeFraction") && c.proto.Fraction.encode(e.nodeRewardFeeFraction, n.uint32(34).fork()).ldelim(), e.stakingPeriodsStored != null && Object.hasOwnProperty.call(e, "stakingPeriodsStored") && n.uint32(40).int64(e.stakingPeriodsStored), e.stakingPeriod != null && Object.hasOwnProperty.call(e, "stakingPeriod") && n.uint32(48).int64(e.stakingPeriod), e.stakingRewardFeeFraction != null && Object.hasOwnProperty.call(e, "stakingRewardFeeFraction") && c.proto.Fraction.encode(e.stakingRewardFeeFraction, n.uint32(58).fork()).ldelim(), e.stakingStartThreshold != null && Object.hasOwnProperty.call(e, "stakingStartThreshold") && n.uint32(64).int64(e.stakingStartThreshold), e.stakingRewardRate != null && Object.hasOwnProperty.call(e, "stakingRewardRate") && n.uint32(72).int64(e.stakingRewardRate), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.NodeStakeUpdateTransactionBody(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.endOfStakingPeriod = c.proto.Timestamp.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.nodeStake && y.nodeStake.length || (y.nodeStake = []), y.nodeStake.push(c.proto.NodeStake.decode(e, e.uint32()));
            break;
          }
          case 3: {
            y.maxStakingRewardRatePerHbar = e.int64();
            break;
          }
          case 4: {
            y.nodeRewardFeeFraction = c.proto.Fraction.decode(e, e.uint32());
            break;
          }
          case 5: {
            y.stakingPeriodsStored = e.int64();
            break;
          }
          case 6: {
            y.stakingPeriod = e.int64();
            break;
          }
          case 7: {
            y.stakingRewardFeeFraction = c.proto.Fraction.decode(e, e.uint32());
            break;
          }
          case 8: {
            y.stakingStartThreshold = e.int64();
            break;
          }
          case 9: {
            y.stakingRewardRate = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.NodeStakeUpdateTransactionBody";
    }, o;
  }(), NodeStake: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.maxStake = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.minStake = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.nodeId = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.rewardRate = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.stake = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.stakeNotRewarded = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.stakeRewarded = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.maxStake != null && Object.hasOwnProperty.call(e, "maxStake") && n.uint32(8).int64(e.maxStake), e.minStake != null && Object.hasOwnProperty.call(e, "minStake") && n.uint32(16).int64(e.minStake), e.nodeId != null && Object.hasOwnProperty.call(e, "nodeId") && n.uint32(24).int64(e.nodeId), e.rewardRate != null && Object.hasOwnProperty.call(e, "rewardRate") && n.uint32(32).int64(e.rewardRate), e.stake != null && Object.hasOwnProperty.call(e, "stake") && n.uint32(40).int64(e.stake), e.stakeNotRewarded != null && Object.hasOwnProperty.call(e, "stakeNotRewarded") && n.uint32(48).int64(e.stakeNotRewarded), e.stakeRewarded != null && Object.hasOwnProperty.call(e, "stakeRewarded") && n.uint32(56).int64(e.stakeRewarded), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.NodeStake(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.maxStake = e.int64();
            break;
          }
          case 2: {
            y.minStake = e.int64();
            break;
          }
          case 3: {
            y.nodeId = e.int64();
            break;
          }
          case 4: {
            y.rewardRate = e.int64();
            break;
          }
          case 5: {
            y.stake = e.int64();
            break;
          }
          case 6: {
            y.stakeNotRewarded = e.int64();
            break;
          }
          case 7: {
            y.stakeRewarded = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.NodeStake";
    }, o;
  }(), ResponseHeader: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.nodeTransactionPrecheckCode = 0, o.prototype.responseType = 0, o.prototype.cost = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.stateProof = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.nodeTransactionPrecheckCode != null && Object.hasOwnProperty.call(e, "nodeTransactionPrecheckCode") && n.uint32(8).int32(e.nodeTransactionPrecheckCode), e.responseType != null && Object.hasOwnProperty.call(e, "responseType") && n.uint32(16).int32(e.responseType), e.cost != null && Object.hasOwnProperty.call(e, "cost") && n.uint32(24).uint64(e.cost), e.stateProof != null && Object.hasOwnProperty.call(e, "stateProof") && n.uint32(34).bytes(e.stateProof), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ResponseHeader(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.nodeTransactionPrecheckCode = e.int32();
            break;
          }
          case 2: {
            y.responseType = e.int32();
            break;
          }
          case 3: {
            y.cost = e.uint64();
            break;
          }
          case 4: {
            y.stateProof = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ResponseHeader";
    }, o;
  }(), TransactionResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.nodeTransactionPrecheckCode = 0, o.prototype.cost = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.nodeTransactionPrecheckCode != null && Object.hasOwnProperty.call(e, "nodeTransactionPrecheckCode") && n.uint32(8).int32(e.nodeTransactionPrecheckCode), e.cost != null && Object.hasOwnProperty.call(e, "cost") && n.uint32(16).uint64(e.cost), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TransactionResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.nodeTransactionPrecheckCode = e.int32();
            break;
          }
          case 2: {
            y.cost = e.uint64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TransactionResponse";
    }, o;
  }(), ResponseCodeEnum: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "OK"] = 0, e[o[1] = "INVALID_TRANSACTION"] = 1, e[o[2] = "PAYER_ACCOUNT_NOT_FOUND"] = 2, e[o[3] = "INVALID_NODE_ACCOUNT"] = 3, e[o[4] = "TRANSACTION_EXPIRED"] = 4, e[o[5] = "INVALID_TRANSACTION_START"] = 5, e[o[6] = "INVALID_TRANSACTION_DURATION"] = 6, e[o[7] = "INVALID_SIGNATURE"] = 7, e[o[8] = "MEMO_TOO_LONG"] = 8, e[o[9] = "INSUFFICIENT_TX_FEE"] = 9, e[o[10] = "INSUFFICIENT_PAYER_BALANCE"] = 10, e[o[11] = "DUPLICATE_TRANSACTION"] = 11, e[o[12] = "BUSY"] = 12, e[o[13] = "NOT_SUPPORTED"] = 13, e[o[14] = "INVALID_FILE_ID"] = 14, e[o[15] = "INVALID_ACCOUNT_ID"] = 15, e[o[16] = "INVALID_CONTRACT_ID"] = 16, e[o[17] = "INVALID_TRANSACTION_ID"] = 17, e[o[18] = "RECEIPT_NOT_FOUND"] = 18, e[o[19] = "RECORD_NOT_FOUND"] = 19, e[o[20] = "INVALID_SOLIDITY_ID"] = 20, e[o[21] = "UNKNOWN"] = 21, e[o[22] = "SUCCESS"] = 22, e[o[23] = "FAIL_INVALID"] = 23, e[o[24] = "FAIL_FEE"] = 24, e[o[25] = "FAIL_BALANCE"] = 25, e[o[26] = "KEY_REQUIRED"] = 26, e[o[27] = "BAD_ENCODING"] = 27, e[o[28] = "INSUFFICIENT_ACCOUNT_BALANCE"] = 28, e[o[29] = "INVALID_SOLIDITY_ADDRESS"] = 29, e[o[30] = "INSUFFICIENT_GAS"] = 30, e[o[31] = "CONTRACT_SIZE_LIMIT_EXCEEDED"] = 31, e[o[32] = "LOCAL_CALL_MODIFICATION_EXCEPTION"] = 32, e[o[33] = "CONTRACT_REVERT_EXECUTED"] = 33, e[o[34] = "CONTRACT_EXECUTION_EXCEPTION"] = 34, e[o[35] = "INVALID_RECEIVING_NODE_ACCOUNT"] = 35, e[o[36] = "MISSING_QUERY_HEADER"] = 36, e[o[37] = "ACCOUNT_UPDATE_FAILED"] = 37, e[o[38] = "INVALID_KEY_ENCODING"] = 38, e[o[39] = "NULL_SOLIDITY_ADDRESS"] = 39, e[o[40] = "CONTRACT_UPDATE_FAILED"] = 40, e[o[41] = "INVALID_QUERY_HEADER"] = 41, e[o[42] = "INVALID_FEE_SUBMITTED"] = 42, e[o[43] = "INVALID_PAYER_SIGNATURE"] = 43, e[o[44] = "KEY_NOT_PROVIDED"] = 44, e[o[45] = "INVALID_EXPIRATION_TIME"] = 45, e[o[46] = "NO_WACL_KEY"] = 46, e[o[47] = "FILE_CONTENT_EMPTY"] = 47, e[o[48] = "INVALID_ACCOUNT_AMOUNTS"] = 48, e[o[49] = "EMPTY_TRANSACTION_BODY"] = 49, e[o[50] = "INVALID_TRANSACTION_BODY"] = 50, e[o[51] = "INVALID_SIGNATURE_TYPE_MISMATCHING_KEY"] = 51, e[o[52] = "INVALID_SIGNATURE_COUNT_MISMATCHING_KEY"] = 52, e[o[53] = "EMPTY_LIVE_HASH_BODY"] = 53, e[o[54] = "EMPTY_LIVE_HASH"] = 54, e[o[55] = "EMPTY_LIVE_HASH_KEYS"] = 55, e[o[56] = "INVALID_LIVE_HASH_SIZE"] = 56, e[o[57] = "EMPTY_QUERY_BODY"] = 57, e[o[58] = "EMPTY_LIVE_HASH_QUERY"] = 58, e[o[59] = "LIVE_HASH_NOT_FOUND"] = 59, e[o[60] = "ACCOUNT_ID_DOES_NOT_EXIST"] = 60, e[o[61] = "LIVE_HASH_ALREADY_EXISTS"] = 61, e[o[62] = "INVALID_FILE_WACL"] = 62, e[o[63] = "SERIALIZATION_FAILED"] = 63, e[o[64] = "TRANSACTION_OVERSIZE"] = 64, e[o[65] = "TRANSACTION_TOO_MANY_LAYERS"] = 65, e[o[66] = "CONTRACT_DELETED"] = 66, e[o[67] = "PLATFORM_NOT_ACTIVE"] = 67, e[o[68] = "KEY_PREFIX_MISMATCH"] = 68, e[o[69] = "PLATFORM_TRANSACTION_NOT_CREATED"] = 69, e[o[70] = "INVALID_RENEWAL_PERIOD"] = 70, e[o[71] = "INVALID_PAYER_ACCOUNT_ID"] = 71, e[o[72] = "ACCOUNT_DELETED"] = 72, e[o[73] = "FILE_DELETED"] = 73, e[o[74] = "ACCOUNT_REPEATED_IN_ACCOUNT_AMOUNTS"] = 74, e[o[75] = "SETTING_NEGATIVE_ACCOUNT_BALANCE"] = 75, e[o[76] = "OBTAINER_REQUIRED"] = 76, e[o[77] = "OBTAINER_SAME_CONTRACT_ID"] = 77, e[o[78] = "OBTAINER_DOES_NOT_EXIST"] = 78, e[o[79] = "MODIFYING_IMMUTABLE_CONTRACT"] = 79, e[o[80] = "FILE_SYSTEM_EXCEPTION"] = 80, e[o[81] = "AUTORENEW_DURATION_NOT_IN_RANGE"] = 81, e[o[82] = "ERROR_DECODING_BYTESTRING"] = 82, e[o[83] = "CONTRACT_FILE_EMPTY"] = 83, e[o[84] = "CONTRACT_BYTECODE_EMPTY"] = 84, e[o[85] = "INVALID_INITIAL_BALANCE"] = 85, e[o[86] = "INVALID_RECEIVE_RECORD_THRESHOLD"] = 86, e[o[87] = "INVALID_SEND_RECORD_THRESHOLD"] = 87, e[o[88] = "ACCOUNT_IS_NOT_GENESIS_ACCOUNT"] = 88, e[o[89] = "PAYER_ACCOUNT_UNAUTHORIZED"] = 89, e[o[90] = "INVALID_FREEZE_TRANSACTION_BODY"] = 90, e[o[91] = "FREEZE_TRANSACTION_BODY_NOT_FOUND"] = 91, e[o[92] = "TRANSFER_LIST_SIZE_LIMIT_EXCEEDED"] = 92, e[o[93] = "RESULT_SIZE_LIMIT_EXCEEDED"] = 93, e[o[94] = "NOT_SPECIAL_ACCOUNT"] = 94, e[o[95] = "CONTRACT_NEGATIVE_GAS"] = 95, e[o[96] = "CONTRACT_NEGATIVE_VALUE"] = 96, e[o[97] = "INVALID_FEE_FILE"] = 97, e[o[98] = "INVALID_EXCHANGE_RATE_FILE"] = 98, e[o[99] = "INSUFFICIENT_LOCAL_CALL_GAS"] = 99, e[o[100] = "ENTITY_NOT_ALLOWED_TO_DELETE"] = 100, e[o[101] = "AUTHORIZATION_FAILED"] = 101, e[o[102] = "FILE_UPLOADED_PROTO_INVALID"] = 102, e[o[103] = "FILE_UPLOADED_PROTO_NOT_SAVED_TO_DISK"] = 103, e[o[104] = "FEE_SCHEDULE_FILE_PART_UPLOADED"] = 104, e[o[105] = "EXCHANGE_RATE_CHANGE_LIMIT_EXCEEDED"] = 105, e[o[106] = "MAX_CONTRACT_STORAGE_EXCEEDED"] = 106, e[o[107] = "TRANSFER_ACCOUNT_SAME_AS_DELETE_ACCOUNT"] = 107, e[o[108] = "TOTAL_LEDGER_BALANCE_INVALID"] = 108, e[o[110] = "EXPIRATION_REDUCTION_NOT_ALLOWED"] = 110, e[o[111] = "MAX_GAS_LIMIT_EXCEEDED"] = 111, e[o[112] = "MAX_FILE_SIZE_EXCEEDED"] = 112, e[o[113] = "RECEIVER_SIG_REQUIRED"] = 113, e[o[150] = "INVALID_TOPIC_ID"] = 150, e[o[155] = "INVALID_ADMIN_KEY"] = 155, e[o[156] = "INVALID_SUBMIT_KEY"] = 156, e[o[157] = "UNAUTHORIZED"] = 157, e[o[158] = "INVALID_TOPIC_MESSAGE"] = 158, e[o[159] = "INVALID_AUTORENEW_ACCOUNT"] = 159, e[o[160] = "AUTORENEW_ACCOUNT_NOT_ALLOWED"] = 160, e[o[162] = "TOPIC_EXPIRED"] = 162, e[o[163] = "INVALID_CHUNK_NUMBER"] = 163, e[o[164] = "INVALID_CHUNK_TRANSACTION_ID"] = 164, e[o[165] = "ACCOUNT_FROZEN_FOR_TOKEN"] = 165, e[o[166] = "TOKENS_PER_ACCOUNT_LIMIT_EXCEEDED"] = 166, e[o[167] = "INVALID_TOKEN_ID"] = 167, e[o[168] = "INVALID_TOKEN_DECIMALS"] = 168, e[o[169] = "INVALID_TOKEN_INITIAL_SUPPLY"] = 169, e[o[170] = "INVALID_TREASURY_ACCOUNT_FOR_TOKEN"] = 170, e[o[171] = "INVALID_TOKEN_SYMBOL"] = 171, e[o[172] = "TOKEN_HAS_NO_FREEZE_KEY"] = 172, e[o[173] = "TRANSFERS_NOT_ZERO_SUM_FOR_TOKEN"] = 173, e[o[174] = "MISSING_TOKEN_SYMBOL"] = 174, e[o[175] = "TOKEN_SYMBOL_TOO_LONG"] = 175, e[o[176] = "ACCOUNT_KYC_NOT_GRANTED_FOR_TOKEN"] = 176, e[o[177] = "TOKEN_HAS_NO_KYC_KEY"] = 177, e[o[178] = "INSUFFICIENT_TOKEN_BALANCE"] = 178, e[o[179] = "TOKEN_WAS_DELETED"] = 179, e[o[180] = "TOKEN_HAS_NO_SUPPLY_KEY"] = 180, e[o[181] = "TOKEN_HAS_NO_WIPE_KEY"] = 181, e[o[182] = "INVALID_TOKEN_MINT_AMOUNT"] = 182, e[o[183] = "INVALID_TOKEN_BURN_AMOUNT"] = 183, e[o[184] = "TOKEN_NOT_ASSOCIATED_TO_ACCOUNT"] = 184, e[o[185] = "CANNOT_WIPE_TOKEN_TREASURY_ACCOUNT"] = 185, e[o[186] = "INVALID_KYC_KEY"] = 186, e[o[187] = "INVALID_WIPE_KEY"] = 187, e[o[188] = "INVALID_FREEZE_KEY"] = 188, e[o[189] = "INVALID_SUPPLY_KEY"] = 189, e[o[190] = "MISSING_TOKEN_NAME"] = 190, e[o[191] = "TOKEN_NAME_TOO_LONG"] = 191, e[o[192] = "INVALID_WIPING_AMOUNT"] = 192, e[o[193] = "TOKEN_IS_IMMUTABLE"] = 193, e[o[194] = "TOKEN_ALREADY_ASSOCIATED_TO_ACCOUNT"] = 194, e[o[195] = "TRANSACTION_REQUIRES_ZERO_TOKEN_BALANCES"] = 195, e[o[196] = "ACCOUNT_IS_TREASURY"] = 196, e[o[197] = "TOKEN_ID_REPEATED_IN_TOKEN_LIST"] = 197, e[o[198] = "TOKEN_TRANSFER_LIST_SIZE_LIMIT_EXCEEDED"] = 198, e[o[199] = "EMPTY_TOKEN_TRANSFER_BODY"] = 199, e[o[200] = "EMPTY_TOKEN_TRANSFER_ACCOUNT_AMOUNTS"] = 200, e[o[201] = "INVALID_SCHEDULE_ID"] = 201, e[o[202] = "SCHEDULE_IS_IMMUTABLE"] = 202, e[o[203] = "INVALID_SCHEDULE_PAYER_ID"] = 203, e[o[204] = "INVALID_SCHEDULE_ACCOUNT_ID"] = 204, e[o[205] = "NO_NEW_VALID_SIGNATURES"] = 205, e[o[206] = "UNRESOLVABLE_REQUIRED_SIGNERS"] = 206, e[o[207] = "SCHEDULED_TRANSACTION_NOT_IN_WHITELIST"] = 207, e[o[208] = "SOME_SIGNATURES_WERE_INVALID"] = 208, e[o[209] = "TRANSACTION_ID_FIELD_NOT_ALLOWED"] = 209, e[o[210] = "IDENTICAL_SCHEDULE_ALREADY_CREATED"] = 210, e[o[211] = "INVALID_ZERO_BYTE_IN_STRING"] = 211, e[o[212] = "SCHEDULE_ALREADY_DELETED"] = 212, e[o[213] = "SCHEDULE_ALREADY_EXECUTED"] = 213, e[o[214] = "MESSAGE_SIZE_TOO_LARGE"] = 214, e[o[215] = "OPERATION_REPEATED_IN_BUCKET_GROUPS"] = 215, e[o[216] = "BUCKET_CAPACITY_OVERFLOW"] = 216, e[o[217] = "NODE_CAPACITY_NOT_SUFFICIENT_FOR_OPERATION"] = 217, e[o[218] = "BUCKET_HAS_NO_THROTTLE_GROUPS"] = 218, e[o[219] = "THROTTLE_GROUP_HAS_ZERO_OPS_PER_SEC"] = 219, e[o[220] = "SUCCESS_BUT_MISSING_EXPECTED_OPERATION"] = 220, e[o[221] = "UNPARSEABLE_THROTTLE_DEFINITIONS"] = 221, e[o[222] = "INVALID_THROTTLE_DEFINITIONS"] = 222, e[o[223] = "ACCOUNT_EXPIRED_AND_PENDING_REMOVAL"] = 223, e[o[224] = "INVALID_TOKEN_MAX_SUPPLY"] = 224, e[o[225] = "INVALID_TOKEN_NFT_SERIAL_NUMBER"] = 225, e[o[226] = "INVALID_NFT_ID"] = 226, e[o[227] = "METADATA_TOO_LONG"] = 227, e[o[228] = "BATCH_SIZE_LIMIT_EXCEEDED"] = 228, e[o[229] = "INVALID_QUERY_RANGE"] = 229, e[o[230] = "FRACTION_DIVIDES_BY_ZERO"] = 230, e[o[231] = "INSUFFICIENT_PAYER_BALANCE_FOR_CUSTOM_FEE"] = 231, e[o[232] = "CUSTOM_FEES_LIST_TOO_LONG"] = 232, e[o[233] = "INVALID_CUSTOM_FEE_COLLECTOR"] = 233, e[o[234] = "INVALID_TOKEN_ID_IN_CUSTOM_FEES"] = 234, e[o[235] = "TOKEN_NOT_ASSOCIATED_TO_FEE_COLLECTOR"] = 235, e[o[236] = "TOKEN_MAX_SUPPLY_REACHED"] = 236, e[o[237] = "SENDER_DOES_NOT_OWN_NFT_SERIAL_NO"] = 237, e[o[238] = "CUSTOM_FEE_NOT_FULLY_SPECIFIED"] = 238, e[o[239] = "CUSTOM_FEE_MUST_BE_POSITIVE"] = 239, e[o[240] = "TOKEN_HAS_NO_FEE_SCHEDULE_KEY"] = 240, e[o[241] = "CUSTOM_FEE_OUTSIDE_NUMERIC_RANGE"] = 241, e[o[242] = "ROYALTY_FRACTION_CANNOT_EXCEED_ONE"] = 242, e[o[243] = "FRACTIONAL_FEE_MAX_AMOUNT_LESS_THAN_MIN_AMOUNT"] = 243, e[o[244] = "CUSTOM_SCHEDULE_ALREADY_HAS_NO_FEES"] = 244, e[o[245] = "CUSTOM_FEE_DENOMINATION_MUST_BE_FUNGIBLE_COMMON"] = 245, e[o[246] = "CUSTOM_FRACTIONAL_FEE_ONLY_ALLOWED_FOR_FUNGIBLE_COMMON"] = 246, e[o[247] = "INVALID_CUSTOM_FEE_SCHEDULE_KEY"] = 247, e[o[248] = "INVALID_TOKEN_MINT_METADATA"] = 248, e[o[249] = "INVALID_TOKEN_BURN_METADATA"] = 249, e[o[250] = "CURRENT_TREASURY_STILL_OWNS_NFTS"] = 250, e[o[251] = "ACCOUNT_STILL_OWNS_NFTS"] = 251, e[o[252] = "TREASURY_MUST_OWN_BURNED_NFT"] = 252, e[o[253] = "ACCOUNT_DOES_NOT_OWN_WIPED_NFT"] = 253, e[o[254] = "ACCOUNT_AMOUNT_TRANSFERS_ONLY_ALLOWED_FOR_FUNGIBLE_COMMON"] = 254, e[o[255] = "MAX_NFTS_IN_PRICE_REGIME_HAVE_BEEN_MINTED"] = 255, e[o[256] = "PAYER_ACCOUNT_DELETED"] = 256, e[o[257] = "CUSTOM_FEE_CHARGING_EXCEEDED_MAX_RECURSION_DEPTH"] = 257, e[o[258] = "CUSTOM_FEE_CHARGING_EXCEEDED_MAX_ACCOUNT_AMOUNTS"] = 258, e[o[259] = "INSUFFICIENT_SENDER_ACCOUNT_BALANCE_FOR_CUSTOM_FEE"] = 259, e[o[260] = "SERIAL_NUMBER_LIMIT_REACHED"] = 260, e[o[261] = "CUSTOM_ROYALTY_FEE_ONLY_ALLOWED_FOR_NON_FUNGIBLE_UNIQUE"] = 261, e[o[262] = "NO_REMAINING_AUTOMATIC_ASSOCIATIONS"] = 262, e[o[263] = "EXISTING_AUTOMATIC_ASSOCIATIONS_EXCEED_GIVEN_LIMIT"] = 263, e[o[264] = "REQUESTED_NUM_AUTOMATIC_ASSOCIATIONS_EXCEEDS_ASSOCIATION_LIMIT"] = 264, e[o[265] = "TOKEN_IS_PAUSED"] = 265, e[o[266] = "TOKEN_HAS_NO_PAUSE_KEY"] = 266, e[o[267] = "INVALID_PAUSE_KEY"] = 267, e[o[268] = "FREEZE_UPDATE_FILE_DOES_NOT_EXIST"] = 268, e[o[269] = "FREEZE_UPDATE_FILE_HASH_DOES_NOT_MATCH"] = 269, e[o[270] = "NO_UPGRADE_HAS_BEEN_PREPARED"] = 270, e[o[271] = "NO_FREEZE_IS_SCHEDULED"] = 271, e[o[272] = "UPDATE_FILE_HASH_CHANGED_SINCE_PREPARE_UPGRADE"] = 272, e[o[273] = "FREEZE_START_TIME_MUST_BE_FUTURE"] = 273, e[o[274] = "PREPARED_UPDATE_FILE_IS_IMMUTABLE"] = 274, e[o[275] = "FREEZE_ALREADY_SCHEDULED"] = 275, e[o[276] = "FREEZE_UPGRADE_IN_PROGRESS"] = 276, e[o[277] = "UPDATE_FILE_ID_DOES_NOT_MATCH_PREPARED"] = 277, e[o[278] = "UPDATE_FILE_HASH_DOES_NOT_MATCH_PREPARED"] = 278, e[o[279] = "CONSENSUS_GAS_EXHAUSTED"] = 279, e[o[280] = "REVERTED_SUCCESS"] = 280, e[o[281] = "MAX_STORAGE_IN_PRICE_REGIME_HAS_BEEN_USED"] = 281, e[o[282] = "INVALID_ALIAS_KEY"] = 282, e[o[283] = "UNEXPECTED_TOKEN_DECIMALS"] = 283, e[o[284] = "INVALID_PROXY_ACCOUNT_ID"] = 284, e[o[285] = "INVALID_TRANSFER_ACCOUNT_ID"] = 285, e[o[286] = "INVALID_FEE_COLLECTOR_ACCOUNT_ID"] = 286, e[o[287] = "ALIAS_IS_IMMUTABLE"] = 287, e[o[288] = "SPENDER_ACCOUNT_SAME_AS_OWNER"] = 288, e[o[289] = "AMOUNT_EXCEEDS_TOKEN_MAX_SUPPLY"] = 289, e[o[290] = "NEGATIVE_ALLOWANCE_AMOUNT"] = 290, e[o[291] = "CANNOT_APPROVE_FOR_ALL_FUNGIBLE_COMMON"] = 291, e[o[292] = "SPENDER_DOES_NOT_HAVE_ALLOWANCE"] = 292, e[o[293] = "AMOUNT_EXCEEDS_ALLOWANCE"] = 293, e[o[294] = "MAX_ALLOWANCES_EXCEEDED"] = 294, e[o[295] = "EMPTY_ALLOWANCES"] = 295, e[o[296] = "SPENDER_ACCOUNT_REPEATED_IN_ALLOWANCES"] = 296, e[o[297] = "REPEATED_SERIAL_NUMS_IN_NFT_ALLOWANCES"] = 297, e[o[298] = "FUNGIBLE_TOKEN_IN_NFT_ALLOWANCES"] = 298, e[o[299] = "NFT_IN_FUNGIBLE_TOKEN_ALLOWANCES"] = 299, e[o[300] = "INVALID_ALLOWANCE_OWNER_ID"] = 300, e[o[301] = "INVALID_ALLOWANCE_SPENDER_ID"] = 301, e[o[302] = "REPEATED_ALLOWANCES_TO_DELETE"] = 302, e[o[303] = "INVALID_DELEGATING_SPENDER"] = 303, e[o[304] = "DELEGATING_SPENDER_CANNOT_GRANT_APPROVE_FOR_ALL"] = 304, e[o[305] = "DELEGATING_SPENDER_DOES_NOT_HAVE_APPROVE_FOR_ALL"] = 305, e[o[306] = "SCHEDULE_EXPIRATION_TIME_TOO_FAR_IN_FUTURE"] = 306, e[o[307] = "SCHEDULE_EXPIRATION_TIME_MUST_BE_HIGHER_THAN_CONSENSUS_TIME"] = 307, e[o[308] = "SCHEDULE_FUTURE_THROTTLE_EXCEEDED"] = 308, e[o[309] = "SCHEDULE_FUTURE_GAS_LIMIT_EXCEEDED"] = 309, e[o[310] = "INVALID_ETHEREUM_TRANSACTION"] = 310, e[o[311] = "WRONG_CHAIN_ID"] = 311, e[o[312] = "WRONG_NONCE"] = 312, e[o[313] = "ACCESS_LIST_UNSUPPORTED"] = 313, e[o[314] = "SCHEDULE_PENDING_EXPIRATION"] = 314, e[o[315] = "CONTRACT_IS_TOKEN_TREASURY"] = 315, e[o[316] = "CONTRACT_HAS_NON_ZERO_TOKEN_BALANCES"] = 316, e[o[317] = "CONTRACT_EXPIRED_AND_PENDING_REMOVAL"] = 317, e[o[318] = "CONTRACT_HAS_NO_AUTO_RENEW_ACCOUNT"] = 318, e[o[319] = "PERMANENT_REMOVAL_REQUIRES_SYSTEM_INITIATION"] = 319, e[o[320] = "PROXY_ACCOUNT_ID_FIELD_IS_DEPRECATED"] = 320, e[o[321] = "SELF_STAKING_IS_NOT_ALLOWED"] = 321, e[o[322] = "INVALID_STAKING_ID"] = 322, e[o[323] = "STAKING_NOT_ENABLED"] = 323, e[o[324] = "INVALID_PRNG_RANGE"] = 324, e[o[325] = "MAX_ENTITIES_IN_PRICE_REGIME_HAVE_BEEN_CREATED"] = 325, e[o[326] = "INVALID_FULL_PREFIX_SIGNATURE_FOR_PRECOMPILE"] = 326, e[o[327] = "INSUFFICIENT_BALANCES_FOR_STORAGE_RENT"] = 327, e[o[328] = "MAX_CHILD_RECORDS_EXCEEDED"] = 328, e[o[329] = "INSUFFICIENT_BALANCES_FOR_RENEWAL_FEES"] = 329, e[o[330] = "TRANSACTION_HAS_UNKNOWN_FIELDS"] = 330, e[o[331] = "ACCOUNT_IS_IMMUTABLE"] = 331, e[o[332] = "ALIAS_ALREADY_ASSIGNED"] = 332, e;
  }(), ConsensusTopicInfo: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.memo = "", o.prototype.runningHash = g.newBuffer([]), o.prototype.sequenceNumber = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.expirationTime = null, o.prototype.adminKey = null, o.prototype.submitKey = null, o.prototype.autoRenewPeriod = null, o.prototype.autoRenewAccount = null, o.prototype.ledgerId = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.memo != null && Object.hasOwnProperty.call(e, "memo") && n.uint32(10).string(e.memo), e.runningHash != null && Object.hasOwnProperty.call(e, "runningHash") && n.uint32(18).bytes(e.runningHash), e.sequenceNumber != null && Object.hasOwnProperty.call(e, "sequenceNumber") && n.uint32(24).uint64(e.sequenceNumber), e.expirationTime != null && Object.hasOwnProperty.call(e, "expirationTime") && c.proto.Timestamp.encode(e.expirationTime, n.uint32(34).fork()).ldelim(), e.adminKey != null && Object.hasOwnProperty.call(e, "adminKey") && c.proto.Key.encode(e.adminKey, n.uint32(42).fork()).ldelim(), e.submitKey != null && Object.hasOwnProperty.call(e, "submitKey") && c.proto.Key.encode(e.submitKey, n.uint32(50).fork()).ldelim(), e.autoRenewPeriod != null && Object.hasOwnProperty.call(e, "autoRenewPeriod") && c.proto.Duration.encode(e.autoRenewPeriod, n.uint32(58).fork()).ldelim(), e.autoRenewAccount != null && Object.hasOwnProperty.call(e, "autoRenewAccount") && c.proto.AccountID.encode(e.autoRenewAccount, n.uint32(66).fork()).ldelim(), e.ledgerId != null && Object.hasOwnProperty.call(e, "ledgerId") && n.uint32(74).bytes(e.ledgerId), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ConsensusTopicInfo(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.memo = e.string();
            break;
          }
          case 2: {
            y.runningHash = e.bytes();
            break;
          }
          case 3: {
            y.sequenceNumber = e.uint64();
            break;
          }
          case 4: {
            y.expirationTime = c.proto.Timestamp.decode(e, e.uint32());
            break;
          }
          case 5: {
            y.adminKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 6: {
            y.submitKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 7: {
            y.autoRenewPeriod = c.proto.Duration.decode(e, e.uint32());
            break;
          }
          case 8: {
            y.autoRenewAccount = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 9: {
            y.ledgerId = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ConsensusTopicInfo";
    }, o;
  }(), ConsensusService: function() {
    function o(e, n, i) {
      t.rpc.Service.call(this, e, n, i);
    }
    return (o.prototype = Object.create(t.rpc.Service.prototype)).constructor = o, o.create = function(e, n, i) {
      return new this(e, n, i);
    }, Object.defineProperty(o.prototype.createTopic = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "createTopic" }), Object.defineProperty(o.prototype.updateTopic = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "updateTopic" }), Object.defineProperty(o.prototype.deleteTopic = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "deleteTopic" }), Object.defineProperty(o.prototype.getTopicInfo = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getTopicInfo" }), Object.defineProperty(o.prototype.submitMessage = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "submitMessage" }), o;
  }(), Query: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.getByKey = null, o.prototype.getBySolidityID = null, o.prototype.contractCallLocal = null, o.prototype.contractGetInfo = null, o.prototype.contractGetBytecode = null, o.prototype.ContractGetRecords = null, o.prototype.cryptogetAccountBalance = null, o.prototype.cryptoGetAccountRecords = null, o.prototype.cryptoGetInfo = null, o.prototype.cryptoGetLiveHash = null, o.prototype.cryptoGetProxyStakers = null, o.prototype.fileGetContents = null, o.prototype.fileGetInfo = null, o.prototype.transactionGetReceipt = null, o.prototype.transactionGetRecord = null, o.prototype.transactionGetFastRecord = null, o.prototype.consensusGetTopicInfo = null, o.prototype.networkGetVersionInfo = null, o.prototype.tokenGetInfo = null, o.prototype.scheduleGetInfo = null, o.prototype.tokenGetAccountNftInfos = null, o.prototype.tokenGetNftInfo = null, o.prototype.tokenGetNftInfos = null, o.prototype.networkGetExecutionTime = null, o.prototype.accountDetails = null;
    let e;
    return Object.defineProperty(o.prototype, "query", { get: g.oneOfGetter(e = ["getByKey", "getBySolidityID", "contractCallLocal", "contractGetInfo", "contractGetBytecode", "ContractGetRecords", "cryptogetAccountBalance", "cryptoGetAccountRecords", "cryptoGetInfo", "cryptoGetLiveHash", "cryptoGetProxyStakers", "fileGetContents", "fileGetInfo", "transactionGetReceipt", "transactionGetRecord", "transactionGetFastRecord", "consensusGetTopicInfo", "networkGetVersionInfo", "tokenGetInfo", "scheduleGetInfo", "tokenGetAccountNftInfos", "tokenGetNftInfo", "tokenGetNftInfos", "networkGetExecutionTime", "accountDetails"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.getByKey != null && Object.hasOwnProperty.call(n, "getByKey") && c.proto.GetByKeyQuery.encode(n.getByKey, i.uint32(10).fork()).ldelim(), n.getBySolidityID != null && Object.hasOwnProperty.call(n, "getBySolidityID") && c.proto.GetBySolidityIDQuery.encode(n.getBySolidityID, i.uint32(18).fork()).ldelim(), n.contractCallLocal != null && Object.hasOwnProperty.call(n, "contractCallLocal") && c.proto.ContractCallLocalQuery.encode(n.contractCallLocal, i.uint32(26).fork()).ldelim(), n.contractGetInfo != null && Object.hasOwnProperty.call(n, "contractGetInfo") && c.proto.ContractGetInfoQuery.encode(n.contractGetInfo, i.uint32(34).fork()).ldelim(), n.contractGetBytecode != null && Object.hasOwnProperty.call(n, "contractGetBytecode") && c.proto.ContractGetBytecodeQuery.encode(n.contractGetBytecode, i.uint32(42).fork()).ldelim(), n.ContractGetRecords != null && Object.hasOwnProperty.call(n, "ContractGetRecords") && c.proto.ContractGetRecordsQuery.encode(n.ContractGetRecords, i.uint32(50).fork()).ldelim(), n.cryptogetAccountBalance != null && Object.hasOwnProperty.call(n, "cryptogetAccountBalance") && c.proto.CryptoGetAccountBalanceQuery.encode(n.cryptogetAccountBalance, i.uint32(58).fork()).ldelim(), n.cryptoGetAccountRecords != null && Object.hasOwnProperty.call(n, "cryptoGetAccountRecords") && c.proto.CryptoGetAccountRecordsQuery.encode(n.cryptoGetAccountRecords, i.uint32(66).fork()).ldelim(), n.cryptoGetInfo != null && Object.hasOwnProperty.call(n, "cryptoGetInfo") && c.proto.CryptoGetInfoQuery.encode(n.cryptoGetInfo, i.uint32(74).fork()).ldelim(), n.cryptoGetLiveHash != null && Object.hasOwnProperty.call(n, "cryptoGetLiveHash") && c.proto.CryptoGetLiveHashQuery.encode(n.cryptoGetLiveHash, i.uint32(82).fork()).ldelim(), n.cryptoGetProxyStakers != null && Object.hasOwnProperty.call(n, "cryptoGetProxyStakers") && c.proto.CryptoGetStakersQuery.encode(n.cryptoGetProxyStakers, i.uint32(90).fork()).ldelim(), n.fileGetContents != null && Object.hasOwnProperty.call(n, "fileGetContents") && c.proto.FileGetContentsQuery.encode(n.fileGetContents, i.uint32(98).fork()).ldelim(), n.fileGetInfo != null && Object.hasOwnProperty.call(n, "fileGetInfo") && c.proto.FileGetInfoQuery.encode(n.fileGetInfo, i.uint32(106).fork()).ldelim(), n.transactionGetReceipt != null && Object.hasOwnProperty.call(n, "transactionGetReceipt") && c.proto.TransactionGetReceiptQuery.encode(n.transactionGetReceipt, i.uint32(114).fork()).ldelim(), n.transactionGetRecord != null && Object.hasOwnProperty.call(n, "transactionGetRecord") && c.proto.TransactionGetRecordQuery.encode(n.transactionGetRecord, i.uint32(122).fork()).ldelim(), n.transactionGetFastRecord != null && Object.hasOwnProperty.call(n, "transactionGetFastRecord") && c.proto.TransactionGetFastRecordQuery.encode(n.transactionGetFastRecord, i.uint32(130).fork()).ldelim(), n.consensusGetTopicInfo != null && Object.hasOwnProperty.call(n, "consensusGetTopicInfo") && c.proto.ConsensusGetTopicInfoQuery.encode(n.consensusGetTopicInfo, i.uint32(402).fork()).ldelim(), n.networkGetVersionInfo != null && Object.hasOwnProperty.call(n, "networkGetVersionInfo") && c.proto.NetworkGetVersionInfoQuery.encode(n.networkGetVersionInfo, i.uint32(410).fork()).ldelim(), n.tokenGetInfo != null && Object.hasOwnProperty.call(n, "tokenGetInfo") && c.proto.TokenGetInfoQuery.encode(n.tokenGetInfo, i.uint32(418).fork()).ldelim(), n.scheduleGetInfo != null && Object.hasOwnProperty.call(n, "scheduleGetInfo") && c.proto.ScheduleGetInfoQuery.encode(n.scheduleGetInfo, i.uint32(426).fork()).ldelim(), n.tokenGetAccountNftInfos != null && Object.hasOwnProperty.call(n, "tokenGetAccountNftInfos") && c.proto.TokenGetAccountNftInfosQuery.encode(n.tokenGetAccountNftInfos, i.uint32(434).fork()).ldelim(), n.tokenGetNftInfo != null && Object.hasOwnProperty.call(n, "tokenGetNftInfo") && c.proto.TokenGetNftInfoQuery.encode(n.tokenGetNftInfo, i.uint32(442).fork()).ldelim(), n.tokenGetNftInfos != null && Object.hasOwnProperty.call(n, "tokenGetNftInfos") && c.proto.TokenGetNftInfosQuery.encode(n.tokenGetNftInfos, i.uint32(450).fork()).ldelim(), n.networkGetExecutionTime != null && Object.hasOwnProperty.call(n, "networkGetExecutionTime") && c.proto.NetworkGetExecutionTimeQuery.encode(n.networkGetExecutionTime, i.uint32(458).fork()).ldelim(), n.accountDetails != null && Object.hasOwnProperty.call(n, "accountDetails") && c.proto.GetAccountDetailsQuery.encode(n.accountDetails, i.uint32(466).fork()).ldelim(), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.Query(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.getByKey = c.proto.GetByKeyQuery.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.getBySolidityID = c.proto.GetBySolidityIDQuery.decode(n, n.uint32());
            break;
          }
          case 3: {
            m.contractCallLocal = c.proto.ContractCallLocalQuery.decode(n, n.uint32());
            break;
          }
          case 4: {
            m.contractGetInfo = c.proto.ContractGetInfoQuery.decode(n, n.uint32());
            break;
          }
          case 5: {
            m.contractGetBytecode = c.proto.ContractGetBytecodeQuery.decode(n, n.uint32());
            break;
          }
          case 6: {
            m.ContractGetRecords = c.proto.ContractGetRecordsQuery.decode(n, n.uint32());
            break;
          }
          case 7: {
            m.cryptogetAccountBalance = c.proto.CryptoGetAccountBalanceQuery.decode(n, n.uint32());
            break;
          }
          case 8: {
            m.cryptoGetAccountRecords = c.proto.CryptoGetAccountRecordsQuery.decode(n, n.uint32());
            break;
          }
          case 9: {
            m.cryptoGetInfo = c.proto.CryptoGetInfoQuery.decode(n, n.uint32());
            break;
          }
          case 10: {
            m.cryptoGetLiveHash = c.proto.CryptoGetLiveHashQuery.decode(n, n.uint32());
            break;
          }
          case 11: {
            m.cryptoGetProxyStakers = c.proto.CryptoGetStakersQuery.decode(n, n.uint32());
            break;
          }
          case 12: {
            m.fileGetContents = c.proto.FileGetContentsQuery.decode(n, n.uint32());
            break;
          }
          case 13: {
            m.fileGetInfo = c.proto.FileGetInfoQuery.decode(n, n.uint32());
            break;
          }
          case 14: {
            m.transactionGetReceipt = c.proto.TransactionGetReceiptQuery.decode(n, n.uint32());
            break;
          }
          case 15: {
            m.transactionGetRecord = c.proto.TransactionGetRecordQuery.decode(n, n.uint32());
            break;
          }
          case 16: {
            m.transactionGetFastRecord = c.proto.TransactionGetFastRecordQuery.decode(n, n.uint32());
            break;
          }
          case 50: {
            m.consensusGetTopicInfo = c.proto.ConsensusGetTopicInfoQuery.decode(n, n.uint32());
            break;
          }
          case 51: {
            m.networkGetVersionInfo = c.proto.NetworkGetVersionInfoQuery.decode(n, n.uint32());
            break;
          }
          case 52: {
            m.tokenGetInfo = c.proto.TokenGetInfoQuery.decode(n, n.uint32());
            break;
          }
          case 53: {
            m.scheduleGetInfo = c.proto.ScheduleGetInfoQuery.decode(n, n.uint32());
            break;
          }
          case 54: {
            m.tokenGetAccountNftInfos = c.proto.TokenGetAccountNftInfosQuery.decode(n, n.uint32());
            break;
          }
          case 55: {
            m.tokenGetNftInfo = c.proto.TokenGetNftInfoQuery.decode(n, n.uint32());
            break;
          }
          case 56: {
            m.tokenGetNftInfos = c.proto.TokenGetNftInfosQuery.decode(n, n.uint32());
            break;
          }
          case 57: {
            m.networkGetExecutionTime = c.proto.NetworkGetExecutionTimeQuery.decode(n, n.uint32());
            break;
          }
          case 58: {
            m.accountDetails = c.proto.GetAccountDetailsQuery.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.Query";
    }, o;
  }(), GetByKeyQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.key = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.key != null && Object.hasOwnProperty.call(e, "key") && c.proto.Key.encode(e.key, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.GetByKeyQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.key = c.proto.Key.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.GetByKeyQuery";
    }, o;
  }(), EntityID: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.accountID = null, o.prototype.liveHash = null, o.prototype.fileID = null, o.prototype.contractID = null;
    let e;
    return Object.defineProperty(o.prototype, "entity", { get: g.oneOfGetter(e = ["accountID", "liveHash", "fileID", "contractID"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.accountID != null && Object.hasOwnProperty.call(n, "accountID") && c.proto.AccountID.encode(n.accountID, i.uint32(10).fork()).ldelim(), n.liveHash != null && Object.hasOwnProperty.call(n, "liveHash") && c.proto.LiveHash.encode(n.liveHash, i.uint32(18).fork()).ldelim(), n.fileID != null && Object.hasOwnProperty.call(n, "fileID") && c.proto.FileID.encode(n.fileID, i.uint32(26).fork()).ldelim(), n.contractID != null && Object.hasOwnProperty.call(n, "contractID") && c.proto.ContractID.encode(n.contractID, i.uint32(34).fork()).ldelim(), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.EntityID(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.accountID = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.liveHash = c.proto.LiveHash.decode(n, n.uint32());
            break;
          }
          case 3: {
            m.fileID = c.proto.FileID.decode(n, n.uint32());
            break;
          }
          case 4: {
            m.contractID = c.proto.ContractID.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.EntityID";
    }, o;
  }(), GetByKeyResponse: function() {
    function o(e) {
      if (this.entities = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.entities = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.entities != null && e.entities.length)
        for (var i = 0; i < e.entities.length; ++i)
          c.proto.EntityID.encode(e.entities[i], n.uint32(18).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.GetByKeyResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.entities && y.entities.length || (y.entities = []), y.entities.push(c.proto.EntityID.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.GetByKeyResponse";
    }, o;
  }(), GetBySolidityIDQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.solidityID = "", o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.solidityID != null && Object.hasOwnProperty.call(e, "solidityID") && n.uint32(18).string(e.solidityID), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.GetBySolidityIDQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.solidityID = e.string();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.GetBySolidityIDQuery";
    }, o;
  }(), GetBySolidityIDResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.accountID = null, o.prototype.fileID = null, o.prototype.contractID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(18).fork()).ldelim(), e.fileID != null && Object.hasOwnProperty.call(e, "fileID") && c.proto.FileID.encode(e.fileID, n.uint32(26).fork()).ldelim(), e.contractID != null && Object.hasOwnProperty.call(e, "contractID") && c.proto.ContractID.encode(e.contractID, n.uint32(34).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.GetBySolidityIDResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.fileID = c.proto.FileID.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.contractID = c.proto.ContractID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.GetBySolidityIDResponse";
    }, o;
  }(), ContractLoginfo: function() {
    function o(e) {
      if (this.topic = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.contractID = null, o.prototype.bloom = g.newBuffer([]), o.prototype.topic = g.emptyArray, o.prototype.data = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.contractID != null && Object.hasOwnProperty.call(e, "contractID") && c.proto.ContractID.encode(e.contractID, n.uint32(10).fork()).ldelim(), e.bloom != null && Object.hasOwnProperty.call(e, "bloom") && n.uint32(18).bytes(e.bloom), e.topic != null && e.topic.length)
        for (var i = 0; i < e.topic.length; ++i)
          n.uint32(26).bytes(e.topic[i]);
      return e.data != null && Object.hasOwnProperty.call(e, "data") && n.uint32(34).bytes(e.data), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractLoginfo(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.contractID = c.proto.ContractID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.bloom = e.bytes();
            break;
          }
          case 3: {
            y.topic && y.topic.length || (y.topic = []), y.topic.push(e.bytes());
            break;
          }
          case 4: {
            y.data = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractLoginfo";
    }, o;
  }(), ContractFunctionResult: function() {
    function o(e) {
      if (this.logInfo = [], this.createdContractIDs = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.contractID = null, o.prototype.contractCallResult = g.newBuffer([]), o.prototype.errorMessage = "", o.prototype.bloom = g.newBuffer([]), o.prototype.gasUsed = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.logInfo = g.emptyArray, o.prototype.createdContractIDs = g.emptyArray, o.prototype.evmAddress = null, o.prototype.gas = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.amount = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.functionParameters = g.newBuffer([]), o.prototype.senderId = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.contractID != null && Object.hasOwnProperty.call(e, "contractID") && c.proto.ContractID.encode(e.contractID, n.uint32(10).fork()).ldelim(), e.contractCallResult != null && Object.hasOwnProperty.call(e, "contractCallResult") && n.uint32(18).bytes(e.contractCallResult), e.errorMessage != null && Object.hasOwnProperty.call(e, "errorMessage") && n.uint32(26).string(e.errorMessage), e.bloom != null && Object.hasOwnProperty.call(e, "bloom") && n.uint32(34).bytes(e.bloom), e.gasUsed != null && Object.hasOwnProperty.call(e, "gasUsed") && n.uint32(40).uint64(e.gasUsed), e.logInfo != null && e.logInfo.length)
        for (var i = 0; i < e.logInfo.length; ++i)
          c.proto.ContractLoginfo.encode(e.logInfo[i], n.uint32(50).fork()).ldelim();
      if (e.createdContractIDs != null && e.createdContractIDs.length)
        for (var i = 0; i < e.createdContractIDs.length; ++i)
          c.proto.ContractID.encode(e.createdContractIDs[i], n.uint32(58).fork()).ldelim();
      return e.evmAddress != null && Object.hasOwnProperty.call(e, "evmAddress") && c.google.protobuf.BytesValue.encode(e.evmAddress, n.uint32(74).fork()).ldelim(), e.gas != null && Object.hasOwnProperty.call(e, "gas") && n.uint32(80).int64(e.gas), e.amount != null && Object.hasOwnProperty.call(e, "amount") && n.uint32(88).int64(e.amount), e.functionParameters != null && Object.hasOwnProperty.call(e, "functionParameters") && n.uint32(98).bytes(e.functionParameters), e.senderId != null && Object.hasOwnProperty.call(e, "senderId") && c.proto.AccountID.encode(e.senderId, n.uint32(106).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractFunctionResult(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.contractID = c.proto.ContractID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.contractCallResult = e.bytes();
            break;
          }
          case 3: {
            y.errorMessage = e.string();
            break;
          }
          case 4: {
            y.bloom = e.bytes();
            break;
          }
          case 5: {
            y.gasUsed = e.uint64();
            break;
          }
          case 6: {
            y.logInfo && y.logInfo.length || (y.logInfo = []), y.logInfo.push(c.proto.ContractLoginfo.decode(e, e.uint32()));
            break;
          }
          case 7: {
            y.createdContractIDs && y.createdContractIDs.length || (y.createdContractIDs = []), y.createdContractIDs.push(c.proto.ContractID.decode(e, e.uint32()));
            break;
          }
          case 9: {
            y.evmAddress = c.google.protobuf.BytesValue.decode(e, e.uint32());
            break;
          }
          case 10: {
            y.gas = e.int64();
            break;
          }
          case 11: {
            y.amount = e.int64();
            break;
          }
          case 12: {
            y.functionParameters = e.bytes();
            break;
          }
          case 13: {
            y.senderId = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractFunctionResult";
    }, o;
  }(), ContractCallLocalQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.contractID = null, o.prototype.gas = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.functionParameters = g.newBuffer([]), o.prototype.maxResultSize = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.senderId = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.contractID != null && Object.hasOwnProperty.call(e, "contractID") && c.proto.ContractID.encode(e.contractID, n.uint32(18).fork()).ldelim(), e.gas != null && Object.hasOwnProperty.call(e, "gas") && n.uint32(24).int64(e.gas), e.functionParameters != null && Object.hasOwnProperty.call(e, "functionParameters") && n.uint32(34).bytes(e.functionParameters), e.maxResultSize != null && Object.hasOwnProperty.call(e, "maxResultSize") && n.uint32(40).int64(e.maxResultSize), e.senderId != null && Object.hasOwnProperty.call(e, "senderId") && c.proto.AccountID.encode(e.senderId, n.uint32(50).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractCallLocalQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.contractID = c.proto.ContractID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.gas = e.int64();
            break;
          }
          case 4: {
            y.functionParameters = e.bytes();
            break;
          }
          case 5: {
            y.maxResultSize = e.int64();
            break;
          }
          case 6: {
            y.senderId = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractCallLocalQuery";
    }, o;
  }(), ContractCallLocalResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.functionResult = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.functionResult != null && Object.hasOwnProperty.call(e, "functionResult") && c.proto.ContractFunctionResult.encode(e.functionResult, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractCallLocalResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.functionResult = c.proto.ContractFunctionResult.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractCallLocalResponse";
    }, o;
  }(), ContractGetInfoQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.contractID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.contractID != null && Object.hasOwnProperty.call(e, "contractID") && c.proto.ContractID.encode(e.contractID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractGetInfoQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.contractID = c.proto.ContractID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractGetInfoQuery";
    }, o;
  }(), ContractGetInfoResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.contractInfo = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.contractInfo != null && Object.hasOwnProperty.call(e, "contractInfo") && c.proto.ContractGetInfoResponse.ContractInfo.encode(e.contractInfo, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractGetInfoResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.contractInfo = c.proto.ContractGetInfoResponse.ContractInfo.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractGetInfoResponse";
    }, o.ContractInfo = function() {
      function e(n) {
        if (this.tokenRelationships = [], n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.contractID = null, e.prototype.accountID = null, e.prototype.contractAccountID = "", e.prototype.adminKey = null, e.prototype.expirationTime = null, e.prototype.autoRenewPeriod = null, e.prototype.storage = g.Long ? g.Long.fromBits(0, 0, !1) : 0, e.prototype.memo = "", e.prototype.balance = g.Long ? g.Long.fromBits(0, 0, !0) : 0, e.prototype.deleted = !1, e.prototype.tokenRelationships = g.emptyArray, e.prototype.ledgerId = g.newBuffer([]), e.prototype.autoRenewAccountId = null, e.prototype.maxAutomaticTokenAssociations = 0, e.prototype.stakingInfo = null, e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        if (i || (i = h.create()), n.contractID != null && Object.hasOwnProperty.call(n, "contractID") && c.proto.ContractID.encode(n.contractID, i.uint32(10).fork()).ldelim(), n.accountID != null && Object.hasOwnProperty.call(n, "accountID") && c.proto.AccountID.encode(n.accountID, i.uint32(18).fork()).ldelim(), n.contractAccountID != null && Object.hasOwnProperty.call(n, "contractAccountID") && i.uint32(26).string(n.contractAccountID), n.adminKey != null && Object.hasOwnProperty.call(n, "adminKey") && c.proto.Key.encode(n.adminKey, i.uint32(34).fork()).ldelim(), n.expirationTime != null && Object.hasOwnProperty.call(n, "expirationTime") && c.proto.Timestamp.encode(n.expirationTime, i.uint32(42).fork()).ldelim(), n.autoRenewPeriod != null && Object.hasOwnProperty.call(n, "autoRenewPeriod") && c.proto.Duration.encode(n.autoRenewPeriod, i.uint32(50).fork()).ldelim(), n.storage != null && Object.hasOwnProperty.call(n, "storage") && i.uint32(56).int64(n.storage), n.memo != null && Object.hasOwnProperty.call(n, "memo") && i.uint32(66).string(n.memo), n.balance != null && Object.hasOwnProperty.call(n, "balance") && i.uint32(72).uint64(n.balance), n.deleted != null && Object.hasOwnProperty.call(n, "deleted") && i.uint32(80).bool(n.deleted), n.tokenRelationships != null && n.tokenRelationships.length)
          for (var y = 0; y < n.tokenRelationships.length; ++y)
            c.proto.TokenRelationship.encode(n.tokenRelationships[y], i.uint32(90).fork()).ldelim();
        return n.ledgerId != null && Object.hasOwnProperty.call(n, "ledgerId") && i.uint32(98).bytes(n.ledgerId), n.autoRenewAccountId != null && Object.hasOwnProperty.call(n, "autoRenewAccountId") && c.proto.AccountID.encode(n.autoRenewAccountId, i.uint32(106).fork()).ldelim(), n.maxAutomaticTokenAssociations != null && Object.hasOwnProperty.call(n, "maxAutomaticTokenAssociations") && i.uint32(112).int32(n.maxAutomaticTokenAssociations), n.stakingInfo != null && Object.hasOwnProperty.call(n, "stakingInfo") && c.proto.StakingInfo.encode(n.stakingInfo, i.uint32(122).fork()).ldelim(), i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.ContractGetInfoResponse.ContractInfo(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.contractID = c.proto.ContractID.decode(n, n.uint32());
              break;
            }
            case 2: {
              m.accountID = c.proto.AccountID.decode(n, n.uint32());
              break;
            }
            case 3: {
              m.contractAccountID = n.string();
              break;
            }
            case 4: {
              m.adminKey = c.proto.Key.decode(n, n.uint32());
              break;
            }
            case 5: {
              m.expirationTime = c.proto.Timestamp.decode(n, n.uint32());
              break;
            }
            case 6: {
              m.autoRenewPeriod = c.proto.Duration.decode(n, n.uint32());
              break;
            }
            case 7: {
              m.storage = n.int64();
              break;
            }
            case 8: {
              m.memo = n.string();
              break;
            }
            case 9: {
              m.balance = n.uint64();
              break;
            }
            case 10: {
              m.deleted = n.bool();
              break;
            }
            case 11: {
              m.tokenRelationships && m.tokenRelationships.length || (m.tokenRelationships = []), m.tokenRelationships.push(c.proto.TokenRelationship.decode(n, n.uint32()));
              break;
            }
            case 12: {
              m.ledgerId = n.bytes();
              break;
            }
            case 13: {
              m.autoRenewAccountId = c.proto.AccountID.decode(n, n.uint32());
              break;
            }
            case 14: {
              m.maxAutomaticTokenAssociations = n.int32();
              break;
            }
            case 15: {
              m.stakingInfo = c.proto.StakingInfo.decode(n, n.uint32());
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/proto.ContractGetInfoResponse.ContractInfo";
      }, e;
    }(), o;
  }(), ContractGetBytecodeQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.contractID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.contractID != null && Object.hasOwnProperty.call(e, "contractID") && c.proto.ContractID.encode(e.contractID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractGetBytecodeQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.contractID = c.proto.ContractID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractGetBytecodeQuery";
    }, o;
  }(), ContractGetBytecodeResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.bytecode = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.bytecode != null && Object.hasOwnProperty.call(e, "bytecode") && n.uint32(50).bytes(e.bytecode), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractGetBytecodeResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 6: {
            y.bytecode = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractGetBytecodeResponse";
    }, o;
  }(), ContractGetRecordsQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.contractID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.contractID != null && Object.hasOwnProperty.call(e, "contractID") && c.proto.ContractID.encode(e.contractID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractGetRecordsQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.contractID = c.proto.ContractID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractGetRecordsQuery";
    }, o;
  }(), ContractGetRecordsResponse: function() {
    function o(e) {
      if (this.records = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.contractID = null, o.prototype.records = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.contractID != null && Object.hasOwnProperty.call(e, "contractID") && c.proto.ContractID.encode(e.contractID, n.uint32(18).fork()).ldelim(), e.records != null && e.records.length)
        for (var i = 0; i < e.records.length; ++i)
          c.proto.TransactionRecord.encode(e.records[i], n.uint32(26).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractGetRecordsResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.contractID = c.proto.ContractID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.records && y.records.length || (y.records = []), y.records.push(c.proto.TransactionRecord.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractGetRecordsResponse";
    }, o;
  }(), TransactionRecord: function() {
    function o(n) {
      if (this.tokenTransferLists = [], this.assessedCustomFees = [], this.automaticTokenAssociations = [], this.paidStakingRewards = [], n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.receipt = null, o.prototype.transactionHash = g.newBuffer([]), o.prototype.consensusTimestamp = null, o.prototype.transactionID = null, o.prototype.memo = "", o.prototype.transactionFee = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.contractCallResult = null, o.prototype.contractCreateResult = null, o.prototype.transferList = null, o.prototype.tokenTransferLists = g.emptyArray, o.prototype.scheduleRef = null, o.prototype.assessedCustomFees = g.emptyArray, o.prototype.automaticTokenAssociations = g.emptyArray, o.prototype.parentConsensusTimestamp = null, o.prototype.alias = g.newBuffer([]), o.prototype.ethereumHash = g.newBuffer([]), o.prototype.paidStakingRewards = g.emptyArray, o.prototype.prngBytes = null, o.prototype.prngNumber = null, o.prototype.evmAddress = g.newBuffer([]);
    let e;
    return Object.defineProperty(o.prototype, "body", { get: g.oneOfGetter(e = ["contractCallResult", "contractCreateResult"]), set: g.oneOfSetter(e) }), Object.defineProperty(o.prototype, "entropy", { get: g.oneOfGetter(e = ["prngBytes", "prngNumber"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      if (i || (i = h.create()), n.receipt != null && Object.hasOwnProperty.call(n, "receipt") && c.proto.TransactionReceipt.encode(n.receipt, i.uint32(10).fork()).ldelim(), n.transactionHash != null && Object.hasOwnProperty.call(n, "transactionHash") && i.uint32(18).bytes(n.transactionHash), n.consensusTimestamp != null && Object.hasOwnProperty.call(n, "consensusTimestamp") && c.proto.Timestamp.encode(n.consensusTimestamp, i.uint32(26).fork()).ldelim(), n.transactionID != null && Object.hasOwnProperty.call(n, "transactionID") && c.proto.TransactionID.encode(n.transactionID, i.uint32(34).fork()).ldelim(), n.memo != null && Object.hasOwnProperty.call(n, "memo") && i.uint32(42).string(n.memo), n.transactionFee != null && Object.hasOwnProperty.call(n, "transactionFee") && i.uint32(48).uint64(n.transactionFee), n.contractCallResult != null && Object.hasOwnProperty.call(n, "contractCallResult") && c.proto.ContractFunctionResult.encode(n.contractCallResult, i.uint32(58).fork()).ldelim(), n.contractCreateResult != null && Object.hasOwnProperty.call(n, "contractCreateResult") && c.proto.ContractFunctionResult.encode(n.contractCreateResult, i.uint32(66).fork()).ldelim(), n.transferList != null && Object.hasOwnProperty.call(n, "transferList") && c.proto.TransferList.encode(n.transferList, i.uint32(82).fork()).ldelim(), n.tokenTransferLists != null && n.tokenTransferLists.length)
        for (var y = 0; y < n.tokenTransferLists.length; ++y)
          c.proto.TokenTransferList.encode(n.tokenTransferLists[y], i.uint32(90).fork()).ldelim();
      if (n.scheduleRef != null && Object.hasOwnProperty.call(n, "scheduleRef") && c.proto.ScheduleID.encode(n.scheduleRef, i.uint32(98).fork()).ldelim(), n.assessedCustomFees != null && n.assessedCustomFees.length)
        for (var y = 0; y < n.assessedCustomFees.length; ++y)
          c.proto.AssessedCustomFee.encode(n.assessedCustomFees[y], i.uint32(106).fork()).ldelim();
      if (n.automaticTokenAssociations != null && n.automaticTokenAssociations.length)
        for (var y = 0; y < n.automaticTokenAssociations.length; ++y)
          c.proto.TokenAssociation.encode(n.automaticTokenAssociations[y], i.uint32(114).fork()).ldelim();
      if (n.parentConsensusTimestamp != null && Object.hasOwnProperty.call(n, "parentConsensusTimestamp") && c.proto.Timestamp.encode(n.parentConsensusTimestamp, i.uint32(122).fork()).ldelim(), n.alias != null && Object.hasOwnProperty.call(n, "alias") && i.uint32(130).bytes(n.alias), n.ethereumHash != null && Object.hasOwnProperty.call(n, "ethereumHash") && i.uint32(138).bytes(n.ethereumHash), n.paidStakingRewards != null && n.paidStakingRewards.length)
        for (var y = 0; y < n.paidStakingRewards.length; ++y)
          c.proto.AccountAmount.encode(n.paidStakingRewards[y], i.uint32(146).fork()).ldelim();
      return n.prngBytes != null && Object.hasOwnProperty.call(n, "prngBytes") && i.uint32(154).bytes(n.prngBytes), n.prngNumber != null && Object.hasOwnProperty.call(n, "prngNumber") && i.uint32(160).int32(n.prngNumber), n.evmAddress != null && Object.hasOwnProperty.call(n, "evmAddress") && i.uint32(170).bytes(n.evmAddress), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.TransactionRecord(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.receipt = c.proto.TransactionReceipt.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.transactionHash = n.bytes();
            break;
          }
          case 3: {
            m.consensusTimestamp = c.proto.Timestamp.decode(n, n.uint32());
            break;
          }
          case 4: {
            m.transactionID = c.proto.TransactionID.decode(n, n.uint32());
            break;
          }
          case 5: {
            m.memo = n.string();
            break;
          }
          case 6: {
            m.transactionFee = n.uint64();
            break;
          }
          case 7: {
            m.contractCallResult = c.proto.ContractFunctionResult.decode(n, n.uint32());
            break;
          }
          case 8: {
            m.contractCreateResult = c.proto.ContractFunctionResult.decode(n, n.uint32());
            break;
          }
          case 10: {
            m.transferList = c.proto.TransferList.decode(n, n.uint32());
            break;
          }
          case 11: {
            m.tokenTransferLists && m.tokenTransferLists.length || (m.tokenTransferLists = []), m.tokenTransferLists.push(c.proto.TokenTransferList.decode(n, n.uint32()));
            break;
          }
          case 12: {
            m.scheduleRef = c.proto.ScheduleID.decode(n, n.uint32());
            break;
          }
          case 13: {
            m.assessedCustomFees && m.assessedCustomFees.length || (m.assessedCustomFees = []), m.assessedCustomFees.push(c.proto.AssessedCustomFee.decode(n, n.uint32()));
            break;
          }
          case 14: {
            m.automaticTokenAssociations && m.automaticTokenAssociations.length || (m.automaticTokenAssociations = []), m.automaticTokenAssociations.push(c.proto.TokenAssociation.decode(n, n.uint32()));
            break;
          }
          case 15: {
            m.parentConsensusTimestamp = c.proto.Timestamp.decode(n, n.uint32());
            break;
          }
          case 16: {
            m.alias = n.bytes();
            break;
          }
          case 17: {
            m.ethereumHash = n.bytes();
            break;
          }
          case 18: {
            m.paidStakingRewards && m.paidStakingRewards.length || (m.paidStakingRewards = []), m.paidStakingRewards.push(c.proto.AccountAmount.decode(n, n.uint32()));
            break;
          }
          case 19: {
            m.prngBytes = n.bytes();
            break;
          }
          case 20: {
            m.prngNumber = n.int32();
            break;
          }
          case 21: {
            m.evmAddress = n.bytes();
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.TransactionRecord";
    }, o;
  }(), TransactionReceipt: function() {
    function o(e) {
      if (this.serialNumbers = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.status = 0, o.prototype.accountID = null, o.prototype.fileID = null, o.prototype.contractID = null, o.prototype.exchangeRate = null, o.prototype.topicID = null, o.prototype.topicSequenceNumber = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.topicRunningHash = g.newBuffer([]), o.prototype.topicRunningHashVersion = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.tokenID = null, o.prototype.newTotalSupply = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.scheduleID = null, o.prototype.scheduledTransactionID = null, o.prototype.serialNumbers = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.status != null && Object.hasOwnProperty.call(e, "status") && n.uint32(8).int32(e.status), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(18).fork()).ldelim(), e.fileID != null && Object.hasOwnProperty.call(e, "fileID") && c.proto.FileID.encode(e.fileID, n.uint32(26).fork()).ldelim(), e.contractID != null && Object.hasOwnProperty.call(e, "contractID") && c.proto.ContractID.encode(e.contractID, n.uint32(34).fork()).ldelim(), e.exchangeRate != null && Object.hasOwnProperty.call(e, "exchangeRate") && c.proto.ExchangeRateSet.encode(e.exchangeRate, n.uint32(42).fork()).ldelim(), e.topicID != null && Object.hasOwnProperty.call(e, "topicID") && c.proto.TopicID.encode(e.topicID, n.uint32(50).fork()).ldelim(), e.topicSequenceNumber != null && Object.hasOwnProperty.call(e, "topicSequenceNumber") && n.uint32(56).uint64(e.topicSequenceNumber), e.topicRunningHash != null && Object.hasOwnProperty.call(e, "topicRunningHash") && n.uint32(66).bytes(e.topicRunningHash), e.topicRunningHashVersion != null && Object.hasOwnProperty.call(e, "topicRunningHashVersion") && n.uint32(72).uint64(e.topicRunningHashVersion), e.tokenID != null && Object.hasOwnProperty.call(e, "tokenID") && c.proto.TokenID.encode(e.tokenID, n.uint32(82).fork()).ldelim(), e.newTotalSupply != null && Object.hasOwnProperty.call(e, "newTotalSupply") && n.uint32(88).uint64(e.newTotalSupply), e.scheduleID != null && Object.hasOwnProperty.call(e, "scheduleID") && c.proto.ScheduleID.encode(e.scheduleID, n.uint32(98).fork()).ldelim(), e.scheduledTransactionID != null && Object.hasOwnProperty.call(e, "scheduledTransactionID") && c.proto.TransactionID.encode(e.scheduledTransactionID, n.uint32(106).fork()).ldelim(), e.serialNumbers != null && e.serialNumbers.length) {
        n.uint32(114).fork();
        for (var i = 0; i < e.serialNumbers.length; ++i)
          n.int64(e.serialNumbers[i]);
        n.ldelim();
      }
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TransactionReceipt(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.status = e.int32();
            break;
          }
          case 2: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.fileID = c.proto.FileID.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.contractID = c.proto.ContractID.decode(e, e.uint32());
            break;
          }
          case 5: {
            y.exchangeRate = c.proto.ExchangeRateSet.decode(e, e.uint32());
            break;
          }
          case 6: {
            y.topicID = c.proto.TopicID.decode(e, e.uint32());
            break;
          }
          case 7: {
            y.topicSequenceNumber = e.uint64();
            break;
          }
          case 8: {
            y.topicRunningHash = e.bytes();
            break;
          }
          case 9: {
            y.topicRunningHashVersion = e.uint64();
            break;
          }
          case 10: {
            y.tokenID = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 11: {
            y.newTotalSupply = e.uint64();
            break;
          }
          case 12: {
            y.scheduleID = c.proto.ScheduleID.decode(e, e.uint32());
            break;
          }
          case 13: {
            y.scheduledTransactionID = c.proto.TransactionID.decode(e, e.uint32());
            break;
          }
          case 14: {
            if (y.serialNumbers && y.serialNumbers.length || (y.serialNumbers = []), (7 & m) == 2)
              for (var U = e.uint32() + e.pos; e.pos < U; )
                y.serialNumbers.push(e.int64());
            else
              y.serialNumbers.push(e.int64());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TransactionReceipt";
    }, o;
  }(), ExchangeRate: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.hbarEquiv = 0, o.prototype.centEquiv = 0, o.prototype.expirationTime = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.hbarEquiv != null && Object.hasOwnProperty.call(e, "hbarEquiv") && n.uint32(8).int32(e.hbarEquiv), e.centEquiv != null && Object.hasOwnProperty.call(e, "centEquiv") && n.uint32(16).int32(e.centEquiv), e.expirationTime != null && Object.hasOwnProperty.call(e, "expirationTime") && c.proto.TimestampSeconds.encode(e.expirationTime, n.uint32(26).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ExchangeRate(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.hbarEquiv = e.int32();
            break;
          }
          case 2: {
            y.centEquiv = e.int32();
            break;
          }
          case 3: {
            y.expirationTime = c.proto.TimestampSeconds.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ExchangeRate";
    }, o;
  }(), ExchangeRateSet: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.currentRate = null, o.prototype.nextRate = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.currentRate != null && Object.hasOwnProperty.call(e, "currentRate") && c.proto.ExchangeRate.encode(e.currentRate, n.uint32(10).fork()).ldelim(), e.nextRate != null && Object.hasOwnProperty.call(e, "nextRate") && c.proto.ExchangeRate.encode(e.nextRate, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ExchangeRateSet(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.currentRate = c.proto.ExchangeRate.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.nextRate = c.proto.ExchangeRate.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ExchangeRateSet";
    }, o;
  }(), CryptoGetAccountBalanceQuery: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.header = null, o.prototype.accountID = null, o.prototype.contractID = null;
    let e;
    return Object.defineProperty(o.prototype, "balanceSource", { get: g.oneOfGetter(e = ["accountID", "contractID"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.header != null && Object.hasOwnProperty.call(n, "header") && c.proto.QueryHeader.encode(n.header, i.uint32(10).fork()).ldelim(), n.accountID != null && Object.hasOwnProperty.call(n, "accountID") && c.proto.AccountID.encode(n.accountID, i.uint32(18).fork()).ldelim(), n.contractID != null && Object.hasOwnProperty.call(n, "contractID") && c.proto.ContractID.encode(n.contractID, i.uint32(26).fork()).ldelim(), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.CryptoGetAccountBalanceQuery(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.header = c.proto.QueryHeader.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.accountID = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 3: {
            m.contractID = c.proto.ContractID.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.CryptoGetAccountBalanceQuery";
    }, o;
  }(), CryptoGetAccountBalanceResponse: function() {
    function o(e) {
      if (this.tokenBalances = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.accountID = null, o.prototype.balance = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.tokenBalances = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(18).fork()).ldelim(), e.balance != null && Object.hasOwnProperty.call(e, "balance") && n.uint32(24).uint64(e.balance), e.tokenBalances != null && e.tokenBalances.length)
        for (var i = 0; i < e.tokenBalances.length; ++i)
          c.proto.TokenBalance.encode(e.tokenBalances[i], n.uint32(34).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoGetAccountBalanceResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.balance = e.uint64();
            break;
          }
          case 4: {
            y.tokenBalances && y.tokenBalances.length || (y.tokenBalances = []), y.tokenBalances.push(c.proto.TokenBalance.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoGetAccountBalanceResponse";
    }, o;
  }(), CryptoGetAccountRecordsQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.accountID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoGetAccountRecordsQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoGetAccountRecordsQuery";
    }, o;
  }(), CryptoGetAccountRecordsResponse: function() {
    function o(e) {
      if (this.records = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.accountID = null, o.prototype.records = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(18).fork()).ldelim(), e.records != null && e.records.length)
        for (var i = 0; i < e.records.length; ++i)
          c.proto.TransactionRecord.encode(e.records[i], n.uint32(26).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoGetAccountRecordsResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.records && y.records.length || (y.records = []), y.records.push(c.proto.TransactionRecord.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoGetAccountRecordsResponse";
    }, o;
  }(), CryptoGetInfoQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.accountID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoGetInfoQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoGetInfoQuery";
    }, o;
  }(), CryptoGetInfoResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.accountInfo = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.accountInfo != null && Object.hasOwnProperty.call(e, "accountInfo") && c.proto.CryptoGetInfoResponse.AccountInfo.encode(e.accountInfo, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoGetInfoResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountInfo = c.proto.CryptoGetInfoResponse.AccountInfo.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoGetInfoResponse";
    }, o.AccountInfo = function() {
      function e(n) {
        if (this.liveHashes = [], this.tokenRelationships = [], n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.accountID = null, e.prototype.contractAccountID = "", e.prototype.deleted = !1, e.prototype.proxyAccountID = null, e.prototype.proxyReceived = g.Long ? g.Long.fromBits(0, 0, !1) : 0, e.prototype.key = null, e.prototype.balance = g.Long ? g.Long.fromBits(0, 0, !0) : 0, e.prototype.generateSendRecordThreshold = g.Long ? g.Long.fromBits(0, 0, !0) : 0, e.prototype.generateReceiveRecordThreshold = g.Long ? g.Long.fromBits(0, 0, !0) : 0, e.prototype.receiverSigRequired = !1, e.prototype.expirationTime = null, e.prototype.autoRenewPeriod = null, e.prototype.liveHashes = g.emptyArray, e.prototype.tokenRelationships = g.emptyArray, e.prototype.memo = "", e.prototype.ownedNfts = g.Long ? g.Long.fromBits(0, 0, !1) : 0, e.prototype.maxAutomaticTokenAssociations = 0, e.prototype.alias = g.newBuffer([]), e.prototype.ledgerId = g.newBuffer([]), e.prototype.ethereumNonce = g.Long ? g.Long.fromBits(0, 0, !1) : 0, e.prototype.stakingInfo = null, e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        if (i || (i = h.create()), n.accountID != null && Object.hasOwnProperty.call(n, "accountID") && c.proto.AccountID.encode(n.accountID, i.uint32(10).fork()).ldelim(), n.contractAccountID != null && Object.hasOwnProperty.call(n, "contractAccountID") && i.uint32(18).string(n.contractAccountID), n.deleted != null && Object.hasOwnProperty.call(n, "deleted") && i.uint32(24).bool(n.deleted), n.proxyAccountID != null && Object.hasOwnProperty.call(n, "proxyAccountID") && c.proto.AccountID.encode(n.proxyAccountID, i.uint32(34).fork()).ldelim(), n.proxyReceived != null && Object.hasOwnProperty.call(n, "proxyReceived") && i.uint32(48).int64(n.proxyReceived), n.key != null && Object.hasOwnProperty.call(n, "key") && c.proto.Key.encode(n.key, i.uint32(58).fork()).ldelim(), n.balance != null && Object.hasOwnProperty.call(n, "balance") && i.uint32(64).uint64(n.balance), n.generateSendRecordThreshold != null && Object.hasOwnProperty.call(n, "generateSendRecordThreshold") && i.uint32(72).uint64(n.generateSendRecordThreshold), n.generateReceiveRecordThreshold != null && Object.hasOwnProperty.call(n, "generateReceiveRecordThreshold") && i.uint32(80).uint64(n.generateReceiveRecordThreshold), n.receiverSigRequired != null && Object.hasOwnProperty.call(n, "receiverSigRequired") && i.uint32(88).bool(n.receiverSigRequired), n.expirationTime != null && Object.hasOwnProperty.call(n, "expirationTime") && c.proto.Timestamp.encode(n.expirationTime, i.uint32(98).fork()).ldelim(), n.autoRenewPeriod != null && Object.hasOwnProperty.call(n, "autoRenewPeriod") && c.proto.Duration.encode(n.autoRenewPeriod, i.uint32(106).fork()).ldelim(), n.liveHashes != null && n.liveHashes.length)
          for (var y = 0; y < n.liveHashes.length; ++y)
            c.proto.LiveHash.encode(n.liveHashes[y], i.uint32(114).fork()).ldelim();
        if (n.tokenRelationships != null && n.tokenRelationships.length)
          for (var y = 0; y < n.tokenRelationships.length; ++y)
            c.proto.TokenRelationship.encode(n.tokenRelationships[y], i.uint32(122).fork()).ldelim();
        return n.memo != null && Object.hasOwnProperty.call(n, "memo") && i.uint32(130).string(n.memo), n.ownedNfts != null && Object.hasOwnProperty.call(n, "ownedNfts") && i.uint32(136).int64(n.ownedNfts), n.maxAutomaticTokenAssociations != null && Object.hasOwnProperty.call(n, "maxAutomaticTokenAssociations") && i.uint32(144).int32(n.maxAutomaticTokenAssociations), n.alias != null && Object.hasOwnProperty.call(n, "alias") && i.uint32(154).bytes(n.alias), n.ledgerId != null && Object.hasOwnProperty.call(n, "ledgerId") && i.uint32(162).bytes(n.ledgerId), n.ethereumNonce != null && Object.hasOwnProperty.call(n, "ethereumNonce") && i.uint32(168).int64(n.ethereumNonce), n.stakingInfo != null && Object.hasOwnProperty.call(n, "stakingInfo") && c.proto.StakingInfo.encode(n.stakingInfo, i.uint32(178).fork()).ldelim(), i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.CryptoGetInfoResponse.AccountInfo(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.accountID = c.proto.AccountID.decode(n, n.uint32());
              break;
            }
            case 2: {
              m.contractAccountID = n.string();
              break;
            }
            case 3: {
              m.deleted = n.bool();
              break;
            }
            case 4: {
              m.proxyAccountID = c.proto.AccountID.decode(n, n.uint32());
              break;
            }
            case 6: {
              m.proxyReceived = n.int64();
              break;
            }
            case 7: {
              m.key = c.proto.Key.decode(n, n.uint32());
              break;
            }
            case 8: {
              m.balance = n.uint64();
              break;
            }
            case 9: {
              m.generateSendRecordThreshold = n.uint64();
              break;
            }
            case 10: {
              m.generateReceiveRecordThreshold = n.uint64();
              break;
            }
            case 11: {
              m.receiverSigRequired = n.bool();
              break;
            }
            case 12: {
              m.expirationTime = c.proto.Timestamp.decode(n, n.uint32());
              break;
            }
            case 13: {
              m.autoRenewPeriod = c.proto.Duration.decode(n, n.uint32());
              break;
            }
            case 14: {
              m.liveHashes && m.liveHashes.length || (m.liveHashes = []), m.liveHashes.push(c.proto.LiveHash.decode(n, n.uint32()));
              break;
            }
            case 15: {
              m.tokenRelationships && m.tokenRelationships.length || (m.tokenRelationships = []), m.tokenRelationships.push(c.proto.TokenRelationship.decode(n, n.uint32()));
              break;
            }
            case 16: {
              m.memo = n.string();
              break;
            }
            case 17: {
              m.ownedNfts = n.int64();
              break;
            }
            case 18: {
              m.maxAutomaticTokenAssociations = n.int32();
              break;
            }
            case 19: {
              m.alias = n.bytes();
              break;
            }
            case 20: {
              m.ledgerId = n.bytes();
              break;
            }
            case 21: {
              m.ethereumNonce = n.int64();
              break;
            }
            case 22: {
              m.stakingInfo = c.proto.StakingInfo.decode(n, n.uint32());
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/proto.CryptoGetInfoResponse.AccountInfo";
      }, e;
    }(), o;
  }(), CryptoGetLiveHashQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.accountID = null, o.prototype.hash = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(18).fork()).ldelim(), e.hash != null && Object.hasOwnProperty.call(e, "hash") && n.uint32(26).bytes(e.hash), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoGetLiveHashQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.hash = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoGetLiveHashQuery";
    }, o;
  }(), CryptoGetLiveHashResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.liveHash = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.liveHash != null && Object.hasOwnProperty.call(e, "liveHash") && c.proto.LiveHash.encode(e.liveHash, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoGetLiveHashResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.liveHash = c.proto.LiveHash.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoGetLiveHashResponse";
    }, o;
  }(), CryptoGetStakersQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.accountID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoGetStakersQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoGetStakersQuery";
    }, o;
  }(), ProxyStaker: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.accountID = null, o.prototype.amount = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(10).fork()).ldelim(), e.amount != null && Object.hasOwnProperty.call(e, "amount") && n.uint32(16).int64(e.amount), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ProxyStaker(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.amount = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ProxyStaker";
    }, o;
  }(), AllProxyStakers: function() {
    function o(e) {
      if (this.proxyStaker = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.accountID = null, o.prototype.proxyStaker = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(10).fork()).ldelim(), e.proxyStaker != null && e.proxyStaker.length)
        for (var i = 0; i < e.proxyStaker.length; ++i)
          c.proto.ProxyStaker.encode(e.proxyStaker[i], n.uint32(18).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.AllProxyStakers(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.proxyStaker && y.proxyStaker.length || (y.proxyStaker = []), y.proxyStaker.push(c.proto.ProxyStaker.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.AllProxyStakers";
    }, o;
  }(), CryptoGetStakersResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.stakers = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.stakers != null && Object.hasOwnProperty.call(e, "stakers") && c.proto.AllProxyStakers.encode(e.stakers, n.uint32(26).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.CryptoGetStakersResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.stakers = c.proto.AllProxyStakers.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.CryptoGetStakersResponse";
    }, o;
  }(), FileGetContentsQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.fileID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.fileID != null && Object.hasOwnProperty.call(e, "fileID") && c.proto.FileID.encode(e.fileID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FileGetContentsQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.fileID = c.proto.FileID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FileGetContentsQuery";
    }, o;
  }(), FileGetContentsResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.fileContents = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.fileContents != null && Object.hasOwnProperty.call(e, "fileContents") && c.proto.FileGetContentsResponse.FileContents.encode(e.fileContents, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FileGetContentsResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.fileContents = c.proto.FileGetContentsResponse.FileContents.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FileGetContentsResponse";
    }, o.FileContents = function() {
      function e(n) {
        if (n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.fileID = null, e.prototype.contents = g.newBuffer([]), e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        return i || (i = h.create()), n.fileID != null && Object.hasOwnProperty.call(n, "fileID") && c.proto.FileID.encode(n.fileID, i.uint32(10).fork()).ldelim(), n.contents != null && Object.hasOwnProperty.call(n, "contents") && i.uint32(18).bytes(n.contents), i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.FileGetContentsResponse.FileContents(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.fileID = c.proto.FileID.decode(n, n.uint32());
              break;
            }
            case 2: {
              m.contents = n.bytes();
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/proto.FileGetContentsResponse.FileContents";
      }, e;
    }(), o;
  }(), FileGetInfoQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.fileID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.fileID != null && Object.hasOwnProperty.call(e, "fileID") && c.proto.FileID.encode(e.fileID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FileGetInfoQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.fileID = c.proto.FileID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FileGetInfoQuery";
    }, o;
  }(), FileGetInfoResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.fileInfo = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.fileInfo != null && Object.hasOwnProperty.call(e, "fileInfo") && c.proto.FileGetInfoResponse.FileInfo.encode(e.fileInfo, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.FileGetInfoResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.fileInfo = c.proto.FileGetInfoResponse.FileInfo.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.FileGetInfoResponse";
    }, o.FileInfo = function() {
      function e(n) {
        if (n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.fileID = null, e.prototype.size = g.Long ? g.Long.fromBits(0, 0, !1) : 0, e.prototype.expirationTime = null, e.prototype.deleted = !1, e.prototype.keys = null, e.prototype.memo = "", e.prototype.ledgerId = g.newBuffer([]), e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        return i || (i = h.create()), n.fileID != null && Object.hasOwnProperty.call(n, "fileID") && c.proto.FileID.encode(n.fileID, i.uint32(10).fork()).ldelim(), n.size != null && Object.hasOwnProperty.call(n, "size") && i.uint32(16).int64(n.size), n.expirationTime != null && Object.hasOwnProperty.call(n, "expirationTime") && c.proto.Timestamp.encode(n.expirationTime, i.uint32(26).fork()).ldelim(), n.deleted != null && Object.hasOwnProperty.call(n, "deleted") && i.uint32(32).bool(n.deleted), n.keys != null && Object.hasOwnProperty.call(n, "keys") && c.proto.KeyList.encode(n.keys, i.uint32(42).fork()).ldelim(), n.memo != null && Object.hasOwnProperty.call(n, "memo") && i.uint32(50).string(n.memo), n.ledgerId != null && Object.hasOwnProperty.call(n, "ledgerId") && i.uint32(58).bytes(n.ledgerId), i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.FileGetInfoResponse.FileInfo(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.fileID = c.proto.FileID.decode(n, n.uint32());
              break;
            }
            case 2: {
              m.size = n.int64();
              break;
            }
            case 3: {
              m.expirationTime = c.proto.Timestamp.decode(n, n.uint32());
              break;
            }
            case 4: {
              m.deleted = n.bool();
              break;
            }
            case 5: {
              m.keys = c.proto.KeyList.decode(n, n.uint32());
              break;
            }
            case 6: {
              m.memo = n.string();
              break;
            }
            case 7: {
              m.ledgerId = n.bytes();
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/proto.FileGetInfoResponse.FileInfo";
      }, e;
    }(), o;
  }(), TransactionGetReceiptQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.transactionID = null, o.prototype.includeDuplicates = !1, o.prototype.includeChildReceipts = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.transactionID != null && Object.hasOwnProperty.call(e, "transactionID") && c.proto.TransactionID.encode(e.transactionID, n.uint32(18).fork()).ldelim(), e.includeDuplicates != null && Object.hasOwnProperty.call(e, "includeDuplicates") && n.uint32(24).bool(e.includeDuplicates), e.includeChildReceipts != null && Object.hasOwnProperty.call(e, "includeChildReceipts") && n.uint32(32).bool(e.includeChildReceipts), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TransactionGetReceiptQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.transactionID = c.proto.TransactionID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.includeDuplicates = e.bool();
            break;
          }
          case 4: {
            y.includeChildReceipts = e.bool();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TransactionGetReceiptQuery";
    }, o;
  }(), TransactionGetReceiptResponse: function() {
    function o(e) {
      if (this.duplicateTransactionReceipts = [], this.childTransactionReceipts = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.receipt = null, o.prototype.duplicateTransactionReceipts = g.emptyArray, o.prototype.childTransactionReceipts = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.receipt != null && Object.hasOwnProperty.call(e, "receipt") && c.proto.TransactionReceipt.encode(e.receipt, n.uint32(18).fork()).ldelim(), e.duplicateTransactionReceipts != null && e.duplicateTransactionReceipts.length)
        for (var i = 0; i < e.duplicateTransactionReceipts.length; ++i)
          c.proto.TransactionReceipt.encode(e.duplicateTransactionReceipts[i], n.uint32(34).fork()).ldelim();
      if (e.childTransactionReceipts != null && e.childTransactionReceipts.length)
        for (var i = 0; i < e.childTransactionReceipts.length; ++i)
          c.proto.TransactionReceipt.encode(e.childTransactionReceipts[i], n.uint32(42).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TransactionGetReceiptResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.receipt = c.proto.TransactionReceipt.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.duplicateTransactionReceipts && y.duplicateTransactionReceipts.length || (y.duplicateTransactionReceipts = []), y.duplicateTransactionReceipts.push(c.proto.TransactionReceipt.decode(e, e.uint32()));
            break;
          }
          case 5: {
            y.childTransactionReceipts && y.childTransactionReceipts.length || (y.childTransactionReceipts = []), y.childTransactionReceipts.push(c.proto.TransactionReceipt.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TransactionGetReceiptResponse";
    }, o;
  }(), TransactionGetRecordQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.transactionID = null, o.prototype.includeDuplicates = !1, o.prototype.includeChildRecords = !1, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.transactionID != null && Object.hasOwnProperty.call(e, "transactionID") && c.proto.TransactionID.encode(e.transactionID, n.uint32(18).fork()).ldelim(), e.includeDuplicates != null && Object.hasOwnProperty.call(e, "includeDuplicates") && n.uint32(24).bool(e.includeDuplicates), e.includeChildRecords != null && Object.hasOwnProperty.call(e, "includeChildRecords") && n.uint32(32).bool(e.includeChildRecords), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TransactionGetRecordQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.transactionID = c.proto.TransactionID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.includeDuplicates = e.bool();
            break;
          }
          case 4: {
            y.includeChildRecords = e.bool();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TransactionGetRecordQuery";
    }, o;
  }(), TransactionGetRecordResponse: function() {
    function o(e) {
      if (this.duplicateTransactionRecords = [], this.childTransactionRecords = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.transactionRecord = null, o.prototype.duplicateTransactionRecords = g.emptyArray, o.prototype.childTransactionRecords = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.transactionRecord != null && Object.hasOwnProperty.call(e, "transactionRecord") && c.proto.TransactionRecord.encode(e.transactionRecord, n.uint32(26).fork()).ldelim(), e.duplicateTransactionRecords != null && e.duplicateTransactionRecords.length)
        for (var i = 0; i < e.duplicateTransactionRecords.length; ++i)
          c.proto.TransactionRecord.encode(e.duplicateTransactionRecords[i], n.uint32(34).fork()).ldelim();
      if (e.childTransactionRecords != null && e.childTransactionRecords.length)
        for (var i = 0; i < e.childTransactionRecords.length; ++i)
          c.proto.TransactionRecord.encode(e.childTransactionRecords[i], n.uint32(42).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TransactionGetRecordResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.transactionRecord = c.proto.TransactionRecord.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.duplicateTransactionRecords && y.duplicateTransactionRecords.length || (y.duplicateTransactionRecords = []), y.duplicateTransactionRecords.push(c.proto.TransactionRecord.decode(e, e.uint32()));
            break;
          }
          case 5: {
            y.childTransactionRecords && y.childTransactionRecords.length || (y.childTransactionRecords = []), y.childTransactionRecords.push(c.proto.TransactionRecord.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TransactionGetRecordResponse";
    }, o;
  }(), TransactionGetFastRecordQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.transactionID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.transactionID != null && Object.hasOwnProperty.call(e, "transactionID") && c.proto.TransactionID.encode(e.transactionID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TransactionGetFastRecordQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.transactionID = c.proto.TransactionID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TransactionGetFastRecordQuery";
    }, o;
  }(), TransactionGetFastRecordResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.transactionRecord = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.transactionRecord != null && Object.hasOwnProperty.call(e, "transactionRecord") && c.proto.TransactionRecord.encode(e.transactionRecord, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TransactionGetFastRecordResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.transactionRecord = c.proto.TransactionRecord.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TransactionGetFastRecordResponse";
    }, o;
  }(), NetworkGetVersionInfoQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.NetworkGetVersionInfoQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.NetworkGetVersionInfoQuery";
    }, o;
  }(), NetworkGetVersionInfoResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.hapiProtoVersion = null, o.prototype.hederaServicesVersion = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.hapiProtoVersion != null && Object.hasOwnProperty.call(e, "hapiProtoVersion") && c.proto.SemanticVersion.encode(e.hapiProtoVersion, n.uint32(18).fork()).ldelim(), e.hederaServicesVersion != null && Object.hasOwnProperty.call(e, "hederaServicesVersion") && c.proto.SemanticVersion.encode(e.hederaServicesVersion, n.uint32(26).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.NetworkGetVersionInfoResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.hapiProtoVersion = c.proto.SemanticVersion.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.hederaServicesVersion = c.proto.SemanticVersion.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.NetworkGetVersionInfoResponse";
    }, o;
  }(), NetworkGetExecutionTimeQuery: function() {
    function o(e) {
      if (this.transactionIds = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.transactionIds = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.transactionIds != null && e.transactionIds.length)
        for (var i = 0; i < e.transactionIds.length; ++i)
          c.proto.TransactionID.encode(e.transactionIds[i], n.uint32(18).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.NetworkGetExecutionTimeQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.transactionIds && y.transactionIds.length || (y.transactionIds = []), y.transactionIds.push(c.proto.TransactionID.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.NetworkGetExecutionTimeQuery";
    }, o;
  }(), NetworkGetExecutionTimeResponse: function() {
    function o(e) {
      if (this.executionTimes = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.executionTimes = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.executionTimes != null && e.executionTimes.length) {
        n.uint32(18).fork();
        for (var i = 0; i < e.executionTimes.length; ++i)
          n.uint64(e.executionTimes[i]);
        n.ldelim();
      }
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.NetworkGetExecutionTimeResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            if (y.executionTimes && y.executionTimes.length || (y.executionTimes = []), (7 & m) == 2)
              for (var U = e.uint32() + e.pos; e.pos < U; )
                y.executionTimes.push(e.uint64());
            else
              y.executionTimes.push(e.uint64());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.NetworkGetExecutionTimeResponse";
    }, o;
  }(), TokenGetInfoQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.token = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.token != null && Object.hasOwnProperty.call(e, "token") && c.proto.TokenID.encode(e.token, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenGetInfoQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.token = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenGetInfoQuery";
    }, o;
  }(), TokenInfo: function() {
    function o(e) {
      if (this.customFees = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.tokenId = null, o.prototype.name = "", o.prototype.symbol = "", o.prototype.decimals = 0, o.prototype.totalSupply = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.treasury = null, o.prototype.adminKey = null, o.prototype.kycKey = null, o.prototype.freezeKey = null, o.prototype.wipeKey = null, o.prototype.supplyKey = null, o.prototype.defaultFreezeStatus = 0, o.prototype.defaultKycStatus = 0, o.prototype.deleted = !1, o.prototype.autoRenewAccount = null, o.prototype.autoRenewPeriod = null, o.prototype.expiry = null, o.prototype.memo = "", o.prototype.tokenType = 0, o.prototype.supplyType = 0, o.prototype.maxSupply = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.feeScheduleKey = null, o.prototype.customFees = g.emptyArray, o.prototype.pauseKey = null, o.prototype.pauseStatus = 0, o.prototype.ledgerId = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.tokenId != null && Object.hasOwnProperty.call(e, "tokenId") && c.proto.TokenID.encode(e.tokenId, n.uint32(10).fork()).ldelim(), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(18).string(e.name), e.symbol != null && Object.hasOwnProperty.call(e, "symbol") && n.uint32(26).string(e.symbol), e.decimals != null && Object.hasOwnProperty.call(e, "decimals") && n.uint32(32).uint32(e.decimals), e.totalSupply != null && Object.hasOwnProperty.call(e, "totalSupply") && n.uint32(40).uint64(e.totalSupply), e.treasury != null && Object.hasOwnProperty.call(e, "treasury") && c.proto.AccountID.encode(e.treasury, n.uint32(50).fork()).ldelim(), e.adminKey != null && Object.hasOwnProperty.call(e, "adminKey") && c.proto.Key.encode(e.adminKey, n.uint32(58).fork()).ldelim(), e.kycKey != null && Object.hasOwnProperty.call(e, "kycKey") && c.proto.Key.encode(e.kycKey, n.uint32(66).fork()).ldelim(), e.freezeKey != null && Object.hasOwnProperty.call(e, "freezeKey") && c.proto.Key.encode(e.freezeKey, n.uint32(74).fork()).ldelim(), e.wipeKey != null && Object.hasOwnProperty.call(e, "wipeKey") && c.proto.Key.encode(e.wipeKey, n.uint32(82).fork()).ldelim(), e.supplyKey != null && Object.hasOwnProperty.call(e, "supplyKey") && c.proto.Key.encode(e.supplyKey, n.uint32(90).fork()).ldelim(), e.defaultFreezeStatus != null && Object.hasOwnProperty.call(e, "defaultFreezeStatus") && n.uint32(96).int32(e.defaultFreezeStatus), e.defaultKycStatus != null && Object.hasOwnProperty.call(e, "defaultKycStatus") && n.uint32(104).int32(e.defaultKycStatus), e.deleted != null && Object.hasOwnProperty.call(e, "deleted") && n.uint32(112).bool(e.deleted), e.autoRenewAccount != null && Object.hasOwnProperty.call(e, "autoRenewAccount") && c.proto.AccountID.encode(e.autoRenewAccount, n.uint32(122).fork()).ldelim(), e.autoRenewPeriod != null && Object.hasOwnProperty.call(e, "autoRenewPeriod") && c.proto.Duration.encode(e.autoRenewPeriod, n.uint32(130).fork()).ldelim(), e.expiry != null && Object.hasOwnProperty.call(e, "expiry") && c.proto.Timestamp.encode(e.expiry, n.uint32(138).fork()).ldelim(), e.memo != null && Object.hasOwnProperty.call(e, "memo") && n.uint32(146).string(e.memo), e.tokenType != null && Object.hasOwnProperty.call(e, "tokenType") && n.uint32(152).int32(e.tokenType), e.supplyType != null && Object.hasOwnProperty.call(e, "supplyType") && n.uint32(160).int32(e.supplyType), e.maxSupply != null && Object.hasOwnProperty.call(e, "maxSupply") && n.uint32(168).int64(e.maxSupply), e.feeScheduleKey != null && Object.hasOwnProperty.call(e, "feeScheduleKey") && c.proto.Key.encode(e.feeScheduleKey, n.uint32(178).fork()).ldelim(), e.customFees != null && e.customFees.length)
        for (var i = 0; i < e.customFees.length; ++i)
          c.proto.CustomFee.encode(e.customFees[i], n.uint32(186).fork()).ldelim();
      return e.pauseKey != null && Object.hasOwnProperty.call(e, "pauseKey") && c.proto.Key.encode(e.pauseKey, n.uint32(194).fork()).ldelim(), e.pauseStatus != null && Object.hasOwnProperty.call(e, "pauseStatus") && n.uint32(200).int32(e.pauseStatus), e.ledgerId != null && Object.hasOwnProperty.call(e, "ledgerId") && n.uint32(210).bytes(e.ledgerId), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenInfo(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.tokenId = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.name = e.string();
            break;
          }
          case 3: {
            y.symbol = e.string();
            break;
          }
          case 4: {
            y.decimals = e.uint32();
            break;
          }
          case 5: {
            y.totalSupply = e.uint64();
            break;
          }
          case 6: {
            y.treasury = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 7: {
            y.adminKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 8: {
            y.kycKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 9: {
            y.freezeKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 10: {
            y.wipeKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 11: {
            y.supplyKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 12: {
            y.defaultFreezeStatus = e.int32();
            break;
          }
          case 13: {
            y.defaultKycStatus = e.int32();
            break;
          }
          case 14: {
            y.deleted = e.bool();
            break;
          }
          case 15: {
            y.autoRenewAccount = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 16: {
            y.autoRenewPeriod = c.proto.Duration.decode(e, e.uint32());
            break;
          }
          case 17: {
            y.expiry = c.proto.Timestamp.decode(e, e.uint32());
            break;
          }
          case 18: {
            y.memo = e.string();
            break;
          }
          case 19: {
            y.tokenType = e.int32();
            break;
          }
          case 20: {
            y.supplyType = e.int32();
            break;
          }
          case 21: {
            y.maxSupply = e.int64();
            break;
          }
          case 22: {
            y.feeScheduleKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 23: {
            y.customFees && y.customFees.length || (y.customFees = []), y.customFees.push(c.proto.CustomFee.decode(e, e.uint32()));
            break;
          }
          case 24: {
            y.pauseKey = c.proto.Key.decode(e, e.uint32());
            break;
          }
          case 25: {
            y.pauseStatus = e.int32();
            break;
          }
          case 26: {
            y.ledgerId = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenInfo";
    }, o;
  }(), TokenGetInfoResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.tokenInfo = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.tokenInfo != null && Object.hasOwnProperty.call(e, "tokenInfo") && c.proto.TokenInfo.encode(e.tokenInfo, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenGetInfoResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.tokenInfo = c.proto.TokenInfo.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenGetInfoResponse";
    }, o;
  }(), ScheduleGetInfoQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.scheduleID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.scheduleID != null && Object.hasOwnProperty.call(e, "scheduleID") && c.proto.ScheduleID.encode(e.scheduleID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ScheduleGetInfoQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.scheduleID = c.proto.ScheduleID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ScheduleGetInfoQuery";
    }, o;
  }(), ScheduleInfo: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.scheduleID = null, o.prototype.deletionTime = null, o.prototype.executionTime = null, o.prototype.expirationTime = null, o.prototype.scheduledTransactionBody = null, o.prototype.memo = "", o.prototype.adminKey = null, o.prototype.signers = null, o.prototype.creatorAccountID = null, o.prototype.payerAccountID = null, o.prototype.scheduledTransactionID = null, o.prototype.ledgerId = g.newBuffer([]), o.prototype.waitForExpiry = !1;
    let e;
    return Object.defineProperty(o.prototype, "data", { get: g.oneOfGetter(e = ["deletionTime", "executionTime"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.scheduleID != null && Object.hasOwnProperty.call(n, "scheduleID") && c.proto.ScheduleID.encode(n.scheduleID, i.uint32(10).fork()).ldelim(), n.deletionTime != null && Object.hasOwnProperty.call(n, "deletionTime") && c.proto.Timestamp.encode(n.deletionTime, i.uint32(18).fork()).ldelim(), n.executionTime != null && Object.hasOwnProperty.call(n, "executionTime") && c.proto.Timestamp.encode(n.executionTime, i.uint32(26).fork()).ldelim(), n.expirationTime != null && Object.hasOwnProperty.call(n, "expirationTime") && c.proto.Timestamp.encode(n.expirationTime, i.uint32(34).fork()).ldelim(), n.scheduledTransactionBody != null && Object.hasOwnProperty.call(n, "scheduledTransactionBody") && c.proto.SchedulableTransactionBody.encode(n.scheduledTransactionBody, i.uint32(42).fork()).ldelim(), n.memo != null && Object.hasOwnProperty.call(n, "memo") && i.uint32(50).string(n.memo), n.adminKey != null && Object.hasOwnProperty.call(n, "adminKey") && c.proto.Key.encode(n.adminKey, i.uint32(58).fork()).ldelim(), n.signers != null && Object.hasOwnProperty.call(n, "signers") && c.proto.KeyList.encode(n.signers, i.uint32(66).fork()).ldelim(), n.creatorAccountID != null && Object.hasOwnProperty.call(n, "creatorAccountID") && c.proto.AccountID.encode(n.creatorAccountID, i.uint32(74).fork()).ldelim(), n.payerAccountID != null && Object.hasOwnProperty.call(n, "payerAccountID") && c.proto.AccountID.encode(n.payerAccountID, i.uint32(82).fork()).ldelim(), n.scheduledTransactionID != null && Object.hasOwnProperty.call(n, "scheduledTransactionID") && c.proto.TransactionID.encode(n.scheduledTransactionID, i.uint32(90).fork()).ldelim(), n.ledgerId != null && Object.hasOwnProperty.call(n, "ledgerId") && i.uint32(98).bytes(n.ledgerId), n.waitForExpiry != null && Object.hasOwnProperty.call(n, "waitForExpiry") && i.uint32(104).bool(n.waitForExpiry), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.ScheduleInfo(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.scheduleID = c.proto.ScheduleID.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.deletionTime = c.proto.Timestamp.decode(n, n.uint32());
            break;
          }
          case 3: {
            m.executionTime = c.proto.Timestamp.decode(n, n.uint32());
            break;
          }
          case 4: {
            m.expirationTime = c.proto.Timestamp.decode(n, n.uint32());
            break;
          }
          case 5: {
            m.scheduledTransactionBody = c.proto.SchedulableTransactionBody.decode(n, n.uint32());
            break;
          }
          case 6: {
            m.memo = n.string();
            break;
          }
          case 7: {
            m.adminKey = c.proto.Key.decode(n, n.uint32());
            break;
          }
          case 8: {
            m.signers = c.proto.KeyList.decode(n, n.uint32());
            break;
          }
          case 9: {
            m.creatorAccountID = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 10: {
            m.payerAccountID = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 11: {
            m.scheduledTransactionID = c.proto.TransactionID.decode(n, n.uint32());
            break;
          }
          case 12: {
            m.ledgerId = n.bytes();
            break;
          }
          case 13: {
            m.waitForExpiry = n.bool();
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.ScheduleInfo";
    }, o;
  }(), ScheduleGetInfoResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.scheduleInfo = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.scheduleInfo != null && Object.hasOwnProperty.call(e, "scheduleInfo") && c.proto.ScheduleInfo.encode(e.scheduleInfo, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ScheduleGetInfoResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.scheduleInfo = c.proto.ScheduleInfo.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ScheduleGetInfoResponse";
    }, o;
  }(), TokenGetAccountNftInfosQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.accountID = null, o.prototype.start = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.end = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(18).fork()).ldelim(), e.start != null && Object.hasOwnProperty.call(e, "start") && n.uint32(24).int64(e.start), e.end != null && Object.hasOwnProperty.call(e, "end") && n.uint32(32).int64(e.end), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenGetAccountNftInfosQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.start = e.int64();
            break;
          }
          case 4: {
            y.end = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenGetAccountNftInfosQuery";
    }, o;
  }(), TokenGetAccountNftInfosResponse: function() {
    function o(e) {
      if (this.nfts = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.nfts = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.nfts != null && e.nfts.length)
        for (var i = 0; i < e.nfts.length; ++i)
          c.proto.TokenNftInfo.encode(e.nfts[i], n.uint32(18).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenGetAccountNftInfosResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.nfts && y.nfts.length || (y.nfts = []), y.nfts.push(c.proto.TokenNftInfo.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenGetAccountNftInfosResponse";
    }, o;
  }(), NftID: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.tokenID = null, o.prototype.serialNumber = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.tokenID != null && Object.hasOwnProperty.call(e, "tokenID") && c.proto.TokenID.encode(e.tokenID, n.uint32(10).fork()).ldelim(), e.serialNumber != null && Object.hasOwnProperty.call(e, "serialNumber") && n.uint32(16).int64(e.serialNumber), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.NftID(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.tokenID = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.serialNumber = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.NftID";
    }, o;
  }(), TokenGetNftInfoQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.nftID = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.nftID != null && Object.hasOwnProperty.call(e, "nftID") && c.proto.NftID.encode(e.nftID, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenGetNftInfoQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.nftID = c.proto.NftID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenGetNftInfoQuery";
    }, o;
  }(), TokenNftInfo: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.nftID = null, o.prototype.accountID = null, o.prototype.creationTime = null, o.prototype.metadata = g.newBuffer([]), o.prototype.ledgerId = g.newBuffer([]), o.prototype.spenderId = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.nftID != null && Object.hasOwnProperty.call(e, "nftID") && c.proto.NftID.encode(e.nftID, n.uint32(10).fork()).ldelim(), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(18).fork()).ldelim(), e.creationTime != null && Object.hasOwnProperty.call(e, "creationTime") && c.proto.Timestamp.encode(e.creationTime, n.uint32(26).fork()).ldelim(), e.metadata != null && Object.hasOwnProperty.call(e, "metadata") && n.uint32(34).bytes(e.metadata), e.ledgerId != null && Object.hasOwnProperty.call(e, "ledgerId") && n.uint32(42).bytes(e.ledgerId), e.spenderId != null && Object.hasOwnProperty.call(e, "spenderId") && c.proto.AccountID.encode(e.spenderId, n.uint32(50).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenNftInfo(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.nftID = c.proto.NftID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.creationTime = c.proto.Timestamp.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.metadata = e.bytes();
            break;
          }
          case 5: {
            y.ledgerId = e.bytes();
            break;
          }
          case 6: {
            y.spenderId = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenNftInfo";
    }, o;
  }(), TokenGetNftInfoResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.nft = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.nft != null && Object.hasOwnProperty.call(e, "nft") && c.proto.TokenNftInfo.encode(e.nft, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenGetNftInfoResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.nft = c.proto.TokenNftInfo.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenGetNftInfoResponse";
    }, o;
  }(), TokenGetNftInfosQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.tokenID = null, o.prototype.start = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.end = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.tokenID != null && Object.hasOwnProperty.call(e, "tokenID") && c.proto.TokenID.encode(e.tokenID, n.uint32(18).fork()).ldelim(), e.start != null && Object.hasOwnProperty.call(e, "start") && n.uint32(24).int64(e.start), e.end != null && Object.hasOwnProperty.call(e, "end") && n.uint32(32).int64(e.end), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenGetNftInfosQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.tokenID = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.start = e.int64();
            break;
          }
          case 4: {
            y.end = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenGetNftInfosQuery";
    }, o;
  }(), TokenGetNftInfosResponse: function() {
    function o(e) {
      if (this.nfts = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.tokenID = null, o.prototype.nfts = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.tokenID != null && Object.hasOwnProperty.call(e, "tokenID") && c.proto.TokenID.encode(e.tokenID, n.uint32(18).fork()).ldelim(), e.nfts != null && e.nfts.length)
        for (var i = 0; i < e.nfts.length; ++i)
          c.proto.TokenNftInfo.encode(e.nfts[i], n.uint32(26).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenGetNftInfosResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.tokenID = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.nfts && y.nfts.length || (y.nfts = []), y.nfts.push(c.proto.TokenNftInfo.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenGetNftInfosResponse";
    }, o;
  }(), GetAccountDetailsQuery: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.accountId = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.QueryHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.accountId != null && Object.hasOwnProperty.call(e, "accountId") && c.proto.AccountID.encode(e.accountId, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.GetAccountDetailsQuery(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.QueryHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountId = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.GetAccountDetailsQuery";
    }, o;
  }(), GetAccountDetailsResponse: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.header = null, o.prototype.accountDetails = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.header != null && Object.hasOwnProperty.call(e, "header") && c.proto.ResponseHeader.encode(e.header, n.uint32(10).fork()).ldelim(), e.accountDetails != null && Object.hasOwnProperty.call(e, "accountDetails") && c.proto.GetAccountDetailsResponse.AccountDetails.encode(e.accountDetails, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.GetAccountDetailsResponse(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.header = c.proto.ResponseHeader.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.accountDetails = c.proto.GetAccountDetailsResponse.AccountDetails.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.GetAccountDetailsResponse";
    }, o.AccountDetails = function() {
      function e(n) {
        if (this.tokenRelationships = [], this.grantedCryptoAllowances = [], this.grantedNftAllowances = [], this.grantedTokenAllowances = [], n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.accountId = null, e.prototype.contractAccountId = "", e.prototype.deleted = !1, e.prototype.proxyAccountId = null, e.prototype.proxyReceived = g.Long ? g.Long.fromBits(0, 0, !1) : 0, e.prototype.key = null, e.prototype.balance = g.Long ? g.Long.fromBits(0, 0, !0) : 0, e.prototype.receiverSigRequired = !1, e.prototype.expirationTime = null, e.prototype.autoRenewPeriod = null, e.prototype.tokenRelationships = g.emptyArray, e.prototype.memo = "", e.prototype.ownedNfts = g.Long ? g.Long.fromBits(0, 0, !1) : 0, e.prototype.maxAutomaticTokenAssociations = 0, e.prototype.alias = g.newBuffer([]), e.prototype.ledgerId = g.newBuffer([]), e.prototype.grantedCryptoAllowances = g.emptyArray, e.prototype.grantedNftAllowances = g.emptyArray, e.prototype.grantedTokenAllowances = g.emptyArray, e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        if (i || (i = h.create()), n.accountId != null && Object.hasOwnProperty.call(n, "accountId") && c.proto.AccountID.encode(n.accountId, i.uint32(10).fork()).ldelim(), n.contractAccountId != null && Object.hasOwnProperty.call(n, "contractAccountId") && i.uint32(18).string(n.contractAccountId), n.deleted != null && Object.hasOwnProperty.call(n, "deleted") && i.uint32(24).bool(n.deleted), n.proxyAccountId != null && Object.hasOwnProperty.call(n, "proxyAccountId") && c.proto.AccountID.encode(n.proxyAccountId, i.uint32(34).fork()).ldelim(), n.proxyReceived != null && Object.hasOwnProperty.call(n, "proxyReceived") && i.uint32(40).int64(n.proxyReceived), n.key != null && Object.hasOwnProperty.call(n, "key") && c.proto.Key.encode(n.key, i.uint32(50).fork()).ldelim(), n.balance != null && Object.hasOwnProperty.call(n, "balance") && i.uint32(56).uint64(n.balance), n.receiverSigRequired != null && Object.hasOwnProperty.call(n, "receiverSigRequired") && i.uint32(64).bool(n.receiverSigRequired), n.expirationTime != null && Object.hasOwnProperty.call(n, "expirationTime") && c.proto.Timestamp.encode(n.expirationTime, i.uint32(74).fork()).ldelim(), n.autoRenewPeriod != null && Object.hasOwnProperty.call(n, "autoRenewPeriod") && c.proto.Duration.encode(n.autoRenewPeriod, i.uint32(82).fork()).ldelim(), n.tokenRelationships != null && n.tokenRelationships.length)
          for (var y = 0; y < n.tokenRelationships.length; ++y)
            c.proto.TokenRelationship.encode(n.tokenRelationships[y], i.uint32(90).fork()).ldelim();
        if (n.memo != null && Object.hasOwnProperty.call(n, "memo") && i.uint32(98).string(n.memo), n.ownedNfts != null && Object.hasOwnProperty.call(n, "ownedNfts") && i.uint32(104).int64(n.ownedNfts), n.maxAutomaticTokenAssociations != null && Object.hasOwnProperty.call(n, "maxAutomaticTokenAssociations") && i.uint32(112).int32(n.maxAutomaticTokenAssociations), n.alias != null && Object.hasOwnProperty.call(n, "alias") && i.uint32(122).bytes(n.alias), n.ledgerId != null && Object.hasOwnProperty.call(n, "ledgerId") && i.uint32(130).bytes(n.ledgerId), n.grantedCryptoAllowances != null && n.grantedCryptoAllowances.length)
          for (var y = 0; y < n.grantedCryptoAllowances.length; ++y)
            c.proto.GrantedCryptoAllowance.encode(n.grantedCryptoAllowances[y], i.uint32(138).fork()).ldelim();
        if (n.grantedNftAllowances != null && n.grantedNftAllowances.length)
          for (var y = 0; y < n.grantedNftAllowances.length; ++y)
            c.proto.GrantedNftAllowance.encode(n.grantedNftAllowances[y], i.uint32(146).fork()).ldelim();
        if (n.grantedTokenAllowances != null && n.grantedTokenAllowances.length)
          for (var y = 0; y < n.grantedTokenAllowances.length; ++y)
            c.proto.GrantedTokenAllowance.encode(n.grantedTokenAllowances[y], i.uint32(154).fork()).ldelim();
        return i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.GetAccountDetailsResponse.AccountDetails(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.accountId = c.proto.AccountID.decode(n, n.uint32());
              break;
            }
            case 2: {
              m.contractAccountId = n.string();
              break;
            }
            case 3: {
              m.deleted = n.bool();
              break;
            }
            case 4: {
              m.proxyAccountId = c.proto.AccountID.decode(n, n.uint32());
              break;
            }
            case 5: {
              m.proxyReceived = n.int64();
              break;
            }
            case 6: {
              m.key = c.proto.Key.decode(n, n.uint32());
              break;
            }
            case 7: {
              m.balance = n.uint64();
              break;
            }
            case 8: {
              m.receiverSigRequired = n.bool();
              break;
            }
            case 9: {
              m.expirationTime = c.proto.Timestamp.decode(n, n.uint32());
              break;
            }
            case 10: {
              m.autoRenewPeriod = c.proto.Duration.decode(n, n.uint32());
              break;
            }
            case 11: {
              m.tokenRelationships && m.tokenRelationships.length || (m.tokenRelationships = []), m.tokenRelationships.push(c.proto.TokenRelationship.decode(n, n.uint32()));
              break;
            }
            case 12: {
              m.memo = n.string();
              break;
            }
            case 13: {
              m.ownedNfts = n.int64();
              break;
            }
            case 14: {
              m.maxAutomaticTokenAssociations = n.int32();
              break;
            }
            case 15: {
              m.alias = n.bytes();
              break;
            }
            case 16: {
              m.ledgerId = n.bytes();
              break;
            }
            case 17: {
              m.grantedCryptoAllowances && m.grantedCryptoAllowances.length || (m.grantedCryptoAllowances = []), m.grantedCryptoAllowances.push(c.proto.GrantedCryptoAllowance.decode(n, n.uint32()));
              break;
            }
            case 18: {
              m.grantedNftAllowances && m.grantedNftAllowances.length || (m.grantedNftAllowances = []), m.grantedNftAllowances.push(c.proto.GrantedNftAllowance.decode(n, n.uint32()));
              break;
            }
            case 19: {
              m.grantedTokenAllowances && m.grantedTokenAllowances.length || (m.grantedTokenAllowances = []), m.grantedTokenAllowances.push(c.proto.GrantedTokenAllowance.decode(n, n.uint32()));
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/proto.GetAccountDetailsResponse.AccountDetails";
      }, e;
    }(), o;
  }(), GrantedCryptoAllowance: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.spender = null, o.prototype.amount = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.spender != null && Object.hasOwnProperty.call(e, "spender") && c.proto.AccountID.encode(e.spender, n.uint32(10).fork()).ldelim(), e.amount != null && Object.hasOwnProperty.call(e, "amount") && n.uint32(16).int64(e.amount), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.GrantedCryptoAllowance(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.spender = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.amount = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.GrantedCryptoAllowance";
    }, o;
  }(), GrantedNftAllowance: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.tokenId = null, o.prototype.spender = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.tokenId != null && Object.hasOwnProperty.call(e, "tokenId") && c.proto.TokenID.encode(e.tokenId, n.uint32(10).fork()).ldelim(), e.spender != null && Object.hasOwnProperty.call(e, "spender") && c.proto.AccountID.encode(e.spender, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.GrantedNftAllowance(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.tokenId = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.spender = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.GrantedNftAllowance";
    }, o;
  }(), GrantedTokenAllowance: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.tokenId = null, o.prototype.spender = null, o.prototype.amount = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.tokenId != null && Object.hasOwnProperty.call(e, "tokenId") && c.proto.TokenID.encode(e.tokenId, n.uint32(10).fork()).ldelim(), e.spender != null && Object.hasOwnProperty.call(e, "spender") && c.proto.AccountID.encode(e.spender, n.uint32(18).fork()).ldelim(), e.amount != null && Object.hasOwnProperty.call(e, "amount") && n.uint32(24).int64(e.amount), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.GrantedTokenAllowance(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.tokenId = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.spender = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.amount = e.int64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.GrantedTokenAllowance";
    }, o;
  }(), Response: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.getByKey = null, o.prototype.getBySolidityID = null, o.prototype.contractCallLocal = null, o.prototype.contractGetBytecodeResponse = null, o.prototype.contractGetInfo = null, o.prototype.contractGetRecordsResponse = null, o.prototype.cryptogetAccountBalance = null, o.prototype.cryptoGetAccountRecords = null, o.prototype.cryptoGetInfo = null, o.prototype.cryptoGetLiveHash = null, o.prototype.cryptoGetProxyStakers = null, o.prototype.fileGetContents = null, o.prototype.fileGetInfo = null, o.prototype.transactionGetReceipt = null, o.prototype.transactionGetRecord = null, o.prototype.transactionGetFastRecord = null, o.prototype.consensusGetTopicInfo = null, o.prototype.networkGetVersionInfo = null, o.prototype.tokenGetInfo = null, o.prototype.scheduleGetInfo = null, o.prototype.tokenGetAccountNftInfos = null, o.prototype.tokenGetNftInfo = null, o.prototype.tokenGetNftInfos = null, o.prototype.networkGetExecutionTime = null, o.prototype.accountDetails = null;
    let e;
    return Object.defineProperty(o.prototype, "response", { get: g.oneOfGetter(e = ["getByKey", "getBySolidityID", "contractCallLocal", "contractGetBytecodeResponse", "contractGetInfo", "contractGetRecordsResponse", "cryptogetAccountBalance", "cryptoGetAccountRecords", "cryptoGetInfo", "cryptoGetLiveHash", "cryptoGetProxyStakers", "fileGetContents", "fileGetInfo", "transactionGetReceipt", "transactionGetRecord", "transactionGetFastRecord", "consensusGetTopicInfo", "networkGetVersionInfo", "tokenGetInfo", "scheduleGetInfo", "tokenGetAccountNftInfos", "tokenGetNftInfo", "tokenGetNftInfos", "networkGetExecutionTime", "accountDetails"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.getByKey != null && Object.hasOwnProperty.call(n, "getByKey") && c.proto.GetByKeyResponse.encode(n.getByKey, i.uint32(10).fork()).ldelim(), n.getBySolidityID != null && Object.hasOwnProperty.call(n, "getBySolidityID") && c.proto.GetBySolidityIDResponse.encode(n.getBySolidityID, i.uint32(18).fork()).ldelim(), n.contractCallLocal != null && Object.hasOwnProperty.call(n, "contractCallLocal") && c.proto.ContractCallLocalResponse.encode(n.contractCallLocal, i.uint32(26).fork()).ldelim(), n.contractGetInfo != null && Object.hasOwnProperty.call(n, "contractGetInfo") && c.proto.ContractGetInfoResponse.encode(n.contractGetInfo, i.uint32(34).fork()).ldelim(), n.contractGetBytecodeResponse != null && Object.hasOwnProperty.call(n, "contractGetBytecodeResponse") && c.proto.ContractGetBytecodeResponse.encode(n.contractGetBytecodeResponse, i.uint32(42).fork()).ldelim(), n.contractGetRecordsResponse != null && Object.hasOwnProperty.call(n, "contractGetRecordsResponse") && c.proto.ContractGetRecordsResponse.encode(n.contractGetRecordsResponse, i.uint32(50).fork()).ldelim(), n.cryptogetAccountBalance != null && Object.hasOwnProperty.call(n, "cryptogetAccountBalance") && c.proto.CryptoGetAccountBalanceResponse.encode(n.cryptogetAccountBalance, i.uint32(58).fork()).ldelim(), n.cryptoGetAccountRecords != null && Object.hasOwnProperty.call(n, "cryptoGetAccountRecords") && c.proto.CryptoGetAccountRecordsResponse.encode(n.cryptoGetAccountRecords, i.uint32(66).fork()).ldelim(), n.cryptoGetInfo != null && Object.hasOwnProperty.call(n, "cryptoGetInfo") && c.proto.CryptoGetInfoResponse.encode(n.cryptoGetInfo, i.uint32(74).fork()).ldelim(), n.cryptoGetLiveHash != null && Object.hasOwnProperty.call(n, "cryptoGetLiveHash") && c.proto.CryptoGetLiveHashResponse.encode(n.cryptoGetLiveHash, i.uint32(82).fork()).ldelim(), n.cryptoGetProxyStakers != null && Object.hasOwnProperty.call(n, "cryptoGetProxyStakers") && c.proto.CryptoGetStakersResponse.encode(n.cryptoGetProxyStakers, i.uint32(90).fork()).ldelim(), n.fileGetContents != null && Object.hasOwnProperty.call(n, "fileGetContents") && c.proto.FileGetContentsResponse.encode(n.fileGetContents, i.uint32(98).fork()).ldelim(), n.fileGetInfo != null && Object.hasOwnProperty.call(n, "fileGetInfo") && c.proto.FileGetInfoResponse.encode(n.fileGetInfo, i.uint32(106).fork()).ldelim(), n.transactionGetReceipt != null && Object.hasOwnProperty.call(n, "transactionGetReceipt") && c.proto.TransactionGetReceiptResponse.encode(n.transactionGetReceipt, i.uint32(114).fork()).ldelim(), n.transactionGetRecord != null && Object.hasOwnProperty.call(n, "transactionGetRecord") && c.proto.TransactionGetRecordResponse.encode(n.transactionGetRecord, i.uint32(122).fork()).ldelim(), n.transactionGetFastRecord != null && Object.hasOwnProperty.call(n, "transactionGetFastRecord") && c.proto.TransactionGetFastRecordResponse.encode(n.transactionGetFastRecord, i.uint32(130).fork()).ldelim(), n.consensusGetTopicInfo != null && Object.hasOwnProperty.call(n, "consensusGetTopicInfo") && c.proto.ConsensusGetTopicInfoResponse.encode(n.consensusGetTopicInfo, i.uint32(1202).fork()).ldelim(), n.networkGetVersionInfo != null && Object.hasOwnProperty.call(n, "networkGetVersionInfo") && c.proto.NetworkGetVersionInfoResponse.encode(n.networkGetVersionInfo, i.uint32(1210).fork()).ldelim(), n.tokenGetInfo != null && Object.hasOwnProperty.call(n, "tokenGetInfo") && c.proto.TokenGetInfoResponse.encode(n.tokenGetInfo, i.uint32(1218).fork()).ldelim(), n.scheduleGetInfo != null && Object.hasOwnProperty.call(n, "scheduleGetInfo") && c.proto.ScheduleGetInfoResponse.encode(n.scheduleGetInfo, i.uint32(1226).fork()).ldelim(), n.tokenGetAccountNftInfos != null && Object.hasOwnProperty.call(n, "tokenGetAccountNftInfos") && c.proto.TokenGetAccountNftInfosResponse.encode(n.tokenGetAccountNftInfos, i.uint32(1234).fork()).ldelim(), n.tokenGetNftInfo != null && Object.hasOwnProperty.call(n, "tokenGetNftInfo") && c.proto.TokenGetNftInfoResponse.encode(n.tokenGetNftInfo, i.uint32(1242).fork()).ldelim(), n.tokenGetNftInfos != null && Object.hasOwnProperty.call(n, "tokenGetNftInfos") && c.proto.TokenGetNftInfosResponse.encode(n.tokenGetNftInfos, i.uint32(1250).fork()).ldelim(), n.networkGetExecutionTime != null && Object.hasOwnProperty.call(n, "networkGetExecutionTime") && c.proto.NetworkGetExecutionTimeResponse.encode(n.networkGetExecutionTime, i.uint32(1258).fork()).ldelim(), n.accountDetails != null && Object.hasOwnProperty.call(n, "accountDetails") && c.proto.GetAccountDetailsResponse.encode(n.accountDetails, i.uint32(1266).fork()).ldelim(), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.Response(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.getByKey = c.proto.GetByKeyResponse.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.getBySolidityID = c.proto.GetBySolidityIDResponse.decode(n, n.uint32());
            break;
          }
          case 3: {
            m.contractCallLocal = c.proto.ContractCallLocalResponse.decode(n, n.uint32());
            break;
          }
          case 5: {
            m.contractGetBytecodeResponse = c.proto.ContractGetBytecodeResponse.decode(n, n.uint32());
            break;
          }
          case 4: {
            m.contractGetInfo = c.proto.ContractGetInfoResponse.decode(n, n.uint32());
            break;
          }
          case 6: {
            m.contractGetRecordsResponse = c.proto.ContractGetRecordsResponse.decode(n, n.uint32());
            break;
          }
          case 7: {
            m.cryptogetAccountBalance = c.proto.CryptoGetAccountBalanceResponse.decode(n, n.uint32());
            break;
          }
          case 8: {
            m.cryptoGetAccountRecords = c.proto.CryptoGetAccountRecordsResponse.decode(n, n.uint32());
            break;
          }
          case 9: {
            m.cryptoGetInfo = c.proto.CryptoGetInfoResponse.decode(n, n.uint32());
            break;
          }
          case 10: {
            m.cryptoGetLiveHash = c.proto.CryptoGetLiveHashResponse.decode(n, n.uint32());
            break;
          }
          case 11: {
            m.cryptoGetProxyStakers = c.proto.CryptoGetStakersResponse.decode(n, n.uint32());
            break;
          }
          case 12: {
            m.fileGetContents = c.proto.FileGetContentsResponse.decode(n, n.uint32());
            break;
          }
          case 13: {
            m.fileGetInfo = c.proto.FileGetInfoResponse.decode(n, n.uint32());
            break;
          }
          case 14: {
            m.transactionGetReceipt = c.proto.TransactionGetReceiptResponse.decode(n, n.uint32());
            break;
          }
          case 15: {
            m.transactionGetRecord = c.proto.TransactionGetRecordResponse.decode(n, n.uint32());
            break;
          }
          case 16: {
            m.transactionGetFastRecord = c.proto.TransactionGetFastRecordResponse.decode(n, n.uint32());
            break;
          }
          case 150: {
            m.consensusGetTopicInfo = c.proto.ConsensusGetTopicInfoResponse.decode(n, n.uint32());
            break;
          }
          case 151: {
            m.networkGetVersionInfo = c.proto.NetworkGetVersionInfoResponse.decode(n, n.uint32());
            break;
          }
          case 152: {
            m.tokenGetInfo = c.proto.TokenGetInfoResponse.decode(n, n.uint32());
            break;
          }
          case 153: {
            m.scheduleGetInfo = c.proto.ScheduleGetInfoResponse.decode(n, n.uint32());
            break;
          }
          case 154: {
            m.tokenGetAccountNftInfos = c.proto.TokenGetAccountNftInfosResponse.decode(n, n.uint32());
            break;
          }
          case 155: {
            m.tokenGetNftInfo = c.proto.TokenGetNftInfoResponse.decode(n, n.uint32());
            break;
          }
          case 156: {
            m.tokenGetNftInfos = c.proto.TokenGetNftInfosResponse.decode(n, n.uint32());
            break;
          }
          case 157: {
            m.networkGetExecutionTime = c.proto.NetworkGetExecutionTimeResponse.decode(n, n.uint32());
            break;
          }
          case 158: {
            m.accountDetails = c.proto.GetAccountDetailsResponse.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.Response";
    }, o;
  }(), CryptoService: function() {
    function o(e, n, i) {
      t.rpc.Service.call(this, e, n, i);
    }
    return (o.prototype = Object.create(t.rpc.Service.prototype)).constructor = o, o.create = function(e, n, i) {
      return new this(e, n, i);
    }, Object.defineProperty(o.prototype.createAccount = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "createAccount" }), Object.defineProperty(o.prototype.updateAccount = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "updateAccount" }), Object.defineProperty(o.prototype.cryptoTransfer = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "cryptoTransfer" }), Object.defineProperty(o.prototype.cryptoDelete = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "cryptoDelete" }), Object.defineProperty(o.prototype.approveAllowances = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "approveAllowances" }), Object.defineProperty(o.prototype.deleteAllowances = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "deleteAllowances" }), Object.defineProperty(o.prototype.addLiveHash = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "addLiveHash" }), Object.defineProperty(o.prototype.deleteLiveHash = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "deleteLiveHash" }), Object.defineProperty(o.prototype.getLiveHash = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getLiveHash" }), Object.defineProperty(o.prototype.getAccountRecords = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getAccountRecords" }), Object.defineProperty(o.prototype.cryptoGetBalance = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "cryptoGetBalance" }), Object.defineProperty(o.prototype.getAccountInfo = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getAccountInfo" }), Object.defineProperty(o.prototype.getTransactionReceipts = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getTransactionReceipts" }), Object.defineProperty(o.prototype.getFastTransactionRecord = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getFastTransactionRecord" }), Object.defineProperty(o.prototype.getTxRecordByTxID = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getTxRecordByTxID" }), Object.defineProperty(o.prototype.getStakersByAccountID = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getStakersByAccountID" }), o;
  }(), FileService: function() {
    function o(e, n, i) {
      t.rpc.Service.call(this, e, n, i);
    }
    return (o.prototype = Object.create(t.rpc.Service.prototype)).constructor = o, o.create = function(e, n, i) {
      return new this(e, n, i);
    }, Object.defineProperty(o.prototype.createFile = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "createFile" }), Object.defineProperty(o.prototype.updateFile = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "updateFile" }), Object.defineProperty(o.prototype.deleteFile = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "deleteFile" }), Object.defineProperty(o.prototype.appendContent = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "appendContent" }), Object.defineProperty(o.prototype.getFileContent = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getFileContent" }), Object.defineProperty(o.prototype.getFileInfo = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getFileInfo" }), Object.defineProperty(o.prototype.systemDelete = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "systemDelete" }), Object.defineProperty(o.prototype.systemUndelete = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "systemUndelete" }), o;
  }(), FreezeService: function() {
    function o(e, n, i) {
      t.rpc.Service.call(this, e, n, i);
    }
    return (o.prototype = Object.create(t.rpc.Service.prototype)).constructor = o, o.create = function(e, n, i) {
      return new this(e, n, i);
    }, Object.defineProperty(o.prototype.freeze = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "freeze" }), o;
  }(), NetworkService: function() {
    function o(e, n, i) {
      t.rpc.Service.call(this, e, n, i);
    }
    return (o.prototype = Object.create(t.rpc.Service.prototype)).constructor = o, o.create = function(e, n, i) {
      return new this(e, n, i);
    }, Object.defineProperty(o.prototype.getVersionInfo = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getVersionInfo" }), Object.defineProperty(o.prototype.getExecutionTime = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getExecutionTime" }), Object.defineProperty(o.prototype.uncheckedSubmit = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "uncheckedSubmit" }), Object.defineProperty(o.prototype.getAccountDetails = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getAccountDetails" }), o;
  }(), ScheduleService: function() {
    function o(e, n, i) {
      t.rpc.Service.call(this, e, n, i);
    }
    return (o.prototype = Object.create(t.rpc.Service.prototype)).constructor = o, o.create = function(e, n, i) {
      return new this(e, n, i);
    }, Object.defineProperty(o.prototype.createSchedule = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "createSchedule" }), Object.defineProperty(o.prototype.signSchedule = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "signSchedule" }), Object.defineProperty(o.prototype.deleteSchedule = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "deleteSchedule" }), Object.defineProperty(o.prototype.getScheduleInfo = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getScheduleInfo" }), o;
  }(), SmartContractService: function() {
    function o(e, n, i) {
      t.rpc.Service.call(this, e, n, i);
    }
    return (o.prototype = Object.create(t.rpc.Service.prototype)).constructor = o, o.create = function(e, n, i) {
      return new this(e, n, i);
    }, Object.defineProperty(o.prototype.createContract = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "createContract" }), Object.defineProperty(o.prototype.updateContract = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "updateContract" }), Object.defineProperty(o.prototype.contractCallMethod = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "contractCallMethod" }), Object.defineProperty(o.prototype.getContractInfo = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getContractInfo" }), Object.defineProperty(o.prototype.contractCallLocalMethod = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "contractCallLocalMethod" }), Object.defineProperty(o.prototype.contractGetBytecode = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "ContractGetBytecode" }), Object.defineProperty(o.prototype.getBySolidityID = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getBySolidityID" }), Object.defineProperty(o.prototype.getTxRecordByContractID = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getTxRecordByContractID" }), Object.defineProperty(o.prototype.deleteContract = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "deleteContract" }), Object.defineProperty(o.prototype.systemDelete = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "systemDelete" }), Object.defineProperty(o.prototype.systemUndelete = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "systemUndelete" }), Object.defineProperty(o.prototype.callEthereum = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "callEthereum" }), o;
  }(), ThrottleGroup: function() {
    function o(e) {
      if (this.operations = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.operations = g.emptyArray, o.prototype.milliOpsPerSec = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.operations != null && e.operations.length) {
        n.uint32(10).fork();
        for (var i = 0; i < e.operations.length; ++i)
          n.int32(e.operations[i]);
        n.ldelim();
      }
      return e.milliOpsPerSec != null && Object.hasOwnProperty.call(e, "milliOpsPerSec") && n.uint32(16).uint64(e.milliOpsPerSec), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ThrottleGroup(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            if (y.operations && y.operations.length || (y.operations = []), (7 & m) == 2)
              for (var U = e.uint32() + e.pos; e.pos < U; )
                y.operations.push(e.int32());
            else
              y.operations.push(e.int32());
            break;
          }
          case 2: {
            y.milliOpsPerSec = e.uint64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ThrottleGroup";
    }, o;
  }(), ThrottleBucket: function() {
    function o(e) {
      if (this.throttleGroups = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.name = "", o.prototype.burstPeriodMs = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.throttleGroups = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(10).string(e.name), e.burstPeriodMs != null && Object.hasOwnProperty.call(e, "burstPeriodMs") && n.uint32(16).uint64(e.burstPeriodMs), e.throttleGroups != null && e.throttleGroups.length)
        for (var i = 0; i < e.throttleGroups.length; ++i)
          c.proto.ThrottleGroup.encode(e.throttleGroups[i], n.uint32(26).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ThrottleBucket(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.name = e.string();
            break;
          }
          case 2: {
            y.burstPeriodMs = e.uint64();
            break;
          }
          case 3: {
            y.throttleGroups && y.throttleGroups.length || (y.throttleGroups = []), y.throttleGroups.push(c.proto.ThrottleGroup.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ThrottleBucket";
    }, o;
  }(), ThrottleDefinitions: function() {
    function o(e) {
      if (this.throttleBuckets = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.throttleBuckets = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.throttleBuckets != null && e.throttleBuckets.length)
        for (var i = 0; i < e.throttleBuckets.length; ++i)
          c.proto.ThrottleBucket.encode(e.throttleBuckets[i], n.uint32(10).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ThrottleDefinitions(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.throttleBuckets && y.throttleBuckets.length || (y.throttleBuckets = []), y.throttleBuckets.push(c.proto.ThrottleBucket.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ThrottleDefinitions";
    }, o;
  }(), TokenService: function() {
    function o(e, n, i) {
      t.rpc.Service.call(this, e, n, i);
    }
    return (o.prototype = Object.create(t.rpc.Service.prototype)).constructor = o, o.create = function(e, n, i) {
      return new this(e, n, i);
    }, Object.defineProperty(o.prototype.createToken = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "createToken" }), Object.defineProperty(o.prototype.updateToken = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "updateToken" }), Object.defineProperty(o.prototype.mintToken = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "mintToken" }), Object.defineProperty(o.prototype.burnToken = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "burnToken" }), Object.defineProperty(o.prototype.deleteToken = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "deleteToken" }), Object.defineProperty(o.prototype.wipeTokenAccount = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "wipeTokenAccount" }), Object.defineProperty(o.prototype.freezeTokenAccount = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "freezeTokenAccount" }), Object.defineProperty(o.prototype.unfreezeTokenAccount = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "unfreezeTokenAccount" }), Object.defineProperty(o.prototype.grantKycToTokenAccount = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "grantKycToTokenAccount" }), Object.defineProperty(o.prototype.revokeKycFromTokenAccount = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "revokeKycFromTokenAccount" }), Object.defineProperty(o.prototype.associateTokens = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "associateTokens" }), Object.defineProperty(o.prototype.dissociateTokens = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "dissociateTokens" }), Object.defineProperty(o.prototype.updateTokenFeeSchedule = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "updateTokenFeeSchedule" }), Object.defineProperty(o.prototype.getTokenInfo = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getTokenInfo" }), Object.defineProperty(o.prototype.getAccountNftInfos = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getAccountNftInfos" }), Object.defineProperty(o.prototype.getTokenNftInfo = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getTokenNftInfo" }), Object.defineProperty(o.prototype.getTokenNftInfos = function e(n, i) {
      return this.rpcCall(e, c.proto.Query, c.proto.Response, n, i);
    }, "name", { value: "getTokenNftInfos" }), Object.defineProperty(o.prototype.pauseToken = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "pauseToken" }), Object.defineProperty(o.prototype.unpauseToken = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "unpauseToken" }), o;
  }(), SignedTransaction: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.bodyBytes = g.newBuffer([]), o.prototype.sigMap = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.bodyBytes != null && Object.hasOwnProperty.call(e, "bodyBytes") && n.uint32(10).bytes(e.bodyBytes), e.sigMap != null && Object.hasOwnProperty.call(e, "sigMap") && c.proto.SignatureMap.encode(e.sigMap, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.SignedTransaction(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.bodyBytes = e.bytes();
            break;
          }
          case 2: {
            y.sigMap = c.proto.SignatureMap.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.SignedTransaction";
    }, o;
  }(), UtilService: function() {
    function o(e, n, i) {
      t.rpc.Service.call(this, e, n, i);
    }
    return (o.prototype = Object.create(t.rpc.Service.prototype)).constructor = o, o.create = function(e, n, i) {
      return new this(e, n, i);
    }, Object.defineProperty(o.prototype.prng = function e(n, i) {
      return this.rpcCall(e, c.proto.Transaction, c.proto.TransactionResponse, n, i);
    }, "name", { value: "prng" }), o;
  }(), TokenUnitBalance: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.tokenId = null, o.prototype.balance = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.tokenId != null && Object.hasOwnProperty.call(e, "tokenId") && c.proto.TokenID.encode(e.tokenId, n.uint32(10).fork()).ldelim(), e.balance != null && Object.hasOwnProperty.call(e, "balance") && n.uint32(16).uint64(e.balance), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.TokenUnitBalance(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.tokenId = c.proto.TokenID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.balance = e.uint64();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.TokenUnitBalance";
    }, o;
  }(), SingleAccountBalances: function() {
    function o(e) {
      if (this.tokenUnitBalances = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.accountID = null, o.prototype.hbarBalance = g.Long ? g.Long.fromBits(0, 0, !0) : 0, o.prototype.tokenUnitBalances = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.accountID != null && Object.hasOwnProperty.call(e, "accountID") && c.proto.AccountID.encode(e.accountID, n.uint32(10).fork()).ldelim(), e.hbarBalance != null && Object.hasOwnProperty.call(e, "hbarBalance") && n.uint32(16).uint64(e.hbarBalance), e.tokenUnitBalances != null && e.tokenUnitBalances.length)
        for (var i = 0; i < e.tokenUnitBalances.length; ++i)
          c.proto.TokenUnitBalance.encode(e.tokenUnitBalances[i], n.uint32(26).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.SingleAccountBalances(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.accountID = c.proto.AccountID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.hbarBalance = e.uint64();
            break;
          }
          case 3: {
            y.tokenUnitBalances && y.tokenUnitBalances.length || (y.tokenUnitBalances = []), y.tokenUnitBalances.push(c.proto.TokenUnitBalance.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.SingleAccountBalances";
    }, o;
  }(), AllAccountBalances: function() {
    function o(e) {
      if (this.allAccounts = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.consensusTimestamp = null, o.prototype.allAccounts = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.consensusTimestamp != null && Object.hasOwnProperty.call(e, "consensusTimestamp") && c.proto.Timestamp.encode(e.consensusTimestamp, n.uint32(10).fork()).ldelim(), e.allAccounts != null && e.allAccounts.length)
        for (var i = 0; i < e.allAccounts.length; ++i)
          c.proto.SingleAccountBalances.encode(e.allAccounts[i], n.uint32(18).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.AllAccountBalances(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.consensusTimestamp = c.proto.Timestamp.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.allAccounts && y.allAccounts.length || (y.allAccounts = []), y.allAccounts.push(c.proto.SingleAccountBalances.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.AllAccountBalances";
    }, o;
  }(), ContractActions: function() {
    function o(e) {
      if (this.contractActions = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.contractActions = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.contractActions != null && e.contractActions.length)
        for (var i = 0; i < e.contractActions.length; ++i)
          c.proto.ContractAction.encode(e.contractActions[i], n.uint32(10).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractActions(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.contractActions && y.contractActions.length || (y.contractActions = []), y.contractActions.push(c.proto.ContractAction.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractActions";
    }, o;
  }(), ContractActionType: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "NO_ACTION"] = 0, e[o[1] = "CALL"] = 1, e[o[2] = "CREATE"] = 2, e[o[3] = "PRECOMPILE"] = 3, e[o[4] = "SYSTEM"] = 4, e;
  }(), CallOperationType: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "OP_UNKNOWN"] = 0, e[o[1] = "OP_CALL"] = 1, e[o[2] = "OP_CALLCODE"] = 2, e[o[3] = "OP_DELEGATECALL"] = 3, e[o[4] = "OP_STATICCALL"] = 4, e[o[5] = "OP_CREATE"] = 5, e[o[6] = "OP_CREATE2"] = 6, e;
  }(), ContractAction: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.callType = 0, o.prototype.callingAccount = null, o.prototype.callingContract = null, o.prototype.gas = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.input = g.newBuffer([]), o.prototype.recipientAccount = null, o.prototype.recipientContract = null, o.prototype.targetedAddress = null, o.prototype.value = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.gasUsed = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.output = null, o.prototype.revertReason = null, o.prototype.error = null, o.prototype.callDepth = 0, o.prototype.callOperationType = 0;
    let e;
    return Object.defineProperty(o.prototype, "caller", { get: g.oneOfGetter(e = ["callingAccount", "callingContract"]), set: g.oneOfSetter(e) }), Object.defineProperty(o.prototype, "recipient", { get: g.oneOfGetter(e = ["recipientAccount", "recipientContract", "targetedAddress"]), set: g.oneOfSetter(e) }), Object.defineProperty(o.prototype, "resultData", { get: g.oneOfGetter(e = ["output", "revertReason", "error"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.callType != null && Object.hasOwnProperty.call(n, "callType") && i.uint32(8).int32(n.callType), n.callingAccount != null && Object.hasOwnProperty.call(n, "callingAccount") && c.proto.AccountID.encode(n.callingAccount, i.uint32(18).fork()).ldelim(), n.callingContract != null && Object.hasOwnProperty.call(n, "callingContract") && c.proto.ContractID.encode(n.callingContract, i.uint32(26).fork()).ldelim(), n.gas != null && Object.hasOwnProperty.call(n, "gas") && i.uint32(32).int64(n.gas), n.input != null && Object.hasOwnProperty.call(n, "input") && i.uint32(42).bytes(n.input), n.recipientAccount != null && Object.hasOwnProperty.call(n, "recipientAccount") && c.proto.AccountID.encode(n.recipientAccount, i.uint32(50).fork()).ldelim(), n.recipientContract != null && Object.hasOwnProperty.call(n, "recipientContract") && c.proto.ContractID.encode(n.recipientContract, i.uint32(58).fork()).ldelim(), n.targetedAddress != null && Object.hasOwnProperty.call(n, "targetedAddress") && i.uint32(66).bytes(n.targetedAddress), n.value != null && Object.hasOwnProperty.call(n, "value") && i.uint32(72).int64(n.value), n.gasUsed != null && Object.hasOwnProperty.call(n, "gasUsed") && i.uint32(80).int64(n.gasUsed), n.output != null && Object.hasOwnProperty.call(n, "output") && i.uint32(90).bytes(n.output), n.revertReason != null && Object.hasOwnProperty.call(n, "revertReason") && i.uint32(98).bytes(n.revertReason), n.error != null && Object.hasOwnProperty.call(n, "error") && i.uint32(106).bytes(n.error), n.callDepth != null && Object.hasOwnProperty.call(n, "callDepth") && i.uint32(112).int32(n.callDepth), n.callOperationType != null && Object.hasOwnProperty.call(n, "callOperationType") && i.uint32(120).int32(n.callOperationType), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.ContractAction(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.callType = n.int32();
            break;
          }
          case 2: {
            m.callingAccount = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 3: {
            m.callingContract = c.proto.ContractID.decode(n, n.uint32());
            break;
          }
          case 4: {
            m.gas = n.int64();
            break;
          }
          case 5: {
            m.input = n.bytes();
            break;
          }
          case 6: {
            m.recipientAccount = c.proto.AccountID.decode(n, n.uint32());
            break;
          }
          case 7: {
            m.recipientContract = c.proto.ContractID.decode(n, n.uint32());
            break;
          }
          case 8: {
            m.targetedAddress = n.bytes();
            break;
          }
          case 9: {
            m.value = n.int64();
            break;
          }
          case 10: {
            m.gasUsed = n.int64();
            break;
          }
          case 11: {
            m.output = n.bytes();
            break;
          }
          case 12: {
            m.revertReason = n.bytes();
            break;
          }
          case 13: {
            m.error = n.bytes();
            break;
          }
          case 14: {
            m.callDepth = n.int32();
            break;
          }
          case 15: {
            m.callOperationType = n.int32();
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.ContractAction";
    }, o;
  }(), ContractBytecode: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.contractId = null, o.prototype.initcode = g.newBuffer([]), o.prototype.runtimeBytecode = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.contractId != null && Object.hasOwnProperty.call(e, "contractId") && c.proto.ContractID.encode(e.contractId, n.uint32(10).fork()).ldelim(), e.initcode != null && Object.hasOwnProperty.call(e, "initcode") && n.uint32(18).bytes(e.initcode), e.runtimeBytecode != null && Object.hasOwnProperty.call(e, "runtimeBytecode") && n.uint32(26).bytes(e.runtimeBytecode), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractBytecode(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.contractId = c.proto.ContractID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.initcode = e.bytes();
            break;
          }
          case 3: {
            y.runtimeBytecode = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractBytecode";
    }, o;
  }(), ContractStateChanges: function() {
    function o(e) {
      if (this.contractStateChanges = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.contractStateChanges = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.contractStateChanges != null && e.contractStateChanges.length)
        for (var i = 0; i < e.contractStateChanges.length; ++i)
          c.proto.ContractStateChange.encode(e.contractStateChanges[i], n.uint32(10).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractStateChanges(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.contractStateChanges && y.contractStateChanges.length || (y.contractStateChanges = []), y.contractStateChanges.push(c.proto.ContractStateChange.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractStateChanges";
    }, o;
  }(), ContractStateChange: function() {
    function o(e) {
      if (this.storageChanges = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.contractId = null, o.prototype.storageChanges = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.contractId != null && Object.hasOwnProperty.call(e, "contractId") && c.proto.ContractID.encode(e.contractId, n.uint32(10).fork()).ldelim(), e.storageChanges != null && e.storageChanges.length)
        for (var i = 0; i < e.storageChanges.length; ++i)
          c.proto.StorageChange.encode(e.storageChanges[i], n.uint32(18).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.ContractStateChange(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.contractId = c.proto.ContractID.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.storageChanges && y.storageChanges.length || (y.storageChanges = []), y.storageChanges.push(c.proto.StorageChange.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.ContractStateChange";
    }, o;
  }(), StorageChange: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.slot = g.newBuffer([]), o.prototype.valueRead = g.newBuffer([]), o.prototype.valueWritten = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.slot != null && Object.hasOwnProperty.call(e, "slot") && n.uint32(10).bytes(e.slot), e.valueRead != null && Object.hasOwnProperty.call(e, "valueRead") && n.uint32(18).bytes(e.valueRead), e.valueWritten != null && Object.hasOwnProperty.call(e, "valueWritten") && c.google.protobuf.BytesValue.encode(e.valueWritten, n.uint32(26).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.StorageChange(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.slot = e.bytes();
            break;
          }
          case 2: {
            y.valueRead = e.bytes();
            break;
          }
          case 3: {
            y.valueWritten = c.google.protobuf.BytesValue.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.StorageChange";
    }, o;
  }(), HashAlgorithm: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "HASH_ALGORITHM_UNKNOWN"] = 0, e[o[1] = "SHA_384"] = 1, e;
  }(), HashObject: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.algorithm = 0, o.prototype.length = 0, o.prototype.hash = g.newBuffer([]), o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.algorithm != null && Object.hasOwnProperty.call(e, "algorithm") && n.uint32(8).int32(e.algorithm), e.length != null && Object.hasOwnProperty.call(e, "length") && n.uint32(16).int32(e.length), e.hash != null && Object.hasOwnProperty.call(e, "hash") && n.uint32(26).bytes(e.hash), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.HashObject(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.algorithm = e.int32();
            break;
          }
          case 2: {
            y.length = e.int32();
            break;
          }
          case 3: {
            y.hash = e.bytes();
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.HashObject";
    }, o;
  }(), RecordStreamFile: function() {
    function o(e) {
      if (this.recordStreamItems = [], this.sidecars = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.hapiProtoVersion = null, o.prototype.startObjectRunningHash = null, o.prototype.recordStreamItems = g.emptyArray, o.prototype.endObjectRunningHash = null, o.prototype.blockNumber = g.Long ? g.Long.fromBits(0, 0, !1) : 0, o.prototype.sidecars = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.hapiProtoVersion != null && Object.hasOwnProperty.call(e, "hapiProtoVersion") && c.proto.SemanticVersion.encode(e.hapiProtoVersion, n.uint32(10).fork()).ldelim(), e.startObjectRunningHash != null && Object.hasOwnProperty.call(e, "startObjectRunningHash") && c.proto.HashObject.encode(e.startObjectRunningHash, n.uint32(18).fork()).ldelim(), e.recordStreamItems != null && e.recordStreamItems.length)
        for (var i = 0; i < e.recordStreamItems.length; ++i)
          c.proto.RecordStreamItem.encode(e.recordStreamItems[i], n.uint32(26).fork()).ldelim();
      if (e.endObjectRunningHash != null && Object.hasOwnProperty.call(e, "endObjectRunningHash") && c.proto.HashObject.encode(e.endObjectRunningHash, n.uint32(34).fork()).ldelim(), e.blockNumber != null && Object.hasOwnProperty.call(e, "blockNumber") && n.uint32(40).int64(e.blockNumber), e.sidecars != null && e.sidecars.length)
        for (var i = 0; i < e.sidecars.length; ++i)
          c.proto.SidecarMetadata.encode(e.sidecars[i], n.uint32(50).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.RecordStreamFile(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.hapiProtoVersion = c.proto.SemanticVersion.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.startObjectRunningHash = c.proto.HashObject.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.recordStreamItems && y.recordStreamItems.length || (y.recordStreamItems = []), y.recordStreamItems.push(c.proto.RecordStreamItem.decode(e, e.uint32()));
            break;
          }
          case 4: {
            y.endObjectRunningHash = c.proto.HashObject.decode(e, e.uint32());
            break;
          }
          case 5: {
            y.blockNumber = e.int64();
            break;
          }
          case 6: {
            y.sidecars && y.sidecars.length || (y.sidecars = []), y.sidecars.push(c.proto.SidecarMetadata.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.RecordStreamFile";
    }, o;
  }(), RecordStreamItem: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.transaction = null, o.prototype.record = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.transaction != null && Object.hasOwnProperty.call(e, "transaction") && c.proto.Transaction.encode(e.transaction, n.uint32(10).fork()).ldelim(), e.record != null && Object.hasOwnProperty.call(e, "record") && c.proto.TransactionRecord.encode(e.record, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.RecordStreamItem(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.transaction = c.proto.Transaction.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.record = c.proto.TransactionRecord.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.RecordStreamItem";
    }, o;
  }(), SidecarMetadata: function() {
    function o(e) {
      if (this.types = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.hash = null, o.prototype.id = 0, o.prototype.types = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.hash != null && Object.hasOwnProperty.call(e, "hash") && c.proto.HashObject.encode(e.hash, n.uint32(10).fork()).ldelim(), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(16).int32(e.id), e.types != null && e.types.length) {
        n.uint32(26).fork();
        for (var i = 0; i < e.types.length; ++i)
          n.int32(e.types[i]);
        n.ldelim();
      }
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.SidecarMetadata(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.hash = c.proto.HashObject.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.id = e.int32();
            break;
          }
          case 3: {
            if (y.types && y.types.length || (y.types = []), (7 & m) == 2)
              for (var U = e.uint32() + e.pos; e.pos < U; )
                y.types.push(e.int32());
            else
              y.types.push(e.int32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.SidecarMetadata";
    }, o;
  }(), SidecarType: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "SIDECAR_TYPE_UNKNOWN"] = 0, e[o[1] = "CONTRACT_STATE_CHANGE"] = 1, e[o[2] = "CONTRACT_ACTION"] = 2, e[o[3] = "CONTRACT_BYTECODE"] = 3, e;
  }(), SidecarFile: function() {
    function o(e) {
      if (this.sidecarRecords = [], e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.sidecarRecords = g.emptyArray, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      if (n || (n = h.create()), e.sidecarRecords != null && e.sidecarRecords.length)
        for (var i = 0; i < e.sidecarRecords.length; ++i)
          c.proto.TransactionSidecarRecord.encode(e.sidecarRecords[i], n.uint32(10).fork()).ldelim();
      return n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.SidecarFile(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.sidecarRecords && y.sidecarRecords.length || (y.sidecarRecords = []), y.sidecarRecords.push(c.proto.TransactionSidecarRecord.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.SidecarFile";
    }, o;
  }(), TransactionSidecarRecord: function() {
    function o(n) {
      if (n)
        for (var i = Object.keys(n), y = 0; y < i.length; ++y)
          n[i[y]] != null && (this[i[y]] = n[i[y]]);
    }
    o.prototype.consensusTimestamp = null, o.prototype.migration = !1, o.prototype.stateChanges = null, o.prototype.actions = null, o.prototype.bytecode = null;
    let e;
    return Object.defineProperty(o.prototype, "sidecarRecords", { get: g.oneOfGetter(e = ["stateChanges", "actions", "bytecode"]), set: g.oneOfSetter(e) }), o.create = function(n) {
      return new o(n);
    }, o.encode = function(n, i) {
      return i || (i = h.create()), n.consensusTimestamp != null && Object.hasOwnProperty.call(n, "consensusTimestamp") && c.proto.Timestamp.encode(n.consensusTimestamp, i.uint32(10).fork()).ldelim(), n.migration != null && Object.hasOwnProperty.call(n, "migration") && i.uint32(16).bool(n.migration), n.stateChanges != null && Object.hasOwnProperty.call(n, "stateChanges") && c.proto.ContractStateChanges.encode(n.stateChanges, i.uint32(26).fork()).ldelim(), n.actions != null && Object.hasOwnProperty.call(n, "actions") && c.proto.ContractActions.encode(n.actions, i.uint32(34).fork()).ldelim(), n.bytecode != null && Object.hasOwnProperty.call(n, "bytecode") && c.proto.ContractBytecode.encode(n.bytecode, i.uint32(42).fork()).ldelim(), i;
    }, o.decode = function(n, i) {
      n instanceof l || (n = l.create(n));
      for (var y = i === void 0 ? n.len : n.pos + i, m = new c.proto.TransactionSidecarRecord(), U; n.pos < y; )
        switch (U = n.uint32(), U >>> 3) {
          case 1: {
            m.consensusTimestamp = c.proto.Timestamp.decode(n, n.uint32());
            break;
          }
          case 2: {
            m.migration = n.bool();
            break;
          }
          case 3: {
            m.stateChanges = c.proto.ContractStateChanges.decode(n, n.uint32());
            break;
          }
          case 4: {
            m.actions = c.proto.ContractActions.decode(n, n.uint32());
            break;
          }
          case 5: {
            m.bytecode = c.proto.ContractBytecode.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(7 & U);
        }
      return m;
    }, o.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/proto.TransactionSidecarRecord";
    }, o;
  }(), SignatureFile: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.fileSignature = null, o.prototype.metadataSignature = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.fileSignature != null && Object.hasOwnProperty.call(e, "fileSignature") && c.proto.SignatureObject.encode(e.fileSignature, n.uint32(10).fork()).ldelim(), e.metadataSignature != null && Object.hasOwnProperty.call(e, "metadataSignature") && c.proto.SignatureObject.encode(e.metadataSignature, n.uint32(18).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.SignatureFile(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.fileSignature = c.proto.SignatureObject.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.metadataSignature = c.proto.SignatureObject.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.SignatureFile";
    }, o;
  }(), SignatureObject: function() {
    function o(e) {
      if (e)
        for (var n = Object.keys(e), i = 0; i < n.length; ++i)
          e[n[i]] != null && (this[n[i]] = e[n[i]]);
    }
    return o.prototype.type = 0, o.prototype.length = 0, o.prototype.checksum = 0, o.prototype.signature = g.newBuffer([]), o.prototype.hashObject = null, o.create = function(e) {
      return new o(e);
    }, o.encode = function(e, n) {
      return n || (n = h.create()), e.type != null && Object.hasOwnProperty.call(e, "type") && n.uint32(8).int32(e.type), e.length != null && Object.hasOwnProperty.call(e, "length") && n.uint32(16).int32(e.length), e.checksum != null && Object.hasOwnProperty.call(e, "checksum") && n.uint32(24).int32(e.checksum), e.signature != null && Object.hasOwnProperty.call(e, "signature") && n.uint32(34).bytes(e.signature), e.hashObject != null && Object.hasOwnProperty.call(e, "hashObject") && c.proto.HashObject.encode(e.hashObject, n.uint32(42).fork()).ldelim(), n;
    }, o.decode = function(e, n) {
      e instanceof l || (e = l.create(e));
      for (var i = n === void 0 ? e.len : e.pos + n, y = new c.proto.SignatureObject(), m; e.pos < i; )
        switch (m = e.uint32(), m >>> 3) {
          case 1: {
            y.type = e.int32();
            break;
          }
          case 2: {
            y.length = e.int32();
            break;
          }
          case 3: {
            y.checksum = e.int32();
            break;
          }
          case 4: {
            y.signature = e.bytes();
            break;
          }
          case 5: {
            y.hashObject = c.proto.HashObject.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(7 & m);
        }
      return y;
    }, o.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/proto.SignatureObject";
    }, o;
  }(), SignatureType: function() {
    const o = {}, e = Object.create(o);
    return e[o[0] = "SIGNATURE_TYPE_UNKNOWN"] = 0, e[o[1] = "SHA_384_WITH_RSA"] = 1, e;
  }() }))();
  u.proto = R;
  const B = c.google = (() => ({ protobuf: function() {
    return { DoubleValue: function() {
      function e(n) {
        if (n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.value = 0, e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        return i || (i = h.create()), n.value != null && Object.hasOwnProperty.call(n, "value") && i.uint32(9).double(n.value), i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.google.protobuf.DoubleValue(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.value = n.double();
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/google.protobuf.DoubleValue";
      }, e;
    }(), FloatValue: function() {
      function e(n) {
        if (n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.value = 0, e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        return i || (i = h.create()), n.value != null && Object.hasOwnProperty.call(n, "value") && i.uint32(13).float(n.value), i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.google.protobuf.FloatValue(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.value = n.float();
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/google.protobuf.FloatValue";
      }, e;
    }(), Int64Value: function() {
      function e(n) {
        if (n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.value = g.Long ? g.Long.fromBits(0, 0, !1) : 0, e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        return i || (i = h.create()), n.value != null && Object.hasOwnProperty.call(n, "value") && i.uint32(8).int64(n.value), i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.google.protobuf.Int64Value(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.value = n.int64();
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/google.protobuf.Int64Value";
      }, e;
    }(), UInt64Value: function() {
      function e(n) {
        if (n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.value = g.Long ? g.Long.fromBits(0, 0, !0) : 0, e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        return i || (i = h.create()), n.value != null && Object.hasOwnProperty.call(n, "value") && i.uint32(8).uint64(n.value), i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.google.protobuf.UInt64Value(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.value = n.uint64();
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/google.protobuf.UInt64Value";
      }, e;
    }(), Int32Value: function() {
      function e(n) {
        if (n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.value = 0, e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        return i || (i = h.create()), n.value != null && Object.hasOwnProperty.call(n, "value") && i.uint32(8).int32(n.value), i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.google.protobuf.Int32Value(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.value = n.int32();
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/google.protobuf.Int32Value";
      }, e;
    }(), UInt32Value: function() {
      function e(n) {
        if (n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.value = 0, e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        return i || (i = h.create()), n.value != null && Object.hasOwnProperty.call(n, "value") && i.uint32(8).uint32(n.value), i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.google.protobuf.UInt32Value(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.value = n.uint32();
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/google.protobuf.UInt32Value";
      }, e;
    }(), BoolValue: function() {
      function e(n) {
        if (n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.value = !1, e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        return i || (i = h.create()), n.value != null && Object.hasOwnProperty.call(n, "value") && i.uint32(8).bool(n.value), i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.google.protobuf.BoolValue(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.value = n.bool();
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/google.protobuf.BoolValue";
      }, e;
    }(), StringValue: function() {
      function e(n) {
        if (n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.value = "", e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        return i || (i = h.create()), n.value != null && Object.hasOwnProperty.call(n, "value") && i.uint32(10).string(n.value), i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.google.protobuf.StringValue(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.value = n.string();
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/google.protobuf.StringValue";
      }, e;
    }(), BytesValue: function() {
      function e(n) {
        if (n)
          for (var i = Object.keys(n), y = 0; y < i.length; ++y)
            n[i[y]] != null && (this[i[y]] = n[i[y]]);
      }
      return e.prototype.value = g.newBuffer([]), e.create = function(n) {
        return new e(n);
      }, e.encode = function(n, i) {
        return i || (i = h.create()), n.value != null && Object.hasOwnProperty.call(n, "value") && i.uint32(10).bytes(n.value), i;
      }, e.decode = function(n, i) {
        n instanceof l || (n = l.create(n));
        for (var y = i === void 0 ? n.len : n.pos + i, m = new c.google.protobuf.BytesValue(), U; n.pos < y; )
          switch (U = n.uint32(), U >>> 3) {
            case 1: {
              m.value = n.bytes();
              break;
            }
            default:
              n.skipType(7 & U);
          }
        return m;
      }, e.getTypeUrl = function(n) {
        return n === void 0 && (n = "type.googleapis.com"), n + "/google.protobuf.BytesValue";
      }, e;
    }() };
  }() }))();
  u.google = B;
})(proto$5);
(function(u) {
  Object.defineProperty(u, "__esModule", { value: !0 }), u.proto = u.google = u.com = u.Writer = u.Reader = void 0;
  var t = g(minimal$1.exports), a = l(long), d = g(proto$5);
  function l(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function h(o) {
    if (typeof WeakMap != "function")
      return null;
    var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
    return (h = function(i) {
      return i ? n : e;
    })(o);
  }
  function g(o, e) {
    if (!e && o && o.__esModule)
      return o;
    if (o === null || typeof o != "object" && typeof o != "function")
      return { default: o };
    var n = h(e);
    if (n && n.has(o))
      return n.get(o);
    var i = {}, y = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var m in o)
      if (m != "default" && Object.prototype.hasOwnProperty.call(o, m)) {
        var U = y ? Object.getOwnPropertyDescriptor(o, m) : null;
        U && (U.get || U.set) ? Object.defineProperty(i, m, U) : i[m] = o[m];
      }
    return i.default = o, n && n.set(o, i), i;
  }
  (() => {
    var o = t.util;
    o.Long == null && (console.log("Patching Protobuf Long.js instance..."), o.Long = a.default, t.Reader._configure != null && t.Reader._configure(t.BufferReader));
  })();
  const c = t.Reader;
  u.Reader = c;
  const x = t.Writer;
  u.Writer = x;
  const R = d.proto;
  u.proto = R;
  const B = d.com;
  u.com = B;
  const j = d.google;
  u.google = j;
})(lib);
const index = /* @__PURE__ */ getDefaultExportFromCjs(lib), HashgraphProto = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: index
}, [lib]);
class EvmAddress extends Key {
  constructor(t) {
    super(), this._bytes = t;
  }
  static fromString(t) {
    return new EvmAddress(decode$6(t));
  }
  static fromBytes(t) {
    return new EvmAddress(t);
  }
  toBytes() {
    return this._bytes;
  }
  toString() {
    return encode$4(this._bytes);
  }
  equals(t) {
    return arrayEqual$2(this._bytes, t._bytes);
  }
}
class AccountId {
  constructor(t, a, d, l, h) {
    const g = constructor(t, a, d);
    this.shard = g.shard, this.realm = g.realm, this.num = g.num, this.aliasKey = l != null ? l : null, this.evmAddress = h != null ? h : null, this._checksum = null;
  }
  static fromString(t) {
    let a = long.ZERO, d = long.ZERO, l = long.ZERO, h, g;
    if (t.startsWith("0x") && t.length == 42 || t.length == 40)
      g = EvmAddress.fromString(t);
    else {
      const c = fromStringSplitter(t);
      if (Number.isNaN(c.shard) || Number.isNaN(c.realm))
        throw new Error("invalid format for entity ID");
      c.shard != null && (a = long.fromString(c.shard)), c.realm != null && (d = long.fromString(c.realm)), c.numOrHex.length < 20 ? l = long.fromString(c.numOrHex) : c.numOrHex.length == 40 ? g = EvmAddress.fromString(c.numOrHex) : h = PublicKey.fromString(c.numOrHex);
    }
    return new AccountId(a, d, l, h, g);
  }
  static fromEvmAddress(t, a, d) {
    return new AccountId(
      t,
      a,
      0,
      void 0,
      typeof d == "string" ? EvmAddress.fromString(d) : d
    );
  }
  static fromEvmPublicAddress(t) {
    return new AccountId(0, 0, 0, void 0, t);
  }
  static _fromProtobuf(t) {
    let a, d;
    return t.alias != null && (t.alias.length === 20 ? d = EvmAddress.fromBytes(t.alias) : a = Key._fromProtobufKey(
      lib.proto.Key.decode(t.alias)
    )), a instanceof PublicKey || (a = void 0), new AccountId(
      t.shardNum != null ? t.shardNum : 0,
      t.realmNum != null ? t.realmNum : 0,
      t.accountNum != null ? t.accountNum : 0,
      a,
      d
    );
  }
  get checksum() {
    return this._checksum;
  }
  getEvmAddress() {
    return this.evmAddress;
  }
  validate(t) {
    console.warn("Deprecated: Use `validateChecksum` instead"), this.validateChecksum(t);
  }
  validateChecksum(t) {
    if (this.aliasKey != null)
      throw new Error(
        "cannot calculate checksum with an account ID that has a aliasKey"
      );
    validateChecksum(
      this.shard,
      this.realm,
      this.num,
      this._checksum,
      t
    );
  }
  static fromBytes(t) {
    return AccountId._fromProtobuf(
      lib.proto.AccountID.decode(t)
    );
  }
  static fromSolidityAddress(t) {
    return new AccountId(...fromSolidityAddress(t));
  }
  toSolidityAddress() {
    return toSolidityAddress([this.shard, this.realm, this.num]);
  }
  _toProtobuf() {
    let t = null;
    return this.aliasKey != null ? t = lib.proto.Key.encode(
      this.aliasKey._toProtobufKey()
    ).finish() : this.evmAddress != null && (t = this.evmAddress._bytes), {
      alias: t,
      accountNum: this.aliasKey != null ? null : this.num,
      shardNum: this.shard,
      realmNum: this.realm
    };
  }
  toBytes() {
    return lib.proto.AccountID.encode(
      this._toProtobuf()
    ).finish();
  }
  toString() {
    let t = this.num.toString();
    return this.aliasKey != null ? t = this.aliasKey.toString() : this.evmAddress != null && (t = this.evmAddress.toString()), `${this.shard.toString()}.${this.realm.toString()}.${t}`;
  }
  toStringWithChecksum(t) {
    if (this.aliasKey != null)
      throw new Error(
        "cannot calculate checksum with an account ID that has a aliasKey"
      );
    return toStringWithChecksum(this.toString(), t);
  }
  equals(t) {
    let a = !1;
    return this.aliasKey != null && t.aliasKey != null ? a = this.aliasKey.equals(t.aliasKey) : this.evmAddress != null && t.evmAddress != null ? a = this.evmAddress.equals(t.evmAddress) : this.aliasKey == null && t.aliasKey == null && this.evmAddress == null && t.evmAddress == null && (a = this.num.eq(t.num)), this.shard.eq(t.shard) && this.realm.eq(t.realm) && a;
  }
  clone() {
    const t = new AccountId(this);
    return t._checksum = this._checksum, t.aliasKey = this.aliasKey, t.evmAddress = this.evmAddress, t;
  }
  compare(t) {
    let a = this.shard.compare(t.shard);
    if (a != 0 || (a = this.realm.compare(t.realm), a != 0))
      return a;
    if (this.aliasKey != null && t.aliasKey != null) {
      const d = this.aliasKey.toString(), l = t.aliasKey.toString();
      return d > l ? 1 : d < l ? -1 : 0;
    } else if (this.evmAddress != null && t.evmAddress != null) {
      const d = this.evmAddress.toString(), l = t.evmAddress.toString();
      return d > l ? 1 : d < l ? -1 : 0;
    } else
      return this.aliasKey == null && t.aliasKey == null && this.evmAddress == null && t.evmAddress == null ? this.num.compare(t.num) : 1;
  }
}
CACHE$1.setAccountIdConstructor(
  (u, t, a) => new AccountId(u, t, long.ZERO, a)
);
class GrpcStatus {
  constructor(t) {
    this._code = t, Object.freeze(this);
  }
  static _fromValue(t) {
    switch (t) {
      case 0:
        return GrpcStatus.Ok;
      case 1:
        return GrpcStatus.Cancelled;
      case 2:
        return GrpcStatus.Unknown;
      case 3:
        return GrpcStatus.InvalidArgument;
      case 4:
        return GrpcStatus.DeadlineExceeded;
      case 5:
        return GrpcStatus.NotFound;
      case 6:
        return GrpcStatus.AlreadyExists;
      case 7:
        return GrpcStatus.PermissionDenied;
      case 8:
        return GrpcStatus.ResourceExhausted;
      case 9:
        return GrpcStatus.FailedPrecondition;
      case 10:
        return GrpcStatus.Aborted;
      case 11:
        return GrpcStatus.OutOfRange;
      case 12:
        return GrpcStatus.Unimplemented;
      case 13:
        return GrpcStatus.Internal;
      case 14:
        return GrpcStatus.Unavailable;
      case 15:
        return GrpcStatus.DataLoss;
      case 16:
        return GrpcStatus.Unauthenticated;
      case 17:
        return GrpcStatus.Timeout;
      default:
        throw new Error(
          "(BUG) non-exhaustive GrpcStatus switch statement"
        );
    }
  }
  toString() {
    switch (this) {
      case GrpcStatus.Ok:
        return "OK";
      case GrpcStatus.Cancelled:
        return "CANCELLED";
      case GrpcStatus.Unknown:
        return "UNKNOWN";
      case GrpcStatus.InvalidArgument:
        return "INVALID_ARGUMENT";
      case GrpcStatus.DeadlineExceeded:
        return "DEADLINE_EXCEEDED";
      case GrpcStatus.NotFound:
        return "NOT_FOUND";
      case GrpcStatus.AlreadyExists:
        return "ALREADY_EXISTS";
      case GrpcStatus.PermissionDenied:
        return "PERMISSION_DENIED";
      case GrpcStatus.Unauthenticated:
        return "UNAUTHENTICATED";
      case GrpcStatus.ResourceExhausted:
        return "RESOURCE_EXHAUSTED";
      case GrpcStatus.FailedPrecondition:
        return "FAILED_PRECONDITION";
      case GrpcStatus.Aborted:
        return "ABORTED";
      case GrpcStatus.OutOfRange:
        return "OUT_OF_RANGE";
      case GrpcStatus.Unimplemented:
        return "UNIMPLEMENTED";
      case GrpcStatus.Internal:
        return "INTERNAL";
      case GrpcStatus.Unavailable:
        return "UNAVAILABLE";
      case GrpcStatus.DataLoss:
        return "DATA_LOSS";
      case GrpcStatus.Timeout:
        return "TIMEOUT";
      default:
        return `UNKNOWN (${this._code})`;
    }
  }
  valueOf() {
    return this._code;
  }
}
GrpcStatus.Ok = new GrpcStatus(0);
GrpcStatus.Cancelled = new GrpcStatus(1);
GrpcStatus.Unknown = new GrpcStatus(2);
GrpcStatus.InvalidArgument = new GrpcStatus(3);
GrpcStatus.DeadlineExceeded = new GrpcStatus(4);
GrpcStatus.NotFound = new GrpcStatus(5);
GrpcStatus.AlreadyExists = new GrpcStatus(6);
GrpcStatus.PermissionDenied = new GrpcStatus(7);
GrpcStatus.ResourceExhausted = new GrpcStatus(8);
GrpcStatus.FailedPrecondition = new GrpcStatus(9);
GrpcStatus.Aborted = new GrpcStatus(10);
GrpcStatus.OutOfRange = new GrpcStatus(11);
GrpcStatus.Unimplemented = new GrpcStatus(12);
GrpcStatus.Internal = new GrpcStatus(13);
GrpcStatus.Unavailable = new GrpcStatus(14);
GrpcStatus.DataLoss = new GrpcStatus(15);
GrpcStatus.Unauthenticated = new GrpcStatus(16);
GrpcStatus.Timeout = new GrpcStatus(17);
class GrpcServiceError extends Error {
  constructor(t) {
    super(`gRPC service failed with status: ${t.toString()}`), this.status = t, this.name = "GrpcServiceError", typeof Error.captureStackTrace < "u" && Error.captureStackTrace(this, GrpcServiceError);
  }
  static _fromResponse(t) {
    if (t.code != null && t.details != null) {
      const a = GrpcStatus._fromValue(t.code), d = new GrpcServiceError(a);
      return d.message = t.details, d;
    } else
      return t;
  }
}
class List {
  constructor() {
    this.list = [], this.locked = !1, this.index = 0;
  }
  setList(t) {
    if (this.locked)
      throw new Error("list is locked");
    return this.list = t, this.index = 0, this;
  }
  push(...t) {
    if (this.locked)
      throw new Error("list is locked");
    return this.list.push(...t), this;
  }
  setLocked() {
    return this.locked = !0, this;
  }
  clear() {
    this.list = [], this.index = 0;
  }
  get(t) {
    return this.list[t];
  }
  set(t, a) {
    return t === this.length ? this.list.push(a) : this.list[t] = a, this;
  }
  setIfAbsent(t, a) {
    return (t == this.length || this.list[t] == null) && this.set(t, a()), this;
  }
  get next() {
    return this.get(this.advance());
  }
  get current() {
    return this.get(this.index);
  }
  advance() {
    const t = this.index;
    return this.index = (this.index + 1) % this.list.length, t;
  }
  get isEmpty() {
    return this.length === 0;
  }
  get length() {
    return this.list.length;
  }
  clone() {
    const t = new List();
    return t.list = this.list, t.locked = this.locked, t;
  }
}
class HttpError extends Error {
  constructor(t) {
    super(`failed with error code: ${t.toString()}`), this.status = t, this.name = "HttpError", typeof Error.captureStackTrace < "u" && Error.captureStackTrace(this, HttpError);
  }
}
const ExecutionState = {
  Finished: "Finished",
  Retry: "Retry",
  Error: "Error"
}, RST_STREAM = /\brst[^0-9a-zA-Z]stream\b/i;
class Executable {
  constructor() {
    this._maxAttempts = 10, this._nodeAccountIds = new List(), this._signOnDemand = !1, this._minBackoff = null, this._maxBackoff = 8e3, this._operator = null, this._requestTimeout = null, this._grpcDeadline = null, this._logger = null;
  }
  get nodeAccountIds() {
    return this._nodeAccountIds.isEmpty ? null : (this._nodeAccountIds.setLocked(), this._nodeAccountIds.list);
  }
  setNodeAccountIds(t) {
    return this._nodeAccountIds.setList(t).setLocked(), this;
  }
  get maxRetries() {
    return console.warn("Deprecated: use maxAttempts instead"), this.maxAttempts;
  }
  setMaxRetries(t) {
    return console.warn("Deprecated: use setMaxAttempts() instead"), this.setMaxAttempts(t);
  }
  get maxAttempts() {
    return this._maxAttempts;
  }
  setMaxAttempts(t) {
    return this._maxAttempts = t, this;
  }
  get grpcDeadline() {
    return this._grpcDeadline;
  }
  setGrpcDeadline(t) {
    return this._grpcDeadline = t, this;
  }
  setMinBackoff(t) {
    if (t == null)
      throw new Error("minBackoff cannot be null.");
    if (this._maxBackoff != null && t > this._maxBackoff)
      throw new Error("minBackoff cannot be larger than maxBackoff.");
    return this._minBackoff = t, this;
  }
  get minBackoff() {
    return this._minBackoff;
  }
  setMaxBackoff(t) {
    if (t == null)
      throw new Error("maxBackoff cannot be null.");
    if (this._minBackoff != null && t < this._minBackoff)
      throw new Error("maxBackoff cannot be smaller than minBackoff.");
    return this._maxBackoff = t, this;
  }
  get maxBackoff() {
    return this._maxBackoff;
  }
  _beforeExecute(t) {
    throw new Error("not implemented");
  }
  _makeRequestAsync() {
    throw new Error("not implemented");
  }
  _mapStatusError(t, a) {
    throw new Error("not implemented");
  }
  _mapResponse(t, a, d) {
    throw new Error("not implemented");
  }
  _execute(t, a) {
    throw new Error("not implemented");
  }
  _getTransactionId() {
    throw new Error("not implemented");
  }
  _getLogId() {
    throw new Error("not implemented");
  }
  _requestToBytes(t) {
    throw new Error("not implemented");
  }
  _responseToBytes(t) {
    throw new Error("not implemented");
  }
  _advanceRequest() {
    this._nodeAccountIds.advance();
  }
  _shouldRetry(t, a) {
    throw new Error("not implemented");
  }
  _shouldRetryExceptionally(t) {
    return t instanceof GrpcServiceError ? t.status._code === GrpcStatus.Timeout._code || t.status._code === GrpcStatus.Unavailable._code || t.status._code === GrpcStatus.ResourceExhausted._code || t.status._code === GrpcStatus.Internal._code && RST_STREAM.test(t.message) : !0;
  }
  _setOperatorWith(t, a, d) {
    return this._operator = {
      transactionSigner: d,
      accountId: t,
      publicKey: a
    }, this;
  }
  async executeWithSigner(t) {
    return t.call(this);
  }
  async execute(t, a) {
    this._logger = this._logger == null ? t._logger != null ? t._logger : null : this._logger, this._requestTimeout == null && (this._requestTimeout = a != null ? a : t.requestTimeout), await this._beforeExecute(t), this._maxBackoff == null && (this._maxBackoff = t.maxBackoff), this._minBackoff == null && (this._minBackoff = t.minBackoff);
    const d = t._maxAttempts != null ? t._maxAttempts : this._maxAttempts, l = Date.now();
    let h = null;
    for (let g = 1; g <= d; g += 1) {
      if (this._requestTimeout != null && l + this._requestTimeout <= Date.now())
        throw new Error("timeout exceeded");
      let c, x;
      if (this._nodeAccountIds.locked ? (c = this._nodeAccountIds.current, x = t._network.getNode(c)) : (x = t._network.getNode(), c = x.accountId, this._nodeAccountIds.setList([c])), x == null)
        throw new Error(
          `NodeAccountId not recognized: ${c.toString()}`
        );
      const R = this._getLogId();
      this._logger && this._logger.debug(
        `[${R}] Node AccountID: ${x.accountId.toString()}, IP: ${x.address.toString()}`
      );
      const B = x.getChannel(), j = await this._makeRequestAsync();
      this._advanceRequest();
      let o;
      if (!x.isHealthy()) {
        this._logger && this._logger.debug(
          `[${R}] node is not healthy, skipping waiting ${x.getRemainingTime()}`
        );
        continue;
      }
      try {
        const i = [];
        this._grpcDeadline != null && i.push(
          new Promise(
            (y, m) => setTimeout(
              () => m(new Error("grpc deadline exceeded")),
              this._grpcDeadline
            )
          )
        ), this._logger && this._logger.trace(
          `[${this._getLogId()}] sending protobuf ${encode$4(
            this._requestToBytes(j)
          )}`
        ), i.push(this._execute(B, j)), o = await Promise.race(i);
      } catch (i) {
        const y = GrpcServiceError._fromResponse(
          i
        );
        if (h = y, this._logger && this._logger.debug(
          `[${R}] received error ${JSON.stringify(y)}`
        ), (y instanceof GrpcServiceError || y instanceof HttpError) && this._shouldRetryExceptionally(y) && g <= d) {
          this._logger && this._logger.debug(
            `[${this._getLogId()}] node with accountId: ${x.accountId.toString()} and proxy IP: ${x.address.toString()} is unhealthy`
          ), t._network.increaseBackoff(x);
          continue;
        }
        throw i;
      }
      this._logger && this._logger.trace(
        `[${this._getLogId()}] sending protobuf ${encode$4(
          this._responseToBytes(o)
        )}`
      ), t._network.decreaseBackoff(x);
      const [e, n] = this._shouldRetry(j, o);
      switch (e != null && (h = e), n) {
        case ExecutionState.Retry:
          await delayForAttempt(
            g,
            this._minBackoff,
            this._maxBackoff
          );
          continue;
        case ExecutionState.Finished:
          return this._mapResponse(o, c, j);
        case ExecutionState.Error:
          throw this._mapStatusError(j, o);
        default:
          throw new Error(
            "(BUG) non-exhuastive switch statement for `ExecutionState`"
          );
      }
    }
    throw new Error(
      `max attempts of ${d.toString()} was reached for request with last error being: ${h != null ? h.toString() : ""}`
    );
  }
  toBytes() {
    throw new Error("not implemented");
  }
  setLogger(t) {
    return this._logger = t, this;
  }
  get logger() {
    return this._logger;
  }
}
function delayForAttempt(u, t, a) {
  const d = Math.min(
    Math.floor(t * Math.pow(2, u)),
    a
  );
  return new Promise((l) => setTimeout(l, d));
}
const MAX_NS = long.fromNumber(1e9);
class Timestamp {
  constructor(t, a) {
    this.seconds = t instanceof long ? t : long.fromNumber(t), this.nanos = a instanceof long ? a : long.fromNumber(a), Object.freeze(this);
  }
  static generate() {
    const t = Math.floor(Math.random() * 5e3) + 8e3, a = Date.now() - t, d = Math.floor(a / 1e3) + CACHE$1.timeDrift, l = Math.floor(a % 1e3) * 1e6 + Math.floor(Math.random() * 1e6);
    return new Timestamp(d, l);
  }
  static fromDate(t) {
    let a;
    if (typeof t == "number")
      a = long.fromNumber(t);
    else if (typeof t == "string")
      a = long.fromNumber(Date.parse(t)).mul(1e6);
    else if (t instanceof Date)
      a = long.fromNumber(t.getTime()).mul(1e6);
    else
      throw new TypeError(
        `invalid type '${typeof t}' for 'data', expected 'Date'`
      );
    return new Timestamp(0, 0).plusNanos(a);
  }
  toDate() {
    return new Date(
      this.seconds.toInt() * 1e3 + Math.floor(this.nanos.toInt() / 1e6)
    );
  }
  plusNanos(t) {
    const a = this.nanos.add(t);
    return new Timestamp(this.seconds.add(a.div(MAX_NS)), a.mod(MAX_NS));
  }
  _toProtobuf() {
    return {
      seconds: this.seconds,
      nanos: this.nanos.toInt()
    };
  }
  static _fromProtobuf(t) {
    return new Timestamp(
      t.seconds instanceof long ? t.seconds.toInt() : t.seconds != null ? t.seconds : 0,
      t.nanos != null ? t.nanos : 0
    );
  }
  toString() {
    return `${this.seconds.toString()}.${this.nanos.toString()}`;
  }
  compare(t) {
    const a = this.seconds.compare(t.seconds);
    return a != 0 ? a : this.nanos.compare(t.nanos);
  }
}
class TransactionId {
  constructor(t, a, d = !1, l = null) {
    this.accountId = t, this.validStart = a, this.scheduled = d, this.nonce = null, l != null && l != 0 && this.setNonce(l), Object.seal(this);
  }
  setNonce(t) {
    return this.nonce = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  static withValidStart(t, a) {
    return new TransactionId(t, a);
  }
  static generate(t) {
    return new TransactionId(
      typeof t == "string" ? AccountId.fromString(t) : new AccountId(t),
      Timestamp.generate()
    );
  }
  static fromString(t) {
    let a, d, l, h, g, c;
    return [a, c] = t.split("@"), [d, c] = c.split("."), c.includes("?") ? ([l, c] = c.split("?scheduled"), h = !0, c.includes("/") ? g = c.replace("/", "") : g = null) : c.includes("/") ? ([l, g] = c.split("/"), h = !1) : l = c, new TransactionId(
      AccountId.fromString(a),
      new Timestamp(long.fromValue(d), long.fromValue(l)),
      h,
      g != null ? long.fromString(g) : null
    );
  }
  setScheduled(t) {
    return this.scheduled = t, this;
  }
  toString() {
    if (this.accountId != null && this.validStart != null) {
      const t = String(this.validStart.nanos).padStart(
        9,
        "0"
      ), a = this.nonce != null ? "/".concat(this.nonce.toString()) : "", d = this.scheduled ? "?scheduled" : "";
      return `${this.accountId.toString()}@${this.validStart.seconds.toString()}.${t}${d}${a}`;
    } else
      throw new Error("neither `accountId` nor `validStart` are set");
  }
  static _fromProtobuf(t) {
    if (t.accountID != null && t.transactionValidStart != null)
      return new TransactionId(
        AccountId._fromProtobuf(t.accountID),
        Timestamp._fromProtobuf(t.transactionValidStart),
        t.scheduled != null ? t.scheduled : void 0,
        t.nonce != null ? t.nonce : void 0
      );
    throw new Error(
      "Neither `nonce` or `accountID` and `transactionValidStart` are set"
    );
  }
  _toProtobuf() {
    return {
      accountID: this.accountId != null ? this.accountId._toProtobuf() : null,
      transactionValidStart: this.validStart != null ? this.validStart._toProtobuf() : null,
      scheduled: this.scheduled,
      nonce: this.nonce != null ? this.nonce.toInt() : null
    };
  }
  static fromBytes(t) {
    return TransactionId._fromProtobuf(
      lib.proto.TransactionID.decode(t)
    );
  }
  toBytes() {
    return lib.proto.TransactionID.encode(
      this._toProtobuf()
    ).finish();
  }
  clone() {
    return new TransactionId(
      this.accountId,
      this.validStart,
      this.scheduled,
      this.nonce
    );
  }
  compare(t) {
    const a = this.accountId.compare(
      t.accountId
    );
    return a != 0 ? a : this.validStart.compare(
      t.validStart
    );
  }
  getReceipt(t) {
    return CACHE$1.transactionReceiptQueryConstructor().setTransactionId(this).execute(t);
  }
  async getRecord(t) {
    return await this.getReceipt(t), CACHE$1.transactionRecordQueryConstructor().setTransactionId(this).execute(t);
  }
}
class PrecheckStatusError extends StatusError {
  constructor(t) {
    super(
      t,
      `transaction ${t.transactionId.toString()} failed precheck with status ${t.status.toString()}`
    ), this.contractFunctionResult = t.contractFunctionResult;
  }
  toJSON() {
    return {
      name: this.name,
      status: this.status.toString(),
      transactionId: this.transactionId.toString(),
      message: this.message,
      contractFunctionResult: this.contractFunctionResult
    };
  }
}
class MaxQueryPaymentExceeded extends Error {
  constructor(t, a) {
    super(), this.message = `query cost of ${t.toString()} HBAR exceeds max set on client: ${a.toString()} HBAR`, this.name = "MaxQueryPaymentExceededError", this.queryCost = t, this.maxQueryPayment = a;
  }
}
const QUERY_REGISTRY = /* @__PURE__ */ new Map();
class Query extends Executable {
  constructor() {
    super(), this._paymentTransactionId = null, this._paymentTransactions = [], this._queryPayment = null, this._maxQueryPayment = null, this._timestamp = Date.now();
  }
  static fromBytes(t) {
    const a = lib.proto.Query.decode(t);
    if (a.query == null)
      throw new Error("(BUG) query.query was not set in the protobuf");
    const d = QUERY_REGISTRY.get(a.query);
    if (d == null)
      throw new Error(
        `(BUG) Query.fromBytes() not implemented for type ${a.query}`
      );
    return d(a);
  }
  toBytes() {
    return lib.proto.Query.encode(this._makeRequest()).finish();
  }
  setQueryPayment(t) {
    return this._queryPayment = t, this;
  }
  setMaxQueryPayment(t) {
    return this._maxQueryPayment = t, this;
  }
  async getCost(t) {
    if (this._nodeAccountIds.isEmpty && this._nodeAccountIds.setList(
      t._network.getNodeAccountIdsForExecute()
    ), COST_QUERY.length != 1)
      throw new Error("CostQuery has not been loaded yet");
    this._timestamp = Date.now();
    const a = await COST_QUERY[0](this).execute(t);
    return Hbar.fromTinybars(
      a._valueInTinybar.multipliedBy(1.1).toFixed(0)
    );
  }
  setPaymentTransactionId(t) {
    return this._paymentTransactionId = t, this;
  }
  get paymentTransactionId() {
    return this._paymentTransactionId;
  }
  _getTransactionId() {
    if (this._paymentTransactionId == null)
      throw new Error(
        "Query.PaymentTransactionId was not set duration execution"
      );
    return this._paymentTransactionId;
  }
  _isPaymentRequired() {
    return !0;
  }
  _validateChecksums(t) {
  }
  async _beforeExecute(t) {
    if (this._paymentTransactions.length > 0)
      return;
    if (t.isAutoValidateChecksumsEnabled() && this._validateChecksums(t), this._nodeAccountIds.isEmpty && this._nodeAccountIds.setList(
      t._network.getNodeAccountIdsForExecute()
    ), this._operator = this._operator != null ? this._operator : t._operator, this._paymentTransactionId == null)
      if (this._isPaymentRequired())
        if (this._operator != null)
          this._paymentTransactionId = TransactionId.generate(
            this._operator.accountId
          );
        else
          throw new Error(
            "`client` must have an `operator` or an explicit payment transaction must be provided"
          );
      else
        this._paymentTransactionId = TransactionId.generate(
          new AccountId(0)
        );
    let a = new Hbar(0);
    const d = this._maxQueryPayment != null ? this._maxQueryPayment : t.maxQueryPayment;
    if (this._queryPayment != null)
      a = this._queryPayment;
    else if (this._paymentTransactions.length === 0 && this._isPaymentRequired()) {
      const l = await this.getCost(t);
      if (d.toTinybars().toInt() < l.toTinybars().toInt())
        throw new MaxQueryPaymentExceeded(l, d);
      a = l, this._logger && this._logger.debug(
        `[${this._getLogId()}] received cost for query ${a.toString()}`
      );
    }
    this._queryPayment = a, this._timestamp = Date.now(), this._nodeAccountIds.setLocked();
    for (const l of this._nodeAccountIds.list) {
      const h = this._getLogId(), g = this._paymentTransactionId, c = this._queryPayment;
      this._logger && this._logger.debug(
        `[${h}] making a payment transaction for node ${l.toString()} and transaction ID ${g.toString()} with amount ${c.toString()}`
      ), this._paymentTransactions.push(
        await _makePaymentTransaction(
          g,
          l,
          this._isPaymentRequired() ? this._operator : null,
          c
        )
      );
    }
  }
  _mapResponseHeader(t) {
    throw new Error("not implemented");
  }
  _makeRequestHeader() {
    let t = {};
    return this._isPaymentRequired() && this._paymentTransactions.length > 0 && (t = {
      responseType: lib.proto.ResponseType.ANSWER_ONLY,
      payment: this._paymentTransactions[this._nodeAccountIds.index]
    }), t;
  }
  _onMakeRequest(t) {
    throw new Error("not implemented");
  }
  _makeRequest() {
    let t = {};
    return this._isPaymentRequired() && this._paymentTransactions != null && (t = {
      payment: this._paymentTransactions[this._nodeAccountIds.index],
      responseType: lib.proto.ResponseType.ANSWER_ONLY
    }), this._onMakeRequest(t);
  }
  async _makeRequestAsync() {
    let t = {
      responseType: lib.proto.ResponseType.ANSWER_ONLY
    };
    if (this._isPaymentRequired() && this._paymentTransactions != null)
      if (this._nodeAccountIds.locked)
        t.payment = this._paymentTransactions[this._nodeAccountIds.index];
      else {
        const a = this._getLogId(), d = this._nodeAccountIds.current, l = this._paymentTransactionId, h = this._queryPayment;
        this._logger && this._logger.debug(
          `[${a}] making a payment transaction for node ${d.toString()} and transaction ID ${l.toString()} with amount ${h.toString()}`
        ), t.payment = await _makePaymentTransaction(
          l,
          d,
          this._isPaymentRequired() ? this._operator : null,
          h
        );
      }
    return this._onMakeRequest(t);
  }
  _shouldRetry(t, a) {
    const { nodeTransactionPrecheckCode: d } = this._mapResponseHeader(a), l = Status._fromCode(
      d != null ? d : lib.proto.ResponseCodeEnum.OK
    );
    switch (this._logger && this._logger.debug(
      `[${this._getLogId()}] received status ${l.toString()}`
    ), l) {
      case Status.Busy:
      case Status.Unknown:
      case Status.PlatformTransactionNotCreated:
        return [l, ExecutionState.Retry];
      case Status.Ok:
        return [l, ExecutionState.Finished];
      default:
        return [l, ExecutionState.Error];
    }
  }
  _mapStatusError(t, a) {
    const { nodeTransactionPrecheckCode: d } = this._mapResponseHeader(a), l = Status._fromCode(
      d != null ? d : lib.proto.ResponseCodeEnum.OK
    );
    return new PrecheckStatusError({
      status: l,
      transactionId: this._getTransactionId(),
      contractFunctionResult: null
    });
  }
  _requestToBytes(t) {
    return lib.proto.Query.encode(t).finish();
  }
  _responseToBytes(t) {
    return lib.proto.Response.encode(t).finish();
  }
}
async function _makePaymentTransaction(u, t, a, d) {
  const l = [];
  a != null ? (l.push({
    accountID: a.accountId._toProtobuf(),
    amount: d.negated().toTinybars()
  }), l.push({
    accountID: t._toProtobuf(),
    amount: d.toTinybars()
  })) : (l.push({
    accountID: new AccountId(0)._toProtobuf(),
    amount: d.negated().toTinybars()
  }), l.push({
    accountID: t._toProtobuf(),
    amount: d.toTinybars()
  }));
  const h = {
    transactionID: u._toProtobuf(),
    nodeAccountID: t._toProtobuf(),
    transactionFee: new Hbar(1).toTinybars(),
    transactionValidDuration: {
      seconds: long.fromNumber(120)
    },
    cryptoTransfer: {
      transfers: {
        accountAmounts: l
      }
    }
  }, g = {
    bodyBytes: lib.proto.TransactionBody.encode(h).finish()
  };
  if (a != null) {
    const c = await a.transactionSigner(
      g.bodyBytes
    );
    g.sigMap = {
      sigPair: [a.publicKey._toProtobufSignature(c)]
    };
  }
  return {
    signedTransactionBytes: lib.proto.SignedTransaction.encode(
      g
    ).finish()
  };
}
const COST_QUERY = [];
class ContractId extends Key {
  constructor(t, a, d, l) {
    super();
    const h = constructor(t, a, d);
    this.shard = h.shard, this.realm = h.realm, this.num = h.num, this.evmAddress = l != null ? l : null, this._checksum = null;
  }
  static fromEvmAddress(t, a, d) {
    return new ContractId(t, a, 0, decode$6(d));
  }
  static fromString(t) {
    const a = fromStringSplitter(t);
    if (Number.isNaN(a.shard) || Number.isNaN(a.realm))
      throw new Error("invalid format for entity ID");
    const d = a.shard != null ? long.fromString(a.shard) : long.ZERO, l = a.realm != null ? long.fromString(a.realm) : long.ZERO, [h, g] = a.numOrHex.length < 40 ? [long.fromString(a.numOrHex), void 0] : [long.ZERO, decode$6(a.numOrHex)];
    return new ContractId(d, l, h, g);
  }
  static _fromProtobuf(t) {
    return new ContractId(
      t.shardNum != null ? t.shardNum : 0,
      t.realmNum != null ? t.realmNum : 0,
      t.contractNum != null ? t.contractNum : 0
    );
  }
  get checksum() {
    return this._checksum;
  }
  validate(t) {
    console.warn("Deprecated: Use `validateChecksum` instead"), this.validateChecksum(t);
  }
  validateChecksum(t) {
    validateChecksum(
      this.shard,
      this.realm,
      this.num,
      this._checksum,
      t
    );
  }
  static fromBytes(t) {
    return ContractId._fromProtobuf(
      lib.proto.ContractID.decode(t)
    );
  }
  static fromSolidityAddress(t) {
    const [a, d, l] = fromSolidityAddress(t);
    return new ContractId(a, d, l);
  }
  toSolidityAddress() {
    return this.evmAddress != null ? encode$4(this.evmAddress) : toSolidityAddress([
      this.shard,
      this.realm,
      this.num
    ]);
  }
  _toProtobuf() {
    return {
      contractNum: this.num,
      shardNum: this.shard,
      realmNum: this.realm,
      evmAddress: this.evmAddress
    };
  }
  toString() {
    return this.evmAddress != null ? `${this.shard.toString()}.${this.realm.toString()}.${encode$4(
      this.evmAddress
    )}` : `${this.shard.toString()}.${this.realm.toString()}.${this.num.toString()}`;
  }
  toStringWithChecksum(t) {
    return toStringWithChecksum(this.toString(), t);
  }
  toBytes() {
    return lib.proto.ContractID.encode(
      this._toProtobuf()
    ).finish();
  }
  clone() {
    const t = new ContractId(this);
    return t._checksum = this._checksum, t.evmAddress = this.evmAddress, t;
  }
  compare(t) {
    return compare(
      [this.shard, this.realm, this.num],
      [t.shard, t.realm, t.num]
    );
  }
  _toProtobufKey() {
    return {
      contractID: this._toProtobuf()
    };
  }
  static __fromProtobufKey(t) {
    return ContractId._fromProtobuf(t);
  }
}
CACHE$1.setContractId((u) => ContractId.__fromProtobufKey(u));
class FileId {
  constructor(t, a, d) {
    const l = constructor(t, a, d);
    this.shard = l.shard, this.realm = l.realm, this.num = l.num, this._checksum = null;
  }
  static fromString(t) {
    const a = fromString(t), d = new FileId(a);
    return d._checksum = a.checksum, d;
  }
  static _fromProtobuf(t) {
    return new FileId(
      t.shardNum != null ? long.fromString(t.shardNum.toString()) : 0,
      t.realmNum != null ? long.fromString(t.realmNum.toString()) : 0,
      t.fileNum != null ? long.fromString(t.fileNum.toString()) : 0
    );
  }
  get checksum() {
    return this._checksum;
  }
  validate(t) {
    console.warn("Deprecated: Use `validateChecksum` instead"), this.validateChecksum(t);
  }
  validateChecksum(t) {
    validateChecksum(
      this.shard,
      this.realm,
      this.num,
      this._checksum,
      t
    );
  }
  static fromBytes(t) {
    return FileId._fromProtobuf(lib.proto.FileID.decode(t));
  }
  static fromSolidityAddress(t) {
    const [a, d, l] = fromSolidityAddress(t);
    return new FileId(a, d, l);
  }
  toSolidityAddress() {
    return toSolidityAddress([this.shard, this.realm, this.num]);
  }
  _toProtobuf() {
    return {
      fileNum: this.num,
      shardNum: this.shard,
      realmNum: this.realm
    };
  }
  toString() {
    return `${this.shard.toString()}.${this.realm.toString()}.${this.num.toString()}`;
  }
  toStringWithChecksum(t) {
    return toStringWithChecksum(this.toString(), t);
  }
  toBytes() {
    return lib.proto.FileID.encode(this._toProtobuf()).finish();
  }
  clone() {
    const t = new FileId(this);
    return t._checksum = this._checksum, t;
  }
  compare(t) {
    return compare(
      [this.shard, this.realm, this.num],
      [t.shard, t.realm, t.num]
    );
  }
}
FileId.ADDRESS_BOOK = new FileId(102);
FileId.FEE_SCHEDULE = new FileId(111);
FileId.EXCHANGE_RATES = new FileId(112);
class TopicId {
  constructor(t, a, d) {
    const l = constructor(t, a, d);
    this.shard = l.shard, this.realm = l.realm, this.num = l.num, this._checksum = null;
  }
  static fromString(t) {
    const a = fromString(t), d = new TopicId(a);
    return d._checksum = a.checksum, d;
  }
  static _fromProtobuf(t) {
    return new TopicId(
      t.shardNum != null ? t.shardNum : 0,
      t.realmNum != null ? t.realmNum : 0,
      t.topicNum != null ? t.topicNum : 0
    );
  }
  get checksum() {
    return this._checksum;
  }
  validate(t) {
    console.warn("Deprecated: Use `validateChecksum` instead"), this.validateChecksum(t);
  }
  validateChecksum(t) {
    validateChecksum(
      this.shard,
      this.realm,
      this.num,
      this._checksum,
      t
    );
  }
  static fromBytes(t) {
    return TopicId._fromProtobuf(
      lib.proto.TopicID.decode(t)
    );
  }
  static fromSolidityAddress(t) {
    const [a, d, l] = fromSolidityAddress(t);
    return new TopicId(a, d, l);
  }
  toSolidityAddress() {
    return toSolidityAddress([this.shard, this.realm, this.num]);
  }
  _toProtobuf() {
    return {
      topicNum: this.num,
      shardNum: this.shard,
      realmNum: this.realm
    };
  }
  toString() {
    return `${this.shard.toString()}.${this.realm.toString()}.${this.num.toString()}`;
  }
  toStringWithChecksum(t) {
    return toStringWithChecksum(this.toString(), t);
  }
  toBytes() {
    return lib.proto.TopicID.encode(this._toProtobuf()).finish();
  }
  clone() {
    const t = new TopicId(this);
    return t._checksum = this._checksum, t;
  }
  compare(t) {
    return compare(
      [this.shard, this.realm, this.num],
      [t.shard, t.realm, t.num]
    );
  }
}
class TokenId {
  constructor(t, a, d) {
    const l = constructor(t, a, d);
    this.shard = l.shard, this.realm = l.realm, this.num = l.num, this._checksum = null;
  }
  static fromString(t) {
    const a = fromString(t), d = new TokenId(a);
    return d._checksum = a.checksum, d;
  }
  static _fromProtobuf(t) {
    return new TokenId(
      t.shardNum != null ? t.shardNum : 0,
      t.realmNum != null ? t.realmNum : 0,
      t.tokenNum != null ? t.tokenNum : 0
    );
  }
  get checksum() {
    return this._checksum;
  }
  validate(t) {
    console.warn("Deprecated: Use `validateChecksum` instead"), this.validateChecksum(t);
  }
  validateChecksum(t) {
    validateChecksum(
      this.shard,
      this.realm,
      this.num,
      this._checksum,
      t
    );
  }
  static fromBytes(t) {
    return TokenId._fromProtobuf(
      lib.proto.TokenID.decode(t)
    );
  }
  static fromSolidityAddress(t) {
    return new TokenId(...fromSolidityAddress(t));
  }
  toSolidityAddress() {
    return toSolidityAddress([this.shard, this.realm, this.num]);
  }
  _toProtobuf() {
    return {
      tokenNum: this.num,
      shardNum: this.shard,
      realmNum: this.realm
    };
  }
  toString() {
    return `${this.shard.toString()}.${this.realm.toString()}.${this.num.toString()}`;
  }
  toStringWithChecksum(t) {
    return toStringWithChecksum(this.toString(), t);
  }
  toBytes() {
    return lib.proto.TokenID.encode(this._toProtobuf()).finish();
  }
  clone() {
    const t = new TokenId(this);
    return t._checksum = this._checksum, t;
  }
  compare(t) {
    return compare(
      [this.shard, this.realm, this.num],
      [t.shard, t.realm, t.num]
    );
  }
}
class ScheduleId {
  constructor(t, a, d) {
    const l = constructor(t, a, d);
    this.shard = l.shard, this.realm = l.realm, this.num = l.num, this._checksum = null;
  }
  static fromString(t) {
    const a = fromString(t), d = new ScheduleId(a);
    return d._checksum = a.checksum, d;
  }
  static _fromProtobuf(t) {
    return new ScheduleId(
      t.shardNum != null ? t.shardNum : 0,
      t.realmNum != null ? t.realmNum : 0,
      t.scheduleNum != null ? t.scheduleNum : 0
    );
  }
  get checksum() {
    return this._checksum;
  }
  validate(t) {
    console.warn("Deprecated: Use `validateChecksum` instead"), this.validateChecksum(t);
  }
  validateChecksum(t) {
    validateChecksum(
      this.shard,
      this.realm,
      this.num,
      this._checksum,
      t
    );
  }
  static fromBytes(t) {
    return ScheduleId._fromProtobuf(
      lib.proto.ScheduleID.decode(t)
    );
  }
  static fromSolidityAddress(t) {
    return new ScheduleId(...fromSolidityAddress(t));
  }
  toSolidityAddress() {
    return toSolidityAddress([this.shard, this.realm, this.num]);
  }
  _toProtobuf() {
    return {
      scheduleNum: this.num,
      shardNum: this.shard,
      realmNum: this.realm
    };
  }
  toString() {
    return `${this.shard.toString()}.${this.realm.toString()}.${this.num.toString()}`;
  }
  toStringWithChecksum(t) {
    return toStringWithChecksum(this.toString(), t);
  }
  toBytes() {
    return lib.proto.ScheduleID.encode(
      this._toProtobuf()
    ).finish();
  }
  clone() {
    const t = new ScheduleId(this);
    return t._checksum = this._checksum, t;
  }
  compare(t) {
    return compare(
      [this.shard, this.realm, this.num],
      [t.shard, t.realm, t.num]
    );
  }
}
class ExchangeRate {
  constructor(t) {
    this.hbars = t.hbars, this.cents = t.cents, this.expirationTime = t.expirationTime, this.exchangeRateInCents = t.cents / t.hbars, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    return new ExchangeRate({
      hbars: t.hbarEquiv,
      cents: t.centEquiv,
      expirationTime: new Date(
        t.expirationTime != null && t.expirationTime.seconds != null ? long.isLong(t.expirationTime.seconds) ? t.expirationTime.seconds.toInt() * 1e3 : t.expirationTime.seconds : 0
      )
    });
  }
  _toProtobuf() {
    return {
      hbarEquiv: this.hbars,
      centEquiv: this.cents,
      expirationTime: {
        seconds: long.fromNumber(
          Math.trunc(this.expirationTime.getTime() / 1e3)
        )
      }
    };
  }
}
class TransactionReceipt {
  constructor(t) {
    this.status = t.status, this.accountId = t.accountId, this.fileId = t.fileId, this.contractId = t.contractId, this.topicId = t.topicId, this.tokenId = t.tokenId, this.scheduleId = t.scheduleId, this.exchangeRate = t.exchangeRate, this.topicSequenceNumber = t.topicSequenceNumber, this.topicRunningHash = t.topicRunningHash, this.totalSupply = t.totalSupply, this.scheduledTransactionId = t.scheduledTransactionId, this.serials = t.serials, this.duplicates = t.duplicates, this.children = t.children, Object.freeze(this);
  }
  _toProtobuf() {
    const t = this.duplicates.map(
      (d) => d._toProtobuf().receipt
    ), a = this.children.map(
      (d) => d._toProtobuf().receipt
    );
    return {
      duplicateTransactionReceipts: t,
      childTransactionReceipts: a,
      receipt: {
        status: this.status.valueOf(),
        accountID: this.accountId != null ? this.accountId._toProtobuf() : null,
        fileID: this.fileId != null ? this.fileId._toProtobuf() : null,
        contractID: this.contractId != null ? this.contractId._toProtobuf() : null,
        topicID: this.topicId != null ? this.topicId._toProtobuf() : null,
        tokenID: this.tokenId != null ? this.tokenId._toProtobuf() : null,
        scheduleID: this.scheduleId != null ? this.scheduleId._toProtobuf() : null,
        topicRunningHash: this.topicRunningHash == null ? null : this.topicRunningHash,
        topicSequenceNumber: this.topicSequenceNumber,
        exchangeRate: {
          nextRate: null,
          currentRate: this.exchangeRate != null ? this.exchangeRate._toProtobuf() : null
        },
        scheduledTransactionID: this.scheduledTransactionId != null ? this.scheduledTransactionId._toProtobuf() : null,
        serialNumbers: this.serials,
        newTotalSupply: this.totalSupply
      }
    };
  }
  static _fromProtobuf(t) {
    const a = t.receipt, d = a.exchangeRate, l = t.childTransactionReceipts != null ? t.childTransactionReceipts.map(
      (g) => TransactionReceipt._fromProtobuf({ receipt: g })
    ) : [], h = t.duplicateTransactionReceipts != null ? t.duplicateTransactionReceipts.map(
      (g) => TransactionReceipt._fromProtobuf({ receipt: g })
    ) : [];
    return new TransactionReceipt({
      status: Status._fromCode(
        a.status != null ? a.status : 0
      ),
      accountId: a.accountID != null ? AccountId._fromProtobuf(a.accountID) : null,
      fileId: a.fileID != null ? FileId._fromProtobuf(a.fileID) : null,
      contractId: a.contractID != null ? ContractId._fromProtobuf(a.contractID) : null,
      topicId: a.topicID != null ? TopicId._fromProtobuf(a.topicID) : null,
      tokenId: a.tokenID != null ? TokenId._fromProtobuf(a.tokenID) : null,
      scheduleId: a.scheduleID != null ? ScheduleId._fromProtobuf(a.scheduleID) : null,
      exchangeRate: a.exchangeRate != null ? ExchangeRate._fromProtobuf(
        d.currentRate
      ) : null,
      topicSequenceNumber: a.topicSequenceNumber == null ? null : long.fromString(a.topicSequenceNumber.toString()),
      topicRunningHash: a.topicRunningHash != null ? new Uint8Array(a.topicRunningHash) : null,
      totalSupply: a.newTotalSupply != null ? long.fromString(a.newTotalSupply.toString()) : null,
      scheduledTransactionId: a.scheduledTransactionID != null ? TransactionId._fromProtobuf(
        a.scheduledTransactionID
      ) : null,
      serials: a.serialNumbers != null ? a.serialNumbers.map(
        (g) => long.fromValue(g)
      ) : [],
      children: l,
      duplicates: h
    });
  }
  static fromBytes(t) {
    return TransactionReceipt._fromProtobuf(
      lib.proto.TransactionGetReceiptResponse.decode(t)
    );
  }
  toBytes() {
    return lib.proto.TransactionGetReceiptResponse.encode(
      this._toProtobuf()
    ).finish();
  }
}
const { proto: proto$4 } = HashgraphProto;
class TransactionReceiptQuery extends Query {
  constructor(t = {}) {
    super(), this._transactionId = null, this._includeChildren = null, this._includeDuplicates = null, this._validateStatus = !0, t.transactionId != null && this.setTransactionId(t.transactionId), t.includeChildren != null && this.setIncludeChildren(t.includeChildren), t.includeDuplicates != null && this.setIncludeDuplicates(t.includeDuplicates), t.validateStatus != null && this.setValidateStatus(t.validateStatus);
  }
  static _fromProtobuf(t) {
    const a = t.transactionGetReceipt;
    return new TransactionReceiptQuery({
      transactionId: a.transactionID ? TransactionId._fromProtobuf(a.transactionID) : void 0,
      includeDuplicates: a.includeDuplicates != null ? a.includeDuplicates : void 0,
      includeChildren: a.includeChildReceipts != null ? a.includeChildReceipts : void 0
    });
  }
  get transactionId() {
    return this._transactionId;
  }
  setTransactionId(t) {
    return this._transactionId = typeof t == "string" ? TransactionId.fromString(t) : t.clone(), this;
  }
  setIncludeDuplicates(t) {
    return this._includeDuplicates = t, this;
  }
  get includeDuplicates() {
    return this._includeDuplicates != null ? this._includeDuplicates : !1;
  }
  setIncludeChildren(t) {
    return this._includeChildren = t, this;
  }
  get includeChildren() {
    return this._includeChildren != null ? this._includeChildren : !1;
  }
  setValidateStatus(t) {
    return this._validateStatus = t, this;
  }
  get validateStatus() {
    return this._validateStatus;
  }
  _isPaymentRequired() {
    return !1;
  }
  _shouldRetry(t, a) {
    const { nodeTransactionPrecheckCode: d } = this._mapResponseHeader(a);
    let l = Status._fromCode(
      d != null ? d : proto$4.ResponseCodeEnum.OK
    );
    switch (this._logger && this._logger.debug(
      `[${this._getLogId()}] received node precheck status ${l.toString()}`
    ), l) {
      case Status.Busy:
      case Status.Unknown:
      case Status.ReceiptNotFound:
        return [l, ExecutionState.Retry];
      case Status.Ok:
        break;
      default:
        return [l, ExecutionState.Error];
    }
    const c = a.transactionGetReceipt.receipt.status;
    switch (l = Status._fromCode(c), this._logger && this._logger.debug(
      `[${this._getLogId()}] received receipt status ${l.toString()}`
    ), l) {
      case Status.Busy:
      case Status.Unknown:
      case Status.ReceiptNotFound:
        return [l, ExecutionState.Retry];
      case Status.Success:
        return [l, ExecutionState.Finished];
      default:
        return [
          l,
          this._validateStatus ? ExecutionState.Error : ExecutionState.Finished
        ];
    }
  }
  _getTransactionId() {
    return this._transactionId != null ? this._transactionId : super._getTransactionId();
  }
  _mapStatusError(t, a) {
    const { nodeTransactionPrecheckCode: d } = this._mapResponseHeader(a);
    let l = Status._fromCode(
      d != null ? d : proto$4.ResponseCodeEnum.OK
    );
    switch (l) {
      case Status.Ok:
        break;
      default:
        return new PrecheckStatusError({
          status: l,
          transactionId: this._getTransactionId(),
          contractFunctionResult: null
        });
    }
    const h = a.transactionGetReceipt, c = h.receipt.status;
    if (l = Status._fromCode(c), this._transactionId == null)
      throw new Error(
        "Failed to construct `ReceiptStatusError` because `transactionId` is `null`"
      );
    return new ReceiptStatusError({
      status: l,
      transactionId: this._transactionId,
      transactionReceipt: TransactionReceipt._fromProtobuf(
        h
      )
    });
  }
  _validateChecksums(t) {
    this._transactionId != null && this._transactionId.accountId != null && this._transactionId.accountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.crypto.getTransactionReceipts(a);
  }
  _mapResponseHeader(t) {
    return t.transactionGetReceipt.header;
  }
  _mapResponse(t, a, d) {
    const l = t.transactionGetReceipt;
    return Promise.resolve(
      TransactionReceipt._fromProtobuf(l)
    );
  }
  _onMakeRequest(t) {
    return {
      transactionGetReceipt: {
        header: t,
        transactionID: this._transactionId != null ? this._transactionId._toProtobuf() : null,
        includeDuplicates: this._includeDuplicates,
        includeChildReceipts: this._includeChildren
      }
    };
  }
  _getLogId() {
    return `TransactionReceiptQuery:${this._timestamp.toString()}`;
  }
}
QUERY_REGISTRY.set(
  "transactionGetReceipt",
  TransactionReceiptQuery._fromProtobuf
);
class Transfer {
  constructor(t) {
    this.accountId = t.accountId instanceof AccountId ? t.accountId : AccountId.fromString(t.accountId), this.amount = t.amount instanceof Hbar ? t.amount : new Hbar(t.amount), this.isApproved = t.isApproved;
  }
  static _fromProtobuf(t) {
    const a = [];
    for (const d of t)
      a.push(
        new Transfer({
          accountId: AccountId._fromProtobuf(
            d.accountID
          ),
          amount: Hbar.fromTinybars(
            d.amount != null ? d.amount : 0
          ),
          isApproved: d.isApproval
        })
      );
    return a;
  }
  _toProtobuf() {
    return {
      accountID: this.accountId._toProtobuf(),
      amount: this.amount.toTinybars(),
      isApproval: this.isApproved
    };
  }
}
class ContractLogInfo {
  constructor(t) {
    this.contractId = t.contractId, this.bloom = t.bloom, this.topics = t.topics, this.data = t.data, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    return new ContractLogInfo({
      contractId: ContractId._fromProtobuf(
        t.contractID
      ),
      bloom: t.bloom != null ? t.bloom : new Uint8Array(),
      topics: t.topic != null ? t.topic : [],
      data: t.data != null ? t.data : new Uint8Array()
    });
  }
  _toProtobuf() {
    return {
      contractID: this.contractId._toProtobuf(),
      bloom: this.bloom,
      topic: this.topics,
      data: this.data
    };
  }
}
function decode$1(u) {
  return new TextDecoder().decode(u);
}
function encode$1(u) {
  return new TextEncoder().encode(u);
}
var bn = { exports: {} };
(function(u) {
  (function(t, a) {
    function d(T, p) {
      if (!T)
        throw new Error(p || "Assertion failed");
    }
    function l(T, p) {
      T.super_ = p;
      var b = function() {
      };
      b.prototype = p.prototype, T.prototype = new b(), T.prototype.constructor = T;
    }
    function h(T, p, b) {
      if (h.isBN(T))
        return T;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, T !== null && ((p === "le" || p === "be") && (b = p, p = 10), this._init(T || 0, p || 10, b || "be"));
    }
    typeof t == "object" ? t.exports = h : a.BN = h, h.BN = h, h.wordSize = 26;
    var g;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? g = window.Buffer : g = require$$0$1.Buffer;
    } catch {
    }
    h.isBN = function(p) {
      return p instanceof h ? !0 : p !== null && typeof p == "object" && p.constructor.wordSize === h.wordSize && Array.isArray(p.words);
    }, h.max = function(p, b) {
      return p.cmp(b) > 0 ? p : b;
    }, h.min = function(p, b) {
      return p.cmp(b) < 0 ? p : b;
    }, h.prototype._init = function(p, b, _) {
      if (typeof p == "number")
        return this._initNumber(p, b, _);
      if (typeof p == "object")
        return this._initArray(p, b, _);
      b === "hex" && (b = 16), d(b === (b | 0) && b >= 2 && b <= 36), p = p.toString().replace(/\s+/g, "");
      var v = 0;
      p[0] === "-" && (v++, this.negative = 1), v < p.length && (b === 16 ? this._parseHex(p, v, _) : (this._parseBase(p, b, v), _ === "le" && this._initArray(this.toArray(), b, _)));
    }, h.prototype._initNumber = function(p, b, _) {
      p < 0 && (this.negative = 1, p = -p), p < 67108864 ? (this.words = [p & 67108863], this.length = 1) : p < 4503599627370496 ? (this.words = [
        p & 67108863,
        p / 67108864 & 67108863
      ], this.length = 2) : (d(p < 9007199254740992), this.words = [
        p & 67108863,
        p / 67108864 & 67108863,
        1
      ], this.length = 3), _ === "le" && this._initArray(this.toArray(), b, _);
    }, h.prototype._initArray = function(p, b, _) {
      if (d(typeof p.length == "number"), p.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(p.length / 3), this.words = new Array(this.length);
      for (var v = 0; v < this.length; v++)
        this.words[v] = 0;
      var S, E, w = 0;
      if (_ === "be")
        for (v = p.length - 1, S = 0; v >= 0; v -= 3)
          E = p[v] | p[v - 1] << 8 | p[v - 2] << 16, this.words[S] |= E << w & 67108863, this.words[S + 1] = E >>> 26 - w & 67108863, w += 24, w >= 26 && (w -= 26, S++);
      else if (_ === "le")
        for (v = 0, S = 0; v < p.length; v += 3)
          E = p[v] | p[v + 1] << 8 | p[v + 2] << 16, this.words[S] |= E << w & 67108863, this.words[S + 1] = E >>> 26 - w & 67108863, w += 24, w >= 26 && (w -= 26, S++);
      return this._strip();
    };
    function c(T, p) {
      var b = T.charCodeAt(p);
      if (b >= 48 && b <= 57)
        return b - 48;
      if (b >= 65 && b <= 70)
        return b - 55;
      if (b >= 97 && b <= 102)
        return b - 87;
      d(!1, "Invalid character in " + T);
    }
    function x(T, p, b) {
      var _ = c(T, b);
      return b - 1 >= p && (_ |= c(T, b - 1) << 4), _;
    }
    h.prototype._parseHex = function(p, b, _) {
      this.length = Math.ceil((p.length - b) / 6), this.words = new Array(this.length);
      for (var v = 0; v < this.length; v++)
        this.words[v] = 0;
      var S = 0, E = 0, w;
      if (_ === "be")
        for (v = p.length - 1; v >= b; v -= 2)
          w = x(p, b, v) << S, this.words[E] |= w & 67108863, S >= 18 ? (S -= 18, E += 1, this.words[E] |= w >>> 26) : S += 8;
      else {
        var A = p.length - b;
        for (v = A % 2 === 0 ? b + 1 : b; v < p.length; v += 2)
          w = x(p, b, v) << S, this.words[E] |= w & 67108863, S >= 18 ? (S -= 18, E += 1, this.words[E] |= w >>> 26) : S += 8;
      }
      this._strip();
    };
    function R(T, p, b, _) {
      for (var v = 0, S = 0, E = Math.min(T.length, b), w = p; w < E; w++) {
        var A = T.charCodeAt(w) - 48;
        v *= _, A >= 49 ? S = A - 49 + 10 : A >= 17 ? S = A - 17 + 10 : S = A, d(A >= 0 && S < _, "Invalid character"), v += S;
      }
      return v;
    }
    h.prototype._parseBase = function(p, b, _) {
      this.words = [0], this.length = 1;
      for (var v = 0, S = 1; S <= 67108863; S *= b)
        v++;
      v--, S = S / b | 0;
      for (var E = p.length - _, w = E % v, A = Math.min(E, E - w) + _, I = 0, C = _; C < A; C += v)
        I = R(p, C, C + v, b), this.imuln(S), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
      if (w !== 0) {
        var X = 1;
        for (I = R(p, C, p.length, b), C = 0; C < w; C++)
          X *= b;
        this.imuln(X), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
      }
      this._strip();
    }, h.prototype.copy = function(p) {
      p.words = new Array(this.length);
      for (var b = 0; b < this.length; b++)
        p.words[b] = this.words[b];
      p.length = this.length, p.negative = this.negative, p.red = this.red;
    };
    function B(T, p) {
      T.words = p.words, T.length = p.length, T.negative = p.negative, T.red = p.red;
    }
    if (h.prototype._move = function(p) {
      B(p, this);
    }, h.prototype.clone = function() {
      var p = new h(null);
      return this.copy(p), p;
    }, h.prototype._expand = function(p) {
      for (; this.length < p; )
        this.words[this.length++] = 0;
      return this;
    }, h.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, h.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        h.prototype[Symbol.for("nodejs.util.inspect.custom")] = j;
      } catch {
        h.prototype.inspect = j;
      }
    else
      h.prototype.inspect = j;
    function j() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var o = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], e = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], n = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    h.prototype.toString = function(p, b) {
      p = p || 10, b = b | 0 || 1;
      var _;
      if (p === 16 || p === "hex") {
        _ = "";
        for (var v = 0, S = 0, E = 0; E < this.length; E++) {
          var w = this.words[E], A = ((w << v | S) & 16777215).toString(16);
          S = w >>> 24 - v & 16777215, v += 2, v >= 26 && (v -= 26, E--), S !== 0 || E !== this.length - 1 ? _ = o[6 - A.length] + A + _ : _ = A + _;
        }
        for (S !== 0 && (_ = S.toString(16) + _); _.length % b !== 0; )
          _ = "0" + _;
        return this.negative !== 0 && (_ = "-" + _), _;
      }
      if (p === (p | 0) && p >= 2 && p <= 36) {
        var I = e[p], C = n[p];
        _ = "";
        var X = this.clone();
        for (X.negative = 0; !X.isZero(); ) {
          var D = X.modrn(C).toString(p);
          X = X.idivn(C), X.isZero() ? _ = D + _ : _ = o[I - D.length] + D + _;
        }
        for (this.isZero() && (_ = "0" + _); _.length % b !== 0; )
          _ = "0" + _;
        return this.negative !== 0 && (_ = "-" + _), _;
      }
      d(!1, "Base should be between 2 and 36");
    }, h.prototype.toNumber = function() {
      var p = this.words[0];
      return this.length === 2 ? p += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? p += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && d(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -p : p;
    }, h.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, g && (h.prototype.toBuffer = function(p, b) {
      return this.toArrayLike(g, p, b);
    }), h.prototype.toArray = function(p, b) {
      return this.toArrayLike(Array, p, b);
    };
    var i = function(p, b) {
      return p.allocUnsafe ? p.allocUnsafe(b) : new p(b);
    };
    h.prototype.toArrayLike = function(p, b, _) {
      this._strip();
      var v = this.byteLength(), S = _ || Math.max(1, v);
      d(v <= S, "byte array longer than desired length"), d(S > 0, "Requested array length <= 0");
      var E = i(p, S), w = b === "le" ? "LE" : "BE";
      return this["_toArrayLike" + w](E, v), E;
    }, h.prototype._toArrayLikeLE = function(p, b) {
      for (var _ = 0, v = 0, S = 0, E = 0; S < this.length; S++) {
        var w = this.words[S] << E | v;
        p[_++] = w & 255, _ < p.length && (p[_++] = w >> 8 & 255), _ < p.length && (p[_++] = w >> 16 & 255), E === 6 ? (_ < p.length && (p[_++] = w >> 24 & 255), v = 0, E = 0) : (v = w >>> 24, E += 2);
      }
      if (_ < p.length)
        for (p[_++] = v; _ < p.length; )
          p[_++] = 0;
    }, h.prototype._toArrayLikeBE = function(p, b) {
      for (var _ = p.length - 1, v = 0, S = 0, E = 0; S < this.length; S++) {
        var w = this.words[S] << E | v;
        p[_--] = w & 255, _ >= 0 && (p[_--] = w >> 8 & 255), _ >= 0 && (p[_--] = w >> 16 & 255), E === 6 ? (_ >= 0 && (p[_--] = w >> 24 & 255), v = 0, E = 0) : (v = w >>> 24, E += 2);
      }
      if (_ >= 0)
        for (p[_--] = v; _ >= 0; )
          p[_--] = 0;
    }, Math.clz32 ? h.prototype._countBits = function(p) {
      return 32 - Math.clz32(p);
    } : h.prototype._countBits = function(p) {
      var b = p, _ = 0;
      return b >= 4096 && (_ += 13, b >>>= 13), b >= 64 && (_ += 7, b >>>= 7), b >= 8 && (_ += 4, b >>>= 4), b >= 2 && (_ += 2, b >>>= 2), _ + b;
    }, h.prototype._zeroBits = function(p) {
      if (p === 0)
        return 26;
      var b = p, _ = 0;
      return (b & 8191) === 0 && (_ += 13, b >>>= 13), (b & 127) === 0 && (_ += 7, b >>>= 7), (b & 15) === 0 && (_ += 4, b >>>= 4), (b & 3) === 0 && (_ += 2, b >>>= 2), (b & 1) === 0 && _++, _;
    }, h.prototype.bitLength = function() {
      var p = this.words[this.length - 1], b = this._countBits(p);
      return (this.length - 1) * 26 + b;
    };
    function y(T) {
      for (var p = new Array(T.bitLength()), b = 0; b < p.length; b++) {
        var _ = b / 26 | 0, v = b % 26;
        p[b] = T.words[_] >>> v & 1;
      }
      return p;
    }
    h.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var p = 0, b = 0; b < this.length; b++) {
        var _ = this._zeroBits(this.words[b]);
        if (p += _, _ !== 26)
          break;
      }
      return p;
    }, h.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, h.prototype.toTwos = function(p) {
      return this.negative !== 0 ? this.abs().inotn(p).iaddn(1) : this.clone();
    }, h.prototype.fromTwos = function(p) {
      return this.testn(p - 1) ? this.notn(p).iaddn(1).ineg() : this.clone();
    }, h.prototype.isNeg = function() {
      return this.negative !== 0;
    }, h.prototype.neg = function() {
      return this.clone().ineg();
    }, h.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, h.prototype.iuor = function(p) {
      for (; this.length < p.length; )
        this.words[this.length++] = 0;
      for (var b = 0; b < p.length; b++)
        this.words[b] = this.words[b] | p.words[b];
      return this._strip();
    }, h.prototype.ior = function(p) {
      return d((this.negative | p.negative) === 0), this.iuor(p);
    }, h.prototype.or = function(p) {
      return this.length > p.length ? this.clone().ior(p) : p.clone().ior(this);
    }, h.prototype.uor = function(p) {
      return this.length > p.length ? this.clone().iuor(p) : p.clone().iuor(this);
    }, h.prototype.iuand = function(p) {
      var b;
      this.length > p.length ? b = p : b = this;
      for (var _ = 0; _ < b.length; _++)
        this.words[_] = this.words[_] & p.words[_];
      return this.length = b.length, this._strip();
    }, h.prototype.iand = function(p) {
      return d((this.negative | p.negative) === 0), this.iuand(p);
    }, h.prototype.and = function(p) {
      return this.length > p.length ? this.clone().iand(p) : p.clone().iand(this);
    }, h.prototype.uand = function(p) {
      return this.length > p.length ? this.clone().iuand(p) : p.clone().iuand(this);
    }, h.prototype.iuxor = function(p) {
      var b, _;
      this.length > p.length ? (b = this, _ = p) : (b = p, _ = this);
      for (var v = 0; v < _.length; v++)
        this.words[v] = b.words[v] ^ _.words[v];
      if (this !== b)
        for (; v < b.length; v++)
          this.words[v] = b.words[v];
      return this.length = b.length, this._strip();
    }, h.prototype.ixor = function(p) {
      return d((this.negative | p.negative) === 0), this.iuxor(p);
    }, h.prototype.xor = function(p) {
      return this.length > p.length ? this.clone().ixor(p) : p.clone().ixor(this);
    }, h.prototype.uxor = function(p) {
      return this.length > p.length ? this.clone().iuxor(p) : p.clone().iuxor(this);
    }, h.prototype.inotn = function(p) {
      d(typeof p == "number" && p >= 0);
      var b = Math.ceil(p / 26) | 0, _ = p % 26;
      this._expand(b), _ > 0 && b--;
      for (var v = 0; v < b; v++)
        this.words[v] = ~this.words[v] & 67108863;
      return _ > 0 && (this.words[v] = ~this.words[v] & 67108863 >> 26 - _), this._strip();
    }, h.prototype.notn = function(p) {
      return this.clone().inotn(p);
    }, h.prototype.setn = function(p, b) {
      d(typeof p == "number" && p >= 0);
      var _ = p / 26 | 0, v = p % 26;
      return this._expand(_ + 1), b ? this.words[_] = this.words[_] | 1 << v : this.words[_] = this.words[_] & ~(1 << v), this._strip();
    }, h.prototype.iadd = function(p) {
      var b;
      if (this.negative !== 0 && p.negative === 0)
        return this.negative = 0, b = this.isub(p), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && p.negative !== 0)
        return p.negative = 0, b = this.isub(p), p.negative = 1, b._normSign();
      var _, v;
      this.length > p.length ? (_ = this, v = p) : (_ = p, v = this);
      for (var S = 0, E = 0; E < v.length; E++)
        b = (_.words[E] | 0) + (v.words[E] | 0) + S, this.words[E] = b & 67108863, S = b >>> 26;
      for (; S !== 0 && E < _.length; E++)
        b = (_.words[E] | 0) + S, this.words[E] = b & 67108863, S = b >>> 26;
      if (this.length = _.length, S !== 0)
        this.words[this.length] = S, this.length++;
      else if (_ !== this)
        for (; E < _.length; E++)
          this.words[E] = _.words[E];
      return this;
    }, h.prototype.add = function(p) {
      var b;
      return p.negative !== 0 && this.negative === 0 ? (p.negative = 0, b = this.sub(p), p.negative ^= 1, b) : p.negative === 0 && this.negative !== 0 ? (this.negative = 0, b = p.sub(this), this.negative = 1, b) : this.length > p.length ? this.clone().iadd(p) : p.clone().iadd(this);
    }, h.prototype.isub = function(p) {
      if (p.negative !== 0) {
        p.negative = 0;
        var b = this.iadd(p);
        return p.negative = 1, b._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(p), this.negative = 1, this._normSign();
      var _ = this.cmp(p);
      if (_ === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var v, S;
      _ > 0 ? (v = this, S = p) : (v = p, S = this);
      for (var E = 0, w = 0; w < S.length; w++)
        b = (v.words[w] | 0) - (S.words[w] | 0) + E, E = b >> 26, this.words[w] = b & 67108863;
      for (; E !== 0 && w < v.length; w++)
        b = (v.words[w] | 0) + E, E = b >> 26, this.words[w] = b & 67108863;
      if (E === 0 && w < v.length && v !== this)
        for (; w < v.length; w++)
          this.words[w] = v.words[w];
      return this.length = Math.max(this.length, w), v !== this && (this.negative = 1), this._strip();
    }, h.prototype.sub = function(p) {
      return this.clone().isub(p);
    };
    function m(T, p, b) {
      b.negative = p.negative ^ T.negative;
      var _ = T.length + p.length | 0;
      b.length = _, _ = _ - 1 | 0;
      var v = T.words[0] | 0, S = p.words[0] | 0, E = v * S, w = E & 67108863, A = E / 67108864 | 0;
      b.words[0] = w;
      for (var I = 1; I < _; I++) {
        for (var C = A >>> 26, X = A & 67108863, D = Math.min(I, p.length - 1), V = Math.max(0, I - T.length + 1); V <= D; V++) {
          var Z = I - V | 0;
          v = T.words[Z] | 0, S = p.words[V] | 0, E = v * S + X, C += E / 67108864 | 0, X = E & 67108863;
        }
        b.words[I] = X | 0, A = C | 0;
      }
      return A !== 0 ? b.words[I] = A | 0 : b.length--, b._strip();
    }
    var U = function(p, b, _) {
      var v = p.words, S = b.words, E = _.words, w = 0, A, I, C, X = v[0] | 0, D = X & 8191, V = X >>> 13, Z = v[1] | 0, J = Z & 8191, ee = Z >>> 13, he = v[2] | 0, le = he & 8191, ie = he >>> 13, Ne = v[3] | 0, ue = Ne & 8191, se = Ne >>> 13, ut = v[4] | 0, qe = ut & 8191, ve = ut >>> 13, ot = v[5] | 0, He = ot & 8191, Ae = ot >>> 13, ct = v[6] | 0, Ve = ct & 8191, _e = ct >>> 13, lt = v[7] | 0, je = lt & 8191, me = lt >>> 13, _t = v[8] | 0, tt = _t & 8191, Le = _t >>> 13, mt = v[9] | 0, rt = mt & 8191, De = mt >>> 13, gt = S[0] | 0, Ze = gt & 8191, Ce = gt >>> 13, It = S[1] | 0, et = It & 8191, Ee = It >>> 13, Tt = S[2] | 0, Xe = Tt & 8191, Fe = Tt >>> 13, wt = S[3] | 0, We = wt & 8191, Oe = wt >>> 13, ht = S[4] | 0, nt = ht & 8191, Me = ht >>> 13, vt = S[5] | 0, at = vt & 8191, ke = vt >>> 13, kt = S[6] | 0, M = kt & 8191, L = kt >>> 13, $ = S[7] | 0, O = $ & 8191, P = $ >>> 13, H = S[8] | 0, q = H & 8191, Q = H >>> 13, re = S[9] | 0, ae = re & 8191, te = re >>> 13;
      _.negative = p.negative ^ b.negative, _.length = 19, A = Math.imul(D, Ze), I = Math.imul(D, Ce), I = I + Math.imul(V, Ze) | 0, C = Math.imul(V, Ce);
      var ge = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, A = Math.imul(J, Ze), I = Math.imul(J, Ce), I = I + Math.imul(ee, Ze) | 0, C = Math.imul(ee, Ce), A = A + Math.imul(D, et) | 0, I = I + Math.imul(D, Ee) | 0, I = I + Math.imul(V, et) | 0, C = C + Math.imul(V, Ee) | 0;
      var pe = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (pe >>> 26) | 0, pe &= 67108863, A = Math.imul(le, Ze), I = Math.imul(le, Ce), I = I + Math.imul(ie, Ze) | 0, C = Math.imul(ie, Ce), A = A + Math.imul(J, et) | 0, I = I + Math.imul(J, Ee) | 0, I = I + Math.imul(ee, et) | 0, C = C + Math.imul(ee, Ee) | 0, A = A + Math.imul(D, Xe) | 0, I = I + Math.imul(D, Fe) | 0, I = I + Math.imul(V, Xe) | 0, C = C + Math.imul(V, Fe) | 0;
      var Ie = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, A = Math.imul(ue, Ze), I = Math.imul(ue, Ce), I = I + Math.imul(se, Ze) | 0, C = Math.imul(se, Ce), A = A + Math.imul(le, et) | 0, I = I + Math.imul(le, Ee) | 0, I = I + Math.imul(ie, et) | 0, C = C + Math.imul(ie, Ee) | 0, A = A + Math.imul(J, Xe) | 0, I = I + Math.imul(J, Fe) | 0, I = I + Math.imul(ee, Xe) | 0, C = C + Math.imul(ee, Fe) | 0, A = A + Math.imul(D, We) | 0, I = I + Math.imul(D, Oe) | 0, I = I + Math.imul(V, We) | 0, C = C + Math.imul(V, Oe) | 0;
      var we = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, A = Math.imul(qe, Ze), I = Math.imul(qe, Ce), I = I + Math.imul(ve, Ze) | 0, C = Math.imul(ve, Ce), A = A + Math.imul(ue, et) | 0, I = I + Math.imul(ue, Ee) | 0, I = I + Math.imul(se, et) | 0, C = C + Math.imul(se, Ee) | 0, A = A + Math.imul(le, Xe) | 0, I = I + Math.imul(le, Fe) | 0, I = I + Math.imul(ie, Xe) | 0, C = C + Math.imul(ie, Fe) | 0, A = A + Math.imul(J, We) | 0, I = I + Math.imul(J, Oe) | 0, I = I + Math.imul(ee, We) | 0, C = C + Math.imul(ee, Oe) | 0, A = A + Math.imul(D, nt) | 0, I = I + Math.imul(D, Me) | 0, I = I + Math.imul(V, nt) | 0, C = C + Math.imul(V, Me) | 0;
      var Ue = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Ue >>> 26) | 0, Ue &= 67108863, A = Math.imul(He, Ze), I = Math.imul(He, Ce), I = I + Math.imul(Ae, Ze) | 0, C = Math.imul(Ae, Ce), A = A + Math.imul(qe, et) | 0, I = I + Math.imul(qe, Ee) | 0, I = I + Math.imul(ve, et) | 0, C = C + Math.imul(ve, Ee) | 0, A = A + Math.imul(ue, Xe) | 0, I = I + Math.imul(ue, Fe) | 0, I = I + Math.imul(se, Xe) | 0, C = C + Math.imul(se, Fe) | 0, A = A + Math.imul(le, We) | 0, I = I + Math.imul(le, Oe) | 0, I = I + Math.imul(ie, We) | 0, C = C + Math.imul(ie, Oe) | 0, A = A + Math.imul(J, nt) | 0, I = I + Math.imul(J, Me) | 0, I = I + Math.imul(ee, nt) | 0, C = C + Math.imul(ee, Me) | 0, A = A + Math.imul(D, at) | 0, I = I + Math.imul(D, ke) | 0, I = I + Math.imul(V, at) | 0, C = C + Math.imul(V, ke) | 0;
      var Ye = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Ye >>> 26) | 0, Ye &= 67108863, A = Math.imul(Ve, Ze), I = Math.imul(Ve, Ce), I = I + Math.imul(_e, Ze) | 0, C = Math.imul(_e, Ce), A = A + Math.imul(He, et) | 0, I = I + Math.imul(He, Ee) | 0, I = I + Math.imul(Ae, et) | 0, C = C + Math.imul(Ae, Ee) | 0, A = A + Math.imul(qe, Xe) | 0, I = I + Math.imul(qe, Fe) | 0, I = I + Math.imul(ve, Xe) | 0, C = C + Math.imul(ve, Fe) | 0, A = A + Math.imul(ue, We) | 0, I = I + Math.imul(ue, Oe) | 0, I = I + Math.imul(se, We) | 0, C = C + Math.imul(se, Oe) | 0, A = A + Math.imul(le, nt) | 0, I = I + Math.imul(le, Me) | 0, I = I + Math.imul(ie, nt) | 0, C = C + Math.imul(ie, Me) | 0, A = A + Math.imul(J, at) | 0, I = I + Math.imul(J, ke) | 0, I = I + Math.imul(ee, at) | 0, C = C + Math.imul(ee, ke) | 0, A = A + Math.imul(D, M) | 0, I = I + Math.imul(D, L) | 0, I = I + Math.imul(V, M) | 0, C = C + Math.imul(V, L) | 0;
      var Qe = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Qe >>> 26) | 0, Qe &= 67108863, A = Math.imul(je, Ze), I = Math.imul(je, Ce), I = I + Math.imul(me, Ze) | 0, C = Math.imul(me, Ce), A = A + Math.imul(Ve, et) | 0, I = I + Math.imul(Ve, Ee) | 0, I = I + Math.imul(_e, et) | 0, C = C + Math.imul(_e, Ee) | 0, A = A + Math.imul(He, Xe) | 0, I = I + Math.imul(He, Fe) | 0, I = I + Math.imul(Ae, Xe) | 0, C = C + Math.imul(Ae, Fe) | 0, A = A + Math.imul(qe, We) | 0, I = I + Math.imul(qe, Oe) | 0, I = I + Math.imul(ve, We) | 0, C = C + Math.imul(ve, Oe) | 0, A = A + Math.imul(ue, nt) | 0, I = I + Math.imul(ue, Me) | 0, I = I + Math.imul(se, nt) | 0, C = C + Math.imul(se, Me) | 0, A = A + Math.imul(le, at) | 0, I = I + Math.imul(le, ke) | 0, I = I + Math.imul(ie, at) | 0, C = C + Math.imul(ie, ke) | 0, A = A + Math.imul(J, M) | 0, I = I + Math.imul(J, L) | 0, I = I + Math.imul(ee, M) | 0, C = C + Math.imul(ee, L) | 0, A = A + Math.imul(D, O) | 0, I = I + Math.imul(D, P) | 0, I = I + Math.imul(V, O) | 0, C = C + Math.imul(V, P) | 0;
      var Ge = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Ge >>> 26) | 0, Ge &= 67108863, A = Math.imul(tt, Ze), I = Math.imul(tt, Ce), I = I + Math.imul(Le, Ze) | 0, C = Math.imul(Le, Ce), A = A + Math.imul(je, et) | 0, I = I + Math.imul(je, Ee) | 0, I = I + Math.imul(me, et) | 0, C = C + Math.imul(me, Ee) | 0, A = A + Math.imul(Ve, Xe) | 0, I = I + Math.imul(Ve, Fe) | 0, I = I + Math.imul(_e, Xe) | 0, C = C + Math.imul(_e, Fe) | 0, A = A + Math.imul(He, We) | 0, I = I + Math.imul(He, Oe) | 0, I = I + Math.imul(Ae, We) | 0, C = C + Math.imul(Ae, Oe) | 0, A = A + Math.imul(qe, nt) | 0, I = I + Math.imul(qe, Me) | 0, I = I + Math.imul(ve, nt) | 0, C = C + Math.imul(ve, Me) | 0, A = A + Math.imul(ue, at) | 0, I = I + Math.imul(ue, ke) | 0, I = I + Math.imul(se, at) | 0, C = C + Math.imul(se, ke) | 0, A = A + Math.imul(le, M) | 0, I = I + Math.imul(le, L) | 0, I = I + Math.imul(ie, M) | 0, C = C + Math.imul(ie, L) | 0, A = A + Math.imul(J, O) | 0, I = I + Math.imul(J, P) | 0, I = I + Math.imul(ee, O) | 0, C = C + Math.imul(ee, P) | 0, A = A + Math.imul(D, q) | 0, I = I + Math.imul(D, Q) | 0, I = I + Math.imul(V, q) | 0, C = C + Math.imul(V, Q) | 0;
      var Je = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Je >>> 26) | 0, Je &= 67108863, A = Math.imul(rt, Ze), I = Math.imul(rt, Ce), I = I + Math.imul(De, Ze) | 0, C = Math.imul(De, Ce), A = A + Math.imul(tt, et) | 0, I = I + Math.imul(tt, Ee) | 0, I = I + Math.imul(Le, et) | 0, C = C + Math.imul(Le, Ee) | 0, A = A + Math.imul(je, Xe) | 0, I = I + Math.imul(je, Fe) | 0, I = I + Math.imul(me, Xe) | 0, C = C + Math.imul(me, Fe) | 0, A = A + Math.imul(Ve, We) | 0, I = I + Math.imul(Ve, Oe) | 0, I = I + Math.imul(_e, We) | 0, C = C + Math.imul(_e, Oe) | 0, A = A + Math.imul(He, nt) | 0, I = I + Math.imul(He, Me) | 0, I = I + Math.imul(Ae, nt) | 0, C = C + Math.imul(Ae, Me) | 0, A = A + Math.imul(qe, at) | 0, I = I + Math.imul(qe, ke) | 0, I = I + Math.imul(ve, at) | 0, C = C + Math.imul(ve, ke) | 0, A = A + Math.imul(ue, M) | 0, I = I + Math.imul(ue, L) | 0, I = I + Math.imul(se, M) | 0, C = C + Math.imul(se, L) | 0, A = A + Math.imul(le, O) | 0, I = I + Math.imul(le, P) | 0, I = I + Math.imul(ie, O) | 0, C = C + Math.imul(ie, P) | 0, A = A + Math.imul(J, q) | 0, I = I + Math.imul(J, Q) | 0, I = I + Math.imul(ee, q) | 0, C = C + Math.imul(ee, Q) | 0, A = A + Math.imul(D, ae) | 0, I = I + Math.imul(D, te) | 0, I = I + Math.imul(V, ae) | 0, C = C + Math.imul(V, te) | 0;
      var Re = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, A = Math.imul(rt, et), I = Math.imul(rt, Ee), I = I + Math.imul(De, et) | 0, C = Math.imul(De, Ee), A = A + Math.imul(tt, Xe) | 0, I = I + Math.imul(tt, Fe) | 0, I = I + Math.imul(Le, Xe) | 0, C = C + Math.imul(Le, Fe) | 0, A = A + Math.imul(je, We) | 0, I = I + Math.imul(je, Oe) | 0, I = I + Math.imul(me, We) | 0, C = C + Math.imul(me, Oe) | 0, A = A + Math.imul(Ve, nt) | 0, I = I + Math.imul(Ve, Me) | 0, I = I + Math.imul(_e, nt) | 0, C = C + Math.imul(_e, Me) | 0, A = A + Math.imul(He, at) | 0, I = I + Math.imul(He, ke) | 0, I = I + Math.imul(Ae, at) | 0, C = C + Math.imul(Ae, ke) | 0, A = A + Math.imul(qe, M) | 0, I = I + Math.imul(qe, L) | 0, I = I + Math.imul(ve, M) | 0, C = C + Math.imul(ve, L) | 0, A = A + Math.imul(ue, O) | 0, I = I + Math.imul(ue, P) | 0, I = I + Math.imul(se, O) | 0, C = C + Math.imul(se, P) | 0, A = A + Math.imul(le, q) | 0, I = I + Math.imul(le, Q) | 0, I = I + Math.imul(ie, q) | 0, C = C + Math.imul(ie, Q) | 0, A = A + Math.imul(J, ae) | 0, I = I + Math.imul(J, te) | 0, I = I + Math.imul(ee, ae) | 0, C = C + Math.imul(ee, te) | 0;
      var $e = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + ($e >>> 26) | 0, $e &= 67108863, A = Math.imul(rt, Xe), I = Math.imul(rt, Fe), I = I + Math.imul(De, Xe) | 0, C = Math.imul(De, Fe), A = A + Math.imul(tt, We) | 0, I = I + Math.imul(tt, Oe) | 0, I = I + Math.imul(Le, We) | 0, C = C + Math.imul(Le, Oe) | 0, A = A + Math.imul(je, nt) | 0, I = I + Math.imul(je, Me) | 0, I = I + Math.imul(me, nt) | 0, C = C + Math.imul(me, Me) | 0, A = A + Math.imul(Ve, at) | 0, I = I + Math.imul(Ve, ke) | 0, I = I + Math.imul(_e, at) | 0, C = C + Math.imul(_e, ke) | 0, A = A + Math.imul(He, M) | 0, I = I + Math.imul(He, L) | 0, I = I + Math.imul(Ae, M) | 0, C = C + Math.imul(Ae, L) | 0, A = A + Math.imul(qe, O) | 0, I = I + Math.imul(qe, P) | 0, I = I + Math.imul(ve, O) | 0, C = C + Math.imul(ve, P) | 0, A = A + Math.imul(ue, q) | 0, I = I + Math.imul(ue, Q) | 0, I = I + Math.imul(se, q) | 0, C = C + Math.imul(se, Q) | 0, A = A + Math.imul(le, ae) | 0, I = I + Math.imul(le, te) | 0, I = I + Math.imul(ie, ae) | 0, C = C + Math.imul(ie, te) | 0;
      var Se = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, A = Math.imul(rt, We), I = Math.imul(rt, Oe), I = I + Math.imul(De, We) | 0, C = Math.imul(De, Oe), A = A + Math.imul(tt, nt) | 0, I = I + Math.imul(tt, Me) | 0, I = I + Math.imul(Le, nt) | 0, C = C + Math.imul(Le, Me) | 0, A = A + Math.imul(je, at) | 0, I = I + Math.imul(je, ke) | 0, I = I + Math.imul(me, at) | 0, C = C + Math.imul(me, ke) | 0, A = A + Math.imul(Ve, M) | 0, I = I + Math.imul(Ve, L) | 0, I = I + Math.imul(_e, M) | 0, C = C + Math.imul(_e, L) | 0, A = A + Math.imul(He, O) | 0, I = I + Math.imul(He, P) | 0, I = I + Math.imul(Ae, O) | 0, C = C + Math.imul(Ae, P) | 0, A = A + Math.imul(qe, q) | 0, I = I + Math.imul(qe, Q) | 0, I = I + Math.imul(ve, q) | 0, C = C + Math.imul(ve, Q) | 0, A = A + Math.imul(ue, ae) | 0, I = I + Math.imul(ue, te) | 0, I = I + Math.imul(se, ae) | 0, C = C + Math.imul(se, te) | 0;
      var xe = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, A = Math.imul(rt, nt), I = Math.imul(rt, Me), I = I + Math.imul(De, nt) | 0, C = Math.imul(De, Me), A = A + Math.imul(tt, at) | 0, I = I + Math.imul(tt, ke) | 0, I = I + Math.imul(Le, at) | 0, C = C + Math.imul(Le, ke) | 0, A = A + Math.imul(je, M) | 0, I = I + Math.imul(je, L) | 0, I = I + Math.imul(me, M) | 0, C = C + Math.imul(me, L) | 0, A = A + Math.imul(Ve, O) | 0, I = I + Math.imul(Ve, P) | 0, I = I + Math.imul(_e, O) | 0, C = C + Math.imul(_e, P) | 0, A = A + Math.imul(He, q) | 0, I = I + Math.imul(He, Q) | 0, I = I + Math.imul(Ae, q) | 0, C = C + Math.imul(Ae, Q) | 0, A = A + Math.imul(qe, ae) | 0, I = I + Math.imul(qe, te) | 0, I = I + Math.imul(ve, ae) | 0, C = C + Math.imul(ve, te) | 0;
      var Be = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, A = Math.imul(rt, at), I = Math.imul(rt, ke), I = I + Math.imul(De, at) | 0, C = Math.imul(De, ke), A = A + Math.imul(tt, M) | 0, I = I + Math.imul(tt, L) | 0, I = I + Math.imul(Le, M) | 0, C = C + Math.imul(Le, L) | 0, A = A + Math.imul(je, O) | 0, I = I + Math.imul(je, P) | 0, I = I + Math.imul(me, O) | 0, C = C + Math.imul(me, P) | 0, A = A + Math.imul(Ve, q) | 0, I = I + Math.imul(Ve, Q) | 0, I = I + Math.imul(_e, q) | 0, C = C + Math.imul(_e, Q) | 0, A = A + Math.imul(He, ae) | 0, I = I + Math.imul(He, te) | 0, I = I + Math.imul(Ae, ae) | 0, C = C + Math.imul(Ae, te) | 0;
      var Te = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, A = Math.imul(rt, M), I = Math.imul(rt, L), I = I + Math.imul(De, M) | 0, C = Math.imul(De, L), A = A + Math.imul(tt, O) | 0, I = I + Math.imul(tt, P) | 0, I = I + Math.imul(Le, O) | 0, C = C + Math.imul(Le, P) | 0, A = A + Math.imul(je, q) | 0, I = I + Math.imul(je, Q) | 0, I = I + Math.imul(me, q) | 0, C = C + Math.imul(me, Q) | 0, A = A + Math.imul(Ve, ae) | 0, I = I + Math.imul(Ve, te) | 0, I = I + Math.imul(_e, ae) | 0, C = C + Math.imul(_e, te) | 0;
      var ne = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (ne >>> 26) | 0, ne &= 67108863, A = Math.imul(rt, O), I = Math.imul(rt, P), I = I + Math.imul(De, O) | 0, C = Math.imul(De, P), A = A + Math.imul(tt, q) | 0, I = I + Math.imul(tt, Q) | 0, I = I + Math.imul(Le, q) | 0, C = C + Math.imul(Le, Q) | 0, A = A + Math.imul(je, ae) | 0, I = I + Math.imul(je, te) | 0, I = I + Math.imul(me, ae) | 0, C = C + Math.imul(me, te) | 0;
      var oe = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (oe >>> 26) | 0, oe &= 67108863, A = Math.imul(rt, q), I = Math.imul(rt, Q), I = I + Math.imul(De, q) | 0, C = Math.imul(De, Q), A = A + Math.imul(tt, ae) | 0, I = I + Math.imul(tt, te) | 0, I = I + Math.imul(Le, ae) | 0, C = C + Math.imul(Le, te) | 0;
      var fe = (w + A | 0) + ((I & 8191) << 13) | 0;
      w = (C + (I >>> 13) | 0) + (fe >>> 26) | 0, fe &= 67108863, A = Math.imul(rt, ae), I = Math.imul(rt, te), I = I + Math.imul(De, ae) | 0, C = Math.imul(De, te);
      var ce = (w + A | 0) + ((I & 8191) << 13) | 0;
      return w = (C + (I >>> 13) | 0) + (ce >>> 26) | 0, ce &= 67108863, E[0] = ge, E[1] = pe, E[2] = Ie, E[3] = we, E[4] = Ue, E[5] = Ye, E[6] = Qe, E[7] = Ge, E[8] = Je, E[9] = Re, E[10] = $e, E[11] = Se, E[12] = xe, E[13] = Be, E[14] = Te, E[15] = ne, E[16] = oe, E[17] = fe, E[18] = ce, w !== 0 && (E[19] = w, _.length++), _;
    };
    Math.imul || (U = m);
    function be(T, p, b) {
      b.negative = p.negative ^ T.negative, b.length = T.length + p.length;
      for (var _ = 0, v = 0, S = 0; S < b.length - 1; S++) {
        var E = v;
        v = 0;
        for (var w = _ & 67108863, A = Math.min(S, p.length - 1), I = Math.max(0, S - T.length + 1); I <= A; I++) {
          var C = S - I, X = T.words[C] | 0, D = p.words[I] | 0, V = X * D, Z = V & 67108863;
          E = E + (V / 67108864 | 0) | 0, Z = Z + w | 0, w = Z & 67108863, E = E + (Z >>> 26) | 0, v += E >>> 26, E &= 67108863;
        }
        b.words[S] = w, _ = E, E = v;
      }
      return _ !== 0 ? b.words[S] = _ : b.length--, b._strip();
    }
    function Ke(T, p, b) {
      return be(T, p, b);
    }
    h.prototype.mulTo = function(p, b) {
      var _, v = this.length + p.length;
      return this.length === 10 && p.length === 10 ? _ = U(this, p, b) : v < 63 ? _ = m(this, p, b) : v < 1024 ? _ = be(this, p, b) : _ = Ke(this, p, b), _;
    }, h.prototype.mul = function(p) {
      var b = new h(null);
      return b.words = new Array(this.length + p.length), this.mulTo(p, b);
    }, h.prototype.mulf = function(p) {
      var b = new h(null);
      return b.words = new Array(this.length + p.length), Ke(this, p, b);
    }, h.prototype.imul = function(p) {
      return this.clone().mulTo(p, this);
    }, h.prototype.imuln = function(p) {
      var b = p < 0;
      b && (p = -p), d(typeof p == "number"), d(p < 67108864);
      for (var _ = 0, v = 0; v < this.length; v++) {
        var S = (this.words[v] | 0) * p, E = (S & 67108863) + (_ & 67108863);
        _ >>= 26, _ += S / 67108864 | 0, _ += E >>> 26, this.words[v] = E & 67108863;
      }
      return _ !== 0 && (this.words[v] = _, this.length++), b ? this.ineg() : this;
    }, h.prototype.muln = function(p) {
      return this.clone().imuln(p);
    }, h.prototype.sqr = function() {
      return this.mul(this);
    }, h.prototype.isqr = function() {
      return this.imul(this.clone());
    }, h.prototype.pow = function(p) {
      var b = y(p);
      if (b.length === 0)
        return new h(1);
      for (var _ = this, v = 0; v < b.length && b[v] === 0; v++, _ = _.sqr())
        ;
      if (++v < b.length)
        for (var S = _.sqr(); v < b.length; v++, S = S.sqr())
          b[v] !== 0 && (_ = _.mul(S));
      return _;
    }, h.prototype.iushln = function(p) {
      d(typeof p == "number" && p >= 0);
      var b = p % 26, _ = (p - b) / 26, v = 67108863 >>> 26 - b << 26 - b, S;
      if (b !== 0) {
        var E = 0;
        for (S = 0; S < this.length; S++) {
          var w = this.words[S] & v, A = (this.words[S] | 0) - w << b;
          this.words[S] = A | E, E = w >>> 26 - b;
        }
        E && (this.words[S] = E, this.length++);
      }
      if (_ !== 0) {
        for (S = this.length - 1; S >= 0; S--)
          this.words[S + _] = this.words[S];
        for (S = 0; S < _; S++)
          this.words[S] = 0;
        this.length += _;
      }
      return this._strip();
    }, h.prototype.ishln = function(p) {
      return d(this.negative === 0), this.iushln(p);
    }, h.prototype.iushrn = function(p, b, _) {
      d(typeof p == "number" && p >= 0);
      var v;
      b ? v = (b - b % 26) / 26 : v = 0;
      var S = p % 26, E = Math.min((p - S) / 26, this.length), w = 67108863 ^ 67108863 >>> S << S, A = _;
      if (v -= E, v = Math.max(0, v), A) {
        for (var I = 0; I < E; I++)
          A.words[I] = this.words[I];
        A.length = E;
      }
      if (E !== 0)
        if (this.length > E)
          for (this.length -= E, I = 0; I < this.length; I++)
            this.words[I] = this.words[I + E];
        else
          this.words[0] = 0, this.length = 1;
      var C = 0;
      for (I = this.length - 1; I >= 0 && (C !== 0 || I >= v); I--) {
        var X = this.words[I] | 0;
        this.words[I] = C << 26 - S | X >>> S, C = X & w;
      }
      return A && C !== 0 && (A.words[A.length++] = C), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, h.prototype.ishrn = function(p, b, _) {
      return d(this.negative === 0), this.iushrn(p, b, _);
    }, h.prototype.shln = function(p) {
      return this.clone().ishln(p);
    }, h.prototype.ushln = function(p) {
      return this.clone().iushln(p);
    }, h.prototype.shrn = function(p) {
      return this.clone().ishrn(p);
    }, h.prototype.ushrn = function(p) {
      return this.clone().iushrn(p);
    }, h.prototype.testn = function(p) {
      d(typeof p == "number" && p >= 0);
      var b = p % 26, _ = (p - b) / 26, v = 1 << b;
      if (this.length <= _)
        return !1;
      var S = this.words[_];
      return !!(S & v);
    }, h.prototype.imaskn = function(p) {
      d(typeof p == "number" && p >= 0);
      var b = p % 26, _ = (p - b) / 26;
      if (d(this.negative === 0, "imaskn works only with positive numbers"), this.length <= _)
        return this;
      if (b !== 0 && _++, this.length = Math.min(_, this.length), b !== 0) {
        var v = 67108863 ^ 67108863 >>> b << b;
        this.words[this.length - 1] &= v;
      }
      return this._strip();
    }, h.prototype.maskn = function(p) {
      return this.clone().imaskn(p);
    }, h.prototype.iaddn = function(p) {
      return d(typeof p == "number"), d(p < 67108864), p < 0 ? this.isubn(-p) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= p ? (this.words[0] = p - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(p), this.negative = 1, this) : this._iaddn(p);
    }, h.prototype._iaddn = function(p) {
      this.words[0] += p;
      for (var b = 0; b < this.length && this.words[b] >= 67108864; b++)
        this.words[b] -= 67108864, b === this.length - 1 ? this.words[b + 1] = 1 : this.words[b + 1]++;
      return this.length = Math.max(this.length, b + 1), this;
    }, h.prototype.isubn = function(p) {
      if (d(typeof p == "number"), d(p < 67108864), p < 0)
        return this.iaddn(-p);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(p), this.negative = 1, this;
      if (this.words[0] -= p, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var b = 0; b < this.length && this.words[b] < 0; b++)
          this.words[b] += 67108864, this.words[b + 1] -= 1;
      return this._strip();
    }, h.prototype.addn = function(p) {
      return this.clone().iaddn(p);
    }, h.prototype.subn = function(p) {
      return this.clone().isubn(p);
    }, h.prototype.iabs = function() {
      return this.negative = 0, this;
    }, h.prototype.abs = function() {
      return this.clone().iabs();
    }, h.prototype._ishlnsubmul = function(p, b, _) {
      var v = p.length + _, S;
      this._expand(v);
      var E, w = 0;
      for (S = 0; S < p.length; S++) {
        E = (this.words[S + _] | 0) + w;
        var A = (p.words[S] | 0) * b;
        E -= A & 67108863, w = (E >> 26) - (A / 67108864 | 0), this.words[S + _] = E & 67108863;
      }
      for (; S < this.length - _; S++)
        E = (this.words[S + _] | 0) + w, w = E >> 26, this.words[S + _] = E & 67108863;
      if (w === 0)
        return this._strip();
      for (d(w === -1), w = 0, S = 0; S < this.length; S++)
        E = -(this.words[S] | 0) + w, w = E >> 26, this.words[S] = E & 67108863;
      return this.negative = 1, this._strip();
    }, h.prototype._wordDiv = function(p, b) {
      var _ = this.length - p.length, v = this.clone(), S = p, E = S.words[S.length - 1] | 0, w = this._countBits(E);
      _ = 26 - w, _ !== 0 && (S = S.ushln(_), v.iushln(_), E = S.words[S.length - 1] | 0);
      var A = v.length - S.length, I;
      if (b !== "mod") {
        I = new h(null), I.length = A + 1, I.words = new Array(I.length);
        for (var C = 0; C < I.length; C++)
          I.words[C] = 0;
      }
      var X = v.clone()._ishlnsubmul(S, 1, A);
      X.negative === 0 && (v = X, I && (I.words[A] = 1));
      for (var D = A - 1; D >= 0; D--) {
        var V = (v.words[S.length + D] | 0) * 67108864 + (v.words[S.length + D - 1] | 0);
        for (V = Math.min(V / E | 0, 67108863), v._ishlnsubmul(S, V, D); v.negative !== 0; )
          V--, v.negative = 0, v._ishlnsubmul(S, 1, D), v.isZero() || (v.negative ^= 1);
        I && (I.words[D] = V);
      }
      return I && I._strip(), v._strip(), b !== "div" && _ !== 0 && v.iushrn(_), {
        div: I || null,
        mod: v
      };
    }, h.prototype.divmod = function(p, b, _) {
      if (d(!p.isZero()), this.isZero())
        return {
          div: new h(0),
          mod: new h(0)
        };
      var v, S, E;
      return this.negative !== 0 && p.negative === 0 ? (E = this.neg().divmod(p, b), b !== "mod" && (v = E.div.neg()), b !== "div" && (S = E.mod.neg(), _ && S.negative !== 0 && S.iadd(p)), {
        div: v,
        mod: S
      }) : this.negative === 0 && p.negative !== 0 ? (E = this.divmod(p.neg(), b), b !== "mod" && (v = E.div.neg()), {
        div: v,
        mod: E.mod
      }) : (this.negative & p.negative) !== 0 ? (E = this.neg().divmod(p.neg(), b), b !== "div" && (S = E.mod.neg(), _ && S.negative !== 0 && S.isub(p)), {
        div: E.div,
        mod: S
      }) : p.length > this.length || this.cmp(p) < 0 ? {
        div: new h(0),
        mod: this
      } : p.length === 1 ? b === "div" ? {
        div: this.divn(p.words[0]),
        mod: null
      } : b === "mod" ? {
        div: null,
        mod: new h(this.modrn(p.words[0]))
      } : {
        div: this.divn(p.words[0]),
        mod: new h(this.modrn(p.words[0]))
      } : this._wordDiv(p, b);
    }, h.prototype.div = function(p) {
      return this.divmod(p, "div", !1).div;
    }, h.prototype.mod = function(p) {
      return this.divmod(p, "mod", !1).mod;
    }, h.prototype.umod = function(p) {
      return this.divmod(p, "mod", !0).mod;
    }, h.prototype.divRound = function(p) {
      var b = this.divmod(p);
      if (b.mod.isZero())
        return b.div;
      var _ = b.div.negative !== 0 ? b.mod.isub(p) : b.mod, v = p.ushrn(1), S = p.andln(1), E = _.cmp(v);
      return E < 0 || S === 1 && E === 0 ? b.div : b.div.negative !== 0 ? b.div.isubn(1) : b.div.iaddn(1);
    }, h.prototype.modrn = function(p) {
      var b = p < 0;
      b && (p = -p), d(p <= 67108863);
      for (var _ = (1 << 26) % p, v = 0, S = this.length - 1; S >= 0; S--)
        v = (_ * v + (this.words[S] | 0)) % p;
      return b ? -v : v;
    }, h.prototype.modn = function(p) {
      return this.modrn(p);
    }, h.prototype.idivn = function(p) {
      var b = p < 0;
      b && (p = -p), d(p <= 67108863);
      for (var _ = 0, v = this.length - 1; v >= 0; v--) {
        var S = (this.words[v] | 0) + _ * 67108864;
        this.words[v] = S / p | 0, _ = S % p;
      }
      return this._strip(), b ? this.ineg() : this;
    }, h.prototype.divn = function(p) {
      return this.clone().idivn(p);
    }, h.prototype.egcd = function(p) {
      d(p.negative === 0), d(!p.isZero());
      var b = this, _ = p.clone();
      b.negative !== 0 ? b = b.umod(p) : b = b.clone();
      for (var v = new h(1), S = new h(0), E = new h(0), w = new h(1), A = 0; b.isEven() && _.isEven(); )
        b.iushrn(1), _.iushrn(1), ++A;
      for (var I = _.clone(), C = b.clone(); !b.isZero(); ) {
        for (var X = 0, D = 1; (b.words[0] & D) === 0 && X < 26; ++X, D <<= 1)
          ;
        if (X > 0)
          for (b.iushrn(X); X-- > 0; )
            (v.isOdd() || S.isOdd()) && (v.iadd(I), S.isub(C)), v.iushrn(1), S.iushrn(1);
        for (var V = 0, Z = 1; (_.words[0] & Z) === 0 && V < 26; ++V, Z <<= 1)
          ;
        if (V > 0)
          for (_.iushrn(V); V-- > 0; )
            (E.isOdd() || w.isOdd()) && (E.iadd(I), w.isub(C)), E.iushrn(1), w.iushrn(1);
        b.cmp(_) >= 0 ? (b.isub(_), v.isub(E), S.isub(w)) : (_.isub(b), E.isub(v), w.isub(S));
      }
      return {
        a: E,
        b: w,
        gcd: _.iushln(A)
      };
    }, h.prototype._invmp = function(p) {
      d(p.negative === 0), d(!p.isZero());
      var b = this, _ = p.clone();
      b.negative !== 0 ? b = b.umod(p) : b = b.clone();
      for (var v = new h(1), S = new h(0), E = _.clone(); b.cmpn(1) > 0 && _.cmpn(1) > 0; ) {
        for (var w = 0, A = 1; (b.words[0] & A) === 0 && w < 26; ++w, A <<= 1)
          ;
        if (w > 0)
          for (b.iushrn(w); w-- > 0; )
            v.isOdd() && v.iadd(E), v.iushrn(1);
        for (var I = 0, C = 1; (_.words[0] & C) === 0 && I < 26; ++I, C <<= 1)
          ;
        if (I > 0)
          for (_.iushrn(I); I-- > 0; )
            S.isOdd() && S.iadd(E), S.iushrn(1);
        b.cmp(_) >= 0 ? (b.isub(_), v.isub(S)) : (_.isub(b), S.isub(v));
      }
      var X;
      return b.cmpn(1) === 0 ? X = v : X = S, X.cmpn(0) < 0 && X.iadd(p), X;
    }, h.prototype.gcd = function(p) {
      if (this.isZero())
        return p.abs();
      if (p.isZero())
        return this.abs();
      var b = this.clone(), _ = p.clone();
      b.negative = 0, _.negative = 0;
      for (var v = 0; b.isEven() && _.isEven(); v++)
        b.iushrn(1), _.iushrn(1);
      do {
        for (; b.isEven(); )
          b.iushrn(1);
        for (; _.isEven(); )
          _.iushrn(1);
        var S = b.cmp(_);
        if (S < 0) {
          var E = b;
          b = _, _ = E;
        } else if (S === 0 || _.cmpn(1) === 0)
          break;
        b.isub(_);
      } while (!0);
      return _.iushln(v);
    }, h.prototype.invm = function(p) {
      return this.egcd(p).a.umod(p);
    }, h.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, h.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, h.prototype.andln = function(p) {
      return this.words[0] & p;
    }, h.prototype.bincn = function(p) {
      d(typeof p == "number");
      var b = p % 26, _ = (p - b) / 26, v = 1 << b;
      if (this.length <= _)
        return this._expand(_ + 1), this.words[_] |= v, this;
      for (var S = v, E = _; S !== 0 && E < this.length; E++) {
        var w = this.words[E] | 0;
        w += S, S = w >>> 26, w &= 67108863, this.words[E] = w;
      }
      return S !== 0 && (this.words[E] = S, this.length++), this;
    }, h.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, h.prototype.cmpn = function(p) {
      var b = p < 0;
      if (this.negative !== 0 && !b)
        return -1;
      if (this.negative === 0 && b)
        return 1;
      this._strip();
      var _;
      if (this.length > 1)
        _ = 1;
      else {
        b && (p = -p), d(p <= 67108863, "Number is too big");
        var v = this.words[0] | 0;
        _ = v === p ? 0 : v < p ? -1 : 1;
      }
      return this.negative !== 0 ? -_ | 0 : _;
    }, h.prototype.cmp = function(p) {
      if (this.negative !== 0 && p.negative === 0)
        return -1;
      if (this.negative === 0 && p.negative !== 0)
        return 1;
      var b = this.ucmp(p);
      return this.negative !== 0 ? -b | 0 : b;
    }, h.prototype.ucmp = function(p) {
      if (this.length > p.length)
        return 1;
      if (this.length < p.length)
        return -1;
      for (var b = 0, _ = this.length - 1; _ >= 0; _--) {
        var v = this.words[_] | 0, S = p.words[_] | 0;
        if (v !== S) {
          v < S ? b = -1 : v > S && (b = 1);
          break;
        }
      }
      return b;
    }, h.prototype.gtn = function(p) {
      return this.cmpn(p) === 1;
    }, h.prototype.gt = function(p) {
      return this.cmp(p) === 1;
    }, h.prototype.gten = function(p) {
      return this.cmpn(p) >= 0;
    }, h.prototype.gte = function(p) {
      return this.cmp(p) >= 0;
    }, h.prototype.ltn = function(p) {
      return this.cmpn(p) === -1;
    }, h.prototype.lt = function(p) {
      return this.cmp(p) === -1;
    }, h.prototype.lten = function(p) {
      return this.cmpn(p) <= 0;
    }, h.prototype.lte = function(p) {
      return this.cmp(p) <= 0;
    }, h.prototype.eqn = function(p) {
      return this.cmpn(p) === 0;
    }, h.prototype.eq = function(p) {
      return this.cmp(p) === 0;
    }, h.red = function(p) {
      return new F(p);
    }, h.prototype.toRed = function(p) {
      return d(!this.red, "Already a number in reduction context"), d(this.negative === 0, "red works only with positives"), p.convertTo(this)._forceRed(p);
    }, h.prototype.fromRed = function() {
      return d(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, h.prototype._forceRed = function(p) {
      return this.red = p, this;
    }, h.prototype.forceRed = function(p) {
      return d(!this.red, "Already a number in reduction context"), this._forceRed(p);
    }, h.prototype.redAdd = function(p) {
      return d(this.red, "redAdd works only with red numbers"), this.red.add(this, p);
    }, h.prototype.redIAdd = function(p) {
      return d(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, p);
    }, h.prototype.redSub = function(p) {
      return d(this.red, "redSub works only with red numbers"), this.red.sub(this, p);
    }, h.prototype.redISub = function(p) {
      return d(this.red, "redISub works only with red numbers"), this.red.isub(this, p);
    }, h.prototype.redShl = function(p) {
      return d(this.red, "redShl works only with red numbers"), this.red.shl(this, p);
    }, h.prototype.redMul = function(p) {
      return d(this.red, "redMul works only with red numbers"), this.red._verify2(this, p), this.red.mul(this, p);
    }, h.prototype.redIMul = function(p) {
      return d(this.red, "redMul works only with red numbers"), this.red._verify2(this, p), this.red.imul(this, p);
    }, h.prototype.redSqr = function() {
      return d(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, h.prototype.redISqr = function() {
      return d(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, h.prototype.redSqrt = function() {
      return d(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, h.prototype.redInvm = function() {
      return d(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, h.prototype.redNeg = function() {
      return d(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, h.prototype.redPow = function(p) {
      return d(this.red && !p.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, p);
    };
    var ze = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Pe(T, p) {
      this.name = T, this.p = new h(p, 16), this.n = this.p.bitLength(), this.k = new h(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Pe.prototype._tmp = function() {
      var p = new h(null);
      return p.words = new Array(Math.ceil(this.n / 13)), p;
    }, Pe.prototype.ireduce = function(p) {
      var b = p, _;
      do
        this.split(b, this.tmp), b = this.imulK(b), b = b.iadd(this.tmp), _ = b.bitLength();
      while (_ > this.n);
      var v = _ < this.n ? -1 : b.ucmp(this.p);
      return v === 0 ? (b.words[0] = 0, b.length = 1) : v > 0 ? b.isub(this.p) : b.strip !== void 0 ? b.strip() : b._strip(), b;
    }, Pe.prototype.split = function(p, b) {
      p.iushrn(this.n, 0, b);
    }, Pe.prototype.imulK = function(p) {
      return p.imul(this.k);
    };
    function st() {
      Pe.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    l(st, Pe), st.prototype.split = function(p, b) {
      for (var _ = 4194303, v = Math.min(p.length, 9), S = 0; S < v; S++)
        b.words[S] = p.words[S];
      if (b.length = v, p.length <= 9) {
        p.words[0] = 0, p.length = 1;
        return;
      }
      var E = p.words[9];
      for (b.words[b.length++] = E & _, S = 10; S < p.length; S++) {
        var w = p.words[S] | 0;
        p.words[S - 10] = (w & _) << 4 | E >>> 22, E = w;
      }
      E >>>= 22, p.words[S - 10] = E, E === 0 && p.length > 10 ? p.length -= 10 : p.length -= 9;
    }, st.prototype.imulK = function(p) {
      p.words[p.length] = 0, p.words[p.length + 1] = 0, p.length += 2;
      for (var b = 0, _ = 0; _ < p.length; _++) {
        var v = p.words[_] | 0;
        b += v * 977, p.words[_] = b & 67108863, b = v * 64 + (b / 67108864 | 0);
      }
      return p.words[p.length - 1] === 0 && (p.length--, p.words[p.length - 1] === 0 && p.length--), p;
    };
    function G() {
      Pe.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    l(G, Pe);
    function z() {
      Pe.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    l(z, Pe);
    function W() {
      Pe.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    l(W, Pe), W.prototype.imulK = function(p) {
      for (var b = 0, _ = 0; _ < p.length; _++) {
        var v = (p.words[_] | 0) * 19 + b, S = v & 67108863;
        v >>>= 26, p.words[_] = S, b = v;
      }
      return b !== 0 && (p.words[p.length++] = b), p;
    }, h._prime = function(p) {
      if (ze[p])
        return ze[p];
      var b;
      if (p === "k256")
        b = new st();
      else if (p === "p224")
        b = new G();
      else if (p === "p192")
        b = new z();
      else if (p === "p25519")
        b = new W();
      else
        throw new Error("Unknown prime " + p);
      return ze[p] = b, b;
    };
    function F(T) {
      if (typeof T == "string") {
        var p = h._prime(T);
        this.m = p.p, this.prime = p;
      } else
        d(T.gtn(1), "modulus must be greater than 1"), this.m = T, this.prime = null;
    }
    F.prototype._verify1 = function(p) {
      d(p.negative === 0, "red works only with positives"), d(p.red, "red works only with red numbers");
    }, F.prototype._verify2 = function(p, b) {
      d((p.negative | b.negative) === 0, "red works only with positives"), d(
        p.red && p.red === b.red,
        "red works only with red numbers"
      );
    }, F.prototype.imod = function(p) {
      return this.prime ? this.prime.ireduce(p)._forceRed(this) : (B(p, p.umod(this.m)._forceRed(this)), p);
    }, F.prototype.neg = function(p) {
      return p.isZero() ? p.clone() : this.m.sub(p)._forceRed(this);
    }, F.prototype.add = function(p, b) {
      this._verify2(p, b);
      var _ = p.add(b);
      return _.cmp(this.m) >= 0 && _.isub(this.m), _._forceRed(this);
    }, F.prototype.iadd = function(p, b) {
      this._verify2(p, b);
      var _ = p.iadd(b);
      return _.cmp(this.m) >= 0 && _.isub(this.m), _;
    }, F.prototype.sub = function(p, b) {
      this._verify2(p, b);
      var _ = p.sub(b);
      return _.cmpn(0) < 0 && _.iadd(this.m), _._forceRed(this);
    }, F.prototype.isub = function(p, b) {
      this._verify2(p, b);
      var _ = p.isub(b);
      return _.cmpn(0) < 0 && _.iadd(this.m), _;
    }, F.prototype.shl = function(p, b) {
      return this._verify1(p), this.imod(p.ushln(b));
    }, F.prototype.imul = function(p, b) {
      return this._verify2(p, b), this.imod(p.imul(b));
    }, F.prototype.mul = function(p, b) {
      return this._verify2(p, b), this.imod(p.mul(b));
    }, F.prototype.isqr = function(p) {
      return this.imul(p, p.clone());
    }, F.prototype.sqr = function(p) {
      return this.mul(p, p);
    }, F.prototype.sqrt = function(p) {
      if (p.isZero())
        return p.clone();
      var b = this.m.andln(3);
      if (d(b % 2 === 1), b === 3) {
        var _ = this.m.add(new h(1)).iushrn(2);
        return this.pow(p, _);
      }
      for (var v = this.m.subn(1), S = 0; !v.isZero() && v.andln(1) === 0; )
        S++, v.iushrn(1);
      d(!v.isZero());
      var E = new h(1).toRed(this), w = E.redNeg(), A = this.m.subn(1).iushrn(1), I = this.m.bitLength();
      for (I = new h(2 * I * I).toRed(this); this.pow(I, A).cmp(w) !== 0; )
        I.redIAdd(w);
      for (var C = this.pow(I, v), X = this.pow(p, v.addn(1).iushrn(1)), D = this.pow(p, v), V = S; D.cmp(E) !== 0; ) {
        for (var Z = D, J = 0; Z.cmp(E) !== 0; J++)
          Z = Z.redSqr();
        d(J < V);
        var ee = this.pow(C, new h(1).iushln(V - J - 1));
        X = X.redMul(ee), C = ee.redSqr(), D = D.redMul(C), V = J;
      }
      return X;
    }, F.prototype.invm = function(p) {
      var b = p._invmp(this.m);
      return b.negative !== 0 ? (b.negative = 0, this.imod(b).redNeg()) : this.imod(b);
    }, F.prototype.pow = function(p, b) {
      if (b.isZero())
        return new h(1).toRed(this);
      if (b.cmpn(1) === 0)
        return p.clone();
      var _ = 4, v = new Array(1 << _);
      v[0] = new h(1).toRed(this), v[1] = p;
      for (var S = 2; S < v.length; S++)
        v[S] = this.mul(v[S - 1], p);
      var E = v[0], w = 0, A = 0, I = b.bitLength() % 26;
      for (I === 0 && (I = 26), S = b.length - 1; S >= 0; S--) {
        for (var C = b.words[S], X = I - 1; X >= 0; X--) {
          var D = C >> X & 1;
          if (E !== v[0] && (E = this.sqr(E)), D === 0 && w === 0) {
            A = 0;
            continue;
          }
          w <<= 1, w |= D, A++, !(A !== _ && (S !== 0 || X !== 0)) && (E = this.mul(E, v[w]), A = 0, w = 0);
        }
        I = 26;
      }
      return E;
    }, F.prototype.convertTo = function(p) {
      var b = p.umod(this.m);
      return b === p ? b.clone() : b;
    }, F.prototype.convertFrom = function(p) {
      var b = p.clone();
      return b.red = null, b;
    }, h.mont = function(p) {
      return new k(p);
    };
    function k(T) {
      F.call(this, T), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new h(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    l(k, F), k.prototype.convertTo = function(p) {
      return this.imod(p.ushln(this.shift));
    }, k.prototype.convertFrom = function(p) {
      var b = this.imod(p.mul(this.rinv));
      return b.red = null, b;
    }, k.prototype.imul = function(p, b) {
      if (p.isZero() || b.isZero())
        return p.words[0] = 0, p.length = 1, p;
      var _ = p.imul(b), v = _.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), S = _.isub(v).iushrn(this.shift), E = S;
      return S.cmp(this.m) >= 0 ? E = S.isub(this.m) : S.cmpn(0) < 0 && (E = S.iadd(this.m)), E._forceRed(this);
    }, k.prototype.mul = function(p, b) {
      if (p.isZero() || b.isZero())
        return new h(0)._forceRed(this);
      var _ = p.mul(b), v = _.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), S = _.isub(v).iushrn(this.shift), E = S;
      return S.cmp(this.m) >= 0 ? E = S.isub(this.m) : S.cmpn(0) < 0 && (E = S.iadd(this.m)), E._forceRed(this);
    }, k.prototype.invm = function(p) {
      var b = this.imod(p._invmp(this.m).mul(this.r2));
      return b._forceRed(this);
    };
  })(u, commonjsGlobal);
})(bn);
const _BN = bn.exports, version$8 = "logger/5.7.0";
let _permanentCensorErrors = !1, _censorErrors = !1;
const LogLevels = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let _logLevel = LogLevels.default, _globalLogger = null;
function _checkNormalize() {
  try {
    const u = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((t) => {
      try {
        if ("test".normalize(t) !== "test")
          throw new Error("bad normalize");
      } catch {
        u.push(t);
      }
    }), u.length)
      throw new Error("missing " + u.join(", "));
    if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769))
      throw new Error("broken implementation");
  } catch (u) {
    return u.message;
  }
  return null;
}
const _normalizeError = _checkNormalize();
var LogLevel$1;
(function(u) {
  u.DEBUG = "DEBUG", u.INFO = "INFO", u.WARNING = "WARNING", u.ERROR = "ERROR", u.OFF = "OFF";
})(LogLevel$1 || (LogLevel$1 = {}));
var ErrorCode;
(function(u) {
  u.UNKNOWN_ERROR = "UNKNOWN_ERROR", u.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", u.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", u.NETWORK_ERROR = "NETWORK_ERROR", u.SERVER_ERROR = "SERVER_ERROR", u.TIMEOUT = "TIMEOUT", u.BUFFER_OVERRUN = "BUFFER_OVERRUN", u.NUMERIC_FAULT = "NUMERIC_FAULT", u.MISSING_NEW = "MISSING_NEW", u.INVALID_ARGUMENT = "INVALID_ARGUMENT", u.MISSING_ARGUMENT = "MISSING_ARGUMENT", u.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", u.CALL_EXCEPTION = "CALL_EXCEPTION", u.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", u.NONCE_EXPIRED = "NONCE_EXPIRED", u.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", u.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", u.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", u.ACTION_REJECTED = "ACTION_REJECTED";
})(ErrorCode || (ErrorCode = {}));
const HEX = "0123456789abcdef";
class Logger {
  constructor(t) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: t,
      writable: !1
    });
  }
  _log(t, a) {
    const d = t.toLowerCase();
    LogLevels[d] == null && this.throwArgumentError("invalid log level name", "logLevel", t), !(_logLevel > LogLevels[d]) && console.log.apply(console, a);
  }
  debug(...t) {
    this._log(Logger.levels.DEBUG, t);
  }
  info(...t) {
    this._log(Logger.levels.INFO, t);
  }
  warn(...t) {
    this._log(Logger.levels.WARNING, t);
  }
  makeError(t, a, d) {
    if (_censorErrors)
      return this.makeError("censored error", a, {});
    a || (a = Logger.errors.UNKNOWN_ERROR), d || (d = {});
    const l = [];
    Object.keys(d).forEach((x) => {
      const R = d[x];
      try {
        if (R instanceof Uint8Array) {
          let B = "";
          for (let j = 0; j < R.length; j++)
            B += HEX[R[j] >> 4], B += HEX[R[j] & 15];
          l.push(x + "=Uint8Array(0x" + B + ")");
        } else
          l.push(x + "=" + JSON.stringify(R));
      } catch {
        l.push(x + "=" + JSON.stringify(d[x].toString()));
      }
    }), l.push(`code=${a}`), l.push(`version=${this.version}`);
    const h = t;
    let g = "";
    switch (a) {
      case ErrorCode.NUMERIC_FAULT: {
        g = "NUMERIC_FAULT";
        const x = t;
        switch (x) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            g += "-" + x;
            break;
          case "negative-power":
          case "negative-width":
            g += "-unsupported";
            break;
          case "unbound-bitwise-result":
            g += "-unbound-result";
            break;
        }
        break;
      }
      case ErrorCode.CALL_EXCEPTION:
      case ErrorCode.INSUFFICIENT_FUNDS:
      case ErrorCode.MISSING_NEW:
      case ErrorCode.NONCE_EXPIRED:
      case ErrorCode.REPLACEMENT_UNDERPRICED:
      case ErrorCode.TRANSACTION_REPLACED:
      case ErrorCode.UNPREDICTABLE_GAS_LIMIT:
        g = a;
        break;
    }
    g && (t += " [ See: https://links.ethers.org/v5-errors-" + g + " ]"), l.length && (t += " (" + l.join(", ") + ")");
    const c = new Error(t);
    return c.reason = h, c.code = a, Object.keys(d).forEach(function(x) {
      c[x] = d[x];
    }), c;
  }
  throwError(t, a, d) {
    throw this.makeError(t, a, d);
  }
  throwArgumentError(t, a, d) {
    return this.throwError(t, Logger.errors.INVALID_ARGUMENT, {
      argument: a,
      value: d
    });
  }
  assert(t, a, d, l) {
    t || this.throwError(a, d, l);
  }
  assertArgument(t, a, d, l) {
    t || this.throwArgumentError(a, d, l);
  }
  checkNormalize(t) {
    _normalizeError && this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: _normalizeError
    });
  }
  checkSafeUint53(t, a) {
    typeof t == "number" && (a == null && (a = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(a, Logger.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: t
    }), t % 1 && this.throwError(a, Logger.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: t
    }));
  }
  checkArgumentCount(t, a, d) {
    d ? d = ": " + d : d = "", t < a && this.throwError("missing argument" + d, Logger.errors.MISSING_ARGUMENT, {
      count: t,
      expectedCount: a
    }), t > a && this.throwError("too many arguments" + d, Logger.errors.UNEXPECTED_ARGUMENT, {
      count: t,
      expectedCount: a
    });
  }
  checkNew(t, a) {
    (t === Object || t == null) && this.throwError("missing new", Logger.errors.MISSING_NEW, { name: a.name });
  }
  checkAbstract(t, a) {
    t === a ? this.throwError("cannot instantiate abstract class " + JSON.stringify(a.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, { name: t.name, operation: "new" }) : (t === Object || t == null) && this.throwError("missing new", Logger.errors.MISSING_NEW, { name: a.name });
  }
  static globalLogger() {
    return _globalLogger || (_globalLogger = new Logger(version$8)), _globalLogger;
  }
  static setCensorship(t, a) {
    if (!t && a && this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), _permanentCensorErrors) {
      if (!t)
        return;
      this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    _censorErrors = !!t, _permanentCensorErrors = !!a;
  }
  static setLogLevel(t) {
    const a = LogLevels[t.toLowerCase()];
    if (a == null) {
      Logger.globalLogger().warn("invalid log level - " + t);
      return;
    }
    _logLevel = a;
  }
  static from(t) {
    return new Logger(t);
  }
}
Logger.errors = ErrorCode;
Logger.levels = LogLevel$1;
const version$7 = "bytes/5.7.0", logger$a = new Logger(version$7);
function isHexable(u) {
  return !!u.toHexString;
}
function addSlice(u) {
  return u.slice || (u.slice = function() {
    const t = Array.prototype.slice.call(arguments);
    return addSlice(new Uint8Array(Array.prototype.slice.apply(u, t)));
  }), u;
}
function isBytesLike(u) {
  return isHexString(u) && !(u.length % 2) || isBytes(u);
}
function isInteger(u) {
  return typeof u == "number" && u == u && u % 1 === 0;
}
function isBytes(u) {
  if (u == null)
    return !1;
  if (u.constructor === Uint8Array)
    return !0;
  if (typeof u == "string" || !isInteger(u.length) || u.length < 0)
    return !1;
  for (let t = 0; t < u.length; t++) {
    const a = u[t];
    if (!isInteger(a) || a < 0 || a >= 256)
      return !1;
  }
  return !0;
}
function arrayify(u, t) {
  if (t || (t = {}), typeof u == "number") {
    logger$a.checkSafeUint53(u, "invalid arrayify value");
    const a = [];
    for (; u; )
      a.unshift(u & 255), u = parseInt(String(u / 256));
    return a.length === 0 && a.push(0), addSlice(new Uint8Array(a));
  }
  if (t.allowMissingPrefix && typeof u == "string" && u.substring(0, 2) !== "0x" && (u = "0x" + u), isHexable(u) && (u = u.toHexString()), isHexString(u)) {
    let a = u.substring(2);
    a.length % 2 && (t.hexPad === "left" ? a = "0" + a : t.hexPad === "right" ? a += "0" : logger$a.throwArgumentError("hex data is odd-length", "value", u));
    const d = [];
    for (let l = 0; l < a.length; l += 2)
      d.push(parseInt(a.substring(l, l + 2), 16));
    return addSlice(new Uint8Array(d));
  }
  return isBytes(u) ? addSlice(new Uint8Array(u)) : logger$a.throwArgumentError("invalid arrayify value", "value", u);
}
function concat(u) {
  const t = u.map((l) => arrayify(l)), a = t.reduce((l, h) => l + h.length, 0), d = new Uint8Array(a);
  return t.reduce((l, h) => (d.set(h, l), l + h.length), 0), addSlice(d);
}
function isHexString(u, t) {
  return !(typeof u != "string" || !u.match(/^0x[0-9A-Fa-f]*$/) || t && u.length !== 2 + 2 * t);
}
const HexCharacters = "0123456789abcdef";
function hexlify(u, t) {
  if (t || (t = {}), typeof u == "number") {
    logger$a.checkSafeUint53(u, "invalid hexlify value");
    let a = "";
    for (; u; )
      a = HexCharacters[u & 15] + a, u = Math.floor(u / 16);
    return a.length ? (a.length % 2 && (a = "0" + a), "0x" + a) : "0x00";
  }
  if (typeof u == "bigint")
    return u = u.toString(16), u.length % 2 ? "0x0" + u : "0x" + u;
  if (t.allowMissingPrefix && typeof u == "string" && u.substring(0, 2) !== "0x" && (u = "0x" + u), isHexable(u))
    return u.toHexString();
  if (isHexString(u))
    return u.length % 2 && (t.hexPad === "left" ? u = "0x0" + u.substring(2) : t.hexPad === "right" ? u += "0" : logger$a.throwArgumentError("hex data is odd-length", "value", u)), u.toLowerCase();
  if (isBytes(u)) {
    let a = "0x";
    for (let d = 0; d < u.length; d++) {
      let l = u[d];
      a += HexCharacters[(l & 240) >> 4] + HexCharacters[l & 15];
    }
    return a;
  }
  return logger$a.throwArgumentError("invalid hexlify value", "value", u);
}
function hexConcat(u) {
  let t = "0x";
  return u.forEach((a) => {
    t += hexlify(a).substring(2);
  }), t;
}
function hexZeroPad(u, t) {
  for (typeof u != "string" ? u = hexlify(u) : isHexString(u) || logger$a.throwArgumentError("invalid hex string", "value", u), u.length > 2 * t + 2 && logger$a.throwArgumentError("value out of range", "value", arguments[1]); u.length < 2 * t + 2; )
    u = "0x0" + u.substring(2);
  return u;
}
const version$6 = "bignumber/5.7.0";
var BN = _BN.BN;
const logger$9 = new Logger(version$6), _constructorGuard$2 = {}, MAX_SAFE = 9007199254740991;
function isBigNumberish(u) {
  return u != null && (BigNumber.isBigNumber(u) || typeof u == "number" && u % 1 === 0 || typeof u == "string" && !!u.match(/^-?[0-9]+$/) || isHexString(u) || typeof u == "bigint" || isBytes(u));
}
let _warnedToStringRadix = !1;
class BigNumber {
  constructor(t, a) {
    t !== _constructorGuard$2 && logger$9.throwError("cannot call constructor directly; use BigNumber.from", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new (BigNumber)"
    }), this._hex = a, this._isBigNumber = !0, Object.freeze(this);
  }
  fromTwos(t) {
    return toBigNumber(toBN(this).fromTwos(t));
  }
  toTwos(t) {
    return toBigNumber(toBN(this).toTwos(t));
  }
  abs() {
    return this._hex[0] === "-" ? BigNumber.from(this._hex.substring(1)) : this;
  }
  add(t) {
    return toBigNumber(toBN(this).add(toBN(t)));
  }
  sub(t) {
    return toBigNumber(toBN(this).sub(toBN(t)));
  }
  div(t) {
    return BigNumber.from(t).isZero() && throwFault$1("division-by-zero", "div"), toBigNumber(toBN(this).div(toBN(t)));
  }
  mul(t) {
    return toBigNumber(toBN(this).mul(toBN(t)));
  }
  mod(t) {
    const a = toBN(t);
    return a.isNeg() && throwFault$1("division-by-zero", "mod"), toBigNumber(toBN(this).umod(a));
  }
  pow(t) {
    const a = toBN(t);
    return a.isNeg() && throwFault$1("negative-power", "pow"), toBigNumber(toBN(this).pow(a));
  }
  and(t) {
    const a = toBN(t);
    return (this.isNegative() || a.isNeg()) && throwFault$1("unbound-bitwise-result", "and"), toBigNumber(toBN(this).and(a));
  }
  or(t) {
    const a = toBN(t);
    return (this.isNegative() || a.isNeg()) && throwFault$1("unbound-bitwise-result", "or"), toBigNumber(toBN(this).or(a));
  }
  xor(t) {
    const a = toBN(t);
    return (this.isNegative() || a.isNeg()) && throwFault$1("unbound-bitwise-result", "xor"), toBigNumber(toBN(this).xor(a));
  }
  mask(t) {
    return (this.isNegative() || t < 0) && throwFault$1("negative-width", "mask"), toBigNumber(toBN(this).maskn(t));
  }
  shl(t) {
    return (this.isNegative() || t < 0) && throwFault$1("negative-width", "shl"), toBigNumber(toBN(this).shln(t));
  }
  shr(t) {
    return (this.isNegative() || t < 0) && throwFault$1("negative-width", "shr"), toBigNumber(toBN(this).shrn(t));
  }
  eq(t) {
    return toBN(this).eq(toBN(t));
  }
  lt(t) {
    return toBN(this).lt(toBN(t));
  }
  lte(t) {
    return toBN(this).lte(toBN(t));
  }
  gt(t) {
    return toBN(this).gt(toBN(t));
  }
  gte(t) {
    return toBN(this).gte(toBN(t));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return toBN(this).isZero();
  }
  toNumber() {
    try {
      return toBN(this).toNumber();
    } catch {
      throwFault$1("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch {
    }
    return logger$9.throwError("this platform does not support BigInt", Logger.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    return arguments.length > 0 && (arguments[0] === 10 ? _warnedToStringRadix || (_warnedToStringRadix = !0, logger$9.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? logger$9.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", Logger.errors.UNEXPECTED_ARGUMENT, {}) : logger$9.throwError("BigNumber.toString does not accept parameters", Logger.errors.UNEXPECTED_ARGUMENT, {})), toBN(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(t) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(t) {
    if (t instanceof BigNumber)
      return t;
    if (typeof t == "string")
      return t.match(/^-?0x[0-9a-f]+$/i) ? new BigNumber(_constructorGuard$2, toHex(t)) : t.match(/^-?[0-9]+$/) ? new BigNumber(_constructorGuard$2, toHex(new BN(t))) : logger$9.throwArgumentError("invalid BigNumber string", "value", t);
    if (typeof t == "number")
      return t % 1 && throwFault$1("underflow", "BigNumber.from", t), (t >= MAX_SAFE || t <= -MAX_SAFE) && throwFault$1("overflow", "BigNumber.from", t), BigNumber.from(String(t));
    const a = t;
    if (typeof a == "bigint")
      return BigNumber.from(a.toString());
    if (isBytes(a))
      return BigNumber.from(hexlify(a));
    if (a)
      if (a.toHexString) {
        const d = a.toHexString();
        if (typeof d == "string")
          return BigNumber.from(d);
      } else {
        let d = a._hex;
        if (d == null && a.type === "BigNumber" && (d = a.hex), typeof d == "string" && (isHexString(d) || d[0] === "-" && isHexString(d.substring(1))))
          return BigNumber.from(d);
      }
    return logger$9.throwArgumentError("invalid BigNumber value", "value", t);
  }
  static isBigNumber(t) {
    return !!(t && t._isBigNumber);
  }
}
function toHex(u) {
  if (typeof u != "string")
    return toHex(u.toString(16));
  if (u[0] === "-")
    return u = u.substring(1), u[0] === "-" && logger$9.throwArgumentError("invalid hex", "value", u), u = toHex(u), u === "0x00" ? u : "-" + u;
  if (u.substring(0, 2) !== "0x" && (u = "0x" + u), u === "0x")
    return "0x00";
  for (u.length % 2 && (u = "0x0" + u.substring(2)); u.length > 4 && u.substring(0, 4) === "0x00"; )
    u = "0x" + u.substring(4);
  return u;
}
function toBigNumber(u) {
  return BigNumber.from(toHex(u));
}
function toBN(u) {
  const t = BigNumber.from(u).toHexString();
  return t[0] === "-" ? new BN("-" + t.substring(3), 16) : new BN(t.substring(2), 16);
}
function throwFault$1(u, t, a) {
  const d = { fault: u, operation: t };
  return a != null && (d.value = a), logger$9.throwError(u, Logger.errors.NUMERIC_FAULT, d);
}
function _base36To16(u) {
  return new BN(u, 36).toString(16);
}
const logger$8 = new Logger(version$6), _constructorGuard$1 = {}, Zero$1 = BigNumber.from(0), NegativeOne$1 = BigNumber.from(-1);
function throwFault(u, t, a, d) {
  const l = { fault: t, operation: a };
  return d !== void 0 && (l.value = d), logger$8.throwError(u, Logger.errors.NUMERIC_FAULT, l);
}
let zeros = "0";
for (; zeros.length < 256; )
  zeros += zeros;
function getMultiplier(u) {
  if (typeof u != "number")
    try {
      u = BigNumber.from(u).toNumber();
    } catch {
    }
  return typeof u == "number" && u >= 0 && u <= 256 && !(u % 1) ? "1" + zeros.substring(0, u) : logger$8.throwArgumentError("invalid decimal size", "decimals", u);
}
function formatFixed(u, t) {
  t == null && (t = 0);
  const a = getMultiplier(t);
  u = BigNumber.from(u);
  const d = u.lt(Zero$1);
  d && (u = u.mul(NegativeOne$1));
  let l = u.mod(a).toString();
  for (; l.length < a.length - 1; )
    l = "0" + l;
  l = l.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  const h = u.div(a).toString();
  return a.length === 1 ? u = h : u = h + "." + l, d && (u = "-" + u), u;
}
function parseFixed(u, t) {
  t == null && (t = 0);
  const a = getMultiplier(t);
  (typeof u != "string" || !u.match(/^-?[0-9.]+$/)) && logger$8.throwArgumentError("invalid decimal value", "value", u);
  const d = u.substring(0, 1) === "-";
  d && (u = u.substring(1)), u === "." && logger$8.throwArgumentError("missing value", "value", u);
  const l = u.split(".");
  l.length > 2 && logger$8.throwArgumentError("too many decimal points", "value", u);
  let h = l[0], g = l[1];
  for (h || (h = "0"), g || (g = "0"); g[g.length - 1] === "0"; )
    g = g.substring(0, g.length - 1);
  for (g.length > a.length - 1 && throwFault("fractional component exceeds decimals", "underflow", "parseFixed"), g === "" && (g = "0"); g.length < a.length - 1; )
    g += "0";
  const c = BigNumber.from(h), x = BigNumber.from(g);
  let R = c.mul(a).add(x);
  return d && (R = R.mul(NegativeOne$1)), R;
}
class FixedFormat {
  constructor(t, a, d, l) {
    t !== _constructorGuard$1 && logger$8.throwError("cannot use FixedFormat constructor; use FixedFormat.from", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.signed = a, this.width = d, this.decimals = l, this.name = (a ? "" : "u") + "fixed" + String(d) + "x" + String(l), this._multiplier = getMultiplier(l), Object.freeze(this);
  }
  static from(t) {
    if (t instanceof FixedFormat)
      return t;
    typeof t == "number" && (t = `fixed128x${t}`);
    let a = !0, d = 128, l = 18;
    if (typeof t == "string") {
      if (t !== "fixed")
        if (t === "ufixed")
          a = !1;
        else {
          const h = t.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
          h || logger$8.throwArgumentError("invalid fixed format", "format", t), a = h[1] !== "u", d = parseInt(h[2]), l = parseInt(h[3]);
        }
    } else if (t) {
      const h = (g, c, x) => t[g] == null ? x : (typeof t[g] !== c && logger$8.throwArgumentError("invalid fixed format (" + g + " not " + c + ")", "format." + g, t[g]), t[g]);
      a = h("signed", "boolean", a), d = h("width", "number", d), l = h("decimals", "number", l);
    }
    return d % 8 && logger$8.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", d), l > 80 && logger$8.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", l), new FixedFormat(_constructorGuard$1, a, d, l);
  }
}
class FixedNumber {
  constructor(t, a, d, l) {
    t !== _constructorGuard$1 && logger$8.throwError("cannot use FixedNumber constructor; use FixedNumber.from", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.format = l, this._hex = a, this._value = d, this._isFixedNumber = !0, Object.freeze(this);
  }
  _checkFormat(t) {
    this.format.name !== t.format.name && logger$8.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", t);
  }
  addUnsafe(t) {
    this._checkFormat(t);
    const a = parseFixed(this._value, this.format.decimals), d = parseFixed(t._value, t.format.decimals);
    return FixedNumber.fromValue(a.add(d), this.format.decimals, this.format);
  }
  subUnsafe(t) {
    this._checkFormat(t);
    const a = parseFixed(this._value, this.format.decimals), d = parseFixed(t._value, t.format.decimals);
    return FixedNumber.fromValue(a.sub(d), this.format.decimals, this.format);
  }
  mulUnsafe(t) {
    this._checkFormat(t);
    const a = parseFixed(this._value, this.format.decimals), d = parseFixed(t._value, t.format.decimals);
    return FixedNumber.fromValue(a.mul(d).div(this.format._multiplier), this.format.decimals, this.format);
  }
  divUnsafe(t) {
    this._checkFormat(t);
    const a = parseFixed(this._value, this.format.decimals), d = parseFixed(t._value, t.format.decimals);
    return FixedNumber.fromValue(a.mul(this.format._multiplier).div(d), this.format.decimals, this.format);
  }
  floor() {
    const t = this.toString().split(".");
    t.length === 1 && t.push("0");
    let a = FixedNumber.from(t[0], this.format);
    const d = !t[1].match(/^(0*)$/);
    return this.isNegative() && d && (a = a.subUnsafe(ONE.toFormat(a.format))), a;
  }
  ceiling() {
    const t = this.toString().split(".");
    t.length === 1 && t.push("0");
    let a = FixedNumber.from(t[0], this.format);
    const d = !t[1].match(/^(0*)$/);
    return !this.isNegative() && d && (a = a.addUnsafe(ONE.toFormat(a.format))), a;
  }
  round(t) {
    t == null && (t = 0);
    const a = this.toString().split(".");
    if (a.length === 1 && a.push("0"), (t < 0 || t > 80 || t % 1) && logger$8.throwArgumentError("invalid decimal count", "decimals", t), a[1].length <= t)
      return this;
    const d = FixedNumber.from("1" + zeros.substring(0, t), this.format), l = BUMP.toFormat(this.format);
    return this.mulUnsafe(d).addUnsafe(l).floor().divUnsafe(d);
  }
  isZero() {
    return this._value === "0.0" || this._value === "0";
  }
  isNegative() {
    return this._value[0] === "-";
  }
  toString() {
    return this._value;
  }
  toHexString(t) {
    if (t == null)
      return this._hex;
    t % 8 && logger$8.throwArgumentError("invalid byte width", "width", t);
    const a = BigNumber.from(this._hex).fromTwos(this.format.width).toTwos(t).toHexString();
    return hexZeroPad(a, t / 8);
  }
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  toFormat(t) {
    return FixedNumber.fromString(this._value, t);
  }
  static fromValue(t, a, d) {
    return d == null && a != null && !isBigNumberish(a) && (d = a, a = null), a == null && (a = 0), d == null && (d = "fixed"), FixedNumber.fromString(formatFixed(t, a), FixedFormat.from(d));
  }
  static fromString(t, a) {
    a == null && (a = "fixed");
    const d = FixedFormat.from(a), l = parseFixed(t, d.decimals);
    !d.signed && l.lt(Zero$1) && throwFault("unsigned value cannot be negative", "overflow", "value", t);
    let h = null;
    d.signed ? h = l.toTwos(d.width).toHexString() : (h = l.toHexString(), h = hexZeroPad(h, d.width / 8));
    const g = formatFixed(l, d.decimals);
    return new FixedNumber(_constructorGuard$1, h, g, d);
  }
  static fromBytes(t, a) {
    a == null && (a = "fixed");
    const d = FixedFormat.from(a);
    if (arrayify(t).length > d.width / 8)
      throw new Error("overflow");
    let l = BigNumber.from(t);
    d.signed && (l = l.fromTwos(d.width));
    const h = l.toTwos((d.signed ? 0 : 1) + d.width).toHexString(), g = formatFixed(l, d.decimals);
    return new FixedNumber(_constructorGuard$1, h, g, d);
  }
  static from(t, a) {
    if (typeof t == "string")
      return FixedNumber.fromString(t, a);
    if (isBytes(t))
      return FixedNumber.fromBytes(t, a);
    try {
      return FixedNumber.fromValue(t, 0, a);
    } catch (d) {
      if (d.code !== Logger.errors.INVALID_ARGUMENT)
        throw d;
    }
    return logger$8.throwArgumentError("invalid FixedNumber value", "value", t);
  }
  static isFixedNumber(t) {
    return !!(t && t._isFixedNumber);
  }
}
const ONE = FixedNumber.from(1), BUMP = FixedNumber.from("0.5"), version$5 = "properties/5.7.0";
globalThis && globalThis.__awaiter;
new Logger(version$5);
function defineReadOnly(u, t, a) {
  Object.defineProperty(u, t, {
    enumerable: !0,
    value: a,
    writable: !1
  });
}
const version$4 = "abi/5.7.0", logger$7 = new Logger(version$4), _constructorGuard = {};
let ModifiersBytes = { calldata: !0, memory: !0, storage: !0 }, ModifiersNest = { calldata: !0, memory: !0 };
function checkModifier(u, t) {
  if (u === "bytes" || u === "string") {
    if (ModifiersBytes[t])
      return !0;
  } else if (u === "address") {
    if (t === "payable")
      return !0;
  } else if ((u.indexOf("[") >= 0 || u === "tuple") && ModifiersNest[t])
    return !0;
  return (ModifiersBytes[t] || t === "payable") && logger$7.throwArgumentError("invalid modifier", "name", t), !1;
}
function parseParamType(u, t) {
  let a = u;
  function d(c) {
    logger$7.throwArgumentError(`unexpected character at position ${c}`, "param", u);
  }
  u = u.replace(/\s/g, " ");
  function l(c) {
    let x = { type: "", name: "", parent: c, state: { allowType: !0 } };
    return t && (x.indexed = !1), x;
  }
  let h = { type: "", name: "", state: { allowType: !0 } }, g = h;
  for (let c = 0; c < u.length; c++) {
    let x = u[c];
    switch (x) {
      case "(":
        g.state.allowType && g.type === "" ? g.type = "tuple" : g.state.allowParams || d(c), g.state.allowType = !1, g.type = verifyType(g.type), g.components = [l(g)], g = g.components[0];
        break;
      case ")":
        delete g.state, g.name === "indexed" && (t || d(c), g.indexed = !0, g.name = ""), checkModifier(g.type, g.name) && (g.name = ""), g.type = verifyType(g.type);
        let R = g;
        g = g.parent, g || d(c), delete R.parent, g.state.allowParams = !1, g.state.allowName = !0, g.state.allowArray = !0;
        break;
      case ",":
        delete g.state, g.name === "indexed" && (t || d(c), g.indexed = !0, g.name = ""), checkModifier(g.type, g.name) && (g.name = ""), g.type = verifyType(g.type);
        let B = l(g.parent);
        g.parent.components.push(B), delete g.parent, g = B;
        break;
      case " ":
        g.state.allowType && g.type !== "" && (g.type = verifyType(g.type), delete g.state.allowType, g.state.allowName = !0, g.state.allowParams = !0), g.state.allowName && g.name !== "" && (g.name === "indexed" ? (t || d(c), g.indexed && d(c), g.indexed = !0, g.name = "") : checkModifier(g.type, g.name) ? g.name = "" : g.state.allowName = !1);
        break;
      case "[":
        g.state.allowArray || d(c), g.type += x, g.state.allowArray = !1, g.state.allowName = !1, g.state.readArray = !0;
        break;
      case "]":
        g.state.readArray || d(c), g.type += x, g.state.readArray = !1, g.state.allowArray = !0, g.state.allowName = !0;
        break;
      default:
        g.state.allowType ? (g.type += x, g.state.allowParams = !0, g.state.allowArray = !0) : g.state.allowName ? (g.name += x, delete g.state.allowArray) : g.state.readArray ? g.type += x : d(c);
    }
  }
  return g.parent && logger$7.throwArgumentError("unexpected eof", "param", u), delete h.state, g.name === "indexed" ? (t || d(a.length - 7), g.indexed && d(a.length - 7), g.indexed = !0, g.name = "") : checkModifier(g.type, g.name) && (g.name = ""), h.type = verifyType(h.type), h;
}
function populate(u, t) {
  for (let a in t)
    defineReadOnly(u, a, t[a]);
}
const FormatTypes = Object.freeze({
  sighash: "sighash",
  minimal: "minimal",
  full: "full",
  json: "json"
}), paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class ParamType {
  constructor(t, a) {
    t !== _constructorGuard && logger$7.throwError("use fromString", Logger.errors.UNSUPPORTED_OPERATION, {
      operation: "new ParamType()"
    }), populate(this, a);
    let d = this.type.match(paramTypeArray);
    d ? populate(this, {
      arrayLength: parseInt(d[2] || "-1"),
      arrayChildren: ParamType.fromObject({
        type: d[1],
        components: this.components
      }),
      baseType: "array"
    }) : populate(this, {
      arrayLength: null,
      arrayChildren: null,
      baseType: this.components != null ? "tuple" : this.type
    }), this._isParamType = !0, Object.freeze(this);
  }
  format(t) {
    if (t || (t = FormatTypes.sighash), FormatTypes[t] || logger$7.throwArgumentError("invalid format type", "format", t), t === FormatTypes.json) {
      let d = {
        type: this.baseType === "tuple" ? "tuple" : this.type,
        name: this.name || void 0
      };
      return typeof this.indexed == "boolean" && (d.indexed = this.indexed), this.components && (d.components = this.components.map((l) => JSON.parse(l.format(t)))), JSON.stringify(d);
    }
    let a = "";
    return this.baseType === "array" ? (a += this.arrayChildren.format(t), a += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]") : this.baseType === "tuple" ? (t !== FormatTypes.sighash && (a += this.type), a += "(" + this.components.map((d) => d.format(t)).join(t === FormatTypes.full ? ", " : ",") + ")") : a += this.type, t !== FormatTypes.sighash && (this.indexed === !0 && (a += " indexed"), t === FormatTypes.full && this.name && (a += " " + this.name)), a;
  }
  static from(t, a) {
    return typeof t == "string" ? ParamType.fromString(t, a) : ParamType.fromObject(t);
  }
  static fromObject(t) {
    return ParamType.isParamType(t) ? t : new ParamType(_constructorGuard, {
      name: t.name || null,
      type: verifyType(t.type),
      indexed: t.indexed == null ? null : !!t.indexed,
      components: t.components ? t.components.map(ParamType.fromObject) : null
    });
  }
  static fromString(t, a) {
    function d(l) {
      return ParamType.fromObject({
        name: l.name,
        type: l.type,
        indexed: l.indexed,
        components: l.components
      });
    }
    return d(parseParamType(t, !!a));
  }
  static isParamType(t) {
    return !!(t != null && t._isParamType);
  }
}
function verifyType(u) {
  return u.match(/^uint($|[^1-9])/) ? u = "uint256" + u.substring(4) : u.match(/^int($|[^1-9])/) && (u = "int256" + u.substring(3)), u;
}
const logger$6 = new Logger(version$4);
class Coder {
  constructor(t, a, d, l) {
    this.name = t, this.type = a, this.localName = d, this.dynamic = l;
  }
  _throwError(t, a) {
    logger$6.throwArgumentError(t, this.localName, a);
  }
}
class Writer {
  constructor(t) {
    defineReadOnly(this, "wordSize", t || 32), this._data = [], this._dataLength = 0, this._padding = new Uint8Array(t);
  }
  get data() {
    return hexConcat(this._data);
  }
  get length() {
    return this._dataLength;
  }
  _writeData(t) {
    return this._data.push(t), this._dataLength += t.length, t.length;
  }
  appendWriter(t) {
    return this._writeData(concat(t._data));
  }
  writeBytes(t) {
    let a = arrayify(t);
    const d = a.length % this.wordSize;
    return d && (a = concat([a, this._padding.slice(d)])), this._writeData(a);
  }
  _getValue(t) {
    let a = arrayify(BigNumber.from(t));
    return a.length > this.wordSize && logger$6.throwError("value out-of-bounds", Logger.errors.BUFFER_OVERRUN, {
      length: this.wordSize,
      offset: a.length
    }), a.length % this.wordSize && (a = concat([this._padding.slice(a.length % this.wordSize), a])), a;
  }
  writeValue(t) {
    return this._writeData(this._getValue(t));
  }
  writeUpdatableValue() {
    const t = this._data.length;
    return this._data.push(this._padding), this._dataLength += this.wordSize, (a) => {
      this._data[t] = this._getValue(a);
    };
  }
}
class Reader {
  constructor(t, a, d, l) {
    defineReadOnly(this, "_data", arrayify(t)), defineReadOnly(this, "wordSize", a || 32), defineReadOnly(this, "_coerceFunc", d), defineReadOnly(this, "allowLoose", l), this._offset = 0;
  }
  get data() {
    return hexlify(this._data);
  }
  get consumed() {
    return this._offset;
  }
  static coerce(t, a) {
    let d = t.match("^u?int([0-9]+)$");
    return d && parseInt(d[1]) <= 48 && (a = a.toNumber()), a;
  }
  coerce(t, a) {
    return this._coerceFunc ? this._coerceFunc(t, a) : Reader.coerce(t, a);
  }
  _peekBytes(t, a, d) {
    let l = Math.ceil(a / this.wordSize) * this.wordSize;
    return this._offset + l > this._data.length && (this.allowLoose && d && this._offset + a <= this._data.length ? l = a : logger$6.throwError("data out-of-bounds", Logger.errors.BUFFER_OVERRUN, {
      length: this._data.length,
      offset: this._offset + l
    })), this._data.slice(this._offset, this._offset + l);
  }
  subReader(t) {
    return new Reader(this._data.slice(this._offset + t), this.wordSize, this._coerceFunc, this.allowLoose);
  }
  readBytes(t, a) {
    let d = this._peekBytes(0, t, !!a);
    return this._offset += d.length, d.slice(0, t);
  }
  readValue() {
    return BigNumber.from(this.readBytes(this.wordSize));
  }
}
var sha3$1 = { exports: {} };
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */
(function(u) {
  (function() {
    var t = "input is invalid type", a = "finalize already called", d = typeof window == "object", l = d ? window : {};
    l.JS_SHA3_NO_WINDOW && (d = !1);
    var h = !d && typeof self == "object", g = !l.JS_SHA3_NO_NODE_JS && typeof process == "object" && process.versions && process.versions.node;
    g ? l = commonjsGlobal : h && (l = self);
    var c = !l.JS_SHA3_NO_COMMON_JS && !0 && u.exports, x = !l.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", R = "0123456789abcdef".split(""), B = [31, 7936, 2031616, 520093696], j = [4, 1024, 262144, 67108864], o = [1, 256, 65536, 16777216], e = [6, 1536, 393216, 100663296], n = [0, 8, 16, 24], i = [
      1,
      0,
      32898,
      0,
      32906,
      2147483648,
      2147516416,
      2147483648,
      32907,
      0,
      2147483649,
      0,
      2147516545,
      2147483648,
      32777,
      2147483648,
      138,
      0,
      136,
      0,
      2147516425,
      0,
      2147483658,
      0,
      2147516555,
      0,
      139,
      2147483648,
      32905,
      2147483648,
      32771,
      2147483648,
      32770,
      2147483648,
      128,
      2147483648,
      32778,
      0,
      2147483658,
      2147483648,
      2147516545,
      2147483648,
      32896,
      2147483648,
      2147483649,
      0,
      2147516424,
      2147483648
    ], y = [224, 256, 384, 512], m = [128, 256], U = ["hex", "buffer", "arrayBuffer", "array", "digest"], be = {
      128: 168,
      256: 136
    };
    (l.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(D) {
      return Object.prototype.toString.call(D) === "[object Array]";
    }), x && (l.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(D) {
      return typeof D == "object" && D.buffer && D.buffer.constructor === ArrayBuffer;
    });
    for (var Ke = function(D, V, Z) {
      return function(J) {
        return new I(D, V, D).update(J)[Z]();
      };
    }, ze = function(D, V, Z) {
      return function(J, ee) {
        return new I(D, V, ee).update(J)[Z]();
      };
    }, Pe = function(D, V, Z) {
      return function(J, ee, he, le) {
        return p["cshake" + D].update(J, ee, he, le)[Z]();
      };
    }, st = function(D, V, Z) {
      return function(J, ee, he, le) {
        return p["kmac" + D].update(J, ee, he, le)[Z]();
      };
    }, G = function(D, V, Z, J) {
      for (var ee = 0; ee < U.length; ++ee) {
        var he = U[ee];
        D[he] = V(Z, J, he);
      }
      return D;
    }, z = function(D, V) {
      var Z = Ke(D, V, "hex");
      return Z.create = function() {
        return new I(D, V, D);
      }, Z.update = function(J) {
        return Z.create().update(J);
      }, G(Z, Ke, D, V);
    }, W = function(D, V) {
      var Z = ze(D, V, "hex");
      return Z.create = function(J) {
        return new I(D, V, J);
      }, Z.update = function(J, ee) {
        return Z.create(ee).update(J);
      }, G(Z, ze, D, V);
    }, F = function(D, V) {
      var Z = be[D], J = Pe(D, V, "hex");
      return J.create = function(ee, he, le) {
        return !he && !le ? p["shake" + D].create(ee) : new I(D, V, ee).bytepad([he, le], Z);
      }, J.update = function(ee, he, le, ie) {
        return J.create(he, le, ie).update(ee);
      }, G(J, Pe, D, V);
    }, k = function(D, V) {
      var Z = be[D], J = st(D, V, "hex");
      return J.create = function(ee, he, le) {
        return new C(D, V, he).bytepad(["KMAC", le], Z).bytepad([ee], Z);
      }, J.update = function(ee, he, le, ie) {
        return J.create(ee, le, ie).update(he);
      }, G(J, st, D, V);
    }, T = [
      { name: "keccak", padding: o, bits: y, createMethod: z },
      { name: "sha3", padding: e, bits: y, createMethod: z },
      { name: "shake", padding: B, bits: m, createMethod: W },
      { name: "cshake", padding: j, bits: m, createMethod: F },
      { name: "kmac", padding: j, bits: m, createMethod: k }
    ], p = {}, b = [], _ = 0; _ < T.length; ++_)
      for (var v = T[_], S = v.bits, E = 0; E < S.length; ++E) {
        var w = v.name + "_" + S[E];
        if (b.push(w), p[w] = v.createMethod(S[E], v.padding), v.name !== "sha3") {
          var A = v.name + S[E];
          b.push(A), p[A] = p[w];
        }
      }
    function I(D, V, Z) {
      this.blocks = [], this.s = [], this.padding = V, this.outputBits = Z, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (D << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = Z >> 5, this.extraBytes = (Z & 31) >> 3;
      for (var J = 0; J < 50; ++J)
        this.s[J] = 0;
    }
    I.prototype.update = function(D) {
      if (this.finalized)
        throw new Error(a);
      var V, Z = typeof D;
      if (Z !== "string") {
        if (Z === "object") {
          if (D === null)
            throw new Error(t);
          if (x && D.constructor === ArrayBuffer)
            D = new Uint8Array(D);
          else if (!Array.isArray(D) && (!x || !ArrayBuffer.isView(D)))
            throw new Error(t);
        } else
          throw new Error(t);
        V = !0;
      }
      for (var J = this.blocks, ee = this.byteCount, he = D.length, le = this.blockCount, ie = 0, Ne = this.s, ue, se; ie < he; ) {
        if (this.reset)
          for (this.reset = !1, J[0] = this.block, ue = 1; ue < le + 1; ++ue)
            J[ue] = 0;
        if (V)
          for (ue = this.start; ie < he && ue < ee; ++ie)
            J[ue >> 2] |= D[ie] << n[ue++ & 3];
        else
          for (ue = this.start; ie < he && ue < ee; ++ie)
            se = D.charCodeAt(ie), se < 128 ? J[ue >> 2] |= se << n[ue++ & 3] : se < 2048 ? (J[ue >> 2] |= (192 | se >> 6) << n[ue++ & 3], J[ue >> 2] |= (128 | se & 63) << n[ue++ & 3]) : se < 55296 || se >= 57344 ? (J[ue >> 2] |= (224 | se >> 12) << n[ue++ & 3], J[ue >> 2] |= (128 | se >> 6 & 63) << n[ue++ & 3], J[ue >> 2] |= (128 | se & 63) << n[ue++ & 3]) : (se = 65536 + ((se & 1023) << 10 | D.charCodeAt(++ie) & 1023), J[ue >> 2] |= (240 | se >> 18) << n[ue++ & 3], J[ue >> 2] |= (128 | se >> 12 & 63) << n[ue++ & 3], J[ue >> 2] |= (128 | se >> 6 & 63) << n[ue++ & 3], J[ue >> 2] |= (128 | se & 63) << n[ue++ & 3]);
        if (this.lastByteIndex = ue, ue >= ee) {
          for (this.start = ue - ee, this.block = J[le], ue = 0; ue < le; ++ue)
            Ne[ue] ^= J[ue];
          X(Ne), this.reset = !0;
        } else
          this.start = ue;
      }
      return this;
    }, I.prototype.encode = function(D, V) {
      var Z = D & 255, J = 1, ee = [Z];
      for (D = D >> 8, Z = D & 255; Z > 0; )
        ee.unshift(Z), D = D >> 8, Z = D & 255, ++J;
      return V ? ee.push(J) : ee.unshift(J), this.update(ee), ee.length;
    }, I.prototype.encodeString = function(D) {
      var V, Z = typeof D;
      if (Z !== "string") {
        if (Z === "object") {
          if (D === null)
            throw new Error(t);
          if (x && D.constructor === ArrayBuffer)
            D = new Uint8Array(D);
          else if (!Array.isArray(D) && (!x || !ArrayBuffer.isView(D)))
            throw new Error(t);
        } else
          throw new Error(t);
        V = !0;
      }
      var J = 0, ee = D.length;
      if (V)
        J = ee;
      else
        for (var he = 0; he < D.length; ++he) {
          var le = D.charCodeAt(he);
          le < 128 ? J += 1 : le < 2048 ? J += 2 : le < 55296 || le >= 57344 ? J += 3 : (le = 65536 + ((le & 1023) << 10 | D.charCodeAt(++he) & 1023), J += 4);
        }
      return J += this.encode(J * 8), this.update(D), J;
    }, I.prototype.bytepad = function(D, V) {
      for (var Z = this.encode(V), J = 0; J < D.length; ++J)
        Z += this.encodeString(D[J]);
      var ee = V - Z % V, he = [];
      return he.length = ee, this.update(he), this;
    }, I.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var D = this.blocks, V = this.lastByteIndex, Z = this.blockCount, J = this.s;
        if (D[V >> 2] |= this.padding[V & 3], this.lastByteIndex === this.byteCount)
          for (D[0] = D[Z], V = 1; V < Z + 1; ++V)
            D[V] = 0;
        for (D[Z - 1] |= 2147483648, V = 0; V < Z; ++V)
          J[V] ^= D[V];
        X(J);
      }
    }, I.prototype.toString = I.prototype.hex = function() {
      this.finalize();
      for (var D = this.blockCount, V = this.s, Z = this.outputBlocks, J = this.extraBytes, ee = 0, he = 0, le = "", ie; he < Z; ) {
        for (ee = 0; ee < D && he < Z; ++ee, ++he)
          ie = V[ee], le += R[ie >> 4 & 15] + R[ie & 15] + R[ie >> 12 & 15] + R[ie >> 8 & 15] + R[ie >> 20 & 15] + R[ie >> 16 & 15] + R[ie >> 28 & 15] + R[ie >> 24 & 15];
        he % D === 0 && (X(V), ee = 0);
      }
      return J && (ie = V[ee], le += R[ie >> 4 & 15] + R[ie & 15], J > 1 && (le += R[ie >> 12 & 15] + R[ie >> 8 & 15]), J > 2 && (le += R[ie >> 20 & 15] + R[ie >> 16 & 15])), le;
    }, I.prototype.arrayBuffer = function() {
      this.finalize();
      var D = this.blockCount, V = this.s, Z = this.outputBlocks, J = this.extraBytes, ee = 0, he = 0, le = this.outputBits >> 3, ie;
      J ? ie = new ArrayBuffer(Z + 1 << 2) : ie = new ArrayBuffer(le);
      for (var Ne = new Uint32Array(ie); he < Z; ) {
        for (ee = 0; ee < D && he < Z; ++ee, ++he)
          Ne[he] = V[ee];
        he % D === 0 && X(V);
      }
      return J && (Ne[ee] = V[ee], ie = ie.slice(0, le)), ie;
    }, I.prototype.buffer = I.prototype.arrayBuffer, I.prototype.digest = I.prototype.array = function() {
      this.finalize();
      for (var D = this.blockCount, V = this.s, Z = this.outputBlocks, J = this.extraBytes, ee = 0, he = 0, le = [], ie, Ne; he < Z; ) {
        for (ee = 0; ee < D && he < Z; ++ee, ++he)
          ie = he << 2, Ne = V[ee], le[ie] = Ne & 255, le[ie + 1] = Ne >> 8 & 255, le[ie + 2] = Ne >> 16 & 255, le[ie + 3] = Ne >> 24 & 255;
        he % D === 0 && X(V);
      }
      return J && (ie = he << 2, Ne = V[ee], le[ie] = Ne & 255, J > 1 && (le[ie + 1] = Ne >> 8 & 255), J > 2 && (le[ie + 2] = Ne >> 16 & 255)), le;
    };
    function C(D, V, Z) {
      I.call(this, D, V, Z);
    }
    C.prototype = new I(), C.prototype.finalize = function() {
      return this.encode(this.outputBits, !0), I.prototype.finalize.call(this);
    };
    var X = function(D) {
      var V, Z, J, ee, he, le, ie, Ne, ue, se, ut, qe, ve, ot, He, Ae, ct, Ve, _e, lt, je, me, _t, tt, Le, mt, rt, De, gt, Ze, Ce, It, et, Ee, Tt, Xe, Fe, wt, We, Oe, ht, nt, Me, vt, at, ke, kt, M, L, $, O, P, H, q, Q, re, ae, te, ge, pe, Ie, we, Ue;
      for (J = 0; J < 48; J += 2)
        ee = D[0] ^ D[10] ^ D[20] ^ D[30] ^ D[40], he = D[1] ^ D[11] ^ D[21] ^ D[31] ^ D[41], le = D[2] ^ D[12] ^ D[22] ^ D[32] ^ D[42], ie = D[3] ^ D[13] ^ D[23] ^ D[33] ^ D[43], Ne = D[4] ^ D[14] ^ D[24] ^ D[34] ^ D[44], ue = D[5] ^ D[15] ^ D[25] ^ D[35] ^ D[45], se = D[6] ^ D[16] ^ D[26] ^ D[36] ^ D[46], ut = D[7] ^ D[17] ^ D[27] ^ D[37] ^ D[47], qe = D[8] ^ D[18] ^ D[28] ^ D[38] ^ D[48], ve = D[9] ^ D[19] ^ D[29] ^ D[39] ^ D[49], V = qe ^ (le << 1 | ie >>> 31), Z = ve ^ (ie << 1 | le >>> 31), D[0] ^= V, D[1] ^= Z, D[10] ^= V, D[11] ^= Z, D[20] ^= V, D[21] ^= Z, D[30] ^= V, D[31] ^= Z, D[40] ^= V, D[41] ^= Z, V = ee ^ (Ne << 1 | ue >>> 31), Z = he ^ (ue << 1 | Ne >>> 31), D[2] ^= V, D[3] ^= Z, D[12] ^= V, D[13] ^= Z, D[22] ^= V, D[23] ^= Z, D[32] ^= V, D[33] ^= Z, D[42] ^= V, D[43] ^= Z, V = le ^ (se << 1 | ut >>> 31), Z = ie ^ (ut << 1 | se >>> 31), D[4] ^= V, D[5] ^= Z, D[14] ^= V, D[15] ^= Z, D[24] ^= V, D[25] ^= Z, D[34] ^= V, D[35] ^= Z, D[44] ^= V, D[45] ^= Z, V = Ne ^ (qe << 1 | ve >>> 31), Z = ue ^ (ve << 1 | qe >>> 31), D[6] ^= V, D[7] ^= Z, D[16] ^= V, D[17] ^= Z, D[26] ^= V, D[27] ^= Z, D[36] ^= V, D[37] ^= Z, D[46] ^= V, D[47] ^= Z, V = se ^ (ee << 1 | he >>> 31), Z = ut ^ (he << 1 | ee >>> 31), D[8] ^= V, D[9] ^= Z, D[18] ^= V, D[19] ^= Z, D[28] ^= V, D[29] ^= Z, D[38] ^= V, D[39] ^= Z, D[48] ^= V, D[49] ^= Z, ot = D[0], He = D[1], ke = D[11] << 4 | D[10] >>> 28, kt = D[10] << 4 | D[11] >>> 28, De = D[20] << 3 | D[21] >>> 29, gt = D[21] << 3 | D[20] >>> 29, pe = D[31] << 9 | D[30] >>> 23, Ie = D[30] << 9 | D[31] >>> 23, nt = D[40] << 18 | D[41] >>> 14, Me = D[41] << 18 | D[40] >>> 14, Ee = D[2] << 1 | D[3] >>> 31, Tt = D[3] << 1 | D[2] >>> 31, Ae = D[13] << 12 | D[12] >>> 20, ct = D[12] << 12 | D[13] >>> 20, M = D[22] << 10 | D[23] >>> 22, L = D[23] << 10 | D[22] >>> 22, Ze = D[33] << 13 | D[32] >>> 19, Ce = D[32] << 13 | D[33] >>> 19, we = D[42] << 2 | D[43] >>> 30, Ue = D[43] << 2 | D[42] >>> 30, q = D[5] << 30 | D[4] >>> 2, Q = D[4] << 30 | D[5] >>> 2, Xe = D[14] << 6 | D[15] >>> 26, Fe = D[15] << 6 | D[14] >>> 26, Ve = D[25] << 11 | D[24] >>> 21, _e = D[24] << 11 | D[25] >>> 21, $ = D[34] << 15 | D[35] >>> 17, O = D[35] << 15 | D[34] >>> 17, It = D[45] << 29 | D[44] >>> 3, et = D[44] << 29 | D[45] >>> 3, tt = D[6] << 28 | D[7] >>> 4, Le = D[7] << 28 | D[6] >>> 4, re = D[17] << 23 | D[16] >>> 9, ae = D[16] << 23 | D[17] >>> 9, wt = D[26] << 25 | D[27] >>> 7, We = D[27] << 25 | D[26] >>> 7, lt = D[36] << 21 | D[37] >>> 11, je = D[37] << 21 | D[36] >>> 11, P = D[47] << 24 | D[46] >>> 8, H = D[46] << 24 | D[47] >>> 8, vt = D[8] << 27 | D[9] >>> 5, at = D[9] << 27 | D[8] >>> 5, mt = D[18] << 20 | D[19] >>> 12, rt = D[19] << 20 | D[18] >>> 12, te = D[29] << 7 | D[28] >>> 25, ge = D[28] << 7 | D[29] >>> 25, Oe = D[38] << 8 | D[39] >>> 24, ht = D[39] << 8 | D[38] >>> 24, me = D[48] << 14 | D[49] >>> 18, _t = D[49] << 14 | D[48] >>> 18, D[0] = ot ^ ~Ae & Ve, D[1] = He ^ ~ct & _e, D[10] = tt ^ ~mt & De, D[11] = Le ^ ~rt & gt, D[20] = Ee ^ ~Xe & wt, D[21] = Tt ^ ~Fe & We, D[30] = vt ^ ~ke & M, D[31] = at ^ ~kt & L, D[40] = q ^ ~re & te, D[41] = Q ^ ~ae & ge, D[2] = Ae ^ ~Ve & lt, D[3] = ct ^ ~_e & je, D[12] = mt ^ ~De & Ze, D[13] = rt ^ ~gt & Ce, D[22] = Xe ^ ~wt & Oe, D[23] = Fe ^ ~We & ht, D[32] = ke ^ ~M & $, D[33] = kt ^ ~L & O, D[42] = re ^ ~te & pe, D[43] = ae ^ ~ge & Ie, D[4] = Ve ^ ~lt & me, D[5] = _e ^ ~je & _t, D[14] = De ^ ~Ze & It, D[15] = gt ^ ~Ce & et, D[24] = wt ^ ~Oe & nt, D[25] = We ^ ~ht & Me, D[34] = M ^ ~$ & P, D[35] = L ^ ~O & H, D[44] = te ^ ~pe & we, D[45] = ge ^ ~Ie & Ue, D[6] = lt ^ ~me & ot, D[7] = je ^ ~_t & He, D[16] = Ze ^ ~It & tt, D[17] = Ce ^ ~et & Le, D[26] = Oe ^ ~nt & Ee, D[27] = ht ^ ~Me & Tt, D[36] = $ ^ ~P & vt, D[37] = O ^ ~H & at, D[46] = pe ^ ~we & q, D[47] = Ie ^ ~Ue & Q, D[8] = me ^ ~ot & Ae, D[9] = _t ^ ~He & ct, D[18] = It ^ ~tt & mt, D[19] = et ^ ~Le & rt, D[28] = nt ^ ~Ee & Xe, D[29] = Me ^ ~Tt & Fe, D[38] = P ^ ~vt & ke, D[39] = H ^ ~at & kt, D[48] = we ^ ~q & re, D[49] = Ue ^ ~Q & ae, D[0] ^= i[J], D[1] ^= i[J + 1];
    };
    if (c)
      u.exports = p;
    else
      for (_ = 0; _ < b.length; ++_)
        l[b[_]] = p[b[_]];
  })();
})(sha3$1);
const sha3 = sha3$1.exports;
function keccak256$1(u) {
  return "0x" + sha3.keccak_256(arrayify(u));
}
const version$3 = "rlp/5.7.0", logger$5 = new Logger(version$3);
function arrayifyInteger(u) {
  const t = [];
  for (; u; )
    t.unshift(u & 255), u >>= 8;
  return t;
}
function unarrayifyInteger(u, t, a) {
  let d = 0;
  for (let l = 0; l < a; l++)
    d = d * 256 + u[t + l];
  return d;
}
function _encode(u) {
  if (Array.isArray(u)) {
    let d = [];
    if (u.forEach(function(h) {
      d = d.concat(_encode(h));
    }), d.length <= 55)
      return d.unshift(192 + d.length), d;
    const l = arrayifyInteger(d.length);
    return l.unshift(247 + l.length), l.concat(d);
  }
  isBytesLike(u) || logger$5.throwArgumentError("RLP object must be BytesLike", "object", u);
  const t = Array.prototype.slice.call(arrayify(u));
  if (t.length === 1 && t[0] <= 127)
    return t;
  if (t.length <= 55)
    return t.unshift(128 + t.length), t;
  const a = arrayifyInteger(t.length);
  return a.unshift(183 + a.length), a.concat(t);
}
function encode(u) {
  return hexlify(_encode(u));
}
function _decodeChildren(u, t, a, d) {
  const l = [];
  for (; a < t + 1 + d; ) {
    const h = _decode(u, a);
    l.push(h.result), a += h.consumed, a > t + 1 + d && logger$5.throwError("child data too short", Logger.errors.BUFFER_OVERRUN, {});
  }
  return { consumed: 1 + d, result: l };
}
function _decode(u, t) {
  if (u.length === 0 && logger$5.throwError("data too short", Logger.errors.BUFFER_OVERRUN, {}), u[t] >= 248) {
    const a = u[t] - 247;
    t + 1 + a > u.length && logger$5.throwError("data short segment too short", Logger.errors.BUFFER_OVERRUN, {});
    const d = unarrayifyInteger(u, t + 1, a);
    return t + 1 + a + d > u.length && logger$5.throwError("data long segment too short", Logger.errors.BUFFER_OVERRUN, {}), _decodeChildren(u, t, t + 1 + a, a + d);
  } else if (u[t] >= 192) {
    const a = u[t] - 192;
    return t + 1 + a > u.length && logger$5.throwError("data array too short", Logger.errors.BUFFER_OVERRUN, {}), _decodeChildren(u, t, t + 1, a);
  } else if (u[t] >= 184) {
    const a = u[t] - 183;
    t + 1 + a > u.length && logger$5.throwError("data array too short", Logger.errors.BUFFER_OVERRUN, {});
    const d = unarrayifyInteger(u, t + 1, a);
    t + 1 + a + d > u.length && logger$5.throwError("data array too short", Logger.errors.BUFFER_OVERRUN, {});
    const l = hexlify(u.slice(t + 1 + a, t + 1 + a + d));
    return { consumed: 1 + a + d, result: l };
  } else if (u[t] >= 128) {
    const a = u[t] - 128;
    t + 1 + a > u.length && logger$5.throwError("data too short", Logger.errors.BUFFER_OVERRUN, {});
    const d = hexlify(u.slice(t + 1, t + 1 + a));
    return { consumed: 1 + a, result: d };
  }
  return { consumed: 1, result: hexlify(u[t]) };
}
function decode(u) {
  const t = arrayify(u), a = _decode(t, 0);
  return a.consumed !== t.length && logger$5.throwArgumentError("invalid rlp data", "data", u), a.result;
}
const version$2 = "address/5.7.0", logger$4 = new Logger(version$2);
function getChecksumAddress(u) {
  isHexString(u, 20) || logger$4.throwArgumentError("invalid address", "address", u), u = u.toLowerCase();
  const t = u.substring(2).split(""), a = new Uint8Array(40);
  for (let l = 0; l < 40; l++)
    a[l] = t[l].charCodeAt(0);
  const d = arrayify(keccak256$1(a));
  for (let l = 0; l < 40; l += 2)
    d[l >> 1] >> 4 >= 8 && (t[l] = t[l].toUpperCase()), (d[l >> 1] & 15) >= 8 && (t[l + 1] = t[l + 1].toUpperCase());
  return "0x" + t.join("");
}
const MAX_SAFE_INTEGER = 9007199254740991;
function log10(u) {
  return Math.log10 ? Math.log10(u) : Math.log(u) / Math.LN10;
}
const ibanLookup = {};
for (let u = 0; u < 10; u++)
  ibanLookup[String(u)] = String(u);
for (let u = 0; u < 26; u++)
  ibanLookup[String.fromCharCode(65 + u)] = String(10 + u);
const safeDigits = Math.floor(log10(MAX_SAFE_INTEGER));
function ibanChecksum(u) {
  u = u.toUpperCase(), u = u.substring(4) + u.substring(0, 2) + "00";
  let t = u.split("").map((d) => ibanLookup[d]).join("");
  for (; t.length >= safeDigits; ) {
    let d = t.substring(0, safeDigits);
    t = parseInt(d, 10) % 97 + t.substring(d.length);
  }
  let a = String(98 - parseInt(t, 10) % 97);
  for (; a.length < 2; )
    a = "0" + a;
  return a;
}
function getAddress(u) {
  let t = null;
  if (typeof u != "string" && logger$4.throwArgumentError("invalid address", "address", u), u.match(/^(0x)?[0-9a-fA-F]{40}$/))
    u.substring(0, 2) !== "0x" && (u = "0x" + u), t = getChecksumAddress(u), u.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && t !== u && logger$4.throwArgumentError("bad address checksum", "address", u);
  else if (u.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    for (u.substring(2, 4) !== ibanChecksum(u) && logger$4.throwArgumentError("bad icap checksum", "address", u), t = _base36To16(u.substring(4)); t.length < 40; )
      t = "0" + t;
    t = getChecksumAddress("0x" + t);
  } else
    logger$4.throwArgumentError("invalid address", "address", u);
  return t;
}
class AddressCoder extends Coder {
  constructor(t) {
    super("address", "address", t, !1);
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000";
  }
  encode(t, a) {
    try {
      a = getAddress(a);
    } catch (d) {
      this._throwError(d.message, a);
    }
    return t.writeValue(a);
  }
  decode(t) {
    return getAddress(hexZeroPad(t.readValue().toHexString(), 20));
  }
}
class AnonymousCoder extends Coder {
  constructor(t) {
    super(t.name, t.type, void 0, t.dynamic), this.coder = t;
  }
  defaultValue() {
    return this.coder.defaultValue();
  }
  encode(t, a) {
    return this.coder.encode(t, a);
  }
  decode(t) {
    return this.coder.decode(t);
  }
}
const logger$3 = new Logger(version$4);
function pack(u, t, a) {
  let d = null;
  if (Array.isArray(a))
    d = a;
  else if (a && typeof a == "object") {
    let x = {};
    d = t.map((R) => {
      const B = R.localName;
      return B || logger$3.throwError("cannot encode object for signature with missing names", Logger.errors.INVALID_ARGUMENT, {
        argument: "values",
        coder: R,
        value: a
      }), x[B] && logger$3.throwError("cannot encode object for signature with duplicate names", Logger.errors.INVALID_ARGUMENT, {
        argument: "values",
        coder: R,
        value: a
      }), x[B] = !0, a[B];
    });
  } else
    logger$3.throwArgumentError("invalid tuple value", "tuple", a);
  t.length !== d.length && logger$3.throwArgumentError("types/value length mismatch", "tuple", a);
  let l = new Writer(u.wordSize), h = new Writer(u.wordSize), g = [];
  t.forEach((x, R) => {
    let B = d[R];
    if (x.dynamic) {
      let j = h.length;
      x.encode(h, B);
      let o = l.writeUpdatableValue();
      g.push((e) => {
        o(e + j);
      });
    } else
      x.encode(l, B);
  }), g.forEach((x) => {
    x(l.length);
  });
  let c = u.appendWriter(l);
  return c += u.appendWriter(h), c;
}
function unpack(u, t) {
  let a = [], d = u.subReader(0);
  t.forEach((h) => {
    let g = null;
    if (h.dynamic) {
      let c = u.readValue(), x = d.subReader(c.toNumber());
      try {
        g = h.decode(x);
      } catch (R) {
        if (R.code === Logger.errors.BUFFER_OVERRUN)
          throw R;
        g = R, g.baseType = h.name, g.name = h.localName, g.type = h.type;
      }
    } else
      try {
        g = h.decode(u);
      } catch (c) {
        if (c.code === Logger.errors.BUFFER_OVERRUN)
          throw c;
        g = c, g.baseType = h.name, g.name = h.localName, g.type = h.type;
      }
    g != null && a.push(g);
  });
  const l = t.reduce((h, g) => {
    const c = g.localName;
    return c && (h[c] || (h[c] = 0), h[c]++), h;
  }, {});
  t.forEach((h, g) => {
    let c = h.localName;
    if (!c || l[c] !== 1 || (c === "length" && (c = "_length"), a[c] != null))
      return;
    const x = a[g];
    x instanceof Error ? Object.defineProperty(a, c, {
      enumerable: !0,
      get: () => {
        throw x;
      }
    }) : a[c] = x;
  });
  for (let h = 0; h < a.length; h++) {
    const g = a[h];
    g instanceof Error && Object.defineProperty(a, h, {
      enumerable: !0,
      get: () => {
        throw g;
      }
    });
  }
  return Object.freeze(a);
}
class ArrayCoder extends Coder {
  constructor(t, a, d) {
    const l = t.type + "[" + (a >= 0 ? a : "") + "]", h = a === -1 || t.dynamic;
    super("array", l, d, h), this.coder = t, this.length = a;
  }
  defaultValue() {
    const t = this.coder.defaultValue(), a = [];
    for (let d = 0; d < this.length; d++)
      a.push(t);
    return a;
  }
  encode(t, a) {
    Array.isArray(a) || this._throwError("expected array value", a);
    let d = this.length;
    d === -1 && (d = a.length, t.writeValue(a.length)), logger$3.checkArgumentCount(a.length, d, "coder array" + (this.localName ? " " + this.localName : ""));
    let l = [];
    for (let h = 0; h < a.length; h++)
      l.push(this.coder);
    return pack(t, l, a);
  }
  decode(t) {
    let a = this.length;
    a === -1 && (a = t.readValue().toNumber(), a * 32 > t._data.length && logger$3.throwError("insufficient data length", Logger.errors.BUFFER_OVERRUN, {
      length: t._data.length,
      count: a
    }));
    let d = [];
    for (let l = 0; l < a; l++)
      d.push(new AnonymousCoder(this.coder));
    return t.coerce(this.name, unpack(t, d));
  }
}
class BooleanCoder extends Coder {
  constructor(t) {
    super("bool", "bool", t, !1);
  }
  defaultValue() {
    return !1;
  }
  encode(t, a) {
    return t.writeValue(a ? 1 : 0);
  }
  decode(t) {
    return t.coerce(this.type, !t.readValue().isZero());
  }
}
class DynamicBytesCoder extends Coder {
  constructor(t, a) {
    super(t, t, a, !0);
  }
  defaultValue() {
    return "0x";
  }
  encode(t, a) {
    a = arrayify(a);
    let d = t.writeValue(a.length);
    return d += t.writeBytes(a), d;
  }
  decode(t) {
    return t.readBytes(t.readValue().toNumber(), !0);
  }
}
class BytesCoder extends DynamicBytesCoder {
  constructor(t) {
    super("bytes", t);
  }
  decode(t) {
    return t.coerce(this.name, hexlify(super.decode(t)));
  }
}
class FixedBytesCoder extends Coder {
  constructor(t, a) {
    let d = "bytes" + String(t);
    super(d, d, a, !1), this.size = t;
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
  }
  encode(t, a) {
    let d = arrayify(a);
    return d.length !== this.size && this._throwError("incorrect data length", a), t.writeBytes(d);
  }
  decode(t) {
    return t.coerce(this.name, hexlify(t.readBytes(this.size)));
  }
}
class NullCoder extends Coder {
  constructor(t) {
    super("null", "", t, !1);
  }
  defaultValue() {
    return null;
  }
  encode(t, a) {
    return a != null && this._throwError("not null", a), t.writeBytes([]);
  }
  decode(t) {
    return t.readBytes(0), t.coerce(this.name, null);
  }
}
const NegativeOne = /* @__PURE__ */ BigNumber.from(-1), Zero = /* @__PURE__ */ BigNumber.from(0), One = /* @__PURE__ */ BigNumber.from(1), MaxUint256 = /* @__PURE__ */ BigNumber.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class NumberCoder extends Coder {
  constructor(t, a, d) {
    const l = (a ? "int" : "uint") + t * 8;
    super(l, l, d, !1), this.size = t, this.signed = a;
  }
  defaultValue() {
    return 0;
  }
  encode(t, a) {
    let d = BigNumber.from(a), l = MaxUint256.mask(t.wordSize * 8);
    if (this.signed) {
      let h = l.mask(this.size * 8 - 1);
      (d.gt(h) || d.lt(h.add(One).mul(NegativeOne))) && this._throwError("value out-of-bounds", a);
    } else
      (d.lt(Zero) || d.gt(l.mask(this.size * 8))) && this._throwError("value out-of-bounds", a);
    return d = d.toTwos(this.size * 8).mask(this.size * 8), this.signed && (d = d.fromTwos(this.size * 8).toTwos(8 * t.wordSize)), t.writeValue(d);
  }
  decode(t) {
    let a = t.readValue().mask(this.size * 8);
    return this.signed && (a = a.fromTwos(this.size * 8)), t.coerce(this.name, a);
  }
}
const version$1 = "strings/5.7.0", logger$2 = new Logger(version$1);
var UnicodeNormalizationForm;
(function(u) {
  u.current = "", u.NFC = "NFC", u.NFD = "NFD", u.NFKC = "NFKC", u.NFKD = "NFKD";
})(UnicodeNormalizationForm || (UnicodeNormalizationForm = {}));
var Utf8ErrorReason;
(function(u) {
  u.UNEXPECTED_CONTINUE = "unexpected continuation byte", u.BAD_PREFIX = "bad codepoint prefix", u.OVERRUN = "string overrun", u.MISSING_CONTINUE = "missing continuation byte", u.OUT_OF_RANGE = "out of UTF-8 range", u.UTF16_SURROGATE = "UTF-16 surrogate", u.OVERLONG = "overlong representation";
})(Utf8ErrorReason || (Utf8ErrorReason = {}));
function errorFunc(u, t, a, d, l) {
  return logger$2.throwArgumentError(`invalid codepoint at offset ${t}; ${u}`, "bytes", a);
}
function ignoreFunc(u, t, a, d, l) {
  if (u === Utf8ErrorReason.BAD_PREFIX || u === Utf8ErrorReason.UNEXPECTED_CONTINUE) {
    let h = 0;
    for (let g = t + 1; g < a.length && a[g] >> 6 === 2; g++)
      h++;
    return h;
  }
  return u === Utf8ErrorReason.OVERRUN ? a.length - t - 1 : 0;
}
function replaceFunc(u, t, a, d, l) {
  return u === Utf8ErrorReason.OVERLONG ? (d.push(l), 0) : (d.push(65533), ignoreFunc(u, t, a));
}
const Utf8ErrorFuncs = Object.freeze({
  error: errorFunc,
  ignore: ignoreFunc,
  replace: replaceFunc
});
function getUtf8CodePoints(u, t) {
  t == null && (t = Utf8ErrorFuncs.error), u = arrayify(u);
  const a = [];
  let d = 0;
  for (; d < u.length; ) {
    const l = u[d++];
    if (l >> 7 === 0) {
      a.push(l);
      continue;
    }
    let h = null, g = null;
    if ((l & 224) === 192)
      h = 1, g = 127;
    else if ((l & 240) === 224)
      h = 2, g = 2047;
    else if ((l & 248) === 240)
      h = 3, g = 65535;
    else {
      (l & 192) === 128 ? d += t(Utf8ErrorReason.UNEXPECTED_CONTINUE, d - 1, u, a) : d += t(Utf8ErrorReason.BAD_PREFIX, d - 1, u, a);
      continue;
    }
    if (d - 1 + h >= u.length) {
      d += t(Utf8ErrorReason.OVERRUN, d - 1, u, a);
      continue;
    }
    let c = l & (1 << 8 - h - 1) - 1;
    for (let x = 0; x < h; x++) {
      let R = u[d];
      if ((R & 192) != 128) {
        d += t(Utf8ErrorReason.MISSING_CONTINUE, d, u, a), c = null;
        break;
      }
      c = c << 6 | R & 63, d++;
    }
    if (c !== null) {
      if (c > 1114111) {
        d += t(Utf8ErrorReason.OUT_OF_RANGE, d - 1 - h, u, a, c);
        continue;
      }
      if (c >= 55296 && c <= 57343) {
        d += t(Utf8ErrorReason.UTF16_SURROGATE, d - 1 - h, u, a, c);
        continue;
      }
      if (c <= g) {
        d += t(Utf8ErrorReason.OVERLONG, d - 1 - h, u, a, c);
        continue;
      }
      a.push(c);
    }
  }
  return a;
}
function toUtf8Bytes(u, t = UnicodeNormalizationForm.current) {
  t != UnicodeNormalizationForm.current && (logger$2.checkNormalize(), u = u.normalize(t));
  let a = [];
  for (let d = 0; d < u.length; d++) {
    const l = u.charCodeAt(d);
    if (l < 128)
      a.push(l);
    else if (l < 2048)
      a.push(l >> 6 | 192), a.push(l & 63 | 128);
    else if ((l & 64512) == 55296) {
      d++;
      const h = u.charCodeAt(d);
      if (d >= u.length || (h & 64512) !== 56320)
        throw new Error("invalid utf-8 string");
      const g = 65536 + ((l & 1023) << 10) + (h & 1023);
      a.push(g >> 18 | 240), a.push(g >> 12 & 63 | 128), a.push(g >> 6 & 63 | 128), a.push(g & 63 | 128);
    } else
      a.push(l >> 12 | 224), a.push(l >> 6 & 63 | 128), a.push(l & 63 | 128);
  }
  return arrayify(a);
}
function _toUtf8String(u) {
  return u.map((t) => t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode((t >> 10 & 1023) + 55296, (t & 1023) + 56320))).join("");
}
function toUtf8String(u, t) {
  return _toUtf8String(getUtf8CodePoints(u, t));
}
class StringCoder extends DynamicBytesCoder {
  constructor(t) {
    super("string", t);
  }
  defaultValue() {
    return "";
  }
  encode(t, a) {
    return super.encode(t, toUtf8Bytes(a));
  }
  decode(t) {
    return toUtf8String(super.decode(t));
  }
}
class TupleCoder extends Coder {
  constructor(t, a) {
    let d = !1;
    const l = [];
    t.forEach((g) => {
      g.dynamic && (d = !0), l.push(g.type);
    });
    const h = "tuple(" + l.join(",") + ")";
    super("tuple", h, a, d), this.coders = t;
  }
  defaultValue() {
    const t = [];
    this.coders.forEach((d) => {
      t.push(d.defaultValue());
    });
    const a = this.coders.reduce((d, l) => {
      const h = l.localName;
      return h && (d[h] || (d[h] = 0), d[h]++), d;
    }, {});
    return this.coders.forEach((d, l) => {
      let h = d.localName;
      !h || a[h] !== 1 || (h === "length" && (h = "_length"), t[h] == null && (t[h] = t[l]));
    }), Object.freeze(t);
  }
  encode(t, a) {
    return pack(t, this.coders, a);
  }
  decode(t) {
    return t.coerce(this.name, unpack(t, this.coders));
  }
}
const logger$1 = new Logger(version$4), paramTypeBytes = new RegExp(/^bytes([0-9]*)$/), paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class AbiCoder {
  constructor(t) {
    defineReadOnly(this, "coerceFunc", t || null);
  }
  _getCoder(t) {
    switch (t.baseType) {
      case "address":
        return new AddressCoder(t.name);
      case "bool":
        return new BooleanCoder(t.name);
      case "string":
        return new StringCoder(t.name);
      case "bytes":
        return new BytesCoder(t.name);
      case "array":
        return new ArrayCoder(this._getCoder(t.arrayChildren), t.arrayLength, t.name);
      case "tuple":
        return new TupleCoder((t.components || []).map((d) => this._getCoder(d)), t.name);
      case "":
        return new NullCoder(t.name);
    }
    let a = t.type.match(paramTypeNumber);
    if (a) {
      let d = parseInt(a[2] || "256");
      return (d === 0 || d > 256 || d % 8 !== 0) && logger$1.throwArgumentError("invalid " + a[1] + " bit length", "param", t), new NumberCoder(d / 8, a[1] === "int", t.name);
    }
    if (a = t.type.match(paramTypeBytes), a) {
      let d = parseInt(a[1]);
      return (d === 0 || d > 32) && logger$1.throwArgumentError("invalid bytes length", "param", t), new FixedBytesCoder(d, t.name);
    }
    return logger$1.throwArgumentError("invalid type", "type", t.type);
  }
  _getWordSize() {
    return 32;
  }
  _getReader(t, a) {
    return new Reader(t, this._getWordSize(), this.coerceFunc, a);
  }
  _getWriter() {
    return new Writer(this._getWordSize());
  }
  getDefaultValue(t) {
    const a = t.map((l) => this._getCoder(ParamType.from(l)));
    return new TupleCoder(a, "_").defaultValue();
  }
  encode(t, a) {
    t.length !== a.length && logger$1.throwError("types/values length mismatch", Logger.errors.INVALID_ARGUMENT, {
      count: { types: t.length, values: a.length },
      value: { types: t, values: a }
    });
    const d = t.map((g) => this._getCoder(ParamType.from(g))), l = new TupleCoder(d, "_"), h = this._getWriter();
    return l.encode(h, a), h.data;
  }
  decode(t, a, d) {
    const l = t.map((g) => this._getCoder(ParamType.from(g)));
    return new TupleCoder(l, "_").decode(this._getReader(arrayify(a), d));
  }
}
const defaultAbiCoder = new AbiCoder();
class ContractFunctionResult {
  constructor(t) {
    this._createResult = t._createResult, this.contractId = t.contractId, this.bytes = t.bytes, this.errorMessage = t.errorMessage, this.bloom = t.bloom, this.gasUsed = t.gasUsed, this.logs = t.logs, this.createdContractIds = t.createdContractIds, this.evmAddress = t.evmAddress, this.stateChanges = t.stateChanges, this.gas = t.gas, this.amount = t.amount, this.functionParameters = t.functionParameters, this.senderAccountId = t.senderAccountId;
  }
  static _fromProtobuf(t, a) {
    const d = t.contractID, l = t.gasUsed, h = t.gas ? t.gas : -1, g = t.amount ? t.amount : -1;
    return new ContractFunctionResult({
      _createResult: a,
      bytes: t.contractCallResult,
      contractId: d != null ? ContractId._fromProtobuf(d) : null,
      errorMessage: t.errorMessage != null ? t.errorMessage : null,
      bloom: t.bloom,
      gasUsed: l instanceof long ? l : long.fromValue(l),
      logs: (t.logInfo != null ? t.logInfo : []).map(
        (c) => ContractLogInfo._fromProtobuf(c)
      ),
      createdContractIds: (t.createdContractIDs != null ? t.createdContractIDs : []).map((c) => ContractId._fromProtobuf(c)),
      evmAddress: t.evmAddress != null && t.evmAddress.value != null ? t.evmAddress.value : null,
      stateChanges: [],
      gas: h instanceof long ? h : long.fromValue(h),
      amount: g instanceof long ? g : long.fromValue(g),
      functionParameters: t.functionParameters,
      senderAccountId: t.senderId != null ? AccountId._fromProtobuf(t.senderId) : null
    });
  }
  asBytes() {
    return this.bytes;
  }
  getString(t) {
    return decode$1(this.getBytes(t));
  }
  getBytes(t) {
    const a = this.getInt32(t), d = safeView(this.bytes).getInt32(a + 28);
    return this.bytes.subarray(a + 32, a + 32 + d);
  }
  getBytes32(t) {
    return this.bytes.subarray(
      (t != null ? t : 0) * 32,
      (t != null ? t : 0) * 32 + 32
    );
  }
  getBool(t) {
    return this.bytes[(t != null ? t : 0) * 32 + 31] !== 0;
  }
  getInt8(t) {
    const a = (t != null ? t : 0) * 32 + 31;
    return safeView(this.bytes).getInt8(a);
  }
  getUint8(t) {
    return this.bytes[(t != null ? t : 0) * 32 + 31];
  }
  getInt32(t) {
    const a = (t != null ? t : 0) * 32 + 28;
    return safeView(this.bytes).getInt32(a);
  }
  getUint32(t) {
    const a = (t != null ? t : 0) * 32 + 28;
    return safeView(this.bytes).getUint32(a);
  }
  getInt40(t) {
    const a = defaultAbiCoder.decode(
      ["int40"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint40(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(27, 32)),
      16
    );
  }
  getInt48(t) {
    const a = defaultAbiCoder.decode(
      ["int48"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint48(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(26, 32)),
      16
    );
  }
  getInt56(t) {
    const a = defaultAbiCoder.decode(
      ["int56"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint56(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(25, 32)),
      16
    );
  }
  getInt64(t) {
    const a = defaultAbiCoder.decode(
      ["int64"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint64(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(24, 32)),
      16
    );
  }
  getInt72(t) {
    const a = defaultAbiCoder.decode(
      ["int72"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint72(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(23, 32)),
      16
    );
  }
  getInt80(t) {
    const a = defaultAbiCoder.decode(
      ["int80"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint80(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(22, 32)),
      16
    );
  }
  getInt88(t) {
    const a = defaultAbiCoder.decode(
      ["int88"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint88(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(21, 32)),
      16
    );
  }
  getInt96(t) {
    const a = defaultAbiCoder.decode(
      ["int96"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint96(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(20, 32)),
      16
    );
  }
  getInt104(t) {
    const a = defaultAbiCoder.decode(
      ["int104"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint104(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(19, 32)),
      16
    );
  }
  getInt112(t) {
    const a = defaultAbiCoder.decode(
      ["int112"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint112(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(18, 32)),
      16
    );
  }
  getInt120(t) {
    const a = defaultAbiCoder.decode(
      ["int120"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint120(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(17, 32)),
      16
    );
  }
  getInt128(t) {
    const a = defaultAbiCoder.decode(
      ["int128"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint128(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(16, 32)),
      16
    );
  }
  getInt136(t) {
    const a = defaultAbiCoder.decode(
      ["int136"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint136(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(15, 32)),
      16
    );
  }
  getInt144(t) {
    const a = defaultAbiCoder.decode(
      ["int144"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint144(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(14, 32)),
      16
    );
  }
  getInt152(t) {
    const a = defaultAbiCoder.decode(
      ["int152"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint152(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(13, 32)),
      16
    );
  }
  getInt160(t) {
    const a = defaultAbiCoder.decode(
      ["int160"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint160(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(12, 32)),
      16
    );
  }
  getInt168(t) {
    const a = defaultAbiCoder.decode(
      ["int168"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint168(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(11, 32)),
      16
    );
  }
  getInt176(t) {
    const a = defaultAbiCoder.decode(
      ["int176"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint176(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(10, 32)),
      16
    );
  }
  getInt184(t) {
    const a = defaultAbiCoder.decode(
      ["int184"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint184(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(9, 32)),
      16
    );
  }
  getInt192(t) {
    const a = defaultAbiCoder.decode(
      ["int192"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint192(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(8, 32)),
      16
    );
  }
  getInt200(t) {
    const a = defaultAbiCoder.decode(
      ["int200"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint200(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(7, 32)),
      16
    );
  }
  getInt208(t) {
    const a = defaultAbiCoder.decode(
      ["int208"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint208(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(6, 32)),
      16
    );
  }
  getInt216(t) {
    const a = defaultAbiCoder.decode(
      ["int216"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint216(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(5, 32)),
      16
    );
  }
  getInt224(t) {
    const a = defaultAbiCoder.decode(
      ["int224"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint224(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(4, 32)),
      16
    );
  }
  getInt232(t) {
    const a = defaultAbiCoder.decode(
      ["int232"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint232(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(3, 32)),
      16
    );
  }
  getInt240(t) {
    const a = defaultAbiCoder.decode(
      ["int240"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint240(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(2, 32)),
      16
    );
  }
  getInt248(t) {
    const a = defaultAbiCoder.decode(
      ["int248"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint248(t) {
    return new BigNumber$1(
      encode$4(this._getBytes32(t).subarray(1, 32)),
      16
    );
  }
  getInt256(t) {
    const a = defaultAbiCoder.decode(
      ["int256"],
      this._getBytes32(t != null ? t : 0)
    );
    return new BigNumber$1(a.toString());
  }
  getUint256(t) {
    return new BigNumber$1(encode$4(this._getBytes32(t)), 16);
  }
  getAddress(t) {
    return encode$4(
      this.bytes.subarray(
        (t != null ? t : 0) * 32 + 12,
        (t != null ? t : 0) * 32 + 32
      )
    );
  }
  getResult(t) {
    return defaultAbiCoder.decode(t, this.bytes);
  }
  _getBytes32(t) {
    return this.bytes.subarray(
      (t != null ? t : 0) * 32,
      (t != null ? t : 0) * 32 + 32
    );
  }
  _toProtobuf() {
    return {
      contractID: this.contractId != null ? this.contractId._toProtobuf() : null,
      contractCallResult: this.bytes,
      errorMessage: this.errorMessage,
      bloom: this.bloom,
      gasUsed: this.gasUsed,
      logInfo: this.logs.map((t) => t._toProtobuf()),
      createdContractIDs: this.createdContractIds.map(
        (t) => t._toProtobuf()
      ),
      evmAddress: this.evmAddress != null ? {
        value: this.evmAddress
      } : null,
      gas: this.gas,
      amount: this.amount,
      functionParameters: this.functionParameters,
      senderId: this.senderAccountId != null ? this.senderAccountId._toProtobuf() : null
    };
  }
}
class ObjectMap {
  constructor(t) {
    this._map = /* @__PURE__ */ new Map(), this.__map = /* @__PURE__ */ new Map(), this._fromString = t;
  }
  get(t) {
    const a = typeof t == "string" ? t : t.toString(), d = this._map.get(a);
    return d != null ? d : null;
  }
  _set(t, a) {
    const d = typeof t == "string" ? t : t.toString();
    this._map.set(d, a), this.__map.set(t, a);
  }
  values() {
    return this._map.values();
  }
  get size() {
    return this._map.size;
  }
  keys() {
    return this.__map.keys();
  }
  [Symbol.iterator]() {
    return this.__map[Symbol.iterator]();
  }
  toString() {
    const t = {};
    for (const [a, d] of this._map)
      t[a] = d;
    return JSON.stringify(t);
  }
}
class TokenTransferAccountMap extends ObjectMap {
  constructor() {
    super((t) => AccountId.fromString(t));
  }
}
class TokenTransferMap extends ObjectMap {
  constructor() {
    super((t) => TokenId.fromString(t));
  }
  __set(t, a, d) {
    const l = t.toString();
    let h = this._map.get(l);
    h == null && (h = new TokenTransferAccountMap(), this._map.set(l, h), this.__map.set(t, h)), h._set(a, d);
  }
  static _fromProtobuf(t) {
    const a = new TokenTransferMap();
    for (const d of t) {
      const l = TokenId._fromProtobuf(
        d.token
      );
      for (const h of d.transfers != null ? d.transfers : []) {
        const g = AccountId._fromProtobuf(
          h.accountID
        );
        a.__set(
          l,
          g,
          h.amount
        );
      }
    }
    return a;
  }
  _toProtobuf() {
    const t = [];
    for (const [a, d] of this) {
      const l = [];
      for (const [h, g] of d)
        l.push({
          accountID: h._toProtobuf(),
          amount: g
        });
      t.push({
        token: a._toProtobuf(),
        transfers: l
      });
    }
    return t;
  }
}
class TokenNftTransferMap extends ObjectMap {
  constructor() {
    super((t) => TokenId.fromString(t));
  }
  __set(t, a) {
    const d = t.toString();
    let l = this._map.get(d);
    l == null && (l = [], this._map.set(d, l), this.__map.set(t, l)), l.push(a);
  }
  static _fromProtobuf(t) {
    const a = new TokenNftTransferMap();
    for (const d of t) {
      const l = TokenId._fromProtobuf(
        d.token
      );
      for (const h of d.nftTransfers != null ? d.nftTransfers : []) {
        const g = AccountId._fromProtobuf(
          h.senderAccountID
        ), c = AccountId._fromProtobuf(
          h.receiverAccountID
        );
        a.__set(l, {
          sender: g,
          recipient: c,
          serial: long.fromValue(
            h.serialNumber
          ),
          isApproved: !1
        });
      }
    }
    return a;
  }
  _toProtobuf() {
    const t = [];
    for (const [a, d] of this) {
      const l = [];
      for (const h of d)
        l.push({
          senderAccountID: h.sender._toProtobuf(),
          receiverAccountID: h.recipient._toProtobuf(),
          serialNumber: h.serial
        });
      t.push({
        token: a._toProtobuf(),
        nftTransfers: l
      });
    }
    return t;
  }
}
class AssessedCustomFee {
  constructor(t = {}) {
    this._feeCollectorAccountId = null, t.feeCollectorAccountId != null && this.setFeeCollectorAccountId(t.feeCollectorAccountId), this._tokenId = null, t.tokenId != null && this.setTokenId(t.tokenId), this._amount = null, t.amount != null && this.setAmount(t.amount), this._payerAccountIds = null, t.payerAccountIds != null && this.setPayerAccountIds(t.payerAccountIds);
  }
  get feeCollectorAccountId() {
    return this._feeCollectorAccountId;
  }
  setFeeCollectorAccountId(t) {
    return this._feeCollectorAccountId = typeof t == "string" ? AccountId.fromString(t) : t, this;
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t, this;
  }
  get amount() {
    return this._amount;
  }
  setAmount(t) {
    return this._amount = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  get payerAccountIds() {
    return this._payerAccountIds;
  }
  setPayerAccountIds(t) {
    return this._payerAccountIds = t, this;
  }
  static _fromProtobuf(t) {
    return new AssessedCustomFee({
      feeCollectorAccountId: t.feeCollectorAccountId != null ? AccountId._fromProtobuf(t.feeCollectorAccountId) : void 0,
      tokenId: t.tokenId != null ? TokenId._fromProtobuf(t.tokenId) : void 0,
      amount: t.amount != null ? t.amount : void 0,
      payerAccountIds: t.effectivePayerAccountId != null ? t.effectivePayerAccountId.map(
        (a) => AccountId._fromProtobuf(a)
      ) : void 0
    });
  }
  _toProtobuf() {
    return {
      feeCollectorAccountId: this.feeCollectorAccountId != null ? this.feeCollectorAccountId._toProtobuf() : null,
      tokenId: this._tokenId != null ? this._tokenId._toProtobuf() : null,
      amount: this._amount,
      effectivePayerAccountId: this._payerAccountIds != null ? this._payerAccountIds.map((t) => t._toProtobuf()) : null
    };
  }
}
class TokenAssociation {
  constructor(t = {}) {
    this._accountId = null, t.accountId != null && this.setAccountId(t.accountId), this._tokenId = null, t.tokenId != null && this.setTokenId(t.tokenId), this._defaultMaxTransactionFee = new Hbar(5);
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._accountId = typeof t == "string" ? AccountId.fromString(t) : t, this;
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t, this;
  }
  static _fromProtobuf(t) {
    return new TokenAssociation({
      accountId: t.accountId != null ? AccountId._fromProtobuf(t.accountId) : void 0,
      tokenId: t.tokenId != null ? TokenId._fromProtobuf(t.tokenId) : void 0
    });
  }
  _toProtobuf() {
    return {
      accountId: this._accountId != null ? this._accountId._toProtobuf() : void 0,
      tokenId: this._tokenId != null ? this._tokenId._toProtobuf() : void 0
    };
  }
}
class TokenTransfer {
  constructor(t) {
    this.tokenId = t.tokenId instanceof TokenId ? t.tokenId : TokenId.fromString(t.tokenId), this.accountId = t.accountId instanceof AccountId ? t.accountId : AccountId.fromString(t.accountId), this.expectedDecimals = t.expectedDecimals, this.amount = long.fromValue(t.amount), this.isApproved = t.isApproved;
  }
  static _fromProtobuf(t) {
    const a = [];
    for (const d of t) {
      const l = TokenId._fromProtobuf(
        d.token
      ), h = d.expectedDecimals != null ? d.expectedDecimals.value : null;
      for (const g of d.transfers != null ? d.transfers : [])
        a.push(
          new TokenTransfer({
            tokenId: l,
            accountId: AccountId._fromProtobuf(
              g.accountID
            ),
            expectedDecimals: h,
            amount: g.amount != null ? g.amount : long.ZERO,
            isApproved: g.isApproval == !0
          })
        );
    }
    return a;
  }
  _toProtobuf() {
    return {
      accountID: this.accountId._toProtobuf(),
      amount: this.amount,
      isApproval: this.isApproved
    };
  }
}
class TransactionRecord {
  constructor(t) {
    this.receipt = t.receipt, this.transactionHash = t.transactionHash, this.consensusTimestamp = t.consensusTimestamp, this.transactionId = t.transactionId, this.transactionMemo = t.transactionMemo, this.transactionFee = t.transactionFee, this.transfers = t.transfers, this.contractFunctionResult = t.contractFunctionResult != null ? t.contractFunctionResult : null, this.tokenTransfers = t.tokenTransfers, this.tokenTransfersList = t.tokenTransfersList, this.scheduleRef = t.scheduleRef, this.assessedCustomFees = t.assessedCustomFees, this.nftTransfers = t.nftTransfers, this.automaticTokenAssociations = t.automaticTokenAssociations, this.parentConsensusTimestamp = t.parentConsensusTimestamp, this.aliasKey = t.aliasKey, this.duplicates = t.duplicates, this.children = t.children, this.hbarAllowanceAdjustments = t.hbarAllowanceAdjustments, this.tokenAllowanceAdjustments = t.tokenAllowanceAdjustments, this.nftAllowanceAdjustments = t.nftAllowanceAdjustments, this.ethereumHash = t.ethereumHash, this.paidStakingRewards = t.paidStakingRewards, this.prngBytes = t.prngBytes, this.prngNumber = t.prngNumber, this.evmAddress = t.evmAddress, Object.freeze(this);
  }
  _toProtobuf() {
    const t = this.tokenTransfers._toProtobuf(), a = this.nftTransfers._toProtobuf(), d = [];
    for (const g of t)
      for (const c of a)
        g.token != null && c.token != null && g.token.shardNum === c.token.shardNum && g.token.realmNum === c.token.realmNum && g.token.tokenNum === c.token.tokenNum ? d.push({
          token: g.token,
          transfers: g.transfers,
          nftTransfers: g.nftTransfers
        }) : (d.push(g), d.push(c));
    const l = this.duplicates.map(
      (g) => g._toProtobuf().transactionRecord
    ), h = this.children.map(
      (g) => g._toProtobuf().transactionRecord
    );
    return {
      duplicateTransactionRecords: l,
      childTransactionRecords: h,
      transactionRecord: {
        receipt: this.receipt._toProtobuf().receipt,
        transactionHash: this.transactionHash != null ? this.transactionHash : null,
        consensusTimestamp: this.consensusTimestamp != null ? this.consensusTimestamp._toProtobuf() : null,
        transactionID: this.transactionId != null ? this.transactionId._toProtobuf() : null,
        memo: this.transactionMemo != null ? this.transactionMemo : null,
        transactionFee: this.transactionFee != null ? this.transactionFee.toTinybars() : null,
        contractCallResult: this.contractFunctionResult != null && !this.contractFunctionResult._createResult ? this.contractFunctionResult._toProtobuf() : null,
        contractCreateResult: this.contractFunctionResult != null && this.contractFunctionResult._createResult ? this.contractFunctionResult._toProtobuf() : null,
        transferList: this.transfers != null ? {
          accountAmounts: this.transfers.map(
            (g) => g._toProtobuf()
          )
        } : null,
        tokenTransferLists: d,
        scheduleRef: this.scheduleRef != null ? this.scheduleRef._toProtobuf() : null,
        assessedCustomFees: this.assessedCustomFees.map(
          (g) => g._toProtobuf()
        ),
        automaticTokenAssociations: this.automaticTokenAssociations.map(
          (g) => g._toProtobuf()
        ),
        parentConsensusTimestamp: this.parentConsensusTimestamp != null ? this.parentConsensusTimestamp._toProtobuf() : null,
        alias: this.aliasKey != null ? lib.proto.Key.encode(
          this.aliasKey._toProtobufKey()
        ).finish() : null,
        ethereumHash: this.ethereumHash,
        paidStakingRewards: this.paidStakingRewards.map(
          (g) => g._toProtobuf()
        ),
        prngBytes: this.prngBytes,
        prngNumber: this.prngNumber != null ? this.prngNumber : null,
        evmAddress: this.evmAddress != null ? this.evmAddress.toBytes() : null
      }
    };
  }
  static _fromProtobuf(t) {
    const a = t.transactionRecord;
    let d = a.alias != null && a.alias.length > 0 ? Key._fromProtobufKey(
      lib.proto.Key.decode(a.alias)
    ) : null;
    d instanceof PublicKey || (d = null);
    const l = t.childTransactionRecords != null ? t.childTransactionRecords.map(
      (c) => TransactionRecord._fromProtobuf({
        transactionRecord: c
      })
    ) : [], h = t.duplicateTransactionRecords != null ? t.duplicateTransactionRecords.map(
      (c) => TransactionRecord._fromProtobuf({
        transactionRecord: c
      })
    ) : [], g = a.contractCallResult != null ? ContractFunctionResult._fromProtobuf(
      a.contractCallResult,
      !1
    ) : a.contractCreateResult != null ? ContractFunctionResult._fromProtobuf(
      a.contractCreateResult,
      !0
    ) : void 0;
    return new TransactionRecord({
      receipt: TransactionReceipt._fromProtobuf({
        receipt: a.receipt
      }),
      transactionHash: a.transactionHash != null ? a.transactionHash : new Uint8Array(),
      consensusTimestamp: Timestamp._fromProtobuf(
        a.consensusTimestamp
      ),
      transactionId: TransactionId._fromProtobuf(
        a.transactionID
      ),
      transactionMemo: a.memo != null ? a.memo : "",
      transactionFee: Hbar.fromTinybars(
        a.transactionFee != null ? a.transactionFee : 0
      ),
      transfers: Transfer._fromProtobuf(
        a.transferList != null ? a.transferList.accountAmounts != null ? a.transferList.accountAmounts : [] : []
      ),
      contractFunctionResult: g,
      tokenTransfers: TokenTransferMap._fromProtobuf(
        a.tokenTransferLists != null ? a.tokenTransferLists : []
      ),
      tokenTransfersList: TokenTransfer._fromProtobuf(
        a.tokenTransferLists != null ? a.tokenTransferLists : []
      ),
      scheduleRef: a.scheduleRef != null ? ScheduleId._fromProtobuf(a.scheduleRef) : null,
      assessedCustomFees: a.assessedCustomFees != null ? a.assessedCustomFees.map(
        (c) => AssessedCustomFee._fromProtobuf(c)
      ) : [],
      nftTransfers: TokenNftTransferMap._fromProtobuf(
        a.tokenTransferLists != null ? a.tokenTransferLists : []
      ),
      automaticTokenAssociations: a.automaticTokenAssociations != null ? a.automaticTokenAssociations.map(
        (c) => TokenAssociation._fromProtobuf(c)
      ) : [],
      parentConsensusTimestamp: a.parentConsensusTimestamp != null ? Timestamp._fromProtobuf(a.parentConsensusTimestamp) : null,
      aliasKey: d,
      duplicates: h,
      children: l,
      hbarAllowanceAdjustments: [],
      tokenAllowanceAdjustments: [],
      nftAllowanceAdjustments: [],
      ethereumHash: a.ethereumHash != null ? a.ethereumHash : null,
      paidStakingRewards: a.paidStakingRewards != null ? Transfer._fromProtobuf(a.paidStakingRewards) : [],
      prngBytes: a.prngBytes != null ? a.prngBytes : null,
      prngNumber: a.prngNumber != null ? a.prngNumber : null,
      evmAddress: a.evmAddress != null ? EvmAddress.fromBytes(a.evmAddress) : null
    });
  }
  static fromBytes(t) {
    return TransactionRecord._fromProtobuf(
      lib.proto.TransactionGetRecordResponse.decode(t)
    );
  }
  toBytes() {
    return lib.proto.TransactionGetRecordResponse.encode(
      this._toProtobuf()
    ).finish();
  }
}
class RecordStatusError extends StatusError {
  constructor(t) {
    super(
      t,
      `Record for transaction ${t.transactionId.toString()} contained error status ${t.status.toString()}`
    ), this.transactionRecord = t.transactionRecord;
  }
}
const { proto: proto$3 } = HashgraphProto;
class TransactionRecordQuery extends Query {
  constructor(t = {}) {
    super(), this._transactionId = null, this._includeChildren = null, this._includeDuplicates = null, this._validateReceiptStatus = !0, t.transactionId != null && this.setTransactionId(t.transactionId), t.includeChildren != null && this.setIncludeChildren(t.includeChildren), t.includeDuplicates != null && this.setIncludeDuplicates(t.includeDuplicates), t.validateReceiptStatus != null && this.setValidateReceiptStatus(t.validateReceiptStatus);
  }
  get transactionId() {
    return this._transactionId;
  }
  static _fromProtobuf(t) {
    const a = t.transactionGetRecord;
    return new TransactionRecordQuery({
      transactionId: a.transactionID ? TransactionId._fromProtobuf(a.transactionID) : void 0,
      includeChildren: a.includeChildRecords != null ? a.includeChildRecords : void 0,
      includeDuplicates: a.includeDuplicates != null ? a.includeDuplicates : void 0
    });
  }
  setTransactionId(t) {
    return this._transactionId = typeof t == "string" ? TransactionId.fromString(t) : t.clone(), this;
  }
  setIncludeChildren(t) {
    return this._includeChildren = t, this;
  }
  get includeChildren() {
    return this._includeChildren != null ? this._includeChildren : !1;
  }
  setIncludeDuplicates(t) {
    return this._duplicates = t, this;
  }
  get includeDuplicates() {
    return this._duplicates != null ? this._duplicates : !1;
  }
  setValidateReceiptStatus(t) {
    return this._validateReceiptStatus = t, this;
  }
  get validateReceiptStatus() {
    return this._validateReceiptStatus;
  }
  _shouldRetry(t, a) {
    const { nodeTransactionPrecheckCode: d } = this._mapResponseHeader(a);
    let l = Status._fromCode(
      d != null ? d : proto$3.ResponseCodeEnum.OK
    );
    switch (this._logger && this._logger.debug(
      `[${this._getLogId()}] received node precheck status ${l.toString()}`
    ), l) {
      case Status.Busy:
      case Status.Unknown:
      case Status.ReceiptNotFound:
      case Status.RecordNotFound:
        return [l, ExecutionState.Retry];
      case Status.Ok:
        break;
      default:
        return [l, ExecutionState.Error];
    }
    const h = a.transactionGetRecord;
    if (h.header.responseType === lib.proto.ResponseType.COST_ANSWER)
      return [l, ExecutionState.Finished];
    const R = h.transactionRecord.receipt.status;
    switch (l = Status._fromCode(R), this._logger && this._logger.debug(
      `[${this._getLogId()}] received record's receipt ${l.toString()}`
    ), l) {
      case Status.Ok:
      case Status.Busy:
      case Status.Unknown:
      case Status.ReceiptNotFound:
      case Status.RecordNotFound:
        return [l, ExecutionState.Retry];
      case Status.Success:
        return [l, ExecutionState.Finished];
      default:
        return [
          l,
          this._validateReceiptStatus ? ExecutionState.Error : ExecutionState.Finished
        ];
    }
  }
  _mapStatusError(t, a) {
    const { nodeTransactionPrecheckCode: d } = this._mapResponseHeader(a);
    let l = Status._fromCode(
      d != null ? d : proto$3.ResponseCodeEnum.OK
    );
    switch (l) {
      case Status.Ok:
        break;
      case Status.ContractRevertExecuted:
        return new RecordStatusError({
          status: l,
          transactionId: this._getTransactionId(),
          transactionRecord: TransactionRecord._fromProtobuf({
            transactionRecord: a.transactionGetRecord.transactionRecord
          })
        });
      default:
        return new PrecheckStatusError({
          status: l,
          transactionId: this._getTransactionId(),
          contractFunctionResult: null
        });
    }
    const c = a.transactionGetRecord.transactionRecord.receipt, x = c.status;
    switch (l = Status._fromCode(x), l) {
      case Status.ContractRevertExecuted:
        return new RecordStatusError({
          status: l,
          transactionId: this._getTransactionId(),
          transactionRecord: TransactionRecord._fromProtobuf({
            transactionRecord: a.transactionGetRecord.transactionRecord
          })
        });
      default:
        return new ReceiptStatusError({
          status: l,
          transactionId: this._getTransactionId(),
          transactionReceipt: TransactionReceipt._fromProtobuf({
            receipt: c
          })
        });
    }
  }
  _validateChecksums(t) {
    this._transactionId != null && this._transactionId.accountId != null && this._transactionId.accountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.crypto.getTxRecordByTxID(a);
  }
  _mapResponseHeader(t) {
    return t.transactionGetRecord.header;
  }
  _mapResponse(t, a, d) {
    const l = t.transactionGetRecord;
    return Promise.resolve(TransactionRecord._fromProtobuf(l));
  }
  _onMakeRequest(t) {
    return {
      transactionGetRecord: {
        header: t,
        transactionID: this._transactionId != null ? this._transactionId._toProtobuf() : null,
        includeChildRecords: this._includeChildren,
        includeDuplicates: this._includeDuplicates
      }
    };
  }
  _getLogId() {
    return `TransactionRecordQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set(
  "transactionGetRecord",
  TransactionRecordQuery._fromProtobuf
);
class TransactionResponse {
  constructor(t) {
    this.nodeId = t.nodeId, this.transactionHash = t.transactionHash, this.transactionId = t.transactionId, Object.freeze(this);
  }
  static fromJSON(t) {
    return new TransactionResponse({
      nodeId: AccountId.fromString(t.nodeId),
      transactionHash: decode$6(t.transactionHash),
      transactionId: TransactionId.fromString(t.transactionId)
    });
  }
  async getReceipt(t) {
    const a = await this.getReceiptQuery().execute(t);
    if (a.status !== Status.Success)
      throw new ReceiptStatusError({
        transactionReceipt: a,
        status: a.status,
        transactionId: this.transactionId
      });
    return a;
  }
  async getRecord(t) {
    return await this.getReceipt(t), this.getRecordQuery().execute(t);
  }
  async getVerboseRecord(t) {
    try {
      return await this.getReceiptQuery().execute(t), this.getRecordQuery().execute(t);
    } catch {
      return this.getRecordQuery().execute(t);
    }
  }
  async getReceiptWithSigner(t) {
    const a = await this.getReceiptQuery().executeWithSigner(t);
    if (a.status !== Status.Success)
      throw new ReceiptStatusError({
        transactionReceipt: a,
        status: a.status,
        transactionId: this.transactionId
      });
    return a;
  }
  async getRecordWithSigner(t) {
    return await this.getReceiptWithSigner(t), this.getRecordQuery().executeWithSigner(t);
  }
  getReceiptQuery() {
    return new TransactionReceiptQuery().setTransactionId(this.transactionId).setNodeAccountIds([this.nodeId]);
  }
  getRecordQuery() {
    return new TransactionRecordQuery().setTransactionId(this.transactionId).setNodeAccountIds([this.nodeId]);
  }
  toJSON() {
    return {
      nodeId: this.nodeId.toString(),
      transactionHash: encode$4(this.transactionHash),
      transactionId: this.transactionId.toString()
    };
  }
  toString() {
    return JSON.stringify(this.toJSON());
  }
}
async function digest(u) {
  return new Uint8Array(await window.crypto.subtle.digest("SHA-384", u));
}
class TransactionHashMap extends ObjectMap {
  constructor() {
    super((t) => AccountId.fromString(t));
  }
  static async _fromTransaction(t) {
    const a = new TransactionHashMap();
    for (let d = 0; d < t._nodeAccountIds.length; d++) {
      const l = t._nodeAccountIds.list[d], h = t._transactions.get(d), g = await digest(
        h.signedTransactionBytes
      );
      a._set(l, g);
    }
    return a;
  }
}
class NodeAccountIdSignatureMap extends ObjectMap {
  constructor() {
    super((t) => PublicKey.fromString(t));
  }
  static _fromTransactionSigMap(t) {
    const a = new NodeAccountIdSignatureMap(), d = t.sigPair != null ? t.sigPair : [];
    for (const l of d)
      l.pubKeyPrefix != null && (l.ed25519 != null ? a._set(
        PublicKey.fromBytesED25519(l.pubKeyPrefix),
        l.ed25519
      ) : l.ECDSASecp256k1 != null && a._set(
        PublicKey.fromBytesECDSA(l.pubKeyPrefix),
        l.ECDSASecp256k1
      ));
    return a;
  }
}
class SignatureMap extends ObjectMap {
  constructor() {
    super((t) => AccountId.fromString(t));
  }
  static _fromTransaction(t) {
    const a = new SignatureMap();
    for (let d = 0; d < t._nodeAccountIds.length; d++) {
      const l = t._signedTransactions.get(d).sigMap;
      l != null && a._set(
        t._nodeAccountIds.list[d],
        NodeAccountIdSignatureMap._fromTransactionSigMap(l)
      );
    }
    return a;
  }
}
const DEFAULT_AUTO_RENEW_PERIOD = long.fromValue(7776e3), DEFAULT_RECORD_THRESHOLD = Hbar.fromTinybars(
  long.fromString("9223372036854775807")
), DEFAULT_TRANSACTION_VALID_DURATION = 120, CHUNK_SIZE = 1024, TRANSACTION_REGISTRY = /* @__PURE__ */ new Map();
class Transaction extends Executable {
  constructor() {
    super(), this._transactions = new List(), this._signedTransactions = new List(), this._signerPublicKeys = /* @__PURE__ */ new Set(), this._transactionValidDuration = DEFAULT_TRANSACTION_VALID_DURATION, this._defaultMaxTransactionFee = new Hbar(2), this._maxTransactionFee = null, this._transactionMemo = "", this._transactionIds = new List(), this._publicKeys = [], this._transactionSigners = [], this._regenerateTransactionId = null;
  }
  static fromBytes(t) {
    const a = [], d = [], l = [], h = [], g = [], c = [], x = lib.proto.TransactionList.decode(t).transactionList;
    if (x.length === 0) {
      const j = lib.proto.Transaction.decode(t);
      j.signedTransactionBytes.length !== 0 ? x.push(j) : x.push({
        signedTransactionBytes: lib.proto.SignedTransaction.encode({
          bodyBytes: j.bodyBytes,
          sigMap: j.sigMap
        }).finish()
      });
    }
    for (const j of x) {
      if (j.signedTransactionBytes == null)
        throw new Error("Transaction.signedTransactionBytes are null");
      const o = lib.proto.SignedTransaction.decode(
        j.signedTransactionBytes
      );
      a.push(o);
      const e = lib.proto.TransactionBody.decode(
        o.bodyBytes
      );
      if (e.data == null)
        throw new Error("(BUG) body.data was not set in the protobuf");
      if (c.push(e), e.transactionID != null) {
        const n = TransactionId._fromProtobuf(
          e.transactionID
        );
        h.includes(n.toString()) || (d.push(n), h.push(n.toString()));
      }
      if (e.nodeAccountID != null) {
        const n = AccountId._fromProtobuf(
          e.nodeAccountID
        );
        g.includes(n.toString()) || (l.push(n), g.push(n.toString()));
      }
    }
    const R = c[0];
    if (R == null || R.data == null)
      throw new Error(
        "No transaction found in bytes or failed to decode TransactionBody"
      );
    const B = TRANSACTION_REGISTRY.get(R.data);
    if (B == null)
      throw new Error(
        `(BUG) Transaction.fromBytes() not implemented for type ${R.data}`
      );
    return B(
      x,
      a,
      d,
      l,
      c
    );
  }
  schedule() {
    if (this._requireNotFrozen(), SCHEDULE_CREATE_TRANSACTION.length != 1)
      throw new Error(
        "ScheduleCreateTransaction has not been loaded yet"
      );
    return SCHEDULE_CREATE_TRANSACTION[0]()._setScheduledTransaction(this);
  }
  static _fromProtobufTransactions(t, a, d, l, h, g) {
    const c = g[0];
    for (let R = 0; R < l.length; R++)
      for (let B = 0; B < h.length - 1; B++)
        if (!compare$1(
          g[R * h.length + B],
          g[R * h.length + B + 1],
          /* @__PURE__ */ new Set(["nodeAccountID"])
        ))
          throw new Error("failed to validate transaction bodies");
    const x = new AccountId(0);
    for (let R = 0; R < h.length; R++)
      h[R].equals(x) && h.splice(R--, 1);
    t._transactions.setList(a), t._signedTransactions.setList(d).setLocked(), t._transactionIds.setList(l).setLocked(), t._nodeAccountIds.setList(h).setLocked(), t._transactionValidDuration = c.transactionValidDuration != null && c.transactionValidDuration.seconds != null ? long.fromValue(c.transactionValidDuration.seconds).toInt() : DEFAULT_TRANSACTION_VALID_DURATION, t._maxTransactionFee = c.transactionFee != null ? Hbar.fromTinybars(c.transactionFee) : new Hbar(0), t._transactionMemo = c.memo != null ? c.memo : "";
    for (let R = 0; R < h.length; R++) {
      const B = d[R];
      if (B.sigMap != null && B.sigMap.sigPair != null)
        for (const j of B.sigMap.sigPair)
          t._signerPublicKeys.add(
            encode$4(
              j.pubKeyPrefix
            )
          ), t._publicKeys.push(
            PublicKey.fromBytes(
              j.pubKeyPrefix
            )
          ), t._transactionSigners.push(null);
    }
    return t;
  }
  setNodeAccountIds(t) {
    return this._requireNotFrozen(), super.setNodeAccountIds(t), this;
  }
  get transactionValidDuration() {
    return this._transactionValidDuration;
  }
  setTransactionValidDuration(t) {
    return this._requireNotFrozen(), this._transactionValidDuration = t, this;
  }
  get maxTransactionFee() {
    return this._maxTransactionFee;
  }
  setMaxTransactionFee(t) {
    return this._requireNotFrozen(), this._maxTransactionFee = t instanceof Hbar ? t : new Hbar(t), this;
  }
  get regenerateTransactionId() {
    return this._regenerateTransactionId;
  }
  setRegenerateTransactionId(t) {
    return this._requireNotFrozen(), this._regenerateTransactionId = t, this;
  }
  get transactionMemo() {
    return this._transactionMemo;
  }
  setTransactionMemo(t) {
    return this._requireNotFrozen(), this._transactionMemo = t, this;
  }
  get transactionId() {
    return this._transactionIds.isEmpty ? null : (this._transactionIds.setLocked(), this._transactionIds.current);
  }
  setTransactionId(t) {
    return this._requireNotFrozen(), this._transactionIds.setList([t]).setLocked(), this;
  }
  sign(t) {
    return this.signWith(
      t.publicKey,
      (a) => Promise.resolve(t.sign(a))
    );
  }
  async signWith(t, a) {
    this._signOnDemand || this._requireFrozen();
    const d = t.toBytesRaw(), l = encode$4(d);
    if (this._signerPublicKeys.has(l))
      return this;
    if (this._transactions.clear(), this._signerPublicKeys.add(l), this._signOnDemand)
      return this._publicKeys.push(t), this._transactionSigners.push(a), this;
    this._transactionIds.setLocked(), this._nodeAccountIds.setLocked();
    for (const h of this._signedTransactions.list) {
      const g = h.bodyBytes, c = await a(g);
      h.sigMap == null && (h.sigMap = {}), h.sigMap.sigPair == null && (h.sigMap.sigPair = []), h.sigMap.sigPair.push(
        t._toProtobufSignature(c)
      );
    }
    return this;
  }
  signWithOperator(t) {
    const a = t._operator;
    if (a == null)
      throw new Error(
        "`client` must have an operator to sign with the operator"
      );
    return this._isFrozen() || this.freezeWith(t), this.signWith(a.publicKey, a.transactionSigner);
  }
  addSignature(t, a) {
    this._requireOneNodeAccountId(), this.isFrozen() || this.freeze();
    const d = t.toBytesRaw(), l = encode$4(d);
    if (this._signerPublicKeys.has(l))
      return this;
    this._transactions.clear(), this._transactionIds.setLocked(), this._nodeAccountIds.setLocked(), this._signedTransactions.setLocked();
    for (const h of this._signedTransactions.list)
      h.sigMap == null && (h.sigMap = {}), h.sigMap.sigPair == null && (h.sigMap.sigPair = []), h.sigMap.sigPair.push(
        t._toProtobufSignature(a)
      );
    return this._signerPublicKeys.add(l), this._publicKeys.push(t), this._transactionSigners.push(null), this;
  }
  getSignatures() {
    return this._requireFrozen(), this._requireNotSignOnDemand(), this._buildAllTransactions(), this._transactionIds.setLocked(), this._nodeAccountIds.setLocked(), SignatureMap._fromTransaction(this);
  }
  async getSignaturesAsync() {
    return this._transactionIds.setLocked(), this._nodeAccountIds.setLocked(), await this._buildAllTransactionsAsync(), this._transactions.setLocked(), this._signedTransactions.setLocked(), SignatureMap._fromTransaction(this);
  }
  _setTransactionId() {
    if (this._operatorAccountId == null && this._transactionIds.isEmpty)
      throw new Error(
        "`transactionId` must be set or `client` must be provided with `freezeWith`"
      );
  }
  _setNodeAccountIds(t) {
    if (!!this._nodeAccountIds.isEmpty) {
      if (t == null)
        throw new Error(
          "`nodeAccountId` must be set or `client` must be provided with `freezeWith`"
        );
      this._nodeAccountIds.setList(
        t._network.getNodeAccountIdsForExecute()
      );
    }
  }
  _buildSignedTransactions() {
    this._signedTransactions.locked || this._signedTransactions.setList(
      this._nodeAccountIds.list.map(
        (t) => this._makeSignedTransaction(t)
      )
    );
  }
  freeze() {
    return this.freezeWith(null);
  }
  _freezeWithAccountId(t) {
    this._operatorAccountId == null && (this._operatorAccountId = t);
  }
  freezeWith(t) {
    if (this._signOnDemand = t != null ? t.signOnDemand : !1, this._operator = t != null ? t._operator : null, this._freezeWithAccountId(
      t != null ? t.operatorAccountId : null
    ), this._maxTransactionFee = this._maxTransactionFee == null ? t != null && t.defaultMaxTransactionFee != null ? t.defaultMaxTransactionFee : this._defaultMaxTransactionFee : this._maxTransactionFee, this._regenerateTransactionId = t != null && this._regenerateTransactionId == null ? t.defaultRegenerateTransactionId : this._regenerateTransactionId, this._setNodeAccountIds(t), this._setTransactionId(), t != null)
      for (const a of this._transactionIds.list)
        a.accountId != null && a.accountId.validateChecksum(t);
    return this._buildNewTransactionIdList(), this._signOnDemand || this._buildSignedTransactions(), this;
  }
  async signWithSigner(t) {
    return await t.signTransaction(this), this;
  }
  async freezeWithSigner(t) {
    return await t.populateTransaction(this), this.freeze(), this;
  }
  toBytes() {
    return this._requireFrozen(), this._requireNotSignOnDemand(), this._transactionIds.setLocked(), this._nodeAccountIds.setLocked(), this._buildAllTransactions(), lib.proto.TransactionList.encode({
      transactionList: this._transactions.list
    }).finish();
  }
  async toBytesAsync() {
    return this._transactionIds.setLocked(), this._nodeAccountIds.setLocked(), await this._buildAllTransactionsAsync(), this._transactions.setLocked(), this._signedTransactions.setLocked(), lib.proto.TransactionList.encode({
      transactionList: this._transactions.list
    }).finish();
  }
  async getTransactionHash() {
    return this._requireFrozen(), this._transactionIds.setLocked(), this._nodeAccountIds.setLocked(), await this._buildAllTransactionsAsync(), this._transactions.setLocked(), this._signedTransactions.setLocked(), digest(
      this._transactions.get(0).signedTransactionBytes
    );
  }
  async getTransactionHashPerNode() {
    return this._requireFrozen(), this._transactionIds.setLocked(), this._nodeAccountIds.setLocked(), await this._buildAllTransactionsAsync(), await TransactionHashMap._fromTransaction(this);
  }
  isFrozen() {
    return this._signedTransactions.length > 0;
  }
  _getTransactionId() {
    const t = this.transactionId;
    if (t == null)
      throw new Error(
        "transaction must have been frozen before getting the transaction ID, try calling `freeze`"
      );
    return t;
  }
  _validateChecksums(t) {
  }
  async _beforeExecute(t) {
    this._logger && this._logger.info(
      `Network used: ${t._network.networkName}`
    ), this._isFrozen() || this.freezeWith(t), t.isAutoValidateChecksumsEnabled() && this._validateChecksums(t), (this._operator == null || this._operator == null) && (this._operator = t != null ? t._operator : null), (this._operatorAccountId == null || this._operatorAccountId == null) && (this._operatorAccountId = t != null && t._operator != null ? t._operator.accountId : null), this._operator != null && await this.signWith(
      this._operator.publicKey,
      this._operator.transactionSigner
    );
  }
  async _makeRequestAsync() {
    const t = this._transactionIds.index * this._nodeAccountIds.length + this._nodeAccountIds.index;
    return this._signOnDemand ? await this._buildTransactionAsync() : (this._buildTransaction(t), this._transactions.get(t));
  }
  async _signTransaction() {
    const t = this._makeSignedTransaction(
      this._nodeAccountIds.next
    ), a = t.bodyBytes;
    for (let d = 0; d < this._publicKeys.length; d++) {
      const l = this._publicKeys[d], h = this._transactionSigners[d];
      if (h == null)
        continue;
      const g = await h(a);
      t.sigMap == null && (t.sigMap = {}), t.sigMap.sigPair == null && (t.sigMap.sigPair = []), t.sigMap.sigPair.push(
        l._toProtobufSignature(g)
      );
    }
    return t;
  }
  _buildNewTransactionIdList() {
    if (this._transactionIds.locked || this._operatorAccountId == null)
      return;
    const t = TransactionId.withValidStart(
      this._operatorAccountId,
      Timestamp.generate()
    );
    this._transactionIds.set(this._transactionIds.index, t);
  }
  _buildAllTransactions() {
    for (let t = 0; t < this._signedTransactions.length; t++)
      this._buildTransaction(t);
  }
  async _buildAllTransactionsAsync() {
    if (!this._signOnDemand) {
      this._buildAllTransactions();
      return;
    }
    if (this._buildSignedTransactions(), !this._transactions.locked)
      for (let t = 0; t < this._signedTransactions.length; t++)
        this._transactions.push(await this._buildTransactionAsync());
  }
  _buildTransaction(t) {
    if (this._transactions.length < t)
      for (let a = this._transactions.length; a < t; a++)
        this._transactions.push(null);
    this._transactions.setIfAbsent(t, () => ({
      signedTransactionBytes: lib.proto.SignedTransaction.encode(
        this._signedTransactions.get(t)
      ).finish()
    }));
  }
  async _buildTransactionAsync() {
    return {
      signedTransactionBytes: lib.proto.SignedTransaction.encode(
        await this._signTransaction()
      ).finish()
    };
  }
  _shouldRetry(t, a) {
    const { nodeTransactionPrecheckCode: d } = a, l = Status._fromCode(
      d != null ? d : lib.proto.ResponseCodeEnum.OK
    );
    switch (this._logger && (this._logger.debug(
      `[${this._getLogId()}] received status ${l.toString()}`
    ), this._logger.info(
      `SDK Transaction Status Response: ${l.toString()}`
    )), l) {
      case Status.Busy:
      case Status.Unknown:
      case Status.PlatformTransactionNotCreated:
      case Status.PlatformNotActive:
        return [l, ExecutionState.Retry];
      case Status.Ok:
        return [l, ExecutionState.Finished];
      case Status.TransactionExpired:
        return this._regenerateTransactionId == null || this._regenerateTransactionId ? (this._buildNewTransactionIdList(), [l, ExecutionState.Retry]) : [l, ExecutionState.Error];
      default:
        return [l, ExecutionState.Error];
    }
  }
  _mapStatusError(t, a) {
    const { nodeTransactionPrecheckCode: d } = a, l = Status._fromCode(
      d != null ? d : lib.proto.ResponseCodeEnum.OK
    );
    return this._logger && this._logger.info(
      `Transaction Error Info: ${l.toString()}, ${this.transactionId.toString()}`
    ), new PrecheckStatusError({
      status: l,
      transactionId: this._getTransactionId(),
      contractFunctionResult: null
    });
  }
  async _mapResponse(t, a, d) {
    const l = await digest(
      d.signedTransactionBytes
    ), h = this._getTransactionId();
    return this._transactionIds.advance(), this._logger && this._logger.info(
      `Transaction Info: ${JSON.stringify(
        new TransactionResponse({
          nodeId: a,
          transactionHash: l,
          transactionId: h
        }).toJSON()
      )}`
    ), new TransactionResponse({
      nodeId: a,
      transactionHash: l,
      transactionId: h
    });
  }
  _makeSignedTransaction(t) {
    const a = this._makeTransactionBody(t);
    return this._logger && this._logger.info(`Transaction Body: ${JSON.stringify(a)}`), {
      bodyBytes: lib.proto.TransactionBody.encode(a).finish(),
      sigMap: {
        sigPair: []
      }
    };
  }
  _makeTransactionBody(t) {
    return {
      [this._getTransactionDataCase()]: this._makeTransactionData(),
      transactionFee: this._maxTransactionFee != null ? this._maxTransactionFee.toTinybars() : null,
      memo: this._transactionMemo,
      transactionID: this._transactionIds.current._toProtobuf(),
      nodeAccountID: t != null ? t._toProtobuf() : null,
      transactionValidDuration: {
        seconds: long.fromNumber(this._transactionValidDuration)
      }
    };
  }
  _getTransactionDataCase() {
    throw new Error("not implemented");
  }
  _getScheduledTransactionBody() {
    return {
      memo: this.transactionMemo,
      transactionFee: this._maxTransactionFee == null ? this._defaultMaxTransactionFee.toTinybars() : this._maxTransactionFee.toTinybars(),
      [this._getTransactionDataCase()]: this._makeTransactionData()
    };
  }
  _makeTransactionData() {
    throw new Error("not implemented");
  }
  _isFrozen() {
    return this._signOnDemand || this._signedTransactions.length > 0 || this._transactions.length > 0;
  }
  _requireNotFrozen() {
    if (this._isFrozen())
      throw new Error(
        "transaction is immutable; it has at least one signature or has been explicitly frozen"
      );
  }
  _requireNotSignOnDemand() {
    if (this._signOnDemand)
      throw new Error(
        "Please use `toBytesAsync()` if `signOnDemand` is enabled"
      );
  }
  _requireFrozen() {
    if (!this._isFrozen())
      throw new Error(
        "transaction must have been frozen before calculating the hash will be stable, try calling `freeze`"
      );
  }
  _requireOneNodeAccountId() {
    if (this._nodeAccountIds.length != 1)
      throw "transaction did not have exactly one node ID set";
  }
  _requestToBytes(t) {
    return lib.proto.Transaction.encode(t).finish();
  }
  _responseToBytes(t) {
    return lib.proto.TransactionResponse.encode(
      t
    ).finish();
  }
}
const SCHEDULE_CREATE_TRANSACTION = [];
class NftId {
  constructor(t, a) {
    this.tokenId = t, this.serial = typeof a == "number" ? long.fromNumber(a) : a, Object.freeze(this);
  }
  static fromString(t) {
    const a = t.split("/").length > 1 ? t.split("/") : t.split("@");
    for (const h of a)
      if (h === "")
        throw new Error(
          "invalid format for NftId: use [token]/[serial] or [token]@[serial]"
        );
    const d = TokenId.fromString(a[0]), l = long.fromString(a[1]);
    return new NftId(d, l);
  }
  static _fromProtobuf(t) {
    return new NftId(
      TokenId._fromProtobuf(
        t.tokenID
      ),
      t.serialNumber != null ? t.serialNumber : long.ZERO
    );
  }
  static fromBytes(t) {
    return NftId._fromProtobuf(lib.proto.NftID.decode(t));
  }
  _toProtobuf() {
    return {
      tokenID: this.tokenId._toProtobuf(),
      serialNumber: long.fromValue(
        this.serial !== void 0 ? this.serial : 0
      )
    };
  }
  toString() {
    return `${this.tokenId.toString()}/${this.serial.toString()}`;
  }
  toBytes() {
    return lib.proto.NftID.encode(this._toProtobuf()).finish();
  }
}
class HbarAllowance {
  constructor(t) {
    this.spenderAccountId = t.spenderAccountId, this.ownerAccountId = t.ownerAccountId, this.amount = t.amount, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    return new HbarAllowance({
      spenderAccountId: AccountId._fromProtobuf(
        t.spender
      ),
      ownerAccountId: t.owner != null ? AccountId._fromProtobuf(
        t.owner
      ) : null,
      amount: Hbar.fromTinybars(
        t.amount != null ? t.amount : 0
      )
    });
  }
  static _fromGrantedProtobuf(t, a) {
    return new HbarAllowance({
      spenderAccountId: AccountId._fromProtobuf(
        t.spender
      ),
      ownerAccountId: a,
      amount: Hbar.fromTinybars(
        t.amount != null ? t.amount : 0
      )
    });
  }
  _toProtobuf() {
    return {
      owner: this.ownerAccountId != null ? this.ownerAccountId._toProtobuf() : null,
      spender: this.spenderAccountId != null ? this.spenderAccountId._toProtobuf() : null,
      amount: this.amount != null ? this.amount.toTinybars() : null
    };
  }
  _validateChecksums(t) {
    this.spenderAccountId != null && this.spenderAccountId.validateChecksum(t), this.spenderAccountId != null && this.spenderAccountId.validateChecksum(t);
  }
  toJSON() {
    return {
      ownerAccountId: this.ownerAccountId != null ? this.ownerAccountId.toString() : null,
      spenderAccountId: this.spenderAccountId != null ? this.spenderAccountId.toString() : null,
      amount: this.amount != null ? this.amount.toString() : null
    };
  }
}
class TokenAllowance {
  constructor(t) {
    this.tokenId = t.tokenId, this.spenderAccountId = t.spenderAccountId, this.ownerAccountId = t.ownerAccountId, this.amount = t.amount, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    return new TokenAllowance({
      tokenId: TokenId._fromProtobuf(
        t.tokenId
      ),
      spenderAccountId: AccountId._fromProtobuf(
        t.spender
      ),
      ownerAccountId: t.owner != null ? AccountId._fromProtobuf(
        t.owner
      ) : null,
      amount: t.amount != null ? long.fromValue(t.amount) : null
    });
  }
  static _fromGrantedProtobuf(t, a) {
    return new TokenAllowance({
      tokenId: TokenId._fromProtobuf(
        t.tokenId
      ),
      spenderAccountId: AccountId._fromProtobuf(
        t.spender
      ),
      ownerAccountId: a,
      amount: t.amount != null ? long.fromValue(t.amount) : null
    });
  }
  _toProtobuf() {
    return {
      tokenId: this.tokenId._toProtobuf(),
      spender: this.spenderAccountId != null ? this.spenderAccountId._toProtobuf() : null,
      owner: this.ownerAccountId != null ? this.ownerAccountId._toProtobuf() : null,
      amount: this.amount
    };
  }
  _validateChecksums(t) {
    this.tokenId.validateChecksum(t), this.ownerAccountId != null && this.ownerAccountId.validateChecksum(t), this.spenderAccountId != null && this.spenderAccountId.validateChecksum(t);
  }
}
class TokenNftAllowance {
  constructor(t) {
    this.tokenId = t.tokenId, this.spenderAccountId = t.spenderAccountId, this.ownerAccountId = t.ownerAccountId, this.serialNumbers = t.serialNumbers, this.allSerials = t.allSerials, this.delegatingSpender = t.delegatingSpender, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    const a = t.approvedForAll != null && t.approvedForAll.value == !0;
    return new TokenNftAllowance({
      tokenId: TokenId._fromProtobuf(
        t.tokenId
      ),
      spenderAccountId: t.spender != null ? AccountId._fromProtobuf(
        t.spender
      ) : null,
      ownerAccountId: t.owner != null ? AccountId._fromProtobuf(
        t.owner
      ) : null,
      serialNumbers: a ? null : t.serialNumbers != null ? t.serialNumbers.map(
        (d) => long.fromValue(d)
      ) : [],
      allSerials: a,
      delegatingSpender: t.delegatingSpender != null ? AccountId._fromProtobuf(
        t.delegatingSpender
      ) : null
    });
  }
  static _fromGrantedProtobuf(t, a) {
    return new TokenNftAllowance({
      tokenId: TokenId._fromProtobuf(
        t.tokenId
      ),
      spenderAccountId: AccountId._fromProtobuf(
        t.spender
      ),
      ownerAccountId: a,
      serialNumbers: [],
      allSerials: null,
      delegatingSpender: null
    });
  }
  static _fromRemoveProtobuf(t) {
    return new TokenNftAllowance({
      tokenId: TokenId._fromProtobuf(
        t.tokenId
      ),
      spenderAccountId: null,
      ownerAccountId: t.owner != null ? AccountId._fromProtobuf(
        t.owner
      ) : null,
      serialNumbers: t.serialNumbers != null ? t.serialNumbers.map(
        (a) => long.fromValue(a)
      ) : [],
      allSerials: null,
      delegatingSpender: null
    });
  }
  _toProtobuf() {
    return {
      tokenId: this.tokenId._toProtobuf(),
      spender: this.spenderAccountId != null ? this.spenderAccountId._toProtobuf() : null,
      owner: this.ownerAccountId != null ? this.ownerAccountId._toProtobuf() : null,
      approvedForAll: this.serialNumbers == null ? { value: this.allSerials } : null,
      serialNumbers: this.serialNumbers,
      delegatingSpender: this.delegatingSpender != null ? this.delegatingSpender._toProtobuf() : null
    };
  }
  _validateChecksums(t) {
    this.tokenId.validateChecksum(t), this.ownerAccountId != null && this.ownerAccountId.validateChecksum(t), this.spenderAccountId != null && this.spenderAccountId.validateChecksum(t);
  }
}
class AccountAllowanceApproveTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._hbarApprovals = t.hbarApprovals != null ? t.hbarApprovals : [], this._tokenApprovals = t.tokenApprovals != null ? t.tokenApprovals : [], this._nftApprovals = t.nftApprovals != null ? t.nftApprovals : [];
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].cryptoApproveAllowance;
    return Transaction._fromProtobufTransactions(
      new AccountAllowanceApproveTransaction({
        hbarApprovals: (c.cryptoAllowances != null ? c.cryptoAllowances : []).map((x) => HbarAllowance._fromProtobuf(x)),
        tokenApprovals: (c.tokenAllowances != null ? c.tokenAllowances : []).map((x) => TokenAllowance._fromProtobuf(x)),
        nftApprovals: (c.nftAllowances != null ? c.nftAllowances : []).map((x) => TokenNftAllowance._fromProtobuf(x))
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get hbarApprovals() {
    return this._hbarApprovals;
  }
  approveHbarAllowance(t, a, d) {
    return this._requireNotFrozen(), this._hbarApprovals.push(
      new HbarAllowance({
        spenderAccountId: typeof a == "string" ? AccountId.fromString(a) : a instanceof ContractId ? AccountId.fromSolidityAddress(
          a.toSolidityAddress()
        ) : a,
        ownerAccountId: typeof t == "string" ? AccountId.fromString(t) : t instanceof ContractId ? AccountId.fromSolidityAddress(
          t.toSolidityAddress()
        ) : t,
        amount: d instanceof Hbar ? d : new Hbar(d)
      })
    ), this;
  }
  addHbarAllowance(t, a) {
    return this._requireNotFrozen(), this._hbarApprovals.push(
      new HbarAllowance({
        spenderAccountId: typeof t == "string" ? AccountId.fromString(t) : t,
        amount: a instanceof Hbar ? a : new Hbar(a),
        ownerAccountId: null
      })
    ), this;
  }
  get tokenApprovals() {
    return this._tokenApprovals;
  }
  approveTokenAllowance(t, a, d, l) {
    return this._requireNotFrozen(), this._tokenApprovals.push(
      new TokenAllowance({
        tokenId: typeof t == "string" ? TokenId.fromString(t) : t,
        spenderAccountId: typeof d == "string" ? AccountId.fromString(d) : d instanceof ContractId ? AccountId.fromSolidityAddress(
          d.toSolidityAddress()
        ) : d,
        ownerAccountId: typeof a == "string" ? AccountId.fromString(a) : a instanceof ContractId ? AccountId.fromSolidityAddress(
          a.toSolidityAddress()
        ) : a,
        amount: typeof l == "number" ? long.fromNumber(l) : l
      })
    ), this;
  }
  addTokenAllowance(t, a, d) {
    return this._requireNotFrozen(), this._tokenApprovals.push(
      new TokenAllowance({
        tokenId: typeof t == "string" ? TokenId.fromString(t) : t,
        spenderAccountId: typeof a == "string" ? AccountId.fromString(a) : a,
        amount: typeof d == "number" ? long.fromNumber(d) : d,
        ownerAccountId: null
      })
    ), this;
  }
  addTokenNftAllowance(t, a) {
    return this._approveTokenNftAllowance(
      t,
      null,
      a,
      null
    );
  }
  get tokenNftApprovals() {
    return this._nftApprovals;
  }
  _approveTokenNftAllowance(t, a, d, l) {
    this._requireNotFrozen();
    const h = typeof t == "string" ? NftId.fromString(t) : t, g = typeof d == "string" ? AccountId.fromString(d) : d instanceof ContractId ? AccountId.fromSolidityAddress(
      d.toSolidityAddress()
    ) : d;
    let c = !1;
    for (const x of this._nftApprovals)
      if (x.tokenId.compare(h.tokenId) === 0 && x.spenderAccountId != null && x.spenderAccountId.compare(g) === 0) {
        x.serialNumbers != null && x.serialNumbers.push(h.serial), c = !0;
        break;
      }
    return c || this._nftApprovals.push(
      new TokenNftAllowance({
        tokenId: h.tokenId,
        spenderAccountId: g,
        ownerAccountId: typeof a == "string" ? AccountId.fromString(a) : a instanceof ContractId ? AccountId.fromSolidityAddress(
          a.toSolidityAddress()
        ) : a,
        serialNumbers: [h.serial],
        allSerials: !1,
        delegatingSpender: typeof l == "string" ? AccountId.fromString(l) : l
      })
    ), this;
  }
  approveTokenNftAllowance(t, a, d) {
    return this._approveTokenNftAllowance(
      t,
      a,
      d,
      null
    );
  }
  approveTokenNftAllowanceWithDelegatingSpender(t, a, d, l) {
    return this._approveTokenNftAllowance(
      t,
      a,
      d,
      l
    );
  }
  _approveAllTokenNftAllowance(t, a, d, l) {
    return this._requireNotFrozen(), this._nftApprovals.push(
      new TokenNftAllowance({
        tokenId: typeof t == "string" ? TokenId.fromString(t) : t,
        spenderAccountId: typeof d == "string" ? AccountId.fromString(d) : d instanceof ContractId ? AccountId.fromSolidityAddress(
          d.toSolidityAddress()
        ) : d,
        ownerAccountId: typeof a == "string" ? AccountId.fromString(a) : a instanceof ContractId ? AccountId.fromSolidityAddress(
          a.toSolidityAddress()
        ) : a,
        serialNumbers: null,
        allSerials: l,
        delegatingSpender: null
      })
    ), this;
  }
  addAllTokenNftAllowance(t, a, d) {
    return this._approveAllTokenNftAllowance(
      t,
      a,
      d,
      !0
    );
  }
  approveTokenNftAllowanceAllSerials(t, a, d) {
    return this._approveAllTokenNftAllowance(
      t,
      a,
      d,
      !0
    );
  }
  deleteTokenNftAllowanceAllSerials(t, a, d) {
    return this._approveAllTokenNftAllowance(
      t,
      a,
      d,
      !1
    );
  }
  _validateChecksums(t) {
    this._hbarApprovals.map(
      (a) => a._validateChecksums(t)
    ), this._tokenApprovals.map(
      (a) => a._validateChecksums(t)
    ), this._nftApprovals.map(
      (a) => a._validateChecksums(t)
    );
  }
  _execute(t, a) {
    return t.crypto.approveAllowances(a);
  }
  _getTransactionDataCase() {
    return "cryptoApproveAllowance";
  }
  _makeTransactionData() {
    return {
      cryptoAllowances: this._hbarApprovals.map(
        (t) => t._toProtobuf()
      ),
      tokenAllowances: this._tokenApprovals.map(
        (t) => t._toProtobuf()
      ),
      nftAllowances: this._nftApprovals.map(
        (t) => t._toProtobuf()
      )
    };
  }
  _getLogId() {
    return `AccountAllowanceApproveTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "cryptoApproveAllowance",
  AccountAllowanceApproveTransaction._fromProtobuf
);
class AccountAllowanceDeleteTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._nftAllowances = t.nftAllowances != null ? t.nftAllowances : [];
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].cryptoDeleteAllowance;
    return Transaction._fromProtobufTransactions(
      new AccountAllowanceDeleteTransaction({
        nftAllowances: (c.nftAllowances != null ? c.nftAllowances : []).map(
          (x) => TokenNftAllowance._fromProtobuf(x)
        )
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenNftAllowanceDeletions() {
    return this._nftAllowances;
  }
  deleteAllTokenNftAllowances(t, a) {
    this._requireNotFrozen();
    const d = typeof t == "string" ? NftId.fromString(t) : t, l = typeof a == "string" ? AccountId.fromString(a) : a;
    let h = !1;
    for (const g of this._nftAllowances)
      if (g.tokenId.compare(d.tokenId) === 0) {
        g.serialNumbers != null && g.serialNumbers.push(d.serial), h = !0;
        break;
      }
    return h || this._nftAllowances.push(
      new TokenNftAllowance({
        tokenId: d.tokenId,
        spenderAccountId: null,
        serialNumbers: [d.serial],
        ownerAccountId: l,
        allSerials: !1,
        delegatingSpender: null
      })
    ), this;
  }
  _validateChecksums(t) {
    this._nftAllowances.map(
      (a) => a._validateChecksums(t)
    );
  }
  _execute(t, a) {
    return t.crypto.deleteAllowances(a);
  }
  _getTransactionDataCase() {
    return "cryptoDeleteAllowance";
  }
  _makeTransactionData() {
    return {
      nftAllowances: this._nftAllowances.map(
        (t) => t._toProtobuf()
      )
    };
  }
  _getLogId() {
    return `AccountAllowanceDeleteTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "cryptoDeleteAllowance",
  AccountAllowanceDeleteTransaction._fromProtobuf
);
class TokenBalanceMap extends ObjectMap {
  constructor() {
    super((t) => TokenId.fromString(t));
  }
}
class TokenDecimalMap extends ObjectMap {
  constructor() {
    super((t) => TokenId.fromString(t));
  }
}
class AccountBalance {
  constructor(t) {
    this.hbars = t.hbars, this.tokens = t.tokens, this.tokenDecimals = t.tokenDecimals, Object.freeze(this);
  }
  static fromBytes(t) {
    return AccountBalance._fromProtobuf(
      lib.proto.CryptoGetAccountBalanceResponse.decode(t)
    );
  }
  static _fromProtobuf(t) {
    const a = new TokenBalanceMap(), d = new TokenDecimalMap();
    if (t.tokenBalances != null)
      for (const l of t.tokenBalances) {
        const h = TokenId._fromProtobuf(
          l.tokenId
        );
        d._set(
          h,
          l.decimals != null ? l.decimals : 0
        ), a._set(
          h,
          long.fromValue(l.balance)
        );
      }
    return new AccountBalance({
      hbars: Hbar.fromTinybars(
        t.balance
      ),
      tokens: a,
      tokenDecimals: d
    });
  }
  _toProtobuf() {
    const t = [];
    for (const [a, d] of this.tokens != null ? this.tokens : [])
      t.push({
        tokenId: a._toProtobuf(),
        balance: d,
        decimals: this.tokenDecimals != null ? this.tokenDecimals.get(a) : null
      });
    return {
      balance: this.hbars.toTinybars(),
      tokenBalances: t
    };
  }
  toBytes() {
    return lib.proto.CryptoGetAccountBalanceResponse.encode(
      this._toProtobuf()
    ).finish();
  }
  toString() {
    return JSON.stringify(this.toJSON());
  }
  toJSON() {
    const t = [];
    for (const [a, d] of this.tokens != null ? this.tokens : []) {
      const l = this.tokenDecimals != null ? this.tokenDecimals.get(a) : null;
      t.push({
        tokenId: a.toString(),
        balance: d.toString(),
        decimals: l != null ? l : 0
      });
    }
    return {
      hbars: this.hbars.toString(),
      tokens: t
    };
  }
}
class AccountBalanceQuery extends Query {
  constructor(t = {}) {
    super(), this._accountId = null, this._contractId = null, t.accountId != null && this.setAccountId(t.accountId), t.contractId != null && this.setContractId(t.contractId);
  }
  static _fromProtobuf(t) {
    const a = t.cryptogetAccountBalance;
    return new AccountBalanceQuery({
      accountId: a.accountID != null ? AccountId._fromProtobuf(a.accountID) : void 0,
      contractId: a.contractID != null ? ContractId._fromProtobuf(a.contractID) : void 0
    });
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  get contractId() {
    return this._contractId;
  }
  setContractId(t) {
    return this._contractId = typeof t == "string" ? ContractId.fromString(t) : t.clone(), this;
  }
  _isPaymentRequired() {
    return !1;
  }
  _validateChecksums(t) {
    this._accountId != null && this._accountId.validateChecksum(t), this._contractId != null && this._contractId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.crypto.cryptoGetBalance(a);
  }
  _mapResponseHeader(t) {
    return t.cryptogetAccountBalance.header;
  }
  _mapResponse(t, a, d) {
    const l = t.cryptogetAccountBalance;
    return Promise.resolve(
      AccountBalance._fromProtobuf(l)
    );
  }
  _onMakeRequest(t) {
    return {
      cryptogetAccountBalance: {
        header: t,
        accountID: this._accountId != null ? this._accountId._toProtobuf() : null,
        contractID: this._contractId != null ? this._contractId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `AccountBalanceQuery:${this._timestamp.toString()}`;
  }
}
QUERY_REGISTRY.set(
  "cryptogetAccountBalance",
  AccountBalanceQuery._fromProtobuf
);
class Duration {
  constructor(t) {
    this.seconds = t instanceof long ? t : long.fromNumber(t), Object.freeze(this);
  }
  _toProtobuf() {
    return {
      seconds: this.seconds
    };
  }
  static _fromProtobuf(t) {
    return new Duration(t.seconds);
  }
}
class AccountCreateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._key = null, this._initialBalance = null, this._sendRecordThreshold = DEFAULT_RECORD_THRESHOLD, this._receiveRecordThreshold = DEFAULT_RECORD_THRESHOLD, this._receiverSignatureRequired = !1, this._proxyAccountId = null, this._autoRenewPeriod = new Duration(DEFAULT_AUTO_RENEW_PERIOD), this._accountMemo = null, this._maxAutomaticTokenAssociations = null, this._stakedAccountId = null, this._stakedNodeId = null, this._declineStakingReward = !1, this._alias = null, t.key != null && this.setKey(t.key), t.receiverSignatureRequired != null && this.setReceiverSignatureRequired(t.receiverSignatureRequired), t.initialBalance != null && this.setInitialBalance(t.initialBalance), t.proxyAccountId != null && this.setProxyAccountId(t.proxyAccountId), t.autoRenewPeriod != null && this.setAutoRenewPeriod(t.autoRenewPeriod), t.accountMemo != null && this.setAccountMemo(t.accountMemo), t.maxAutomaticTokenAssociations != null && this.setMaxAutomaticTokenAssociations(
      t.maxAutomaticTokenAssociations
    ), t.stakedAccountId != null && this.setStakedAccountId(t.stakedAccountId), t.stakedNodeId != null && this.setStakedNodeId(t.stakedNodeId), t.declineStakingReward != null && this.setDeclineStakingReward(t.declineStakingReward), t.alias != null && this.setAlias(t.alias);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].cryptoCreateAccount;
    let x;
    return c.alias != null && c.alias.length > 0 && c.alias.length === 20 && (x = EvmAddress.fromBytes(c.alias)), Transaction._fromProtobufTransactions(
      new AccountCreateTransaction({
        key: c.key != null ? Key._fromProtobufKey(c.key) : void 0,
        initialBalance: c.initialBalance != null ? c.initialBalance : void 0,
        receiverSignatureRequired: c.receiverSigRequired != null ? c.receiverSigRequired : void 0,
        proxyAccountId: c.proxyAccountID != null ? AccountId._fromProtobuf(
          c.proxyAccountID
        ) : void 0,
        autoRenewPeriod: c.autoRenewPeriod != null && c.autoRenewPeriod.seconds != null ? c.autoRenewPeriod.seconds : void 0,
        accountMemo: c.memo != null ? c.memo : void 0,
        maxAutomaticTokenAssociations: c.maxAutomaticTokenAssociations != null ? c.maxAutomaticTokenAssociations : void 0,
        stakedAccountId: c.stakedAccountId != null ? AccountId._fromProtobuf(c.stakedAccountId) : void 0,
        stakedNodeId: c.stakedNodeId != null ? c.stakedNodeId : void 0,
        declineStakingReward: c.declineReward == !0,
        alias: x
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get key() {
    return this._key;
  }
  setKey(t) {
    return this._requireNotFrozen(), this._key = t, this;
  }
  get initialBalance() {
    return this._initialBalance;
  }
  setInitialBalance(t) {
    return this._requireNotFrozen(), this._initialBalance = t instanceof Hbar ? t : new Hbar(t), this;
  }
  get receiverSignatureRequired() {
    return this._receiverSignatureRequired;
  }
  setReceiverSignatureRequired(t) {
    return this._requireNotFrozen(), this._receiverSignatureRequired = t, this;
  }
  get proxyAccountId() {
    return this._proxyAccountId;
  }
  setProxyAccountId(t) {
    return this._requireNotFrozen(), this._proxyAccountId = t, this;
  }
  get autoRenewPeriod() {
    return this._autoRenewPeriod;
  }
  setAutoRenewPeriod(t) {
    return this._requireNotFrozen(), this._autoRenewPeriod = t instanceof Duration ? t : new Duration(t), this;
  }
  get accountMemo() {
    return this._accountMemo;
  }
  setAccountMemo(t) {
    return this._requireNotFrozen(), this._accountMemo = t, this;
  }
  get maxAutomaticTokenAssociations() {
    return this._maxAutomaticTokenAssociations;
  }
  setMaxAutomaticTokenAssociations(t) {
    return this._requireNotFrozen(), this._maxAutomaticTokenAssociations = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  get stakedAccountId() {
    return this._stakedAccountId;
  }
  setStakedAccountId(t) {
    return this._requireNotFrozen(), this._stakedAccountId = typeof t == "string" ? AccountId.fromString(t) : t, this;
  }
  get stakedNodeId() {
    return this._stakedNodeId;
  }
  setStakedNodeId(t) {
    return this._requireNotFrozen(), this._stakedNodeId = long.fromValue(t), this;
  }
  get declineStakingRewards() {
    return this._declineStakingReward;
  }
  setDeclineStakingReward(t) {
    return this._requireNotFrozen(), this._declineStakingReward = t, this;
  }
  get alias() {
    return this._alias;
  }
  setAlias(t) {
    if (typeof t == "string")
      if (t.startsWith("0x") && t.length == 42 || t.length == 40)
        this._alias = EvmAddress.fromString(t);
      else
        throw new Error(
          'evmAddress must be a valid EVM address with or without "0x" prefix'
        );
    else
      this._alias = t;
    return this;
  }
  _validateChecksums(t) {
    this._proxyAccountId != null && this._proxyAccountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.crypto.createAccount(a);
  }
  _getTransactionDataCase() {
    return "cryptoCreateAccount";
  }
  _makeTransactionData() {
    let t = null;
    return this._alias != null && (t = this._alias.toBytes()), {
      key: this._key != null ? this._key._toProtobufKey() : null,
      initialBalance: this._initialBalance != null ? this._initialBalance.toTinybars() : null,
      autoRenewPeriod: this._autoRenewPeriod._toProtobuf(),
      proxyAccountID: this._proxyAccountId != null ? this._proxyAccountId._toProtobuf() : null,
      receiveRecordThreshold: this._receiveRecordThreshold.toTinybars(),
      sendRecordThreshold: this._sendRecordThreshold.toTinybars(),
      receiverSigRequired: this._receiverSignatureRequired,
      memo: this._accountMemo,
      maxAutomaticTokenAssociations: this._maxAutomaticTokenAssociations != null ? this._maxAutomaticTokenAssociations.toInt() : null,
      stakedAccountId: this.stakedAccountId != null ? this.stakedAccountId._toProtobuf() : null,
      stakedNodeId: this.stakedNodeId,
      declineReward: this.declineStakingRewards,
      alias: t
    };
  }
  _getLogId() {
    return `AccountCreateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "cryptoCreateAccount",
  AccountCreateTransaction._fromProtobuf
);
class AccountDeleteTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._accountId = null, this._transferAccountId = null, t.accountId != null && this.setAccountId(t.accountId), t.transferAccountId != null && this.setTransferAccountId(t.transferAccountId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].cryptoDelete;
    return Transaction._fromProtobufTransactions(
      new AccountDeleteTransaction({
        accountId: c.deleteAccountID != null ? AccountId._fromProtobuf(
          c.deleteAccountID
        ) : void 0,
        transferAccountId: c.transferAccountID != null ? AccountId._fromProtobuf(
          c.transferAccountID
        ) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._requireNotFrozen(), this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  get transferAccountId() {
    return this._transferAccountId;
  }
  setTransferAccountId(t) {
    return this._requireNotFrozen(), this._transferAccountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._accountId != null && this._accountId.validateChecksum(t), this._transferAccountId != null && this._transferAccountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.crypto.cryptoDelete(a);
  }
  _getTransactionDataCase() {
    return "cryptoDelete";
  }
  _makeTransactionData() {
    return {
      deleteAccountID: this._accountId != null ? this._accountId._toProtobuf() : null,
      transferAccountID: this._transferAccountId != null ? this._transferAccountId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `AccountDeleteTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "cryptoDelete",
  AccountDeleteTransaction._fromProtobuf
);
class StakingInfo {
  constructor(t) {
    this.declineStakingReward = t.declineStakingReward, this.stakePeriodStart = t.stakePeriodStart, this.pendingReward = t.pendingReward, this.stakedToMe = t.stakedToMe, this.stakedAccountId = t.stakedAccountId, this.stakedNodeId = t.stakedNodeId, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    return new StakingInfo({
      declineStakingReward: t.declineReward == !0,
      stakePeriodStart: t.stakePeriodStart != null ? Timestamp._fromProtobuf(t.stakePeriodStart) : null,
      pendingReward: t.pendingReward != null ? Hbar.fromTinybars(t.pendingReward) : null,
      stakedToMe: t.stakedToMe != null ? Hbar.fromTinybars(t.stakedToMe) : null,
      stakedAccountId: t.stakedAccountId != null ? AccountId._fromProtobuf(t.stakedAccountId) : null,
      stakedNodeId: t.stakedNodeId != null ? t.stakedNodeId : null
    });
  }
  _toProtobuf() {
    return {
      declineReward: this.declineStakingReward,
      stakePeriodStart: this.stakePeriodStart != null ? this.stakePeriodStart._toProtobuf() : null,
      pendingReward: this.pendingReward != null ? this.pendingReward.toTinybars() : null,
      stakedToMe: this.stakedToMe != null ? this.stakedToMe.toTinybars() : null,
      stakedAccountId: this.stakedAccountId != null ? this.stakedAccountId._toProtobuf() : null,
      stakedNodeId: this.stakedNodeId
    };
  }
  static fromBytes(t) {
    return StakingInfo._fromProtobuf(
      lib.proto.StakingInfo.decode(t)
    );
  }
  toBytes() {
    return lib.proto.StakingInfo.encode(
      this._toProtobuf()
    ).finish();
  }
  toString() {
    return JSON.stringify(this.toJSON());
  }
  toJSON() {
    return {
      declineStakingReward: this.declineStakingReward,
      stakePeriodStart: this.stakePeriodStart != null ? this.stakePeriodStart.toString() : null,
      pendingReward: this.pendingReward != null ? this.pendingReward.toString() : null,
      stakedToMe: this.stakedToMe != null ? this.stakedToMe.toString() : null,
      stakedAccountId: this.stakedAccountId != null ? this.stakedAccountId.toString() : null,
      stakedNodeId: this.stakedNodeId != null ? this.stakedNodeId.toString() : null
    };
  }
}
class LiveHash {
  constructor(t) {
    this.accountId = t.accountId, this.hash = t.hash, this.keys = t.keys, this.duration = t.duration, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    const a = t;
    return new LiveHash({
      accountId: AccountId._fromProtobuf(
        a.accountId
      ),
      hash: a.hash != null ? a.hash : new Uint8Array(),
      keys: a.keys != null ? KeyList.__fromProtobufKeyList(a.keys) : new KeyList(),
      duration: Duration._fromProtobuf(
        a.duration
      )
    });
  }
  _toProtobuf() {
    return {
      accountId: this.accountId._toProtobuf(),
      hash: this.hash,
      keys: this.keys._toProtobufKey().keyList,
      duration: this.duration._toProtobuf()
    };
  }
}
class TokenRelationship {
  constructor(t) {
    this.tokenId = t.tokenId, this.symbol = t.symbol, this.balance = t.balance, this.isKycGranted = t.isKycGranted, this.isFrozen = t.isFrozen, this.automaticAssociation = t.automaticAssociation, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    const a = TokenId._fromProtobuf(
      t.tokenId
    ), d = t.kycStatus == null || t.kycStatus === 0 ? null : t.kycStatus === 1, l = t.freezeStatus == null || t.freezeStatus === 0 ? null : t.freezeStatus === 1;
    return new TokenRelationship({
      tokenId: a,
      symbol: t.symbol,
      balance: t.balance != null ? t.balance instanceof long ? t.balance : long.fromValue(t.balance) : long.ZERO,
      isKycGranted: d,
      isFrozen: l,
      automaticAssociation: t.automaticAssociation != null ? t.automaticAssociation : null
    });
  }
  _toProtobuf() {
    return {
      tokenId: this.tokenId._toProtobuf(),
      symbol: this.symbol,
      balance: this.balance,
      kycStatus: this.isKycGranted == null ? 0 : this.isKycGranted ? 1 : 2,
      freezeStatus: this.isFrozen == null ? 0 : this.isFrozen ? 1 : 2,
      automaticAssociation: this.automaticAssociation
    };
  }
}
class TokenRelationshipMap extends ObjectMap {
  constructor() {
    super((t) => TokenId.fromString(t));
  }
  static _fromProtobuf(t) {
    const a = new TokenRelationshipMap();
    for (const d of t) {
      const l = TokenId._fromProtobuf(
        d.tokenId
      );
      a._set(
        l,
        TokenRelationship._fromProtobuf(d)
      );
    }
    return a;
  }
  _toProtobuf() {
    const t = [];
    for (const [a, d] of this)
      t.push(d._toProtobuf());
    return t;
  }
}
class LedgerId {
  constructor(t) {
    this._ledgerId = t, Object.freeze(this);
  }
  static fromString(t) {
    switch (t) {
      case NETNAMES[0]:
      case "0":
        return LedgerId.MAINNET;
      case NETNAMES[1]:
      case "1":
        return LedgerId.TESTNET;
      case NETNAMES[2]:
      case "2":
        return LedgerId.PREVIEWNET;
      case NETNAMES[3]:
      case "3":
        return LedgerId.LOCAL_NODE;
      default: {
        let a = decode$6(t);
        if (a.length == 0 && t.length != 0)
          throw new Error("Default reached for fromString");
        return new LedgerId(a);
      }
    }
  }
  toString() {
    if (this._ledgerId.length == 1)
      switch (this._ledgerId[0]) {
        case 0:
          return NETNAMES[0];
        case 1:
          return NETNAMES[1];
        case 2:
          return NETNAMES[2];
        case 3:
          return NETNAMES[3];
        default:
          return encode$4(this._ledgerId);
      }
    else
      return encode$4(this._ledgerId);
  }
  static fromBytes(t) {
    return new LedgerId(t);
  }
  toBytes() {
    return this._ledgerId;
  }
  isMainnet() {
    return this.toString() == NETNAMES[0];
  }
  isTestnet() {
    return this.toString() == NETNAMES[1];
  }
  isPreviewnet() {
    return this.toString() == NETNAMES[2];
  }
  isLocalNode() {
    return this.toString() == NETNAMES[3];
  }
}
const NETNAMES = ["mainnet", "testnet", "previewnet", "local-node"];
LedgerId.MAINNET = new LedgerId(new Uint8Array([0]));
LedgerId.TESTNET = new LedgerId(new Uint8Array([1]));
LedgerId.PREVIEWNET = new LedgerId(new Uint8Array([2]));
LedgerId.LOCAL_NODE = new LedgerId(new Uint8Array([3]));
class AccountInfo {
  constructor(t) {
    this.accountId = t.accountId, this.contractAccountId = t.contractAccountId, this.isDeleted = t.isDeleted, this.proxyAccountId = t.proxyAccountId, this.proxyReceived = t.proxyReceived, this.key = t.key, this.balance = t.balance, this.sendRecordThreshold = t.sendRecordThreshold, this.receiveRecordThreshold = t.receiveRecordThreshold, this.isReceiverSignatureRequired = t.isReceiverSignatureRequired, this.expirationTime = t.expirationTime, this.autoRenewPeriod = t.autoRenewPeriod, this.liveHashes = t.liveHashes, this.tokenRelationships = t.tokenRelationships, this.accountMemo = t.accountMemo, this.ownedNfts = t.ownedNfts, this.maxAutomaticTokenAssociations = t.maxAutomaticTokenAssociations, this.aliasKey = t.aliasKey, this.ledgerId = t.ledgerId, this.hbarAllowances = t.hbarAllowances, this.tokenAllowances = t.tokenAllowances, this.nftAllowances = t.nftAllowances, this.ethereumNonce = t.ethereumNonce, this.stakingInfo = t.stakingInfo, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    let a = t.alias != null && t.alias.length > 0 ? Key._fromProtobufKey(
      lib.proto.Key.decode(t.alias)
    ) : null;
    a instanceof PublicKey || (a = null);
    const d = AccountId._fromProtobuf(
      t.accountID
    );
    return new AccountInfo({
      accountId: d,
      contractAccountId: t.contractAccountID != null ? t.contractAccountID : null,
      isDeleted: t.deleted != null ? t.deleted : !1,
      key: Key._fromProtobufKey(
        t.key
      ),
      balance: Hbar.fromTinybars(t.balance != null ? t.balance : 0),
      sendRecordThreshold: Hbar.fromTinybars(
        t.generateSendRecordThreshold != null ? t.generateSendRecordThreshold : 0
      ),
      receiveRecordThreshold: Hbar.fromTinybars(
        t.generateReceiveRecordThreshold != null ? t.generateReceiveRecordThreshold : 0
      ),
      isReceiverSignatureRequired: t.receiverSigRequired != null ? t.receiverSigRequired : !1,
      expirationTime: Timestamp._fromProtobuf(
        t.expirationTime
      ),
      autoRenewPeriod: t.autoRenewPeriod != null ? new Duration(
        t.autoRenewPeriod.seconds
      ) : new Duration(0),
      proxyAccountId: t.proxyAccountID != null && long.fromValue(
        t.proxyAccountID.shardNum
      ).toInt() !== 0 && long.fromValue(
        t.proxyAccountID.realmNum
      ).toInt() !== 0 && long.fromValue(
        t.proxyAccountID.accountNum
      ).toInt() !== 0 ? AccountId._fromProtobuf(t.proxyAccountID) : null,
      proxyReceived: Hbar.fromTinybars(
        t.proxyReceived != null ? t.proxyReceived : 0
      ),
      liveHashes: (t.liveHashes != null ? t.liveHashes : []).map(
        (l) => LiveHash._fromProtobuf(l)
      ),
      tokenRelationships: TokenRelationshipMap._fromProtobuf(
        t.tokenRelationships != null ? t.tokenRelationships : []
      ),
      accountMemo: t.memo != null ? t.memo : "",
      ownedNfts: t.ownedNfts ? t.ownedNfts : long.ZERO,
      maxAutomaticTokenAssociations: t.maxAutomaticTokenAssociations ? long.fromNumber(t.maxAutomaticTokenAssociations) : long.ZERO,
      aliasKey: a,
      ledgerId: t.ledgerId != null ? LedgerId.fromBytes(t.ledgerId) : null,
      hbarAllowances: [],
      tokenAllowances: [],
      nftAllowances: [],
      ethereumNonce: t.ethereumNonce != null ? t.ethereumNonce : null,
      stakingInfo: t.stakingInfo != null ? StakingInfo._fromProtobuf(t.stakingInfo) : null
    });
  }
  _toProtobuf() {
    return {
      accountID: this.accountId._toProtobuf(),
      contractAccountID: this.contractAccountId,
      deleted: this.isDeleted,
      proxyAccountID: this.proxyAccountId != null ? this.proxyAccountId._toProtobuf() : null,
      proxyReceived: this.proxyReceived.toTinybars(),
      key: this.key._toProtobufKey(),
      balance: this.balance.toTinybars(),
      generateSendRecordThreshold: this.sendRecordThreshold.toTinybars(),
      generateReceiveRecordThreshold: this.receiveRecordThreshold.toTinybars(),
      receiverSigRequired: this.isReceiverSignatureRequired,
      expirationTime: this.expirationTime._toProtobuf(),
      autoRenewPeriod: this.autoRenewPeriod._toProtobuf(),
      liveHashes: this.liveHashes.map((t) => t._toProtobuf()),
      tokenRelationships: this.tokenRelationships != null ? this.tokenRelationships._toProtobuf() : null,
      memo: this.accountMemo,
      ownedNfts: this.ownedNfts,
      maxAutomaticTokenAssociations: this.maxAutomaticTokenAssociations.toInt(),
      alias: this.aliasKey != null ? lib.proto.Key.encode(
        this.aliasKey._toProtobufKey()
      ).finish() : null,
      ledgerId: this.ledgerId != null ? this.ledgerId.toBytes() : null,
      ethereumNonce: this.ethereumNonce,
      stakingInfo: this.stakingInfo != null ? this.stakingInfo._toProtobuf() : null
    };
  }
  static fromBytes(t) {
    return AccountInfo._fromProtobuf(
      lib.proto.CryptoGetInfoResponse.AccountInfo.decode(t)
    );
  }
  toBytes() {
    return lib.proto.CryptoGetInfoResponse.AccountInfo.encode(
      this._toProtobuf()
    ).finish();
  }
  toString() {
    return JSON.stringify(this.toJSON());
  }
  toJSON() {
    return {
      balance: this.balance.toString(),
      accountId: this.accountId.toString(),
      contractAccountId: this.contractAccountId,
      isDeleted: this.isDeleted,
      proxyAccountId: this.proxyAccountId != null ? this.proxyAccountId.toString() : null,
      proxyReceived: this.proxyReceived.toString(),
      key: this.key != null ? this.key.toString() : null,
      sendRecordThreshold: this.sendRecordThreshold.toString(),
      receiveRecordThreshold: this.receiveRecordThreshold.toString(),
      isReceiverSignatureRequired: this.isReceiverSignatureRequired,
      expirationTime: this.expirationTime.toString(),
      autoRenewPeriod: this.autoRenewPeriod.toString(),
      accountMemo: this.accountMemo,
      ownedNfts: this.ownedNfts.toString(),
      maxAutomaticTokenAssociations: this.maxAutomaticTokenAssociations.toString(),
      aliasKey: this.aliasKey != null ? this.aliasKey.toString() : null,
      ledgerId: this.ledgerId != null ? this.ledgerId.toString() : null,
      ethereumNonce: this.ethereumNonce != null ? this.ethereumNonce.toString() : null,
      stakingInfo: this.stakingInfo != null ? this.stakingInfo.toJSON() : null
    };
  }
}
class AccountInfoQuery extends Query {
  constructor(t = {}) {
    super(), this._accountId = null, t.accountId != null && this.setAccountId(t.accountId);
  }
  static _fromProtobuf(t) {
    const a = t.cryptoGetInfo;
    return new AccountInfoQuery({
      accountId: a.accountID != null ? AccountId._fromProtobuf(a.accountID) : void 0
    });
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._accountId != null && this._accountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.crypto.getAccountInfo(a);
  }
  async getCost(t) {
    return super.getCost(t);
  }
  _mapResponseHeader(t) {
    return t.cryptoGetInfo.header;
  }
  _mapResponse(t, a, d) {
    const l = t.cryptoGetInfo;
    return Promise.resolve(
      AccountInfo._fromProtobuf(
        l.accountInfo
      )
    );
  }
  _onMakeRequest(t) {
    return {
      cryptoGetInfo: {
        header: t,
        accountID: this._accountId != null ? this._accountId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `AccountInfoQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set("cryptoGetInfo", AccountInfoQuery._fromProtobuf);
class AccountRecordsQuery extends Query {
  constructor(t = {}) {
    super(), this._accountId = null, t.accountId != null && this.setAccountId(t.accountId);
  }
  static _fromProtobuf(t) {
    const a = t.cryptoGetAccountRecords;
    return new AccountRecordsQuery({
      accountId: a.accountID != null ? AccountId._fromProtobuf(a.accountID) : void 0
    });
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._accountId != null && this._accountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.crypto.getAccountRecords(a);
  }
  _mapResponseHeader(t) {
    return t.cryptoGetAccountRecords.header;
  }
  _mapResponse(t, a, d) {
    const h = t.cryptoGetAccountRecords.records;
    return Promise.resolve(
      h.map(
        (g) => TransactionRecord._fromProtobuf({ transactionRecord: g })
      )
    );
  }
  _onMakeRequest(t) {
    return {
      cryptoGetAccountRecords: {
        header: t,
        accountID: this._accountId != null ? this._accountId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `AccountRecordsQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set(
  "cryptoGetAccountRecords",
  AccountRecordsQuery._fromProtobuf
);
class ProxyStaker {
  constructor(t) {
    this.accountId = t.accountId, this.amount = t.amount instanceof Hbar ? t.amount : new Hbar(t.amount), Object.freeze(this);
  }
  static _fromProtobuf(t) {
    return new ProxyStaker({
      accountId: AccountId._fromProtobuf(
        t.accountID
      ),
      amount: Hbar.fromTinybars(
        t.amount != null ? t.amount : 0
      )
    });
  }
  _toProtobuf() {
    return {
      accountID: this.accountId._toProtobuf(),
      amount: this.amount.toTinybars()
    };
  }
}
class AccountStakersQuery extends Query {
  constructor(t = {}) {
    super(), this._accountId = null, t.accountId != null && this.setAccountId(t.accountId);
  }
  static _fromProtobuf(t) {
    const a = t.cryptoGetProxyStakers;
    return new AccountStakersQuery({
      accountId: a.accountID != null ? AccountId._fromProtobuf(a.accountID) : void 0
    });
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._accountId != null && this._accountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.crypto.getStakersByAccountID(a);
  }
  _mapResponseHeader(t) {
    return t.cryptoGetProxyStakers.header;
  }
  _mapResponse(t) {
    const d = t.cryptoGetProxyStakers.stakers;
    return Promise.resolve(
      (d.proxyStaker != null ? d.proxyStaker : []).map(
        (l) => ProxyStaker._fromProtobuf(l)
      )
    );
  }
  _onMakeRequest(t) {
    return {
      cryptoGetProxyStakers: {
        header: t,
        accountID: this._accountId != null ? this._accountId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `AccountStakersQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set("cryptoGetProxyStakers", AccountStakersQuery._fromProtobuf);
class AccountUpdateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._accountId = null, this._key = null, this._receiverSignatureRequired = !1, this._proxyAccountId = null, this._autoRenewPeriod = null, this._expirationTime = null, this._accountMemo = null, this._maxAutomaticTokenAssociations = null, this._aliasKey = null, this._stakedAccountId = null, this._stakedNodeId = null, this._declineStakingReward = null, t.accountId != null && this.setAccountId(t.accountId), t.key != null && this.setKey(t.key), t.receiverSignatureRequired != null && this.setReceiverSignatureRequired(t.receiverSignatureRequired), t.proxyAccountId != null && this.setProxyAccountId(t.proxyAccountId), t.autoRenewPeriod != null && this.setAutoRenewPeriod(t.autoRenewPeriod), t.expirationTime != null && this.setExpirationTime(t.expirationTime), t.accountMemo != null && this.setAccountMemo(t.accountMemo), t.maxAutomaticTokenAssociations != null && this.setMaxAutomaticTokenAssociations(
      t.maxAutomaticTokenAssociations
    ), t.stakedAccountId != null && this.setStakedAccountId(t.stakedAccountId), t.stakedNodeId != null && this.setStakedNodeId(t.stakedNodeId), t.declineStakingReward != null && this.setDeclineStakingReward(t.declineStakingReward);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].cryptoUpdateAccount;
    return Transaction._fromProtobufTransactions(
      new AccountUpdateTransaction({
        accountId: c.accountIDToUpdate != null ? AccountId._fromProtobuf(
          c.accountIDToUpdate
        ) : void 0,
        key: c.key != null ? Key._fromProtobufKey(c.key) : void 0,
        receiverSignatureRequired: c.receiverSigRequired != null ? c.receiverSigRequired : void 0,
        proxyAccountId: c.proxyAccountID != null ? AccountId._fromProtobuf(
          c.proxyAccountID
        ) : void 0,
        autoRenewPeriod: c.autoRenewPeriod != null && c.autoRenewPeriod.seconds != null ? c.autoRenewPeriod.seconds : void 0,
        expirationTime: c.expirationTime != null ? Timestamp._fromProtobuf(c.expirationTime) : void 0,
        accountMemo: c.memo != null && c.memo.value != null ? c.memo.value : void 0,
        maxAutomaticTokenAssociations: c.maxAutomaticTokenAssociations != null && c.maxAutomaticTokenAssociations.value != null ? long.fromNumber(
          c.maxAutomaticTokenAssociations.value
        ) : void 0,
        stakedAccountId: c.stakedAccountId != null ? AccountId._fromProtobuf(c.stakedAccountId) : void 0,
        stakedNodeId: c.stakedNodeId != null ? c.stakedNodeId : void 0,
        declineStakingReward: c.declineReward != null && Boolean(c.declineReward) == !0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._requireNotFrozen(), this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  get key() {
    return this._key;
  }
  setKey(t) {
    return this._requireNotFrozen(), this._key = t, this;
  }
  get receiverSignatureRequired() {
    return this._receiverSignatureRequired;
  }
  setReceiverSignatureRequired(t) {
    return this._requireNotFrozen(), this._receiverSignatureRequired = t, this;
  }
  get proxyAccountId() {
    return this._proxyAccountId;
  }
  setProxyAccountId(t) {
    return this._requireNotFrozen(), this._proxyAccountId = t, this;
  }
  get autoRenewPeriod() {
    return this._autoRenewPeriod;
  }
  setAutoRenewPeriod(t) {
    return this._requireNotFrozen(), this._autoRenewPeriod = t instanceof Duration ? t : new Duration(t), this;
  }
  get expirationTime() {
    return this._expirationTime;
  }
  setExpirationTime(t) {
    return this._requireNotFrozen(), this._expirationTime = t instanceof Date ? Timestamp.fromDate(t) : t, this;
  }
  get accountMemo() {
    return this._accountMemo;
  }
  setAccountMemo(t) {
    return this._requireNotFrozen(), this._accountMemo = t, this;
  }
  clearAccountMemo() {
    return this._requireNotFrozen(), this._accountMemo = null, this;
  }
  get maxAutomaticTokenAssociations() {
    return this._maxAutomaticTokenAssociations;
  }
  setMaxAutomaticTokenAssociations(t) {
    return this._requireNotFrozen(), this._maxAutomaticTokenAssociations = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  get aliasKey() {
    return null;
  }
  setAliasKey(t) {
    return this;
  }
  get stakedAccountId() {
    return this._stakedAccountId;
  }
  setStakedAccountId(t) {
    return this._requireNotFrozen(), this._stakedAccountId = typeof t == "string" ? AccountId.fromString(t) : t, this;
  }
  clearStakedAccountId() {
    return this._requireNotFrozen(), this._stakedAccountId = new AccountId(0, 0, 0), this;
  }
  get stakedNodeId() {
    return this._stakedNodeId;
  }
  setStakedNodeId(t) {
    return this._requireNotFrozen(), this._stakedNodeId = long.fromValue(t), this;
  }
  clearStakedNodeId() {
    return this._requireNotFrozen(), this._stakedNodeId = long.fromNumber(-1), this;
  }
  get declineStakingRewards() {
    return this._declineStakingReward;
  }
  setDeclineStakingReward(t) {
    return this._requireNotFrozen(), this._declineStakingReward = t, this;
  }
  _validateChecksums(t) {
    this._accountId != null && this._accountId.validateChecksum(t), this._proxyAccountId != null && this._proxyAccountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.crypto.updateAccount(a);
  }
  _getTransactionDataCase() {
    return "cryptoUpdateAccount";
  }
  _makeTransactionData() {
    return {
      accountIDToUpdate: this._accountId != null ? this._accountId._toProtobuf() : null,
      key: this._key != null ? this._key._toProtobufKey() : null,
      expirationTime: this._expirationTime != null ? this._expirationTime._toProtobuf() : null,
      proxyAccountID: this._proxyAccountId != null ? this._proxyAccountId._toProtobuf() : null,
      autoRenewPeriod: this._autoRenewPeriod != null ? this._autoRenewPeriod._toProtobuf() : null,
      receiverSigRequiredWrapper: this._receiverSignatureRequired == null ? null : {
        value: this._receiverSignatureRequired
      },
      memo: this._accountMemo != null ? {
        value: this._accountMemo
      } : null,
      maxAutomaticTokenAssociations: this._maxAutomaticTokenAssociations != null ? { value: this._maxAutomaticTokenAssociations.toInt() } : null,
      stakedAccountId: this.stakedAccountId != null ? this.stakedAccountId._toProtobuf() : null,
      stakedNodeId: this.stakedNodeId,
      declineReward: this.declineStakingRewards != null ? { value: this.declineStakingRewards } : null
    };
  }
  _getLogId() {
    return `AccountUpdateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "cryptoUpdateAccount",
  AccountUpdateTransaction._fromProtobuf
);
class IPv4AddressPart {
  constructor(t = {}) {
    this._left = null, t.left != null && this.setLeft(t.left), this._right = null, t.right != null && this.setRight(t.right);
  }
  get left() {
    return this._left;
  }
  setLeft(t) {
    return this._left = t, this;
  }
  get right() {
    return this._right;
  }
  setRight(t) {
    return this._right = t, this;
  }
  toString() {
    return this._left != null && this._right != null ? `${this._left.toString()}.${this._right.toString()}` : "";
  }
}
class IPv4Address {
  constructor(t = {}) {
    this._network = null, t.network != null && this.setNetwork(t.network), this._host = null, t.host != null && this.setHost(t.host);
  }
  get newtork() {
    return this._network;
  }
  setNetwork(t) {
    return this._network = t, this;
  }
  get host() {
    return this._host;
  }
  setHost(t) {
    return this._host = t, this;
  }
  static _fromProtobuf(t) {
    return new IPv4Address({
      network: new IPv4AddressPart().setLeft(t[0]).setRight(t[1]),
      host: new IPv4AddressPart().setLeft(t[2]).setRight(t[3])
    });
  }
  _toProtobuf() {
    return Uint8Array.of(
      this._network != null && this._network._left != null ? this._network._left : 0,
      this._network != null && this._network.right != null ? this._network.right : 0,
      this._host != null && this._host.left != null ? this._host.left : 0,
      this._host != null && this._host.right != null ? this._host.right : 0
    );
  }
  toString() {
    return this._network != null && this._host != null ? `${this._network.toString()}.${this._host.toString()}` : "";
  }
}
class EndPoint {
  constructor(t = {}) {
    this._address = null, t.address != null && this.setAddress(t.address), this._port = null, t.port != null && this.setPort(t.port);
  }
  get address() {
    return this.address;
  }
  setAddress(t) {
    return this._address = t, this;
  }
  get port() {
    return this._port;
  }
  setPort(t) {
    return this._port = t, this;
  }
  static _fromProtobuf(t) {
    return new EndPoint({
      address: t.ipAddressV4 != null ? IPv4Address._fromProtobuf(t.ipAddressV4) : void 0,
      port: t.port != null ? t.port : void 0
    });
  }
  _toProtobuf() {
    return {
      ipAddressV4: this._address != null ? this._address._toProtobuf() : null,
      port: this._port
    };
  }
  toString() {
    return `${this._address != null ? this._address.toString() : ""}:${this._port != null ? this._port.toString() : ""}`;
  }
  toJSON() {
    return {
      address: this._address != null ? this._address.toString() : null,
      port: this._port != null ? this._port.toString() : null
    };
  }
}
class NodeAddress {
  constructor(t = {}) {
    this._publicKey = null, t.publicKey != null && this.setPublicKey(t.publicKey), this._nodeId = null, t.nodeId != null && this.setNodeId(t.nodeId), this._accountId = null, t.accountId != null && this.setAccountId(t.accountId), this._certHash = null, t.certHash != null && this.setCertHash(t.certHash), this._addresses = [], t.addresses != null && this.setAddresses(t.addresses), this._description = null, t.description != null && this.setDescription(t.description), this._stake = null, t.stake != null && this.setStake(t.stake);
  }
  get publicKey() {
    return this._publicKey;
  }
  setPublicKey(t) {
    return this._publicKey = t, this;
  }
  get nodeId() {
    return this._nodeId;
  }
  setNodeId(t) {
    return this._nodeId = t, this;
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  get certHash() {
    return this._certHash;
  }
  setCertHash(t) {
    return this._certHash = t, this;
  }
  get addresses() {
    return this._addresses;
  }
  setAddresses(t) {
    return this._addresses = t, this;
  }
  get description() {
    return this._description;
  }
  setDescription(t) {
    return this._description = t, this;
  }
  get stake() {
    return this._stake;
  }
  setStake(t) {
    return this._stake = t, this;
  }
  static _fromProtobuf(t) {
    return new NodeAddress({
      publicKey: t.RSA_PubKey != null ? t.RSA_PubKey : void 0,
      nodeId: t.nodeId != null ? t.nodeId : void 0,
      accountId: t.nodeAccountId != null ? AccountId._fromProtobuf(t.nodeAccountId) : void 0,
      certHash: t.nodeCertHash != null ? t.nodeCertHash : void 0,
      addresses: t.serviceEndpoint != null ? t.serviceEndpoint.map(
        (a) => EndPoint._fromProtobuf(a)
      ) : void 0,
      description: t.description != null ? t.description : void 0,
      stake: t.stake != null ? t.stake : void 0
    });
  }
  _toProtobuf() {
    return {
      RSA_PubKey: this._publicKey,
      nodeId: this._nodeId,
      nodeAccountId: this._accountId != null ? this._accountId._toProtobuf() : null,
      nodeCertHash: this._certHash,
      serviceEndpoint: this._addresses.map(
        (t) => t._toProtobuf()
      ),
      description: this._description,
      stake: this._stake
    };
  }
  toString() {
    return JSON.stringify(this.toJSON());
  }
  toJSON() {
    return {
      publicKey: this._publicKey,
      nodeId: this._nodeId != null ? this._nodeId.toString() : null,
      accountId: this._accountId != null ? this._accountId.toString() : null,
      certHash: this._certHash != null ? decode$1(this._certHash) : null,
      addresses: this._addresses.map((t) => t.toJSON()),
      description: this._description,
      stake: this._stake != null ? this._stake.toString() : null
    };
  }
}
class NodeAddressBook {
  constructor(t = {}) {
    this._nodeAddresses = [], t.nodeAddresses != null && this.setNodeAddresses(t.nodeAddresses);
  }
  get nodeAddresses() {
    return this._nodeAddresses;
  }
  setNodeAddresses(t) {
    return this._nodeAddresses = t, this;
  }
  static fromBytes(t) {
    return NodeAddressBook._fromProtobuf(
      lib.proto.NodeAddressBook.decode(t)
    );
  }
  static _fromProtobuf(t) {
    return new NodeAddressBook({
      nodeAddresses: t.nodeAddress != null ? t.nodeAddress.map(
        (a) => NodeAddress._fromProtobuf(a)
      ) : void 0
    });
  }
  _toProtobuf() {
    return {
      nodeAddress: this._nodeAddresses.map(
        (t) => t._toProtobuf()
      )
    };
  }
  toString() {
    return JSON.stringify(this.toJSON());
  }
  toJSON() {
    return {
      nodeAddresses: this._nodeAddresses.map(
        (t) => t.toJSON()
      )
    };
  }
  toBytes() {
    return lib.proto.NodeAddressBook.encode(
      this._toProtobuf()
    ).finish();
  }
}
class AddressBookQuery extends Query {
  constructor(t = {}) {
    super(), this._fileId = null, t.fileId != null && this.setFileId(t.fileId), this._limit = null, t.limit != null && this.setLimit(t.limit), this._retryHandler = (a) => {
      if (a != null) {
        if (a instanceof Error)
          return !0;
        switch (a.code) {
          case 13:
            return RST_STREAM.test(a.details.toString());
          case 5:
          case 8:
          case 14:
          case 17:
            return !0;
          default:
            return !1;
        }
      }
      return !1;
    }, this._addresses = [], this._attempt = 0;
  }
  get fileId() {
    return this._fileId;
  }
  setFileId(t) {
    return this._fileId = typeof t == "string" ? FileId.fromString(t) : t.clone(), this;
  }
  get limit() {
    return this._limit;
  }
  setLimit(t) {
    return this._limit = t, this;
  }
  setMaxAttempts(t) {
    return this._maxAttempts = t, this;
  }
  setMaxBackoff(t) {
    return this._maxBackoff = t, this;
  }
  execute(t, a) {
    return new Promise((d, l) => {
      this._makeServerStreamRequest(
        t,
        d,
        l,
        a
      );
    });
  }
  _makeServerStreamRequest(t, a, d, l) {
    const h = lib.com.hedera.mirror.api.proto.AddressBookQuery.encode({
      fileId: this._fileId != null ? this._fileId._toProtobuf() : null,
      limit: this._limit
    }).finish();
    t._mirrorNetwork.getNextMirrorNode().getChannel().makeServerStreamRequest(
      "NetworkService",
      "getNodes",
      h,
      (g) => {
        this._addresses.push(
          NodeAddress._fromProtobuf(
            lib.proto.NodeAddress.decode(g)
          )
        ), this._limit != null && this._limit > 0 && (this._limit = this._limit - 1);
      },
      (g) => {
        const c = g instanceof Error ? g.message : g.details;
        if (this._attempt < this._maxAttempts && !t.isClientShutDown && this._retryHandler(g)) {
          const x = Math.min(
            250 * 2 ** this._attempt,
            this._maxBackoff
          );
          this._attempt >= this._maxAttempts && console.warn(
            `Error getting nodes from mirror for file ${this._fileId != null ? this._fileId.toString() : "UNKNOWN"} during attempt ${this._attempt}. Waiting ${x} ms before next attempt: ${c}`
          ), this._logger && this._logger.debug(
            `Error getting nodes from mirror for file ${this._fileId != null ? this._fileId.toString() : "UNKNOWN"} during attempt ${this._attempt}. Waiting ${x} ms before next attempt: ${c}`
          ), this._attempt += 1, setTimeout(() => {
            this._makeServerStreamRequest(
              t,
              a,
              d,
              l
            );
          }, x);
        } else
          d(new Error("failed to query address book"));
      },
      () => {
        a(
          new NodeAddressBook({ nodeAddresses: this._addresses })
        );
      }
    );
  }
}
CACHE$1.setAddressBookQueryConstructor(() => new AddressBookQuery());
class ContractByteCodeQuery extends Query {
  constructor(t = {}) {
    super(), this._contractId = null, t.contractId != null && this.setContractId(t.contractId);
  }
  static _fromProtobuf(t) {
    const a = t.contractGetBytecode;
    return new ContractByteCodeQuery({
      contractId: a.contractID != null ? ContractId._fromProtobuf(a.contractID) : void 0
    });
  }
  get contractId() {
    return this._contractId;
  }
  setContractId(t) {
    return this._contractId = typeof t == "string" ? ContractId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._contractId != null && this._contractId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.smartContract.contractGetBytecode(a);
  }
  _mapResponseHeader(t) {
    return t.contractGetBytecodeResponse.header;
  }
  _mapResponse(t) {
    const a = t.contractGetBytecodeResponse;
    return Promise.resolve(
      a.bytecode != null ? a.bytecode : new Uint8Array()
    );
  }
  _onMakeRequest(t) {
    return {
      contractGetBytecode: {
        header: t,
        contractID: this._contractId != null ? this._contractId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `ContractByteCodeQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set("contractGetBytecode", ContractByteCodeQuery._fromProtobuf);
const HEX_CHARS = "0123456789abcdef".split(""), KECCAK_PADDING = [1, 256, 65536, 16777216], SHIFT = [0, 8, 16, 24], RC = [
  1,
  0,
  32898,
  0,
  32906,
  2147483648,
  2147516416,
  2147483648,
  32907,
  0,
  2147483649,
  0,
  2147516545,
  2147483648,
  32777,
  2147483648,
  138,
  0,
  136,
  0,
  2147516425,
  0,
  2147483658,
  0,
  2147516555,
  0,
  139,
  2147483648,
  32905,
  2147483648,
  32771,
  2147483648,
  32770,
  2147483648,
  128,
  2147483648,
  32778,
  0,
  2147483658,
  2147483648,
  2147516545,
  2147483648,
  32896,
  2147483648,
  2147483649,
  0,
  2147516424,
  2147483648
], Keccak = (u) => ({
  blocks: [],
  reset: !0,
  block: 0,
  start: 0,
  blockCount: 1600 - (u << 1) >> 5,
  outputBlocks: u >> 5,
  s: ((t) => [].concat(t, t, t, t, t))([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
}), update = (u, t) => {
  for (var a = t.length, d = u.blocks, l = u.blockCount << 2, h = u.blockCount, g = u.outputBlocks, c = u.s, x = 0, R, B; x < a; ) {
    if (u.reset)
      for (u.reset = !1, d[0] = u.block, R = 1; R < h + 1; ++R)
        d[R] = 0;
    if (typeof t != "string")
      for (R = u.start; x < a && R < l; ++x)
        d[R >> 2] |= t[x] << SHIFT[R++ & 3];
    else
      for (R = u.start; x < a && R < l; ++x)
        B = t.charCodeAt(x), B < 128 ? d[R >> 2] |= B << SHIFT[R++ & 3] : B < 2048 ? (d[R >> 2] |= (192 | B >> 6) << SHIFT[R++ & 3], d[R >> 2] |= (128 | B & 63) << SHIFT[R++ & 3]) : B < 55296 || B >= 57344 ? (d[R >> 2] |= (224 | B >> 12) << SHIFT[R++ & 3], d[R >> 2] |= (128 | B >> 6 & 63) << SHIFT[R++ & 3], d[R >> 2] |= (128 | B & 63) << SHIFT[R++ & 3]) : (B = 65536 + ((B & 1023) << 10 | t.charCodeAt(++x) & 1023), d[R >> 2] |= (240 | B >> 18) << SHIFT[R++ & 3], d[R >> 2] |= (128 | B >> 12 & 63) << SHIFT[R++ & 3], d[R >> 2] |= (128 | B >> 6 & 63) << SHIFT[R++ & 3], d[R >> 2] |= (128 | B & 63) << SHIFT[R++ & 3]);
    if (u.lastByteIndex = R, R >= l) {
      for (u.start = R - l, u.block = d[h], R = 0; R < h; ++R)
        c[R] ^= d[R];
      f(c), u.reset = !0;
    } else
      u.start = R;
  }
  if (R = u.lastByteIndex, d[R >> 2] |= KECCAK_PADDING[R & 3], u.lastByteIndex === l)
    for (d[0] = d[h], R = 1; R < h + 1; ++R)
      d[R] = 0;
  for (d[h - 1] |= 2147483648, R = 0; R < h; ++R)
    c[R] ^= d[R];
  f(c);
  var j = "", o, e = 0;
  for (R = 0; e < g; ) {
    for (R = 0; R < h && e < g; ++R, ++e)
      o = c[R], j += HEX_CHARS[o >> 4 & 15] + HEX_CHARS[o & 15] + HEX_CHARS[o >> 12 & 15] + HEX_CHARS[o >> 8 & 15] + HEX_CHARS[o >> 20 & 15] + HEX_CHARS[o >> 16 & 15] + HEX_CHARS[o >> 28 & 15] + HEX_CHARS[o >> 24 & 15];
    e % h === 0 && (f(c), R = 0);
  }
  return "0x" + j;
}, f = (u) => {
  var t, a, d, l, h, g, c, x, R, B, j, o, e, n, i, y, m, U, be, Ke, ze, Pe, st, G, z, W, F, k, T, p, b, _, v, S, E, w, A, I, C, X, D, V, Z, J, ee, he, le, ie, Ne, ue, se, ut, qe, ve, ot, He, Ae, ct, Ve, _e, lt, je, me;
  for (d = 0; d < 48; d += 2)
    l = u[0] ^ u[10] ^ u[20] ^ u[30] ^ u[40], h = u[1] ^ u[11] ^ u[21] ^ u[31] ^ u[41], g = u[2] ^ u[12] ^ u[22] ^ u[32] ^ u[42], c = u[3] ^ u[13] ^ u[23] ^ u[33] ^ u[43], x = u[4] ^ u[14] ^ u[24] ^ u[34] ^ u[44], R = u[5] ^ u[15] ^ u[25] ^ u[35] ^ u[45], B = u[6] ^ u[16] ^ u[26] ^ u[36] ^ u[46], j = u[7] ^ u[17] ^ u[27] ^ u[37] ^ u[47], o = u[8] ^ u[18] ^ u[28] ^ u[38] ^ u[48], e = u[9] ^ u[19] ^ u[29] ^ u[39] ^ u[49], t = o ^ (g << 1 | c >>> 31), a = e ^ (c << 1 | g >>> 31), u[0] ^= t, u[1] ^= a, u[10] ^= t, u[11] ^= a, u[20] ^= t, u[21] ^= a, u[30] ^= t, u[31] ^= a, u[40] ^= t, u[41] ^= a, t = l ^ (x << 1 | R >>> 31), a = h ^ (R << 1 | x >>> 31), u[2] ^= t, u[3] ^= a, u[12] ^= t, u[13] ^= a, u[22] ^= t, u[23] ^= a, u[32] ^= t, u[33] ^= a, u[42] ^= t, u[43] ^= a, t = g ^ (B << 1 | j >>> 31), a = c ^ (j << 1 | B >>> 31), u[4] ^= t, u[5] ^= a, u[14] ^= t, u[15] ^= a, u[24] ^= t, u[25] ^= a, u[34] ^= t, u[35] ^= a, u[44] ^= t, u[45] ^= a, t = x ^ (o << 1 | e >>> 31), a = R ^ (e << 1 | o >>> 31), u[6] ^= t, u[7] ^= a, u[16] ^= t, u[17] ^= a, u[26] ^= t, u[27] ^= a, u[36] ^= t, u[37] ^= a, u[46] ^= t, u[47] ^= a, t = B ^ (l << 1 | h >>> 31), a = j ^ (h << 1 | l >>> 31), u[8] ^= t, u[9] ^= a, u[18] ^= t, u[19] ^= a, u[28] ^= t, u[29] ^= a, u[38] ^= t, u[39] ^= a, u[48] ^= t, u[49] ^= a, n = u[0], i = u[1], he = u[11] << 4 | u[10] >>> 28, le = u[10] << 4 | u[11] >>> 28, k = u[20] << 3 | u[21] >>> 29, T = u[21] << 3 | u[20] >>> 29, _e = u[31] << 9 | u[30] >>> 23, lt = u[30] << 9 | u[31] >>> 23, V = u[40] << 18 | u[41] >>> 14, Z = u[41] << 18 | u[40] >>> 14, S = u[2] << 1 | u[3] >>> 31, E = u[3] << 1 | u[2] >>> 31, y = u[13] << 12 | u[12] >>> 20, m = u[12] << 12 | u[13] >>> 20, ie = u[22] << 10 | u[23] >>> 22, Ne = u[23] << 10 | u[22] >>> 22, p = u[33] << 13 | u[32] >>> 19, b = u[32] << 13 | u[33] >>> 19, je = u[42] << 2 | u[43] >>> 30, me = u[43] << 2 | u[42] >>> 30, ve = u[5] << 30 | u[4] >>> 2, ot = u[4] << 30 | u[5] >>> 2, w = u[14] << 6 | u[15] >>> 26, A = u[15] << 6 | u[14] >>> 26, U = u[25] << 11 | u[24] >>> 21, be = u[24] << 11 | u[25] >>> 21, ue = u[34] << 15 | u[35] >>> 17, se = u[35] << 15 | u[34] >>> 17, _ = u[45] << 29 | u[44] >>> 3, v = u[44] << 29 | u[45] >>> 3, G = u[6] << 28 | u[7] >>> 4, z = u[7] << 28 | u[6] >>> 4, He = u[17] << 23 | u[16] >>> 9, Ae = u[16] << 23 | u[17] >>> 9, I = u[26] << 25 | u[27] >>> 7, C = u[27] << 25 | u[26] >>> 7, Ke = u[36] << 21 | u[37] >>> 11, ze = u[37] << 21 | u[36] >>> 11, ut = u[47] << 24 | u[46] >>> 8, qe = u[46] << 24 | u[47] >>> 8, J = u[8] << 27 | u[9] >>> 5, ee = u[9] << 27 | u[8] >>> 5, W = u[18] << 20 | u[19] >>> 12, F = u[19] << 20 | u[18] >>> 12, ct = u[29] << 7 | u[28] >>> 25, Ve = u[28] << 7 | u[29] >>> 25, X = u[38] << 8 | u[39] >>> 24, D = u[39] << 8 | u[38] >>> 24, Pe = u[48] << 14 | u[49] >>> 18, st = u[49] << 14 | u[48] >>> 18, u[0] = n ^ ~y & U, u[1] = i ^ ~m & be, u[10] = G ^ ~W & k, u[11] = z ^ ~F & T, u[20] = S ^ ~w & I, u[21] = E ^ ~A & C, u[30] = J ^ ~he & ie, u[31] = ee ^ ~le & Ne, u[40] = ve ^ ~He & ct, u[41] = ot ^ ~Ae & Ve, u[2] = y ^ ~U & Ke, u[3] = m ^ ~be & ze, u[12] = W ^ ~k & p, u[13] = F ^ ~T & b, u[22] = w ^ ~I & X, u[23] = A ^ ~C & D, u[32] = he ^ ~ie & ue, u[33] = le ^ ~Ne & se, u[42] = He ^ ~ct & _e, u[43] = Ae ^ ~Ve & lt, u[4] = U ^ ~Ke & Pe, u[5] = be ^ ~ze & st, u[14] = k ^ ~p & _, u[15] = T ^ ~b & v, u[24] = I ^ ~X & V, u[25] = C ^ ~D & Z, u[34] = ie ^ ~ue & ut, u[35] = Ne ^ ~se & qe, u[44] = ct ^ ~_e & je, u[45] = Ve ^ ~lt & me, u[6] = Ke ^ ~Pe & n, u[7] = ze ^ ~st & i, u[16] = p ^ ~_ & G, u[17] = b ^ ~v & z, u[26] = X ^ ~V & S, u[27] = D ^ ~Z & E, u[36] = ue ^ ~ut & J, u[37] = se ^ ~qe & ee, u[46] = _e ^ ~je & ve, u[47] = lt ^ ~me & ot, u[8] = Pe ^ ~n & y, u[9] = st ^ ~i & m, u[18] = _ ^ ~G & W, u[19] = v ^ ~z & F, u[28] = V ^ ~S & w, u[29] = Z ^ ~E & A, u[38] = ut ^ ~J & he, u[39] = qe ^ ~ee & le, u[48] = je ^ ~ve & He, u[49] = me ^ ~ot & Ae, u[0] ^= RC[d], u[1] ^= RC[d + 1];
}, keccak = (u) => (t) => {
  var a;
  if (t.slice(0, 2) === "0x") {
    a = [];
    for (var d = 2, l = t.length; d < l; d += 2)
      a.push(parseInt(t.slice(d, d + 2), 16));
  } else
    a = t;
  return update(Keccak(u), a);
}, keccak256 = keccak(256), ArgumentType = {
  uint8: 0,
  int8: 1,
  uint16: 2,
  int16: 3,
  uint24: 4,
  int24: 5,
  uint32: 6,
  int32: 7,
  uint40: 8,
  int40: 9,
  uint48: 10,
  int48: 11,
  uint56: 12,
  int56: 13,
  uint64: 14,
  int64: 15,
  uint72: 16,
  int72: 17,
  uint80: 18,
  int80: 19,
  uint88: 20,
  int88: 21,
  uint96: 22,
  int96: 23,
  uint104: 24,
  int104: 25,
  uint112: 26,
  int112: 27,
  uint120: 28,
  int120: 29,
  uint128: 30,
  int128: 31,
  uint136: 32,
  int136: 33,
  uint144: 34,
  int144: 35,
  uint152: 36,
  int152: 37,
  uint160: 38,
  int160: 39,
  uint168: 40,
  int168: 41,
  uint176: 42,
  int176: 43,
  uint184: 44,
  int184: 45,
  uint192: 46,
  int192: 47,
  uint200: 48,
  int200: 49,
  uint208: 50,
  int208: 51,
  uint216: 52,
  int216: 53,
  uint224: 54,
  int224: 55,
  uint232: 56,
  int232: 57,
  uint240: 58,
  int240: 59,
  uint248: 60,
  int248: 61,
  uint256: 62,
  int256: 63,
  string: 64,
  bool: 65,
  bytes: 66,
  bytes32: 67,
  address: 68,
  func: 69
};
class ContractFunctionSelector {
  constructor(t) {
    this.name = null, this._params = "", this._paramTypes = [], t != null && (this._name = t);
  }
  addString() {
    return this._addParam({ ty: ArgumentType.string, array: !1 });
  }
  addStringArray() {
    return this._addParam({ ty: ArgumentType.string, array: !0 });
  }
  addBytes() {
    return this._addParam({ ty: ArgumentType.bytes, array: !1 });
  }
  addBytes32() {
    return this._addParam({ ty: ArgumentType.bytes32, array: !1 });
  }
  addBytesArray() {
    return this._addParam({ ty: ArgumentType.bytes, array: !0 });
  }
  addBytes32Array() {
    return this._addParam({ ty: ArgumentType.bytes32, array: !0 });
  }
  addInt8() {
    return this._addParam({ ty: ArgumentType.int8, array: !1 });
  }
  addUint8() {
    return this._addParam({ ty: ArgumentType.uint8, array: !1 });
  }
  addInt16() {
    return this._addParam({ ty: ArgumentType.int16, array: !1 });
  }
  addUint16() {
    return this._addParam({ ty: ArgumentType.uint16, array: !1 });
  }
  addInt24() {
    return this._addParam({ ty: ArgumentType.int24, array: !1 });
  }
  addUint24() {
    return this._addParam({ ty: ArgumentType.uint24, array: !1 });
  }
  addInt32() {
    return this._addParam({ ty: ArgumentType.int32, array: !1 });
  }
  addUint32() {
    return this._addParam({ ty: ArgumentType.uint32, array: !1 });
  }
  addInt40() {
    return this._addParam({ ty: ArgumentType.int40, array: !1 });
  }
  addUint40() {
    return this._addParam({ ty: ArgumentType.uint40, array: !1 });
  }
  addInt48() {
    return this._addParam({ ty: ArgumentType.int48, array: !1 });
  }
  addUint48() {
    return this._addParam({ ty: ArgumentType.uint48, array: !1 });
  }
  addInt56() {
    return this._addParam({ ty: ArgumentType.int56, array: !1 });
  }
  addUint56() {
    return this._addParam({ ty: ArgumentType.uint56, array: !1 });
  }
  addInt64() {
    return this._addParam({ ty: ArgumentType.int64, array: !1 });
  }
  addUint64() {
    return this._addParam({ ty: ArgumentType.uint64, array: !1 });
  }
  addInt72() {
    return this._addParam({ ty: ArgumentType.int72, array: !1 });
  }
  addUint72() {
    return this._addParam({ ty: ArgumentType.uint72, array: !1 });
  }
  addInt80() {
    return this._addParam({ ty: ArgumentType.int80, array: !1 });
  }
  addUint80() {
    return this._addParam({ ty: ArgumentType.uint80, array: !1 });
  }
  addInt88() {
    return this._addParam({ ty: ArgumentType.int88, array: !1 });
  }
  addUint88() {
    return this._addParam({ ty: ArgumentType.uint88, array: !1 });
  }
  addInt96() {
    return this._addParam({ ty: ArgumentType.int96, array: !1 });
  }
  addUint96() {
    return this._addParam({ ty: ArgumentType.uint96, array: !1 });
  }
  addInt104() {
    return this._addParam({ ty: ArgumentType.int104, array: !1 });
  }
  addUint104() {
    return this._addParam({ ty: ArgumentType.uint104, array: !1 });
  }
  addInt112() {
    return this._addParam({ ty: ArgumentType.int112, array: !1 });
  }
  addUint112() {
    return this._addParam({ ty: ArgumentType.uint112, array: !1 });
  }
  addInt120() {
    return this._addParam({ ty: ArgumentType.int120, array: !1 });
  }
  addUint120() {
    return this._addParam({ ty: ArgumentType.uint120, array: !1 });
  }
  addInt128() {
    return this._addParam({ ty: ArgumentType.int128, array: !1 });
  }
  addUint128() {
    return this._addParam({ ty: ArgumentType.uint128, array: !1 });
  }
  addInt136() {
    return this._addParam({ ty: ArgumentType.int136, array: !1 });
  }
  addUint136() {
    return this._addParam({ ty: ArgumentType.uint136, array: !1 });
  }
  addInt144() {
    return this._addParam({ ty: ArgumentType.int144, array: !1 });
  }
  addUint144() {
    return this._addParam({ ty: ArgumentType.uint144, array: !1 });
  }
  addInt152() {
    return this._addParam({ ty: ArgumentType.int152, array: !1 });
  }
  addUint152() {
    return this._addParam({ ty: ArgumentType.uint152, array: !1 });
  }
  addInt160() {
    return this._addParam({ ty: ArgumentType.int160, array: !1 });
  }
  addUint160() {
    return this._addParam({ ty: ArgumentType.uint160, array: !1 });
  }
  addInt168() {
    return this._addParam({ ty: ArgumentType.int168, array: !1 });
  }
  addUint168() {
    return this._addParam({ ty: ArgumentType.uint168, array: !1 });
  }
  addInt176() {
    return this._addParam({ ty: ArgumentType.int176, array: !1 });
  }
  addUint176() {
    return this._addParam({ ty: ArgumentType.uint176, array: !1 });
  }
  addInt184() {
    return this._addParam({ ty: ArgumentType.int184, array: !1 });
  }
  addUint184() {
    return this._addParam({ ty: ArgumentType.uint184, array: !1 });
  }
  addInt192() {
    return this._addParam({ ty: ArgumentType.int192, array: !1 });
  }
  addUint192() {
    return this._addParam({ ty: ArgumentType.uint192, array: !1 });
  }
  addInt200() {
    return this._addParam({ ty: ArgumentType.int200, array: !1 });
  }
  addUint200() {
    return this._addParam({ ty: ArgumentType.uint200, array: !1 });
  }
  addInt208() {
    return this._addParam({ ty: ArgumentType.int208, array: !1 });
  }
  addUint208() {
    return this._addParam({ ty: ArgumentType.uint208, array: !1 });
  }
  addInt216() {
    return this._addParam({ ty: ArgumentType.int216, array: !1 });
  }
  addUint216() {
    return this._addParam({ ty: ArgumentType.uint216, array: !1 });
  }
  addInt224() {
    return this._addParam({ ty: ArgumentType.int224, array: !1 });
  }
  addUint224() {
    return this._addParam({ ty: ArgumentType.uint224, array: !1 });
  }
  addInt232() {
    return this._addParam({ ty: ArgumentType.int232, array: !1 });
  }
  addUint232() {
    return this._addParam({ ty: ArgumentType.uint232, array: !1 });
  }
  addInt240() {
    return this._addParam({ ty: ArgumentType.int240, array: !1 });
  }
  addUint240() {
    return this._addParam({ ty: ArgumentType.uint240, array: !1 });
  }
  addInt248() {
    return this._addParam({ ty: ArgumentType.int248, array: !1 });
  }
  addUint248() {
    return this._addParam({ ty: ArgumentType.uint248, array: !1 });
  }
  addInt256() {
    return this._addParam({ ty: ArgumentType.int256, array: !1 });
  }
  addUint256() {
    return this._addParam({ ty: ArgumentType.uint256, array: !1 });
  }
  addInt8Array() {
    return this._addParam({ ty: ArgumentType.int8, array: !0 });
  }
  addUint8Array() {
    return this._addParam({ ty: ArgumentType.uint8, array: !0 });
  }
  addInt16Array() {
    return this._addParam({ ty: ArgumentType.int16, array: !0 });
  }
  addUint16Array() {
    return this._addParam({ ty: ArgumentType.uint16, array: !0 });
  }
  addInt24Array() {
    return this._addParam({ ty: ArgumentType.int24, array: !0 });
  }
  addUint24Array() {
    return this._addParam({ ty: ArgumentType.uint24, array: !0 });
  }
  addInt32Array() {
    return this._addParam({ ty: ArgumentType.int32, array: !0 });
  }
  addUint32Array() {
    return this._addParam({ ty: ArgumentType.uint32, array: !0 });
  }
  addInt40Array() {
    return this._addParam({ ty: ArgumentType.int40, array: !0 });
  }
  addUint40Array() {
    return this._addParam({ ty: ArgumentType.uint40, array: !0 });
  }
  addInt48Array() {
    return this._addParam({ ty: ArgumentType.int48, array: !0 });
  }
  addUint48Array() {
    return this._addParam({ ty: ArgumentType.uint48, array: !0 });
  }
  addInt56Array() {
    return this._addParam({ ty: ArgumentType.int56, array: !0 });
  }
  addUint56Array() {
    return this._addParam({ ty: ArgumentType.uint56, array: !0 });
  }
  addInt64Array() {
    return this._addParam({ ty: ArgumentType.int64, array: !0 });
  }
  addUint64Array() {
    return this._addParam({ ty: ArgumentType.uint64, array: !0 });
  }
  addInt72Array() {
    return this._addParam({ ty: ArgumentType.int72, array: !0 });
  }
  addUint72Array() {
    return this._addParam({ ty: ArgumentType.uint72, array: !0 });
  }
  addInt80Array() {
    return this._addParam({ ty: ArgumentType.int80, array: !0 });
  }
  addUint80Array() {
    return this._addParam({ ty: ArgumentType.uint80, array: !0 });
  }
  addInt88Array() {
    return this._addParam({ ty: ArgumentType.int88, array: !0 });
  }
  addUint88Array() {
    return this._addParam({ ty: ArgumentType.uint88, array: !0 });
  }
  addInt96Array() {
    return this._addParam({ ty: ArgumentType.int96, array: !0 });
  }
  addUint96Array() {
    return this._addParam({ ty: ArgumentType.uint96, array: !0 });
  }
  addInt104Array() {
    return this._addParam({ ty: ArgumentType.int104, array: !0 });
  }
  addUint104Array() {
    return this._addParam({ ty: ArgumentType.uint104, array: !0 });
  }
  addInt112Array() {
    return this._addParam({ ty: ArgumentType.int112, array: !0 });
  }
  addUint112Array() {
    return this._addParam({ ty: ArgumentType.uint112, array: !0 });
  }
  addInt120Array() {
    return this._addParam({ ty: ArgumentType.int120, array: !0 });
  }
  addUint120Array() {
    return this._addParam({ ty: ArgumentType.uint120, array: !0 });
  }
  addInt128Array() {
    return this._addParam({ ty: ArgumentType.int128, array: !0 });
  }
  addUint128Array() {
    return this._addParam({ ty: ArgumentType.uint128, array: !0 });
  }
  addInt136Array() {
    return this._addParam({ ty: ArgumentType.int136, array: !0 });
  }
  addUint136Array() {
    return this._addParam({ ty: ArgumentType.uint136, array: !0 });
  }
  addInt144Array() {
    return this._addParam({ ty: ArgumentType.int144, array: !0 });
  }
  addUint144Array() {
    return this._addParam({ ty: ArgumentType.uint144, array: !0 });
  }
  addInt152Array() {
    return this._addParam({ ty: ArgumentType.int152, array: !0 });
  }
  addUint152Array() {
    return this._addParam({ ty: ArgumentType.uint152, array: !0 });
  }
  addInt160Array() {
    return this._addParam({ ty: ArgumentType.int160, array: !0 });
  }
  addUint160Array() {
    return this._addParam({ ty: ArgumentType.uint160, array: !0 });
  }
  addInt168Array() {
    return this._addParam({ ty: ArgumentType.int168, array: !0 });
  }
  addUint168Array() {
    return this._addParam({ ty: ArgumentType.uint168, array: !0 });
  }
  addInt176Array() {
    return this._addParam({ ty: ArgumentType.int176, array: !0 });
  }
  addUint176Array() {
    return this._addParam({ ty: ArgumentType.uint176, array: !0 });
  }
  addInt184Array() {
    return this._addParam({ ty: ArgumentType.int184, array: !0 });
  }
  addUint184Array() {
    return this._addParam({ ty: ArgumentType.uint184, array: !0 });
  }
  addInt192Array() {
    return this._addParam({ ty: ArgumentType.int192, array: !0 });
  }
  addUint192Array() {
    return this._addParam({ ty: ArgumentType.uint192, array: !0 });
  }
  addInt200Array() {
    return this._addParam({ ty: ArgumentType.int200, array: !0 });
  }
  addUint200Array() {
    return this._addParam({ ty: ArgumentType.uint200, array: !0 });
  }
  addInt208Array() {
    return this._addParam({ ty: ArgumentType.int208, array: !0 });
  }
  addUint208Array() {
    return this._addParam({ ty: ArgumentType.uint208, array: !0 });
  }
  addInt216Array() {
    return this._addParam({ ty: ArgumentType.int216, array: !0 });
  }
  addUint216Array() {
    return this._addParam({ ty: ArgumentType.uint216, array: !0 });
  }
  addInt224Array() {
    return this._addParam({ ty: ArgumentType.int224, array: !0 });
  }
  addUint224Array() {
    return this._addParam({ ty: ArgumentType.uint224, array: !0 });
  }
  addInt232Array() {
    return this._addParam({ ty: ArgumentType.int232, array: !0 });
  }
  addUint232Array() {
    return this._addParam({ ty: ArgumentType.uint232, array: !0 });
  }
  addInt240Array() {
    return this._addParam({ ty: ArgumentType.int240, array: !0 });
  }
  addUint240Array() {
    return this._addParam({ ty: ArgumentType.uint240, array: !0 });
  }
  addInt248Array() {
    return this._addParam({ ty: ArgumentType.int248, array: !0 });
  }
  addUint248Array() {
    return this._addParam({ ty: ArgumentType.uint248, array: !0 });
  }
  addInt256Array() {
    return this._addParam({ ty: ArgumentType.int256, array: !0 });
  }
  addUint256Array() {
    return this._addParam({ ty: ArgumentType.uint256, array: !0 });
  }
  addBool() {
    return this._addParam({ ty: ArgumentType.bool, array: !1 });
  }
  addAddress() {
    return this._addParam({ ty: ArgumentType.address, array: !1 });
  }
  addAddressArray() {
    return this._addParam({ ty: ArgumentType.address, array: !0 });
  }
  addFunction() {
    return this._addParam({ ty: ArgumentType.func, array: !1 });
  }
  _addParam(t) {
    return this._paramTypes.length > 0 && (this._params += ","), this._params += solidityTypeToString(t), this._paramTypes.push(t), this;
  }
  _build(t) {
    if (t != null)
      this._name = t;
    else if (this._name == null)
      throw new Error("`name` required for ContractFunctionSelector");
    const a = encode$4(encode$1(this.toString()));
    return decode$6(keccak256(`0x${a}`)).slice(0, 4);
  }
  toString() {
    return `${this._name != null ? this._name.toString() : ""}(${this._params})`;
  }
}
function solidityTypeToString(u) {
  let t = "";
  switch (u.ty) {
    case ArgumentType.uint8:
      t = "uint8";
      break;
    case ArgumentType.int8:
      t = "int8";
      break;
    case ArgumentType.uint16:
      t = "uint16";
      break;
    case ArgumentType.int16:
      t = "int16";
      break;
    case ArgumentType.uint24:
      t = "uint24";
      break;
    case ArgumentType.int24:
      t = "int24";
      break;
    case ArgumentType.uint32:
      t = "uint32";
      break;
    case ArgumentType.int32:
      t = "int32";
      break;
    case ArgumentType.uint40:
      t = "uint40";
      break;
    case ArgumentType.int40:
      t = "int40";
      break;
    case ArgumentType.uint48:
      t = "uint48";
      break;
    case ArgumentType.int48:
      t = "int48";
      break;
    case ArgumentType.uint56:
      t = "uint56";
      break;
    case ArgumentType.int56:
      t = "int56";
      break;
    case ArgumentType.uint64:
      t = "uint64";
      break;
    case ArgumentType.int64:
      t = "int64";
      break;
    case ArgumentType.uint72:
      t = "uint72";
      break;
    case ArgumentType.int72:
      t = "int72";
      break;
    case ArgumentType.uint80:
      t = "uint80";
      break;
    case ArgumentType.int80:
      t = "int80";
      break;
    case ArgumentType.uint88:
      t = "uint88";
      break;
    case ArgumentType.int88:
      t = "int88";
      break;
    case ArgumentType.uint96:
      t = "uint96";
      break;
    case ArgumentType.int96:
      t = "int96";
      break;
    case ArgumentType.uint104:
      t = "uint104";
      break;
    case ArgumentType.int104:
      t = "int104";
      break;
    case ArgumentType.uint112:
      t = "uint112";
      break;
    case ArgumentType.int112:
      t = "int112";
      break;
    case ArgumentType.uint120:
      t = "uint120";
      break;
    case ArgumentType.int120:
      t = "int120";
      break;
    case ArgumentType.uint128:
      t = "uint128";
      break;
    case ArgumentType.int128:
      t = "int128";
      break;
    case ArgumentType.uint136:
      t = "uint136";
      break;
    case ArgumentType.int136:
      t = "int136";
      break;
    case ArgumentType.uint144:
      t = "uint144";
      break;
    case ArgumentType.int144:
      t = "int144";
      break;
    case ArgumentType.uint152:
      t = "uint152";
      break;
    case ArgumentType.int152:
      t = "int152";
      break;
    case ArgumentType.uint160:
      t = "uint160";
      break;
    case ArgumentType.int160:
      t = "int160";
      break;
    case ArgumentType.uint168:
      t = "uint168";
      break;
    case ArgumentType.int168:
      t = "int168";
      break;
    case ArgumentType.uint176:
      t = "uint176";
      break;
    case ArgumentType.int176:
      t = "int176";
      break;
    case ArgumentType.uint184:
      t = "uint184";
      break;
    case ArgumentType.int184:
      t = "int184";
      break;
    case ArgumentType.uint192:
      t = "uint192";
      break;
    case ArgumentType.int192:
      t = "int192";
      break;
    case ArgumentType.uint200:
      t = "uint200";
      break;
    case ArgumentType.int200:
      t = "int200";
      break;
    case ArgumentType.uint208:
      t = "uint208";
      break;
    case ArgumentType.int208:
      t = "int208";
      break;
    case ArgumentType.uint216:
      t = "uint216";
      break;
    case ArgumentType.int216:
      t = "int216";
      break;
    case ArgumentType.uint224:
      t = "uint224";
      break;
    case ArgumentType.int224:
      t = "int224";
      break;
    case ArgumentType.uint232:
      t = "uint232";
      break;
    case ArgumentType.int232:
      t = "int232";
      break;
    case ArgumentType.uint240:
      t = "uint240";
      break;
    case ArgumentType.int240:
      t = "int240";
      break;
    case ArgumentType.uint248:
      t = "uint248";
      break;
    case ArgumentType.int248:
      t = "int248";
      break;
    case ArgumentType.uint256:
      t = "uint256";
      break;
    case ArgumentType.int256:
      t = "int256";
      break;
    case ArgumentType.string:
      t = "string";
      break;
    case ArgumentType.bool:
      t = "bool";
      break;
    case ArgumentType.bytes:
      t = "bytes";
      break;
    case ArgumentType.bytes32:
      t = "bytes32";
      break;
    case ArgumentType.address:
      t = "address";
      break;
    case ArgumentType.func:
      t = "function";
      break;
    default:
      t = "";
      break;
  }
  return u.array && (t += "[]"), t;
}
class ContractFunctionParameters {
  constructor() {
    this._selector = new ContractFunctionSelector(), this._arguments = [];
  }
  addString(t) {
    return this._selector.addString(), this._addParam(t, !0);
  }
  addStringArray(t) {
    return this._selector.addStringArray(), this._addParam(t, !0);
  }
  addBytes(t) {
    return this._selector.addBytes(), this._addParam(t, !0);
  }
  addBytes32(t) {
    if (t.length !== 32)
      throw new Error(
        `addBytes32 expected array to be of length 32, but received ${t.length}`
      );
    return this._selector.addBytes32(), this._addParam(t, !1);
  }
  addBytesArray(t) {
    return this._selector.addBytesArray(), this._addParam(t, !0);
  }
  addBytes32Array(t) {
    for (const [a, d] of t.entries())
      if (d.length !== 32)
        throw new Error(
          `addBytes32 expected array to be of length 32, but received ${d.length}`
        );
    return this._selector.addBytes32Array(), this._addParam(t, !0);
  }
  addBool(t) {
    return this._selector.addBool(), this._addParam(t, !1);
  }
  addInt8(t) {
    return this._selector.addInt8(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint8(t) {
    return this._selector.addUint8(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt16(t) {
    return this._selector.addInt16(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint16(t) {
    return this._selector.addUint16(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt24(t) {
    return this._selector.addInt24(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint24(t) {
    return this._selector.addUint24(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt32(t) {
    return this._selector.addInt32(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint32(t) {
    return this._selector.addUint32(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt40(t) {
    return this._selector.addInt40(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint40(t) {
    return this._selector.addUint40(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt48(t) {
    return this._selector.addInt48(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint48(t) {
    return this._selector.addUint48(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt56(t) {
    return this._selector.addInt56(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint56(t) {
    return this._selector.addUint56(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt64(t) {
    return this._selector.addInt64(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint64(t) {
    return this._selector.addUint64(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt72(t) {
    return this._selector.addInt72(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint72(t) {
    return this._selector.addUint72(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt80(t) {
    return this._selector.addInt80(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint80(t) {
    return this._selector.addUint80(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt88(t) {
    return this._selector.addInt88(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint88(t) {
    return this._selector.addUint88(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt96(t) {
    return this._selector.addInt96(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint96(t) {
    return this._selector.addUint96(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt104(t) {
    return this._selector.addInt104(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint104(t) {
    return this._selector.addUint104(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt112(t) {
    return this._selector.addInt112(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint112(t) {
    return this._selector.addUint112(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt120(t) {
    return this._selector.addInt120(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint120(t) {
    return this._selector.addUint120(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt128(t) {
    return this._selector.addInt128(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint128(t) {
    return this._selector.addUint128(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt136(t) {
    return this._selector.addInt136(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint136(t) {
    return this._selector.addUint136(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt144(t) {
    return this._selector.addInt144(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint144(t) {
    return this._selector.addUint144(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt152(t) {
    return this._selector.addInt152(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint152(t) {
    return this._selector.addUint152(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt160(t) {
    return this._selector.addInt160(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint160(t) {
    return this._selector.addUint160(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt168(t) {
    return this._selector.addInt168(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint168(t) {
    return this._selector.addUint168(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt176(t) {
    return this._selector.addInt176(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint176(t) {
    return this._selector.addUint176(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt184(t) {
    return this._selector.addInt184(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint184(t) {
    return this._selector.addUint184(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt192(t) {
    return this._selector.addInt192(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint192(t) {
    return this._selector.addUint192(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt200(t) {
    return this._selector.addInt200(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint200(t) {
    return this._selector.addUint200(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt208(t) {
    return this._selector.addInt208(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint208(t) {
    return this._selector.addUint208(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt216(t) {
    return this._selector.addInt216(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint216(t) {
    return this._selector.addUint216(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt224(t) {
    return this._selector.addInt224(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint224(t) {
    return this._selector.addUint224(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt232(t) {
    return this._selector.addInt232(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint232(t) {
    return this._selector.addUint232(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt240(t) {
    return this._selector.addInt240(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint240(t) {
    return this._selector.addUint240(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt248(t) {
    return this._selector.addInt248(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint248(t) {
    return this._selector.addUint248(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt256(t) {
    return this._selector.addInt256(), this._addParam(convertToBigNumber(t), !1);
  }
  addUint256(t) {
    return this._selector.addUint256(), this._addParam(convertToBigNumber(t), !1);
  }
  addInt8Array(t) {
    return this._selector.addInt8Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint8Array(t) {
    return this._selector.addUint8Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt16Array(t) {
    return this._selector.addInt16Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint16Array(t) {
    return this._selector.addUint16Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt24Array(t) {
    return this._selector.addInt24Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint24Array(t) {
    return this._selector.addUint24Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt32Array(t) {
    return this._selector.addInt32Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint32Array(t) {
    return this._selector.addUint32Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt40Array(t) {
    return this._selector.addInt40Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint40Array(t) {
    return this._selector.addUint40Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt48Array(t) {
    return this._selector.addInt48Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint48Array(t) {
    return this._selector.addUint48Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt56Array(t) {
    return this._selector.addInt56Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint56Array(t) {
    return this._selector.addUint56Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt64Array(t) {
    return this._selector.addInt64Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint64Array(t) {
    return this._selector.addUint64Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt72Array(t) {
    return this._selector.addInt72Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint72Array(t) {
    return this._selector.addUint72Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt80Array(t) {
    return this._selector.addInt80Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint80Array(t) {
    return this._selector.addUint80Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt88Array(t) {
    return this._selector.addInt88Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint88Array(t) {
    return this._selector.addUint88Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt96Array(t) {
    return this._selector.addInt96Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint96Array(t) {
    return this._selector.addUint96Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt104Array(t) {
    return this._selector.addInt104Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint104Array(t) {
    return this._selector.addUint104Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt112Array(t) {
    return this._selector.addInt112Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint112Array(t) {
    return this._selector.addUint112Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt120Array(t) {
    return this._selector.addInt120Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint120Array(t) {
    return this._selector.addUint120Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt128Array(t) {
    return this._selector.addInt128Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint128Array(t) {
    return this._selector.addUint128Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt136Array(t) {
    return this._selector.addInt136Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint136Array(t) {
    return this._selector.addUint136Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt144Array(t) {
    return this._selector.addInt144Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint144Array(t) {
    return this._selector.addUint144Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt152Array(t) {
    return this._selector.addInt152Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint152Array(t) {
    return this._selector.addUint152Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt160Array(t) {
    return this._selector.addInt160Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint160Array(t) {
    return this._selector.addUint160Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt168Array(t) {
    return this._selector.addInt168Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint168Array(t) {
    return this._selector.addUint168Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt176Array(t) {
    return this._selector.addInt176Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint176Array(t) {
    return this._selector.addUint176Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt184Array(t) {
    return this._selector.addInt184Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint184Array(t) {
    return this._selector.addUint184Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt192Array(t) {
    return this._selector.addInt192Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint192Array(t) {
    return this._selector.addUint192Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt200Array(t) {
    return this._selector.addInt200Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint200Array(t) {
    return this._selector.addUint200Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt208Array(t) {
    return this._selector.addInt208Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint208Array(t) {
    return this._selector.addUint208Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt216Array(t) {
    return this._selector.addInt216Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint216Array(t) {
    return this._selector.addUint216Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt224Array(t) {
    return this._selector.addInt224Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint224Array(t) {
    return this._selector.addUint224Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt232Array(t) {
    return this._selector.addInt232Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint232Array(t) {
    return this._selector.addUint232Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt240Array(t) {
    return this._selector.addInt240Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint240Array(t) {
    return this._selector.addUint240Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt248Array(t) {
    return this._selector.addInt248Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint248Array(t) {
    return this._selector.addUint248Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addInt256Array(t) {
    return this._selector.addInt256Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addUint256Array(t) {
    return this._selector.addUint256Array(), this._addParam(convertToBigNumberArray(t), !0);
  }
  addAddress(t) {
    if (t.length !== 40 && t.length !== 42)
      throw new Error(
        "`address` type requires parameter to be 40 or 42 characters"
      );
    const a = t.length === 40 ? decode$6(t) : decode$6(t.substring(2));
    return this._selector.addAddress(), this._addParam(a, !1);
  }
  addAddressArray(t) {
    const a = [];
    for (const [d, l] of t.entries()) {
      if (l.length !== 40 && l.length !== 42)
        throw new Error(
          "`address` type requires parameter to be 40 or 42 characters"
        );
      const h = l.length === 40 ? decode$6(l) : decode$6(l.substring(2));
      a.push(h);
    }
    return this._selector.addAddressArray(), this._addParam(a, !0);
  }
  addFunction(t, a) {
    const d = decode$6(t), l = a._build();
    if (d.length !== 20)
      throw new Error(
        "`function` type requires parameter `address` to be exactly 20 bytes"
      );
    this._selector.addFunction();
    const h = new Uint8Array(24);
    return h.set(d, 0), h.set(l, 20), this._addParam(h, !1);
  }
  _addParam(t, a) {
    const d = this._selector._paramTypes.length - 1, l = argumentToBytes(t, this._selector._paramTypes[d]);
    return this._arguments.push({ dynamic: a, value: l }), this;
  }
  _build(t) {
    const a = t != null, d = a ? 4 : 0, l = this._arguments.length === 0 ? d : this._arguments.length * 32 + this._arguments.map((c) => c.dynamic ? c.value.length : 0).reduce((c, x) => c + x) + d, h = new Uint8Array(l);
    a && h.set(this._selector._build(t), 0);
    let g = 32 * this._arguments.length;
    for (const [c, { dynamic: x, value: R }] of this._arguments.entries())
      if (x) {
        const B = safeView(h, d + c * 32 + 28);
        B.setUint32(0, g), h.set(R, B.getUint32(0) + d), g += R.length;
      } else
        h.set(R, d + c * 32);
    return h;
  }
}
function argumentToBytes(u, t) {
  let a = new Uint8Array(32), d = safeView(a), l;
  if (t.array) {
    if (!Array.isArray(u))
      throw new TypeError(
        "SolidityType indicates type is array, but parameter is not an array"
      );
    const h = [];
    for (const [x, R] of u.entries()) {
      const B = argumentToBytes(R, { ty: t.ty, array: !1 });
      h.push(B);
    }
    const g = h.map((x) => x.length).reduce((x, R) => x + R);
    switch (t.ty) {
      case ArgumentType.uint8:
      case ArgumentType.int8:
      case ArgumentType.uint16:
      case ArgumentType.int16:
      case ArgumentType.uint32:
      case ArgumentType.int32:
      case ArgumentType.uint40:
      case ArgumentType.int40:
      case ArgumentType.uint48:
      case ArgumentType.int48:
      case ArgumentType.uint56:
      case ArgumentType.int56:
      case ArgumentType.uint64:
      case ArgumentType.int64:
      case ArgumentType.uint72:
      case ArgumentType.int72:
      case ArgumentType.uint80:
      case ArgumentType.int80:
      case ArgumentType.uint88:
      case ArgumentType.int88:
      case ArgumentType.uint96:
      case ArgumentType.int96:
      case ArgumentType.uint104:
      case ArgumentType.int104:
      case ArgumentType.uint112:
      case ArgumentType.int112:
      case ArgumentType.uint120:
      case ArgumentType.int120:
      case ArgumentType.uint128:
      case ArgumentType.int128:
      case ArgumentType.uint136:
      case ArgumentType.int136:
      case ArgumentType.uint144:
      case ArgumentType.int144:
      case ArgumentType.uint152:
      case ArgumentType.int152:
      case ArgumentType.uint160:
      case ArgumentType.int160:
      case ArgumentType.uint168:
      case ArgumentType.int168:
      case ArgumentType.uint176:
      case ArgumentType.int176:
      case ArgumentType.uint184:
      case ArgumentType.int184:
      case ArgumentType.uint192:
      case ArgumentType.int192:
      case ArgumentType.uint200:
      case ArgumentType.int200:
      case ArgumentType.uint208:
      case ArgumentType.int208:
      case ArgumentType.uint216:
      case ArgumentType.int216:
      case ArgumentType.uint224:
      case ArgumentType.int224:
      case ArgumentType.uint232:
      case ArgumentType.int232:
      case ArgumentType.uint240:
      case ArgumentType.int240:
      case ArgumentType.uint248:
      case ArgumentType.int248:
      case ArgumentType.uint256:
      case ArgumentType.int256:
      case ArgumentType.bool:
      case ArgumentType.bytes32:
      case ArgumentType.address:
      case ArgumentType.func:
        a = new Uint8Array(g + 32);
        break;
      case ArgumentType.bytes:
      case ArgumentType.string:
        a = new Uint8Array(
          h.length * 32 + g + 32
        );
        break;
      default:
        throw new TypeError(
          `Expected param type to be ArgumentType, but received ${t.ty}`
        );
    }
    d = safeView(a, 28), d.setUint32(0, h.length);
    let c = 32 * h.length;
    for (const [x, R] of h.entries())
      switch (t.ty) {
        case ArgumentType.uint8:
        case ArgumentType.int8:
        case ArgumentType.uint16:
        case ArgumentType.int16:
        case ArgumentType.uint24:
        case ArgumentType.int24:
        case ArgumentType.uint32:
        case ArgumentType.int32:
        case ArgumentType.uint40:
        case ArgumentType.int40:
        case ArgumentType.uint48:
        case ArgumentType.int48:
        case ArgumentType.uint56:
        case ArgumentType.int56:
        case ArgumentType.uint64:
        case ArgumentType.int64:
        case ArgumentType.uint72:
        case ArgumentType.int72:
        case ArgumentType.uint80:
        case ArgumentType.int80:
        case ArgumentType.uint88:
        case ArgumentType.int88:
        case ArgumentType.uint96:
        case ArgumentType.int96:
        case ArgumentType.uint104:
        case ArgumentType.int104:
        case ArgumentType.uint112:
        case ArgumentType.int112:
        case ArgumentType.uint120:
        case ArgumentType.int120:
        case ArgumentType.uint128:
        case ArgumentType.int128:
        case ArgumentType.uint136:
        case ArgumentType.int136:
        case ArgumentType.uint144:
        case ArgumentType.int144:
        case ArgumentType.uint152:
        case ArgumentType.int152:
        case ArgumentType.uint160:
        case ArgumentType.int160:
        case ArgumentType.uint168:
        case ArgumentType.int168:
        case ArgumentType.uint176:
        case ArgumentType.int176:
        case ArgumentType.uint184:
        case ArgumentType.int184:
        case ArgumentType.uint192:
        case ArgumentType.int192:
        case ArgumentType.uint200:
        case ArgumentType.int200:
        case ArgumentType.uint208:
        case ArgumentType.int208:
        case ArgumentType.uint216:
        case ArgumentType.int216:
        case ArgumentType.uint224:
        case ArgumentType.int224:
        case ArgumentType.uint232:
        case ArgumentType.int232:
        case ArgumentType.uint240:
        case ArgumentType.int240:
        case ArgumentType.uint248:
        case ArgumentType.int248:
        case ArgumentType.uint256:
        case ArgumentType.int256:
        case ArgumentType.bool:
        case ArgumentType.bytes32:
        case ArgumentType.address:
        case ArgumentType.func:
          a.set(R, x * 32 + 32);
          break;
        case ArgumentType.bytes:
        case ArgumentType.string:
          const B = safeView(a, (x + 1) * 32 + 28);
          B.setUint32(0, c), a.set(R, B.getUint32(0) + 32), c += R.length;
          break;
        default:
          throw new TypeError(
            `Expected param type to be ArgumentType, but received ${t.ty}`
          );
      }
    return a;
  }
  switch (t.ty) {
    case ArgumentType.uint8:
    case ArgumentType.int8:
    case ArgumentType.uint16:
    case ArgumentType.int16:
    case ArgumentType.uint24:
    case ArgumentType.int24:
    case ArgumentType.uint32:
    case ArgumentType.int32:
    case ArgumentType.uint40:
    case ArgumentType.int40:
    case ArgumentType.uint48:
    case ArgumentType.int48:
    case ArgumentType.uint56:
    case ArgumentType.int56:
    case ArgumentType.uint64:
    case ArgumentType.int64:
    case ArgumentType.uint72:
    case ArgumentType.int72:
    case ArgumentType.uint80:
    case ArgumentType.int80:
    case ArgumentType.uint88:
    case ArgumentType.int88:
    case ArgumentType.uint96:
    case ArgumentType.int96:
    case ArgumentType.uint104:
    case ArgumentType.int104:
    case ArgumentType.uint112:
    case ArgumentType.int112:
    case ArgumentType.uint120:
    case ArgumentType.int120:
    case ArgumentType.uint128:
    case ArgumentType.int128:
    case ArgumentType.uint136:
    case ArgumentType.int136:
    case ArgumentType.uint144:
    case ArgumentType.int144:
    case ArgumentType.uint152:
    case ArgumentType.int152:
    case ArgumentType.uint160:
    case ArgumentType.int160:
    case ArgumentType.uint168:
    case ArgumentType.int168:
    case ArgumentType.uint176:
    case ArgumentType.int176:
    case ArgumentType.uint184:
    case ArgumentType.int184:
    case ArgumentType.uint192:
    case ArgumentType.int192:
    case ArgumentType.uint200:
    case ArgumentType.int200:
    case ArgumentType.uint208:
    case ArgumentType.int208:
    case ArgumentType.uint216:
    case ArgumentType.int216:
    case ArgumentType.uint224:
    case ArgumentType.int224:
    case ArgumentType.uint232:
    case ArgumentType.int232:
    case ArgumentType.uint240:
    case ArgumentType.int240:
    case ArgumentType.uint248:
    case ArgumentType.int248:
    case ArgumentType.int256:
    case ArgumentType.uint256: {
      let h = u.toString(16);
      u > 0 ? h = "0x" + h : h = h.slice(0, 1) + "0x" + h.slice(1);
      const g = defaultAbiCoder.encode(
        [solidityTypeToString(t)],
        [h]
      );
      return arrayify(g);
    }
    case ArgumentType.address:
      return a.set(u, 32 - 20), a;
    case ArgumentType.bool:
      return a[31] = u ? 1 : 0, a;
    case ArgumentType.func:
      return a.set(u, 32 - 24), a;
    case ArgumentType.bytes32:
      return a.set(u, 0), a;
    case ArgumentType.bytes:
    case ArgumentType.string:
      return l = u instanceof Uint8Array ? u : encode$1(u), Math.floor(l.length / 32) >= 0 ? Math.floor(l.length % 32) !== 0 ? a = new Uint8Array(
        (Math.floor(l.length / 32) + 1) * 32 + 32
      ) : a = new Uint8Array(
        Math.floor(l.length / 32) * 32 + 32
      ) : a = new Uint8Array(64), a.set(l, 32), d = safeView(a, 28), d.setUint32(0, l.length), a;
    default:
      throw new Error(`Unsupported argument type: ${t.toString()}`);
  }
}
class ContractCallQuery extends Query {
  constructor(t = {}) {
    super(), this._contractId = null, t.contractId != null && this.setContractId(t.contractId), this._gas = null, t.gas != null && this.setGas(t.gas), this._functionParameters = null, t.functionParameters != null && (t.functionParameters instanceof Uint8Array ? this.setFunctionParameters(t.functionParameters) : this.setFunction(
      t.functionParameters.name,
      t.functionParameters.parameters
    )), this._maxResultSize = null, t.maxResultSize != null && this.setMaxResultSize(t.maxResultSize), this._senderAccountId = null, t.senderAccountId != null && this.setSenderAccountId(t.senderAccountId);
  }
  static _fromProtobuf(t) {
    const a = t.contractCallLocal;
    return new ContractCallQuery({
      contractId: a.contractID != null ? ContractId._fromProtobuf(a.contractID) : void 0,
      gas: a.gas != null ? a.gas : void 0,
      functionParameters: a.functionParameters != null ? a.functionParameters : void 0,
      maxResultSize: a.maxResultSize != null ? a.maxResultSize : void 0
    });
  }
  get contractId() {
    return this._contractId;
  }
  setContractId(t) {
    return this._contractId = typeof t == "string" ? ContractId.fromString(t) : t.clone(), this;
  }
  get gas() {
    return this._gas;
  }
  setGas(t) {
    return this._gas = t instanceof long ? t : long.fromValue(t), this;
  }
  get senderAccountId() {
    return this._senderAccountId;
  }
  setSenderAccountId(t) {
    return this._senderAccountId = typeof t == "string" ? AccountId.fromString(t) : t, this;
  }
  get functionParameters() {
    return this._functionParameters;
  }
  setFunctionParameters(t) {
    return this._functionParameters = t, this;
  }
  setFunction(t, a) {
    return this._functionParameters = (a != null ? a : new ContractFunctionParameters())._build(t), this;
  }
  setMaxResultSize(t) {
    return this._maxResultSize = t instanceof long ? t : long.fromValue(t), this;
  }
  _validateChecksums(t) {
    this._contractId != null && this._contractId.validateChecksum(t);
  }
  _mapStatusError(t, a) {
    const { nodeTransactionPrecheckCode: d } = this._mapResponseHeader(a), l = Status._fromCode(
      d != null ? d : lib.proto.ResponseCodeEnum.OK
    );
    if (!a.contractCallLocal.functionResult)
      return new PrecheckStatusError({
        status: l,
        transactionId: this._getTransactionId(),
        contractFunctionResult: null
      });
    const g = this._mapResponseSync(a);
    return new PrecheckStatusError({
      status: l,
      transactionId: this._getTransactionId(),
      contractFunctionResult: g
    });
  }
  _execute(t, a) {
    return t.smartContract.contractCallLocalMethod(a);
  }
  _mapResponseHeader(t) {
    return t.contractCallLocal.header;
  }
  _mapResponse(t) {
    const a = t.contractCallLocal;
    return Promise.resolve(
      ContractFunctionResult._fromProtobuf(
        a.functionResult,
        !1
      )
    );
  }
  _mapResponseSync(t) {
    const a = t.contractCallLocal;
    return ContractFunctionResult._fromProtobuf(
      a.functionResult,
      !1
    );
  }
  _onMakeRequest(t) {
    return {
      contractCallLocal: {
        header: t,
        contractID: this._contractId != null ? this._contractId._toProtobuf() : null,
        gas: this._gas,
        maxResultSize: this._maxResultSize,
        functionParameters: this._functionParameters,
        senderId: this._senderAccountId != null ? this._senderAccountId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `ContractCallQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set("contractCallLocal", ContractCallQuery._fromProtobuf);
class FileCreateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._keys = null, this._expirationTime = new Timestamp(0, 0).plusNanos(
      long.fromNumber(Date.now()).mul(1e6).add(DEFAULT_AUTO_RENEW_PERIOD.mul(1e9))
    ), this._contents = null, this._fileMemo = null, this._defaultMaxTransactionFee = new Hbar(5), t.keys != null && this.setKeys(t.keys), t.expirationTime != null && this.setExpirationTime(t.expirationTime), t.contents != null && this.setContents(t.contents), t.fileMemo != null && this.setFileMemo(t.fileMemo);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].fileCreate;
    return Transaction._fromProtobufTransactions(
      new FileCreateTransaction({
        keys: c.keys != null && c.keys.keys != null ? c.keys.keys.map(
          (x) => Key._fromProtobufKey(x)
        ) : void 0,
        expirationTime: c.expirationTime != null ? Timestamp._fromProtobuf(c.expirationTime) : void 0,
        contents: c.contents != null ? c.contents : void 0,
        fileMemo: c.memo != null ? c.memo : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get keys() {
    return this._keys;
  }
  setKeys(t) {
    if (this._requireNotFrozen(), t instanceof KeyList && t.threshold != null)
      throw new Error("Cannot set threshold key as file key");
    return this._keys = t instanceof KeyList ? t.toArray() : t, this;
  }
  get expirationTime() {
    return this._expirationTime;
  }
  setExpirationTime(t) {
    return this._requireNotFrozen(), this._expirationTime = t instanceof Timestamp ? t : Timestamp.fromDate(t), this;
  }
  get contents() {
    return this._contents;
  }
  setContents(t) {
    return this._requireNotFrozen(), this._contents = t instanceof Uint8Array ? t : encode$1(t), this;
  }
  get fileMemo() {
    return this._fileMemo;
  }
  setFileMemo(t) {
    return this._requireNotFrozen(), this._fileMemo = t, this;
  }
  _execute(t, a) {
    return t.file.createFile(a);
  }
  _getTransactionDataCase() {
    return "fileCreate";
  }
  _makeTransactionData() {
    return {
      keys: this._keys != null ? {
        keys: this._keys.map((t) => t._toProtobufKey())
      } : null,
      expirationTime: this._expirationTime._toProtobuf(),
      contents: this._contents,
      memo: this._fileMemo
    };
  }
  _getLogId() {
    return `FileCreateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set("fileCreate", FileCreateTransaction._fromProtobuf);
class FileAppendTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._fileId = null, this._contents = null, this._maxChunks = 20, this._chunkSize = 4096, this._defaultMaxTransactionFee = new Hbar(5), t.fileId != null && this.setFileId(t.fileId), t.contents != null && this.setContents(t.contents), t.maxChunks != null && this.setMaxChunks(t.maxChunks), t.chunkSize != null && this.setChunkSize(t.chunkSize), this._transactionIds = new List();
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].fileAppend;
    let x;
    for (let R = 0; R < h.length; R += l.length) {
      const B = h[R].fileAppend;
      if (B.contents == null)
        break;
      if (x == null) {
        x = new Uint8Array(
          B.contents
        );
        continue;
      }
      const j = new Uint8Array(
        x.length + B.contents.length
      );
      j.set(x, 0), j.set(
        B.contents,
        x.length
      ), x = j;
    }
    return Transaction._fromProtobufTransactions(
      new FileAppendTransaction({
        fileId: c.fileID != null ? FileId._fromProtobuf(
          c.fileID
        ) : void 0,
        contents: x
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get fileId() {
    return this._fileId;
  }
  setFileId(t) {
    return this._requireNotFrozen(), this._fileId = typeof t == "string" ? FileId.fromString(t) : t.clone(), this;
  }
  get contents() {
    return this._contents;
  }
  setContents(t) {
    return this._requireNotFrozen(), this._contents = t instanceof Uint8Array ? t : encode$1(t), this;
  }
  get maxChunks() {
    return this._maxChunks;
  }
  setMaxChunks(t) {
    return this._requireNotFrozen(), this._maxChunks = t, this;
  }
  get chunkSize() {
    return this._chunkSize;
  }
  setChunkSize(t) {
    return this._chunkSize = t, this;
  }
  freezeWith(t) {
    if (super.freezeWith(t), this._contents == null)
      return this;
    const a = Math.floor(
      (this._contents.length + (this._chunkSize - 1)) / this._chunkSize
    );
    if (a > this._maxChunks)
      throw new Error(
        `Contents with size ${this._contents.length} too long for ${this._maxChunks} chunks`
      );
    let d = this._getTransactionId();
    this._transactionIds.locked = !1, this._transactions.clear(), this._transactionIds.clear(), this._signedTransactions.clear();
    for (let l = 0; l < a; l++) {
      this._transactionIds.push(d), this._transactionIds.advance();
      for (const h of this._nodeAccountIds.list)
        this._signedTransactions.push(
          this._makeSignedTransaction(h)
        );
      d = new TransactionId(
        d.accountId,
        new Timestamp(
          d.validStart.seconds,
          d.validStart.nanos.add(1)
        )
      );
    }
    return this._transactionIds.advance(), this._transactionIds.setLocked(), this;
  }
  schedule() {
    if (this._requireNotFrozen(), this._contents != null && this._contents.length > this._chunkSize)
      throw new Error(
        `cannot schedule \`FileAppendTransaction\` with message over ${this._chunkSize} bytes`
      );
    return super.schedule();
  }
  async execute(t, a) {
    return (await this.executeAll(t, a))[0];
  }
  async executeAll(t, a) {
    super._isFrozen() || this.freezeWith(t);
    const d = this._getTransactionId(), l = t.operatorAccountId;
    l != null && l.equals(
      d.accountId
    ) && await super.signWithOperator(t);
    const h = [];
    let g = a;
    for (let c = 0; c < this._transactionIds.length; c++) {
      const x = Date.now(), R = await super.execute(t, g);
      g != null && (g = Date.now() - x), await R.getReceipt(t), h.push(R);
    }
    return h;
  }
  _validateChecksums(t) {
    this._fileId != null && this._fileId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.file.appendContent(a);
  }
  _getTransactionDataCase() {
    return "fileAppend";
  }
  _makeTransactionData() {
    const t = this._contents != null ? this._contents.length : 0, a = this._transactionIds.index * this._chunkSize, d = Math.min(a + this._chunkSize, t);
    return {
      fileID: this._fileId != null ? this._fileId._toProtobuf() : null,
      contents: this._contents != null ? this._contents.slice(a, d) : null
    };
  }
  _getLogId() {
    return `FileAppendTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set("fileAppend", FileAppendTransaction._fromProtobuf);
class FileDeleteTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._fileId = null, t.fileId != null && this.setFileId(t.fileId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].fileDelete;
    return Transaction._fromProtobufTransactions(
      new FileDeleteTransaction({
        fileId: c.fileID != null ? FileId._fromProtobuf(c.fileID) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get fileId() {
    return this._fileId;
  }
  setFileId(t) {
    return this._requireNotFrozen(), this._fileId = typeof t == "string" ? FileId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._fileId != null && this._fileId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.file.deleteFile(a);
  }
  _getTransactionDataCase() {
    return "fileDelete";
  }
  _makeTransactionData() {
    return {
      fileID: this._fileId != null ? this._fileId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `FileDeleteTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set("fileDelete", FileDeleteTransaction._fromProtobuf);
class ContractCreateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._bytecodeFileId = null, this._bytecode = null, this._adminKey = null, this._gas = null, this._initialBalance = null, this._proxyAccountId = null, this._autoRenewPeriod = new Duration(DEFAULT_AUTO_RENEW_PERIOD), this._constructorParameters = null, this._contractMemo = null, this._maxAutomaticTokenAssociations = null, this._defaultMaxTransactionFee = new Hbar(20), this._stakedAccountId = null, this._stakedNodeId = null, this._declineStakingReward = !1, this._autoRenewAccountId = null, t.bytecodeFileId != null && this.setBytecodeFileId(t.bytecodeFileId), t.bytecode != null && this.setBytecode(t.bytecode), t.adminKey != null && this.setAdminKey(t.adminKey), t.gas != null && this.setGas(t.gas), t.initialBalance != null && this.setInitialBalance(t.initialBalance), t.proxyAccountId != null && this.setProxyAccountId(t.proxyAccountId), t.autoRenewPeriod != null && this.setAutoRenewPeriod(t.autoRenewPeriod), t.constructorParameters != null && this.setConstructorParameters(t.constructorParameters), t.contractMemo != null && this.setContractMemo(t.contractMemo), t.maxAutomaticTokenAssociations != null && this.setMaxAutomaticTokenAssociations(
      t.maxAutomaticTokenAssociations
    ), t.stakedAccountId != null && this.setStakedAccountId(t.stakedAccountId), t.stakedNodeId != null && this.setStakedNodeId(t.stakedNodeId), t.declineStakingReward != null && this.setDeclineStakingReward(t.declineStakingReward), t.autoRenewAccountId != null && this.setAutoRenewAccountId(t.autoRenewAccountId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].contractCreateInstance;
    return Transaction._fromProtobufTransactions(
      new ContractCreateTransaction({
        bytecodeFileId: c.fileID != null ? FileId._fromProtobuf(
          c.fileID
        ) : void 0,
        adminKey: c.adminKey != null ? Key._fromProtobufKey(c.adminKey) : void 0,
        gas: c.gas != null ? c.gas : void 0,
        initialBalance: c.initialBalance != null ? c.initialBalance : void 0,
        proxyAccountId: c.proxyAccountID != null ? AccountId._fromProtobuf(
          c.proxyAccountID
        ) : void 0,
        autoRenewPeriod: c.autoRenewPeriod != null && c.autoRenewPeriod.seconds != null ? c.autoRenewPeriod.seconds : void 0,
        constructorParameters: c.constructorParameters != null ? c.constructorParameters : void 0,
        contractMemo: c.memo != null ? c.memo : void 0,
        maxAutomaticTokenAssociations: c.maxAutomaticTokenAssociations != null ? c.maxAutomaticTokenAssociations : void 0,
        stakedAccountId: c.stakedAccountId != null ? AccountId._fromProtobuf(c.stakedAccountId) : void 0,
        stakedNodeId: c.stakedNodeId != null ? c.stakedNodeId : void 0,
        declineStakingReward: c.declineReward == !0,
        autoRenewAccountId: c.autoRenewAccountId != null ? AccountId._fromProtobuf(c.autoRenewAccountId) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get bytecodeFileId() {
    return this._bytecodeFileId;
  }
  setBytecodeFileId(t) {
    return this._requireNotFrozen(), this._bytecodeFileId = typeof t == "string" ? FileId.fromString(t) : t.clone(), this._bytecode = null, this;
  }
  get bytecode() {
    return this._bytecode;
  }
  setBytecode(t) {
    return this._requireNotFrozen(), this._bytecode = t, this._bytecodeFileId = null, this;
  }
  get adminKey() {
    return this._adminKey;
  }
  setAdminKey(t) {
    return this._requireNotFrozen(), this._adminKey = t, this;
  }
  get gas() {
    return this._gas;
  }
  setGas(t) {
    return this._requireNotFrozen(), this._gas = t instanceof long ? t : long.fromValue(t), this;
  }
  get initialBalance() {
    return this._initialBalance;
  }
  setInitialBalance(t) {
    return this._requireNotFrozen(), this._initialBalance = t instanceof Hbar ? t : new Hbar(t), this;
  }
  get proxyAccountId() {
    return this._proxyAccountId;
  }
  setProxyAccountId(t) {
    return this._requireNotFrozen(), this._proxyAccountId = t instanceof AccountId ? t : AccountId.fromString(t), this;
  }
  get autoRenewPeriod() {
    return this._autoRenewPeriod;
  }
  setAutoRenewPeriod(t) {
    return this._requireNotFrozen(), this._autoRenewPeriod = t instanceof Duration ? t : new Duration(t), this;
  }
  get constructorParameters() {
    return this._constructorParameters;
  }
  setConstructorParameters(t) {
    return this._requireNotFrozen(), this._constructorParameters = t instanceof ContractFunctionParameters ? t._build() : t, this;
  }
  get contractMemo() {
    return this._contractMemo;
  }
  setContractMemo(t) {
    return this._requireNotFrozen(), this._contractMemo = t, this;
  }
  get maxAutomaticTokenAssociations() {
    return this._maxAutomaticTokenAssociations;
  }
  setMaxAutomaticTokenAssociations(t) {
    return this._maxAutomaticTokenAssociations = t, this;
  }
  get stakedAccountId() {
    return this._stakedAccountId;
  }
  setStakedAccountId(t) {
    return this._requireNotFrozen(), this._stakedAccountId = typeof t == "string" ? AccountId.fromString(t) : t, this;
  }
  get stakedNodeId() {
    return this._stakedNodeId;
  }
  setStakedNodeId(t) {
    return this._requireNotFrozen(), this._stakedNodeId = long.fromValue(t), this;
  }
  get declineStakingRewards() {
    return this._declineStakingReward;
  }
  setDeclineStakingReward(t) {
    return this._requireNotFrozen(), this._declineStakingReward = t, this;
  }
  get autoRenewAccountId() {
    return this._autoRenewAccountId;
  }
  setAutoRenewAccountId(t) {
    return this._requireNotFrozen(), this._autoRenewAccountId = typeof t == "string" ? AccountId.fromString(t) : t, this;
  }
  _validateChecksums(t) {
    this._bytecodeFileId != null && this._bytecodeFileId.validateChecksum(t), this._proxyAccountId != null && this._proxyAccountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.smartContract.createContract(a);
  }
  _getTransactionDataCase() {
    return "contractCreateInstance";
  }
  _makeTransactionData() {
    return {
      fileID: this._bytecodeFileId != null ? this._bytecodeFileId._toProtobuf() : null,
      initcode: this._bytecode,
      adminKey: this._adminKey != null ? this._adminKey._toProtobufKey() : null,
      gas: this._gas,
      initialBalance: this._initialBalance != null ? this._initialBalance.toTinybars() : null,
      proxyAccountID: this._proxyAccountId != null ? this._proxyAccountId._toProtobuf() : null,
      autoRenewPeriod: this._autoRenewPeriod._toProtobuf(),
      constructorParameters: this._constructorParameters,
      memo: this._contractMemo,
      maxAutomaticTokenAssociations: this._maxAutomaticTokenAssociations,
      stakedAccountId: this.stakedAccountId != null ? this.stakedAccountId._toProtobuf() : null,
      stakedNodeId: this.stakedNodeId,
      declineReward: this.declineStakingRewards,
      autoRenewAccountId: this._autoRenewAccountId != null ? this._autoRenewAccountId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `ContractCreateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "contractCreateInstance",
  ContractCreateTransaction._fromProtobuf
);
class ContractDeleteTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._contractId = null, this._transferAccountId = null, this._transferContractId = null, t.contractId != null && this.setContractId(t.contractId), t.transferAccountId != null && this.setTransferAccountId(t.transferAccountId), t.transferContractId != null && this.setTransferContractId(t.transferContractId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].contractDeleteInstance;
    return Transaction._fromProtobufTransactions(
      new ContractDeleteTransaction({
        contractId: c.contractID != null ? ContractId._fromProtobuf(
          c.contractID
        ) : void 0,
        transferAccountId: c.transferAccountID != null ? AccountId._fromProtobuf(
          c.transferAccountID
        ) : void 0,
        transferContractId: c.transferContractID != null ? ContractId._fromProtobuf(
          c.transferContractID
        ) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get contractId() {
    return this._contractId;
  }
  setContractId(t) {
    return this._requireNotFrozen(), this._contractId = typeof t == "string" ? ContractId.fromString(t) : t.clone(), this;
  }
  get transferContractId() {
    return this._transferContractId;
  }
  setTransferContractId(t) {
    return this._requireNotFrozen(), this._transferContractId = t instanceof ContractId ? t : ContractId.fromString(t), this;
  }
  get transferAccountId() {
    return this._transferAccountId;
  }
  setTransferAccountId(t) {
    return this._requireNotFrozen(), this._transferAccountId = t instanceof AccountId ? t : AccountId.fromString(t), this;
  }
  _validateChecksums(t) {
    this._contractId != null && this._contractId.validateChecksum(t), this._transferAccountId != null && this._transferAccountId.validateChecksum(t), this._transferContractId != null && this._transferContractId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.smartContract.deleteContract(a);
  }
  _getTransactionDataCase() {
    return "contractDeleteInstance";
  }
  _makeTransactionData() {
    return {
      contractID: this._contractId != null ? this._contractId._toProtobuf() : null,
      transferAccountID: this._transferAccountId ? this._transferAccountId._toProtobuf() : null,
      transferContractID: this._transferContractId != null ? this._transferContractId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `ContractDeleteTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "contractDeleteInstance",
  ContractDeleteTransaction._fromProtobuf
);
class ContractExecuteTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._contractId = null, this._gas = null, this._amount = null, this._functionParameters = null, t.contractId != null && this.setContractId(t.contractId), t.gas != null && this.setGas(t.gas), t.amount != null && this.setPayableAmount(t.amount), t.functionParameters != null ? this.setFunctionParameters(t.functionParameters) : t.function != null && this.setFunction(t.function.name, t.function.parameters);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].contractCall;
    return Transaction._fromProtobufTransactions(
      new ContractExecuteTransaction({
        contractId: c.contractID != null ? ContractId._fromProtobuf(
          c.contractID
        ) : void 0,
        gas: c.gas != null ? c.gas : void 0,
        amount: c.amount != null ? Hbar.fromTinybars(c.amount) : void 0,
        functionParameters: c.functionParameters != null ? c.functionParameters : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get contractId() {
    return this._contractId;
  }
  setContractId(t) {
    return this._requireNotFrozen(), this._contractId = typeof t == "string" ? ContractId.fromString(t) : t.clone(), this;
  }
  get gas() {
    return this._gas;
  }
  setGas(t) {
    return this._requireNotFrozen(), this._gas = t instanceof long ? t : long.fromValue(t), this;
  }
  get payableAmount() {
    return this._amount;
  }
  setPayableAmount(t) {
    return this._requireNotFrozen(), this._amount = t instanceof Hbar ? t : new Hbar(t), this;
  }
  get functionParameters() {
    return this._functionParameters;
  }
  setFunctionParameters(t) {
    return this._requireNotFrozen(), this._functionParameters = t, this;
  }
  setFunction(t, a) {
    return this._requireNotFrozen(), this._functionParameters = a != null ? a._build(t) : new ContractFunctionParameters()._build(t), this;
  }
  _validateChecksums(t) {
    this._contractId != null && this._contractId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.smartContract.contractCallMethod(a);
  }
  _getTransactionDataCase() {
    return "contractCall";
  }
  _makeTransactionData() {
    return {
      contractID: this._contractId != null ? this._contractId._toProtobuf() : null,
      gas: this._gas,
      amount: this._amount != null ? this._amount.toTinybars() : null,
      functionParameters: this._functionParameters
    };
  }
  _getLogId() {
    return `ContractExecuteTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "contractCall",
  ContractExecuteTransaction._fromProtobuf
);
const { proto: proto$2 } = HashgraphProto;
class ContractInfo {
  constructor(t) {
    this.contractId = t.contractId, this.accountId = t.accountId, this.contractAccountId = t.contractAccountId, this.adminKey = t.adminKey != null ? t.adminKey : null, this.expirationTime = t.expirationTime, this.autoRenewPeriod = t.autoRenewPeriod, this.autoRenewAccountId = t.autoRenewAccountId, this.storage = t.storage, this.contractMemo = t.contractMemo, this.balance = t.balance, this.isDeleted = t.isDeleted, this.tokenRelationships = t.tokenRelationships, this.ledgerId = t.ledgerId, this.stakingInfo = t.stakingInfo, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    const a = t.autoRenewPeriod.seconds;
    return new ContractInfo({
      contractId: ContractId._fromProtobuf(
        t.contractID
      ),
      accountId: AccountId._fromProtobuf(
        t.accountID
      ),
      contractAccountId: t.contractAccountID != null ? t.contractAccountID : "",
      adminKey: t.adminKey != null ? Key._fromProtobufKey(t.adminKey) : null,
      expirationTime: Timestamp._fromProtobuf(
        t.expirationTime
      ),
      autoRenewPeriod: new Duration(a),
      autoRenewAccountId: t.autoRenewAccountId != null ? AccountId._fromProtobuf(t.autoRenewAccountId) : null,
      storage: t.storage != null ? t.storage instanceof long ? t.storage : long.fromValue(t.storage) : long.ZERO,
      contractMemo: t.memo != null ? t.memo : "",
      balance: Hbar.fromTinybars(t.balance != null ? t.balance : 0),
      isDeleted: t.deleted,
      tokenRelationships: TokenRelationshipMap._fromProtobuf(
        t.tokenRelationships != null ? t.tokenRelationships : []
      ),
      ledgerId: t.ledgerId != null ? LedgerId.fromBytes(t.ledgerId) : null,
      stakingInfo: t.stakingInfo != null ? StakingInfo._fromProtobuf(t.stakingInfo) : null
    });
  }
  _toProtobuf() {
    return {
      contractID: this.contractId._toProtobuf(),
      accountID: this.accountId._toProtobuf(),
      contractAccountID: this.contractAccountId,
      adminKey: this.adminKey != null ? this.adminKey._toProtobufKey() : null,
      expirationTime: this.expirationTime._toProtobuf(),
      autoRenewPeriod: this.autoRenewPeriod != null ? this.autoRenewPeriod._toProtobuf() : null,
      autoRenewAccountId: this.autoRenewAccountId != null ? this.autoRenewAccountId._toProtobuf() : null,
      storage: this.storage,
      memo: this.contractMemo,
      balance: this.balance.toTinybars(),
      deleted: this.isDeleted,
      tokenRelationships: this.tokenRelationships != null ? this.tokenRelationships._toProtobuf() : null,
      ledgerId: this.ledgerId != null ? this.ledgerId.toBytes() : null,
      stakingInfo: this.stakingInfo != null ? this.stakingInfo._toProtobuf() : null
    };
  }
  static fromBytes(t) {
    return ContractInfo._fromProtobuf(
      proto$2.ContractGetInfoResponse.ContractInfo.decode(t)
    );
  }
  toBytes() {
    return proto$2.ContractGetInfoResponse.ContractInfo.encode(
      this._toProtobuf()
    ).finish();
  }
}
class ContractInfoQuery extends Query {
  constructor(t = {}) {
    super(), this._contractId = null, t.contractId != null && this.setContractId(t.contractId);
  }
  static _fromProtobuf(t) {
    const a = t.contractGetInfo;
    return new ContractInfoQuery({
      contractId: a.contractID != null ? ContractId._fromProtobuf(a.contractID) : void 0
    });
  }
  get contractId() {
    return this._contractId;
  }
  setContractId(t) {
    return this._contractId = typeof t == "string" ? ContractId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._contractId != null && this._contractId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.smartContract.getContractInfo(a);
  }
  async getCost(t) {
    return super.getCost(t);
  }
  _mapResponseHeader(t) {
    return t.contractGetInfo.header;
  }
  _mapResponse(t, a, d) {
    const l = t.contractGetInfo;
    return Promise.resolve(
      ContractInfo._fromProtobuf(
        l.contractInfo
      )
    );
  }
  _onMakeRequest(t) {
    return {
      contractGetInfo: {
        header: t,
        contractID: this._contractId != null ? this._contractId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `ContractInfoQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set("contractGetInfo", ContractInfoQuery._fromProtobuf);
class ContractUpdateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._contractId = null, this._expirationTime = null, this._adminKey = null, this._proxyAccountId = null, this._autoRenewPeriod = null, this._bytecodeFileId = null, this._contractMemo = null, this._maxAutomaticTokenAssociations = null, this._stakedAccountId = null, this._stakedNodeId = null, this._declineStakingReward = null, this._autoRenewAccountId = null, t.contractId != null && this.setContractId(t.contractId), t.expirationTime != null && this.setExpirationTime(t.expirationTime), t.adminKey != null && this.setAdminKey(t.adminKey), t.proxyAccountId != null && this.setProxyAccountId(t.proxyAccountId), t.autoRenewPeriod != null && this.setAutoRenewPeriod(t.autoRenewPeriod), t.bytecodeFileId != null && this.setBytecodeFileId(t.bytecodeFileId), t.contractMemo != null && this.setContractMemo(t.contractMemo), t.maxAutomaticTokenAssociations != null && this.setMaxAutomaticTokenAssociations(
      t.maxAutomaticTokenAssociations
    ), t.stakedAccountId != null && this.setStakedAccountId(t.stakedAccountId), t.stakedNodeId != null && this.setStakedNodeId(t.stakedNodeId), t.declineStakingReward != null && this.setDeclineStakingReward(t.declineStakingReward), t.autoRenewAccountId != null && this.setAutoRenewAccountId(t.autoRenewAccountId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].contractUpdateInstance;
    let x;
    c.autoRenewPeriod != null && c.autoRenewPeriod.seconds != null && (x = c.autoRenewPeriod.seconds);
    let R;
    c.memoWrapper != null && c.memoWrapper.value != null && (R = c.memoWrapper.value);
    let B;
    return c.maxAutomaticTokenAssociations != null && c.maxAutomaticTokenAssociations.value != null && (B = c.maxAutomaticTokenAssociations.value), Transaction._fromProtobufTransactions(
      new ContractUpdateTransaction({
        contractId: c.contractID != null ? ContractId._fromProtobuf(
          c.contractID
        ) : void 0,
        bytecodeFileId: c.fileID != null ? FileId._fromProtobuf(
          c.fileID
        ) : void 0,
        expirationTime: c.expirationTime != null ? Timestamp._fromProtobuf(c.expirationTime) : void 0,
        adminKey: c.adminKey != null ? Key._fromProtobufKey(c.adminKey) : void 0,
        proxyAccountId: c.proxyAccountID != null ? AccountId._fromProtobuf(
          c.proxyAccountID
        ) : void 0,
        autoRenewPeriod: x,
        contractMemo: R,
        maxAutomaticTokenAssociations: B,
        stakedAccountId: c.stakedAccountId != null ? AccountId._fromProtobuf(c.stakedAccountId) : void 0,
        stakedNodeId: c.stakedNodeId != null ? c.stakedNodeId : void 0,
        declineStakingReward: c.declineReward != null && Boolean(c.declineReward) == !0,
        autoRenewAccountId: c.autoRenewAccountId != null ? AccountId._fromProtobuf(c.autoRenewAccountId) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get contractId() {
    return this._contractId;
  }
  setContractId(t) {
    return this._requireNotFrozen(), this._contractId = typeof t == "string" ? ContractId.fromString(t) : t.clone(), this;
  }
  get expirationTime() {
    return this._expirationTime;
  }
  setExpirationTime(t) {
    return this._requireNotFrozen(), this._expirationTime = t instanceof Timestamp ? t : Timestamp.fromDate(t), this;
  }
  get adminKey() {
    return this._adminKey;
  }
  setAdminKey(t) {
    return this._requireNotFrozen(), this._adminKey = t, this;
  }
  get proxyAccountId() {
    return this._proxyAccountId;
  }
  setProxyAccountId(t) {
    return this._requireNotFrozen(), this._proxyAccountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  get autoRenewPeriod() {
    return this._autoRenewPeriod;
  }
  setAutoRenewPeriod(t) {
    return this._requireNotFrozen(), this._autoRenewPeriod = t instanceof Duration ? t : new Duration(t), this;
  }
  get bytecodeFileId() {
    return this._bytecodeFileId;
  }
  setBytecodeFileId(t) {
    return console.warn("Deprecated: there is no replacement"), this._requireNotFrozen(), this._bytecodeFileId = typeof t == "string" ? FileId.fromString(t) : t.clone(), this;
  }
  get contractMemo() {
    return this._contractMemo;
  }
  setContractMemo(t) {
    return this._requireNotFrozen(), this._contractMemo = t, this;
  }
  clearContractMemo() {
    return this._requireNotFrozen(), this._contractMemo = null, this;
  }
  get maxAutomaticTokenAssociations() {
    return this._maxAutomaticTokenAssociations;
  }
  setMaxAutomaticTokenAssociations(t) {
    return this._requireNotFrozen(), this._maxAutomaticTokenAssociations = t, this;
  }
  get stakedAccountId() {
    return this._stakedAccountId;
  }
  setStakedAccountId(t) {
    return this._requireNotFrozen(), this._stakedAccountId = typeof t == "string" ? AccountId.fromString(t) : t, this;
  }
  get stakedNodeId() {
    return this._stakedNodeId;
  }
  setStakedNodeId(t) {
    return this._requireNotFrozen(), this._stakedNodeId = long.fromValue(t), this;
  }
  get declineStakingRewards() {
    return this._declineStakingReward;
  }
  setDeclineStakingReward(t) {
    return this._requireNotFrozen(), this._declineStakingReward = t, this;
  }
  get autoRenewAccountId() {
    return this._autoRenewAccountId;
  }
  setAutoRenewAccountId(t) {
    return this._requireNotFrozen(), this._autoRenewAccountId = typeof t == "string" ? AccountId.fromString(t) : t, this;
  }
  clearAutoRenewAccountId() {
    return this._autoRenewAccountId = new AccountId(0), this;
  }
  _validateChecksums(t) {
    this._contractId != null && this._contractId.validateChecksum(t), this._bytecodeFileId != null && this._bytecodeFileId.validateChecksum(t), this._proxyAccountId != null && this._proxyAccountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.smartContract.updateContract(a);
  }
  _getTransactionDataCase() {
    return "contractUpdateInstance";
  }
  _makeTransactionData() {
    return {
      contractID: this._contractId != null ? this._contractId._toProtobuf() : null,
      expirationTime: this._expirationTime != null ? this._expirationTime._toProtobuf() : null,
      adminKey: this._adminKey != null ? this._adminKey._toProtobufKey() : null,
      proxyAccountID: this._proxyAccountId != null ? this._proxyAccountId._toProtobuf() : null,
      autoRenewPeriod: this._autoRenewPeriod != null ? this._autoRenewPeriod._toProtobuf() : null,
      fileID: this._bytecodeFileId ? this._bytecodeFileId._toProtobuf() : null,
      memoWrapper: this._contractMemo != null ? {
        value: this._contractMemo
      } : null,
      maxAutomaticTokenAssociations: this._maxAutomaticTokenAssociations != null ? {
        value: this._maxAutomaticTokenAssociations
      } : null,
      stakedAccountId: this.stakedAccountId != null ? this.stakedAccountId._toProtobuf() : null,
      stakedNodeId: this.stakedNodeId,
      declineReward: this.declineStakingRewards != null ? { value: this.declineStakingRewards } : null,
      autoRenewAccountId: this._autoRenewAccountId != null ? this._autoRenewAccountId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `ContractUpdateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "contractUpdateInstance",
  ContractUpdateTransaction._fromProtobuf
);
class CustomFee {
  constructor(t = {}) {
    this._feeCollectorAccountId = null, this._allCollectorsAreExempt = !1, t.feeCollectorAccountId != null && this.setFeeCollectorAccountId(t.feeCollectorAccountId), t.allCollectorsAreExempt != null && this.setAllCollectorsAreExempt(t.allCollectorsAreExempt);
  }
  get feeCollectorAccountId() {
    return this._feeCollectorAccountId;
  }
  setFeeCollectorAccountId(t) {
    return this._feeCollectorAccountId = typeof t == "string" ? AccountId.fromString(t) : t, this;
  }
  get allCollectorsAreExempt() {
    return this._allCollectorsAreExempt;
  }
  setAllCollectorsAreExempt(t) {
    return this._allCollectorsAreExempt = t, this;
  }
  static _fromProtobuf(t) {
    throw new Error("not implemented");
  }
  _toProtobuf() {
    throw new Error("not implemented");
  }
}
class CustomFixedFee extends CustomFee {
  constructor(t = {}) {
    super(t), this._denominatingTokenId = null, t.denominatingTokenId != null && this.setDenominatingTokenId(t.denominatingTokenId), this._amount = null, t.amount != null && this.setAmount(t.amount);
  }
  setHbarAmount(t) {
    return this._amount = t.toTinybars(), this._denominatingTokenId = null, this;
  }
  get hbarAmount() {
    return this._denominatingTokenId != null ? null : Hbar.fromTinybars(this._amount != null ? this._amount : 0);
  }
  setDenominatingTokenToSameToken() {
    return this._denominatingTokenId = new TokenId(0, 0, 0), this;
  }
  get denominatingTokenId() {
    return this._denominatingTokenId;
  }
  setDenominatingTokenId(t) {
    return this._denominatingTokenId = typeof t == "string" ? TokenId.fromString(t) : t, this;
  }
  get amount() {
    return this._amount;
  }
  setAmount(t) {
    return this._amount = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  static _fromProtobuf(t) {
    const a = t.fixedFee;
    return new CustomFixedFee({
      feeCollectorAccountId: t.feeCollectorAccountId != null ? AccountId._fromProtobuf(t.feeCollectorAccountId) : void 0,
      allCollectorsAreExempt: t.allCollectorsAreExempt != null ? t.allCollectorsAreExempt : void 0,
      denominatingTokenId: a.denominatingTokenId != null ? TokenId._fromProtobuf(a.denominatingTokenId) : void 0,
      amount: a.amount != null ? a.amount : void 0
    });
  }
  _toProtobuf() {
    return {
      feeCollectorAccountId: this.feeCollectorAccountId != null ? this.feeCollectorAccountId._toProtobuf() : null,
      allCollectorsAreExempt: this.allCollectorsAreExempt,
      fixedFee: {
        denominatingTokenId: this._denominatingTokenId != null ? this._denominatingTokenId._toProtobuf() : null,
        amount: this._amount
      }
    };
  }
}
class FeeAssessmentMethod {
  constructor(t) {
    this._value = t, Object.freeze(this);
  }
  toString() {
    switch (this) {
      case FeeAssessmentMethod.Inclusive:
        return "INCLUSIVE";
      case FeeAssessmentMethod.Exclusive:
        return "EXCLUSIVE";
      default:
        return `UNKNOWN (${this._value.toString()})`;
    }
  }
  static _fromValue(t) {
    switch (t) {
      case !1:
        return FeeAssessmentMethod.Inclusive;
      case !0:
        return FeeAssessmentMethod.Exclusive;
    }
  }
  valueOf() {
    return this._value;
  }
}
FeeAssessmentMethod.Inclusive = new FeeAssessmentMethod(!1);
FeeAssessmentMethod.Exclusive = new FeeAssessmentMethod(!0);
class CustomFractionalFee extends CustomFee {
  constructor(t = {}) {
    super(t), this._numerator = null, t.numerator != null && this.setNumerator(t.numerator), this._denominator = null, t.denominator != null && this.setDenominator(t.denominator), this._min = null, t.min != null && this.setMin(t.min), this._max, t.max != null && this.setMax(t.max), this._assessmentMethod, t.assessmentMethod != null && this.setAssessmentMethod(t.assessmentMethod);
  }
  get numerator() {
    return this._numerator;
  }
  setNumerator(t) {
    return this._numerator = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  get denominator() {
    return this._denominator;
  }
  setDenominator(t) {
    return this._denominator = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  get min() {
    return this._min;
  }
  setMin(t) {
    return this._min = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  get max() {
    return this._max;
  }
  setMax(t) {
    return this._max = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  get assessmentMethod() {
    return this._assessmentMethod;
  }
  setAssessmentMethod(t) {
    return this._assessmentMethod = t, this;
  }
  static _fromProtobuf(t) {
    const a = t.fractionalFee, d = a.fractionalAmount;
    return new CustomFractionalFee({
      feeCollectorAccountId: t.feeCollectorAccountId != null ? AccountId._fromProtobuf(t.feeCollectorAccountId) : void 0,
      allCollectorsAreExempt: t.allCollectorsAreExempt != null ? t.allCollectorsAreExempt : void 0,
      numerator: d.numerator != null ? d.numerator : void 0,
      denominator: d.denominator != null ? d.denominator : void 0,
      min: a.minimumAmount != null ? a.minimumAmount : void 0,
      max: a.maximumAmount != null ? a.maximumAmount : void 0,
      assessmentMethod: a.netOfTransfers != null ? new FeeAssessmentMethod(a.netOfTransfers) : void 0
    });
  }
  _toProtobuf() {
    return {
      feeCollectorAccountId: this.feeCollectorAccountId != null ? this.feeCollectorAccountId._toProtobuf() : null,
      allCollectorsAreExempt: this.allCollectorsAreExempt,
      fractionalFee: {
        fractionalAmount: {
          numerator: this._numerator,
          denominator: this._denominator
        },
        minimumAmount: this._min,
        maximumAmount: this._max,
        netOfTransfers: this._assessmentMethod != null ? this._assessmentMethod.valueOf() : !1
      }
    };
  }
}
class CustomRoyalyFee extends CustomFee {
  constructor(t = {}) {
    super(t), this._fallbackFee = null, t.fallbackFee != null && this.setFallbackFee(t.fallbackFee), this._numerator = null, t.numerator != null && this.setNumerator(t.numerator), this._denominator = null, t.denominator != null && this.setDenominator(t.denominator);
  }
  get fallbackFee() {
    return this._fallbackFee;
  }
  setFallbackFee(t) {
    return this._fallbackFee = t, this;
  }
  get numerator() {
    return this._numerator;
  }
  setNumerator(t) {
    return this._numerator = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  get denominator() {
    return this._denominator;
  }
  setDenominator(t) {
    return this._denominator = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  static _fromProtobuf(t) {
    const a = t.royaltyFee, d = a.exchangeValueFraction;
    return new CustomRoyalyFee({
      feeCollectorAccountId: t.feeCollectorAccountId != null ? AccountId._fromProtobuf(t.feeCollectorAccountId) : void 0,
      allCollectorsAreExempt: t.allCollectorsAreExempt != null ? t.allCollectorsAreExempt : void 0,
      fallbackFee: a.fallbackFee != null ? CustomFixedFee._fromProtobuf({
        fixedFee: a.fallbackFee
      }) : void 0,
      numerator: d.numerator != null ? d.numerator : void 0,
      denominator: d.denominator != null ? d.denominator : void 0
    });
  }
  _toProtobuf() {
    return {
      feeCollectorAccountId: this.feeCollectorAccountId != null ? this.feeCollectorAccountId._toProtobuf() : null,
      allCollectorsAreExempt: this.allCollectorsAreExempt,
      royaltyFee: {
        exchangeValueFraction: {
          numerator: this._numerator,
          denominator: this._denominator
        },
        fallbackFee: this._fallbackFee != null ? this._fallbackFee._toProtobuf().fixedFee : null
      }
    };
  }
}
class DelegateContractId extends ContractId {
  constructor(t, a, d, l) {
    super(t, a, d, l);
  }
  static fromEvmAddress(t, a, d) {
    return new DelegateContractId(t, a, 0, decode$6(d));
  }
  static fromString(t) {
    return new DelegateContractId(ContractId.fromString(t));
  }
  static _fromProtobuf(t) {
    return new DelegateContractId(ContractId._fromProtobuf(t));
  }
  static fromBytes(t) {
    return new DelegateContractId(ContractId.fromBytes(t));
  }
  static fromSolidityAddress(t) {
    return new DelegateContractId(ContractId.fromSolidityAddress(t));
  }
  clone() {
    const t = new DelegateContractId(this);
    return t._checksum = this._checksum, t;
  }
  _toProtobufKey() {
    return {
      delegatableContractId: this._toProtobuf()
    };
  }
  static __fromProtobufKey(t) {
    return DelegateContractId._fromProtobuf(t);
  }
}
CACHE$1.setDelegateContractId((u) => DelegateContractId.__fromProtobufKey(u));
class EthereumTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._ethereumData = null, this._callDataFileId = null, this._maxGasAllowance = null, t.ethereumData != null && this.setEthereumData(t.ethereumData), t.callData != null && this.setCallDataFileId(t.callData), t.callDataFileId != null && this.setCallDataFileId(t.callDataFileId), t.maxGasAllowance != null && this.setMaxGasAllowanceHbar(t.maxGasAllowance);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].ethereumTransaction;
    return Transaction._fromProtobufTransactions(
      new EthereumTransaction({
        ethereumData: c.ethereumData != null ? c.ethereumData : void 0,
        callData: c.callData != null ? FileId._fromProtobuf(c.callData) : void 0,
        maxGasAllowance: c.maxGasAllowance != null ? Hbar.fromTinybars(c.maxGasAllowance) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get ethereumData() {
    return this._ethereumData;
  }
  setEthereumData(t) {
    return this._requireNotFrozen(), this._ethereumData = t, this;
  }
  get callData() {
    return this.callDataFileId;
  }
  setCallData(t) {
    return this.setCallDataFileId(t);
  }
  get callDataFileId() {
    return this._callDataFileId;
  }
  setCallDataFileId(t) {
    return this._requireNotFrozen(), this._callDataFileId = t, this;
  }
  get maxGasAllowance() {
    return this._maxGasAllowance;
  }
  setMaxGasAllowance(t) {
    return this.setMaxGasAllowanceHbar(t);
  }
  setMaxGasAllowanceHbar(t) {
    return this._requireNotFrozen(), this._maxGasAllowance = t instanceof Hbar ? t : new Hbar(t), this;
  }
  _validateChecksums(t) {
    this._ethereumData != null && this._ethereumData instanceof FileId && this._ethereumData.validateChecksum(t);
  }
  _execute(t, a) {
    return t.smartContract.callEthereum(a);
  }
  _getTransactionDataCase() {
    return "ethereumTransaction";
  }
  _makeTransactionData() {
    return {
      ethereumData: this._ethereumData,
      callData: this._callDataFileId != null ? this._callDataFileId._toProtobuf() : null,
      maxGasAllowance: this._maxGasAllowance != null ? this._maxGasAllowance.toTinybars() : null
    };
  }
  _getLogId() {
    return `EthereumTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "ethereumTransaction",
  EthereumTransaction._fromProtobuf
);
class EthereumTransactionData {
  constructor(t) {
    this.callData = t.callData;
  }
  static fromBytes(t) {
    if (t.length === 0)
      throw new Error("empty bytes");
    return t[0] != 2 ? CACHE$1.ethereumTransactionDataLegacyFromBytes(t) : CACHE$1.ethereumTransactionDataEip1559FromBytes(t);
  }
  toBytes() {
    throw new Error("not implemented");
  }
  toString() {
    throw new Error("not implemented");
  }
  toJSON() {
    throw new Error("not implemented");
  }
}
class EthereumTransactionDataLegacy extends EthereumTransactionData {
  constructor(t) {
    super(t), this.nonce = t.nonce, this.gasPrice = t.gasPrice, this.gasLimit = t.gasLimit, this.to = t.to, this.value = t.value, this.v = t.v, this.r = t.r, this.s = t.s;
  }
  static fromBytes(t) {
    if (t.length === 0)
      throw new Error("empty bytes");
    const a = decode(t);
    if (a.length != 9)
      throw new Error("invalid ethereum transaction data");
    return new EthereumTransactionDataLegacy({
      nonce: decode$6(a[0]),
      gasPrice: decode$6(a[1]),
      gasLimit: decode$6(a[2]),
      to: decode$6(a[3]),
      value: decode$6(a[4]),
      callData: decode$6(a[5]),
      v: decode$6(a[6]),
      r: decode$6(a[7]),
      s: decode$6(a[8])
    });
  }
  toBytes() {
    return decode$6(
      encode([
        this.nonce,
        this.gasPrice,
        this.gasLimit,
        this.to,
        this.value,
        this.callData,
        this.v,
        this.r,
        this.s
      ])
    );
  }
  toString() {
    return JSON.stringify(this.toJSON(), null, 2);
  }
  toJSON() {
    return {
      nonce: encode$4(this.nonce),
      gasPrice: encode$4(this.gasPrice),
      gasLimit: encode$4(this.gasLimit),
      to: encode$4(this.to),
      value: encode$4(this.value),
      callData: encode$4(this.callData),
      v: encode$4(this.v),
      r: encode$4(this.r),
      s: encode$4(this.s)
    };
  }
}
CACHE$1.setEthereumTransactionDataLegacyFromBytes(
  (u) => EthereumTransactionDataLegacy.fromBytes(u)
);
class EthereumTransactionDataEip1559 extends EthereumTransactionData {
  constructor(t) {
    super(t), this.chainId = t.chainId, this.nonce = t.nonce, this.maxPriorityGas = t.maxPriorityGas, this.maxGas = t.maxGas, this.gasLimit = t.gasLimit, this.to = t.to, this.value = t.value, this.accessList = t.accessList, this.recId = t.recId, this.r = t.r, this.s = t.s;
  }
  static fromBytes(t) {
    if (t.length === 0)
      throw new Error("empty bytes");
    const a = decode(t.subarray(1));
    if (!Array.isArray(a))
      throw new Error("ethereum data is not a list");
    if (a.length != 12)
      throw new Error("invalid ethereum transaction data");
    return new EthereumTransactionDataEip1559({
      chainId: decode$6(a[0]),
      nonce: decode$6(a[1]),
      maxPriorityGas: decode$6(a[2]),
      maxGas: decode$6(a[3]),
      gasLimit: decode$6(a[4]),
      to: decode$6(a[5]),
      value: decode$6(a[6]),
      callData: decode$6(a[7]),
      accessList: a[8].map(
        (d) => decode$6(d)
      ),
      recId: decode$6(a[9]),
      r: decode$6(a[10]),
      s: decode$6(a[11])
    });
  }
  toBytes() {
    const t = encode([
      this.chainId,
      this.nonce,
      this.maxPriorityGas,
      this.maxGas,
      this.gasLimit,
      this.to,
      this.value,
      this.callData,
      this.accessList,
      this.recId,
      this.r,
      this.s
    ]);
    return decode$6("02" + t.substring(2));
  }
  toString() {
    return JSON.stringify(this.toJSON(), null, 2);
  }
  toJSON() {
    return {
      chainId: encode$4(this.chainId),
      nonce: encode$4(this.nonce),
      maxPriorityGas: encode$4(this.maxPriorityGas),
      maxGas: encode$4(this.maxGas),
      gasLimit: encode$4(this.gasLimit),
      to: encode$4(this.to),
      value: encode$4(this.value),
      callData: encode$4(this.callData),
      accessList: this.accessList.map((t) => encode$4(t)),
      recId: encode$4(this.recId),
      r: encode$4(this.r),
      s: encode$4(this.s)
    };
  }
}
CACHE$1.setEthereumTransactionDataEip1559FromBytes(
  (u) => EthereumTransactionDataEip1559.fromBytes(u)
);
class FeeDataType {
  constructor(t) {
    this._code = t, Object.freeze(this);
  }
  toString() {
    switch (this) {
      case FeeDataType.Default:
        return "DEFAULT";
      case FeeDataType.TokenFungibleCommon:
        return "TOKEN_FUNGIBLE_COMMON";
      case FeeDataType.TokenNonFungibleUnique:
        return "TOKEN_NON_FUNGIBLE_UNIQUE";
      case FeeDataType.TokenFungibleCommonWithCustomFees:
        return "TOKEN_FUNGIBLE_COMMON_WITH_CUSTOM_FEES";
      case FeeDataType.TokenNonFungibleUniqueWithCustomFees:
        return "TOKEN_NON_FUNGIBLE_UNIQUE_WITH_CUSTOM_FEES";
      case FeeDataType.ScheduleCreateContractCall:
        return "SCHEDULE_CREATE_CONTRACT_CALL";
      default:
        return `UNKNOWN (${this._code})`;
    }
  }
  static _fromCode(t) {
    switch (t) {
      case 0:
        return FeeDataType.Default;
      case 1:
        return FeeDataType.TokenFungibleCommon;
      case 2:
        return FeeDataType.TokenNonFungibleUnique;
      case 3:
        return FeeDataType.TokenFungibleCommonWithCustomFees;
      case 4:
        return FeeDataType.TokenNonFungibleUniqueWithCustomFees;
      case 5:
        return FeeDataType.ScheduleCreateContractCall;
    }
    throw new Error(
      `(BUG) SubType.fromCode() does not handle code: ${t}`
    );
  }
  valueOf() {
    return this._code;
  }
}
FeeDataType.Default = new FeeDataType(0);
FeeDataType.TokenFungibleCommon = new FeeDataType(1);
FeeDataType.TokenNonFungibleUnique = new FeeDataType(2);
FeeDataType.TokenFungibleCommonWithCustomFees = new FeeDataType(3);
FeeDataType.TokenNonFungibleUniqueWithCustomFees = new FeeDataType(4);
FeeDataType.ScheduleCreateContractCall = new FeeDataType(5);
class RequestType {
  constructor(t) {
    this._code = t, Object.freeze(this);
  }
  toString() {
    switch (this) {
      case RequestType.None:
        return "NONE";
      case RequestType.CryptoTransfer:
        return "CryptoTransfer";
      case RequestType.CryptoUpdate:
        return "CryptoUpdate";
      case RequestType.CryptoDelete:
        return "CryptoDelete";
      case RequestType.CryptoAddLiveHash:
        return "CryptoAddLiveHash";
      case RequestType.CryptoDeleteLiveHash:
        return "CryptoDeleteLiveHash";
      case RequestType.ContractCall:
        return "ContractCall";
      case RequestType.ContractCreate:
        return "ContractCreate";
      case RequestType.ContractUpdate:
        return "ContractUpdate";
      case RequestType.FileCreate:
        return "FileCreate";
      case RequestType.FileAppend:
        return "FileAppend";
      case RequestType.FileUpdate:
        return "FileUpdate";
      case RequestType.FileDelete:
        return "FileDelete";
      case RequestType.CryptoGetAccountBalance:
        return "CryptoGetAccountBalance";
      case RequestType.CryptoGetAccountRecords:
        return "CryptoGetAccountRecords";
      case RequestType.CryptoGetInfo:
        return "CryptoGetInfo";
      case RequestType.ContractCallLocal:
        return "ContractCallLocal";
      case RequestType.ContractGetInfo:
        return "ContractGetInfo";
      case RequestType.ContractGetBytecode:
        return "ContractGetBytecode";
      case RequestType.GetBySolidityID:
        return "GetBySolidityID";
      case RequestType.GetByKey:
        return "GetByKey";
      case RequestType.CryptoGetLiveHash:
        return "CryptoGetLiveHash";
      case RequestType.CryptoGetStakers:
        return "CryptoGetStakers";
      case RequestType.FileGetContents:
        return "FileGetContents";
      case RequestType.FileGetInfo:
        return "FileGetInfo";
      case RequestType.TransactionGetRecord:
        return "TransactionGetRecord";
      case RequestType.ContractGetRecords:
        return "ContractGetRecords";
      case RequestType.CryptoCreate:
        return "CryptoCreate";
      case RequestType.SystemDelete:
        return "SystemDelete";
      case RequestType.SystemUndelete:
        return "SystemUndelete";
      case RequestType.ContractDelete:
        return "ContractDelete";
      case RequestType.Freeze:
        return "Freeze";
      case RequestType.CreateTransactionRecord:
        return "CreateTransactionRecord";
      case RequestType.CryptoAccountAutoRenew:
        return "CryptoAccountAutoRenew";
      case RequestType.ContractAutoRenew:
        return "ContractAutoRenew";
      case RequestType.GetVersionInfo:
        return "GetVersionInfo";
      case RequestType.TransactionGetReceipt:
        return "TransactionGetReceipt";
      case RequestType.ConsensusCreateTopic:
        return "ConsensusCreateTopic";
      case RequestType.ConsensusUpdateTopic:
        return "ConsensusUpdateTopic";
      case RequestType.ConsensusDeleteTopic:
        return "ConsensusDeleteTopic";
      case RequestType.ConsensusGetTopicInfo:
        return "ConsensusGetTopicInfo";
      case RequestType.ConsensusSubmitMessage:
        return "ConsensusSubmitMessage";
      case RequestType.UncheckedSubmit:
        return "UncheckedSubmit";
      case RequestType.TokenCreate:
        return "TokenCreate";
      case RequestType.TokenGetInfo:
        return "TokenGetInfo";
      case RequestType.TokenFreezeAccount:
        return "TokenFreezeAccount";
      case RequestType.TokenUnfreezeAccount:
        return "TokenUnfreezeAccount";
      case RequestType.TokenGrantKycToAccount:
        return "TokenGrantKycToAccount";
      case RequestType.TokenRevokeKycFromAccount:
        return "TokenRevokeKycFromAccount";
      case RequestType.TokenDelete:
        return "TokenDelete";
      case RequestType.TokenUpdate:
        return "TokenUpdate";
      case RequestType.TokenMint:
        return "TokenMint";
      case RequestType.TokenBurn:
        return "TokenBurn";
      case RequestType.TokenAccountWipe:
        return "TokenAccountWipe";
      case RequestType.TokenAssociateToAccount:
        return "TokenAssociateToAccount";
      case RequestType.TokenDissociateFromAccount:
        return "TokenDissociateFromAccount";
      case RequestType.ScheduleCreate:
        return "ScheduleCreate";
      case RequestType.ScheduleDelete:
        return "ScheduleDelete";
      case RequestType.ScheduleSign:
        return "ScheduleSign";
      case RequestType.ScheduleGetInfo:
        return "ScheduleGetInfo";
      case RequestType.TokenGetAccountNftInfos:
        return "TokenGetAccountNftInfos";
      case RequestType.TokenGetNftInfo:
        return "TokenGetNftInfo";
      case RequestType.TokenGetNftInfos:
        return "TokenGetNftInfos";
      case RequestType.TokenFeeScheduleUpdate:
        return "TokenFeeScheduleUpdate";
      case RequestType.NetworkGetExecutionTime:
        return "NetworkGetExecutionTime";
      case RequestType.TokenPause:
        return "TokenPause";
      case RequestType.TokenUnpause:
        return "TokenUnpause";
      case RequestType.CryptoApproveAllowance:
        return "CryptoApproveAllowance";
      case RequestType.CryptoDeleteAllowance:
        return "CryptoDeleteAllowance";
      case RequestType.GetAccountDetails:
        return "GetAccountDetails";
      case RequestType.EthereumTransaction:
        return "EthereumTransaction";
      case RequestType.NodeStakeUpdate:
        return "NodeStakeUpdate";
      case RequestType.Prng:
        return "UtilPrng";
      default:
        return `UNKNOWN (${this._code})`;
    }
  }
  static _fromCode(t) {
    switch (t) {
      case 0:
        return RequestType.None;
      case 1:
        return RequestType.CryptoTransfer;
      case 2:
        return RequestType.CryptoUpdate;
      case 3:
        return RequestType.CryptoDelete;
      case 4:
        return RequestType.CryptoAddLiveHash;
      case 5:
        return RequestType.CryptoDeleteLiveHash;
      case 6:
        return RequestType.ContractCall;
      case 7:
        return RequestType.ContractCreate;
      case 8:
        return RequestType.ContractUpdate;
      case 9:
        return RequestType.FileCreate;
      case 10:
        return RequestType.FileAppend;
      case 11:
        return RequestType.FileUpdate;
      case 12:
        return RequestType.FileDelete;
      case 13:
        return RequestType.CryptoGetAccountBalance;
      case 14:
        return RequestType.CryptoGetAccountRecords;
      case 15:
        return RequestType.CryptoGetInfo;
      case 16:
        return RequestType.ContractCallLocal;
      case 17:
        return RequestType.ContractGetInfo;
      case 18:
        return RequestType.ContractGetBytecode;
      case 19:
        return RequestType.GetBySolidityID;
      case 20:
        return RequestType.GetByKey;
      case 21:
        return RequestType.CryptoGetLiveHash;
      case 22:
        return RequestType.CryptoGetStakers;
      case 23:
        return RequestType.FileGetContents;
      case 24:
        return RequestType.FileGetInfo;
      case 25:
        return RequestType.TransactionGetRecord;
      case 26:
        return RequestType.ContractGetRecords;
      case 27:
        return RequestType.CryptoCreate;
      case 28:
        return RequestType.SystemDelete;
      case 29:
        return RequestType.SystemUndelete;
      case 30:
        return RequestType.ContractDelete;
      case 31:
        return RequestType.Freeze;
      case 32:
        return RequestType.CreateTransactionRecord;
      case 33:
        return RequestType.CryptoAccountAutoRenew;
      case 34:
        return RequestType.ContractAutoRenew;
      case 35:
        return RequestType.GetVersionInfo;
      case 36:
        return RequestType.TransactionGetReceipt;
      case 50:
        return RequestType.ConsensusCreateTopic;
      case 51:
        return RequestType.ConsensusUpdateTopic;
      case 52:
        return RequestType.ConsensusDeleteTopic;
      case 53:
        return RequestType.ConsensusGetTopicInfo;
      case 54:
        return RequestType.ConsensusSubmitMessage;
      case 55:
        return RequestType.UncheckedSubmit;
      case 56:
        return RequestType.TokenCreate;
      case 58:
        return RequestType.TokenGetInfo;
      case 59:
        return RequestType.TokenFreezeAccount;
      case 60:
        return RequestType.TokenUnfreezeAccount;
      case 61:
        return RequestType.TokenGrantKycToAccount;
      case 62:
        return RequestType.TokenRevokeKycFromAccount;
      case 63:
        return RequestType.TokenDelete;
      case 64:
        return RequestType.TokenUpdate;
      case 65:
        return RequestType.TokenMint;
      case 66:
        return RequestType.TokenBurn;
      case 67:
        return RequestType.TokenAccountWipe;
      case 68:
        return RequestType.TokenAssociateToAccount;
      case 69:
        return RequestType.TokenDissociateFromAccount;
      case 70:
        return RequestType.ScheduleCreate;
      case 71:
        return RequestType.ScheduleDelete;
      case 72:
        return RequestType.ScheduleSign;
      case 73:
        return RequestType.ScheduleGetInfo;
      case 74:
        return RequestType.TokenGetAccountNftInfos;
      case 75:
        return RequestType.TokenGetNftInfo;
      case 76:
        return RequestType.TokenGetNftInfos;
      case 77:
        return RequestType.TokenFeeScheduleUpdate;
      case 78:
        return RequestType.NetworkGetExecutionTime;
      case 79:
        return RequestType.TokenPause;
      case 80:
        return RequestType.TokenUnpause;
      case 81:
        return RequestType.CryptoApproveAllowance;
      case 82:
        return RequestType.CryptoDeleteAllowance;
      case 83:
        return RequestType.GetAccountDetails;
      case 84:
        return RequestType.EthereumTransaction;
      case 85:
        return RequestType.NodeStakeUpdate;
      case 86:
        return RequestType.Prng;
    }
    throw new Error(
      `(BUG) RequestType.fromCode() does not handle code: ${t}`
    );
  }
  valueOf() {
    return this._code;
  }
}
RequestType.None = new RequestType(0);
RequestType.CryptoTransfer = new RequestType(1);
RequestType.CryptoUpdate = new RequestType(2);
RequestType.CryptoDelete = new RequestType(3);
RequestType.CryptoAddLiveHash = new RequestType(4);
RequestType.CryptoDeleteLiveHash = new RequestType(5);
RequestType.ContractCall = new RequestType(6);
RequestType.ContractCreate = new RequestType(7);
RequestType.ContractUpdate = new RequestType(8);
RequestType.FileCreate = new RequestType(9);
RequestType.FileAppend = new RequestType(10);
RequestType.FileUpdate = new RequestType(11);
RequestType.FileDelete = new RequestType(12);
RequestType.CryptoGetAccountBalance = new RequestType(13);
RequestType.CryptoGetAccountRecords = new RequestType(14);
RequestType.CryptoGetInfo = new RequestType(15);
RequestType.ContractCallLocal = new RequestType(16);
RequestType.ContractGetInfo = new RequestType(17);
RequestType.ContractGetBytecode = new RequestType(18);
RequestType.GetBySolidityID = new RequestType(19);
RequestType.GetByKey = new RequestType(20);
RequestType.CryptoGetLiveHash = new RequestType(21);
RequestType.CryptoGetStakers = new RequestType(22);
RequestType.FileGetContents = new RequestType(23);
RequestType.FileGetInfo = new RequestType(24);
RequestType.TransactionGetRecord = new RequestType(25);
RequestType.ContractGetRecords = new RequestType(26);
RequestType.CryptoCreate = new RequestType(27);
RequestType.SystemDelete = new RequestType(28);
RequestType.SystemUndelete = new RequestType(29);
RequestType.ContractDelete = new RequestType(30);
RequestType.Freeze = new RequestType(31);
RequestType.CreateTransactionRecord = new RequestType(32);
RequestType.CryptoAccountAutoRenew = new RequestType(33);
RequestType.ContractAutoRenew = new RequestType(34);
RequestType.GetVersionInfo = new RequestType(35);
RequestType.TransactionGetReceipt = new RequestType(36);
RequestType.ConsensusCreateTopic = new RequestType(50);
RequestType.ConsensusUpdateTopic = new RequestType(51);
RequestType.ConsensusDeleteTopic = new RequestType(52);
RequestType.ConsensusGetTopicInfo = new RequestType(53);
RequestType.ConsensusSubmitMessage = new RequestType(54);
RequestType.UncheckedSubmit = new RequestType(55);
RequestType.TokenCreate = new RequestType(56);
RequestType.TokenGetInfo = new RequestType(58);
RequestType.TokenFreezeAccount = new RequestType(59);
RequestType.TokenUnfreezeAccount = new RequestType(60);
RequestType.TokenGrantKycToAccount = new RequestType(61);
RequestType.TokenRevokeKycFromAccount = new RequestType(62);
RequestType.TokenDelete = new RequestType(63);
RequestType.TokenUpdate = new RequestType(64);
RequestType.TokenMint = new RequestType(65);
RequestType.TokenBurn = new RequestType(66);
RequestType.TokenAccountWipe = new RequestType(67);
RequestType.TokenAssociateToAccount = new RequestType(68);
RequestType.TokenDissociateFromAccount = new RequestType(69);
RequestType.ScheduleCreate = new RequestType(70);
RequestType.ScheduleDelete = new RequestType(71);
RequestType.ScheduleSign = new RequestType(72);
RequestType.ScheduleGetInfo = new RequestType(73);
RequestType.TokenGetAccountNftInfos = new RequestType(74);
RequestType.TokenGetNftInfo = new RequestType(75);
RequestType.TokenGetNftInfos = new RequestType(76);
RequestType.TokenFeeScheduleUpdate = new RequestType(77);
RequestType.NetworkGetExecutionTime = new RequestType(78);
RequestType.TokenPause = new RequestType(79);
RequestType.TokenUnpause = new RequestType(80);
RequestType.CryptoApproveAllowance = new RequestType(81);
RequestType.CryptoDeleteAllowance = new RequestType(82);
RequestType.GetAccountDetails = new RequestType(83);
RequestType.EthereumTransaction = new RequestType(84);
RequestType.NodeStakeUpdate = new RequestType(85);
RequestType.Prng = new RequestType(86);
class FileContentsQuery extends Query {
  constructor(t = {}) {
    super(), this._fileId = null, t.fileId != null && this.setFileId(t.fileId);
  }
  static _fromProtobuf(t) {
    const a = t.fileGetContents;
    return new FileContentsQuery({
      fileId: a.fileID != null ? FileId._fromProtobuf(a.fileID) : void 0
    });
  }
  _validateChecksums(t) {
    this._fileId != null && this._fileId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.file.getFileContent(a);
  }
  get fileId() {
    return this._fileId;
  }
  setFileId(t) {
    return this._fileId = typeof t == "string" ? FileId.fromString(t) : t.clone(), this;
  }
  _mapResponseHeader(t) {
    return t.fileGetContents.header;
  }
  _mapResponse(t) {
    const l = t.fileGetContents.fileContents.contents;
    return Promise.resolve(l);
  }
  _onMakeRequest(t) {
    return {
      fileGetContents: {
        header: t,
        fileID: this._fileId != null ? this._fileId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `FileContentsQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set("fileGetContents", FileContentsQuery._fromProtobuf);
const { proto: proto$1 } = HashgraphProto;
class FileInfo {
  constructor(t) {
    this.fileId = t.fileId, this.size = t.size, this.expirationTime = t.expirationTime, this.isDeleted = t.isDeleted, this.keys = t.keys, this.fileMemo = t.fileMemo, this.ledgerId = t.ledgerId, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    const a = t.size;
    return new FileInfo({
      fileId: FileId._fromProtobuf(
        t.fileID
      ),
      size: a instanceof long ? a : long.fromValue(a),
      expirationTime: Timestamp._fromProtobuf(
        t.expirationTime
      ),
      isDeleted: t.deleted,
      keys: t.keys != null ? KeyList.__fromProtobufKeyList(t.keys) : new KeyList(),
      fileMemo: t.memo != null ? t.memo : "",
      ledgerId: t.ledgerId != null ? LedgerId.fromBytes(t.ledgerId) : null
    });
  }
  _toProtobuf() {
    return {
      fileID: this.fileId._toProtobuf(),
      size: this.size,
      expirationTime: this.expirationTime._toProtobuf(),
      deleted: this.isDeleted,
      keys: this.keys._toProtobufKey().keyList,
      memo: this.fileMemo,
      ledgerId: this.ledgerId != null ? this.ledgerId.toBytes() : null
    };
  }
  static fromBytes(t) {
    return FileInfo._fromProtobuf(
      lib.proto.FileGetInfoResponse.FileInfo.decode(t)
    );
  }
  toBytes() {
    return proto$1.FileGetInfoResponse.FileInfo.encode(
      this._toProtobuf()
    ).finish();
  }
}
class FileInfoQuery extends Query {
  constructor(t = {}) {
    super(), this._fileId = null, t.fileId != null && this.setFileId(t.fileId);
  }
  static _fromProtobuf(t) {
    const a = t.fileGetInfo;
    return new FileInfoQuery({
      fileId: a.fileID != null ? FileId._fromProtobuf(a.fileID) : void 0
    });
  }
  get fileId() {
    return this._fileId;
  }
  setFileId(t) {
    return this._fileId = typeof t == "string" ? FileId.fromString(t) : t.clone(), this;
  }
  async getCost(t) {
    return super.getCost(t);
  }
  _validateChecksums(t) {
    this._fileId != null && this._fileId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.file.getFileInfo(a);
  }
  _mapResponseHeader(t) {
    return t.fileGetInfo.header;
  }
  _mapResponse(t, a, d) {
    const l = t.fileGetInfo;
    return Promise.resolve(
      FileInfo._fromProtobuf(
        l.fileInfo
      )
    );
  }
  _onMakeRequest(t) {
    return {
      fileGetInfo: {
        header: t,
        fileID: this._fileId != null ? this._fileId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `FileInfoQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set("fileGetInfo", FileInfoQuery._fromProtobuf);
class FileUpdateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._fileId = null, this._keys = null, this._expirationTime = null, this._contents = null, this._fileMemo = null, t.fileId != null && this.setFileId(t.fileId), t.keys != null && this.setKeys(t.keys), t.expirationTime != null && this.setExpirationTime(t.expirationTime), t.contents != null && this.setContents(t.contents), t.fileMemo != null && this.setFileMemo(t.fileMemo);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].fileUpdate;
    return Transaction._fromProtobufTransactions(
      new FileUpdateTransaction({
        fileId: c.fileID != null ? FileId._fromProtobuf(c.fileID) : void 0,
        keys: c.keys != null && c.keys.keys != null ? c.keys.keys.map(
          (x) => Key._fromProtobufKey(x)
        ) : void 0,
        expirationTime: c.expirationTime != null ? Timestamp._fromProtobuf(c.expirationTime) : void 0,
        contents: c.contents != null ? c.contents : void 0,
        fileMemo: c.memo != null && c.memo.value != null ? c.memo.value : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get fileId() {
    return this._fileId;
  }
  setFileId(t) {
    return this._requireNotFrozen(), this._fileId = typeof t == "string" ? FileId.fromString(t) : t.clone(), this;
  }
  get keys() {
    return this._keys;
  }
  setKeys(t) {
    if (this._requireNotFrozen(), t instanceof KeyList && t.threshold != null)
      throw new Error("Cannot set threshold key as file key");
    return this._keys = t instanceof KeyList ? t.toArray() : t, this;
  }
  get expirationTime() {
    return this._expirationTime;
  }
  setExpirationTime(t) {
    return this._requireNotFrozen(), this._expirationTime = t instanceof Timestamp ? t : Timestamp.fromDate(t), this;
  }
  get contents() {
    return this._contents;
  }
  setContents(t) {
    return this._requireNotFrozen(), this._contents = t instanceof Uint8Array ? t : encode$1(t), this;
  }
  get fileMemo() {
    return this._fileMemo;
  }
  setFileMemo(t) {
    return this._requireNotFrozen(), this._fileMemo = t, this;
  }
  clearFileMemo() {
    return this._requireNotFrozen(), this._fileMemo = null, this;
  }
  _validateChecksums(t) {
    this._fileId != null && this._fileId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.file.updateFile(a);
  }
  _getTransactionDataCase() {
    return "fileUpdate";
  }
  _makeTransactionData() {
    return {
      fileID: this._fileId != null ? this._fileId._toProtobuf() : null,
      keys: this._keys != null ? {
        keys: this._keys.map((t) => t._toProtobufKey())
      } : null,
      expirationTime: this._expirationTime != null ? this._expirationTime._toProtobuf() : null,
      contents: this._contents,
      memo: this._fileMemo != null ? {
        value: this._fileMemo
      } : null
    };
  }
  _getLogId() {
    return `FileUpdateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set("fileUpdate", FileUpdateTransaction._fromProtobuf);
class FreezeType {
  constructor(t) {
    this._code = t, Object.freeze(this);
  }
  toString() {
    switch (this) {
      case FreezeType.UnknownFreezeType:
        return "UNKNOWN_FREEZE_TYPE";
      case FreezeType.FreezeOnly:
        return "FREEZE_ONLY";
      case FreezeType.PrepareUpgrade:
        return "PREPARE_UPGRADE";
      case FreezeType.FreezeUpgrade:
        return "FREEZE_UPGRADE";
      case FreezeType.FreezeAbort:
        return "FREEZE_ABORT";
      case FreezeType.TelemetryUpgrade:
        return "TELEMETRY_UPGRADE";
      default:
        return `UNKNOWN (${this._code})`;
    }
  }
  static _fromCode(t) {
    switch (t) {
      case 0:
        return FreezeType.UnknownFreezeType;
      case 1:
        return FreezeType.FreezeOnly;
      case 2:
        return FreezeType.PrepareUpgrade;
      case 3:
        return FreezeType.FreezeUpgrade;
      case 4:
        return FreezeType.FreezeAbort;
      case 5:
        return FreezeType.TelemetryUpgrade;
      default:
        throw new Error(
          `(BUG) Status.fromCode() does not handle code: ${t}`
        );
    }
  }
  valueOf() {
    return this._code;
  }
}
FreezeType.UnknownFreezeType = new FreezeType(0);
FreezeType.FreezeOnly = new FreezeType(1);
FreezeType.PrepareUpgrade = new FreezeType(2);
FreezeType.FreezeUpgrade = new FreezeType(3);
FreezeType.FreezeAbort = new FreezeType(4);
FreezeType.TelemetryUpgrade = new FreezeType(5);
class FreezeTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._startTime = null, this._startTimestamp = null, this._endTime = null, this._fileId = null, this._fileHash = null, this._freezeType = null, t.startTime != null && this.setStartTime(t.startTime.hour, t.startTime.minute), t.endTime != null && this.setEndTime(t.endTime.hour, t.endTime.minute), t.startTimestamp != null && this.setStartTimestamp(t.startTimestamp), t.updateFileId != null && this.setUpdateFileId(t.updateFileId), t.fileId != null && this.setFileId(t.fileId), t.fileHash != null && this.setFileHash(t.fileHash), t.freezeType != null && this.setFreezeType(t.freezeType);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].freeze;
    return Transaction._fromProtobufTransactions(
      new FreezeTransaction({
        startTime: c.startHour != null && c.startMin != null ? {
          hour: c.startHour,
          minute: c.startMin
        } : void 0,
        endTime: c.endHour != null && c.endMin != null ? {
          hour: c.endHour,
          minute: c.endMin
        } : void 0,
        startTimestamp: c.startTime != null ? Timestamp._fromProtobuf(c.startTime) : void 0,
        updateFileId: c.updateFile != null ? FileId._fromProtobuf(c.updateFile) : void 0,
        fileHash: c.fileHash != null ? c.fileHash : void 0,
        freezeType: c.freezeType != null ? FreezeType._fromCode(c.freezeType) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get startTime() {
    return null;
  }
  setStartTime(t, a) {
    if (this._requireNotFrozen(), typeof t == "string") {
      const d = t.split(":");
      this._startTime = {
        hour: Number(d[0]),
        minute: Number(d[1])
      };
    } else
      this._startTime = {
        hour: t,
        minute: a
      };
    return this;
  }
  get startTimestamp() {
    return this._startTimestamp;
  }
  setStartTimestamp(t) {
    return this._requireNotFrozen(), this._startTimestamp = t, this;
  }
  get endTime() {
    return console.warn("`FreezeTransaction.endTime` is deprecated"), this._endTime;
  }
  setEndTime(t, a) {
    if (console.warn("`FreezeTransaction.endTime` is deprecated"), this._requireNotFrozen(), typeof t == "string") {
      const d = t.split(":");
      this._endTime = {
        hour: Number(d[0]),
        minute: Number(d[1])
      };
    } else
      this._endTime = {
        hour: t,
        minute: a
      };
    return this;
  }
  get updateFileId() {
    return this.fileId;
  }
  setUpdateFileId(t) {
    return this.setFileId(t);
  }
  get fileId() {
    return this._fileId;
  }
  setFileId(t) {
    return this._requireNotFrozen(), this._fileId = t, this;
  }
  get fileHash() {
    return this._fileHash;
  }
  setFileHash(t) {
    return this._requireNotFrozen(), this._fileHash = typeof t == "string" ? decode$6(t) : t, this;
  }
  get freezeType() {
    return this._freezeType;
  }
  setFreezeType(t) {
    return this._requireNotFrozen(), this._freezeType = t, this;
  }
  _getTransactionDataCase() {
    return "freeze";
  }
  _makeTransactionData() {
    return {
      startTime: this._startTimestamp != null ? this._startTimestamp._toProtobuf() : null,
      updateFile: this._fileId != null ? this._fileId._toProtobuf() : null,
      fileHash: this._fileHash,
      freezeType: this._freezeType != null ? this._freezeType.valueOf() : null
    };
  }
  _getLogId() {
    return `FreezeTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set("freeze", FreezeTransaction._fromProtobuf);
class LiveHashAddTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._hash = null, this._keys = null, this._duration = null, this._accountId = null, t.hash != null && this.setHash(t.hash), t.keys != null && this.setKeys(t.keys), t.duration != null && this.setDuration(t.duration), t.accountId != null && this.setAccountId(t.accountId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const x = h[0].cryptoAddLiveHash.liveHash;
    return Transaction._fromProtobufTransactions(
      new LiveHashAddTransaction({
        hash: x.hash != null ? x.hash : void 0,
        keys: x.keys != null && x.keys.keys != null ? x.keys.keys.map(
          (R) => Key._fromProtobufKey(R)
        ) : void 0,
        duration: x.duration != null && x.duration.seconds != null ? x.duration.seconds : void 0,
        accountId: x.accountId != null ? AccountId._fromProtobuf(x.accountId) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get hash() {
    return this._hash;
  }
  setHash(t) {
    return this._requireNotFrozen(), this._hash = t, this;
  }
  get keys() {
    return this._keys;
  }
  setKeys(t) {
    return this._requireNotFrozen(), this._keys = t instanceof KeyList ? t.toArray() : t, this;
  }
  get duration() {
    return this._duration;
  }
  setDuration(t) {
    return this._requireNotFrozen(), this._duration = t instanceof Duration ? t : new Duration(t), this;
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._requireNotFrozen(), this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._accountId != null && this._accountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.crypto.addLiveHash(a);
  }
  _getTransactionDataCase() {
    return "cryptoAddLiveHash";
  }
  _makeTransactionData() {
    return {
      liveHash: {
        hash: this._hash,
        keys: this._keys != null ? {
          keys: this._keys.map(
            (t) => t._toProtobufKey()
          )
        } : void 0,
        duration: this._duration != null ? this._duration._toProtobuf() : null,
        accountId: this._accountId != null ? this._accountId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `LiveHashAddTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "cryptoAddLiveHash",
  LiveHashAddTransaction._fromProtobuf
);
class LiveHashDeleteTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._hash = null, this._accountId = null, t.hash != null && this.setHash(t.hash), t.accountId != null && this.setAccountId(t.accountId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].cryptoDeleteLiveHash;
    return Transaction._fromProtobufTransactions(
      new LiveHashDeleteTransaction({
        hash: c.liveHashToDelete != null ? c.liveHashToDelete : void 0,
        accountId: c.accountOfLiveHash != null ? AccountId._fromProtobuf(c.accountOfLiveHash) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get hash() {
    return this._hash;
  }
  setHash(t) {
    return this._requireNotFrozen(), this._hash = t, this;
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._requireNotFrozen(), this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._accountId != null && this._accountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.crypto.deleteLiveHash(a);
  }
  _getTransactionDataCase() {
    return "cryptoDeleteLiveHash";
  }
  _makeTransactionData() {
    return {
      liveHashToDelete: this._hash,
      accountOfLiveHash: this._accountId != null ? this._accountId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `LiveHashDeleteTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "cryptoDeleteLiveHash",
  LiveHashDeleteTransaction._fromProtobuf
);
class LiveHashQuery extends Query {
  constructor(t = {}) {
    super(), this._accountId = null, t.accountId != null && this.setAccountId(t.accountId), this._hash = null, t.hash != null && this.setHash(t.hash);
  }
  static _fromProtobuf(t) {
    const a = t.cryptoGetLiveHash;
    return new LiveHashQuery({
      accountId: a.accountID != null ? AccountId._fromProtobuf(a.accountID) : void 0,
      hash: a.hash != null ? a.hash : void 0
    });
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._accountId = t instanceof AccountId ? t : AccountId.fromString(t), this;
  }
  get liveHash() {
    return this._hash;
  }
  setHash(t) {
    return this._hash = t, this;
  }
  _validateChecksums(t) {
    this._accountId != null && this._accountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.crypto.getLiveHash(a);
  }
  _mapResponseHeader(t) {
    return t.cryptoGetLiveHash.header;
  }
  _mapResponse(t) {
    const a = t.cryptoGetLiveHash;
    return Promise.resolve(
      LiveHash._fromProtobuf(
        a.liveHash
      )
    );
  }
  _onMakeRequest(t) {
    return {
      cryptoGetLiveHash: {
        header: t,
        accountID: this._accountId != null ? this._accountId._toProtobuf() : null,
        hash: this._hash
      }
    };
  }
  _getLogId() {
    return `LiveHashQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set("cryptoGetLiveHash", LiveHashQuery._fromProtobuf);
class SemanticVersion {
  constructor(t) {
    this.major = t.major, this.minor = t.minor, this.patch = t.patch, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    return new SemanticVersion({
      major: t.major,
      minor: t.minor,
      patch: t.patch
    });
  }
  _toProtobuf() {
    return {
      major: this.major,
      minor: this.minor,
      patch: this.patch
    };
  }
  static fromBytes(t) {
    return SemanticVersion._fromProtobuf(
      lib.proto.SemanticVersion.decode(t)
    );
  }
  toBytes() {
    return lib.proto.SemanticVersion.encode(
      this._toProtobuf()
    ).finish();
  }
}
class NetworkVersionInfo {
  constructor(t) {
    this.protobufVersion = t.protobufVersion, this.servicesVesion = t.servicesVesion, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    return new NetworkVersionInfo({
      protobufVersion: SemanticVersion._fromProtobuf(
        t.hapiProtoVersion
      ),
      servicesVesion: SemanticVersion._fromProtobuf(
        t.hederaServicesVersion
      )
    });
  }
  _toProtobuf() {
    return {
      hapiProtoVersion: this.protobufVersion._toProtobuf(),
      hederaServicesVersion: this.servicesVesion._toProtobuf()
    };
  }
  static fromBytes(t) {
    return NetworkVersionInfo._fromProtobuf(
      lib.proto.NetworkGetVersionInfoResponse.decode(t)
    );
  }
  toBytes() {
    return lib.proto.NetworkGetVersionInfoResponse.encode(
      this._toProtobuf()
    ).finish();
  }
}
class NetworkVersionInfoQuery extends Query {
  constructor() {
    super();
  }
  static _fromProtobuf(t) {
    return new NetworkVersionInfoQuery();
  }
  _execute(t, a) {
    return t.network.getVersionInfo(a);
  }
  _mapResponseHeader(t) {
    return t.networkGetVersionInfo.header;
  }
  _mapResponse(t) {
    const a = t.networkGetVersionInfo;
    return Promise.resolve(NetworkVersionInfo._fromProtobuf(a));
  }
  _onMakeRequest(t) {
    return {
      networkGetVersionInfo: {
        header: t
      }
    };
  }
  _getLogId() {
    return `NetworkVersionInfoQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set(
  "networkGetVersionInfo",
  NetworkVersionInfoQuery._fromProtobuf
);
class PrngTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._range = null, t.range != null && this.setRange(t.range);
  }
  setRange(t) {
    return this._range = t, this;
  }
  get range() {
    return this._range;
  }
  _validateChecksums(t) {
    this._range != null && isNumber(this._range) && this._validateChecksums(t);
  }
  _execute(t, a) {
    return t.util.prng(a);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].utilPrng;
    return Transaction._fromProtobufTransactions(
      new PrngTransaction({
        range: c.range
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  _getTransactionDataCase() {
    return "utilPrng";
  }
  _makeTransactionData() {
    return {
      range: this.range
    };
  }
  _getLogId() {
    return `RandomGenerate:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "utilPrng",
  PrngTransaction._fromProtobuf
);
class ScheduleCreateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._adminKey = null, this._scheduledTransaction = null, this._payerAccountId = null, this._scheduleMemo = null, this._scheduledSignerPublicKeys = /* @__PURE__ */ new Set(), this._expirationTime = null, this._waitForExpiry = null, t.adminKey != null && this.setAdminKey(t.adminKey), t.payerAccountID != null && this.setPayerAccountId(t.payerAccountID), t.scheduleMemo != null && this.setScheduleMemo(t.scheduleMemo), this._defaultMaxTransactionFee = new Hbar(5);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const g = h[0], c = g.scheduleCreate, x = new ScheduleCreateTransaction({
      adminKey: c.adminKey != null ? Key._fromProtobufKey(c.adminKey) : void 0,
      payerAccountID: c.payerAccountID != null ? AccountId._fromProtobuf(
        c.payerAccountID
      ) : void 0,
      scheduleMemo: c.memo != null ? c.memo : void 0,
      waitForExpiry: c.waitForExpiry != null ? c.waitForExpiry : void 0,
      expirationTime: c.expirationTime != null ? Timestamp._fromProtobuf(c.expirationTime) : void 0
    });
    if (g.scheduleCreate != null) {
      const R = g.scheduleCreate.scheduledTransactionBody, B = lib.proto.TransactionBody.encode(
        R
      ).finish(), o = {
        signedTransactionBytes: lib.proto.SignedTransaction.encode({
          bodyBytes: B
        }).finish()
      }, e = lib.proto.TransactionList.encode({
        transactionList: [o]
      }).finish(), n = Transaction.fromBytes(e);
      x._setScheduledTransaction(
        n
      );
    }
    return Transaction._fromProtobufTransactions(
      x,
      t,
      a,
      d,
      l,
      h
    );
  }
  _setScheduledTransaction(t) {
    return this._scheduledTransaction = t, this;
  }
  get adminKey() {
    return this._adminKey;
  }
  setAdminKey(t) {
    return this._requireNotFrozen(), this._adminKey = t, this;
  }
  get payerAccountId() {
    return this._payerAccountId;
  }
  setPayerAccountId(t) {
    return this._requireNotFrozen(), this._payerAccountId = t, this;
  }
  setScheduleMemo(t) {
    return this._requireNotFrozen(), this._scheduleMemo = t, this;
  }
  get getScheduleMemo() {
    return this._requireNotFrozen(), this._scheduleMemo;
  }
  setScheduledTransaction(t) {
    return this._requireNotFrozen(), t._requireNotFrozen(), this._scheduledTransaction = t.schedule()._scheduledTransaction, this;
  }
  _validateChecksums(t) {
    this._payerAccountId != null && this._payerAccountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.schedule.createSchedule(a);
  }
  _getTransactionDataCase() {
    return "scheduleCreate";
  }
  _makeTransactionData() {
    return {
      adminKey: this._adminKey != null ? this._adminKey._toProtobufKey() : null,
      payerAccountID: this._payerAccountId != null ? this._payerAccountId._toProtobuf() : null,
      scheduledTransactionBody: this._scheduledTransaction != null ? this._scheduledTransaction._getScheduledTransactionBody() : null,
      memo: this._scheduleMemo,
      waitForExpiry: this._waitForExpiry,
      expirationTime: this._expirationTime != null ? this._expirationTime._toProtobuf() : null
    };
  }
  _getLogId() {
    return `ScheduleCreateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
  setExpirationTime(t) {
    return this._expirationTime = t, this;
  }
  get expirationTime() {
    return this._requireNotFrozen(), this._expirationTime;
  }
  setWaitForExpiry(t) {
    return this._waitForExpiry = t, this;
  }
  get waitForExpiry() {
    return this._requireNotFrozen(), this._waitForExpiry;
  }
}
TRANSACTION_REGISTRY.set(
  "scheduleCreate",
  ScheduleCreateTransaction._fromProtobuf
);
SCHEDULE_CREATE_TRANSACTION.push(() => new ScheduleCreateTransaction());
class ScheduleDeleteTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._scheduleId = null, t.scheduleId != null && this.setScheduleId(t.scheduleId), this._defaultMaxTransactionFee = new Hbar(5);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].scheduleDelete;
    return Transaction._fromProtobufTransactions(
      new ScheduleDeleteTransaction({
        scheduleId: c.scheduleID != null ? ScheduleId._fromProtobuf(
          c.scheduleID
        ) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get scheduleId() {
    return this._scheduleId;
  }
  setScheduleId(t) {
    return this._requireNotFrozen(), this._scheduleId = typeof t == "string" ? ScheduleId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._scheduleId != null && this._scheduleId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.schedule.deleteSchedule(a);
  }
  _getTransactionDataCase() {
    return "scheduleDelete";
  }
  _makeTransactionData() {
    return {
      scheduleID: this._scheduleId != null ? this._scheduleId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `ScheduleDeleteTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "scheduleDelete",
  ScheduleDeleteTransaction._fromProtobuf
);
const { proto } = HashgraphProto;
class ScheduleInfo {
  constructor(t) {
    this.scheduleId = t.scheduleId, this.creatorAccountId = t.creatorAccountID, this.payerAccountId = t.payerAccountID, this.schedulableTransactionBody = t.schedulableTransactionBody, this.signers = t.signers, this.scheduleMemo = t.scheduleMemo, this.adminKey = t.adminKey != null ? t.adminKey : null, this.expirationTime = t.expirationTime, this.executed = t.executed, this.deleted = t.deleted, this.scheduledTransactionId = t.scheduledTransactionId, this.waitForExpiry = t.waitForExpiry, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    return new ScheduleInfo({
      scheduleId: ScheduleId._fromProtobuf(
        t.scheduleID
      ),
      creatorAccountID: t.creatorAccountID != null ? AccountId._fromProtobuf(
        t.creatorAccountID
      ) : null,
      payerAccountID: t.payerAccountID != null ? AccountId._fromProtobuf(
        t.payerAccountID
      ) : null,
      schedulableTransactionBody: t.scheduledTransactionBody != null ? t.scheduledTransactionBody : null,
      adminKey: t.adminKey != null ? Key._fromProtobufKey(t.adminKey) : null,
      signers: t.signers != null ? KeyList.__fromProtobufKeyList(t.signers) : null,
      scheduleMemo: t.memo != null ? t.memo : null,
      expirationTime: t.expirationTime != null ? Timestamp._fromProtobuf(
        t.expirationTime
      ) : null,
      executed: t.executionTime != null ? Timestamp._fromProtobuf(
        t.executionTime
      ) : null,
      deleted: t.deletionTime != null ? Timestamp._fromProtobuf(
        t.deletionTime
      ) : null,
      scheduledTransactionId: t.scheduledTransactionID != null ? TransactionId._fromProtobuf(t.scheduledTransactionID) : null,
      waitForExpiry: t.waitForExpiry != null ? t.waitForExpiry : !1
    });
  }
  _toProtobuf() {
    return {
      scheduleID: this.scheduleId != null ? this.scheduleId._toProtobuf() : null,
      creatorAccountID: this.creatorAccountId != null ? this.creatorAccountId._toProtobuf() : null,
      payerAccountID: this.payerAccountId != null ? this.payerAccountId._toProtobuf() : null,
      scheduledTransactionBody: this.schedulableTransactionBody != null ? this.schedulableTransactionBody : null,
      adminKey: this.adminKey != null ? this.adminKey._toProtobufKey() : null,
      signers: this.signers != null ? this.signers._toProtobufKey().keyList : null,
      memo: this.scheduleMemo != null ? this.scheduleMemo : "",
      expirationTime: this.expirationTime != null ? this.expirationTime._toProtobuf() : null,
      scheduledTransactionID: this.scheduledTransactionId != null ? this.scheduledTransactionId._toProtobuf() : null,
      waitForExpiry: this.waitForExpiry
    };
  }
  get scheduledTransaction() {
    if (this.schedulableTransactionBody == null)
      throw new Error("Scheduled transaction body is empty");
    const t = new proto.SchedulableTransactionBody(
      this.schedulableTransactionBody
    ), a = t.data;
    return Transaction.fromBytes(
      proto.TransactionList.encode({
        transactionList: [
          {
            signedTransactionBytes: proto.SignedTransaction.encode({
              bodyBytes: proto.TransactionBody.encode({
                transactionFee: this.schedulableTransactionBody.transactionFee,
                memo: this.schedulableTransactionBody.memo,
                [a]: t[a]
              }).finish()
            }).finish()
          }
        ]
      }).finish()
    );
  }
}
class ScheduleInfoQuery extends Query {
  constructor(t = {}) {
    super(), this._scheduleId = null, t.scheduleId != null && this.setScheduleId(t.scheduleId);
  }
  static _fromProtobuf(t) {
    const a = t.scheduleGetInfo;
    return new ScheduleInfoQuery({
      scheduleId: a.scheduleID != null ? ScheduleId._fromProtobuf(a.scheduleID) : void 0
    });
  }
  get scheduleId() {
    return this._scheduleId;
  }
  setScheduleId(t) {
    return this._scheduleId = typeof t == "string" ? ScheduleId.fromString(t) : t.clone(), this;
  }
  async getCost(t) {
    return super.getCost(t);
  }
  _validateChecksums(t) {
    this._scheduleId != null && this._scheduleId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.schedule.getScheduleInfo(a);
  }
  _mapResponseHeader(t) {
    return t.scheduleGetInfo.header;
  }
  _mapResponse(t, a, d) {
    const l = t.scheduleGetInfo;
    return Promise.resolve(
      ScheduleInfo._fromProtobuf(
        l.scheduleInfo
      )
    );
  }
  _onMakeRequest(t) {
    return {
      scheduleGetInfo: {
        header: t,
        scheduleID: this._scheduleId != null ? this._scheduleId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `ScheduleInfoQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set("scheduleGetInfo", ScheduleInfoQuery._fromProtobuf);
class ScheduleSignTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._scheduleId = null, t.scheduleId != null && this.setScheduleId(t.scheduleId), this._defaultMaxTransactionFee = new Hbar(5);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].scheduleSign;
    return Transaction._fromProtobufTransactions(
      new ScheduleSignTransaction({
        scheduleId: c.scheduleID != null ? ScheduleId._fromProtobuf(c.scheduleID) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get scheduleId() {
    return this._scheduleId;
  }
  setScheduleId(t) {
    return this._requireNotFrozen(), this._scheduleId = typeof t == "string" ? ScheduleId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._scheduleId != null && this._scheduleId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.schedule.signSchedule(a);
  }
  _getTransactionDataCase() {
    return "scheduleSign";
  }
  _makeTransactionData() {
    return {
      scheduleID: this._scheduleId != null ? this._scheduleId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `ScheduleSignTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "scheduleSign",
  ScheduleSignTransaction._fromProtobuf
);
class SystemDeleteTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._fileId = null, this._contractId = null, this._expirationTime = null, t.fileId != null && this.setFileId(t.fileId), t.contractId != null && this.setContractId(t.contractId), t.expirationTime != null && this.setExpirationTime(t.expirationTime);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].systemDelete;
    return Transaction._fromProtobufTransactions(
      new SystemDeleteTransaction({
        fileId: c.fileID != null ? FileId._fromProtobuf(
          c.fileID
        ) : void 0,
        contractId: c.contractID != null ? ContractId._fromProtobuf(
          c.contractID
        ) : void 0,
        expirationTime: c.expirationTime != null ? Timestamp._fromProtobuf(c.expirationTime) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get fileId() {
    return this._fileId;
  }
  setFileId(t) {
    return this._requireNotFrozen(), this._fileId = t instanceof FileId ? t : FileId.fromString(t), this;
  }
  get contractId() {
    return this._contractId;
  }
  setContractId(t) {
    return this._requireNotFrozen(), this._contractId = t instanceof ContractId ? t : ContractId.fromString(t), this;
  }
  get expirationTime() {
    return this._expirationTime;
  }
  setExpirationTime(t) {
    return this._requireNotFrozen(), this._expirationTime = t, this;
  }
  _execute(t, a) {
    return this._fileId != null ? t.file.systemDelete(a) : t.smartContract.systemDelete(a);
  }
  _getTransactionDataCase() {
    return "systemDelete";
  }
  _makeTransactionData() {
    return {
      fileID: this._fileId != null ? this._fileId._toProtobuf() : null,
      contractID: this._contractId != null ? this._contractId._toProtobuf() : null,
      expirationTime: this._expirationTime != null ? this._expirationTime._toProtobuf() : null
    };
  }
  _getLogId() {
    return `SystemDeleteTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set("systemDelete", SystemDeleteTransaction._fromProtobuf);
class SystemUndeleteTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._fileId = null, this._contractId = null, t.fileId != null && this.setFileId(t.fileId), t.contractId != null && this.setContractId(t.contractId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].systemUndelete;
    return Transaction._fromProtobufTransactions(
      new SystemUndeleteTransaction({
        fileId: c.fileID != null ? FileId._fromProtobuf(
          c.fileID
        ) : void 0,
        contractId: c.contractID != null ? ContractId._fromProtobuf(
          c.contractID
        ) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get fileId() {
    return this._fileId;
  }
  setFileId(t) {
    return this._requireNotFrozen(), this._fileId = t instanceof FileId ? t : FileId.fromString(t), this;
  }
  get contractId() {
    return this._contractId;
  }
  setContractId(t) {
    return this._requireNotFrozen(), this._contractId = t instanceof ContractId ? t : ContractId.fromString(t), this;
  }
  _execute(t, a) {
    return this._fileId != null ? t.file.systemUndelete(a) : t.smartContract.systemUndelete(a);
  }
  _getTransactionDataCase() {
    return "systemUndelete";
  }
  _makeTransactionData() {
    return {
      fileID: this._fileId != null ? this._fileId._toProtobuf() : null,
      contractID: this._contractId != null ? this._contractId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `SystemUndeleteTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "systemUndelete",
  SystemUndeleteTransaction._fromProtobuf
);
class TokenAssociateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenIds = null, this._accountId = null, this._defaultMaxTransactionFee = new Hbar(5), t.tokenIds != null && this.setTokenIds(t.tokenIds), t.accountId != null && this.setAccountId(t.accountId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenAssociate;
    return Transaction._fromProtobufTransactions(
      new TokenAssociateTransaction({
        tokenIds: c.tokens != null ? c.tokens.map(
          (x) => TokenId._fromProtobuf(x)
        ) : void 0,
        accountId: c.account != null ? AccountId._fromProtobuf(c.account) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenIds() {
    return this._tokenIds;
  }
  setTokenIds(t) {
    return this._requireNotFrozen(), this._tokenIds = t.map(
      (a) => typeof a == "string" ? TokenId.fromString(a) : a.clone()
    ), this;
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._requireNotFrozen(), this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._accountId != null && this._accountId.validateChecksum(t);
    for (const a of this._tokenIds != null ? this._tokenIds : [])
      a != null && a.validateChecksum(t);
  }
  _execute(t, a) {
    return t.token.associateTokens(a);
  }
  _getTransactionDataCase() {
    return "tokenAssociate";
  }
  _makeTransactionData() {
    return {
      tokens: this._tokenIds != null ? this._tokenIds.map((t) => t._toProtobuf()) : null,
      account: this._accountId != null ? this._accountId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `TokenAssociateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenAssociate",
  TokenAssociateTransaction._fromProtobuf
);
class TokenBurnTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenId = null, this._amount = null, this._serials = [], t.tokenId != null && this.setTokenId(t.tokenId), t.amount != null && this.setAmount(t.amount), t.serials != null && this.setSerials(t.serials);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenBurn;
    return Transaction._fromProtobufTransactions(
      new TokenBurnTransaction({
        tokenId: c.token != null ? TokenId._fromProtobuf(c.token) : void 0,
        amount: c.amount != null ? c.amount : void 0,
        serials: c.serialNumbers != null ? c.serialNumbers : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._requireNotFrozen(), this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t.clone(), this;
  }
  get amount() {
    return this._amount;
  }
  setAmount(t) {
    return this._requireNotFrozen(), this._amount = t instanceof long ? t : long.fromValue(t), this;
  }
  _validateChecksums(t) {
    this._tokenId != null && this._tokenId.validateChecksum(t);
  }
  get serials() {
    return this._serials;
  }
  setSerials(t) {
    return this._requireNotFrozen(), this._serials = t.map(
      (a) => a instanceof long ? a : long.fromValue(a)
    ), this;
  }
  _execute(t, a) {
    return t.token.burnToken(a);
  }
  _getTransactionDataCase() {
    return "tokenBurn";
  }
  _makeTransactionData() {
    return {
      amount: this._amount,
      serialNumbers: this._serials,
      token: this._tokenId != null ? this._tokenId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `TokenBurnTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenBurn",
  TokenBurnTransaction._fromProtobuf
);
class TokenType {
  constructor(t) {
    this._code = t, Object.freeze(this);
  }
  toString() {
    switch (this) {
      case TokenType.FungibleCommon:
        return "FUNGIBLE_COMMON";
      case TokenType.NonFungibleUnique:
        return "NON_FUNGIBLE_UNIQUE";
      default:
        return `UNKNOWN (${this._code})`;
    }
  }
  static _fromCode(t) {
    switch (t) {
      case 0:
        return TokenType.FungibleCommon;
      case 1:
        return TokenType.NonFungibleUnique;
    }
    throw new Error(
      `(BUG) TokenType.fromCode() does not handle code: ${t}`
    );
  }
  valueOf() {
    return this._code;
  }
}
TokenType.FungibleCommon = new TokenType(0);
TokenType.NonFungibleUnique = new TokenType(1);
class TokenSupplyType {
  constructor(t) {
    this._code = t, Object.freeze(this);
  }
  toString() {
    switch (this) {
      case TokenSupplyType.Infinite:
        return "INFINITE";
      case TokenSupplyType.Finite:
        return "FINITE";
      default:
        return `UNKNOWN (${this._code})`;
    }
  }
  static _fromCode(t) {
    switch (t) {
      case 0:
        return TokenSupplyType.Infinite;
      case 1:
        return TokenSupplyType.Finite;
    }
    throw new Error(
      `(BUG) TokenSupplyType.fromCode() does not handle code: ${t}`
    );
  }
  valueOf() {
    return this._code;
  }
}
TokenSupplyType.Infinite = new TokenSupplyType(0);
TokenSupplyType.Finite = new TokenSupplyType(1);
class TokenCreateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenName = null, this._tokenSymbol = null, this._decimals = null, this._initialSupply = null, this._treasuryAccountId = null, this._adminKey = null, this._kycKey = null, this._freezeKey = null, this._pauseKey = null, this._wipeKey = null, this._supplyKey = null, this._feeScheduleKey = null, this._freezeDefault = null, this._autoRenewAccountId = null, this._expirationTime = null, this._autoRenewPeriod = new Duration(DEFAULT_AUTO_RENEW_PERIOD), this._tokenMemo = null, this._customFees = [], this._tokenType = null, this._supplyType = null, this._maxSupply = null, this._defaultMaxTransactionFee = new Hbar(30), t.tokenName != null && this.setTokenName(t.tokenName), t.tokenSymbol != null && this.setTokenSymbol(t.tokenSymbol), t.decimals != null && this.setDecimals(t.decimals), t.initialSupply != null && this.setInitialSupply(t.initialSupply), t.treasuryAccountId != null && this.setTreasuryAccountId(t.treasuryAccountId), t.adminKey != null && this.setAdminKey(t.adminKey), t.kycKey != null && this.setKycKey(t.kycKey), t.freezeKey != null && this.setFreezeKey(t.freezeKey), t.pauseKey != null && this.setPauseKey(t.pauseKey), t.wipeKey != null && this.setWipeKey(t.wipeKey), t.supplyKey != null && this.setSupplyKey(t.supplyKey), t.feeScheduleKey != null && this.setFeeScheduleKey(t.feeScheduleKey), t.freezeDefault != null && this.setFreezeDefault(t.freezeDefault), t.autoRenewAccountId != null && this.setAutoRenewAccountId(t.autoRenewAccountId), t.expirationTime != null && this.setExpirationTime(t.expirationTime), t.autoRenewPeriod != null && this.setAutoRenewPeriod(t.autoRenewPeriod), t.tokenMemo != null && this.setTokenMemo(t.tokenMemo), t.customFees != null && this.setCustomFees(t.customFees), t.tokenType != null && this.setTokenType(t.tokenType), t.supplyType != null && this.setSupplyType(t.supplyType), t.maxSupply != null && this.setMaxSupply(t.maxSupply);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenCreation;
    return Transaction._fromProtobufTransactions(
      new TokenCreateTransaction({
        tokenName: c.name != null ? c.name : void 0,
        tokenSymbol: c.symbol != null ? c.symbol : void 0,
        decimals: c.decimals != null ? c.decimals : void 0,
        initialSupply: c.initialSupply != null ? c.initialSupply : void 0,
        treasuryAccountId: c.treasury != null ? AccountId._fromProtobuf(c.treasury) : void 0,
        adminKey: c.adminKey != null ? Key._fromProtobufKey(c.adminKey) : void 0,
        kycKey: c.kycKey != null ? Key._fromProtobufKey(c.kycKey) : void 0,
        freezeKey: c.freezeKey != null ? Key._fromProtobufKey(c.freezeKey) : void 0,
        pauseKey: c.pauseKey != null ? Key._fromProtobufKey(c.pauseKey) : void 0,
        wipeKey: c.wipeKey != null ? Key._fromProtobufKey(c.wipeKey) : void 0,
        supplyKey: c.supplyKey != null ? Key._fromProtobufKey(c.supplyKey) : void 0,
        feeScheduleKey: c.feeScheduleKey != null ? Key._fromProtobufKey(c.feeScheduleKey) : void 0,
        freezeDefault: c.freezeDefault != null ? c.freezeDefault : void 0,
        autoRenewAccountId: c.autoRenewAccount != null ? AccountId._fromProtobuf(c.autoRenewAccount) : void 0,
        expirationTime: c.expiry != null ? Timestamp._fromProtobuf(c.expiry) : void 0,
        autoRenewPeriod: c.autoRenewPeriod != null ? Duration._fromProtobuf(c.autoRenewPeriod) : void 0,
        tokenMemo: c.memo != null ? c.memo : void 0,
        customFees: c.customFees != null ? c.customFees.map((x) => x.fixedFee != null ? CustomFixedFee._fromProtobuf(x) : x.fractionalFee != null ? CustomFractionalFee._fromProtobuf(x) : CustomRoyalyFee._fromProtobuf(x)) : void 0,
        tokenType: c.tokenType != null ? TokenType._fromCode(c.tokenType) : void 0,
        supplyType: c.supplyType != null ? TokenSupplyType._fromCode(c.supplyType) : void 0,
        maxSupply: c.maxSupply != null ? c.maxSupply : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenName() {
    return this._tokenName;
  }
  setTokenName(t) {
    return this._requireNotFrozen(), this._tokenName = t, this;
  }
  get tokenSymbol() {
    return this._tokenSymbol;
  }
  setTokenSymbol(t) {
    return this._requireNotFrozen(), this._tokenSymbol = t, this;
  }
  get decimals() {
    return this._decimals;
  }
  setDecimals(t) {
    return this._requireNotFrozen(), this._decimals = t instanceof long ? t : long.fromValue(t), this;
  }
  get initialSupply() {
    return this._initialSupply;
  }
  setInitialSupply(t) {
    return this._requireNotFrozen(), this._initialSupply = long.fromValue(t), this;
  }
  get treasuryAccountId() {
    return this._treasuryAccountId;
  }
  setTreasuryAccountId(t) {
    return this._requireNotFrozen(), this._treasuryAccountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  get adminKey() {
    return this._adminKey;
  }
  setAdminKey(t) {
    return this._requireNotFrozen(), this._adminKey = t, this;
  }
  get kycKey() {
    return this._kycKey;
  }
  setKycKey(t) {
    return this._requireNotFrozen(), this._kycKey = t, this;
  }
  get freezeKey() {
    return this._freezeKey;
  }
  setFreezeKey(t) {
    return this._requireNotFrozen(), this._freezeKey = t, this;
  }
  get pauseKey() {
    return this._pauseKey;
  }
  setPauseKey(t) {
    return this._requireNotFrozen(), this._pauseKey = t, this;
  }
  get wipeKey() {
    return this._wipeKey;
  }
  setWipeKey(t) {
    return this._requireNotFrozen(), this._wipeKey = t, this;
  }
  get supplyKey() {
    return this._supplyKey;
  }
  setSupplyKey(t) {
    return this._requireNotFrozen(), this._supplyKey = t, this;
  }
  get feeScheduleKey() {
    return this._feeScheduleKey;
  }
  setFeeScheduleKey(t) {
    return this._requireNotFrozen(), this._feeScheduleKey = t, this;
  }
  get freezeDefault() {
    return this._freezeDefault;
  }
  setFreezeDefault(t) {
    return this._requireNotFrozen(), this._freezeDefault = t, this;
  }
  get expirationTime() {
    return this._expirationTime;
  }
  setExpirationTime(t) {
    return this._requireNotFrozen(), this._autoRenewPeriod = null, this._expirationTime = t instanceof Timestamp ? t : Timestamp.fromDate(t), this;
  }
  get autoRenewAccountId() {
    return this._autoRenewAccountId;
  }
  setAutoRenewAccountId(t) {
    return this._requireNotFrozen(), this._autoRenewAccountId = t instanceof AccountId ? t : AccountId.fromString(t), this;
  }
  get autoRenewPeriod() {
    return this._autoRenewPeriod;
  }
  setAutoRenewPeriod(t) {
    return this._requireNotFrozen(), this._autoRenewPeriod = t instanceof Duration ? t : new Duration(t), this;
  }
  get tokenMemo() {
    return this._tokenMemo;
  }
  setTokenMemo(t) {
    return this._requireNotFrozen(), this._tokenMemo = t, this;
  }
  get customFees() {
    return this._customFees;
  }
  setCustomFees(t) {
    return this._customFees = t, this;
  }
  get tokenType() {
    return this._tokenType;
  }
  setTokenType(t) {
    return this._tokenType = t, this;
  }
  get supplyType() {
    return this._supplyType;
  }
  setSupplyType(t) {
    return this._supplyType = t, this;
  }
  get maxSupply() {
    return this._maxSupply;
  }
  setMaxSupply(t) {
    return this._maxSupply = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  _freezeWithAccountId(t) {
    super._freezeWithAccountId(t), this._autoRenewPeriod != null && t != null && (this._autoRenewAccountId = t);
  }
  freezeWith(t) {
    return t != null && t.operatorAccountId != null && this._freezeWithAccountId(t.operatorAccountId), super.freezeWith(t);
  }
  _validateChecksums(t) {
    this._treasuryAccountId != null && this._treasuryAccountId.validateChecksum(t), this._autoRenewAccountId != null && this._autoRenewAccountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.token.createToken(a);
  }
  _getTransactionDataCase() {
    return "tokenCreation";
  }
  _makeTransactionData() {
    return {
      name: this._tokenName,
      symbol: this._tokenSymbol,
      decimals: this._decimals != null ? this._decimals.toInt() : null,
      initialSupply: this._initialSupply,
      treasury: this._treasuryAccountId != null ? this._treasuryAccountId._toProtobuf() : null,
      adminKey: this._adminKey != null ? this._adminKey._toProtobufKey() : null,
      kycKey: this._kycKey != null ? this._kycKey._toProtobufKey() : null,
      freezeKey: this._freezeKey != null ? this._freezeKey._toProtobufKey() : null,
      pauseKey: this._pauseKey != null ? this._pauseKey._toProtobufKey() : null,
      wipeKey: this._wipeKey != null ? this._wipeKey._toProtobufKey() : null,
      supplyKey: this._supplyKey != null ? this._supplyKey._toProtobufKey() : null,
      feeScheduleKey: this._feeScheduleKey != null ? this._feeScheduleKey._toProtobufKey() : null,
      freezeDefault: this._freezeDefault,
      autoRenewAccount: this._autoRenewAccountId != null ? this._autoRenewAccountId._toProtobuf() : null,
      expiry: this._expirationTime != null ? this._expirationTime._toProtobuf() : null,
      autoRenewPeriod: this._autoRenewPeriod != null ? this._autoRenewPeriod._toProtobuf() : null,
      memo: this._tokenMemo,
      customFees: this.customFees.map((t) => t._toProtobuf()),
      tokenType: this._tokenType != null ? this._tokenType._code : null,
      supplyType: this._supplyType != null ? this._supplyType._code : null,
      maxSupply: this.maxSupply
    };
  }
  _getLogId() {
    return `TokenCreateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenCreation",
  TokenCreateTransaction._fromProtobuf
);
class TokenDeleteTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenId = null, t.tokenId != null && this.setTokenId(t.tokenId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenDeletion;
    return Transaction._fromProtobufTransactions(
      new TokenDeleteTransaction({
        tokenId: c.token != null ? TokenId._fromProtobuf(c.token) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._requireNotFrozen(), this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._tokenId != null && this._tokenId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.token.deleteToken(a);
  }
  _getTransactionDataCase() {
    return "tokenDeletion";
  }
  _makeTransactionData() {
    return {
      token: this._tokenId != null ? this._tokenId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `TokenDeleteTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenDeletion",
  TokenDeleteTransaction._fromProtobuf
);
class TokenDissociateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenIds = null, this._accountId = null, this._defaultMaxTransactionFee = new Hbar(5), t.tokenIds != null && this.setTokenIds(t.tokenIds), t.accountId != null && this.setAccountId(t.accountId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenDissociate;
    return Transaction._fromProtobufTransactions(
      new TokenDissociateTransaction({
        tokenIds: c.tokens != null ? c.tokens.map(
          (x) => TokenId._fromProtobuf(x)
        ) : void 0,
        accountId: c.account != null ? AccountId._fromProtobuf(c.account) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenIds() {
    return this._tokenIds;
  }
  setTokenIds(t) {
    return this._requireNotFrozen(), this._tokenIds = t.map(
      (a) => typeof a == "string" ? TokenId.fromString(a) : a.clone()
    ), this;
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._requireNotFrozen(), this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._accountId != null && this._accountId.validateChecksum(t);
    for (const a of this._tokenIds != null ? this._tokenIds : [])
      a != null && a.validateChecksum(t);
  }
  _execute(t, a) {
    return t.token.dissociateTokens(a);
  }
  _getTransactionDataCase() {
    return "tokenDissociate";
  }
  _makeTransactionData() {
    return {
      tokens: this._tokenIds != null ? this._tokenIds.map((t) => t._toProtobuf()) : null,
      account: this._accountId != null ? this._accountId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `TokenDissociateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenDissociate",
  TokenDissociateTransaction._fromProtobuf
);
class TokenFeeScheduleUpdateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenId = null, this._customFees = [], t.tokenId != null && this.setTokenId(t.tokenId), t.customFees != null && this.setCustomFees(t.customFees);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenFeeScheduleUpdate;
    return Transaction._fromProtobufTransactions(
      new TokenFeeScheduleUpdateTransaction({
        tokenId: c.tokenId != null ? TokenId._fromProtobuf(c.tokenId) : void 0,
        customFees: c.customFees != null ? c.customFees.map((x) => x.fixedFee != null ? CustomFixedFee._fromProtobuf(x) : x.fractionalFee != null ? CustomFractionalFee._fromProtobuf(x) : CustomRoyalyFee._fromProtobuf(x)) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._requireNotFrozen(), this._tokenId = typeof t == "string" ? TokenId.fromString(t) : TokenId._fromProtobuf(t._toProtobuf()), this;
  }
  get customFees() {
    return this._customFees;
  }
  setCustomFees(t) {
    return this._requireNotFrozen(), this._customFees = t, this;
  }
  _execute(t, a) {
    return t.token.updateTokenFeeSchedule(a);
  }
  _getTransactionDataCase() {
    return "tokenFeeScheduleUpdate";
  }
  _makeTransactionData() {
    return {
      tokenId: this._tokenId != null ? this._tokenId._toProtobuf() : null,
      customFees: this._customFees.map((t) => t._toProtobuf())
    };
  }
  _getLogId() {
    return `TokenFeeScheduleUpdateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenFeeScheduleUpdate",
  TokenFeeScheduleUpdateTransaction._fromProtobuf
);
class TokenFreezeTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenId = null, this._accountId = null, t.tokenId != null && this.setTokenId(t.tokenId), t.accountId != null && this.setAccountId(t.accountId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenFreeze;
    return Transaction._fromProtobufTransactions(
      new TokenFreezeTransaction({
        tokenId: c.token != null ? TokenId._fromProtobuf(c.token) : void 0,
        accountId: c.account != null ? AccountId._fromProtobuf(c.account) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._requireNotFrozen(), this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t.clone(), this;
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._requireNotFrozen(), this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._tokenId != null && this._tokenId.validateChecksum(t), this._accountId != null && this._accountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.token.freezeTokenAccount(a);
  }
  _getTransactionDataCase() {
    return "tokenFreeze";
  }
  _makeTransactionData() {
    return {
      token: this._tokenId != null ? this._tokenId._toProtobuf() : null,
      account: this._accountId != null ? this._accountId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `TokenFreezeTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenFreeze",
  TokenFreezeTransaction._fromProtobuf
);
class TokenGrantKycTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenId = null, this._accountId = null, t.tokenId != null && this.setTokenId(t.tokenId), t.accountId != null && this.setAccountId(t.accountId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenGrantKyc;
    return Transaction._fromProtobufTransactions(
      new TokenGrantKycTransaction({
        tokenId: c.token != null ? TokenId._fromProtobuf(c.token) : void 0,
        accountId: c.account != null ? AccountId._fromProtobuf(c.account) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._requireNotFrozen(), this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t.clone(), this;
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._requireNotFrozen(), this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._tokenId != null && this._tokenId.validateChecksum(t), this._accountId != null && this._accountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.token.grantKycToTokenAccount(a);
  }
  _getTransactionDataCase() {
    return "tokenGrantKyc";
  }
  _makeTransactionData() {
    return {
      token: this._tokenId != null ? this._tokenId._toProtobuf() : null,
      account: this._accountId != null ? this._accountId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `TokenGrantKycTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenGrantKyc",
  TokenGrantKycTransaction._fromProtobuf
);
class TokenInfo {
  constructor(t) {
    this.tokenId = t.tokenId, this.name = t.name, this.symbol = t.symbol, this.decimals = t.decimals, this.totalSupply = t.totalSupply, this.treasuryAccountId = t.treasuryAccountId, this.adminKey = t.adminKey, this.kycKey = t.kycKey, this.freezeKey = t.freezeKey, this.pauseKey = t.pauseKey, this.wipeKey = t.wipeKey, this.supplyKey = t.supplyKey, this.feeScheduleKey = t.feeScheduleKey, this.defaultFreezeStatus = t.defaultFreezeStatus, this.defaultKycStatus = t.defaultKycStatus, this.pauseStatus = t.pauseStatus, this.isDeleted = t.isDeleted, this.autoRenewAccountId = t.autoRenewAccountId, this.autoRenewPeriod = t.autoRenewPeriod, this.expirationTime = t.expirationTime, this.tokenMemo = t.tokenMemo, this.customFees = t.customFees, this.tokenType = t.tokenType, this.supplyType = t.supplyType, this.maxSupply = t.maxSupply, this.ledgerId = t.ledgerId;
  }
  static _fromProtobuf(t) {
    const a = t.defaultFreezeStatus, d = t.defaultKycStatus, l = t.pauseStatus, h = t.autoRenewAccount != null ? AccountId._fromProtobuf(t.autoRenewAccount) : new AccountId(0);
    return new TokenInfo({
      tokenId: TokenId._fromProtobuf(
        t.tokenId
      ),
      name: t.name,
      symbol: t.symbol,
      decimals: t.decimals,
      totalSupply: long.fromValue(t.totalSupply),
      treasuryAccountId: t.treasury != null ? AccountId._fromProtobuf(
        t.treasury
      ) : null,
      adminKey: t.adminKey != null ? Key._fromProtobufKey(t.adminKey) : null,
      kycKey: t.kycKey != null ? Key._fromProtobufKey(t.kycKey) : null,
      freezeKey: t.freezeKey != null ? Key._fromProtobufKey(t.freezeKey) : null,
      pauseKey: t.pauseKey != null ? Key._fromProtobufKey(t.pauseKey) : null,
      wipeKey: t.wipeKey != null ? Key._fromProtobufKey(t.wipeKey) : null,
      supplyKey: t.supplyKey != null ? Key._fromProtobufKey(t.supplyKey) : null,
      feeScheduleKey: t.feeScheduleKey != null ? Key._fromProtobufKey(t.feeScheduleKey) : null,
      defaultFreezeStatus: a === 0 ? null : a == 1,
      defaultKycStatus: d === 0 ? null : d == 1,
      pauseStatus: l === 0 ? null : l == 1,
      isDeleted: t.deleted,
      autoRenewAccountId: h.shard.toInt() == 0 && h.realm.toInt() == 0 && h.num.toInt() == 0 ? null : h,
      autoRenewPeriod: t.autoRenewPeriod != null ? Duration._fromProtobuf(
        t.autoRenewPeriod
      ) : null,
      expirationTime: t.expiry != null ? Timestamp._fromProtobuf(
        t.expiry
      ) : null,
      tokenMemo: t.memo != null ? t.memo : "",
      customFees: t.customFees != null ? t.customFees.map((g) => g.fixedFee != null ? CustomFixedFee._fromProtobuf(g) : g.fractionalFee != null ? CustomFractionalFee._fromProtobuf(g) : CustomRoyalyFee._fromProtobuf(g)) : [],
      tokenType: t.tokenType != null ? TokenType._fromCode(t.tokenType) : null,
      supplyType: t.supplyType != null ? TokenSupplyType._fromCode(t.supplyType) : null,
      maxSupply: t.maxSupply != null ? t.maxSupply : null,
      ledgerId: t.ledgerId != null ? LedgerId.fromBytes(t.ledgerId) : null
    });
  }
  _toProtobuf() {
    return {
      tokenId: this.tokenId._toProtobuf(),
      name: this.name,
      symbol: this.symbol,
      decimals: this.decimals,
      totalSupply: this.totalSupply,
      treasury: this.treasuryAccountId != null ? this.treasuryAccountId._toProtobuf() : null,
      adminKey: this.adminKey != null ? this.adminKey._toProtobufKey() : null,
      kycKey: this.kycKey != null ? this.kycKey._toProtobufKey() : null,
      freezeKey: this.freezeKey != null ? this.freezeKey._toProtobufKey() : null,
      pauseKey: this.pauseKey != null ? this.pauseKey._toProtobufKey() : null,
      wipeKey: this.wipeKey != null ? this.wipeKey._toProtobufKey() : null,
      supplyKey: this.supplyKey != null ? this.supplyKey._toProtobufKey() : null,
      feeScheduleKey: this.feeScheduleKey != null ? this.feeScheduleKey._toProtobufKey() : null,
      defaultFreezeStatus: this.defaultFreezeStatus == null ? 0 : this.defaultFreezeStatus ? 1 : 2,
      defaultKycStatus: this.defaultKycStatus == null ? 0 : this.defaultKycStatus ? 1 : 2,
      pauseStatus: this.pauseStatus == null ? 0 : this.pauseStatus ? 1 : 2,
      deleted: this.isDeleted,
      autoRenewAccount: this.autoRenewAccountId != null ? this.autoRenewAccountId._toProtobuf() : void 0,
      autoRenewPeriod: this.autoRenewPeriod != null ? this.autoRenewPeriod._toProtobuf() : null,
      expiry: this.expirationTime != null ? this.expirationTime._toProtobuf() : null,
      memo: this.tokenMemo,
      customFees: this.customFees.map((t) => t._toProtobuf()),
      tokenType: this.tokenType != null ? this.tokenType._code : null,
      supplyType: this.supplyType != null ? this.supplyType._code : null,
      maxSupply: this.maxSupply,
      ledgerId: this.ledgerId != null ? this.ledgerId.toBytes() : null
    };
  }
  static fromBytes(t) {
    return TokenInfo._fromProtobuf(
      lib.proto.TokenInfo.decode(t)
    );
  }
  toBytes() {
    return lib.proto.TokenInfo.encode(
      this._toProtobuf()
    ).finish();
  }
}
class TokenInfoQuery extends Query {
  constructor(t = {}) {
    super(), this._tokenId = null, t.tokenId != null && this.setTokenId(t.tokenId);
  }
  static _fromProtobuf(t) {
    const a = t.tokenGetInfo;
    return new TokenInfoQuery({
      tokenId: a.token != null ? TokenId._fromProtobuf(a.token) : void 0
    });
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t.clone(), this;
  }
  async getCost(t) {
    return super.getCost(t);
  }
  _validateChecksums(t) {
    this._tokenId != null && this._tokenId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.token.getTokenInfo(a);
  }
  _mapResponseHeader(t) {
    return t.tokenGetInfo.header;
  }
  _mapResponse(t, a, d) {
    const l = t.tokenGetInfo;
    return Promise.resolve(
      TokenInfo._fromProtobuf(
        l.tokenInfo
      )
    );
  }
  _onMakeRequest(t) {
    return {
      tokenGetInfo: {
        header: t,
        token: this._tokenId != null ? this._tokenId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `TokenInfoQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set("tokenGetInfo", TokenInfoQuery._fromProtobuf);
class TokenMintTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenId = null, this._amount = null, this._metadata = [], t.tokenId != null && this.setTokenId(t.tokenId), t.amount != null && this.setAmount(t.amount), t.metadata != null && this.setMetadata(t.metadata);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenMint;
    return Transaction._fromProtobufTransactions(
      new TokenMintTransaction({
        tokenId: c.token != null ? TokenId._fromProtobuf(c.token) : void 0,
        amount: c.amount != null ? c.amount : void 0,
        metadata: c.metadata != null ? c.metadata : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._requireNotFrozen(), this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t.clone(), this;
  }
  get amount() {
    return this._amount;
  }
  setAmount(t) {
    return this._requireNotFrozen(), this._amount = t instanceof long ? t : long.fromValue(t), this;
  }
  _validateChecksums(t) {
    this._tokenId != null && this._tokenId.validateChecksum(t);
  }
  get metadata() {
    return this._metadata;
  }
  addMetadata(t) {
    return this._requireNotFrozen(), typeof t == "string" && console.warn(
      "Passing a `string` for token metadata is considered a bug, and has been removed. Please provide a `Uint8Array` instead."
    ), this._metadata.push(
      typeof t == "string" ? decode$6(t) : t
    ), this;
  }
  setMetadata(t) {
    this._requireNotFrozen();
    for (const a of t)
      if (typeof a == "string") {
        console.warn(
          "Passing a `string` for token metadata is considered a bug, and has been removed. Please provide a `Uint8Array` instead."
        );
        break;
      }
    return this._metadata = t.map(
      (a) => typeof a == "string" ? decode$6(a) : a
    ), this;
  }
  _execute(t, a) {
    return t.token.mintToken(a);
  }
  _getTransactionDataCase() {
    return "tokenMint";
  }
  _makeTransactionData() {
    return {
      amount: this._amount,
      token: this._tokenId != null ? this._tokenId._toProtobuf() : null,
      metadata: this._metadata
    };
  }
  _getLogId() {
    return `TokenMintTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenMint",
  TokenMintTransaction._fromProtobuf
);
class TokenNftInfo {
  constructor(t) {
    this.nftId = t.nftId, this.accountId = t.accountId, this.creationTime = t.creationTime, this.metadata = t.metadata, this.ledgerId = t.ledgerId, this.spenderId = t.spenderId, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    return new TokenNftInfo({
      nftId: NftId._fromProtobuf(
        t.nftID
      ),
      accountId: AccountId._fromProtobuf(
        t.accountID
      ),
      creationTime: Timestamp._fromProtobuf(
        t.creationTime
      ),
      metadata: t.metadata !== void 0 ? t.metadata : null,
      ledgerId: t.ledgerId != null ? LedgerId.fromBytes(t.ledgerId) : null,
      spenderId: t.spenderId != null ? AccountId._fromProtobuf(t.spenderId) : null
    });
  }
  _toProtobuf() {
    return {
      nftID: this.nftId._toProtobuf(),
      accountID: this.accountId._toProtobuf(),
      creationTime: this.creationTime._toProtobuf(),
      metadata: this.metadata,
      ledgerId: this.ledgerId != null ? this.ledgerId.toBytes() : null,
      spenderId: this.spenderId != null ? this.spenderId._toProtobuf() : null
    };
  }
  toJson() {
    return {
      nftId: this.nftId.toString(),
      accountId: this.accountId.toString(),
      creationTime: this.creationTime.toString(),
      metadata: this.metadata != null ? encode$4(this.metadata) : null,
      ledgerId: this.ledgerId != null ? this.ledgerId.toString() : null,
      spenderId: this.spenderId != null ? this.spenderId.toString() : null
    };
  }
  toString() {
    return JSON.stringify(this.toJson());
  }
}
class TokenNftInfoQuery extends Query {
  constructor(t = {}) {
    super(), this._nftId = null, t.nftId != null && this.setNftId(t.nftId), this._accountId = null, t.accountId != null && this.setAccountId(t.accountId), this._tokenId = null, t.tokenId != null && this.setTokenId(t.tokenId), this._start = null, t.start != null && this.setStart(t.start), this._end = null, t.end != null && this.setEnd(t.end);
  }
  static _fromProtobuf(t) {
    if (t.tokenGetNftInfo != null) {
      const a = t.tokenGetNftInfo;
      return new TokenNftInfoQuery({
        nftId: a.nftID != null ? NftId._fromProtobuf(a.nftID) : void 0
      });
    } else if (t.tokenGetAccountNftInfos != null) {
      const a = t.tokenGetAccountNftInfos;
      return new TokenNftInfoQuery({
        accountId: a.accountID != null ? AccountId._fromProtobuf(a.accountID) : void 0,
        start: a.start != null ? a.start : void 0,
        end: a.end != null ? a.end : void 0
      });
    } else {
      const a = t.tokenGetNftInfos;
      return new TokenNftInfoQuery({
        tokenId: a.tokenID != null ? TokenId._fromProtobuf(a.tokenID) : void 0,
        start: a.start != null ? a.start : void 0,
        end: a.end != null ? a.end : void 0
      });
    }
  }
  get nftId() {
    return this._nftId;
  }
  setNftId(t) {
    return this._nftId = typeof t == "string" ? NftId.fromString(t) : NftId._fromProtobuf(t._toProtobuf()), this;
  }
  get accountId() {
    return console.warn(
      "`TokenNftInfoQuery.accountId` is deprecated with no replacement"
    ), this._accountId;
  }
  setAccountId(t) {
    return console.warn(
      "`TokenNftInfoQuery.setAccountId()` is deprecated with no replacement"
    ), this._accountId = typeof t == "string" ? AccountId.fromString(t) : AccountId._fromProtobuf(t._toProtobuf()), this;
  }
  get tokenId() {
    return console.warn(
      "`TokenNftInfoQuery.tokenId` is deprecated with no replacement"
    ), this._tokenId;
  }
  setTokenId(t) {
    return console.warn(
      "`TokenNftInfoQuery.setTokenId()` is deprecated with no replacement"
    ), this._tokenId = typeof t == "string" ? TokenId.fromString(t) : TokenId._fromProtobuf(t._toProtobuf()), this;
  }
  get start() {
    return console.warn(
      "`TokenNftInfoQuery.start` is deprecated with no replacement"
    ), this._start;
  }
  setStart(t) {
    return console.warn(
      "`TokenNftInfoQuery.setStart()` is deprecated with no replacement"
    ), this._start = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  get end() {
    return console.warn(
      "`TokenNftInfoQuery.end` is deprecated with no replacement"
    ), this._end;
  }
  setEnd(t) {
    return console.warn(
      "`TokenNftInfoQuery.setEnd()` is deprecated with no replacement"
    ), this._end = typeof t == "number" ? long.fromNumber(t) : t, this;
  }
  async getCost(t) {
    return super.getCost(t);
  }
  _execute(t, a) {
    return t.token.getTokenNftInfo(a);
  }
  _mapResponseHeader(t) {
    return t.tokenGetNftInfo.header;
  }
  _mapResponse(t, a, d) {
    const l = [
      t.tokenGetNftInfo.nft
    ];
    return Promise.resolve(
      l.map(
        (h) => TokenNftInfo._fromProtobuf(
          h
        )
      )
    );
  }
  _onMakeRequest(t) {
    return {
      tokenGetNftInfo: {
        header: t,
        nftID: this._nftId != null ? this._nftId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `TokenNftInfoQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set("tokenGetNftInfo", TokenNftInfoQuery._fromProtobuf);
class TokenPauseTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenId = null, t.tokenId != null && this.setTokenId(t.tokenId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenPause;
    return Transaction._fromProtobufTransactions(
      new TokenPauseTransaction({
        tokenId: c.token != null ? TokenId._fromProtobuf(c.token) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._requireNotFrozen(), this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._tokenId != null && this._tokenId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.token.pauseToken(a);
  }
  _getTransactionDataCase() {
    return "tokenPause";
  }
  _makeTransactionData() {
    return {
      token: this._tokenId != null ? this._tokenId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `TokenPauseTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenPause",
  TokenPauseTransaction._fromProtobuf
);
class TokenRevokeKycTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenId = null, this._accountId = null, t.tokenId != null && this.setTokenId(t.tokenId), t.accountId != null && this.setAccountId(t.accountId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenRevokeKyc;
    return Transaction._fromProtobufTransactions(
      new TokenRevokeKycTransaction({
        tokenId: c.token != null ? TokenId._fromProtobuf(c.token) : void 0,
        accountId: c.account != null ? AccountId._fromProtobuf(c.account) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._requireNotFrozen(), this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t.clone(), this;
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._requireNotFrozen(), this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._tokenId != null && this._tokenId.validateChecksum(t), this._accountId != null && this._accountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.token.revokeKycFromTokenAccount(a);
  }
  _getTransactionDataCase() {
    return "tokenRevokeKyc";
  }
  _makeTransactionData() {
    return {
      token: this._tokenId != null ? this._tokenId._toProtobuf() : null,
      account: this._accountId != null ? this._accountId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `TokenRevokeKycTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenRevokeKyc",
  TokenRevokeKycTransaction._fromProtobuf
);
class TokenUnfreezeTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenId = null, this._accountId = null, t.tokenId != null && this.setTokenId(t.tokenId), t.accountId != null && this.setAccountId(t.accountId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenUnfreeze;
    return Transaction._fromProtobufTransactions(
      new TokenUnfreezeTransaction({
        tokenId: c.token != null ? TokenId._fromProtobuf(c.token) : void 0,
        accountId: c.account != null ? AccountId._fromProtobuf(c.account) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._requireNotFrozen(), this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t.clone(), this;
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._requireNotFrozen(), this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._tokenId != null && this._tokenId.validateChecksum(t), this._accountId != null && this._accountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.token.unfreezeTokenAccount(a);
  }
  _getTransactionDataCase() {
    return "tokenUnfreeze";
  }
  _makeTransactionData() {
    return {
      token: this._tokenId != null ? this._tokenId._toProtobuf() : null,
      account: this._accountId != null ? this._accountId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `TokenUnfreezeTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenUnfreeze",
  TokenUnfreezeTransaction._fromProtobuf
);
class TokenUnpauseTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenId = null, t.tokenId != null && this.setTokenId(t.tokenId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenUnpause;
    return Transaction._fromProtobufTransactions(
      new TokenUnpauseTransaction({
        tokenId: c.token != null ? TokenId._fromProtobuf(c.token) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._requireNotFrozen(), this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._tokenId != null && this._tokenId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.token.unpauseToken(a);
  }
  _getTransactionDataCase() {
    return "tokenUnpause";
  }
  _makeTransactionData() {
    return {
      token: this._tokenId != null ? this._tokenId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `TokenUnpauseTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenUnpause",
  TokenUnpauseTransaction._fromProtobuf
);
class TokenUpdateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenId = null, this._tokenName = null, this._tokenSymbol = null, this._treasuryAccountId = null, this._adminKey = null, this._kycKey = null, this._freezeKey = null, this._wipeKey = null, this._supplyKey = null, this._autoRenewAccountId = null, this._expirationTime = null, this._autoRenewPeriod = null, this._tokenMemo = null, this._feeScheduleKey = null, this._pauseKey = null, t.tokenId != null && this.setTokenId(t.tokenId), t.tokenName != null && this.setTokenName(t.tokenName), t.tokenSymbol != null && this.setTokenSymbol(t.tokenSymbol), t.treasuryAccountId != null && this.setTreasuryAccountId(t.treasuryAccountId), t.adminKey != null && this.setAdminKey(t.adminKey), t.kycKey != null && this.setKycKey(t.kycKey), t.freezeKey != null && this.setFreezeKey(t.freezeKey), t.wipeKey != null && this.setWipeKey(t.wipeKey), t.supplyKey != null && this.setSupplyKey(t.supplyKey), t.autoRenewAccountId != null && this.setAutoRenewAccountId(t.autoRenewAccountId), t.expirationTime != null && this.setExpirationTime(t.expirationTime), t.autoRenewPeriod != null && this.setAutoRenewPeriod(t.autoRenewPeriod), t.tokenMemo != null && this.setTokenMemo(t.tokenMemo), t.feeScheduleKey != null && this.setFeeScheduleKey(t.feeScheduleKey), t.pauseKey != null && this.setPauseKey(t.pauseKey);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenUpdate;
    return Transaction._fromProtobufTransactions(
      new TokenUpdateTransaction({
        tokenId: c.token != null ? TokenId._fromProtobuf(c.token) : void 0,
        tokenName: c.name != null ? c.name : void 0,
        tokenSymbol: c.symbol != null ? c.symbol : void 0,
        treasuryAccountId: c.treasury != null ? AccountId._fromProtobuf(c.treasury) : void 0,
        adminKey: c.adminKey != null ? Key._fromProtobufKey(c.adminKey) : void 0,
        kycKey: c.kycKey != null ? Key._fromProtobufKey(c.kycKey) : void 0,
        freezeKey: c.freezeKey != null ? Key._fromProtobufKey(c.freezeKey) : void 0,
        wipeKey: c.wipeKey != null ? Key._fromProtobufKey(c.wipeKey) : void 0,
        supplyKey: c.supplyKey != null ? Key._fromProtobufKey(c.supplyKey) : void 0,
        autoRenewAccountId: c.autoRenewAccount != null ? AccountId._fromProtobuf(c.autoRenewAccount) : void 0,
        expirationTime: c.expiry != null ? Timestamp._fromProtobuf(c.expiry) : void 0,
        autoRenewPeriod: c.autoRenewPeriod != null ? Duration._fromProtobuf(c.autoRenewPeriod) : void 0,
        tokenMemo: c.memo != null && c.memo.value != null ? c.memo.value : void 0,
        feeScheduleKey: c.feeScheduleKey != null ? Key._fromProtobufKey(c.feeScheduleKey) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._requireNotFrozen(), this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t.clone(), this;
  }
  get tokenName() {
    return this._tokenName;
  }
  setTokenName(t) {
    return this._requireNotFrozen(), this._tokenName = t, this;
  }
  get tokenSymbol() {
    return this._tokenSymbol;
  }
  setTokenSymbol(t) {
    return this._requireNotFrozen(), this._tokenSymbol = t, this;
  }
  get treasuryAccountId() {
    return this._treasuryAccountId;
  }
  setTreasuryAccountId(t) {
    return this._requireNotFrozen(), this._treasuryAccountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  get adminKey() {
    return this._adminKey;
  }
  setAdminKey(t) {
    return this._requireNotFrozen(), this._adminKey = t, this;
  }
  get kycKey() {
    return this._kycKey;
  }
  setKycKey(t) {
    return this._requireNotFrozen(), this._kycKey = t, this;
  }
  get freezeKey() {
    return this._freezeKey;
  }
  setFreezeKey(t) {
    return this._requireNotFrozen(), this._freezeKey = t, this;
  }
  get wipeKey() {
    return this._wipeKey;
  }
  setWipeKey(t) {
    return this._requireNotFrozen(), this._wipeKey = t, this;
  }
  get supplyKey() {
    return this._supplyKey;
  }
  setSupplyKey(t) {
    return this._requireNotFrozen(), this._supplyKey = t, this;
  }
  setsupplyKey(t) {
    return this._requireNotFrozen(), this._supplyKey = t, this;
  }
  get expirationTime() {
    return this._expirationTime;
  }
  setExpirationTime(t) {
    return this._requireNotFrozen(), this._expirationTime = t instanceof Timestamp ? t : Timestamp.fromDate(t), this;
  }
  get autoRenewAccountId() {
    return this._autoRenewAccountId;
  }
  setAutoRenewAccountId(t) {
    return this._requireNotFrozen(), this._autoRenewAccountId = t instanceof AccountId ? t : AccountId.fromString(t), this;
  }
  get autoRenewPeriod() {
    return this._autoRenewPeriod;
  }
  setAutoRenewPeriod(t) {
    return this._requireNotFrozen(), this._autoRenewPeriod = t instanceof Duration ? t : new Duration(t), this;
  }
  get tokenMemo() {
    return this._tokenMemo;
  }
  setTokenMemo(t) {
    return this._requireNotFrozen(), this._tokenMemo = t, this;
  }
  get feeScheduleKey() {
    return this._feeScheduleKey;
  }
  setFeeScheduleKey(t) {
    return this._requireNotFrozen(), this._feeScheduleKey = t, this;
  }
  get pauseKey() {
    return this._pauseKey;
  }
  setPauseKey(t) {
    return this._requireNotFrozen(), this._pauseKey = t, this;
  }
  clearTokenMemo() {
    return this._requireNotFrozen(), this._tokenMemo = null, this;
  }
  _validateChecksums(t) {
    this._tokenId != null && this._tokenId.validateChecksum(t), this._treasuryAccountId != null && this._treasuryAccountId.validateChecksum(t), this._autoRenewAccountId != null && this._autoRenewAccountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.token.updateToken(a);
  }
  _getTransactionDataCase() {
    return "tokenUpdate";
  }
  _makeTransactionData() {
    return {
      token: this._tokenId != null ? this._tokenId._toProtobuf() : null,
      name: this.tokenName,
      symbol: this.tokenSymbol,
      treasury: this._treasuryAccountId != null ? this._treasuryAccountId._toProtobuf() : null,
      adminKey: this._adminKey != null ? this._adminKey._toProtobufKey() : null,
      kycKey: this._kycKey != null ? this._kycKey._toProtobufKey() : null,
      freezeKey: this._freezeKey != null ? this._freezeKey._toProtobufKey() : null,
      pauseKey: this._pauseKey != null ? this._pauseKey._toProtobufKey() : null,
      wipeKey: this._wipeKey != null ? this._wipeKey._toProtobufKey() : null,
      supplyKey: this._supplyKey != null ? this._supplyKey._toProtobufKey() : null,
      autoRenewAccount: this._autoRenewAccountId != null ? this._autoRenewAccountId._toProtobuf() : null,
      expiry: this._expirationTime != null ? this._expirationTime._toProtobuf() : null,
      autoRenewPeriod: this._autoRenewPeriod != null ? this._autoRenewPeriod._toProtobuf() : null,
      memo: this._tokenMemo != null ? {
        value: this._tokenMemo
      } : null,
      feeScheduleKey: this._feeScheduleKey != null ? this._feeScheduleKey._toProtobufKey() : null
    };
  }
  _getLogId() {
    return `TokenUpdateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenUpdate",
  TokenUpdateTransaction._fromProtobuf
);
class TokenWipeTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenId = null, this._accountId = null, this._serials = [], this._amount = null, t.tokenId != null && this.setTokenId(t.tokenId), t.accountId != null && this.setAccountId(t.accountId), t.amount != null && this.setAmount(t.amount), t.serials != null && this.setSerials(t.serials);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].tokenWipe;
    return Transaction._fromProtobufTransactions(
      new TokenWipeTransaction({
        tokenId: c.token != null ? TokenId._fromProtobuf(c.token) : void 0,
        accountId: c.account != null ? AccountId._fromProtobuf(c.account) : void 0,
        amount: c.amount != null ? c.amount : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenId() {
    return this._tokenId;
  }
  setTokenId(t) {
    return this._requireNotFrozen(), this._tokenId = typeof t == "string" ? TokenId.fromString(t) : t.clone(), this;
  }
  get accountId() {
    return this._accountId;
  }
  setAccountId(t) {
    return this._requireNotFrozen(), this._accountId = typeof t == "string" ? AccountId.fromString(t) : t.clone(), this;
  }
  get amount() {
    return this._amount;
  }
  setAmount(t) {
    return this._requireNotFrozen(), this._amount = t instanceof long ? t : long.fromValue(t), this;
  }
  _validateChecksums(t) {
    this._tokenId != null && this._tokenId.validateChecksum(t), this._accountId != null && this._accountId.validateChecksum(t);
  }
  get serials() {
    return this._serials;
  }
  setSerials(t) {
    return this._requireNotFrozen(), this._serials = t.map(
      (a) => typeof a == "number" ? long.fromNumber(a) : a
    ), this;
  }
  _execute(t, a) {
    return t.token.wipeTokenAccount(a);
  }
  _getTransactionDataCase() {
    return "tokenWipe";
  }
  _makeTransactionData() {
    return {
      amount: this._amount,
      token: this._tokenId != null ? this._tokenId._toProtobuf() : null,
      account: this._accountId != null ? this._accountId._toProtobuf() : null,
      serialNumbers: this.serials
    };
  }
  _getLogId() {
    return `TokenWipeTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "tokenWipe",
  TokenWipeTransaction._fromProtobuf
);
class TopicCreateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._adminKey = null, this._submitKey = null, this._autoRenewAccountId = null, this._autoRenewPeriod = new Duration(DEFAULT_AUTO_RENEW_PERIOD), this._topicMemo = null, t.adminKey != null && this.setAdminKey(t.adminKey), t.submitKey != null && this.setSubmitKey(t.submitKey), t.autoRenewAccountId != null && this.setAutoRenewAccountId(t.autoRenewAccountId), t.autoRenewPeriod != null && this.setAutoRenewPeriod(t.autoRenewPeriod), t.topicMemo != null && this.setTopicMemo(t.topicMemo);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].consensusCreateTopic;
    return Transaction._fromProtobufTransactions(
      new TopicCreateTransaction({
        adminKey: c.adminKey != null ? Key._fromProtobufKey(c.adminKey) : void 0,
        submitKey: c.submitKey != null ? Key._fromProtobufKey(c.submitKey) : void 0,
        autoRenewAccountId: c.autoRenewAccount != null ? AccountId._fromProtobuf(c.autoRenewAccount) : void 0,
        autoRenewPeriod: c.autoRenewPeriod != null && c.autoRenewPeriod.seconds != null ? c.autoRenewPeriod.seconds : void 0,
        topicMemo: c.memo != null ? c.memo : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get topicMemo() {
    return this._topicMemo;
  }
  getTopicMemo() {
    return this._topicMemo;
  }
  setTopicMemo(t) {
    return this._requireNotFrozen(), this._topicMemo = t, this;
  }
  get adminKey() {
    return this._adminKey;
  }
  getAdminKey() {
    return this._adminKey;
  }
  setAdminKey(t) {
    return this._requireNotFrozen(), this._adminKey = t, this;
  }
  get submitKey() {
    return this._submitKey;
  }
  getSubmitKey() {
    return this._submitKey;
  }
  setSubmitKey(t) {
    return this._requireNotFrozen(), this._submitKey = t, this;
  }
  get autoRenewAccountId() {
    return this._autoRenewAccountId;
  }
  getAutoRenewAccountId() {
    return this._autoRenewAccountId;
  }
  setAutoRenewAccountId(t) {
    return this._requireNotFrozen(), this._autoRenewAccountId = t instanceof AccountId ? t : AccountId.fromString(t), this;
  }
  get autoRenewPeriod() {
    return this._autoRenewPeriod;
  }
  getAutoRenewPeriod() {
    return this._autoRenewPeriod;
  }
  setAutoRenewPeriod(t) {
    return this._requireNotFrozen(), this._autoRenewPeriod = t instanceof Duration ? t : new Duration(t), this;
  }
  _validateChecksums(t) {
    this._autoRenewAccountId != null && this._autoRenewAccountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.consensus.createTopic(a);
  }
  _getTransactionDataCase() {
    return "consensusCreateTopic";
  }
  _makeTransactionData() {
    return {
      adminKey: this._adminKey != null ? this._adminKey._toProtobufKey() : null,
      submitKey: this._submitKey != null ? this._submitKey._toProtobufKey() : null,
      autoRenewAccount: this._autoRenewAccountId != null ? this._autoRenewAccountId._toProtobuf() : null,
      autoRenewPeriod: this._autoRenewPeriod._toProtobuf(),
      memo: this._topicMemo
    };
  }
  _getLogId() {
    return `TopicCreateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "consensusCreateTopic",
  TopicCreateTransaction._fromProtobuf
);
class TopicDeleteTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._topicId = null, t.topicId != null && this.setTopicId(t.topicId);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].consensusDeleteTopic;
    return Transaction._fromProtobufTransactions(
      new TopicDeleteTransaction({
        topicId: c.topicID != null ? TopicId._fromProtobuf(c.topicID) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get topicId() {
    return this._topicId;
  }
  setTopicId(t) {
    return this._requireNotFrozen(), this._topicId = typeof t == "string" ? TopicId.fromString(t) : t.clone(), this;
  }
  _validateChecksums(t) {
    this._topicId != null && this._topicId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.consensus.deleteTopic(a);
  }
  _getTransactionDataCase() {
    return "consensusDeleteTopic";
  }
  _makeTransactionData() {
    return {
      topicID: this._topicId != null ? this._topicId._toProtobuf() : null
    };
  }
  _getLogId() {
    return `TopicDeleteTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "consensusDeleteTopic",
  TopicDeleteTransaction._fromProtobuf
);
class TopicInfo {
  constructor(t) {
    this.topicId = t.topicId, this.topicMemo = t.topicMemo, this.runningHash = t.runningHash, this.sequenceNumber = t.sequenceNumber, this.expirationTime = t.expirationTime, this.adminKey = t.adminKey, this.submitKey = t.submitKey, this.autoRenewPeriod = t.autoRenewPeriod, this.autoRenewAccountId = t.autoRenewAccountId, this.ledgerId = t.ledgerId, Object.freeze(this);
  }
  static _fromProtobuf(t) {
    const a = t.topicInfo;
    return new TopicInfo({
      topicId: TopicId._fromProtobuf(
        t.topicID
      ),
      topicMemo: a.memo != null ? a.memo : "",
      runningHash: a.runningHash != null ? a.runningHash : new Uint8Array(),
      sequenceNumber: a.sequenceNumber != null ? a.sequenceNumber instanceof long ? a.sequenceNumber : long.fromValue(a.sequenceNumber) : long.ZERO,
      expirationTime: a.expirationTime != null ? Timestamp._fromProtobuf(a.expirationTime) : null,
      adminKey: a.adminKey != null ? Key._fromProtobufKey(a.adminKey) : null,
      submitKey: a.submitKey != null ? Key._fromProtobufKey(a.submitKey) : null,
      autoRenewPeriod: a.autoRenewPeriod != null ? new Duration(
        a.autoRenewPeriod.seconds
      ) : null,
      autoRenewAccountId: a.autoRenewAccount != null ? AccountId._fromProtobuf(a.autoRenewAccount) : null,
      ledgerId: a.ledgerId != null ? LedgerId.fromBytes(a.ledgerId) : null
    });
  }
  _toProtobuf() {
    return {
      topicID: this.topicId._toProtobuf(),
      topicInfo: {
        memo: this.topicMemo,
        runningHash: this.runningHash,
        sequenceNumber: this.sequenceNumber,
        expirationTime: this.expirationTime != null ? this.expirationTime._toProtobuf() : null,
        adminKey: this.adminKey != null ? this.adminKey._toProtobufKey() : null,
        submitKey: this.submitKey != null ? this.submitKey._toProtobufKey() : null,
        autoRenewPeriod: this.autoRenewPeriod != null ? this.autoRenewPeriod._toProtobuf() : null,
        autoRenewAccount: this.autoRenewAccountId != null ? this.autoRenewAccountId._toProtobuf() : null
      }
    };
  }
  static fromBytes(t) {
    return TopicInfo._fromProtobuf({
      topicInfo: lib.proto.ConsensusTopicInfo.decode(t)
    });
  }
  toBytes() {
    return lib.proto.ConsensusTopicInfo.encode(
      this._toProtobuf().topicInfo
    ).finish();
  }
}
class TopicInfoQuery extends Query {
  constructor(t = {}) {
    super(), this._topicId = null, t.topicId != null && this.setTopicId(t.topicId);
  }
  static _fromProtobuf(t) {
    const a = t.consensusGetTopicInfo;
    return new TopicInfoQuery({
      topicId: a.topicID != null ? TopicId._fromProtobuf(a.topicID) : void 0
    });
  }
  get topicId() {
    return this._topicId;
  }
  setTopicId(t) {
    return this._topicId = typeof t == "string" ? TopicId.fromString(t) : t.clone(), this;
  }
  async getCost(t) {
    return super.getCost(t);
  }
  _validateChecksums(t) {
    this._topicId != null && this._topicId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.consensus.getTopicInfo(a);
  }
  _mapResponseHeader(t) {
    return t.consensusGetTopicInfo.header;
  }
  _mapResponse(t, a, d) {
    return Promise.resolve(
      TopicInfo._fromProtobuf(
        t.consensusGetTopicInfo
      )
    );
  }
  _onMakeRequest(t) {
    return {
      consensusGetTopicInfo: {
        header: t,
        topicID: this._topicId != null ? this._topicId._toProtobuf() : null
      }
    };
  }
  _getLogId() {
    return `TopicInfoQuery:${(this._paymentTransactionId != null && this._paymentTransactionId.validStart != null ? this._paymentTransactionId.validStart : this._timestamp).toString()}`;
  }
}
QUERY_REGISTRY.set("consensusGetTopicInfo", TopicInfoQuery._fromProtobuf);
class TopicMessageSubmitTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._topicId = null, t.topicId != null && this.setTopicId(t.topicId), this._message = null, t.message != null && this.setMessage(t.message), this._maxChunks = 20, this._chunkSize = CHUNK_SIZE, t.maxChunks != null && this.setMaxChunks(t.maxChunks), t.chunkSize != null && this.setChunkSize(t.chunkSize), this._chunkInfo = null;
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].consensusSubmitMessage;
    return Transaction._fromProtobufTransactions(
      new TopicMessageSubmitTransaction({
        topicId: c.topicID != null ? TopicId._fromProtobuf(c.topicID) : void 0,
        message: c.message != null ? c.message : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get topicId() {
    return this._topicId;
  }
  setTopicId(t) {
    return this._requireNotFrozen(), this._topicId = typeof t == "string" ? TopicId.fromString(t) : t.clone(), this;
  }
  get message() {
    return this._message;
  }
  getMessage() {
    return this._message;
  }
  setMessage(t) {
    return this._requireNotFrozen(), t = requireStringOrUint8Array(t), this._message = t instanceof Uint8Array ? t : encode$1(t), this;
  }
  get maxChunks() {
    return this._maxChunks;
  }
  getMaxChunks() {
    return this._maxChunks;
  }
  setMaxChunks(t) {
    return this._requireNotFrozen(), this._maxChunks = t, this;
  }
  get chunkSize() {
    return this._chunkSize;
  }
  getChunkSize() {
    return this._chunkSize;
  }
  setChunkSize(t) {
    return this._chunkSize = t, this;
  }
  freezeWith(t) {
    if (super.freezeWith(t), this._message == null)
      return this;
    const a = Math.floor(
      (this._message.length + (this._chunkSize - 1)) / this._chunkSize
    );
    if (a > this._maxChunks)
      throw new Error(
        `Message with size ${this._message.length} too long for ${this._maxChunks} chunks`
      );
    const d = this._getTransactionId()._toProtobuf();
    let l = this._getTransactionId();
    this._transactionIds.locked = !1, this._transactions.clear(), this._transactionIds.clear(), this._signedTransactions.clear();
    for (let h = 0; h < a; h++) {
      this._chunkInfo = {
        initialTransactionID: d,
        total: a,
        number: h + 1
      }, this._transactionIds.push(l), this._transactionIds.advance();
      for (const g of this._nodeAccountIds.list)
        this._signedTransactions.push(
          this._makeSignedTransaction(g)
        );
      l = new TransactionId(
        l.accountId,
        new Timestamp(
          l.validStart.seconds,
          l.validStart.nanos.add(1)
        )
      );
    }
    return this._transactionIds.advance(), this._chunkInfo = null, this;
  }
  schedule() {
    if (this._requireNotFrozen(), this._message != null && this._message.length > this._chunkSize)
      throw new Error(
        `cannot schedule \`TopicMessageSubmitTransaction\` with message over ${this._chunkSize} bytes`
      );
    return super.schedule();
  }
  async execute(t, a) {
    return (await this.executeAll(t, a))[0];
  }
  async executeAll(t, a) {
    super._isFrozen() || this.freezeWith(t);
    const d = this._getTransactionId(), l = t.operatorAccountId;
    l != null && l.equals(
      d.accountId
    ) && await super.signWithOperator(t);
    const h = [];
    let g = a;
    for (let c = 0; c < this._transactionIds.length; c++) {
      const x = Date.now();
      h.push(await super.execute(t, g)), g != null && (g = Date.now() - x);
    }
    return h;
  }
  _execute(t, a) {
    return t.consensus.submitMessage(a);
  }
  _getTransactionDataCase() {
    return "consensusSubmitMessage";
  }
  _makeTransactionData() {
    if (this._chunkInfo != null && this._message != null) {
      const a = (this._chunkInfo.number - 1) * this._chunkSize;
      let d = a + this._chunkSize;
      return d > this._message.length && (d = this._message.length), {
        topicID: this._topicId != null ? this._topicId._toProtobuf() : null,
        message: this._message.slice(a, d),
        chunkInfo: this._chunkInfo
      };
    } else
      return {
        topicID: this._topicId != null ? this._topicId._toProtobuf() : null,
        message: this._message
      };
  }
  _getLogId() {
    return `TopicMessageSubmitTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "consensusSubmitMessage",
  TopicMessageSubmitTransaction._fromProtobuf
);
class TopicUpdateTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._topicId = null, t.topicId != null && this.setTopicId(t.topicId), this._topicMemo = null, t.topicMemo != null && this.setTopicMemo(t.topicMemo), this._submitKey = null, t.submitKey != null && this.setSubmitKey(t.submitKey), this._adminKey = null, t.adminKey != null && this.setAdminKey(t.adminKey), this._autoRenewAccountId = null, t.autoRenewAccountId != null && this.setAutoRenewAccountId(t.autoRenewAccountId), this._autoRenewPeriod = null, t.autoRenewPeriod != null && this.setAutoRenewPeriod(t.autoRenewPeriod), this._expirationTime = null, t.expirationTime != null && this.setExpirationTime(t.expirationTime);
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].consensusUpdateTopic;
    return Transaction._fromProtobufTransactions(
      new TopicUpdateTransaction({
        topicId: c.topicID != null ? TopicId._fromProtobuf(c.topicID) : void 0,
        adminKey: c.adminKey != null ? Key._fromProtobufKey(c.adminKey) : void 0,
        submitKey: c.submitKey != null ? Key._fromProtobufKey(c.submitKey) : void 0,
        autoRenewAccountId: c.autoRenewAccount != null ? AccountId._fromProtobuf(c.autoRenewAccount) : void 0,
        autoRenewPeriod: c.autoRenewPeriod != null && c.autoRenewPeriod.seconds != null ? c.autoRenewPeriod.seconds : void 0,
        topicMemo: c.memo != null && c.memo.value != null ? c.memo.value : void 0,
        expirationTime: c.expirationTime != null ? Timestamp._fromProtobuf(c.expirationTime) : void 0
      }),
      t,
      a,
      d,
      l,
      h
    );
  }
  get expirationTime() {
    return this._expirationTime;
  }
  setExpirationTime(t) {
    return this._requireNotFrozen(), this._expirationTime = t instanceof Date ? Timestamp.fromDate(t) : t, this;
  }
  get topicId() {
    return this._topicId;
  }
  setTopicId(t) {
    return this._requireNotFrozen(), this._topicId = typeof t == "string" ? TopicId.fromString(t) : t.clone(), this;
  }
  clearTopicId() {
    return this._requireNotFrozen(), this._topicId = null, this;
  }
  get topicMemo() {
    return this._topicMemo;
  }
  setTopicMemo(t) {
    return this._requireNotFrozen(), this._topicMemo = t, this;
  }
  clearTopicMemo() {
    return this._requireNotFrozen(), this._topicMemo = null, this;
  }
  get adminKey() {
    return this._adminKey;
  }
  setAdminKey(t) {
    return this._requireNotFrozen(), this._adminKey = t, this;
  }
  clearAdminKey() {
    return this._requireNotFrozen(), this._adminKey = null, this;
  }
  get submitKey() {
    return this._submitKey;
  }
  setSubmitKey(t) {
    return this._requireNotFrozen(), this._submitKey = t, this;
  }
  clearSubmitKey() {
    return this._requireNotFrozen(), this._submitKey = null, this;
  }
  get autoRenewAccountId() {
    return this._autoRenewAccountId;
  }
  setAutoRenewAccountId(t) {
    return this._requireNotFrozen(), this._autoRenewAccountId = t instanceof AccountId ? t : AccountId.fromString(t), this;
  }
  clearAutoRenewAccountId() {
    return this._requireNotFrozen(), this._autoRenewAccountId = null, this;
  }
  get autoRenewPeriod() {
    return this._autoRenewPeriod;
  }
  setAutoRenewPeriod(t) {
    return this._requireNotFrozen(), this._autoRenewPeriod = t instanceof Duration ? t : new Duration(t), this;
  }
  _validateChecksums(t) {
    this._topicId != null && this._topicId.validateChecksum(t), this._autoRenewAccountId != null && this._autoRenewAccountId.validateChecksum(t);
  }
  _execute(t, a) {
    return t.consensus.updateTopic(a);
  }
  _getTransactionDataCase() {
    return "consensusUpdateTopic";
  }
  _makeTransactionData() {
    return {
      topicID: this._topicId != null ? this._topicId._toProtobuf() : null,
      adminKey: this._adminKey != null ? this._adminKey._toProtobufKey() : null,
      submitKey: this._submitKey != null ? this._submitKey._toProtobufKey() : null,
      memo: this._topicMemo != null ? {
        value: this._topicMemo
      } : null,
      autoRenewAccount: this._autoRenewAccountId != null ? this._autoRenewAccountId._toProtobuf() : null,
      autoRenewPeriod: this._autoRenewPeriod != null ? this._autoRenewPeriod._toProtobuf() : null,
      expirationTime: this._expirationTime != null ? this._expirationTime._toProtobuf() : null
    };
  }
  _getLogId() {
    return `TopicUpdateTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "consensusUpdateTopic",
  TopicUpdateTransaction._fromProtobuf
);
class NullableTokenDecimalMap extends ObjectMap {
  constructor() {
    super((t) => TokenId.fromString(t));
  }
}
class HbarTransferMap extends ObjectMap {
  constructor() {
    super((t) => AccountId.fromString(t));
  }
  static _fromProtobuf(t) {
    const a = new HbarTransferMap();
    for (const d of t.accountAmounts != null ? t.accountAmounts : []) {
      const l = AccountId._fromProtobuf(
        d.accountID
      );
      a._set(
        l,
        Hbar.fromTinybars(d.amount)
      );
    }
    return a;
  }
}
class TokenNftTransfer {
  constructor(t) {
    this.tokenId = t.tokenId instanceof TokenId ? t.tokenId : TokenId.fromString(t.tokenId), this.senderAccountId = t.senderAccountId instanceof AccountId ? t.senderAccountId : AccountId.fromString(t.senderAccountId), this.receiverAccountId = t.receiverAccountId instanceof AccountId ? t.receiverAccountId : AccountId.fromString(t.receiverAccountId), this.serialNumber = long.fromValue(t.serialNumber), this.isApproved = t.isApproved;
  }
  static _fromProtobuf(t) {
    const a = [];
    for (const d of t) {
      const l = TokenId._fromProtobuf(
        d.token
      );
      for (const h of d.nftTransfers != null ? d.nftTransfers : [])
        a.push(
          new TokenNftTransfer({
            tokenId: l,
            senderAccountId: AccountId._fromProtobuf(
              h.senderAccountID
            ),
            receiverAccountId: AccountId._fromProtobuf(
              h.receiverAccountID
            ),
            serialNumber: h.serialNumber != null ? h.serialNumber : long.ZERO,
            isApproved: h.isApproval == !0
          })
        );
    }
    return a;
  }
  _toProtobuf() {
    return {
      senderAccountID: this.senderAccountId._toProtobuf(),
      receiverAccountID: this.receiverAccountId._toProtobuf(),
      serialNumber: this.serialNumber,
      isApproval: this.isApproved
    };
  }
}
class TransferTransaction extends Transaction {
  constructor(t = {}) {
    super(), this._tokenTransfers = [], this._hbarTransfers = [], this._nftTransfers = [], this._defaultMaxTransactionFee = new Hbar(1);
    for (const a of t.tokenTransfers != null ? t.tokenTransfers : [])
      this.addTokenTransfer(
        a.tokenId,
        a.accountId,
        a.amount
      );
    for (const a of t.hbarTransfers != null ? t.hbarTransfers : [])
      this.addHbarTransfer(a.accountId, a.amount);
    for (const a of t.nftTransfers != null ? t.nftTransfers : [])
      this.addNftTransfer(
        a.tokenId,
        a.serial,
        a.sender,
        a.recipient
      );
  }
  static _fromProtobuf(t, a, d, l, h) {
    const c = h[0].cryptoTransfer, x = new TransferTransaction();
    return x._tokenTransfers = TokenTransfer._fromProtobuf(
      c.tokenTransfers != null ? c.tokenTransfers : []
    ), x._hbarTransfers = Transfer._fromProtobuf(
      c.transfers != null ? c.transfers.accountAmounts != null ? c.transfers.accountAmounts : [] : []
    ), x._nftTransfers = TokenNftTransfer._fromProtobuf(
      c.tokenTransfers != null ? c.tokenTransfers : []
    ), Transaction._fromProtobufTransactions(
      x,
      t,
      a,
      d,
      l,
      h
    );
  }
  get tokenTransfers() {
    const t = new TokenTransferMap();
    for (const a of this._tokenTransfers) {
      let d = t.get(a.tokenId);
      d != null ? d._set(a.accountId, a.amount) : (d = new TokenTransferAccountMap(), d._set(a.accountId, a.amount), t._set(a.tokenId, d));
    }
    return t;
  }
  _addTokenTransfer(t, a, d, l) {
    this._requireNotFrozen();
    const h = t instanceof TokenId ? t : TokenId.fromString(t), g = a instanceof AccountId ? a : AccountId.fromString(a), c = d instanceof long ? d : long.fromNumber(d);
    for (const x of this._tokenTransfers)
      if (x.tokenId.compare(h) === 0 && x.accountId.compare(g) === 0)
        return x.amount = x.amount.add(c), x.expectedDecimals = null, this;
    return this._tokenTransfers.push(
      new TokenTransfer({
        tokenId: t,
        accountId: a,
        expectedDecimals: null,
        amount: d,
        isApproved: l
      })
    ), this;
  }
  addTokenTransfer(t, a, d) {
    return this._addTokenTransfer(t, a, d, !1);
  }
  addApprovedTokenTransfer(t, a, d) {
    return this._addTokenTransfer(t, a, d, !0);
  }
  addTokenTransferWithDecimals(t, a, d, l) {
    this._requireNotFrozen();
    const h = t instanceof TokenId ? t : TokenId.fromString(t), g = a instanceof AccountId ? a : AccountId.fromString(a), c = d instanceof long ? d : long.fromNumber(d);
    let x = !1;
    for (const R of this._tokenTransfers)
      if (R.tokenId.compare(h) === 0) {
        if (R.expectedDecimals != null && R.expectedDecimals !== l)
          throw new Error("expected decimals mis-match");
        R.expectedDecimals = l, R.accountId.compare(g) === 0 && (R.amount = R.amount.add(c), R.expectedDecimals = l, x = !0);
      }
    return x ? this : (this._tokenTransfers.push(
      new TokenTransfer({
        tokenId: t,
        accountId: a,
        expectedDecimals: l,
        amount: d,
        isApproved: !1
      })
    ), this);
  }
  get tokenIdDecimals() {
    const t = new NullableTokenDecimalMap();
    for (const a of this._tokenTransfers)
      t._set(a.tokenId, a.expectedDecimals);
    return t;
  }
  get hbarTransfers() {
    const t = new HbarTransferMap();
    for (const a of this._hbarTransfers)
      t._set(a.accountId, a.amount);
    return t;
  }
  _addHbarTransfer(t, a, d) {
    this._requireNotFrozen();
    const l = t instanceof AccountId ? t.clone() : AccountId.fromString(t), h = a instanceof Hbar ? a : new Hbar(a);
    for (const g of this._hbarTransfers)
      if (g.accountId.compare(l) === 0)
        return g.amount = Hbar.fromTinybars(
          g.amount.toTinybars().add(h.toTinybars())
        ), this;
    return this._hbarTransfers.push(
      new Transfer({
        accountId: l,
        amount: h,
        isApproved: d
      })
    ), this;
  }
  addHbarTransfer(t, a) {
    return this._addHbarTransfer(t, a, !1);
  }
  addApprovedHbarTransfer(t, a) {
    return this._addHbarTransfer(t, a, !0);
  }
  _validateChecksums(t) {
    for (const a of this._hbarTransfers)
      a.accountId.validateChecksum(t);
    for (const a of this._tokenTransfers)
      a.tokenId.validateChecksum(t), a.accountId.validateChecksum(t);
    for (const a of this._nftTransfers)
      a.tokenId.validateChecksum(t), a.senderAccountId.validateChecksum(t), a.receiverAccountId.validateChecksum(t);
  }
  get nftTransfers() {
    const t = new TokenNftTransferMap();
    for (const a of this._nftTransfers) {
      const d = t.get(a.tokenId), l = {
        sender: a.senderAccountId,
        recipient: a.receiverAccountId,
        serial: a.serialNumber,
        isApproved: a.isApproved
      };
      d != null ? d.push(l) : t._set(a.tokenId, [l]);
    }
    return t;
  }
  _addNftTransfer(t, a, d, l, h) {
    this._requireNotFrozen();
    let g, c, x;
    if (a instanceof NftId)
      g = a, c = typeof d == "string" ? AccountId.fromString(d) : d, x = typeof l == "string" ? AccountId.fromString(l) : l;
    else if (a instanceof TokenId)
      g = new NftId(
        a,
        d
      ), c = typeof l == "string" ? AccountId.fromString(l) : l, x = typeof h == "string" ? AccountId.fromString(h) : h;
    else
      try {
        g = NftId.fromString(a), c = typeof d == "string" ? AccountId.fromString(d) : d, x = typeof l == "string" ? AccountId.fromString(
          l
        ) : l;
      } catch {
        const B = TokenId.fromString(a);
        g = new NftId(
          B,
          d
        ), c = typeof l == "string" ? AccountId.fromString(
          l
        ) : l, x = typeof h == "string" ? AccountId.fromString(h) : h;
      }
    for (const R of this._nftTransfers)
      if (R.tokenId.compare(g.tokenId) === 0 && R.serialNumber.compare(g.serial) === 0)
        return R.senderAccountId = c, R.receiverAccountId = x, this;
    return this._nftTransfers.push(
      new TokenNftTransfer({
        tokenId: g.tokenId,
        serialNumber: g.serial,
        senderAccountId: c,
        receiverAccountId: x,
        isApproved: t
      })
    ), this;
  }
  addNftTransfer(t, a, d, l) {
    return this._addNftTransfer(
      !1,
      t,
      a,
      d,
      l
    );
  }
  addApprovedNftTransfer(t, a, d, l) {
    return this._addNftTransfer(
      !0,
      t,
      a,
      d,
      l
    );
  }
  setHbarTransferApproval(t, a) {
    const d = typeof t == "string" ? AccountId.fromString(t) : t;
    for (const l of this._hbarTransfers)
      l.accountId.compare(d) === 0 && (l.isApproved = a);
    return this;
  }
  setTokenTransferApproval(t, a, d) {
    const l = typeof t == "string" ? TokenId.fromString(t) : t, h = typeof a == "string" ? AccountId.fromString(a) : a;
    for (const g of this._tokenTransfers)
      g.tokenId.compare(l) === 0 && g.accountId.compare(h) === 0 && (g.isApproved = d);
    return this;
  }
  setNftTransferApproval(t, a) {
    const d = typeof t == "string" ? NftId.fromString(t) : t;
    for (const l of this._nftTransfers)
      l.tokenId.compare(d.tokenId) === 0 && l.serialNumber.compare(d.serial) === 0 && (l.isApproved = a);
    return this;
  }
  _execute(t, a) {
    return t.crypto.cryptoTransfer(a);
  }
  _getTransactionDataCase() {
    return "cryptoTransfer";
  }
  _makeTransactionData() {
    const t = [];
    this._tokenTransfers.sort((l, h) => {
      const g = l.tokenId.compare(h.tokenId);
      return g !== 0 ? g : l.accountId.compare(h.accountId);
    }), this._nftTransfers.sort((l, h) => {
      const g = l.senderAccountId.compare(
        h.senderAccountId
      );
      if (g != 0)
        return g;
      const c = l.receiverAccountId.compare(
        h.receiverAccountId
      );
      return c != 0 ? c : l.serialNumber.compare(h.serialNumber);
    });
    let a = 0, d = 0;
    for (; a < this._tokenTransfers.length || d < this._nftTransfers.length; )
      if (a < this._tokenTransfers.length && d < this._nftTransfers.length) {
        const l = this._tokenTransfers[a].tokenId, h = this._nftTransfers[d].tokenId, g = t.length > 0 ? t[t.length - 1] : null, c = g != null ? g.tokenId : null;
        if (g != null && c != null && c.compare(l) === 0) {
          g.transfers.push(this._tokenTransfers[a++]);
          continue;
        }
        if (g != null && c != null && c.compare(h) === 0) {
          g.nftTransfers.push(this._nftTransfers[d++]);
          continue;
        }
        const x = l.compare(h);
        x === 0 ? t.push({
          tokenId: l,
          expectedDecimals: this._tokenTransfers[a].expectedDecimals,
          transfers: [this._tokenTransfers[a++]],
          nftTransfers: [this._nftTransfers[d++]]
        }) : x < 0 ? t.push({
          tokenId: l,
          expectedDecimals: this._tokenTransfers[a].expectedDecimals,
          transfers: [this._tokenTransfers[a++]],
          nftTransfers: []
        }) : t.push({
          tokenId: h,
          expectedDecimals: null,
          transfers: [],
          nftTransfers: [this._nftTransfers[d++]]
        });
      } else if (a < this._tokenTransfers.length) {
        const l = this._tokenTransfers[a].tokenId;
        let h;
        for (const c of t)
          c.tokenId.compare(l) === 0 && (h = c);
        const g = h != null ? h.tokenId : null;
        if (h != null && g != null && g.compare(l) === 0) {
          h.transfers.push(this._tokenTransfers[a++]);
          continue;
        }
        t.push({
          tokenId: l,
          expectedDecimals: this._tokenTransfers[a].expectedDecimals,
          transfers: [this._tokenTransfers[a++]],
          nftTransfers: []
        });
      } else if (d < this._nftTransfers.length) {
        const l = this._nftTransfers[d].tokenId;
        let h;
        for (const c of t)
          c.tokenId.compare(l) === 0 && (h = c);
        const g = h != null ? h.tokenId : null;
        if (h != null && g != null && g.compare(l) === 0) {
          h.nftTransfers.push(this._nftTransfers[d++]);
          continue;
        }
        t.push({
          tokenId: l,
          expectedDecimals: null,
          transfers: [],
          nftTransfers: [this._nftTransfers[d++]]
        });
      }
    return this._hbarTransfers.sort((l, h) => l.accountId.compare(h.accountId)), {
      transfers: {
        accountAmounts: this._hbarTransfers.map((l) => ({
          accountID: l.accountId._toProtobuf(),
          amount: l.amount.toTinybars(),
          isApproval: l.isApproved
        }))
      },
      tokenTransfers: t.map((l) => ({
        token: l.tokenId._toProtobuf(),
        expectedDecimals: l.expectedDecimals != null ? { value: l.expectedDecimals } : null,
        transfers: l.transfers.map(
          (h) => h._toProtobuf()
        ),
        nftTransfers: l.nftTransfers.map(
          (h) => h._toProtobuf()
        )
      }))
    };
  }
  _getLogId() {
    return `TransferTransaction:${this._transactionIds.current.validStart.toString()}`;
  }
}
TRANSACTION_REGISTRY.set(
  "cryptoTransfer",
  TransferTransaction._fromProtobuf
);
pfGlobalThisOrFallback().console;
Object.assign({}, { nullTime, epochTime, unixTime, isoTime });
function nullTime() {
  return !1;
}
function epochTime() {
  return Date.now();
}
function unixTime() {
  return Math.round(Date.now() / 1e3);
}
function isoTime() {
  return new Date(Date.now()).toISOString();
}
function pfGlobalThisOrFallback() {
  function u(t) {
    return typeof t < "u" && t;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return u(self) || u(window) || u(this) || {};
  }
}
class LogLevel {
  constructor(t) {
    this._name = t, Object.freeze(this);
  }
  toString() {
    switch (this) {
      case LogLevel.Silent:
        return "silent";
      case LogLevel.Trace:
        return "trace";
      case LogLevel.Debug:
        return "debug";
      case LogLevel.Info:
        return "info";
      case LogLevel.Warn:
        return "warn";
      case LogLevel.Error:
        return "error";
      case LogLevel.Fatal:
        return "fatal";
      default:
        return `Unknown log level (${this._name})`;
    }
  }
  static _fromString(t) {
    switch (t) {
      case "silent":
        return LogLevel.Silent;
      case "trace":
        return LogLevel.Trace;
      case "debug":
        return LogLevel.Debug;
      case "info":
        return LogLevel.Info;
      case "warn":
        return LogLevel.Warn;
      case "error":
        return LogLevel.Error;
      case "fatal":
        return LogLevel.Fatal;
      default:
        throw new Error(`Unknown log level: ${t}`);
    }
  }
}
LogLevel.Silent = new LogLevel("silent");
LogLevel.Trace = new LogLevel("trace");
LogLevel.Debug = new LogLevel("debug");
LogLevel.Info = new LogLevel("info");
LogLevel.Warn = new LogLevel("warn");
LogLevel.Error = new LogLevel("error");
LogLevel.Fatal = new LogLevel("fatal");
class CostQuery extends Executable {
  constructor(t) {
    super(), this._query = t, this._grpcDeadline = t._grpcDeadline, this._requestTimeout = t._requestTimeout, this._nodeAccountIds = t._nodeAccountIds.clone(), this._operator = t._operator, this._header = null;
  }
  _getTransactionId() {
    return this._query._getTransactionId();
  }
  _getLogId() {
    return `CostQuery:${this._query._getLogId()}`;
  }
  async _beforeExecute(t) {
    if (t == null)
      throw new Error("Cannot do CostQuery without Client");
    const a = this._operator != null ? this._operator : t._operator;
    if (a == null)
      throw new Error(
        "`client` must have an `operator` or an explicit payment transaction must be provided"
      );
    this._query._nodeAccountIds.isEmpty && this._query._nodeAccountIds.setList(
      t._network.getNodeAccountIdsForExecute()
    );
    const d = TransactionId.generate(a.accountId);
    this._query.paymentTransactionId == null && this._query.setPaymentTransactionId(d);
    const l = this._getLogId(), h = new AccountId(0), g = TransactionId.generate(new AccountId(0)), c = new Hbar(0);
    this._logger && this._logger.debug(
      `[${l}] making a payment transaction for node ${h.toString()} and transaction ID ${g.toString()} with amount ${c.toString()}`
    ), this._header = {
      payment: await _makePaymentTransaction(
        g,
        new AccountId(0),
        a,
        c
      ),
      responseType: lib.proto.ResponseType.COST_ANSWER
    };
  }
  _makeRequestAsync() {
    return Promise.resolve(
      this._query._onMakeRequest(
        this._header
      )
    );
  }
  _shouldRetry(t, a) {
    return this._query._shouldRetry(t, a);
  }
  _mapStatusError(t, a) {
    return this._query._mapStatusError(t, a);
  }
  _mapResponse(t, a, d) {
    const l = this._query._mapResponseHeader(t).cost;
    return Promise.resolve(
      Hbar.fromTinybars(l)
    );
  }
  _execute(t, a) {
    return this._query._execute(t, a);
  }
  _requestToBytes(t) {
    return this._query._requestToBytes(t);
  }
  _responseToBytes(t) {
    return this._query._responseToBytes(t);
  }
}
COST_QUERY.push((u) => new CostQuery(u));
NodeAddressBook._fromProtobuf(
  lib.proto.NodeAddressBook.decode(
    decode$6(
      "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"
    )
  )
);
NodeAddressBook._fromProtobuf(
  lib.proto.NodeAddressBook.decode(
    decode$6(
      "0a7f0a0c33342e39342e3130362e363110a388031a05302e302e33320218033a606131373165336261383334373637343761656232653261633464306531313563616161623931383230336230646665316364656162343433343338666332383961626338626138613661666638336462356631623333343034366461383863380a80010a0d35302e31382e3133322e32313110a388031a05302e302e33320218033a606131373165336261383334373637343761656232653261633464306531313563616161623931383230336230646665316364656162343433343338666332383961626338626138613661666638336462356631623333343034366461383863380a81010a0e3133382e39312e3134322e32313910a388031a05302e302e33320218033a606131373165336261383334373637343761656232653261633464306531313563616161623931383230336230646665316364656162343433343338666332383961626338626138613661666638336462356631623333343034366461383863380a82010a0d33352e3233372e3131392e353510a388031a05302e302e342801320218043a603734303964656332653439346236323765653439633639623239346265316365616562636133666463616633363738396538386663376435623065656635353631663532623832643335313931613339633266626564363032373236373136360a7f0a0a332e3231322e362e313310a388031a05302e302e342801320218043a603734303964656332653439346236323765653439633639623239346265316365616562636133666463616633363738396538386663376435623065656635353631663532623832643335313931613339633266626564363032373236373136360a82010a0d35322e3136382e37362e32343110a388031a05302e302e342801320218043a603734303964656332653439346236323765653439633639623239346265316365616562636133666463616633363738396538386663376435623065656635353631663532623832643335313931613339633266626564363032373236373136360a82010a0d33352e3234352e32372e31393310a388031a05302e302e352802320218053a603962313431363538346134613338306262383661366337643732303764386165646462633362363365613330353939383235356263653833353162613462356463613532633932383261353461366265643630646536336365303361616132340a80010a0b35322e32302e31382e383610a388031a05302e302e352802320218053a603962313431363538346134613338306262383661366337643732303764386165646462633362363365613330353939383235356263653833353162613462356463613532633932383261353461366265643630646536336365303361616132340a81010a0c34302e37392e38332e31323410a388031a05302e302e352802320218053a603962313431363538346134613338306262383661366337643732303764386165646462633362363365613330353939383235356263653833353162613462356463613532633932383261353461366265643630646536336365303361616132340a82010a0d33342e38332e3131322e31313610a388031a05302e302e362803320218063a603634383636383562346536653063623936333437326330316665393939333166643965346334343838376261383334323361653766656564323264363438343834636638613362633563636361366133373338376266393664333836373238300a81010a0c35342e37302e3139322e333310a388031a05302e302e362803320218063a603634383636383562346536653063623936333437326330316665393939333166643965346334343838376261383334323361653766656564323264363438343834636638613362633563636361366133373338376266393664333836373238300a81010a0c35322e3138332e34352e363510a388031a05302e302e362803320218063a603634383636383562346536653063623936333437326330316665393939333166643965346334343838376261383334323361653766656564323264363438343834636638613362633563636361366133373338376266393664333836373238300a80010a0b33342e39342e3136302e3410a388031a05302e302e372804320218073a603339653930393931356138353238303330313534613663373730393530633762343737376261343031333537633065363138373635343231356363323061616363646438653566663239653963346439356366343130316661363862653435630a83010a0e35342e3137362e3139392e31303910a388031a05302e302e372804320218073a603339653930393931356138353238303330313534613663373730393530633762343737376261343031333537633065363138373635343231356363323061616363646438653566663239653963346439356366343130316661363862653435630a82010a0d31332e36342e3138312e31333610a388031a05302e302e372804320218073a603339653930393931356138353238303330313534613663373730393530633762343737376261343031333537633065363138373635343231356363323061616363646438653566663239653963346439356366343130316661363862653435630a83010a0e33342e3130362e3130322e32313810a388031a05302e302e382805320218083a606134343837346137616131623337373431613037316164616165373866623135326236393664316335386438646566626531643832333034353332613063303139656539366363313964373536383635373864333961316536633331613165650a82010a0d33352e3135352e34392e31343710a388031a05302e302e382805320218083a606134343837346137616131623337373431613037316164616165373866623135326236393664316335386438646566626531643832333034353332613063303139656539366363313964373536383635373864333961316536633331613165650a81010a0c31332e37382e3233382e333210a388031a05302e302e382805320218083a606134343837346137616131623337373431613037316164616165373866623135326236393664316335386438646566626531643832333034353332613063303139656539366363313964373536383635373864333961316536633331613165650a83010a0e33342e3133332e3139372e32333010a388031a05302e302e392806320218093a603639383332613733613336303265386431666265356164353864316332363337613162363732643731656538376166313064623634386562393161666232323832353362316634376535376433643461343466663534376233333934616132320a82010a0d35322e31342e3235322e32303710a388031a05302e302e392806320218093a603639383332613733613336303265386431666265356164353864316332363337613162363732643731656538376166313064623634386562393161666232323832353362316634376535376433643461343466663534376233333934616132320a82010a0d35322e3136352e31372e32333110a388031a05302e302e392806320218093a60363938333261373361333630326538643166626535616435386431633236333761316236373264373165653837616631306462363438656239316166623232383235336231663437653537643364346134346666353437623333393461613232"
    )
  )
);
NodeAddressBook._fromProtobuf(
  lib.proto.NodeAddressBook.decode(
    decode$6(
      "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"
    )
  )
);
new AccountId(3), new AccountId(4), new AccountId(5), new AccountId(6), new AccountId(7), new AccountId(8), new AccountId(9), new AccountId(10), new AccountId(11), new AccountId(12), new AccountId(13), new AccountId(14), new AccountId(15), new AccountId(16), new AccountId(17), new AccountId(19), new AccountId(20), new AccountId(21), new AccountId(22), new AccountId(23), new AccountId(24), new AccountId(25), new AccountId(26), new AccountId(27), new AccountId(28), new AccountId(29);
new AccountId(3), new AccountId(4), new AccountId(5), new AccountId(6), new AccountId(7), new AccountId(8), new AccountId(9);
new AccountId(3), new AccountId(4), new AccountId(5), new AccountId(6), new AccountId(7), new AccountId(8), new AccountId(9);
new AccountId(3);
new AccountId(3);
const ENV = process.env.NEXT_PUBLIC_ENV || ENVIRONMENT.PROD, YIELD_API_URL = process.env.NEXT_PUBLIC_YIELD_API_URL, UNIVERSE_API_URL = process.env.NEXT_PUBLIC_UNIVERSE_API_URL, yieldBaseURL = YIELD_API_URL || DEFAULT_YIELD_URL[ENV], universeBaseURL = UNIVERSE_API_URL || DEFAULT_UNIVERSE_URL[ENV];
function fromBase64(u) {
  const t = Buffer.from(u, "base64");
  return Transaction.fromBytes(t);
}
function getHashPackData(u, t) {
  const a = u.toBytes(), d = t.topic, l = {
    topic: d,
    byteArray: a,
    metadata: {
      accountToSign: t.address,
      returnTransaction: t.returnTransaction
    }
  };
  return { topic: d, transaction: l };
}
const yieldAxiosClient = axios.create({
  baseURL: yieldBaseURL
}), universeAxiosClient = axios.create({
  baseURL: universeBaseURL
}), STADER_CLIENT_ID = "8e156db4-59ab-46e8-9ef4-17aac2d9fb96", sdkPostApi = async ({ action: u, token: t, chainId: a, ...d }) => {
  const l = PATH[t];
  l || console.error("couldn't find api subpath for the token :", t);
  const h = d.input ? d.input : {};
  return (await yieldAxiosClient.post(`${l}/${u}?clientId=${STADER_CLIENT_ID}`, {
    ...h,
    chainId: a
  })).data;
}, getDappData = async ({ token: u, query: t }) => {
  const a = DAPPPATH[u];
  return a || console.error("couldn't find api subpath for the token :", u), (await universeAxiosClient.get(`${a}/${t}`)).data;
}, getStaderTVL = async () => (await universeAxiosClient.get("/common/tvl")).data, getGasFees = async (u) => await getDappData({ token: u, query: QUERY.GAS_FEES }), getTVL = async (u) => await getDappData({ token: u, query: QUERY.TVL }), getAPY = async (u) => await getDappData({ token: u, query: QUERY.APY }), getExchangeRate = async (u) => await getDappData({ token: u, query: QUERY.EXCHANGE_RATE }), getTokenPrices = async (u) => (await universeAxiosClient.get(`/coingecko/simple/price?ids=${u.join(",")}&vs_currencies=usd`)).data, getETHSafeMode = async () => await getDappData({ token: TOKEN.ETHX, query: QUERY.GAS_FEES }), getETHNodeOperatorBond = async () => await getDappData({ token: TOKEN.ETHX, query: QUERY.NODE_OPERATOR_BOND }), getETHNodeOperatorCount = async () => await getDappData({ token: TOKEN.ETHX, query: QUERY.NODE_OPERATOR_COUNT }), getETHRatedNetworkOverview = async () => await getDappData({ token: TOKEN.ETHX, query: QUERY.RATED_NETWORK_OVERVIEW }), version = "units/5.2.0", logger = new Logger(version), names = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function parseUnits(u, t) {
  if (typeof u != "string" && logger.throwArgumentError("value must be a string", "value", u), typeof t == "string") {
    const a = names.indexOf(t);
    a !== -1 && (t = 3 * a);
  }
  return parseFixed(u, t != null ? t : 18);
}
function parseEther(u) {
  return parseUnits(u, 18);
}
var TX_TYPES = /* @__PURE__ */ ((u) => (u.STAKE = "stake", u.UNSTAKE = "unstake", u.WITHDRAW = "withdraw", u.ALLOWANCE = "allowance", u.GET_ALLOWANCE = "getAllowance", u.GET_UNSTAKES = "getUnstakes", u.LIMITS = "limits", u.PENALTY = "penalty", u.GET_ASSOCIATED_TOKENS = "getAssociatedTokens", u.ASSOCIATE_TOKEN = "associateToken", u))(TX_TYPES || {});
const ALLOWED_TX_REQUEST_KEYS = {
  chainId: !0,
  data: !0,
  gasLimit: !0,
  gasPrice: !0,
  nonce: !0,
  to: !0,
  value: !0,
  type: !0,
  accessList: !0,
  maxFeePerGas: !0,
  maxPriorityFeePerGas: !0
}, initMetaData = {
  connectorID: "",
  isNativeChain: !0,
  topic: ""
}, buildTxRequest = (u) => {
  var h;
  console.log("txString", u);
  const t = Transaction$1.fromSerializedTx(Buffer.from(u, "hex"));
  console.log("tx", t);
  const a = (h = t.to) == null ? void 0 : h.buf.toString("hex");
  console.log("toAddress", a);
  const d = { ...t, to: a };
  return Object.keys(d).forEach((g) => {
    g in ALLOWED_TX_REQUEST_KEYS || delete d[g];
  }), console.log("txRequest", d), d;
};
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var u = React, t = Symbol.for("react.element"), a = Symbol.for("react.fragment"), d = Object.prototype.hasOwnProperty, l = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, h = { key: !0, ref: !0, __self: !0, __source: !0 };
  function g(c, x, R) {
    var B, j = {}, o = null, e = null;
    R !== void 0 && (o = "" + R), x.key !== void 0 && (o = "" + x.key), x.ref !== void 0 && (e = x.ref);
    for (B in x)
      d.call(x, B) && !h.hasOwnProperty(B) && (j[B] = x[B]);
    if (c && c.defaultProps)
      for (B in x = c.defaultProps, x)
        j[B] === void 0 && (j[B] = x[B]);
    return { $$typeof: t, type: c, key: o, ref: e, props: j, _owner: l.current };
  }
  return reactJsxRuntime_production_min.Fragment = a, reactJsxRuntime_production_min.jsx = g, reactJsxRuntime_production_min.jsxs = g, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function() {
    var u = React, t = Symbol.for("react.element"), a = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), l = Symbol.for("react.strict_mode"), h = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), c = Symbol.for("react.context"), x = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), B = Symbol.for("react.suspense_list"), j = Symbol.for("react.memo"), o = Symbol.for("react.lazy"), e = Symbol.for("react.offscreen"), n = Symbol.iterator, i = "@@iterator";
    function y(P) {
      if (P === null || typeof P != "object")
        return null;
      var H = n && P[n] || P[i];
      return typeof H == "function" ? H : null;
    }
    var m = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function U(P) {
      {
        for (var H = arguments.length, q = new Array(H > 1 ? H - 1 : 0), Q = 1; Q < H; Q++)
          q[Q - 1] = arguments[Q];
        be("error", P, q);
      }
    }
    function be(P, H, q) {
      {
        var Q = m.ReactDebugCurrentFrame, re = Q.getStackAddendum();
        re !== "" && (H += "%s", q = q.concat([re]));
        var ae = q.map(function(te) {
          return String(te);
        });
        ae.unshift("Warning: " + H), Function.prototype.apply.call(console[P], console, ae);
      }
    }
    var Ke = !1, ze = !1, Pe = !1, st = !1, G = !1, z;
    z = Symbol.for("react.module.reference");
    function W(P) {
      return !!(typeof P == "string" || typeof P == "function" || P === d || P === h || G || P === l || P === R || P === B || st || P === e || Ke || ze || Pe || typeof P == "object" && P !== null && (P.$$typeof === o || P.$$typeof === j || P.$$typeof === g || P.$$typeof === c || P.$$typeof === x || P.$$typeof === z || P.getModuleId !== void 0));
    }
    function F(P, H, q) {
      var Q = P.displayName;
      if (Q)
        return Q;
      var re = H.displayName || H.name || "";
      return re !== "" ? q + "(" + re + ")" : q;
    }
    function k(P) {
      return P.displayName || "Context";
    }
    function T(P) {
      if (P == null)
        return null;
      if (typeof P.tag == "number" && U("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof P == "function")
        return P.displayName || P.name || null;
      if (typeof P == "string")
        return P;
      switch (P) {
        case d:
          return "Fragment";
        case a:
          return "Portal";
        case h:
          return "Profiler";
        case l:
          return "StrictMode";
        case R:
          return "Suspense";
        case B:
          return "SuspenseList";
      }
      if (typeof P == "object")
        switch (P.$$typeof) {
          case c:
            var H = P;
            return k(H) + ".Consumer";
          case g:
            var q = P;
            return k(q._context) + ".Provider";
          case x:
            return F(P, P.render, "ForwardRef");
          case j:
            var Q = P.displayName || null;
            return Q !== null ? Q : T(P.type) || "Memo";
          case o: {
            var re = P, ae = re._payload, te = re._init;
            try {
              return T(te(ae));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var p = Object.assign, b = 0, _, v, S, E, w, A, I;
    function C() {
    }
    C.__reactDisabledLog = !0;
    function X() {
      {
        if (b === 0) {
          _ = console.log, v = console.info, S = console.warn, E = console.error, w = console.group, A = console.groupCollapsed, I = console.groupEnd;
          var P = {
            configurable: !0,
            enumerable: !0,
            value: C,
            writable: !0
          };
          Object.defineProperties(console, {
            info: P,
            log: P,
            warn: P,
            error: P,
            group: P,
            groupCollapsed: P,
            groupEnd: P
          });
        }
        b++;
      }
    }
    function D() {
      {
        if (b--, b === 0) {
          var P = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: p({}, P, {
              value: _
            }),
            info: p({}, P, {
              value: v
            }),
            warn: p({}, P, {
              value: S
            }),
            error: p({}, P, {
              value: E
            }),
            group: p({}, P, {
              value: w
            }),
            groupCollapsed: p({}, P, {
              value: A
            }),
            groupEnd: p({}, P, {
              value: I
            })
          });
        }
        b < 0 && U("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var V = m.ReactCurrentDispatcher, Z;
    function J(P, H, q) {
      {
        if (Z === void 0)
          try {
            throw Error();
          } catch (re) {
            var Q = re.stack.trim().match(/\n( *(at )?)/);
            Z = Q && Q[1] || "";
          }
        return `
` + Z + P;
      }
    }
    var ee = !1, he;
    {
      var le = typeof WeakMap == "function" ? WeakMap : Map;
      he = new le();
    }
    function ie(P, H) {
      if (!P || ee)
        return "";
      {
        var q = he.get(P);
        if (q !== void 0)
          return q;
      }
      var Q;
      ee = !0;
      var re = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ae;
      ae = V.current, V.current = null, X();
      try {
        if (H) {
          var te = function() {
            throw Error();
          };
          if (Object.defineProperty(te.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(te, []);
            } catch (Ge) {
              Q = Ge;
            }
            Reflect.construct(P, [], te);
          } else {
            try {
              te.call();
            } catch (Ge) {
              Q = Ge;
            }
            P.call(te.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ge) {
            Q = Ge;
          }
          P();
        }
      } catch (Ge) {
        if (Ge && Q && typeof Ge.stack == "string") {
          for (var ge = Ge.stack.split(`
`), pe = Q.stack.split(`
`), Ie = ge.length - 1, we = pe.length - 1; Ie >= 1 && we >= 0 && ge[Ie] !== pe[we]; )
            we--;
          for (; Ie >= 1 && we >= 0; Ie--, we--)
            if (ge[Ie] !== pe[we]) {
              if (Ie !== 1 || we !== 1)
                do
                  if (Ie--, we--, we < 0 || ge[Ie] !== pe[we]) {
                    var Ue = `
` + ge[Ie].replace(" at new ", " at ");
                    return P.displayName && Ue.includes("<anonymous>") && (Ue = Ue.replace("<anonymous>", P.displayName)), typeof P == "function" && he.set(P, Ue), Ue;
                  }
                while (Ie >= 1 && we >= 0);
              break;
            }
        }
      } finally {
        ee = !1, V.current = ae, D(), Error.prepareStackTrace = re;
      }
      var Ye = P ? P.displayName || P.name : "", Qe = Ye ? J(Ye) : "";
      return typeof P == "function" && he.set(P, Qe), Qe;
    }
    function Ne(P, H, q) {
      return ie(P, !1);
    }
    function ue(P) {
      var H = P.prototype;
      return !!(H && H.isReactComponent);
    }
    function se(P, H, q) {
      if (P == null)
        return "";
      if (typeof P == "function")
        return ie(P, ue(P));
      if (typeof P == "string")
        return J(P);
      switch (P) {
        case R:
          return J("Suspense");
        case B:
          return J("SuspenseList");
      }
      if (typeof P == "object")
        switch (P.$$typeof) {
          case x:
            return Ne(P.render);
          case j:
            return se(P.type, H, q);
          case o: {
            var Q = P, re = Q._payload, ae = Q._init;
            try {
              return se(ae(re), H, q);
            } catch {
            }
          }
        }
      return "";
    }
    var ut = Object.prototype.hasOwnProperty, qe = {}, ve = m.ReactDebugCurrentFrame;
    function ot(P) {
      if (P) {
        var H = P._owner, q = se(P.type, P._source, H ? H.type : null);
        ve.setExtraStackFrame(q);
      } else
        ve.setExtraStackFrame(null);
    }
    function He(P, H, q, Q, re) {
      {
        var ae = Function.call.bind(ut);
        for (var te in P)
          if (ae(P, te)) {
            var ge = void 0;
            try {
              if (typeof P[te] != "function") {
                var pe = Error((Q || "React class") + ": " + q + " type `" + te + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof P[te] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw pe.name = "Invariant Violation", pe;
              }
              ge = P[te](H, te, Q, q, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ie) {
              ge = Ie;
            }
            ge && !(ge instanceof Error) && (ot(re), U("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Q || "React class", q, te, typeof ge), ot(null)), ge instanceof Error && !(ge.message in qe) && (qe[ge.message] = !0, ot(re), U("Failed %s type: %s", q, ge.message), ot(null));
          }
      }
    }
    var Ae = Array.isArray;
    function ct(P) {
      return Ae(P);
    }
    function Ve(P) {
      {
        var H = typeof Symbol == "function" && Symbol.toStringTag, q = H && P[Symbol.toStringTag] || P.constructor.name || "Object";
        return q;
      }
    }
    function _e(P) {
      try {
        return lt(P), !1;
      } catch {
        return !0;
      }
    }
    function lt(P) {
      return "" + P;
    }
    function je(P) {
      if (_e(P))
        return U("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ve(P)), lt(P);
    }
    var me = m.ReactCurrentOwner, _t = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, tt, Le, mt;
    mt = {};
    function rt(P) {
      if (ut.call(P, "ref")) {
        var H = Object.getOwnPropertyDescriptor(P, "ref").get;
        if (H && H.isReactWarning)
          return !1;
      }
      return P.ref !== void 0;
    }
    function De(P) {
      if (ut.call(P, "key")) {
        var H = Object.getOwnPropertyDescriptor(P, "key").get;
        if (H && H.isReactWarning)
          return !1;
      }
      return P.key !== void 0;
    }
    function gt(P, H) {
      if (typeof P.ref == "string" && me.current && H && me.current.stateNode !== H) {
        var q = T(me.current.type);
        mt[q] || (U('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', T(me.current.type), P.ref), mt[q] = !0);
      }
    }
    function Ze(P, H) {
      {
        var q = function() {
          tt || (tt = !0, U("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", H));
        };
        q.isReactWarning = !0, Object.defineProperty(P, "key", {
          get: q,
          configurable: !0
        });
      }
    }
    function Ce(P, H) {
      {
        var q = function() {
          Le || (Le = !0, U("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", H));
        };
        q.isReactWarning = !0, Object.defineProperty(P, "ref", {
          get: q,
          configurable: !0
        });
      }
    }
    var It = function(P, H, q, Q, re, ae, te) {
      var ge = {
        $$typeof: t,
        type: P,
        key: H,
        ref: q,
        props: te,
        _owner: ae
      };
      return ge._store = {}, Object.defineProperty(ge._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ge, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Q
      }), Object.defineProperty(ge, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: re
      }), Object.freeze && (Object.freeze(ge.props), Object.freeze(ge)), ge;
    };
    function et(P, H, q, Q, re) {
      {
        var ae, te = {}, ge = null, pe = null;
        q !== void 0 && (je(q), ge = "" + q), De(H) && (je(H.key), ge = "" + H.key), rt(H) && (pe = H.ref, gt(H, re));
        for (ae in H)
          ut.call(H, ae) && !_t.hasOwnProperty(ae) && (te[ae] = H[ae]);
        if (P && P.defaultProps) {
          var Ie = P.defaultProps;
          for (ae in Ie)
            te[ae] === void 0 && (te[ae] = Ie[ae]);
        }
        if (ge || pe) {
          var we = typeof P == "function" ? P.displayName || P.name || "Unknown" : P;
          ge && Ze(te, we), pe && Ce(te, we);
        }
        return It(P, ge, pe, re, Q, me.current, te);
      }
    }
    var Ee = m.ReactCurrentOwner, Tt = m.ReactDebugCurrentFrame;
    function Xe(P) {
      if (P) {
        var H = P._owner, q = se(P.type, P._source, H ? H.type : null);
        Tt.setExtraStackFrame(q);
      } else
        Tt.setExtraStackFrame(null);
    }
    var Fe;
    Fe = !1;
    function wt(P) {
      return typeof P == "object" && P !== null && P.$$typeof === t;
    }
    function We() {
      {
        if (Ee.current) {
          var P = T(Ee.current.type);
          if (P)
            return `

Check the render method of \`` + P + "`.";
        }
        return "";
      }
    }
    function Oe(P) {
      {
        if (P !== void 0) {
          var H = P.fileName.replace(/^.*[\\\/]/, ""), q = P.lineNumber;
          return `

Check your code at ` + H + ":" + q + ".";
        }
        return "";
      }
    }
    var ht = {};
    function nt(P) {
      {
        var H = We();
        if (!H) {
          var q = typeof P == "string" ? P : P.displayName || P.name;
          q && (H = `

Check the top-level render call using <` + q + ">.");
        }
        return H;
      }
    }
    function Me(P, H) {
      {
        if (!P._store || P._store.validated || P.key != null)
          return;
        P._store.validated = !0;
        var q = nt(H);
        if (ht[q])
          return;
        ht[q] = !0;
        var Q = "";
        P && P._owner && P._owner !== Ee.current && (Q = " It was passed a child from " + T(P._owner.type) + "."), Xe(P), U('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', q, Q), Xe(null);
      }
    }
    function vt(P, H) {
      {
        if (typeof P != "object")
          return;
        if (ct(P))
          for (var q = 0; q < P.length; q++) {
            var Q = P[q];
            wt(Q) && Me(Q, H);
          }
        else if (wt(P))
          P._store && (P._store.validated = !0);
        else if (P) {
          var re = y(P);
          if (typeof re == "function" && re !== P.entries)
            for (var ae = re.call(P), te; !(te = ae.next()).done; )
              wt(te.value) && Me(te.value, H);
        }
      }
    }
    function at(P) {
      {
        var H = P.type;
        if (H == null || typeof H == "string")
          return;
        var q;
        if (typeof H == "function")
          q = H.propTypes;
        else if (typeof H == "object" && (H.$$typeof === x || H.$$typeof === j))
          q = H.propTypes;
        else
          return;
        if (q) {
          var Q = T(H);
          He(q, P.props, "prop", Q, P);
        } else if (H.PropTypes !== void 0 && !Fe) {
          Fe = !0;
          var re = T(H);
          U("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", re || "Unknown");
        }
        typeof H.getDefaultProps == "function" && !H.getDefaultProps.isReactClassApproved && U("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ke(P) {
      {
        for (var H = Object.keys(P.props), q = 0; q < H.length; q++) {
          var Q = H[q];
          if (Q !== "children" && Q !== "key") {
            Xe(P), U("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Q), Xe(null);
            break;
          }
        }
        P.ref !== null && (Xe(P), U("Invalid attribute `ref` supplied to `React.Fragment`."), Xe(null));
      }
    }
    function kt(P, H, q, Q, re, ae) {
      {
        var te = W(P);
        if (!te) {
          var ge = "";
          (P === void 0 || typeof P == "object" && P !== null && Object.keys(P).length === 0) && (ge += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var pe = Oe(re);
          pe ? ge += pe : ge += We();
          var Ie;
          P === null ? Ie = "null" : ct(P) ? Ie = "array" : P !== void 0 && P.$$typeof === t ? (Ie = "<" + (T(P.type) || "Unknown") + " />", ge = " Did you accidentally export a JSX literal instead of a component?") : Ie = typeof P, U("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ie, ge);
        }
        var we = et(P, H, q, re, ae);
        if (we == null)
          return we;
        if (te) {
          var Ue = H.children;
          if (Ue !== void 0)
            if (Q)
              if (ct(Ue)) {
                for (var Ye = 0; Ye < Ue.length; Ye++)
                  vt(Ue[Ye], P);
                Object.freeze && Object.freeze(Ue);
              } else
                U("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vt(Ue, P);
        }
        return P === d ? ke(we) : at(we), we;
      }
    }
    function M(P, H, q) {
      return kt(P, H, q, !0);
    }
    function L(P, H, q) {
      return kt(P, H, q, !1);
    }
    var $ = L, O = M;
    reactJsxRuntime_development.Fragment = d, reactJsxRuntime_development.jsx = $, reactJsxRuntime_development.jsxs = O;
  }()), reactJsxRuntime_development;
}
(function(u) {
  process.env.NODE_ENV === "production" ? u.exports = requireReactJsxRuntime_production_min() : u.exports = requireReactJsxRuntime_development();
})(jsxRuntime);
const jsx = jsxRuntime.exports.jsx, AppContext = createContext({}), AppProvider = ({
  token: u,
  chainId: t,
  children: a
}) => {
  const d = useCallback(async (y) => {
    const m = await sdkPostApi({
      ...y,
      chainId: t
    });
    return u === TOKEN.HBARX ? fromBase64(m) : buildTxRequest(m);
  }, [t]), l = useCallback(async (y) => await sdkPostApi({
    ...y,
    chainId: t
  }), [t]), h = useCallback((y) => d({
    action: TX_TYPES.STAKE,
    token: u,
    input: y
  }), [u, d]), g = useCallback((y) => d({
    action: TX_TYPES.UNSTAKE,
    token: u,
    input: y
  }), [u, d]), c = useCallback((y) => d({
    action: TX_TYPES.WITHDRAW,
    token: u,
    input: y
  }), [u, d]), x = useCallback((y) => d({
    action: TX_TYPES.ALLOWANCE,
    token: u,
    input: y
  }), [u, d]), R = useCallback((y) => l({
    action: TX_TYPES.GET_ALLOWANCE,
    token: u,
    input: y
  }), [u, l]), B = useCallback((y) => l({
    action: TX_TYPES.GET_UNSTAKES,
    token: u,
    input: y
  }), [u, l]), j = useCallback(() => l({
    action: TX_TYPES.LIMITS,
    token: u
  }), [u, l]), o = useCallback((y) => l({
    action: TX_TYPES.PENALTY,
    token: u,
    input: y
  }), [u, l]), e = useCallback((y) => l({
    action: TX_TYPES.GET_ASSOCIATED_TOKENS,
    token: u,
    input: y
  }), [u, l]), n = useCallback((y) => d({
    action: TX_TYPES.ASSOCIATE_TOKEN,
    token: u,
    input: y
  }), [u, d]), i = {
    token: u,
    stakeApi: h,
    unstakeApi: g,
    withdrawApi: c,
    allowanceApi: R,
    approveApi: x,
    unstakesApi: B,
    minMaxLimitApi: j,
    penaltyApi: o,
    associatedTokenApi: e,
    associateTokenApi: n
  };
  return /* @__PURE__ */ jsx(AppContext.Provider, {
    value: i,
    children: a
  });
}, useApp = () => ({
  ...useContext(AppContext)
}), HASHPACK = "hashpack", useStake = () => {
  const {
    stakeApi: u,
    token: t
  } = useApp();
  return {
    stake: useCallback(async (d, l, h, g = initMetaData, c) => {
      if (!l || !d) {
        console.error("wallet address missing in the params.");
        return;
      }
      if (!h) {
        console.error("input missing in the param.");
        return;
      }
      const R = await u({
        from: d,
        amount: h,
        referralId: c
      });
      if (!!R) {
        if (t === TOKEN.HBARX) {
          if (g.connectorID === HASHPACK) {
            const {
              topic: B,
              transaction: j
            } = getHashPackData(R, {
              ...g,
              address: d,
              returnTransaction: !1
            });
            return l.sendTransaction(B, j);
          }
          return l.sendTransaction(R);
        }
        return g.isNativeChain && (R.value = parseEther(h)), l.sendTransaction(R);
      }
    }, [u])
  };
}, useUnstake = () => {
  const {
    unstakeApi: u,
    token: t
  } = useApp();
  return {
    unstake: useCallback(async (d, l, h, g = initMetaData, c) => {
      if (!l || !d) {
        console.error("wallet address missing in the params.");
        return;
      }
      const R = await u({
        from: d,
        amount: h,
        referralId: c
      });
      if (!!R) {
        if (t === TOKEN.HBARX) {
          if (g.connectorID === HASHPACK) {
            const {
              topic: B,
              transaction: j
            } = getHashPackData(R, {
              ...g,
              address: d,
              returnTransaction: !1
            });
            return l.sendTransaction(B, j);
          }
          return l.sendTransaction(R);
        }
        return l.sendTransaction(R);
      }
    }, [u])
  };
}, useWithdrawals = () => {
  const {
    withdrawApi: u,
    unstakesApi: t,
    token: a
  } = useApp(), d = useCallback(async (h) => {
    if (!h) {
      console.error("wallet address missing in the params.");
      return;
    }
    return await t({
      from: h
    });
  }, [t]);
  return {
    withdraw: useCallback(async (h, g, c, x = initMetaData) => {
      if (!g || !h) {
        console.error("wallet address missing in the params.");
        return;
      }
      const B = await u({
        from: h,
        index: c
      });
      if (!!B) {
        if (a === TOKEN.HBARX) {
          if (x.connectorID === HASHPACK) {
            const {
              topic: j,
              transaction: o
            } = getHashPackData(B, {
              ...x,
              address: h,
              returnTransaction: !1
            });
            return g.sendTransaction(j, o);
          }
          return g.sendTransaction(B);
        }
        return g.sendTransaction(B);
      }
    }, [u]),
    fetchWithdrawals: d
  };
}, useAllowance = () => {
  const {
    allowanceApi: u,
    approveApi: t,
    token: a
  } = useApp(), d = useCallback(async (h, g) => {
    if (!h) {
      console.error("No wallet detected, check wallet connection.");
      return;
    }
    if (!g) {
      console.error("tokenType missing in the param.");
      return;
    }
    return await u({
      from: h,
      tokenType: g
    });
  }, [u]);
  return {
    approve: useCallback(async (h, g, c, x, R = initMetaData) => {
      if (!g || !h) {
        console.error("No wallet detected, check wallet connection.");
        return;
      }
      if (!c) {
        console.error("input missing in the param.");
        return;
      }
      if (!x) {
        console.error("tokenType missing in the param.");
        return;
      }
      const j = await t({
        from: h,
        amount: c,
        tokenType: x
      });
      if (!!j) {
        if (a === TOKEN.HBARX) {
          if (R.connectorID === HASHPACK) {
            const {
              topic: o,
              transaction: e
            } = getHashPackData(j, {
              ...R,
              address: h,
              returnTransaction: !1
            });
            return g.sendTransaction(o, e);
          }
          return g.sendTransaction(j);
        }
        return g.sendTransaction(j);
      }
    }, [t]),
    fetchAllowance: d
  };
}, useLimits = () => {
  const {
    minMaxLimitApi: u
  } = useApp();
  return {
    fetchMinMaxLimit: useCallback(async () => await u(), [u])
  };
};
function on(u) {
  for (var t = [], a = 1; a < arguments.length; a++)
    t[a - 1] = arguments[a];
  u && u.addEventListener && u.addEventListener.apply(u, t);
}
function off(u) {
  for (var t = [], a = 1; a < arguments.length; a++)
    t[a - 1] = arguments[a];
  u && u.removeEventListener && u.removeEventListener.apply(u, t);
}
function throttle(u, t, a, d) {
  var l, h = !1, g = 0;
  function c() {
    l && clearTimeout(l);
  }
  function x() {
    c(), h = !0;
  }
  typeof t != "boolean" && (d = a, a = t, t = void 0);
  function R() {
    for (var B = arguments.length, j = new Array(B), o = 0; o < B; o++)
      j[o] = arguments[o];
    var e = this, n = Date.now() - g;
    if (h)
      return;
    function i() {
      g = Date.now(), a.apply(e, j);
    }
    function y() {
      l = void 0;
    }
    d && !l && i(), c(), d === void 0 && n > u ? i() : t !== !0 && (l = setTimeout(d ? y : i, d === void 0 ? u - n : u));
  }
  return R.cancel = x, R;
}
var defaultEvents = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"], oneMinute = 6e4, useIdle = function(u, t, a) {
  u === void 0 && (u = oneMinute), t === void 0 && (t = !1), a === void 0 && (a = defaultEvents);
  var d = useState(t), l = d[0], h = d[1];
  return useEffect(function() {
    for (var g = !0, c, x = l, R = function(e) {
      g && (x = e, h(e));
    }, B = throttle(50, function() {
      x && R(!1), clearTimeout(c), c = setTimeout(function() {
        return R(!0);
      }, u);
    }), j = function() {
      document.hidden || B();
    }, o = 0; o < a.length; o++)
      on(window, a[o], B);
    return on(document, "visibilitychange", j), c = setTimeout(function() {
      return R(!0);
    }, u), function() {
      g = !1;
      for (var e = 0; e < a.length; e++)
        off(window, a[e], B);
      off(document, "visibilitychange", j);
    };
  }, [u, a]), l;
};
const useIdle$1 = useIdle;
var useInterval = function(u, t) {
  var a = useRef(function() {
  });
  useEffect(function() {
    a.current = u;
  }), useEffect(function() {
    if (t !== null) {
      var d = setInterval(function() {
        return a.current();
      }, t || 0);
      return function() {
        return clearInterval(d);
      };
    }
  }, [t]);
};
const useInterval$1 = useInterval, POLLING_INTERVAL$3 = 1e4, useStaderTVL = (u, t = !1) => {
  const a = useIdle$1(15e4), [d, l] = useState({
    tvl: void 0,
    isLoading: !0
  }), h = useCallback(async () => {
    const g = await getStaderTVL();
    l({
      tvl: g,
      isLoading: !1
    });
  }, []);
  return useEffect(() => {
    h();
  }, [h]), useInterval$1(() => {
    !a && !t && h();
  }, u || POLLING_INTERVAL$3), d;
}, POLLING_INTERVAL$2 = 1e4, useTVL = ({
  enabled: u = !0,
  delay: t,
  disablePolling: a
} = {}) => {
  const d = useIdle$1(15e4), {
    token: l
  } = useApp(), [h, g] = useState({
    tvl: void 0,
    isLoading: !0
  }), c = useCallback(async () => {
    const x = await getTVL(l);
    g({
      tvl: x,
      isLoading: !1
    });
  }, [l]);
  return useEffect(() => {
    u && c();
  }, [c, u]), useInterval$1(() => {
    u && !d && !a && c();
  }, t || POLLING_INTERVAL$2), h;
}, POLLING_INTERVAL$1 = 1e4, useAPY = ({
  enabled: u = !0,
  delay: t,
  disablePolling: a
} = {}) => {
  const d = useIdle$1(15e4), {
    token: l
  } = useApp(), [h, g] = useState({
    apy: void 0,
    isLoading: !0
  }), c = useCallback(async () => {
    const x = await getAPY(l);
    g({
      apy: x.value,
      isLoading: !1
    });
  }, [l]);
  return useEffect(() => {
    u && c();
  }, [c, u]), useInterval$1(() => {
    u && !d && !a && c();
  }, t || POLLING_INTERVAL$1), h;
}, POLLING_INTERVAL = 1e4, useExchangeRate = ({
  enabled: u = !0,
  delay: t,
  disablePolling: a
} = {}) => {
  const d = useIdle$1(15e4), {
    token: l
  } = useApp(), [h, g] = useState({
    exchangeRate: void 0,
    isLoading: !0
  }), c = useCallback(async () => {
    const x = await getExchangeRate(l);
    g({
      exchangeRate: x.value,
      isLoading: !1
    });
  }, [l]);
  return useEffect(() => {
    u && c();
  }, [c, u]), useInterval$1(() => {
    u && !d && !a && c();
  }, t || POLLING_INTERVAL), h;
}, useSafeMode = () => {
  const {
    token: u
  } = useApp(), [t, a] = useState({
    safeMode: !1,
    isLoading: !0
  });
  return useEffect(() => {
    if (u !== TOKEN.ETHX)
      return;
    (async () => {
      const l = await getETHSafeMode();
      a({
        safeMode: l.value,
        isLoading: !1
      });
    })();
  }, [u]), t;
}, usePenalty = ({ enabled: u = !0 }) => {
  const { penaltyApi: t } = useApp();
  return {
    fetchPenalty: useCallback(
      async (d) => u ? await t({ amount: d }) : 0,
      [u, t]
    )
  };
}, useGasFees = () => {
  const {
    token: u
  } = useApp(), [t, a] = useState({
    gasFees: void 0,
    isLoading: !0
  }), d = useCallback(async () => {
    const l = await getGasFees(u);
    a({
      gasFees: l,
      isLoading: !1
    });
  }, [u]);
  return useEffect(() => {
    d();
  }, [d]), t;
}, useAssociate = () => {
  const {
    associatedTokenApi: u,
    associateTokenApi: t,
    token: a
  } = useApp(), d = useCallback(async (h) => {
    if (!h) {
      console.error("No wallet detected, check wallet connection.");
      return;
    }
    return await u({
      from: h
    });
  }, [u]);
  return {
    associateToken: useCallback(async (h, g, c = initMetaData) => {
      if (!g || !h) {
        console.error("No wallet detected, check wallet connection.");
        return;
      }
      const R = await t({
        from: h
      });
      if (!!R) {
        if (a === TOKEN.HBARX) {
          if (c.connectorID === HASHPACK) {
            const {
              topic: B,
              transaction: j
            } = getHashPackData(R, {
              ...c,
              address: h,
              returnTransaction: !1
            });
            return g.sendTransaction(B, j);
          }
          return g.sendTransaction(R);
        }
        return g.sendTransaction(R);
      }
    }, [t]),
    fetchAssociatedTokens: d
  };
};
export {
  AppProvider,
  TOKEN,
  TOKENTYPE,
  getAPY,
  getETHNodeOperatorBond,
  getETHNodeOperatorCount,
  getETHRatedNetworkOverview,
  getETHSafeMode,
  getExchangeRate,
  getGasFees,
  getStaderTVL,
  getTVL,
  getTokenPrices,
  useAPY,
  useAllowance,
  useAssociate,
  useExchangeRate,
  useGasFees,
  useLimits,
  usePenalty,
  useSafeMode,
  useStaderTVL,
  useStake,
  useTVL,
  useUnstake,
  useWithdrawals as useWithdraw
};
